//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, o) => (o = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e);
//#endregion
//#region node_modules/preact/dist/preact.module.js
function f(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function p(e) {
	e && e.parentNode && e.parentNode.removeChild(e);
}
function m(e, t, n) {
	var r, i, a, o = {};
	for (a in t) a == "key" ? r = t[a] : a == "ref" ? i = t[a] : o[a] = t[a];
	if (arguments.length > 2 && (o.children = arguments.length > 3 ? de.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (a in e.defaultProps) o[a] === void 0 && (o[a] = e.defaultProps[a]);
	return h(e, o, r, i, null);
}
function h(e, t, n, r, i) {
	var a = {
		type: e,
		props: t,
		key: n,
		ref: r,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: i ?? ++fe,
		__i: -1,
		__u: 0
	};
	return i == null && N.vnode != null && N.vnode(a), a;
}
function g() {
	return { current: null };
}
function _(e) {
	return e.children;
}
function v(e, t) {
	this.props = e, this.context = t;
}
function y(e, t) {
	if (t == null) return e.__ ? y(e.__, e.__i + 1) : null;
	for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
	return typeof e.type == "function" ? y(e) : null;
}
function b(e) {
	if (e.__P && e.__d) {
		var t = e.__v, n = t.__e, r = [], i = [], a = f({}, t);
		a.__v = t.__v + 1, N.vnode && N.vnode(a), M(e.__P, a, t, e.__n, e.__P.namespaceURI, 32 & t.__u ? [n] : null, r, n ?? y(t), !!(32 & t.__u), i), a.__v = t.__v, a.__.__k[a.__i] = a, te(r, a, i), t.__e = t.__ = null, a.__e != n && x(a);
	}
}
function x(e) {
	if ((e = e.__) != null && e.__c != null) return e.__e = e.__c.base = null, e.__k.some(function(t) {
		if (t != null && t.__e != null) return e.__e = e.__c.base = t.__e;
	}), x(e);
}
function S(e) {
	(!e.__d && (e.__d = !0) && pe.push(e) && !C.__r++ || me != N.debounceRendering) && ((me = N.debounceRendering) || he)(C);
}
function C() {
	try {
		for (var e, t = 1; pe.length;) pe.length > t && pe.sort(ge), e = pe.shift(), t = pe.length, b(e);
	} finally {
		pe.length = C.__r = 0;
	}
}
function w(e, t, n, r, i, a, o, s, c, l, u) {
	var d, f, p, m, h, g, _ = r && r.__k || Te, v = t.length;
	for (c = T(n, t, _, c, v), d = 0; d < v; d++) (p = n.__k[d]) != null && (f = p.__i != -1 && _[p.__i] || we, p.__i = d, g = M(e, p, f, i, a, o, s, c, l, u), m = p.__e, p.ref && f.ref != p.ref && (f.ref && ie(f.ref, null, p), u.push(p.ref, p.__c || m, p)), h == null && m != null && (h = m), 4 & p.__u ? (c = E(p, c, e), f.__e && (f.__e = null)) : typeof p.type == "function" && g !== void 0 ? c = g : m && (c = m.nextSibling), p.__u &= -7);
	return n.__e = h, c;
}
function T(e, t, n, r, i) {
	var a, o, s, c, l, u = n.length, d = u, f = 0;
	for (e.__k = Array(i), a = 0; a < i; a++) (o = t[a]) != null && typeof o != "boolean" && typeof o != "function" ? (typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? o = e.__k[a] = h(null, o, null, null, null) : De(o) ? o = e.__k[a] = h(_, { children: o }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? o = e.__k[a] = h(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : e.__k[a] = o, c = a + f, o.__ = e, o.__b = e.__b + 1, s = null, (l = o.__i = O(o, n, c, d)) != -1 && (d--, (s = n[l]) && (s.__u |= 2)), s == null || s.__v == null ? (l == -1 && (i > u ? f-- : i < u && f++), typeof o.type != "function" && (o.__u |= 4)) : l != c && (l == c - 1 ? f-- : l == c + 1 ? f++ : (l > c ? f-- : f++, o.__u |= 4))) : e.__k[a] = null;
	if (d) for (a = 0; a < u; a++) (s = n[a]) != null && !(2 & s.__u) && (s.__e == r && (r = y(s)), ae(s, s));
	return r;
}
function E(e, t, n) {
	var r, i;
	if (typeof e.type == "function") {
		for (r = e.__k, i = 0; r && i < r.length; i++) r[i] && (r[i].__ = e, t = E(r[i], t, n));
		return t;
	}
	e.__e != t && (t && e.type && !t.parentNode && (t = y(e)), t = n.insertBefore(e.__e, t || null));
	do
		t &&= t.nextSibling;
	while (t != null && t.nodeType == 8);
	return t;
}
function D(e, t) {
	return t ||= [], e == null || typeof e == "boolean" || (De(e) ? e.some(function(e) {
		D(e, t);
	}) : t.push(e)), t;
}
function O(e, t, n, r) {
	var i, a, o, s = e.key, c = e.type, l = t[n], u = l != null && !(2 & l.__u);
	if (l === null && s == null || u && s == l.key && c == l.type) return n;
	if (r > +!!u) {
		for (i = n - 1, a = n + 1; i >= 0 || a < t.length;) if ((l = t[o = i >= 0 ? i-- : a++]) != null && !(2 & l.__u) && s == l.key && c == l.type) return o;
	}
	return -1;
}
function k(e, t, n) {
	t[0] == "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || Ee.test(t) ? n : n + "px";
}
function A(e, t, n, r, i) {
	var a, o;
	n: if (t == "style") {
		if (typeof n == "string") e.style.cssText = n;
		else {
			if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || k(e.style, t, "");
			if (n) for (t in n) r && n[t] == r[t] || k(e.style, t, n[t]);
		}
	} else if (t[0] == "o" && t[1] == "n") a = t != (t = t.replace(ye, "$1")), o = t.toLowerCase(), t = o in e || t == "onFocusOut" || t == "onFocusIn" ? o.slice(2) : t.slice(2), e.l ||= {}, e.l[t + a] = n, n ? r ? n[ve] = r[ve] : (n[ve] = be, e.addEventListener(t, a ? Se : xe, a)) : e.removeEventListener(t, a ? Se : xe, a);
	else {
		if (i == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
		else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
			e[t] = n ?? "";
			break n;
		} catch {}
		typeof n == "function" || (n == null || !1 === n && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
	}
}
function j(e) {
	return function(t) {
		if (this.l) {
			var n = this.l[t.type + e];
			if (t[_e] == null) t[_e] = be++;
			else if (t[_e] < n[ve]) return;
			return n(N.event ? N.event(t) : t);
		}
	};
}
function M(e, t, n, r, i, a, o, s, c, l) {
	var u, d, m, h, g, b, x, S, C, T, E, D, O, k, A, j, M = t.type;
	if (t.constructor !== void 0) return null;
	128 & n.__u && (c = !!(32 & n.__u), a = [s = t.__e = n.__e]), (u = N.__b) && u(t);
	n: if (typeof M == "function") {
		d = o.length;
		try {
			if (C = t.props, T = M.prototype && M.prototype.render, E = (u = M.contextType) && r[u.__c], D = u ? E ? E.props.value : u.__ : r, n.__c ? S = (m = t.__c = n.__c).__ = m.__E : (T ? t.__c = m = new M(C, D) : (t.__c = m = new v(C, D), m.constructor = M, m.render = oe), E && E.sub(m), m.state || (m.state = {}), m.__n = r, h = m.__d = !0, m.__h = [], m._sb = []), T && m.__s == null && (m.__s = m.state), T && M.getDerivedStateFromProps != null && (m.__s == m.state && (m.__s = f({}, m.__s)), f(m.__s, M.getDerivedStateFromProps(C, m.__s))), g = m.props, b = m.state, m.__v = t, h) T && M.getDerivedStateFromProps == null && m.componentWillMount != null && m.componentWillMount(), T && m.componentDidMount != null && m.__h.push(m.componentDidMount);
			else {
				if (T && M.getDerivedStateFromProps == null && C !== g && m.componentWillReceiveProps != null && m.componentWillReceiveProps(C, D), t.__v == n.__v || !m.__e && m.shouldComponentUpdate != null && !1 === m.shouldComponentUpdate(C, m.__s, D)) {
					t.__v != n.__v && (m.props = C, m.state = m.__s, m.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.some(function(e) {
						e && (e.__ = t);
					}), Te.push.apply(m.__h, m._sb), m._sb = [], m.__h.length && o.push(m), s = y(n);
					break n;
				}
				m.componentWillUpdate != null && m.componentWillUpdate(C, m.__s, D), T && m.componentDidUpdate != null && m.__h.push(function() {
					m.componentDidUpdate(g, b, x);
				});
			}
			if (m.context = D, m.props = C, m.__P = e, m.__e = !1, O = N.__r, k = 0, T) m.state = m.__s, m.__d = !1, O && O(t), u = m.render(m.props, m.state, m.context), Te.push.apply(m.__h, m._sb), m._sb = [];
			else do
				m.__d = !1, O && O(t), u = m.render(m.props, m.state, m.context), m.state = m.__s;
			while (m.__d && ++k < 25);
			m.state = m.__s, m.getChildContext != null && (r = f(f({}, r), m.getChildContext())), T && !h && m.getSnapshotBeforeUpdate != null && (x = m.getSnapshotBeforeUpdate(g, b)), A = u != null && u.type === _ && u.key == null ? ne(u.props.children) : u, s = w(e, De(A) ? A : [A], t, n, r, i, a, o, s, c, l), m.base = t.__e, t.__u &= -161, m.__h.length && o.push(m), S && (m.__E = m.__ = null);
		} catch (e) {
			if (o.length = d, t.__v = null, c || a != null) {
				if (e.then) {
					for (t.__u |= c ? 160 : 128; s && s.nodeType == 8 && s.nextSibling;) s = s.nextSibling;
					a != null && (a[a.indexOf(s)] = null), t.__e = s;
				} else if (a != null) for (j = a.length; j--;) p(a[j]);
			} else t.__e = n.__e;
			t.__k ??= n.__k || [], e.then || ee(t), N.__e(e, t, n);
		}
	} else a == null && t.__v == n.__v ? (t.__k = n.__k, t.__e = n.__e) : s = t.__e = re(n.__e, t, n, r, i, a, o, c, l);
	return (u = N.diffed) && u(t), 128 & t.__u ? void 0 : s;
}
function ee(e) {
	e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(ee));
}
function te(e, t, n) {
	for (var r = 0; r < n.length; r++) ie(n[r], n[++r], n[++r]);
	N.__c && N.__c(t, e), e.some(function(t) {
		try {
			e = t.__h, t.__h = [], e.some(function(e) {
				e.call(t);
			});
		} catch (e) {
			N.__e(e, t.__v);
		}
	});
}
function ne(e) {
	return typeof e != "object" || !e || e.__b > 0 ? e : De(e) ? e.map(ne) : e.constructor === void 0 ? f({}, e) : null;
}
function re(e, t, n, r, i, a, o, s, c) {
	var l, u, d, f, m, h, g, _ = n.props || we, v = t.props, b = t.type;
	if (b == "svg" ? i = "http://www.w3.org/2000/svg" : b == "math" ? i = "http://www.w3.org/1998/Math/MathML" : i ||= "http://www.w3.org/1999/xhtml", a != null) {
		for (l = 0; l < a.length; l++) if ((m = a[l]) && "setAttribute" in m == !!b && (b ? m.localName == b : m.nodeType == 3)) {
			e = m, a[l] = null;
			break;
		}
	}
	if (e == null) {
		if (b == null) return document.createTextNode(v);
		e = document.createElementNS(i, b, v.is && v), s &&= (N.__m && N.__m(t, a), !1), a = null;
	}
	if (b == null) _ === v || s && e.data == v || (e.data = v);
	else {
		if (a = b == "textarea" && v.defaultValue != null ? null : a && de.call(e.childNodes), !s && a != null) for (_ = {}, l = 0; l < e.attributes.length; l++) _[(m = e.attributes[l]).name] = m.value;
		for (l in _) m = _[l], l == "dangerouslySetInnerHTML" ? d = m : l == "children" || l in v || l == "value" && "defaultValue" in v || l == "checked" && "defaultChecked" in v || A(e, l, null, m, i);
		for (l in v) m = v[l], l == "children" ? f = m : l == "dangerouslySetInnerHTML" ? u = m : l == "value" ? h = m : l == "checked" ? g = m : s && typeof m != "function" || _[l] === m || A(e, l, m, _[l], i);
		if (u) s || d && (u.__html == d.__html || u.__html == e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
		else if (d && (e.innerHTML = ""), w(t.type == "template" ? e.content : e, De(f) ? f : [f], t, n, r, b == "foreignObject" ? "http://www.w3.org/1999/xhtml" : i, a, o, a ? a[0] : n.__k && y(n, 0), s, c), a != null) for (l = a.length; l--;) p(a[l]);
		s && b != "textarea" || (l = "value", b == "progress" && h == null ? e.removeAttribute("value") : h != null && (h !== e[l] || b == "progress" && !h || b == "option" && h != _[l]) && A(e, l, h, _[l], i), l = "checked", g != null && g != e[l] && A(e, l, g, _[l], i));
	}
	return e;
}
function ie(e, t, n) {
	try {
		if (typeof e == "function") {
			var r = typeof e.__u == "function";
			r && e.__u(), r && t == null || (e.__u = e(t));
		} else e.current = t;
	} catch (e) {
		N.__e(e, n);
	}
}
function ae(e, t, n) {
	var r, i;
	if (N.unmount && N.unmount(e), (r = e.ref) && (r.current && r.current != e.__e || ie(r, null, t)), (r = e.__c) != null) {
		if (r.componentWillUnmount) try {
			r.componentWillUnmount();
		} catch (e) {
			N.__e(e, t);
		}
		r.base = r.__P = r.__n = null;
	}
	if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && ae(r[i], t, n || typeof e.type != "function");
	n || p(e.__e), e.__c = e.__ = e.__e = void 0;
}
function oe(e, t, n) {
	return this.constructor(e, n);
}
function se(e, t, n) {
	var r, i, a, o;
	t == document && (t = document.documentElement), N.__ && N.__(e, t), i = (r = typeof n == "function") ? null : n && n.__k || t.__k, a = [], o = [], M(t, e = (!r && n || t).__k = m(_, null, [e]), i || we, we, t.namespaceURI, !r && n ? [n] : i ? null : t.firstChild ? de.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r, o), te(a, e, o), e.props.children = null;
}
function ce(e, t) {
	se(e, t, ce);
}
function le(e, t, n) {
	var r, i, a, o, s = f({}, e.props);
	for (a in e.type && e.type.defaultProps && (o = e.type.defaultProps), t) a == "key" ? r = t[a] : a == "ref" ? i = t[a] : s[a] = t[a] === void 0 && o != null ? o[a] : t[a];
	return arguments.length > 2 && (s.children = arguments.length > 3 ? de.call(arguments, 2) : n), h(e.type, s, r || e.key, i || e.ref, null);
}
function ue(e) {
	function t(e) {
		var n, r;
		return this.getChildContext || (n = /* @__PURE__ */ new Set(), (r = {})[t.__c] = this, this.getChildContext = function() {
			return r;
		}, this.componentWillUnmount = function() {
			n = null;
		}, this.shouldComponentUpdate = function(e) {
			this.props.value != e.value && n.forEach(function(e) {
				e.__e = !0, S(e);
			});
		}, this.sub = function(e) {
			n.add(e);
			var t = e.componentWillUnmount;
			e.componentWillUnmount = function() {
				n && n.delete(e), t && t.call(e);
			};
		}), e.children;
	}
	return t.__c = "__cC" + Ce++, t.__ = e, t.Provider = t.__l = (t.Consumer = function(e, t) {
		return e.children(t);
	}).contextType = t, t;
}
var de, N, fe, pe, me, he, ge, P, _e, ve, ye, be, xe, Se, Ce, we, Te, Ee, De, Oe = o((() => {
	we = {}, Te = [], Ee = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, De = Array.isArray, de = Te.slice, N = { __e: function(e, t, n, r) {
		for (var i, a, o; t = t.__;) if ((i = t.__c) && !i.__) try {
			if ((a = i.constructor) && a.getDerivedStateFromError != null && (i.setState(a.getDerivedStateFromError(e)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), o = i.__d), o) return i.__E = i;
		} catch (t) {
			e = t;
		}
		throw e;
	} }, fe = 0, v.prototype.setState = function(e, t) {
		var n = this.__s != null && this.__s != this.state ? this.__s : this.__s = f({}, this.state);
		typeof e == "function" && (e = e(f({}, n), this.props)), e && f(n, e), e != null && this.__v && (t && this._sb.push(t), S(this));
	}, v.prototype.forceUpdate = function(e) {
		this.__v && (this.__e = !0, e && this.__h.push(e), S(this));
	}, v.prototype.render = _, pe = [], he = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, ge = function(e, t) {
		return e.__v.__b - t.__v.__b;
	}, C.__r = 0, P = Math.random().toString(8), _e = "__d" + P, ve = "__a" + P, ye = /(PointerCapture)$|Capture$/i, be = 0, xe = j(!1), Se = j(!0), Ce = 0;
}));
//#endregion
//#region node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
function F(e, t, n, r, i, a) {
	t ||= {};
	var o, s, c = t;
	if ("ref" in c) for (s in c = {}, t) s == "ref" ? o = t[s] : c[s] = t[s];
	var l = {
		type: e,
		props: c,
		key: n,
		ref: o,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: --ke,
		__i: -1,
		__u: 0,
		__source: i,
		__self: a
	};
	if (typeof e == "function" && (o = e.defaultProps)) for (s in o) c[s] === void 0 && (c[s] = o[s]);
	return N.vnode && N.vnode(l), l;
}
var ke, Ae = o((() => {
	Oe(), ke = 0, Array.isArray;
}));
//#endregion
//#region node_modules/preact/hooks/dist/hooks.module.js
function je(e, t) {
	et.__h && et.__h(Ye, e, Qe || t), Qe = 0;
	var n = Ye.__H || (Ye.__H = {
		__: [],
		__h: []
	});
	return e >= n.__.length && n.__.push({}), n.__[e];
}
function I(e) {
	return Qe = 1, Me(qe, e);
}
function Me(e, t, n) {
	var r = je(Je++, 2);
	if (r.t = e, !r.__c && (r.__ = [n ? n(t) : qe(void 0, t), function(e) {
		var t = r.__N ? r.__N[0] : r.__[0], n = r.t(t, e);
		t !== n && (r.__N = [n, r.__[1]], r.__c.setState({}));
	}], r.__c = Ye, !Ye.__f)) {
		var i = function(e, t, n) {
			if (!r.__c.__H) return !0;
			var i = !1, o = r.__c.props !== e;
			if (r.__c.__H.__.some(function(e) {
				if (e.__N) {
					i = !0;
					var t = e.__[0];
					e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0);
				}
			}), a) {
				var s = a.call(this, e, t, n);
				return i ? s || o : s;
			}
			return !i || o;
		};
		Ye.__f = !0;
		var a = Ye.shouldComponentUpdate, o = Ye.componentWillUpdate;
		Ye.componentWillUpdate = function(e, t, n) {
			if (this.__e) {
				var r = a;
				a = void 0, i(e, t, n), a = r;
			}
			o && o.call(this, e, t, n);
		}, Ye.shouldComponentUpdate = i;
	}
	return r.__N || r.__;
}
function L(e, t) {
	var n = je(Je++, 3);
	!et.__s && Ke(n.__H, t) && (n.__ = e, n.u = t, Ye.__H.__h.push(n));
}
function Ne(e, t) {
	var n = je(Je++, 4);
	!et.__s && Ke(n.__H, t) && (n.__ = e, n.u = t, Ye.__h.push(n));
}
function Pe(e) {
	return Qe = 5, Ie(function() {
		return { current: e };
	}, []);
}
function Fe(e, t, n) {
	Qe = 6, Ne(function() {
		if (typeof e == "function") {
			var n = e(t());
			return function() {
				e(null), n && typeof n == "function" && n();
			};
		}
		if (e) return e.current = t(), function() {
			return e.current = null;
		};
	}, n == null ? n : n.concat(e));
}
function Ie(e, t) {
	var n = je(Je++, 7);
	return Ke(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
}
function Le(e, t) {
	return Qe = 8, Ie(function() {
		return e;
	}, t);
}
function Re(e) {
	var t = Ye.context[e.__c], n = je(Je++, 9);
	return n.c = e, t ? (n.__ ?? (n.__ = !0, t.sub(Ye)), t.props.value) : e.__;
}
function ze(e, t) {
	et.useDebugValue && et.useDebugValue(t ? t(e) : e);
}
function Be(e) {
	var t = je(Je++, 10), n = I();
	return t.__ = e, Ye.componentDidCatch || (Ye.componentDidCatch = function(e, r) {
		t.__ && t.__(e, r), n[1](e);
	}), [n[0], function() {
		n[1](void 0);
	}];
}
function Ve() {
	var e = je(Je++, 11);
	if (!e.__) {
		for (var t = Ye.__v; t !== null && !t.__m && t.__ !== null;) t = t.__;
		var n = t.__m || (t.__m = [0, 0]);
		e.__ = "P" + n[0] + "-" + n[1]++;
	}
	return e.__;
}
function He() {
	for (var e; e = $e.shift();) {
		var t = e.__H;
		if (e.__P && t) try {
			t.__h.some(We), t.__h.some(Ge), t.__h = [];
		} catch (n) {
			t.__h = [], et.__e(n, e.__v);
		}
	}
}
function Ue(e) {
	var t, n = function() {
		clearTimeout(r), st && cancelAnimationFrame(t), setTimeout(e);
	}, r = setTimeout(n, 35);
	st && (t = requestAnimationFrame(n));
}
function We(e) {
	var t = Ye, n = e.__c;
	typeof n == "function" && (e.__c = void 0, n()), Ye = t;
}
function Ge(e) {
	var t = Ye;
	e.__c = e.__(), Ye = t;
}
function Ke(e, t) {
	return !e || e.length !== t.length || t.some(function(t, n) {
		return t !== e[n];
	});
}
function qe(e, t) {
	return typeof t == "function" ? t(e) : t;
}
var Je, Ye, Xe, Ze, Qe, $e, et, tt, nt, rt, it, at, ot, st, R = o((() => {
	Oe(), Qe = 0, $e = [], et = N, tt = et.__b, nt = et.__r, rt = et.diffed, it = et.__c, at = et.unmount, ot = et.__, et.__b = function(e) {
		Ye = null, tt && tt(e);
	}, et.__ = function(e, t) {
		e && t.__k && t.__k.__m && (e.__m = t.__k.__m), ot && ot(e, t);
	}, et.__r = function(e) {
		nt && nt(e), Je = 0;
		var t = (Ye = e.__c).__H;
		t && (Xe === Ye ? (t.__h = [], Ye.__h = [], t.__.some(function(e) {
			e.__N && (e.__ = e.__N), e.u = e.__N = void 0;
		})) : (t.__h.some(We), t.__h.some(Ge), t.__h = [], Je = 0)), Xe = Ye;
	}, et.diffed = function(e) {
		rt && rt(e);
		var t = e.__c;
		t && t.__H && (t.__H.__h.length && ($e.push(t) !== 1 && Ze === et.requestAnimationFrame || ((Ze = et.requestAnimationFrame) || Ue)(He)), t.__H.__.some(function(e) {
			e.u &&= (e.__H = e.u, void 0);
		})), Xe = Ye = null;
	}, et.__c = function(e, t) {
		t.some(function(e) {
			try {
				e.__h.some(We), e.__h = e.__h.filter(function(e) {
					return !e.__ || Ge(e);
				});
			} catch (n) {
				t.some(function(e) {
					e.__h &&= [];
				}), t = [], et.__e(n, e.__v);
			}
		}), it && it(e, t);
	}, et.unmount = function(e) {
		at && at(e);
		var t, n = e.__c;
		n && n.__H && (n.__H.__.some(function(e) {
			try {
				We(e);
			} catch (e) {
				t = e;
			}
		}), n.__H = void 0, t && et.__e(t, n.__v));
	}, st = typeof requestAnimationFrame == "function";
})), ct = /* @__PURE__ */ c({
	Children: () => Vt,
	Component: () => v,
	Fragment: () => _,
	PureComponent: () => gt,
	StrictMode: () => _,
	Suspense: () => xt,
	SuspenseList: () => wt,
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: () => rn,
	cloneElement: () => Pt,
	createContext: () => ue,
	createElement: () => m,
	createFactory: () => At,
	createPortal: () => Dt,
	createRef: () => g,
	default: () => z,
	findDOMNode: () => It,
	flushSync: () => sn,
	forwardRef: () => vt,
	hydrate: () => kt,
	isElement: () => cn,
	isFragment: () => Mt,
	isMemo: () => Nt,
	isValidElement: () => jt,
	lazy: () => Ct,
	memo: () => _t,
	render: () => Ot,
	startTransition: () => pt,
	unmountComponentAtNode: () => Ft,
	unstable_batchedUpdates: () => on,
	useCallback: () => Le,
	useContext: () => Re,
	useDebugValue: () => ze,
	useDeferredValue: () => mt,
	useEffect: () => L,
	useErrorBoundary: () => Be,
	useId: () => Ve,
	useImperativeHandle: () => Fe,
	useInsertionEffect: () => Lt,
	useLayoutEffect: () => Ne,
	useMemo: () => Ie,
	useReducer: () => Me,
	useRef: () => Pe,
	useState: () => I,
	useSyncExternalStore: () => dt,
	useTransition: () => ht,
	version: () => an
});
function lt(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function ut(e, t) {
	for (var n in e) if (n !== "__source" && !(n in t)) return !0;
	for (var r in t) if (r !== "__source" && e[r] !== t[r]) return !0;
	return !1;
}
function dt(e, t) {
	var n = t(), r = I({ t: {
		__: n,
		u: t
	} }), i = r[0].t, a = r[1];
	return Ne(function() {
		i.__ = n, i.u = t, ft(i) && a({ t: i });
	}, [
		e,
		n,
		t
	]), L(function() {
		return ft(i) && a({ t: i }), e(function() {
			ft(i) && a({ t: i });
		});
	}, [e]), n;
}
function ft(e) {
	try {
		return !((t = e.__) === (n = e.u()) && (t !== 0 || 1 / t == 1 / n) || t != t && n != n);
	} catch {
		return !0;
	}
	var t, n;
}
function pt(e) {
	e();
}
function mt(e) {
	return e;
}
function ht() {
	return [!1, pt];
}
function gt(e, t) {
	this.props = e, this.context = t;
}
function _t(e, t) {
	function n(e) {
		var n = this.props.ref;
		return n != e.ref && n && (typeof n == "function" ? n(null) : n.current = null), t ? !t(this.props, e) || n != e.ref : ut(this.props, e);
	}
	function r(t) {
		return this.shouldComponentUpdate = n, m(e, t);
	}
	return r.displayName = "Memo(" + (e.displayName || e.name) + ")", r.__f = r.prototype.isReactComponent = !0, r.type = e, r;
}
function vt(e) {
	function t(t) {
		var n = lt({}, t);
		return delete n.ref, e(n, t.ref || null);
	}
	return t.$$typeof = zt, t.render = e, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t;
}
function yt(e, t, n) {
	return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function(e) {
		typeof e.__c == "function" && e.__c();
	}), e.__c.__H = null), (e = lt({}, e)).__c != null && (e.__c.__P === n && (e.__c.__P = t), e.__c.__e = !0, e.__c = null), e.__k = e.__k && e.__k.map(function(e) {
		return yt(e, t, n);
	})), e;
}
function bt(e, t, n) {
	return e && n && (e.__v = null, e.__k = e.__k && e.__k.map(function(e) {
		return bt(e, t, n);
	}), e.__c && e.__c.__P === t && (e.__e && n.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = n)), e;
}
function xt() {
	this.__u = 0, this.o = null, this.__b = null;
}
function St(e) {
	var t = e.__ && e.__.__c;
	return t && t.__a && t.__a(e);
}
function Ct(e) {
	var t, n, r, i = null;
	function a(a) {
		if (t || (t = e()).then(function(e) {
			e && (i = e.default || e), r = !0;
		}, function(e) {
			n = e, r = !0;
		}), n) throw n;
		if (!r) throw t;
		return i ? m(i, a) : null;
	}
	return a.displayName = "Lazy", a.__f = !0, a;
}
function wt() {
	this.i = null, this.l = null;
}
function Tt(e) {
	return this.getChildContext = function() {
		return e.context;
	}, e.children;
}
function Et(e) {
	var t = this, n = e.h;
	if (t.componentWillUnmount = function() {
		se(null, t.v), t.v = null, t.h = null;
	}, t.h && t.h !== n && t.componentWillUnmount(), !t.v) {
		for (var r = t.__v; r !== null && !r.__m && r.__ !== null;) r = r.__;
		t.h = n, t.v = {
			nodeType: 1,
			parentNode: n,
			childNodes: [],
			__k: { __m: r.__m },
			contains: function() {
				return !0;
			},
			namespaceURI: n.namespaceURI,
			insertBefore: function(e, n) {
				this.childNodes.push(e), t.h.insertBefore(e, n);
			},
			removeChild: function(e) {
				this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t.h.removeChild(e);
			}
		};
	}
	se(m(Tt, { context: t.context }, e.__v), t.v);
}
function Dt(e, t) {
	var n = m(Et, {
		__v: e,
		h: t
	});
	return n.containerInfo = t, n;
}
function Ot(e, t, n) {
	return t.__k ?? (t.textContent = ""), se(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
function kt(e, t, n) {
	return ce(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
function At(e) {
	return m.bind(null, e);
}
function jt(e) {
	return !!e && e.$$typeof === Gt;
}
function Mt(e) {
	return jt(e) && e.type === _;
}
function Nt(e) {
	return !!e && typeof e.displayName == "string" && e.displayName.indexOf("Memo(") == 0;
}
function Pt(e) {
	return jt(e) ? le.apply(null, arguments) : e;
}
function Ft(e) {
	return !!e.__k && (se(null, e), !0);
}
function It(e) {
	return e && (e.base || e.nodeType === 1 && e) || null;
}
var Lt, Rt, zt, Bt, Vt, Ht, Ut, Wt, Gt, Kt, qt, Jt, Yt, Xt, Zt, Qt, $t, en, tn, nn, rn, an, on, sn, cn, z, ln = o((() => {
	Oe(), R(), R(), Lt = Ne, (gt.prototype = new v()).isPureReactComponent = !0, gt.prototype.shouldComponentUpdate = function(e, t) {
		return ut(this.props, e) || ut(this.state, t);
	}, Rt = N.__b, N.__b = function(e) {
		e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), Rt && Rt(e);
	}, zt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911, Bt = function(e, t) {
		return e == null ? null : D(D(e).map(t));
	}, Vt = {
		map: Bt,
		forEach: Bt,
		count: function(e) {
			return e ? D(e).length : 0;
		},
		only: function(e) {
			var t = D(e);
			if (t.length !== 1) throw "Children.only";
			return t[0];
		},
		toArray: D
	}, Ht = N.__e, N.__e = function(e, t, n, r) {
		if (e.then) {
			for (var i, a = t; a = a.__;) if ((i = a.__c) && i.__c) return t.__e ?? (t.__e = n.__e, t.__k = n.__k || []), i.__c(e, t);
		}
		Ht(e, t, n, r);
	}, Ut = N.unmount, N.unmount = function(e) {
		var t = e.__c;
		t && (t.__z = !0), t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), Ut && Ut(e);
	}, (xt.prototype = new v()).__c = function(e, t) {
		var n = t.__c, r = this;
		r.o ??= [], r.o.push(n);
		var i = St(r.__v), a = !1, o = function() {
			a || r.__z || (a = !0, n.__R = null, i ? i(c) : c());
		};
		n.__R = o;
		var s = n.__P;
		n.__P = null;
		var c = function() {
			if (!--r.__u) {
				if (r.state.__a) {
					var e = r.state.__a;
					r.__v.__k[0] = bt(e, e.__c.__P, e.__c.__O);
				}
				var t;
				for (r.setState({ __a: r.__b = null }); t = r.o.pop();) t.__P = s, t.forceUpdate();
			}
		};
		r.__u++ || 32 & t.__u || r.setState({ __a: r.__b = r.__v.__k[0] }), e.then(o, o);
	}, xt.prototype.componentWillUnmount = function() {
		this.o = [];
	}, xt.prototype.render = function(e, t) {
		if (this.__b) {
			if (this.__v.__k) {
				var n = document.createElement("div"), r = this.__v.__k[0].__c;
				this.__v.__k[0] = yt(this.__b, n, r.__O = r.__P);
			}
			this.__b = null;
		}
		var i = t.__a && m(_, null, e.fallback);
		return i && (i.__u &= -33), [m(_, null, t.__a ? null : e.children), i];
	}, Wt = function(e, t, n) {
		if (++n[1] === n[0] && e.l.delete(t), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.l.size)) for (n = e.i; n;) {
			for (; n.length > 3;) n.pop()();
			if (n[1] < n[0]) break;
			e.i = n = n[2];
		}
	}, (wt.prototype = new v()).__a = function(e) {
		var t = this, n = St(t.__v), r = t.l.get(e);
		return r[0]++, function(i) {
			var a = function() {
				t.props.revealOrder ? (r.push(i), Wt(t, e, r)) : i();
			};
			n ? n(a) : a();
		};
	}, wt.prototype.render = function(e) {
		this.i = null, this.l = /* @__PURE__ */ new Map();
		var t = D(e.children);
		e.revealOrder && e.revealOrder[0] === "b" && t.reverse();
		for (var n = t.length; n--;) this.l.set(t[n], this.i = [
			1,
			0,
			this.i
		]);
		return e.children;
	}, wt.prototype.componentDidUpdate = wt.prototype.componentDidMount = function() {
		var e = this;
		this.l.forEach(function(t, n) {
			Wt(e, n, t);
		});
	}, Gt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, Kt = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, qt = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, Jt = /[A-Z0-9]/g, Yt = typeof document < "u", Xt = function(e) {
		return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(e);
	}, v.prototype.isReactComponent = !0, [
		"componentWillMount",
		"componentWillReceiveProps",
		"componentWillUpdate"
	].forEach(function(e) {
		Object.defineProperty(v.prototype, e, {
			configurable: !0,
			get: function() {
				return this["UNSAFE_" + e];
			},
			set: function(t) {
				Object.defineProperty(this, e, {
					configurable: !0,
					writable: !0,
					value: t
				});
			}
		});
	}), Zt = N.event, N.event = function(e) {
		return Zt && (e = Zt(e)), e.persist = function() {}, e.isPropagationStopped = function() {
			return this.cancelBubble;
		}, e.isDefaultPrevented = function() {
			return this.defaultPrevented;
		}, e.nativeEvent = e;
	}, $t = {
		configurable: !0,
		get: function() {
			return this.class;
		}
	}, en = N.vnode, N.vnode = function(e) {
		typeof e.type == "string" && function(e) {
			var t = e.props, n = e.type, r = {}, i = n.indexOf("-") == -1;
			for (var a in t) {
				var o = t[a];
				if (!(a === "value" && "defaultValue" in t && o == null || Yt && a === "children" && n === "noscript" || a === "class" || a === "className")) {
					var s = a.toLowerCase();
					a === "defaultValue" && "value" in t && t.value == null ? a = "value" : a === "download" && !0 === o ? o = "" : s === "translate" && o === "no" ? o = !1 : s[0] === "o" && s[1] === "n" ? s === "ondoubleclick" ? a = "ondblclick" : s !== "onchange" || n !== "input" && n !== "textarea" || Xt(t.type) ? s === "onfocus" ? a = "onfocusin" : s === "onblur" ? a = "onfocusout" : qt.test(a) && (a = s) : s = a = "oninput" : i && Kt.test(a) ? a = a.replace(Jt, "-$&").toLowerCase() : o === null && (o = void 0), s === "oninput" && r[a = s] && (a = "oninputCapture"), r[a] = o;
				}
			}
			n == "select" && (r.multiple && Array.isArray(r.value) && (r.value = D(t.children).forEach(function(e) {
				e.props.selected = r.value.indexOf(e.props.value) != -1;
			})), r.defaultValue != null && (r.value = D(t.children).forEach(function(e) {
				e.props.selected = r.multiple ? r.defaultValue.indexOf(e.props.value) != -1 : r.defaultValue == e.props.value;
			}))), t.class && !t.className ? (r.class = t.class, Object.defineProperty(r, "className", $t)) : t.className && (r.class = r.className = t.className), e.props = r;
		}(e), e.$$typeof = Gt, en && en(e);
	}, tn = N.__r, N.__r = function(e) {
		tn && tn(e), Qt = e.__c;
	}, nn = N.diffed, N.diffed = function(e) {
		nn && nn(e);
		var t = e.props, n = e.__e;
		n != null && e.type === "textarea" && "value" in t && t.value !== n.value && (n.value = t.value == null ? "" : t.value), Qt = null;
	}, rn = { ReactCurrentDispatcher: { current: {
		readContext: function(e) {
			return Qt.__n[e.__c].props.value;
		},
		useCallback: Le,
		useContext: Re,
		useDebugValue: ze,
		useDeferredValue: mt,
		useEffect: L,
		useId: Ve,
		useImperativeHandle: Fe,
		useInsertionEffect: Lt,
		useLayoutEffect: Ne,
		useMemo: Ie,
		useReducer: Me,
		useRef: Pe,
		useState: I,
		useSyncExternalStore: dt,
		useTransition: ht
	} } }, an = "18.3.1", on = function(e, t) {
		return e(t);
	}, sn = function(e, t) {
		var n, r = N.debounceRendering;
		N.debounceRendering = function(e) {
			n = e;
		};
		try {
			var i = e(t);
			return n && n(), i;
		} finally {
			N.debounceRendering = r;
		}
	}, cn = jt, z = {
		useState: I,
		useId: Ve,
		useReducer: Me,
		useEffect: L,
		useLayoutEffect: Ne,
		useInsertionEffect: Lt,
		useTransition: ht,
		useDeferredValue: mt,
		useSyncExternalStore: dt,
		startTransition: pt,
		useRef: Pe,
		useImperativeHandle: Fe,
		useMemo: Ie,
		useCallback: Le,
		useContext: Re,
		useDebugValue: ze,
		version: "18.3.1",
		Children: Vt,
		render: Ot,
		hydrate: kt,
		unmountComponentAtNode: Ft,
		createPortal: Dt,
		createElement: m,
		createContext: ue,
		createFactory: At,
		cloneElement: Pt,
		createRef: g,
		Fragment: _,
		isValidElement: jt,
		isElement: cn,
		isFragment: Mt,
		isMemo: Nt,
		findDOMNode: It,
		Component: v,
		PureComponent: gt,
		memo: _t,
		forwardRef: vt,
		flushSync: sn,
		unstable_batchedUpdates: on,
		StrictMode: _,
		Suspense: xt,
		SuspenseList: wt,
		lazy: Ct,
		__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: rn
	};
}));
//#endregion
//#region node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
function un(e) {
	if (e.sheet) return e.sheet;
	/* istanbul ignore next */
	for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
}
function dn(e) {
	var t = document.createElement("style");
	return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var fn, pn = o((() => {
	fn = /*#__PURE__*/ function() {
		function e(e) {
			var t = this;
			this._insertTag = function(e) {
				var n = t.tags.length === 0 ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling;
				t.container.insertBefore(e, n), t.tags.push(e);
			}, this.isSpeedy = e.speedy === void 0 || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
		}
		var t = e.prototype;
		return t.hydrate = function(e) {
			e.forEach(this._insertTag);
		}, t.insert = function(e) {
			this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(dn(this));
			var t = this.tags[this.tags.length - 1];
			if (this.isSpeedy) {
				var n = un(t);
				try {
					n.insertRule(e, n.cssRules.length);
				} catch {}
			} else t.appendChild(document.createTextNode(e));
			this.ctr++;
		}, t.flush = function() {
			this.tags.forEach(function(e) {
				return e.parentNode?.removeChild(e);
			}), this.tags = [], this.ctr = 0;
		}, e;
	}();
})), mn, hn, gn, _n, vn, yn, bn, xn, Sn, Cn = o((() => {
	mn = "-ms-", hn = "-moz-", gn = "-webkit-", _n = "comm", vn = "rule", yn = "decl", bn = "@import", xn = "@keyframes", Sn = "@layer";
}));
//#endregion
//#region node_modules/stylis/src/Utility.js
function wn(e, t) {
	return kn(e, 0) ^ 45 ? (((t << 2 ^ kn(e, 0)) << 2 ^ kn(e, 1)) << 2 ^ kn(e, 2)) << 2 ^ kn(e, 3) : 0;
}
function Tn(e) {
	return e.trim();
}
function En(e, t) {
	return (e = t.exec(e)) ? e[0] : e;
}
function Dn(e, t, n) {
	return e.replace(t, n);
}
function On(e, t) {
	return e.indexOf(t);
}
function kn(e, t) {
	return e.charCodeAt(t) | 0;
}
function An(e, t, n) {
	return e.slice(t, n);
}
function jn(e) {
	return e.length;
}
function Mn(e) {
	return e.length;
}
function Nn(e, t) {
	return t.push(e), e;
}
function Pn(e, t) {
	return e.map(t).join("");
}
var Fn, In, Ln, Rn = o((() => {
	Fn = Math.abs, In = String.fromCharCode, Ln = Object.assign;
}));
//#endregion
//#region node_modules/stylis/src/Tokenizer.js
function zn(e, t, n, r, i, a, o) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: nr,
		column: rr,
		length: o,
		return: ""
	};
}
function Bn(e, t) {
	return Ln(zn("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Vn() {
	return or;
}
function Hn() {
	return or = ar > 0 ? kn(sr, --ar) : 0, rr--, or === 10 && (rr = 1, nr--), or;
}
function Un() {
	return or = ar < ir ? kn(sr, ar++) : 0, rr++, or === 10 && (rr = 1, nr++), or;
}
function Wn() {
	return kn(sr, ar);
}
function Gn() {
	return ar;
}
function Kn(e, t) {
	return An(sr, e, t);
}
function qn(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function Jn(e) {
	return nr = rr = 1, ir = jn(sr = e), ar = 0, [];
}
function Yn(e) {
	return sr = "", e;
}
function Xn(e) {
	return Tn(Kn(ar - 1, $n(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Zn(e) {
	for (; (or = Wn()) && or < 33;) Un();
	return qn(e) > 2 || qn(or) > 3 ? "" : " ";
}
function Qn(e, t) {
	for (; --t && Un() && !(or < 48 || or > 102 || or > 57 && or < 65 || or > 70 && or < 97););
	return Kn(e, Gn() + (t < 6 && Wn() == 32 && Un() == 32));
}
function $n(e) {
	for (; Un();) switch (or) {
		case e: return ar;
		case 34:
		case 39:
			e !== 34 && e !== 39 && $n(or);
			break;
		case 40:
			e === 41 && $n(e);
			break;
		case 92: Un();
	}
	return ar;
}
function er(e, t) {
	for (; Un() && e + or !== 57 && (e + or !== 84 || Wn() !== 47););
	return "/*" + Kn(t, ar - 1) + "*" + In(e === 47 ? e : Un());
}
function tr(e) {
	for (; !qn(Wn());) Un();
	return Kn(e, ar);
}
var nr, rr, ir, ar, or, sr, cr = o((() => {
	Rn(), nr = 1, rr = 1, ir = 0, ar = 0, or = 0, sr = "";
}));
//#endregion
//#region node_modules/stylis/src/Parser.js
function lr(e) {
	return Yn(ur("", null, null, null, [""], e = Jn(e), 0, [0], e));
}
function ur(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = "", b = i, x = a, S = r, C = y; g;) switch (m = v, v = Un()) {
		case 40: if (m != 108 && kn(C, d - 1) == 58) {
			On(C += Dn(Xn(v), "&", "&\f"), "&\f") != -1 && (_ = -1);
			break;
		}
		case 34:
		case 39:
		case 91:
			C += Xn(v);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			C += Zn(m);
			break;
		case 92:
			C += Qn(Gn() - 1, 7);
			continue;
		case 47:
			switch (Wn()) {
				case 42:
				case 47:
					Nn(fr(er(Un(), Gn()), t, n), c);
					break;
				default: C += "/";
			}
			break;
		case 123 * h: s[l++] = jn(C) * _;
		case 125 * h:
		case 59:
		case 0:
			switch (v) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (C = Dn(C, /\f/g, "")), p > 0 && jn(C) - d && Nn(p > 32 ? pr(C + ";", r, n, d - 1) : pr(Dn(C, " ", "") + ";", r, n, d - 2), c);
					break;
				case 59: C += ";";
				default: if (Nn(S = dr(C, t, n, l, u, i, s, y, b = [], x = [], d), a), v === 123) {
					if (u === 0) ur(C, t, S, S, b, a, d, s, x);
					else switch (f === 99 && kn(C, 3) === 110 ? 100 : f) {
						case 100:
						case 108:
						case 109:
						case 115:
							ur(e, S, S, r && Nn(dr(e, S, S, 0, 0, i, s, y, i, b = [], d), x), i, x, d, s, r ? b : x);
							break;
						default: ur(C, S, S, S, [""], x, 0, s, x);
					}
				}
			}
			l = u = p = 0, h = _ = 1, y = C = "", d = o;
			break;
		case 58: d = 1 + jn(C), p = m;
		default:
			if (h < 1) {
				if (v == 123) --h;
				else if (v == 125 && h++ == 0 && Hn() == 125) continue;
			}
			switch (C += In(v), v * h) {
				case 38:
					_ = u > 0 ? 1 : (C += "\f", -1);
					break;
				case 44:
					s[l++] = (jn(C) - 1) * _, _ = 1;
					break;
				case 64:
					Wn() === 45 && (C += Xn(Un())), f = Wn(), u = d = jn(y = C += tr(Gn())), v++;
					break;
				case 45: m === 45 && jn(C) == 2 && (h = 0);
			}
	}
	return a;
}
function dr(e, t, n, r, i, a, o, s, c, l, u) {
	for (var d = i - 1, f = i === 0 ? a : [""], p = Mn(f), m = 0, h = 0, g = 0; m < r; ++m) for (var _ = 0, v = An(e, d + 1, d = Fn(h = o[m])), y = e; _ < p; ++_) (y = Tn(h > 0 ? f[_] + " " + v : Dn(v, /&\f/g, f[_]))) && (c[g++] = y);
	return zn(e, t, n, i === 0 ? vn : s, c, l, u);
}
function fr(e, t, n) {
	return zn(e, t, n, _n, In(Vn()), An(e, 2, -2), 0);
}
function pr(e, t, n, r) {
	return zn(e, t, n, yn, An(e, 0, r), An(e, r + 1, -1), r);
}
var mr = o((() => {
	Cn(), Rn(), cr();
})), hr = o((() => {}));
//#endregion
//#region node_modules/stylis/src/Serializer.js
function gr(e, t) {
	for (var n = "", r = Mn(e), i = 0; i < r; i++) n += t(e[i], i, e, t) || "";
	return n;
}
function _r(e, t, n, r) {
	switch (e.type) {
		case Sn: if (e.children.length) break;
		case bn:
		case yn: return e.return = e.return || e.value;
		case _n: return "";
		case xn: return e.return = e.value + "{" + gr(e.children, r) + "}";
		case vn: e.value = e.props.join(",");
	}
	return jn(n = gr(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
var vr = o((() => {
	Cn(), Rn();
}));
//#endregion
//#region node_modules/stylis/src/Middleware.js
function yr(e) {
	var t = Mn(e);
	return function(n, r, i, a) {
		for (var o = "", s = 0; s < t; s++) o += e[s](n, r, i, a) || "";
		return o;
	};
}
function br(e) {
	return function(t) {
		t.root || (t = t.return) && e(t);
	};
}
var xr = o((() => {
	Rn();
})), Sr = o((() => {
	Cn(), Rn(), mr(), hr(), cr(), vr(), xr();
}));
//#endregion
//#region node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function Cr(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
var wr = o((() => {}));
//#endregion
//#region node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
function Tr(e, t) {
	switch (wn(e, t)) {
		case 5103: return gn + "print-" + e + e;
		case 5737:
		case 4201:
		case 3177:
		case 3433:
		case 1641:
		case 4457:
		case 2921:
		case 5572:
		case 6356:
		case 5844:
		case 3191:
		case 6645:
		case 3005:
		case 6391:
		case 5879:
		case 5623:
		case 6135:
		case 4599:
		case 4855:
		case 4215:
		case 6389:
		case 5109:
		case 5365:
		case 5621:
		case 3829: return gn + e + e;
		case 5349:
		case 4246:
		case 4810:
		case 6968:
		case 2756: return gn + e + hn + e + mn + e + e;
		case 6828:
		case 4268: return gn + e + mn + e + e;
		case 6165: return gn + e + mn + "flex-" + e + e;
		case 5187: return gn + e + Dn(e, /(\w+).+(:[^]+)/, gn + "box-$1$2" + mn + "flex-$1$2") + e;
		case 5443: return gn + e + mn + "flex-item-" + Dn(e, /flex-|-self/, "") + e;
		case 4675: return gn + e + mn + "flex-line-pack" + Dn(e, /align-content|flex-|-self/, "") + e;
		case 5548: return gn + e + mn + Dn(e, "shrink", "negative") + e;
		case 5292: return gn + e + mn + Dn(e, "basis", "preferred-size") + e;
		case 6060: return gn + "box-" + Dn(e, "-grow", "") + gn + e + mn + Dn(e, "grow", "positive") + e;
		case 4554: return gn + Dn(e, /([^-])(transform)/g, "$1" + gn + "$2") + e;
		case 6187: return Dn(Dn(Dn(e, /(zoom-|grab)/, gn + "$1"), /(image-set)/, gn + "$1"), e, "") + e;
		case 5495:
		case 3959: return Dn(e, /(image-set\([^]*)/, gn + "$1$`$1");
		case 4968: return Dn(Dn(e, /(.+:)(flex-)?(.*)/, gn + "box-pack:$3" + mn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + gn + e + e;
		case 4095:
		case 3583:
		case 4068:
		case 2532: return Dn(e, /(.+)-inline(.+)/, gn + "$1$2") + e;
		case 8116:
		case 7059:
		case 5753:
		case 5535:
		case 5445:
		case 5701:
		case 4933:
		case 4677:
		case 5533:
		case 5789:
		case 5021:
		case 4765:
			if (jn(e) - 1 - t > 6) switch (kn(e, t + 1)) {
				case 109: if (kn(e, t + 4) !== 45) break;
				case 102: return Dn(e, /(.+:)(.+)-([^]+)/, "$1" + gn + "$2-$3$1" + hn + (kn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
				case 115: return ~On(e, "stretch") ? Tr(Dn(e, "stretch", "fill-available"), t) + e : e;
			}
			break;
		case 4949: if (kn(e, t + 1) !== 115) break;
		case 6444:
			switch (kn(e, jn(e) - 3 - (~On(e, "!important") && 10))) {
				case 107: return Dn(e, ":", ":" + gn) + e;
				case 101: return Dn(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + gn + (kn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + gn + "$2$3$1" + mn + "$2box$3") + e;
			}
			break;
		case 5936:
			switch (kn(e, t + 11)) {
				case 114: return gn + e + mn + Dn(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
				case 108: return gn + e + mn + Dn(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
				case 45: return gn + e + mn + Dn(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
			}
			return gn + e + mn + e + e;
	}
	return e;
}
var Er, Dr, Or, kr, Ar, jr, Mr, Nr, Pr = o((() => {
	pn(), Sr(), Er = function(e, t, n) {
		for (var r = 0, i = 0; r = i, i = Wn(), r === 38 && i === 12 && (t[n] = 1), !qn(i);) Un();
		return Kn(e, ar);
	}, Dr = function(e, t) {
		var n = -1, r = 44;
		do
			switch (qn(r)) {
				case 0:
					r === 38 && Wn() === 12 && (t[n] = 1), e[n] += Er(ar - 1, t, n);
					break;
				case 2:
					e[n] += Xn(r);
					break;
				case 4: if (r === 44) {
					e[++n] = Wn() === 58 ? "&\f" : "", t[n] = e[n].length;
					break;
				}
				default: e[n] += In(r);
			}
		while (r = Un());
		return e;
	}, Or = function(e, t) {
		return Yn(Dr(Jn(e), t));
	}, kr = /* #__PURE__ */ new WeakMap(), Ar = function(e) {
		if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
			for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) if (n = n.parent, !n) return;
			if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !kr.get(n)) && !r) {
				kr.set(e, !0);
				for (var i = [], a = Or(t, i), o = n.props, s = 0, c = 0; s < a.length; s++) for (var l = 0; l < o.length; l++, c++) e.props[c] = i[s] ? a[s].replace(/&\f/g, o[l]) : o[l] + " " + a[s];
			}
		}
	}, jr = function(e) {
		if (e.type === "decl") {
			var t = e.value;
			t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
		}
	}, Mr = [function(e, t, n, r) {
		if (e.length > -1 && !e.return) switch (e.type) {
			case yn:
				e.return = Tr(e.value, e.length);
				break;
			case xn: return gr([Bn(e, { value: Dn(e.value, "@", "@" + gn) })], r);
			case vn: if (e.length) return Pn(e.props, function(t) {
				switch (En(t, /(::plac\w+|:read-\w+)/)) {
					case ":read-only":
					case ":read-write": return gr([Bn(e, { props: [Dn(t, /:(read-\w+)/, ":" + hn + "$1")] })], r);
					case "::placeholder": return gr([
						Bn(e, { props: [Dn(t, /:(plac\w+)/, ":" + gn + "input-$1")] }),
						Bn(e, { props: [Dn(t, /:(plac\w+)/, ":" + hn + "$1")] }),
						Bn(e, { props: [Dn(t, /:(plac\w+)/, mn + "input-$1")] })
					], r);
				}
				return "";
			});
		}
	}], Nr = function(e) {
		var t = e.key;
		if (t === "css") {
			var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
			Array.prototype.forEach.call(n, function(e) {
				e.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(e), e.setAttribute("data-s", ""));
			});
		}
		var r = e.stylisPlugins || Mr, i = {}, a, o = [];
		a = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + t + " \"]"), function(e) {
			for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) i[t[n]] = !0;
			o.push(e);
		});
		var s, c = [Ar, jr], l, u = [_r, br(function(e) {
			l.insert(e);
		})], d = yr(c.concat(r, u)), f = function(e) {
			return gr(lr(e), d);
		};
		s = function(e, t, n, r) {
			l = n, f(e ? e + "{" + t.styles + "}" : t.styles), r && (p.inserted[t.name] = !0);
		};
		var p = {
			key: t,
			sheet: new fn({
				key: t,
				container: a,
				nonce: e.nonce,
				speedy: e.speedy,
				prepend: e.prepend,
				insertionPoint: e.insertionPoint
			}),
			nonce: e.nonce,
			inserted: i,
			registered: {},
			insert: s
		};
		return p.sheet.hydrate(o), p;
	};
})), Fr = /* @__PURE__ */ s(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Ir = /* @__PURE__ */ s(((e, t) => {
	t.exports = Fr();
})), Lr = /* @__PURE__ */ s(((e, t) => {
	var n = Ir(), r = {
		childContextTypes: !0,
		contextType: !0,
		contextTypes: !0,
		defaultProps: !0,
		displayName: !0,
		getDefaultProps: !0,
		getDerivedStateFromError: !0,
		getDerivedStateFromProps: !0,
		mixins: !0,
		propTypes: !0,
		type: !0
	}, i = {
		name: !0,
		length: !0,
		prototype: !0,
		caller: !0,
		callee: !0,
		arguments: !0,
		arity: !0
	}, a = {
		$$typeof: !0,
		render: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0
	}, o = {
		$$typeof: !0,
		compare: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0,
		type: !0
	}, s = {};
	s[n.ForwardRef] = a, s[n.Memo] = o;
	function c(e) {
		return n.isMemo(e) ? o : s[e.$$typeof] || r;
	}
	var l = Object.defineProperty, u = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, m = Object.prototype;
	function h(e, t, n) {
		if (typeof t != "string") {
			if (m) {
				var r = p(t);
				r && r !== m && h(e, r, n);
			}
			var a = u(t);
			d && (a = a.concat(d(t)));
			for (var o = c(e), s = c(t), g = 0; g < a.length; ++g) {
				var _ = a[g];
				if (!i[_] && !(n && n[_]) && !(s && s[_]) && !(o && o[_])) {
					var v = f(t, _);
					try {
						l(e, _, v);
					} catch {}
				}
			}
		}
		return e;
	}
	t.exports = h;
}));
//#endregion
//#region node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
function Rr(e, t, n) {
	var r = "";
	return n.split(" ").forEach(function(n) {
		e[n] === void 0 ? n && (r += n + " ") : t.push(e[n] + ";");
	}), r;
}
var zr, Br, Vr = o((() => {
	zr = function(e, t, n) {
		var r = e.key + "-" + t.name;
		n === !1 && e.registered[r] === void 0 && (e.registered[r] = t.styles);
	}, Br = function(e, t, n) {
		zr(e, t, n);
		var r = e.key + "-" + t.name;
		if (e.inserted[t.name] === void 0) {
			var i = t;
			do
				e.insert(t === i ? "." + r : "", i, e.sheet, !0), i = i.next;
			while (i !== void 0);
		}
	};
}));
//#endregion
//#region node_modules/@emotion/hash/dist/emotion-hash.esm.js
function Hr(e) {
	for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4) n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	switch (i) {
		case 3: t ^= (e.charCodeAt(r + 2) & 255) << 16;
		case 2: t ^= (e.charCodeAt(r + 1) & 255) << 8;
		case 1: t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	}
	return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Ur = o((() => {})), Wr, Gr = o((() => {
	Wr = {
		animationIterationCount: 1,
		aspectRatio: 1,
		borderImageOutset: 1,
		borderImageSlice: 1,
		borderImageWidth: 1,
		boxFlex: 1,
		boxFlexGroup: 1,
		boxOrdinalGroup: 1,
		columnCount: 1,
		columns: 1,
		flex: 1,
		flexGrow: 1,
		flexPositive: 1,
		flexShrink: 1,
		flexNegative: 1,
		flexOrder: 1,
		gridRow: 1,
		gridRowEnd: 1,
		gridRowSpan: 1,
		gridRowStart: 1,
		gridColumn: 1,
		gridColumnEnd: 1,
		gridColumnSpan: 1,
		gridColumnStart: 1,
		msGridRow: 1,
		msGridRowSpan: 1,
		msGridColumn: 1,
		msGridColumnSpan: 1,
		fontWeight: 1,
		lineHeight: 1,
		opacity: 1,
		order: 1,
		orphans: 1,
		scale: 1,
		tabSize: 1,
		widows: 1,
		zIndex: 1,
		zoom: 1,
		WebkitLineClamp: 1,
		fillOpacity: 1,
		floodOpacity: 1,
		stopOpacity: 1,
		strokeDasharray: 1,
		strokeDashoffset: 1,
		strokeMiterlimit: 1,
		strokeOpacity: 1,
		strokeWidth: 1
	};
}));
//#endregion
//#region node_modules/@emotion/serialize/dist/emotion-serialize.esm.js
function Kr(e, t, n) {
	if (n == null) return "";
	var r = n;
	if (r.__emotion_styles !== void 0) return r;
	switch (typeof n) {
		case "boolean": return "";
		case "object":
			var i = n;
			if (i.anim === 1) return ii = {
				name: i.name,
				styles: i.styles,
				next: ii
			}, i.name;
			var a = n;
			if (a.styles !== void 0) {
				var o = a.next;
				if (o !== void 0) for (; o !== void 0;) ii = {
					name: o.name,
					styles: o.styles,
					next: ii
				}, o = o.next;
				return a.styles + ";";
			}
			return qr(e, t, n);
		case "function": if (e !== void 0) {
			var s = ii, c = n(e);
			return ii = s, Kr(e, t, c);
		}
	}
	var l = n;
	if (t == null) return l;
	var u = t[l];
	return u === void 0 ? l : u;
}
function qr(e, t, n) {
	var r = "";
	if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += Kr(e, t, n[i]) + ";";
	else for (var a in n) {
		var o = n[a];
		if (typeof o != "object") {
			var s = o;
			t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : $r(s) && (r += ei(a) + ":" + ti(a, s) + ";");
		} else {
			if (a === "NO_COMPONENT_SELECTOR" && Yr) throw Error(ni);
			if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0)) for (var c = 0; c < o.length; c++) $r(o[c]) && (r += ei(a) + ":" + ti(a, o[c]) + ";");
			else {
				var l = Kr(e, t, o);
				switch (a) {
					case "animation":
					case "animationName":
						r += ei(a) + ":" + l + ";";
						break;
					default: r += a + "{" + l + "}";
				}
			}
		}
	}
	return r;
}
function Jr(e, t, n) {
	if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
	var r = !0, i = "";
	ii = void 0;
	var a = e[0];
	a == null || a.raw === void 0 ? (r = !1, i += Kr(n, t, a)) : i += a[0];
	for (var o = 1; o < e.length; o++) i += Kr(n, t, e[o]), r && (i += a[o]);
	ri.lastIndex = 0;
	for (var s = "", c; (c = ri.exec(i)) !== null;) s += "-" + c[1];
	return {
		name: Hr(i) + s,
		styles: i,
		next: ii
	};
}
var Yr, Xr, Zr, Qr, $r, ei, ti, ni, ri, ii, ai = o((() => {
	Ur(), Gr(), wr(), Yr = !1, Xr = /[A-Z]|^ms/g, Zr = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Qr = function(e) {
		return e.charCodeAt(1) === 45;
	}, $r = function(e) {
		return e != null && typeof e != "boolean";
	}, ei = /* #__PURE__ */ Cr(function(e) {
		return Qr(e) ? e : e.replace(Xr, "-$&").toLowerCase();
	}), ti = function(e, t) {
		switch (e) {
			case "animation":
			case "animationName": if (typeof t == "string") return t.replace(Zr, function(e, t, n) {
				return ii = {
					name: t,
					styles: n,
					next: ii
				}, t;
			});
		}
		return Wr[e] !== 1 && !Qr(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
	}, ni = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.", ri = /label:\s*([^\s;{]+)\s*(;|$)/g;
})), oi, si, ci, li = o((() => {
	ln(), oi = function(e) {
		return e();
	}, si = Lt || !1, ci = si || oi;
})), ui, di, fi, pi, mi, hi, gi, _i, vi, yi, bi = o((() => {
	ln(), Pr(), Vr(), ai(), li(), ui = /* #__PURE__ */ ue(typeof HTMLElement < "u" ? /* #__PURE__ */ Nr({ key: "css" }) : null), di = ui.Provider, fi = function(e) {
		return /*#__PURE__*/ vt(function(t, n) {
			return e(t, Re(ui), n);
		});
	}, pi = /* #__PURE__ */ ue({}), mi = function() {
		return Re(pi);
	}, hi = {}.hasOwnProperty, gi = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", _i = function(e, t) {
		var n = {};
		for (var r in t) hi.call(t, r) && (n[r] = t[r]);
		return n[gi] = e, n;
	}, vi = function(e) {
		var t = e.cache, n = e.serialized, r = e.isStringTag;
		return zr(t, n, r), ci(function() {
			return Br(t, n, r);
		}), null;
	}, yi = /* @__PURE__ */ fi(function(e, t, n) {
		var r = e.css;
		typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
		var i = e[gi], a = [r], o = "";
		typeof e.className == "string" ? o = Rr(t.registered, a, e.className) : e.className != null && (o = e.className + " ");
		var s = Jr(a, void 0, Re(pi));
		o += t.key + "-" + s.name;
		var c = {};
		for (var l in e) hi.call(e, l) && l !== "css" && l !== gi && (c[l] = e[l]);
		return c.className = o, n && (c.ref = n), /*#__PURE__*/ m(_, null, /*#__PURE__*/ m(vi, {
			cache: t,
			serialized: s,
			isStringTag: typeof i == "string"
		}), /*#__PURE__*/ m(i, c));
	});
}));
//#endregion
//#region node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
function B(e, t, n) {
	return hi.call(t, "css") ? F(yi, _i(e, t), n) : F(e, t, n);
}
function V(e, t, n) {
	return hi.call(t, "css") ? F(yi, _i(e, t), n) : F(e, t, n);
}
var xi, H = o((() => {
	Ae(), bi(), ln(), Lr(), li(), xi = _;
})), U = /* @__PURE__ */ s(((e, t) => {
	var n = function(e) {
		return r(e) && !i(e);
	};
	function r(e) {
		return !!e && typeof e == "object";
	}
	function i(e) {
		var t = Object.prototype.toString.call(e);
		return t === "[object RegExp]" || t === "[object Date]" || o(e);
	}
	var a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
	function o(e) {
		return e.$$typeof === a;
	}
	function s(e) {
		return Array.isArray(e) ? [] : {};
	}
	function c(e, t) {
		return t.clone !== !1 && t.isMergeableObject(e) ? g(s(e), e, t) : e;
	}
	function l(e, t, n) {
		return e.concat(t).map(function(e) {
			return c(e, n);
		});
	}
	function u(e, t) {
		if (!t.customMerge) return g;
		var n = t.customMerge(e);
		return typeof n == "function" ? n : g;
	}
	function d(e) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
			return Object.propertyIsEnumerable.call(e, t);
		}) : [];
	}
	function f(e) {
		return Object.keys(e).concat(d(e));
	}
	function p(e, t) {
		try {
			return t in e;
		} catch {
			return !1;
		}
	}
	function m(e, t) {
		return p(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
	}
	function h(e, t, n) {
		var r = {};
		return n.isMergeableObject(e) && f(e).forEach(function(t) {
			r[t] = c(e[t], n);
		}), f(t).forEach(function(i) {
			m(e, i) || (r[i] = p(e, i) && n.isMergeableObject(t[i]) ? u(i, n)(e[i], t[i], n) : c(t[i], n));
		}), r;
	}
	function g(e, t, r) {
		r ||= {}, r.arrayMerge = r.arrayMerge || l, r.isMergeableObject = r.isMergeableObject || n, r.cloneUnlessOtherwiseSpecified = c;
		var i = Array.isArray(t);
		return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : h(e, t, r) : c(t, r);
	}
	g.all = function(e, t) {
		if (!Array.isArray(e)) throw Error("first argument should be an array");
		return e.reduce(function(e, n) {
			return g(e, n, t);
		}, {});
	}, t.exports = g;
}));
//#endregion
//#region node_modules/is-plain-object/dist/is-plain-object.mjs
function Si(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Ci(e) {
	var t, n;
	return Si(e) !== !1 && (t = e.constructor, t === void 0 || (n = t.prototype, Si(n) !== !1 && n.hasOwnProperty("isPrototypeOf") !== !1));
}
var wi = o((() => {}));
//#endregion
//#region node_modules/mobx/dist/mobx.esm.js
function W(e) {
	var t = [...arguments].slice(1);
	throw Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (t.length ? " " + t.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
function Ti() {
	return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : Fs;
}
function Ei() {
	Hs || W("Proxy not available");
}
function Di(e) {
	var t = !1;
	return function() {
		if (!t) return t = !0, e.apply(this, arguments);
	};
}
function Oi(e) {
	return typeof e == "function";
}
function ki(e) {
	switch (typeof e) {
		case "string":
		case "symbol":
		case "number": return !0;
	}
	return !1;
}
function Ai(e) {
	return typeof e == "object" && !!e;
}
function ji(e) {
	if (!Ai(e)) return !1;
	var t = Object.getPrototypeOf(e);
	if (t == null) return !0;
	var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n.toString() === Us;
}
function Mi(e) {
	var t = e?.constructor;
	return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Ni(e, t, n) {
	Rs(e, t, {
		enumerable: !1,
		writable: !0,
		configurable: !0,
		value: n
	});
}
function Pi(e, t, n) {
	Rs(e, t, {
		enumerable: !1,
		writable: !1,
		configurable: !0,
		value: n
	});
}
function Fi(e, t) {
	var n = "isMobX" + e;
	return t.prototype[n] = !0, function(e) {
		return Ai(e) && e[n] === !0;
	};
}
function Ii(e) {
	return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function Li(e) {
	var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t);
	return Object.getPrototypeOf(n) === null;
}
function Ri(e) {
	return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
function zi(e) {
	var t = Object.keys(e);
	if (!Gs) return t;
	var n = Object.getOwnPropertySymbols(e);
	return n.length ? [].concat(t, n.filter(function(t) {
		return zs.propertyIsEnumerable.call(e, t);
	})) : t;
}
function Bi(e) {
	return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Vi(e, t) {
	return zs.hasOwnProperty.call(e, t);
}
function Hi(e, t) {
	return !!(e & t);
}
function Ui(e, t, n) {
	return n ? e |= t : e &= ~t, e;
}
function Wi(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Gi(e, t, n) {
	if ($i()) return Reflect.construct.apply(null, arguments);
	var r = [null];
	r.push.apply(r, t);
	var i = new (e.bind.apply(e, r))();
	return n && ea(i, n.prototype), i;
}
function Ki(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, na(r.key), r);
	}
}
function qi(e, t, n) {
	return t && Ki(e.prototype, t), n && Ki(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ji(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = ra(e)) || t && e && typeof e.length == "number") {
		n && (e = n);
		var r = 0;
		return function() {
			return r >= e.length ? { done: !0 } : {
				done: !1,
				value: e[r++]
			};
		};
	}
	throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Yi() {
	return Yi = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Yi.apply(null, arguments);
}
function Xi(e) {
	return Xi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
		return e.__proto__ || Object.getPrototypeOf(e);
	}, Xi(e);
}
function Zi(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ea(e, t);
}
function Qi(e) {
	try {
		return Function.toString.call(e).indexOf("[native code]") !== -1;
	} catch {
		return typeof e == "function";
	}
}
function $i() {
	try {
		var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch {}
	return ($i = function() {
		return !!e;
	})();
}
function ea(e, t) {
	return ea = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
		return e.__proto__ = t, e;
	}, ea(e, t);
}
function ta(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function na(e) {
	var t = ta(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function ra(e, t) {
	if (e) {
		if (typeof e == "string") return Wi(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Wi(e, t) : void 0;
	}
}
function ia(e) {
	var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
	return ia = function(e) {
		if (e === null || !Qi(e)) return e;
		if (typeof e != "function") throw TypeError("Super expression must either be null or a function");
		if (t !== void 0) {
			if (t.has(e)) return t.get(e);
			t.set(e, n);
		}
		function n() {
			return Gi(e, arguments, Xi(this).constructor);
		}
		return n.prototype = Object.create(e.prototype, { constructor: {
			value: n,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} }), ea(n, e);
	}, ia(e);
}
function aa(e) {
	function t(t, n) {
		if (ca(n)) return e.decorate_20223_(t, n);
		oa(t, n, e);
	}
	return Object.assign(t, e);
}
function oa(e, t, n) {
	Vi(e, Js) || Ni(e, Js, Yi({}, e[Js])), va(n) || (e[Js][t] = n);
}
function sa(e) {
	return Vi(e, Js) || Ni(e, Js, Yi({}, e[Js])), e[Js];
}
function ca(e) {
	return typeof e == "object" && typeof e.kind == "string";
}
function la(e, t, n) {
	t === void 0 && (t = Ws), n === void 0 && (n = Ws);
	var r = new Ys(e);
	return t !== Ws && Io(r, t), n !== Ws && Lo(r, n), r;
}
function ua(e, t) {
	return e === t;
}
function da(e, t) {
	return As(e, t);
}
function fa(e, t) {
	return As(e, t, 1);
}
function pa(e, t) {
	return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function ma(e, t, n) {
	return qo(e) ? e : Array.isArray(e) ? K.array(e, { name: n }) : ji(e) ? K.object(e, void 0, { name: n }) : Ii(e) ? K.map(e, { name: n }) : Ri(e) ? K.set(e, { name: n }) : typeof e == "function" && !jo(e) && !Go(e) ? Mi(e) ? tl(e) : Wc(n, e) : e;
}
function ha(e, t, n) {
	if (e == null || ys(e) || ps(e) || ml(e) || _l(e)) return e;
	if (Array.isArray(e)) return K.array(e, {
		name: n,
		deep: !1
	});
	if (ji(e)) return K.object(e, void 0, {
		name: n,
		deep: !1
	});
	if (Ii(e)) return K.map(e, {
		name: n,
		deep: !1
	});
	if (Ri(e)) return K.set(e, {
		name: n,
		deep: !1
	});
}
function ga(e) {
	return e;
}
function _a(e, t) {
	return As(e, t) ? t : e;
}
function va(e) {
	return e.annotationType_ === Qs;
}
function ya(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: ba,
		extend_: xa,
		decorate_20223_: Sa
	};
}
function ba(e, t, n, r) {
	var i;
	return (i = this.options_) != null && i.bound ? this.extend_(e, t, n, !1) === null ? 0 : 1 : r === e.target_ ? this.extend_(e, t, n, !1) === null ? 0 : 2 : jo(n.value) ? 1 : (Rs(r, t, wa(e, this, t, n, !1)), 2);
}
function xa(e, t, n, r) {
	var i = wa(e, this, t, n);
	return e.defineProperty_(t, i, r);
}
function Sa(e, t) {
	var n = t.kind, r = t.name, i = t.addInitializer, a = this, o = function(e) {
		return Xa(a.options_?.name ?? r.toString(), e, a.options_?.autoAction ?? !1);
	};
	if (n == "field") return function(e) {
		var t, n = e;
		return jo(n) || (n = o(n)), (t = a.options_) != null && t.bound && (n = n.bind(this), n.isMobxAction = !0), n;
	};
	if (n == "method") {
		var s;
		return jo(e) || (e = o(e)), (s = this.options_) != null && s.bound && i(function() {
			var e = this, t = e[r].bind(e);
			t.isMobxAction = !0, e[r] = t;
		}), e;
	}
	W("Cannot apply '" + a.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + ("\n'" + a.annotationType_ + "' can only be used on properties with a function value."));
}
function Ca(e, t, n, r) {
	t.annotationType_, r.value;
}
function wa(e, t, n, r, i) {
	var a, o;
	i === void 0 && (i = q.safeDescriptors), Ca(e, t, n, r);
	var s = r.value;
	return (a = t.options_) != null && a.bound && (s = s.bind(e.proxy_ ?? e.target_)), {
		value: Xa(t.options_?.name ?? n.toString(), s, t.options_?.autoAction ?? !1, (o = t.options_) != null && o.bound ? e.proxy_ ?? e.target_ : void 0),
		configurable: !i || e.isPlainObject_,
		enumerable: !1,
		writable: !i
	};
}
function Ta(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: Ea,
		extend_: Da,
		decorate_20223_: Oa
	};
}
function Ea(e, t, n, r) {
	var i;
	return r === e.target_ ? this.extend_(e, t, n, !1) === null ? 0 : 2 : (i = this.options_) != null && i.bound && (!Vi(e.target_, t) || !Go(e.target_[t])) && this.extend_(e, t, n, !1) === null ? 0 : Go(n.value) ? 1 : (Rs(r, t, Aa(e, this, t, n, !1, !1)), 2);
}
function Da(e, t, n, r) {
	var i = Aa(e, this, t, n, this.options_?.bound);
	return e.defineProperty_(t, i, r);
}
function Oa(e, t) {
	var n, r = t.name, i = t.addInitializer;
	return Go(e) || (e = tl(e)), (n = this.options_) != null && n.bound && i(function() {
		var e = this, t = e[r].bind(e);
		t.isMobXFlow = !0, e[r] = t;
	}), e;
}
function ka(e, t, n, r) {
	t.annotationType_, r.value;
}
function Aa(e, t, n, r, i, a) {
	a === void 0 && (a = q.safeDescriptors), ka(e, t, n, r);
	var o = r.value;
	return Go(o) || (o = tl(o)), i && (o = o.bind(e.proxy_ ?? e.target_), o.isMobXFlow = !0), {
		value: o,
		configurable: !a || e.isPlainObject_,
		enumerable: !1,
		writable: !a
	};
}
function ja(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: Ma,
		extend_: Na,
		decorate_20223_: Pa
	};
}
function Ma(e, t, n) {
	return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Na(e, t, n, r) {
	return Fa(e, this, t, n), e.defineComputedProperty_(t, Yi({}, this.options_, {
		get: n.get,
		set: n.set
	}), r);
}
function Pa(e, t) {
	var n = this, r = t.name, i = t.addInitializer, a;
	function o(t, i) {
		var a = Yi({}, n.options_, {
			get: e,
			context: t
		});
		return a.name ||= "ObservableObject." + r.toString(), new Sc(a);
	}
	return i(function() {
		var t = _s(this)[G], n = this, i = t.values_.get(r);
		i instanceof Sc && i.derivation !== e && t.values_.delete(r), (t.lazyComputedKeys_ ??= /* @__PURE__ */ new Map()).set(r, function() {
			return o(n, t);
		});
	}), function() {
		var t = this[G], n = t.values_.get(r);
		if (n instanceof Sc && n.derivation !== e) {
			var i = a?.get(this);
			return i || (i = o(this, t), (a ??= /* @__PURE__ */ new WeakMap()).set(this, i)), i.get();
		}
		return t.getObservablePropValue_(r);
	};
}
function Fa(e, t, n, r) {
	t.annotationType_, r.get;
}
function Ia(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: La,
		extend_: Ra,
		decorate_20223_: za
	};
}
function La(e, t, n) {
	return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Ra(e, t, n, r) {
	return Ba(e, this, t, n), e.defineObservableProperty_(t, n.value, this.options_?.enhancer ?? ma, r);
}
function za(e, t) {
	var n = this, r = t.kind, i = t.name;
	if (r !== "accessor") return;
	function a(e, t) {
		var r = _s(e)[G];
		return (r.lazyObservableKeys_ ??= /* @__PURE__ */ new Map()).set(i, function() {
			return new bc(t, n.options_?.enhancer ?? ma, "ObservableObject." + i.toString(), !1);
		}), r;
	}
	return {
		get: function() {
			return (this[G] ?? a(this, e.get.call(this))).getObservablePropValue_(i);
		},
		set: function(e) {
			return (this[G] ?? a(this, e)).setObservablePropValue_(i, e);
		},
		init: function(e) {
			return a(this, e), e;
		}
	};
}
function Ba(e, t, n, r) {
	t.annotationType_;
}
function Va(e) {
	return {
		annotationType_: $s,
		options_: e,
		make_: Ha,
		extend_: Ua,
		decorate_20223_: Wa
	};
}
function Ha(e, t, n, r) {
	var i;
	if (n.get) return hc.make_(e, t, n, r);
	if (n.set) {
		var a = jo(n.set) ? n.set : Xa(t.toString(), n.set);
		return r === e.target_ ? e.defineProperty_(t, {
			configurable: !q.safeDescriptors || e.isPlainObject_,
			set: a
		}) === null ? 0 : 2 : (Rs(r, t, {
			configurable: !0,
			set: a
		}), 2);
	}
	if (r !== e.target_ && typeof n.value == "function") {
		var o;
		if (Mi(n.value)) {
			var s;
			return ((s = this.options_) != null && s.autoBind ? tl.bound : tl).make_(e, t, n, r);
		}
		return ((o = this.options_) != null && o.autoBind ? Wc.bound : Wc).make_(e, t, n, r);
	}
	var c = this.options_?.deep === !1 ? K.ref : K;
	return typeof n.value == "function" && (i = this.options_) != null && i.autoBind && (n.value = n.value.bind(e.proxy_ ?? e.target_)), c.make_(e, t, n, r);
}
function Ua(e, t, n, r) {
	var i;
	return n.get ? hc.extend_(e, t, n, r) : n.set ? e.defineProperty_(t, {
		configurable: !q.safeDescriptors || e.isPlainObject_,
		set: Xa(t.toString(), n.set)
	}, r) : (typeof n.value == "function" && (i = this.options_) != null && i.autoBind && (n.value = n.value.bind(e.proxy_ ?? e.target_)), (this.options_?.deep === !1 ? K.ref : K).extend_(e, t, n, r));
}
function Wa(e, t) {
	W("'" + this.annotationType_ + "' cannot be used as a decorator");
}
function Ga(e) {
	return e || ac;
}
function Ka(e) {
	return e.deep === !0 ? ma : e.deep === !1 ? ga : Ja(e.defaultDecorator);
}
function qa(e) {
	return e ? e.defaultDecorator ?? Va(e) : void 0;
}
function Ja(e) {
	return e ? e.options_?.enhancer ?? ma : ma;
}
function Ya(e, t, n) {
	if (ca(t)) return oc.decorate_20223_(e, t);
	if (ki(t)) {
		oa(e, t, oc);
		return;
	}
	return qo(e) ? e : ji(e) ? K.object(e, t, n) : Array.isArray(e) ? K.array(e, t) : Ii(e) ? K.map(e, t) : Ri(e) ? K.set(e, t) : typeof e == "object" && e ? e : K.box(e, t);
}
function Xa(e, t, n, r) {
	n === void 0 && (n = !1);
	function i() {
		return Za(e, n, t, r || this, arguments);
	}
	return i.isMobxAction = !0, i.toString = function() {
		return t.toString();
	}, vc && (yc.value = e, Rs(i, "name", yc)), i;
}
function Za(e, t, n, r, i) {
	var a = Qa(e, t, r, i);
	try {
		return n.apply(r, i);
	} catch (e) {
		throw a.error_ = e, e;
	} finally {
		$a(a);
	}
}
function Qa(e, t, n, r) {
	var i = !1, a = 0, o = q.trackingDerivation, s = !t || !o;
	yo();
	var c = q.allowStateChanges;
	s && (lo(), c = to(!0));
	var l = fo(!0), u = {
		runAsAction_: s,
		prevDerivation_: o,
		prevAllowStateChanges_: c,
		prevAllowStateReads_: l,
		notifySpy_: i,
		startTime_: a,
		actionId_: _c++,
		parentActionId_: gc
	};
	return gc = u.actionId_, u;
}
function $a(e) {
	gc !== e.actionId_ && W(30), gc = e.parentActionId_, e.error_ !== void 0 && (q.suppressReactionErrors = !0), no(e.prevAllowStateChanges_), po(e.prevAllowStateReads_), bo(), e.runAsAction_ && uo(e.prevDerivation_), q.suppressReactionErrors = !1;
}
function eo(e, t) {
	var n = to(e);
	try {
		return t();
	} finally {
		no(n);
	}
}
function to(e) {
	var t = q.allowStateChanges;
	return q.allowStateChanges = e, t;
}
function no(e) {
	q.allowStateChanges = e;
}
function ro(e) {
	return e instanceof Ec;
}
function io(e) {
	switch (e.dependenciesState_) {
		case wc.UP_TO_DATE_: return !1;
		case wc.NOT_TRACKING_:
		case wc.STALE_: return !0;
		case wc.POSSIBLY_STALE_:
			for (var t = fo(!0), n = lo(), r = e.observing_, i = r.length, a = 0; a < i; a++) {
				var o = r[a];
				if (Cc(o)) {
					if (q.disableErrorBoundaries) o.get();
					else try {
						o.get();
					} catch {
						return uo(n), po(t), !0;
					}
					if (e.dependenciesState_ === wc.STALE_) return uo(n), po(t), !0;
				}
			}
			return mo(e), uo(n), po(t), !1;
	}
}
function ao(e, t, n) {
	var r = fo(!0);
	mo(e), e.newObserving_ = Array(e.runId_ === 0 ? 100 : e.observing_.length), e.unboundDepsCount_ = 0, e.runId_ = ++q.runId;
	var i = q.trackingDerivation;
	q.trackingDerivation = e, q.inBatch++;
	var a;
	if (q.disableErrorBoundaries === !0) a = t.call(n);
	else try {
		a = t.call(n);
	} catch (e) {
		a = new Ec(e);
	}
	return q.inBatch--, q.trackingDerivation = i, oo(e), po(r), a;
}
function oo(e) {
	for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = wc.UP_TO_DATE_, i = 0, a = e.unboundDepsCount_, o = 0; o < a; o++) {
		var s = n[o];
		s.diffValue === 0 && (s.diffValue = 1, i !== o && (n[i] = s), i++), s.dependenciesState_ > r && (r = s.dependenciesState_);
	}
	for (n.length = i, e.newObserving_ = null, a = t.length; a--;) {
		var c = t[a];
		c.diffValue === 0 && _o(c, e), c.diffValue = 0;
	}
	for (; i--;) {
		var l = n[i];
		l.diffValue === 1 && (l.diffValue = 0, go(l, e));
	}
	r !== wc.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function so(e) {
	var t = e.observing_;
	e.observing_ = [];
	for (var n = t.length; n--;) _o(t[n], e);
	e.dependenciesState_ = wc.NOT_TRACKING_;
}
function co(e) {
	var t = lo();
	try {
		return e();
	} finally {
		uo(t);
	}
}
function lo() {
	var e = q.trackingDerivation;
	return q.trackingDerivation = null, e;
}
function uo(e) {
	q.trackingDerivation = e;
}
function fo(e) {
	var t = q.allowStateReads;
	return q.allowStateReads = e, t;
}
function po(e) {
	q.allowStateReads = e;
}
function mo(e) {
	if (e.dependenciesState_ !== wc.UP_TO_DATE_) {
		e.dependenciesState_ = wc.UP_TO_DATE_;
		for (var t = e.observing_, n = t.length; n--;) t[n].lowestObserverState_ = wc.UP_TO_DATE_;
	}
}
function ho() {
	if ((q.pendingReactions.length || q.inBatch || q.isRunningReactions) && W(36), kc = !0, Oc) {
		var e = Ti();
		--e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), q = new Dc();
	}
}
function go(e, t) {
	e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function _o(e, t) {
	e.observers_.delete(t), e.observers_.size === 0 && vo(e);
}
function vo(e) {
	e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, q.pendingUnobservations.push(e));
}
function yo() {
	q.inBatch++;
}
function bo() {
	if (--q.inBatch === 0) {
		To();
		for (var e = q.pendingUnobservations, t = 0; t < e.length; t++) {
			var n = e[t];
			n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof Sc && n.suspend_());
		}
		q.pendingUnobservations = [];
	}
}
function xo(e) {
	var t = q.trackingDerivation;
	return t === null ? (e.observers_.size === 0 && q.inBatch > 0 && vo(e), !1) : (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && q.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved);
}
function So(e) {
	e.lowestObserverState_ !== wc.STALE_ && (e.lowestObserverState_ = wc.STALE_, e.observers_.forEach(function(e) {
		e.dependenciesState_ === wc.UP_TO_DATE_ && e.onBecomeStale_(), e.dependenciesState_ = wc.STALE_;
	}));
}
function Co(e) {
	e.lowestObserverState_ !== wc.STALE_ && (e.lowestObserverState_ = wc.STALE_, e.observers_.forEach(function(t) {
		t.dependenciesState_ === wc.POSSIBLY_STALE_ ? t.dependenciesState_ = wc.STALE_ : t.dependenciesState_ === wc.UP_TO_DATE_ && (e.lowestObserverState_ = wc.UP_TO_DATE_);
	}));
}
function wo(e) {
	e.lowestObserverState_ === wc.UP_TO_DATE_ && (e.lowestObserverState_ = wc.POSSIBLY_STALE_, e.observers_.forEach(function(e) {
		e.dependenciesState_ === wc.UP_TO_DATE_ && (e.dependenciesState_ = wc.POSSIBLY_STALE_, e.onBecomeStale_());
	}));
}
function To() {
	q.inBatch > 0 || q.isRunningReactions || Mc(Eo);
}
function Eo() {
	q.isRunningReactions = !0;
	for (var e = q.pendingReactions, t = 0; e.length > 0;) {
		++t === jc && (console.error("[mobx] cycle in reaction: " + e[0]), e.splice(0));
		for (var n = e.splice(0), r = 0, i = n.length; r < i; r++) n[r].runReaction_();
	}
	q.isRunningReactions = !1;
}
function Do(e) {
	var t = Mc;
	Mc = function(n) {
		return e(function() {
			return t(n);
		});
	};
}
function Oo() {
	return !1;
}
function ko(e) {
	return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
}
function Ao(e) {
	return function(t, n) {
		if (Oi(t)) return Xa(t.name || Rc, t, e);
		if (Oi(n)) return Xa(t, n, e);
		if (ca(n)) return (e ? Vc : zc).decorate_20223_(t, n);
		if (ki(n)) return oa(t, n, e ? Vc : zc);
		if (ki(t)) return aa(ya(e ? Ic : Pc, {
			name: t,
			autoAction: e
		}));
	};
}
function jo(e) {
	return Oi(e) && e.isMobxAction === !0;
}
function Mo(e, t) {
	var n;
	t === void 0 && (t = Vs);
	var r = t?.name ?? "Autorun", i = !t.scheduler && !t.delay, a;
	if (i) a = new Ac(r, function() {
		this.track(c);
	}, t.onError, t.requiresObservable);
	else {
		var o = No(t), s = !1;
		a = new Ac(r, function() {
			s || (s = !0, o(function() {
				s = !1, a.isDisposed || a.track(c);
			}));
		}, t.onError, t.requiresObservable);
	}
	function c() {
		e(a);
	}
	return (n = t) != null && (n = n.signal) != null && n.aborted || a.schedule_(), a.getDisposer_(t?.signal);
}
function No(e) {
	return e.scheduler ? e.scheduler : e.delay ? function(t) {
		return setTimeout(t, e.delay);
	} : Gc;
}
function Po(e, t, n) {
	var r;
	n === void 0 && (n = Vs);
	var i = n.name ?? "Reaction", a = Uc(i, n.onError ? Fo(n.onError, t) : t), o = !n.scheduler && !n.delay, s = No(n), c = !0, l = !1, u, d = n.compareStructural ? Zs.structural : n.equals || Zs.default, f = new Ac(i, function() {
		c || o ? p() : l || (l = !0, s(p));
	}, n.onError, n.requiresObservable);
	function p() {
		if (l = !1, !f.isDisposed) {
			var t = !1, r = u;
			f.track(function() {
				var n = eo(!1, function() {
					return e(f);
				});
				t = c || !d(u, n), u = n;
			}), (c && n.fireImmediately || !c && t) && a(u, r, f), c = !1;
		}
	}
	return (r = n) != null && (r = r.signal) != null && r.aborted || f.schedule_(), f.getDisposer_(n?.signal);
}
function Fo(e, t) {
	return function() {
		try {
			return t.apply(this, arguments);
		} catch (t) {
			e.call(this, t);
		}
	};
}
function Io(e, t, n) {
	return Ro(Kc, e, t, n);
}
function Lo(e, t, n) {
	return Ro(qc, e, t, n);
}
function Ro(e, t, n, r) {
	var i = typeof r == "function" ? Es(t, n) : Es(t), a = Oi(r) ? r : n, o = e + "L";
	return i[o] ? i[o].add(a) : i[o] = /* @__PURE__ */ new Set([a]), function() {
		var e = i[o];
		e && (e.delete(a), e.size === 0 && delete i[o]);
	};
}
function zo(e) {
	e.isolateGlobalState === !0 && ho();
	var t = e.useProxies, n = e.enforceActions;
	if (t !== void 0 && (q.useProxies = t === Yc || t !== Jc && typeof Proxy < "u"), t === "ifavailable" && (q.verifyProxies = !0), n !== void 0) {
		var r = n === Yc ? Yc : n === Xc;
		q.enforceActions = r, q.allowStateChanges = r !== !0 && r !== Yc;
	}
	[
		"computedRequiresReaction",
		"reactionRequiresObservable",
		"observableRequiresReaction",
		"disableErrorBoundaries",
		"safeDescriptors"
	].forEach(function(t) {
		t in e && (q[t] = !!e[t]);
	}), q.allowStateReads = !q.observableRequiresReaction, e.reactionScheduler && Do(e.reactionScheduler);
}
function Bo(e, t, n, r) {
	var i = qs(t);
	return ks(function() {
		var t = _s(e, r)[G];
		Ks(i).forEach(function(e) {
			t.extend_(e, i[e], n && e in n ? n[e] : !0);
		});
	}), e;
}
function Vo(e, t) {
	return Ho(Es(e, t));
}
function Ho(e) {
	var t = { name: e.name_ };
	return e.observing_ && e.observing_.length > 0 && (t.dependencies = Uo(e.observing_).map(Ho)), t;
}
function Uo(e) {
	return Array.from(new Set(e));
}
function Wo(e) {
	Oi(e.cancel) && e.cancel();
}
function Go(e) {
	return e?.isMobXFlow === !0;
}
function Ko(e, t) {
	if (!e) return !1;
	if (t !== void 0) {
		if (ys(e)) {
			var n, r, i = e[G];
			return i.values_.has(t) || !!((n = i.lazyComputedKeys_) != null && n.has(t)) || !!((r = i.lazyObservableKeys_) != null && r.has(t));
		}
		return !1;
	}
	return ys(e) || !!e[G] || Xs(e) || Nc(e) || Cc(e);
}
function qo(e) {
	return Ko(e);
}
function Jo(e) {
	if (ys(e)) return e[G].ownKeys_();
	W(38);
}
function Yo(e, t, n) {
	return e.set(t, n), n;
}
function Xo(e, t) {
	if (typeof e != "object" || !e || e instanceof Date || !qo(e)) return e;
	if (xc(e) || Cc(e)) return Xo(e.get(), t);
	if (t.has(e)) return t.get(e);
	if (ps(e)) {
		var n = Yo(t, e, Array(e.length));
		return e.forEach(function(e, r) {
			n[r] = Xo(e, t);
		}), n;
	}
	if (_l(e)) {
		var r = Yo(t, e, /* @__PURE__ */ new Set());
		return e.forEach(function(e) {
			r.add(Xo(e, t));
		}), r;
	}
	if (ml(e)) {
		var i = Yo(t, e, /* @__PURE__ */ new Map());
		return e.forEach(function(e, n) {
			i.set(n, Xo(e, t));
		}), i;
	}
	var a = Yo(t, e, {});
	return Jo(e).forEach(function(n) {
		zs.propertyIsEnumerable.call(e, n) && (a[n] = Xo(e[n], t));
	}), a;
}
function Zo(e, t) {
	return Xo(e, /* @__PURE__ */ new Map());
}
function Qo(e, t) {
	t === void 0 && (t = void 0), yo();
	try {
		return e.apply(t);
	} finally {
		bo();
	}
}
function $o(e) {
	return e[G];
}
function es(e, t) {
	var n;
	return Ei(), e = _s(e, t), (n = e[G]).proxy_ ?? (n.proxy_ = new Proxy(e, nl));
}
function ts(e) {
	return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function ns(e, t) {
	var n = e.interceptors_ ||= [];
	return n.push(t), Di(function() {
		var e = n.indexOf(t);
		e !== -1 && n.splice(e, 1);
	});
}
function rs(e, t) {
	var n = lo();
	try {
		for (var r = [].concat(e.interceptors_ || []), i = 0, a = r.length; i < a && (t = r[i](t), t && !t.type && W(14), t); i++);
		return t;
	} finally {
		uo(n);
	}
}
function is(e) {
	return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function as(e, t) {
	var n = e.changeListeners_ ||= [];
	return n.push(t), Di(function() {
		var e = n.indexOf(t);
		e !== -1 && n.splice(e, 1);
	});
}
function os(e, t) {
	var n = lo(), r = e.changeListeners_;
	if (r) {
		r = r.slice();
		for (var i = 0, a = r.length; i < a; i++) r[i](t);
		uo(n);
	}
}
function ss(e, t, n) {
	return ks(function() {
		var r = _s(e, n)[G];
		t ??= sa(e), Ks(t).forEach(function(e) {
			return r.make_(e, t[e]);
		});
	}), e;
}
function cs(e, t, n, r) {
	return n === void 0 && (n = "ObservableArray"), r === void 0 && (r = !1), Ei(), ks(function() {
		var i = new sl(n, t, r, !1);
		Pi(i.values_, G, i);
		var a = new Proxy(i.values_, ol);
		return i.proxy_ = a, e && e.length && i.spliceWithArray_(0, 0, e), a;
	});
}
function ls(e, t) {
	typeof Array.prototype[e] == "function" && (cl[e] = t(e));
}
function us(e) {
	return function() {
		var t = this[G];
		t.atom_.reportObserved();
		var n = t.dehanceValues_(t.values_);
		return n[e].apply(n, arguments);
	};
}
function ds(e) {
	return function(t, n) {
		var r = this, i = this[G];
		return i.atom_.reportObserved(), i.dehanceValues_(i.values_)[e](function(e, i) {
			return t.call(n, e, i, r);
		});
	};
}
function fs(e) {
	return function() {
		var t = this, n = this[G];
		n.atom_.reportObserved();
		var r = n.dehanceValues_(n.values_), i = arguments[0];
		return arguments[0] = function(e, n, r) {
			return i(e, n, r, t);
		}, r[e].apply(r, arguments);
	};
}
function ps(e) {
	return Ai(e) && ll(e[G]);
}
function ms(e) {
	return e[Symbol.toStringTag] = "MapIterator", Ns(e);
}
function hs(e) {
	if (Ii(e) || ml(e)) return e;
	if (Array.isArray(e)) return new Map(e);
	if (ji(e)) {
		var t = /* @__PURE__ */ new Map();
		for (var n in e) t.set(n, e[n]);
		return t;
	}
	return W(21, e);
}
function gs(e) {
	return e[Symbol.toStringTag] = "SetIterator", Ns(e);
}
function _s(e, t) {
	if (Vi(e, G)) return e;
	var n = t?.name ?? "ObservableObject";
	return Ni(e, G, new bl(e, /* @__PURE__ */ new Map(), String(n), qa(t))), e;
}
function vs(e) {
	return vl[e] || (vl[e] = {
		get: function() {
			return this[G].getObservablePropValue_(e);
		},
		set: function(t) {
			return this[G].setObservablePropValue_(e, t);
		}
	});
}
function ys(e) {
	return Ai(e) ? xl(e[G]) : !1;
}
function bs(e, t, n) {
	var r;
	(r = e.target_[Js]) == null || delete r[n];
}
function xs(e, t) {
	Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ === void 0 ? e.prototype = t : e.prototype.__proto__ = t;
}
function Ss(e) {
	return {
		enumerable: !1,
		configurable: !0,
		get: function() {
			return this[G].get_(e);
		},
		set: function(t) {
			this[G].set_(e, t);
		}
	};
}
function Cs(e) {
	Rs(El.prototype, "" + e, Ss(e));
}
function ws(e) {
	if (e > wl) {
		for (var t = wl; t < e + 100; t++) Cs(t);
		wl = e;
	}
}
function Ts(e, t, n) {
	return new El(e, t, n);
}
function Es(e, t) {
	if (typeof e == "object" && e) {
		if (ps(e)) return t !== void 0 && W(23), e[G].atom_;
		if (_l(e)) return e.atom_;
		if (ml(e)) {
			if (t === void 0) return e.keysAtom_;
			var n = e.data_.get(t) || e.hasMap_.get(t);
			return n || W(25, t, Os(e)), n;
		}
		if (ys(e)) {
			if (!t) return W(26);
			var r = e[G], i = r.values_.get(t) ?? r.materializeLazyComputed_(t) ?? r.materializeLazyObservable_(t);
			return i || W(27, t, Os(e)), i;
		}
		if (Xs(e) || Cc(e) || Nc(e)) return e;
	} else if (Oi(e) && Nc(e[G])) return e[G];
	W(28);
}
function Ds(e, t) {
	if (e || W(29), t !== void 0) return Ds(Es(e, t));
	if (Xs(e) || Cc(e) || Nc(e) || ml(e) || _l(e)) return e;
	if (e[G]) return e[G];
	W(24, e);
}
function Os(e, t) {
	var n;
	if (t !== void 0) n = Es(e, t);
	else if (jo(e)) return e.name;
	else n = ys(e) || ml(e) || _l(e) ? Ds(e) : Es(e);
	return n.name_;
}
function ks(e) {
	var t = lo(), n = to(!0);
	yo();
	try {
		return e();
	} finally {
		bo(), no(n), uo(t);
	}
}
function As(e, t, n) {
	return n === void 0 && (n = -1), js(e, t, n);
}
function js(e, t, n, r, i) {
	if (e === t) return e !== 0 || 1 / e == 1 / t;
	if (e == null || t == null) return !1;
	if (e !== e) return t !== t;
	var a = typeof e;
	if (a !== "function" && a !== "object" && typeof t != "object") return !1;
	var o = Dl.call(e);
	if (o !== Dl.call(t)) return !1;
	switch (o) {
		case "[object RegExp]":
		case "[object String]": return "" + e == "" + t;
		case "[object Number]": return +e == +e ? +e == 0 ? 1 / e == 1 / t : +e == +t : +t != +t;
		case "[object Date]":
		case "[object Boolean]": return +e == +t;
		case "[object Symbol]": return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
		case "[object Map]":
		case "[object Set]": n >= 0 && n++;
	}
	e = Ms(e), t = Ms(t);
	var s = o === "[object Array]";
	if (!s) {
		if (typeof e != "object" || typeof t != "object") return !1;
		var c = e.constructor, l = t.constructor;
		if (c !== l && !(Oi(c) && c instanceof c && Oi(l) && l instanceof l) && "constructor" in e && "constructor" in t) return !1;
	}
	if (n === 0) return !1;
	n < 0 && (n = -1), r ||= [], i ||= [];
	for (var u = r.length; u--;) if (r[u] === e) return i[u] === t;
	if (r.push(e), i.push(t), s) {
		if (u = e.length, u !== t.length) return !1;
		for (; u--;) if (!js(e[u], t[u], n - 1, r, i)) return !1;
	} else {
		var d = Object.keys(e), f = d.length;
		if (Object.keys(t).length !== f) return !1;
		for (var p = 0; p < f; p++) {
			var m = d[p];
			if (!(Vi(t, m) && js(e[m], t[m], n - 1, r, i))) return !1;
		}
	}
	return r.pop(), i.pop(), !0;
}
function Ms(e) {
	return ps(e) ? e.slice() : Ii(e) || ml(e) || Ri(e) || _l(e) ? Array.from(e.entries()) : e;
}
function Ns(e) {
	return e[Symbol.iterator] = Ps, Object.assign(Object.create(Ol), e);
}
function Ps() {
	return this;
}
var Fs, Is, Ls, Rs, zs, Bs, Vs, Hs, Us, Ws, Gs, Ks, qs, Js, G, Ys, Xs, Zs, Qs, $s, ec, tc, nc, rc, ic, ac, oc, sc, cc, lc, uc, K, dc, fc, pc, mc, hc, gc, _c, vc, yc, bc, xc, Sc, Cc, wc, Tc, Ec, Dc, Oc, kc, q, Ac, jc, Mc, Nc, Pc, Fc, Ic, Lc, Rc, zc, Bc, Vc, Hc, Uc, Wc, Gc, Kc, qc, Jc, Yc, Xc, Zc, Qc, $c, el, tl, nl, rl, il, al, ol, sl, cl, ll, ul, dl, fl, pl, ml, hl, gl, _l, vl, yl, bl, xl, Sl, Cl, wl, Tl, El, Dl, Ol, kl = o((() => {
	Fs = {}, Is = Object.assign, Ls = Object.getOwnPropertyDescriptor, Rs = Object.defineProperty, zs = Object.prototype, Bs = [], Object.freeze(Bs), Vs = {}, Object.freeze(Vs), Hs = typeof Proxy < "u", Us = /*#__PURE__*/ Object.toString(), Ws = function() {}, Gs = Object.getOwnPropertySymbols !== void 0, Ks = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Gs ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : /* istanbul ignore next */ Object.getOwnPropertyNames, qs = Object.getOwnPropertyDescriptors || function(e) {
		var t = {};
		return Ks(e).forEach(function(n) {
			t[n] = Ls(e, n);
		}), t;
	}, Js = /*#__PURE__*/ Symbol("mobx-stored-annotations"), G = /*#__PURE__*/ Symbol("mobx administration"), Ys = /*#__PURE__*/ function() {
		function e(e) {
			e === void 0 && (e = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = wc.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = e;
		}
		var t = e.prototype;
		return t.onBO = function() {
			this.onBOL && this.onBOL.forEach(function(e) {
				return e();
			});
		}, t.onBUO = function() {
			this.onBUOL && this.onBUOL.forEach(function(e) {
				return e();
			});
		}, t.reportObserved = function() {
			return xo(this);
		}, t.reportChanged = function() {
			yo(), So(this), bo();
		}, t.toString = function() {
			return this.name_;
		}, qi(e, [
			{
				key: "isBeingObserved",
				get: function() {
					return Hi(this.flags_, e.isBeingObservedMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isBeingObservedMask_, t);
				}
			},
			{
				key: "isPendingUnobservation",
				get: function() {
					return Hi(this.flags_, e.isPendingUnobservationMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isPendingUnobservationMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!Hi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), Ys.isBeingObservedMask_ = 1, Ys.isPendingUnobservationMask_ = 2, Ys.diffValueMask_ = 4, Xs = /*#__PURE__*/ Fi("Atom", Ys), Zs = {
		identity: ua,
		structural: da,
		default: pa,
		shallow: fa
	}, Qs = "override", $s = "true", ec = /*#__PURE__*/ Va(), tc = "observable", nc = "observable.ref", rc = "observable.shallow", ic = "observable.struct", ac = {
		deep: !0,
		name: void 0,
		defaultDecorator: void 0,
		proxy: !0
	}, Object.freeze(ac), oc = /*#__PURE__*/ Ia(tc), sc = /*#__PURE__*/ Ia(nc, { enhancer: ga }), cc = /*#__PURE__*/ Ia(rc, { enhancer: ha }), lc = /*#__PURE__*/ Ia(ic, { enhancer: _a }), uc = /*#__PURE__*/ aa(oc), Is(Ya, uc), K = /*#__PURE__*/ Is(Ya, {
		box: function(e, t) {
			var n = Ga(t);
			return new bc(e, Ka(n), n.name, !0, n.equals);
		},
		array: function(e, t) {
			var n = Ga(t);
			return (q.useProxies === !1 || n.proxy === !1 ? Ts : cs)(e, Ka(n), n.name);
		},
		map: function(e, t) {
			var n = Ga(t);
			return new pl(e, Ka(n), n.name);
		},
		set: function(e, t) {
			var n = Ga(t);
			return new gl(e, Ka(n), n.name);
		},
		object: function(e, t, n) {
			return ks(function() {
				return Bo(q.useProxies === !1 || n?.proxy === !1 ? _s({}, n) : es({}, n), e, t);
			});
		},
		ref: /*#__PURE__*/ aa(sc),
		shallow: /*#__PURE__*/ aa(cc),
		deep: uc,
		struct: /*#__PURE__*/ aa(lc)
	}), dc = "computed", fc = "computed.struct", pc = /*#__PURE__*/ ja(dc), mc = /*#__PURE__*/ ja(fc, { equals: Zs.structural }), hc = function(e, t) {
		if (ca(t)) return pc.decorate_20223_(e, t);
		if (ki(t)) return oa(e, t, pc);
		if (ji(e)) return aa(ja(dc, e));
		var n = ji(t) ? t : {};
		return n.get = e, n.name ||= e.name || "", new Sc(n);
	}, Object.assign(hc, pc), hc.struct = /*#__PURE__*/ aa(mc), gc = 0, _c = 1, vc = (/*#__PURE__*/ Ls(function() {}, "name"))?.configurable ?? !1, yc = {
		value: "action",
		configurable: !0,
		writable: !1,
		enumerable: !1
	}, bc = /*#__PURE__*/ function(e) {
		function t(t, n, r, i, a) {
			var o;
			return r === void 0 && (r = "ObservableValue"), i === void 0 && (i = !0), a === void 0 && (a = Zs.default), o = e.call(this, r) || this, o.enhancer = void 0, o.name_ = void 0, o.equals = void 0, o.hasUnreportedChange_ = !1, o.interceptors_ = void 0, o.changeListeners_ = void 0, o.value_ = void 0, o.dehancer = void 0, o.enhancer = n, o.name_ = r, o.equals = a, o.value_ = n(t, void 0, r), o;
		}
		Zi(t, e);
		var n = t.prototype;
		return n.dehanceValue = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, n.set = function(e) {
			this.value_, e = this.prepareNewValue_(e), e !== q.UNCHANGED && this.setNewValue_(e);
		}, n.prepareNewValue_ = function(e) {
			if (ts(this)) {
				var t = rs(this, {
					object: this,
					type: il,
					newValue: e
				});
				if (!t) return q.UNCHANGED;
				e = t.newValue;
			}
			return e = this.enhancer(e, this.value_, this.name_), this.equals(this.value_, e) ? q.UNCHANGED : e;
		}, n.setNewValue_ = function(e) {
			var t = this.value_;
			this.value_ = e, this.reportChanged(), is(this) && os(this, {
				type: il,
				object: this,
				newValue: e,
				oldValue: t
			});
		}, n.get = function() {
			return this.reportObserved(), this.dehanceValue(this.value_);
		}, n.intercept_ = function(e) {
			return ns(this, e);
		}, n.observe_ = function(e, t) {
			return t && e({
				observableKind: "value",
				debugObjectName: this.name_,
				object: this,
				type: il,
				newValue: this.value_,
				oldValue: void 0
			}), as(this, e);
		}, n.raw = function() {
			return this.value_;
		}, n.toJSON = function() {
			return this.get();
		}, n.toString = function() {
			return this.name_ + "[" + this.value_ + "]";
		}, n.valueOf = function() {
			return Bi(this.get());
		}, n[Symbol.toPrimitive] = function() {
			return this.valueOf();
		}, t;
	}(Ys), xc = /*#__PURE__*/ Fi("ObservableValue", bc), Sc = /*#__PURE__*/ function() {
		function e(e) {
			this.dependenciesState_ = wc.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = wc.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Ec(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Tc.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, e.get || W(31), this.derivation = e.get, this.name_ = e.name || "ComputedValue", e.set && (this.setter_ = Xa("ComputedValue-setter", e.set)), this.equals_ = e.equals || (e.compareStructural || e.struct ? Zs.structural : Zs.default), this.scope_ = e.context, this.requiresReaction_ = e.requiresReaction, this.keepAlive_ = !!e.keepAlive;
		}
		var t = e.prototype;
		return t.onBecomeStale_ = function() {
			wo(this);
		}, t.onBO = function() {
			this.onBOL && this.onBOL.forEach(function(e) {
				return e();
			});
		}, t.onBUO = function() {
			this.onBUOL && this.onBUOL.forEach(function(e) {
				return e();
			});
		}, t.get = function() {
			if (this.isComputing && W(32, this.name_, this.derivation), q.inBatch === 0 && this.observers_.size === 0 && !this.keepAlive_) io(this) && (this.warnAboutUntrackedRead_(), yo(), this.value_ = this.computeValue_(!1), bo());
			else if (xo(this), io(this)) {
				var e = q.trackingContext;
				this.keepAlive_ && !e && (q.trackingContext = this), this.trackAndCompute() && Co(this), q.trackingContext = e;
			}
			var t = this.value_;
			if (ro(t)) throw t.cause;
			return t;
		}, t.set = function(e) {
			if (this.setter_) {
				this.isRunningSetter && W(33, this.name_), this.isRunningSetter = !0;
				try {
					this.setter_.call(this.scope_, e);
				} finally {
					this.isRunningSetter = !1;
				}
			} else W(34, this.name_);
		}, t.trackAndCompute = function() {
			var e = this.value_, t = this.dependenciesState_ === wc.NOT_TRACKING_, n = this.computeValue_(!0), r = t || ro(e) || ro(n) || !this.equals_(e, n);
			return r && (this.value_ = n), r;
		}, t.computeValue_ = function(e) {
			this.isComputing = !0;
			var t = to(!1), n;
			if (e) n = ao(this, this.derivation, this.scope_);
			else if (q.disableErrorBoundaries === !0) n = this.derivation.call(this.scope_);
			else try {
				n = this.derivation.call(this.scope_);
			} catch (e) {
				n = new Ec(e);
			}
			return no(t), this.isComputing = !1, n;
		}, t.suspend_ = function() {
			this.keepAlive_ || (so(this), this.value_ = void 0);
		}, t.observe_ = function(e, t) {
			var n = this, r = !0, i = void 0;
			return Mo(function() {
				var a = n.get();
				if (!r || t) {
					var o = lo();
					e({
						observableKind: "computed",
						debugObjectName: n.name_,
						type: il,
						object: n,
						newValue: a,
						oldValue: i
					}), uo(o);
				}
				r = !1, i = a;
			});
		}, t.warnAboutUntrackedRead_ = function() {}, t.toString = function() {
			return this.name_ + "[" + this.derivation.toString() + "]";
		}, t.valueOf = function() {
			return Bi(this.get());
		}, t[Symbol.toPrimitive] = function() {
			return this.valueOf();
		}, qi(e, [
			{
				key: "isComputing",
				get: function() {
					return Hi(this.flags_, e.isComputingMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isComputingMask_, t);
				}
			},
			{
				key: "isRunningSetter",
				get: function() {
					return Hi(this.flags_, e.isRunningSetterMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isRunningSetterMask_, t);
				}
			},
			{
				key: "isBeingObserved",
				get: function() {
					return Hi(this.flags_, e.isBeingObservedMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isBeingObservedMask_, t);
				}
			},
			{
				key: "isPendingUnobservation",
				get: function() {
					return Hi(this.flags_, e.isPendingUnobservationMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isPendingUnobservationMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!Hi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), Sc.isComputingMask_ = 1, Sc.isRunningSetterMask_ = 2, Sc.isBeingObservedMask_ = 4, Sc.isPendingUnobservationMask_ = 8, Sc.diffValueMask_ = 16, Cc = /*#__PURE__*/ Fi("ComputedValue", Sc), (function(e) {
		e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
	})(wc ||= {}), (function(e) {
		e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
	})(Tc ||= {}), Ec = function(e) {
		this.cause = void 0, this.cause = e;
	}, Dc = function() {
		this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
	}, Oc = !0, kc = !1, q = /*#__PURE__*/ function() {
		var e = /*#__PURE__*/ Ti();
		return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (Oc = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Dc().version && (Oc = !1), Oc ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /*#__PURE__*/ new Dc()) : (setTimeout(function() {
			kc || W(35);
		}, 1), new Dc());
	}(), Ac = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			e === void 0 && (e = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = wc.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = Tc.NONE, this.name_ = e, this.onInvalidate_ = t, this.errorHandler_ = n, this.requiresObservable_ = r;
		}
		var t = e.prototype;
		return t.onBecomeStale_ = function() {
			this.schedule_();
		}, t.schedule_ = function() {
			this.isScheduled || (this.isScheduled = !0, q.pendingReactions.push(this), To());
		}, t.runReaction_ = function() {
			if (!this.isDisposed) {
				yo(), this.isScheduled = !1;
				var e = q.trackingContext;
				if (q.trackingContext = this, io(this)) {
					this.isTrackPending = !0;
					try {
						this.onInvalidate_();
					} catch (e) {
						this.reportExceptionInDerivation_(e);
					}
				}
				q.trackingContext = e, bo();
			}
		}, t.track = function(e) {
			if (!this.isDisposed) {
				yo(), this.isRunning = !0;
				var t = q.trackingContext;
				q.trackingContext = this;
				var n = ao(this, e, void 0);
				q.trackingContext = t, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && so(this), ro(n) && this.reportExceptionInDerivation_(n.cause), bo();
			}
		}, t.reportExceptionInDerivation_ = function(e) {
			var t = this;
			if (this.errorHandler_) {
				this.errorHandler_(e, this);
				return;
			}
			if (q.disableErrorBoundaries) throw e;
			var n = "[mobx] uncaught error in '" + this + "'";
			q.suppressReactionErrors || console.error(n, e), q.globalReactionErrorHandlers.forEach(function(n) {
				return n(e, t);
			});
		}, t.dispose = function() {
			this.isDisposed || (this.isDisposed = !0, this.isRunning || (yo(), so(this), bo()));
		}, t.getDisposer_ = function(e) {
			var t = this, n = function n() {
				t.dispose(), e == null || e.removeEventListener == null || e.removeEventListener("abort", n);
			};
			return e == null || e.addEventListener == null || e.addEventListener("abort", n), n[G] = this, "dispose" in Symbol && typeof Symbol.dispose == "symbol" && (n[Symbol.dispose] = n), n;
		}, t.toString = function() {
			return "Reaction[" + this.name_ + "]";
		}, t.trace = function(e) {
			e === void 0 && (e = !1);
		}, qi(e, [
			{
				key: "isDisposed",
				get: function() {
					return Hi(this.flags_, e.isDisposedMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isDisposedMask_, t);
				}
			},
			{
				key: "isScheduled",
				get: function() {
					return Hi(this.flags_, e.isScheduledMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isScheduledMask_, t);
				}
			},
			{
				key: "isTrackPending",
				get: function() {
					return Hi(this.flags_, e.isTrackPendingMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isTrackPendingMask_, t);
				}
			},
			{
				key: "isRunning",
				get: function() {
					return Hi(this.flags_, e.isRunningMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.isRunningMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!Hi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = Ui(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), Ac.isDisposedMask_ = 1, Ac.isScheduledMask_ = 2, Ac.isTrackPendingMask_ = 4, Ac.isRunningMask_ = 8, Ac.diffValueMask_ = 16, jc = 100, Mc = function(e) {
		return e();
	}, Nc = /*#__PURE__*/ Fi("Reaction", Ac), Pc = "action", Fc = "action.bound", Ic = "autoAction", Lc = "autoAction.bound", Rc = "<unnamed action>", zc = /*#__PURE__*/ ya(Pc), Bc = /*#__PURE__*/ ya(Fc, { bound: !0 }), Vc = /*#__PURE__*/ ya(Ic, { autoAction: !0 }), Hc = /*#__PURE__*/ ya(Lc, {
		autoAction: !0,
		bound: !0
	}), Uc = /*#__PURE__*/ Ao(!1), Object.assign(Uc, zc), Wc = /*#__PURE__*/ Ao(!0), Object.assign(Wc, Vc), Uc.bound = /*#__PURE__*/ aa(Bc), Wc.bound = /*#__PURE__*/ aa(Hc), Gc = function(e) {
		return e();
	}, Kc = "onBO", qc = "onBUO", Jc = "never", Yc = "always", Xc = "observed", Zc = 0, Qc = /*#__PURE__*/ function(e) {
		function t() {
			var n = e.call(this, "FLOW_CANCELLED") || this;
			return Object.setPrototypeOf(n, (this instanceof t ? this.constructor : void 0).prototype), n.name = "FlowCancellationError", n;
		}
		Zi(t, e);
		var n = t.prototype;
		return n.toString = function() {
			return "Error: " + this.message;
		}, t;
	}(/*#__PURE__*/ ia(Error)), $c = /*#__PURE__*/ Ta("flow"), el = /*#__PURE__*/ Ta("flow.bound", { bound: !0 }), tl = /*#__PURE__*/ Object.assign(function(e, t) {
		if (ca(t)) return $c.decorate_20223_(e, t);
		if (ki(t)) return oa(e, t, $c);
		var n = e, r = n.name || "<unnamed flow>", i = function() {
			var e = this, t = arguments, i = ++Zc, a = Uc(r + " - runid: " + i + " - init", n).apply(e, t), o, s = void 0, c = new Promise(function(e, t) {
				var n = 0;
				o = t;
				function c(e) {
					s = void 0;
					var o;
					try {
						o = Uc(r + " - runid: " + i + " - yield " + n++, a.next).call(a, e);
					} catch (e) {
						return t(e);
					}
					u(o);
				}
				function l(e) {
					s = void 0;
					var o;
					try {
						o = Uc(r + " - runid: " + i + " - yield " + n++, a.throw).call(a, e);
					} catch (e) {
						return t(e);
					}
					u(o);
				}
				function u(n) {
					if (Oi(n?.then)) {
						n.then(u, t);
						return;
					}
					return n.done ? e(n.value) : (s = Promise.resolve(n.value), s.then(c, l));
				}
				c(void 0);
			});
			return c.cancel = Uc(r + " - runid: " + i + " - cancel", function() {
				try {
					s && Wo(s);
					var e = a.return(void 0), t = Promise.resolve(e.value);
					t.then(Ws, Ws), Wo(t), o(new Qc());
				} catch (e) {
					o(e);
				}
			}), c;
		};
		return i.isMobXFlow = !0, i;
	}, $c), tl.bound = /*#__PURE__*/ aa(el), nl = {
		has: function(e, t) {
			return $o(e).has_(t);
		},
		get: function(e, t) {
			return $o(e).get_(t);
		},
		set: function(e, t, n) {
			return ki(t) ? $o(e).set_(t, n, !0) ?? !0 : !1;
		},
		deleteProperty: function(e, t) {
			return ki(t) ? $o(e).delete_(t, !0) ?? !0 : !1;
		},
		defineProperty: function(e, t, n) {
			return $o(e).defineProperty_(t, n) ?? !0;
		},
		ownKeys: function(e) {
			return $o(e).ownKeys_();
		},
		preventExtensions: function(e) {
			W(13);
		}
	}, rl = "splice", il = "update", al = 1e4, ol = {
		get: function(e, t) {
			var n = e[G];
			return t === G ? n : t === "length" ? n.getArrayLength_() : typeof t == "string" && !isNaN(t) ? n.get_(parseInt(t)) : Vi(cl, t) ? cl[t] : e[t];
		},
		set: function(e, t, n) {
			var r = e[G];
			return t === "length" && r.setArrayLength_(n), typeof t == "symbol" || isNaN(t) ? e[t] = n : r.set_(parseInt(t), n), !0;
		},
		preventExtensions: function() {
			W(15);
		}
	}, sl = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			e === void 0 && (e = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = n, this.legacyMode_ = r, this.atom_ = new Ys(e), this.enhancer_ = function(e, n) {
				return t(e, n, "ObservableArray[..]");
			};
		}
		var t = e.prototype;
		return t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.dehanceValues_ = function(e) {
			return this.dehancer !== void 0 && e.length > 0 ? e.map(this.dehancer) : e;
		}, t.intercept_ = function(e) {
			return ns(this, e);
		}, t.observe_ = function(e, t) {
			return t === void 0 && (t = !1), t && e({
				observableKind: "array",
				object: this.proxy_,
				debugObjectName: this.atom_.name_,
				type: "splice",
				index: 0,
				added: this.values_.slice(),
				addedCount: this.values_.length,
				removed: [],
				removedCount: 0
			}), as(this, e);
		}, t.getArrayLength_ = function() {
			return this.atom_.reportObserved(), this.values_.length;
		}, t.setArrayLength_ = function(e) {
			(typeof e != "number" || isNaN(e) || e < 0) && W("Out of range: " + e);
			var t = this.values_.length;
			if (e !== t) {
				if (e > t) {
					for (var n = Array(e - t), r = 0; r < e - t; r++) n[r] = void 0;
					this.spliceWithArray_(t, 0, n);
				} else this.spliceWithArray_(e, t - e);
			}
		}, t.updateArrayLength_ = function(e, t) {
			e !== this.lastKnownLength_ && W(16), this.lastKnownLength_ += t, this.legacyMode_ && t > 0 && ws(e + t + 1);
		}, t.spliceWithArray_ = function(e, t, n) {
			var r = this;
			this.atom_;
			var i = this.values_.length;
			if (e === void 0 ? e = 0 : e > i ? e = i : e < 0 && (e = Math.max(0, i + e)), t = arguments.length === 1 ? i - e : t == null ? 0 : Math.max(0, Math.min(t, i - e)), n === void 0 && (n = Bs), ts(this)) {
				var a = rs(this, {
					object: this.proxy_,
					type: rl,
					index: e,
					removedCount: t,
					added: n
				});
				if (!a) return Bs;
				t = a.removedCount, n = a.added;
			}
			if (n = n.length === 0 ? n : n.map(function(e) {
				return r.enhancer_(e, void 0);
			}), this.legacyMode_) {
				var o = n.length - t;
				this.updateArrayLength_(i, o);
			}
			var s = this.spliceItemsIntoValues_(e, t, n);
			return (t !== 0 || n.length !== 0) && this.notifyArraySplice_(e, n, s), this.dehanceValues_(s);
		}, t.spliceItemsIntoValues_ = function(e, t, n) {
			if (n.length < al) {
				var r;
				return (r = this.values_).splice.apply(r, [e, t].concat(n));
			}
			var i = this.values_.slice(e, e + t), a = this.values_.slice(e + t);
			this.values_.length += n.length - t;
			for (var o = 0; o < n.length; o++) this.values_[e + o] = n[o];
			for (var s = 0; s < a.length; s++) this.values_[e + n.length + s] = a[s];
			return i;
		}, t.notifyArrayChildUpdate_ = function(e, t, n) {
			var r = !this.owned_ && Oo(), i = is(this), a = i || r ? {
				observableKind: "array",
				object: this.proxy_,
				type: il,
				debugObjectName: this.atom_.name_,
				index: e,
				newValue: t,
				oldValue: n
			} : null;
			this.atom_.reportChanged(), i && os(this, a);
		}, t.notifyArraySplice_ = function(e, t, n) {
			var r = !this.owned_ && Oo(), i = is(this), a = i || r ? {
				observableKind: "array",
				object: this.proxy_,
				debugObjectName: this.atom_.name_,
				type: rl,
				index: e,
				removed: n,
				added: t,
				removedCount: n.length,
				addedCount: t.length
			} : null;
			this.atom_.reportChanged(), i && os(this, a);
		}, t.get_ = function(e) {
			if (this.legacyMode_ && e >= this.values_.length) {
				console.warn("[mobx] Out of bounds read: " + e);
				return;
			}
			return this.atom_.reportObserved(), this.dehanceValue_(this.values_[e]);
		}, t.set_ = function(e, t) {
			var n = this.values_;
			if (this.legacyMode_ && e > n.length && W(17, e, n.length), e < n.length) {
				this.atom_;
				var r = n[e];
				if (ts(this)) {
					var i = rs(this, {
						type: il,
						object: this.proxy_,
						index: e,
						newValue: t
					});
					if (!i) return;
					t = i.newValue;
				}
				t = this.enhancer_(t, r), t !== r && (n[e] = t, this.notifyArrayChildUpdate_(e, t, r));
			} else {
				for (var a = Array(e + 1 - n.length), o = 0; o < a.length - 1; o++) a[o] = void 0;
				a[a.length - 1] = t, this.spliceWithArray_(n.length, 0, a);
			}
		}, e;
	}(), cl = {
		clear: function() {
			return this.splice(0);
		},
		replace: function(e) {
			var t = this[G];
			return t.spliceWithArray_(0, t.values_.length, e);
		},
		toJSON: function() {
			return this.slice();
		},
		splice: function(e, t) {
			var n = [...arguments].slice(2), r = this[G];
			switch (arguments.length) {
				case 0: return [];
				case 1: return r.spliceWithArray_(e);
				case 2: return r.spliceWithArray_(e, t);
			}
			return r.spliceWithArray_(e, t, n);
		},
		spliceWithArray: function(e, t, n) {
			return this[G].spliceWithArray_(e, t, n);
		},
		push: function() {
			var e = this[G], t = [...arguments];
			return e.spliceWithArray_(e.values_.length, 0, t), e.values_.length;
		},
		pop: function() {
			return this.splice(Math.max(this[G].values_.length - 1, 0), 1)[0];
		},
		shift: function() {
			return this.splice(0, 1)[0];
		},
		unshift: function() {
			var e = this[G], t = [...arguments];
			return e.spliceWithArray_(0, 0, t), e.values_.length;
		},
		reverse: function() {
			return q.trackingDerivation && W(37, "reverse"), this.replace(this.slice().reverse()), this;
		},
		sort: function() {
			q.trackingDerivation && W(37, "sort");
			var e = this.slice();
			return e.sort.apply(e, arguments), this.replace(e), this;
		},
		remove: function(e) {
			var t = this[G], n = t.dehanceValues_(t.values_).indexOf(e);
			return n > -1 && (this.splice(n, 1), !0);
		}
	}, ls("at", us), ls("concat", us), ls("flat", us), ls("includes", us), ls("indexOf", us), ls("join", us), ls("lastIndexOf", us), ls("slice", us), ls("toString", us), ls("toLocaleString", us), ls("toSorted", us), ls("toSpliced", us), ls("with", us), ls("every", ds), ls("filter", ds), ls("find", ds), ls("findIndex", ds), ls("findLast", ds), ls("findLastIndex", ds), ls("flatMap", ds), ls("forEach", ds), ls("map", ds), ls("some", ds), ls("toReversed", ds), ls("reduce", fs), ls("reduceRight", fs), ll = /*#__PURE__*/ Fi("ObservableArrayAdministration", sl), ul = {}, dl = "add", fl = "delete", pl = /*#__PURE__*/ function() {
		function e(e, t, n) {
			var r = this;
			t === void 0 && (t = ma), n === void 0 && (n = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[G] = ul, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = t, this.name_ = n, Oi(Map) || W(18), ks(function() {
				r.keysAtom_ = la("ObservableMap.keys()"), r.data_ = /* @__PURE__ */ new Map(), r.hasMap_ = /* @__PURE__ */ new Map(), e && r.merge(e);
			});
		}
		var t = e.prototype;
		return t.has_ = function(e) {
			return this.data_.has(e);
		}, t.has = function(e) {
			var t = this;
			if (!q.trackingDerivation) return this.has_(e);
			var n = this.hasMap_.get(e);
			if (!n) {
				var r = n = new bc(this.has_(e), ga, "ObservableMap.key?", !1);
				this.hasMap_.set(e, r), Lo(r, function() {
					return t.hasMap_.delete(e);
				});
			}
			return n.get();
		}, t.set = function(e, t) {
			var n = this.has_(e);
			if (ts(this)) {
				var r = rs(this, {
					type: n ? il : dl,
					object: this,
					newValue: t,
					name: e
				});
				if (!r) return this;
				t = r.newValue;
			}
			return n ? this.updateValue_(e, t) : this.addValue_(e, t), this;
		}, t.delete = function(e) {
			var t = this;
			if (this.keysAtom_, ts(this) && !rs(this, {
				type: fl,
				object: this,
				name: e
			})) return !1;
			if (this.has_(e)) {
				var n = Oo(), r = is(this), i = r || n ? {
					observableKind: "map",
					debugObjectName: this.name_,
					type: fl,
					object: this,
					oldValue: this.data_.get(e).value_,
					name: e
				} : null;
				return Qo(function() {
					var n;
					t.keysAtom_.reportChanged(), (n = t.hasMap_.get(e)) == null || n.setNewValue_(!1), t.data_.get(e).setNewValue_(void 0), t.data_.delete(e);
				}), r && os(this, i), !0;
			}
			return !1;
		}, t.updateValue_ = function(e, t) {
			var n = this.data_.get(e);
			if (t = n.prepareNewValue_(t), t !== q.UNCHANGED) {
				var r = Oo(), i = is(this), a = i || r ? {
					observableKind: "map",
					debugObjectName: this.name_,
					type: il,
					object: this,
					oldValue: n.value_,
					name: e,
					newValue: t
				} : null;
				n.setNewValue_(t), i && os(this, a);
			}
		}, t.addValue_ = function(e, t) {
			var n = this;
			this.keysAtom_, Qo(function() {
				var r, i = new bc(t, n.enhancer_, "ObservableMap.key", !1);
				n.data_.set(e, i), t = i.value_, (r = n.hasMap_.get(e)) == null || r.setNewValue_(!0), n.keysAtom_.reportChanged();
			});
			var r = Oo(), i = is(this), a = i || r ? {
				observableKind: "map",
				debugObjectName: this.name_,
				type: dl,
				object: this,
				name: e,
				newValue: t
			} : null;
			i && os(this, a);
		}, t.get = function(e) {
			return this.has(e) ? this.dehanceValue_(this.data_.get(e).get()) : this.dehanceValue_(void 0);
		}, t.getOrInsert = function(e, t) {
			return this.has(e) || this.set(e, t), this.get(e);
		}, t.getOrInsertComputed = function(e, t) {
			return this.has(e) || this.set(e, t(e)), this.get(e);
		}, t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.keys = function() {
			return this.keysAtom_.reportObserved(), this.data_.keys();
		}, t.values = function() {
			var e = this, t = this.keys();
			return ms({ next: function() {
				var n = t.next(), r = n.done, i = n.value;
				return {
					done: r,
					value: r ? void 0 : e.get(i)
				};
			} });
		}, t.entries = function() {
			var e = this, t = this.keys();
			return ms({ next: function() {
				var n = t.next(), r = n.done, i = n.value;
				return {
					done: r,
					value: r ? void 0 : [i, e.get(i)]
				};
			} });
		}, t[Symbol.iterator] = function() {
			return this.entries();
		}, t.forEach = function(e, t) {
			for (var n = Ji(this), r; !(r = n()).done;) {
				var i = r.value, a = i[0], o = i[1];
				e.call(t, o, a, this);
			}
		}, t.merge = function(e) {
			var t = this;
			return ml(e) && (e = new Map(e)), Qo(function() {
				ji(e) ? zi(e).forEach(function(n) {
					return t.set(n, e[n]);
				}) : Array.isArray(e) ? e.forEach(function(e) {
					var n = e[0], r = e[1];
					return t.set(n, r);
				}) : Ii(e) ? (Li(e) || W(19, e), e.forEach(function(e, n) {
					return t.set(n, e);
				})) : e != null && W(20, e);
			}), this;
		}, t.clear = function() {
			var e = this;
			Qo(function() {
				co(function() {
					for (var t = Ji(e.keys()), n; !(n = t()).done;) {
						var r = n.value;
						e.delete(r);
					}
				});
			});
		}, t.replace = function(e) {
			var t = this;
			return Qo(function() {
				for (var n = hs(e), r = /* @__PURE__ */ new Map(), i = !1, a = Ji(t.data_.keys()), o; !(o = a()).done;) {
					var s = o.value;
					if (!n.has(s)) {
						if (t.delete(s)) i = !0;
						else {
							var c = t.data_.get(s);
							r.set(s, c);
						}
					}
				}
				for (var l = Ji(n.entries()), u; !(u = l()).done;) {
					var d = u.value, f = d[0], p = d[1], m = t.data_.has(f);
					if (t.set(f, p), t.data_.has(f)) {
						var h = t.data_.get(f);
						r.set(f, h), m || (i = !0);
					}
				}
				if (!i) {
					if (t.data_.size !== r.size) t.keysAtom_.reportChanged();
					else for (var g = t.data_.keys(), _ = r.keys(), v = g.next(), y = _.next(); !v.done;) {
						if (v.value !== y.value) {
							t.keysAtom_.reportChanged();
							break;
						}
						v = g.next(), y = _.next();
					}
				}
				t.data_ = r;
			}), this;
		}, t.toString = function() {
			return "[object ObservableMap]";
		}, t.toJSON = function() {
			return Array.from(this);
		}, t.observe_ = function(e, t) {
			return as(this, e);
		}, t.intercept_ = function(e) {
			return ns(this, e);
		}, qi(e, [{
			key: "size",
			get: function() {
				return this.keysAtom_.reportObserved(), this.data_.size;
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Map";
			}
		}]);
	}(), ml = /*#__PURE__*/ Fi("ObservableMap", pl), hl = {}, gl = /*#__PURE__*/ function() {
		function e(e, t, n) {
			var r = this;
			t === void 0 && (t = ma), n === void 0 && (n = "ObservableSet"), this.name_ = void 0, this[G] = hl, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = n, Oi(Set) || W(22), this.enhancer_ = function(e, r) {
				return t(e, r, n);
			}, ks(function() {
				r.atom_ = la(r.name_), e && r.replace(e);
			});
		}
		var t = e.prototype;
		return t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.clear = function() {
			var e = this;
			Qo(function() {
				co(function() {
					for (var t = Ji(e.data_.values()), n; !(n = t()).done;) {
						var r = n.value;
						e.delete(r);
					}
				});
			});
		}, t.forEach = function(e, t) {
			for (var n = Ji(this), r; !(r = n()).done;) {
				var i = r.value;
				e.call(t, i, i, this);
			}
		}, t.add = function(e) {
			var t = this;
			if (this.atom_, ts(this)) {
				var n = rs(this, {
					type: dl,
					object: this,
					newValue: e
				});
				if (!n) return this;
				e = n.newValue;
			}
			if (!this.has(e)) {
				Qo(function() {
					t.data_.add(t.enhancer_(e, void 0)), t.atom_.reportChanged();
				});
				var r = is(this), i = r ? {
					observableKind: "set",
					debugObjectName: this.name_,
					type: dl,
					object: this,
					newValue: e
				} : null;
				r && os(this, i);
			}
			return this;
		}, t.delete = function(e) {
			var t = this;
			if (ts(this) && !rs(this, {
				type: fl,
				object: this,
				oldValue: e
			})) return !1;
			if (this.has(e)) {
				var n = is(this), r = n ? {
					observableKind: "set",
					debugObjectName: this.name_,
					type: fl,
					object: this,
					oldValue: e
				} : null;
				return Qo(function() {
					t.atom_.reportChanged(), t.data_.delete(e);
				}), n && os(this, r), !0;
			}
			return !1;
		}, t.has = function(e) {
			return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(e));
		}, t.entries = function() {
			var e = this.values();
			return gs({ next: function() {
				var t = e.next(), n = t.value, r = t.done;
				return r ? {
					value: void 0,
					done: r
				} : {
					value: [n, n],
					done: r
				};
			} });
		}, t.keys = function() {
			return this.values();
		}, t.values = function() {
			this.atom_.reportObserved();
			var e = this, t = this.data_.values();
			return gs({ next: function() {
				var n = t.next(), r = n.value, i = n.done;
				return i ? {
					value: void 0,
					done: i
				} : {
					value: e.dehanceValue_(r),
					done: i
				};
			} });
		}, t.intersection = function(e) {
			return Ri(e) && !_l(e) ? e.intersection(this) : new Set(this).intersection(e);
		}, t.union = function(e) {
			return Ri(e) && !_l(e) ? e.union(this) : new Set(this).union(e);
		}, t.difference = function(e) {
			return new Set(this).difference(e);
		}, t.symmetricDifference = function(e) {
			return Ri(e) && !_l(e) ? e.symmetricDifference(this) : new Set(this).symmetricDifference(e);
		}, t.isSubsetOf = function(e) {
			return new Set(this).isSubsetOf(e);
		}, t.isSupersetOf = function(e) {
			return new Set(this).isSupersetOf(e);
		}, t.isDisjointFrom = function(e) {
			return Ri(e) && !_l(e) ? e.isDisjointFrom(this) : new Set(this).isDisjointFrom(e);
		}, t.replace = function(e) {
			var t = this;
			return _l(e) && (e = new Set(e)), Qo(function() {
				Array.isArray(e) || Ri(e) ? (t.clear(), e.forEach(function(e) {
					return t.add(e);
				})) : e != null && W("Cannot initialize set from " + e);
			}), this;
		}, t.observe_ = function(e, t) {
			return as(this, e);
		}, t.intercept_ = function(e) {
			return ns(this, e);
		}, t.toJSON = function() {
			return Array.from(this);
		}, t.toString = function() {
			return "[object ObservableSet]";
		}, t[Symbol.iterator] = function() {
			return this.values();
		}, qi(e, [{
			key: "size",
			get: function() {
				return this.atom_.reportObserved(), this.data_.size;
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Set";
			}
		}]);
	}(), _l = /*#__PURE__*/ Fi("ObservableSet", gl), vl = /*#__PURE__*/ Object.create(null), yl = "remove", bl = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			t === void 0 && (t = /* @__PURE__ */ new Map()), r === void 0 && (r = ec), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.lazyComputedKeys_ = void 0, this.lazyObservableKeys_ = void 0, this.target_ = e, this.values_ = t, this.name_ = n, this.defaultAnnotation_ = r, this.keysAtom_ = new Ys("ObservableObject.keys"), this.isPlainObject_ = ji(this.target_);
		}
		var t = e.prototype;
		return t.getObservablePropValue_ = function(e) {
			return (this.values_.get(e) ?? this.materializeLazyComputed_(e) ?? this.materializeLazyObservable_(e)).get();
		}, t.materializeLazyComputed_ = function(e) {
			var t = this.lazyComputedKeys_?.get(e);
			if (t) {
				this.lazyComputedKeys_.delete(e), this.lazyComputedKeys_.size === 0 && (this.lazyComputedKeys_ = void 0);
				var n = t();
				return this.values_.set(e, n), n;
			}
		}, t.materializeLazyObservable_ = function(e) {
			var t = this.lazyObservableKeys_?.get(e);
			if (t) {
				this.lazyObservableKeys_.delete(e), this.lazyObservableKeys_.size === 0 && (this.lazyObservableKeys_ = void 0);
				var n = t();
				return this.values_.set(e, n), n;
			}
		}, t.setObservablePropValue_ = function(e, t) {
			var n = this.values_.get(e) ?? this.materializeLazyComputed_(e) ?? this.materializeLazyObservable_(e);
			if (n instanceof Sc) return n.set(t), !0;
			if (ts(this)) {
				var r = rs(this, {
					type: il,
					object: this.proxy_ || this.target_,
					name: e,
					newValue: t
				});
				if (!r) return null;
				t = r.newValue;
			}
			if (t = n.prepareNewValue_(t), t !== q.UNCHANGED) {
				var i = is(this), a = i ? {
					type: il,
					observableKind: "object",
					debugObjectName: this.name_,
					object: this.proxy_ || this.target_,
					oldValue: n.value_,
					name: e,
					newValue: t
				} : null;
				n.setNewValue_(t), i && os(this, a);
			}
			return !0;
		}, t.get_ = function(e) {
			return q.trackingDerivation && !Vi(this.target_, e) && this.has_(e), this.target_[e];
		}, t.set_ = function(e, t, n) {
			return n === void 0 && (n = !1), Vi(this.target_, e) ? this.values_.has(e) ? this.setObservablePropValue_(e, t) : n ? Reflect.set(this.target_, e, t) : (this.target_[e] = t, !0) : this.extend_(e, {
				value: t,
				enumerable: !0,
				writable: !0,
				configurable: !0
			}, this.defaultAnnotation_, n);
		}, t.has_ = function(e) {
			if (!q.trackingDerivation) return e in this.target_;
			this.pendingKeys_ ||= /* @__PURE__ */ new Map();
			var t = this.pendingKeys_.get(e);
			return t || (t = new bc(e in this.target_, ga, "ObservableObject.key?", !1), this.pendingKeys_.set(e, t)), t.get();
		}, t.make_ = function(e, t) {
			if (t === !0 && (t = this.defaultAnnotation_), t !== !1) {
				if (!(e in this.target_)) {
					var n;
					if ((n = this.target_[Js]) != null && n[e]) return;
					W(1, t.annotationType_, this.name_ + "." + e.toString());
				}
				for (var r = this.target_; r && r !== zs;) {
					var i = Ls(r, e);
					if (i) {
						var a = t.make_(this, e, i, r);
						if (a === 0) return;
						if (a === 1) break;
					}
					r = Object.getPrototypeOf(r);
				}
				bs(this, t, e);
			}
		}, t.extend_ = function(e, t, n, r) {
			if (r === void 0 && (r = !1), n === !0 && (n = this.defaultAnnotation_), n === !1) return this.defineProperty_(e, t, r);
			var i = n.extend_(this, e, t, r);
			return i && bs(this, n, e), i;
		}, t.defineProperty_ = function(e, t, n) {
			n === void 0 && (n = !1), this.keysAtom_;
			try {
				yo();
				var r = this.delete_(e);
				if (!r) return r;
				if (ts(this)) {
					var i = rs(this, {
						object: this.proxy_ || this.target_,
						name: e,
						type: dl,
						newValue: t.value
					});
					if (!i) return null;
					var a = i.newValue;
					t.value !== a && (t = Yi({}, t, { value: a }));
				}
				if (n) {
					if (!Reflect.defineProperty(this.target_, e, t)) return !1;
				} else Rs(this.target_, e, t);
				this.notifyPropertyAddition_(e, t.value);
			} finally {
				bo();
			}
			return !0;
		}, t.defineObservableProperty_ = function(e, t, n, r) {
			r === void 0 && (r = !1), this.keysAtom_;
			try {
				yo();
				var i = this.delete_(e);
				if (!i) return i;
				if (ts(this)) {
					var a = rs(this, {
						object: this.proxy_ || this.target_,
						name: e,
						type: dl,
						newValue: t
					});
					if (!a) return null;
					t = a.newValue;
				}
				var o = vs(e), s = {
					configurable: !q.safeDescriptors || this.isPlainObject_,
					enumerable: !0,
					get: o.get,
					set: o.set
				};
				if (r) {
					if (!Reflect.defineProperty(this.target_, e, s)) return !1;
				} else Rs(this.target_, e, s);
				var c = new bc(t, n, "ObservableObject.key", !1);
				this.values_.set(e, c), this.notifyPropertyAddition_(e, c.value_);
			} finally {
				bo();
			}
			return !0;
		}, t.defineComputedProperty_ = function(e, t, n) {
			n === void 0 && (n = !1), this.keysAtom_;
			try {
				yo();
				var r = this.delete_(e);
				if (!r) return r;
				if (ts(this) && !rs(this, {
					object: this.proxy_ || this.target_,
					name: e,
					type: dl,
					newValue: void 0
				})) return null;
				t.name ||= "ObservableObject.key", t.context = this.proxy_ || this.target_;
				var i = vs(e), a = {
					configurable: !q.safeDescriptors || this.isPlainObject_,
					enumerable: !1,
					get: i.get,
					set: i.set
				};
				if (n) {
					if (!Reflect.defineProperty(this.target_, e, a)) return !1;
				} else Rs(this.target_, e, a);
				this.values_.set(e, new Sc(t)), this.notifyPropertyAddition_(e, void 0);
			} finally {
				bo();
			}
			return !0;
		}, t.delete_ = function(e, t) {
			if (t === void 0 && (t = !1), this.keysAtom_, !Vi(this.target_, e)) return !0;
			if (ts(this) && !rs(this, {
				object: this.proxy_ || this.target_,
				name: e,
				type: yl
			})) return null;
			try {
				var n;
				yo();
				var r = is(this), i = this.values_.get(e), a = void 0;
				if (!i && r && (a = Ls(this.target_, e)?.value), t) {
					if (!Reflect.deleteProperty(this.target_, e)) return !1;
				} else delete this.target_[e];
				if (i && (this.values_.delete(e), i instanceof bc && (a = i.value_), So(i)), this.keysAtom_.reportChanged(), (n = this.pendingKeys_) == null || (n = n.get(e)) == null || n.set(e in this.target_), r) {
					var o = {
						type: yl,
						observableKind: "object",
						object: this.proxy_ || this.target_,
						debugObjectName: this.name_,
						oldValue: a,
						name: e
					};
					r && os(this, o);
				}
			} finally {
				bo();
			}
			return !0;
		}, t.observe_ = function(e, t) {
			return as(this, e);
		}, t.intercept_ = function(e) {
			return ns(this, e);
		}, t.notifyPropertyAddition_ = function(e, t) {
			var n, r = is(this);
			if (r) {
				var i = r ? {
					type: dl,
					observableKind: "object",
					debugObjectName: this.name_,
					object: this.proxy_ || this.target_,
					name: e,
					newValue: t
				} : null;
				r && os(this, i);
			}
			(n = this.pendingKeys_) == null || (n = n.get(e)) == null || n.set(!0), this.keysAtom_.reportChanged();
		}, t.ownKeys_ = function() {
			return this.keysAtom_.reportObserved(), Ks(this.target_);
		}, t.keys_ = function() {
			return this.keysAtom_.reportObserved(), Object.keys(this.target_);
		}, e;
	}(), xl = /*#__PURE__*/ Fi("ObservableObjectAdministration", bl), Sl = /*#__PURE__*/ Ss(0), Cl = /*#__PURE__*/ function() {
		var e = !1, t = {};
		return Object.defineProperty(t, "0", { set: function() {
			e = !0;
		} }), (/*#__PURE__*/ Object.create(t))[0] = 1, e === !1;
	}(), wl = 0, Tl = function() {}, xs(Tl, Array.prototype), El = /*#__PURE__*/ function(e) {
		function t(t, n, r, i) {
			var a;
			return r === void 0 && (r = "ObservableArray"), i === void 0 && (i = !1), a = e.call(this) || this, ks(function() {
				var e = new sl(r, n, i, !0);
				e.proxy_ = a, Pi(a, G, e), t && t.length && a.spliceWithArray(0, 0, t), Cl && Object.defineProperty(a, "0", Sl);
			}), a;
		}
		Zi(t, e);
		var n = t.prototype;
		return n.concat = function() {
			this[G].atom_.reportObserved();
			var e = [...arguments];
			return Array.prototype.concat.apply(this.slice(), e.map(function(e) {
				return ps(e) ? e.slice() : e;
			}));
		}, n[Symbol.iterator] = function() {
			var e = this, t = 0;
			return Ns({ next: function() {
				return t < e.length ? {
					value: e[t++],
					done: !1
				} : {
					done: !0,
					value: void 0
				};
			} });
		}, qi(t, [{
			key: "length",
			get: function() {
				return this[G].getArrayLength_();
			},
			set: function(e) {
				this[G].setArrayLength_(e);
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Array";
			}
		}]);
	}(Tl), Object.entries(cl).forEach(function(e) {
		var t = e[0], n = e[1];
		t !== "concat" && Ni(El.prototype, t, n);
	}), ws(1e3), Dl = zs.toString, Ol = (/* @__PURE__ */ Ti()).Iterator?.prototype || {}, [
		"Symbol",
		"Map",
		"Set"
	].forEach(function(e) {
		Ti()[e] === void 0 && W("MobX requires global '" + e + "' to be available or polyfilled");
	}), typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
		spy: ko,
		extras: { getDebugName: Os },
		$mobx: G
	});
}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/filters/formatNumber.js
function Al(e, t) {
	let n = {
		symbol: "",
		decimalPlaces: 3,
		padDecimalPlaces: !0,
		thousandsSeparator: "",
		decimalSeparator: ".",
		symbolAfter: !1,
		...t
	};
	if (typeof e != "number" || Number.isNaN(e)) return;
	let r = jl(e, n.decimalPlaces).split(".");
	r[0] = r[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + n.thousandsSeparator), n.decimalPlaces > 0 && n.padDecimalPlaces && (r[1] = (r[1] || "").padEnd(n.decimalPlaces, "0"));
	let i = r.join(n.decimalSeparator);
	return n.symbolAfter ? i += n.symbol : i = n.symbol + i, i;
}
function jl(e, t) {
	let n = e.toString(), r = n.indexOf("."), i = r == -1 ? n.length : 1 + r + (t || -1);
	return n.substr(0, i);
}
var Ml = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/filters/currency.js
function Nl(e, t) {
	return Al(e, {
		symbol: "$",
		thousandsSeparator: ",",
		decimalPlaces: 2,
		...t
	});
}
var Pl = o((() => {
	Ml();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/filters/handleize.js
function Fl(e) {
	if (typeof e != "string") return e;
	let t = e.toLowerCase();
	return t = t.replace(/[^\w\s]/g, "").trim(), t = t.replace(/\s/g, "-"), t;
}
var Il = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/filters/truncate.js
function Ll(e, t, n) {
	if (typeof e != "string" || e.length <= t) return e;
	let r = e.lastIndexOf(" ", t), i = r == -1 ? t - 1 : r;
	return e.substr(0, i) + (n || "");
}
var Rl = o((() => {})), zl = o((() => {
	Pl(), Il(), Rl();
})), Bl, Vl, Hl = o((() => {
	Bl = [], Vl = class {
		constructor(e, t, n) {
			this.targets = [], this.styleBlockRefs = {}, this.targetedElems = [], this.unhideTarget = (e) => {
				if (this.styleBlockRefs[e]) try {
					this.document.head.removeChild(this.styleBlockRefs[e]), delete this.styleBlockRefs[e];
				} catch {}
			}, this.hideTarget = (e) => {
				if (this.styleBlockRefs[e]) return;
				let t = `${e} { visibility: hidden !important }`, n = this.document.createElement("style");
				n.setAttribute("type", "text/css"), n.appendChild(this.document.createTextNode(t)), this.document.head.appendChild(n), this.styleBlockRefs[e] = n;
			}, this.document = n || window.document;
			try {
				this.abortController = new (this.document.defaultView || window).AbortController();
			} catch {}
			this.targets = e, this.onTarget = t, this.retarget(), this.targets.forEach((e) => {
				let t = 100, n = () => {
					this.abortController?.signal.aborted || (t < 2e3 ? (t += 200, this.retarget(), setTimeout(n, t)) : e.hideTarget && this.unhideTarget(e.selector));
				};
				if (e.clickRetarget) {
					let r = [];
					typeof e.clickRetarget == "boolean" ? r.push(this.document) : r = Array.from(this.document.querySelectorAll(e.clickRetarget)), r.map((e) => {
						e.addEventListener("click", () => {
							t = 100, setTimeout(n);
						}, {
							capture: !0,
							signal: this.abortController?.signal
						});
					});
				}
				if (e.navigationRetarget) try {
					this.document.defaultView?.navigation?.addEventListener("navigate", () => {
						t = 100, n();
					}, { signal: this.abortController?.signal });
				} catch {}
				e.autoRetarget ? n() : /complete|interactive|loaded/.test(this.document.readyState) ? e.hideTarget && this.unhideTarget(e.selector) : this.document.addEventListener("DOMContentLoaded", () => {
					this.retarget(), e.hideTarget && this.unhideTarget(e.selector);
				}, { signal: this.abortController?.signal });
			});
		}
		getTargets() {
			return this.targets;
		}
		getTargetedElems() {
			return this.targetedElems = this.targetedElems.filter((e) => e.isConnected !== !1), [...this.targetedElems];
		}
		releaseTargets(e) {
			(e || this.targetedElems).forEach((e) => {
				let t = Bl.indexOf(e);
				t !== -1 && Bl.splice(t, 1);
			}), this.targetedElems = e ? this.targetedElems.filter((t) => !e.includes(t)) : [];
		}
		destroy() {
			this.abortController?.abort(), this.releaseTargets(), Object.keys(this.styleBlockRefs).forEach((e) => this.unhideTarget(e));
		}
		retarget() {
			Bl = Bl.filter((e) => e.isConnected !== !1), this.targetedElems = this.targetedElems.filter((e) => e.isConnected !== !1);
			let e = this.targets.flatMap((e) => {
				e.hideTarget && this.hideTarget(e.selector);
				let t = this.domQuery(e.selector).filter((t) => {
					if (!Bl.find((e) => e == t) && !this.targetedElems.find((e) => e == t)) return !0;
					e.hideTarget && this.unhideTarget(e.selector);
				});
				return e.inject?.element || (Bl = Bl.concat(t)), t.map((t) => ({
					target: e,
					elem: t
				}));
			});
			for (let { target: t, elem: n } of e) try {
				if (this.targetedElems = this.targetedElems.concat(n), t.inject) {
					let e = this.inject(n, t), r = this.onTarget(t, e, n, this);
					r && typeof r.then == "function" && r.catch((e) => {
						console.error("DomTargeter onTarget async failure:", e);
					});
				} else {
					if (t.emptyTarget = t.emptyTarget ?? !0, t.emptyTarget) for (; n.firstChild && n.removeChild(n.firstChild););
					let e = this.onTarget(t, n, void 0, this);
					e && typeof e.then == "function" && e.catch((e) => {
						console.error("DomTargeter onTarget async failure:", e);
					});
				}
				t.hideTarget && this.unhideTarget(t.selector), t.unsetTargetMinHeight = t.unsetTargetMinHeight ?? !0, t.unsetTargetMinHeight && n.style.minHeight && (n.style.minHeight = "");
			} catch (e) {
				console.error("DomTargeter retarget failure:", e);
			}
		}
		domQuery(e) {
			return Array.from(this.document.querySelectorAll(e));
		}
		inject(e, t) {
			if (!t || !t.inject) throw Error("DomTargeter::inject: Injected element unspecified");
			let n = t.inject.element instanceof Function ? t.inject.element(t, e) : t.inject.element;
			if (!n) throw Error("DomTargeter::inject: Injected element unspecified");
			if (!e.parentNode) throw Error("DomTargeter::inject: Provided element has no parent element");
			switch (t?.inject?.action) {
				case "before":
					e.parentNode.insertBefore(n, e);
					break;
				case "after":
					e.nextSibling ? e.parentNode.insertBefore(n, e.nextSibling) : e.parentNode.appendChild(n);
					break;
				case "append":
					e.appendChild(n);
					break;
				case "prepend":
					e.firstChild ? e.insertBefore(n, e.firstChild) : e.appendChild(n);
					break;
				case "replace": e.parentNode.replaceChild(n, e);
			}
			return n;
		}
	};
})), Ul, Wl = o((() => {
	Ul = (e, t = 200) => {
		let n;
		return (...r) => {
			clearTimeout(n), n = window.setTimeout(() => {
				e.apply(void 0, r);
			}, t);
		};
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/featureFlags/featureFlags.js
function Gl(e = "") {
	e = (e || (typeof window > "u" ? {} : window?.navigator).userAgent || "").toLowerCase();
	let t = (function() {
		let t;
		return function() {
			if (t === void 0) {
				let n = (e.match(/(msie|trident\/7.0; rv:) ?([0-9]{1,2})\./) || [])[2];
				t = n ? Number(n) : !1;
			}
			return t;
		};
	})();
	return {
		cors: function() {
			return !t() || Number(t()) >= 10;
		},
		cookies: function() {
			return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
		},
		storage: function() {
			let e = "ss-test";
			try {
				return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
			} catch {
				return !1;
			}
		}
	};
}
var Kl, ql, Jl = o((() => {
	Kl = Gl(), ql = {
		cors: Kl.cors(),
		cookies: Kl.cookies(),
		storage: Kl.storage()
	};
})), Yl, Xl = o((() => {
	Jl(), Yl = {
		set: (e, t, n, r, i) => {
			if (Gl().cookies()) {
				n ||= "Lax";
				let a = e + "=" + encodeURIComponent(t) + ";SameSite=" + n + ";path=/;";
				if (window.location.protocol == "https:" && (a += "Secure;"), r) {
					let e = /* @__PURE__ */ new Date();
					e.setTime(e.getTime() + r), a += "expires=" + e.toUTCString() + ";";
				}
				i && (a += "domain=" + i + ";"), window.document.cookie = a;
			}
		},
		get: (e) => {
			if (Gl().cookies()) {
				e += "=";
				let t = window.document.cookie.split(";");
				for (let n = 0; n < t.length; n++) {
					let r = t[n];
					for (; r.charAt(0) == " ";) r = r.substring(1);
					if (r.indexOf(e) == 0) return decodeURIComponent(r.substring(e.length, r.length));
				}
			}
			return "";
		},
		unset: (e, t) => {
			if (!Gl().cookies()) return;
			let n = e + "=; path=/; Max-Age=-99999999;";
			t && (n += "domain=" + t + ";"), window.document.cookie = n;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/escapeHTML/escapeHTML.js
function Zl(e) {
	if (typeof e != "string") throw Error("parameter must be a string");
	if (window?.document) {
		let t = window.document.createElement("textarea");
		return t.textContent = e, t.innerHTML;
	}
	return e.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/'/g, "&#039;").replace(/"/g, "&quot;");
}
var Ql = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/unescapeHTML/unescapeHTML.js
function $l(e) {
	return e.replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&#0?39;/g, "'").replace(/&apos;/g, "'").replace(/&#0?34;/g, "\"").replace(/&quot;/g, "\"").replace(/&amp;/g, "&");
}
var eu = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/getContext/getContext.js
function tu(e = [], t) {
	let n;
	if (!t || typeof t == "string" ? n = Array.from(document.querySelectorAll(t || "script[id^=searchspring], script[id=athos-context], script[src*=\"snapui.searchspring.io\"], script[src*=\"snapui.athoscommerce.io\"]")).sort((e, t) => e.innerHTML.length - t.innerHTML.length).pop() : t && t.tagName === "SCRIPT" && (n = t), !n) throw Error("getContext: did not find a script tag");
	let r = n;
	if (!t && !r.getAttribute("type")?.match(/^searchspring/i) && !r.id?.match(/^searchspring/i) && !r.id?.match(/athos-context/) && !r.src?.match(/\/\/snapui.searchspring.io/i) && !r.src?.match(/\/\/snapui.athoscommerce.io/i)) throw Error("getContext: did not find a script from Snap CDN or with attribute (type, id) starting with \"athos-context\"");
	if (e && !Array.isArray(e) || e && !e.reduce((e, t) => e && typeof t == "string", !0)) throw Error("getContext: first parameter must be an array of strings");
	let i = "siteId", a = {};
	Object.values(n?.attributes).map((t) => {
		let r = t.nodeName;
		e.includes(r) && (a[r] = n?.getAttribute(r));
	});
	let o = {}, s = n?.innerHTML, c = s.replace(/`(?:\\[\s\S]|[^`\\])*`|'(?:\\[\s\S]|[^'\\])*'|"(?:\\[\s\S]|[^"\\])*"/g, "").match(/([a-zA-Z_$][a-zA-Z_$0-9]*)\s*=/g)?.map((e) => e.replace(/[\s=]/g, "")), l = e.concat(c || []), u = l.filter((e, t) => {
		let n = ru.has(e);
		return n && console.error(`getContext: JavaScript keyword found: '${e}'! Please use a different variable name.`), l.indexOf(e) === t && !n;
	});
	e?.forEach((e) => {
		try {
			let t = Function(`
				var ${u.join(", ")};
				${s}
				return ${e};
			`);
			o[e] = t();
		} catch (t) {
			ru.has(e) || (console.error(`getContext: error evaluating '${e}'`), console.error(t)), o[e] = void 0;
		}
	});
	let d = {
		...nu(a),
		...nu(o)
	};
	if (e.includes(i) && !d[i]) {
		let e = n.getAttribute("src")?.match(/.*snapui.(?:searchspring|athoscommerce).io\/([a-zA-Z0-9]{6})\//);
		e && e.length > 1 && (d.siteId = e[1]);
	}
	return d;
}
function nu(e) {
	return Object.keys(e).forEach((t) => {
		e[t] === void 0 && delete e[t];
	}), e;
}
var ru, iu = o((() => {
	ru = /* @__PURE__ */ new Set(/* @__PURE__ */ "break.case.catch.class.const.continue.debugger.default.delete.do.else.export.extends.finally.for.function.if.import.in.instanceof.new.return.super.switch.this.throw.try.typeof.var.void.while.with.yield.let.static.enum.await.implements.package.protected.interface.private.public".split("."));
})), au = o((() => {})), ou, su = o((() => {
	ou = (e) => {
		if (!e) return;
		let [t, n] = e.split("#"), [r, i] = t.split("?"), a = {
			query: {},
			hash: n
		};
		return i?.split("&").forEach((e) => {
			let [t, n] = e.split("=");
			a.query[t] = n;
		}), {
			base: r,
			params: a,
			url: () => {
				let e = Object.keys(a.query).map((e) => `${e}=${a.query[e]}`).join("&");
				return `${r}${e ? "?" + e : ""}${a.hash ? "#" + a.hash : ""}`;
			}
		};
	};
})), cu, lu, uu, du, fu, pu, mu, hu, gu, _u, vu, yu, bu, xu = o((() => {
	cu = "@athoscommerce/snap-toolbox", lu = "1.11.0", uu = "Snap Toolbox", du = "dist/cjs/index.js", fu = "dist/esm/index.js", pu = "dist/esm/index.d.ts", mu = "AthosCommerce", hu = {
		type: "git",
		url: "https://github.com/AthosCommerce/snap.git"
	}, gu = { access: "public" }, _u = {
		build: "rm -rf ./dist && tsc",
		"build:prod": "rm -rf ./dist && (tsc & p1=$!; tsc -p tsconfig.cjs.json & p2=$!; wait $p1 && wait $p2)",
		"build:docs": "typedoc --out docs src/index.ts",
		dev: "tsc --watch",
		format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
		lint: "eslint 'src/**/*.{js,jsx,ts,tsx}'",
		test: "jest",
		"test:watch": "jest --watch"
	}, vu = ["dist/**/*"], yu = "827b9566f3a8282b3a78fd85b0b2a281fe963df4", bu = {
		name: cu,
		version: lu,
		description: uu,
		main: du,
		module: fu,
		types: pu,
		author: mu,
		license: "MIT",
		repository: hu,
		publishConfig: gu,
		scripts: _u,
		sideEffects: !1,
		files: vu,
		gitHead: yu
	};
})), Su, Cu = o((() => {
	xu(), {version: Su} = bu;
})), wu = o((() => {})), Tu, Eu, Du, Ou = o((() => {
	Iu(), Tu = { cookies: Yl }, Eu = class {
		constructor(e) {
			if (this.type = null, this.expiration = 31536e6, this.sameSite = "Lax", this.key = "ss-storage", this.cookieDomain = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, this.state = {}, e) switch (e.key.trim() !== "" && (this.key = e.key.trim()), e?.cookie?.expiration && (this.expiration = e.cookie.expiration), e?.cookie?.sameSite && (this.sameSite = e.cookie.sameSite), e.type) {
				case Du.session:
					this.type = ql.storage ? e.type : null, this.type && (this.state = JSON.parse(window.sessionStorage.getItem(this.key) || "{}"), window.sessionStorage.setItem(this.key, JSON.stringify(this.state)));
					break;
				case Du.local:
					this.type = ql.storage ? e.type : null, this.type && (this.state = JSON.parse(window.localStorage.getItem(this.key) || "{}"), window.localStorage.setItem(this.key, JSON.stringify(this.state)));
					break;
				case Du.cookie:
					if (ql.cookies) {
						this.type = e.type;
						let t = Tu.cookies.get(this.key);
						t && (this.state = JSON.parse(t));
					}
					break;
				default: this.type = Du.memory;
			}
		}
		set(e, t) {
			switch (this.type) {
				case Du.session:
					this.state = JSON.parse(window.sessionStorage.getItem(this.key) || "{}");
					break;
				case Du.local:
					this.state = JSON.parse(window.localStorage.getItem(this.key) || "{}");
					break;
				case Du.cookie: {
					let e = Tu.cookies.get(this.key);
					e && (this.state = JSON.parse(e));
					break;
				}
			}
			let n;
			n = typeof e == "string" ? e?.split(".") : e;
			let r = this.state;
			n?.forEach((e, i) => {
				i == n.length - 1 ? r[e] = t : r = r[e] = r[e] || {};
			});
			try {
				switch (this.type) {
					case Du.session:
						window.sessionStorage.setItem(this.key, JSON.stringify(this.state));
						break;
					case Du.local:
						window.localStorage.setItem(this.key, JSON.stringify(this.state));
						break;
					case Du.cookie: Tu.cookies.set(this.key, JSON.stringify(this.state), this.sameSite, this.expiration, this.cookieDomain);
				}
			} catch {
				console.warn(`something went wrong setting ${this.key} to ${this.type} storage`);
			}
		}
		get(e) {
			switch (this.type) {
				case Du.session:
					let e = window.sessionStorage.getItem(this.key);
					this.state = e ? JSON.parse(e) : {};
					break;
				case Du.local:
					let t = window.localStorage.getItem(this.key);
					this.state = t ? JSON.parse(t) : {};
					break;
				case Du.cookie:
					let n = Tu.cookies.get(this.key);
					n && (this.state = JSON.parse(n) || {});
			}
			let t;
			if (t = typeof e == "string" ? e?.split(".") : e, !t?.length) return;
			let n = this.state;
			for (let e of t) if (n && n[e] !== void 0) n = n[e];
			else {
				n = {};
				return;
			}
			return n;
		}
		clear() {
			switch (this.type) {
				case Du.session:
					window.sessionStorage.removeItem(this.key);
					break;
				case Du.local:
					window.localStorage.removeItem(this.key);
					break;
				case Du.cookie: Tu.cookies.unset(this.key, this.cookieDomain);
			}
			this.state = {};
		}
	}, (function(e) {
		e.session = "session", e.local = "local", e.cookie = "cookie", e.memory = "memory";
	})(Du ||= {});
})), ku, Au = o((() => {
	(function(e) {
		e.production = "production", e.development = "development";
	})(ku ||= {});
})), ju, Mu = o((() => {
	ju = (e) => e.replace(/_/g, "-").toLowerCase();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/sprintf/sprintf.js
function Nu(e, t) {
	let n = [];
	for (; t > 0; n[--t] = e);
	return n.join("");
}
function Pu(e, ...t) {
	let n = [e, ...t], r = 0, i, a = n[r++], o, s, c, l, u = [];
	for (; a;) {
		if (o = /^[^\x25]+/.exec(a)) u.push(o[0]);
		else if (o = /^\x25{2}/.exec(a)) u.push("%");
		else if (o = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(a)) {
			if ((i = n[parseInt(o[1]) || r++]) == null || i == null) throw "Too few arguments.";
			if (/[^s]/.test(o[7]) && typeof i != "number") throw "Expecting number but found " + typeof i;
			switch (o[7]) {
				case "b":
					i = i.toString(2);
					break;
				case "c":
					i = String.fromCharCode(i);
					break;
				case "d":
					i = parseInt(i);
					break;
				case "e":
					i = o[6] ? i.toExponential(parseInt(o[6])) : i.toExponential();
					break;
				case "f":
					i = o[6] ? parseFloat(i).toFixed(parseInt(o[6])) : parseFloat(i);
					break;
				case "o":
					i = i.toString(8);
					break;
				case "s":
					i = (i = String(i)) && o[6] ? i.substring(0, parseInt(o[6])) : i;
					break;
				case "u":
					i = Math.abs(i);
					break;
				case "x":
					i = i.toString(16);
					break;
				case "X": i = i.toString(16).toUpperCase();
			}
			i = /[def]/.test(o[7]) && o[2] && i > 0 ? "+" + i : i, c = o[3] ? o[3] == "0" ? "0" : o[3].charAt(1) : " ", l = (o[5] ? parseInt(o[5]) : 0) - String(i).length, s = o[5] ? Nu(c, l) : "", u.push(o[4] ? i + s : s + i);
		} else throw Error("sprintf: Invalid format string encountered");
		a = a.substring(o[0].length);
	}
	return u.join("");
}
var Fu = o((() => {})), Iu = o((() => {
	zl(), Hl(), Wl(), Jl(), Xl(), Ql(), eu(), iu(), au(), su(), Cu(), wu(), Ou(), Au(), Mu(), Fu();
})), Lu, Ru = o((() => {
	Lu = (e) => {
		let t = 1, n = 0, r;
		for (; e >= 0;) r = t, t += n, n = r, e--;
		return n;
	};
})), zu, Bu, Vu, Hu, Uu = o((() => {
	zu = /* @__PURE__ */ u(U()), Bu = "athos-networkcache", Vu = {
		enabled: !0,
		type: "sessionStorage",
		ttl: 3e5,
		maxSize: 1e3,
		purgeable: !0
	}, Hu = class {
		constructor(e) {
			this.memoryCache = {}, this.config = (0, zu.default)(Vu, e || {}), this.load(), this.config?.entries && Object.keys(this.config.entries).map((e) => {
				this.config.entries && this.config.entries[e] && this.set(e, this.config.entries[e]);
			});
		}
		load() {
			if (typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage") {
				let e = window.sessionStorage.getItem(Bu), t = { ...e && JSON.parse(e) };
				this.memoryCache = t || {};
			}
			this.purgeExpired();
		}
		get(e) {
			if (this.config.enabled) {
				this.load();
				try {
					let t = [];
					if (typeof window < "u" && window.performance?.getEntriesByType("navigation")?.[0]?.type === "back_forward" && (t = ["lastViewed", "cart"]), Object.keys(this.memoryCache).length && e) {
						let n = e;
						if (t.length && e.startsWith("/v1/search")) try {
							let r = e.split("{")[0], i = "{" + e.split("{")[1], a = JSON.parse(i), o = Object.keys(this.memoryCache).find((e) => {
								try {
									if (e.split("{")[0] == r) {
										let n = "{" + e.split("{")[1], r = JSON.parse(n), i = Array.from(/* @__PURE__ */ new Set([...Object.keys(a), ...Object.keys(r)]));
										for (let e of i) if (!t.includes(e) && JSON.stringify(a[e]) !== JSON.stringify(r[e])) return !1;
										return !0;
									}
									return !1;
								} catch {
									return !1;
								}
							});
							o && (n = o);
						} catch {}
						if (this.memoryCache[n]) return this.memoryCache[n].value;
					}
				} catch (e) {
					console.warn("something went wrong getting from cache: ", e);
				}
			}
		}
		purgeExpired() {
			Object.keys(this.memoryCache).forEach((e) => {
				Date.now() >= this.memoryCache[e].expires && delete this.memoryCache[e];
			});
			try {
				if (typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage") {
					let e = JSON.stringify(this.memoryCache);
					window.sessionStorage.setItem(Bu, e);
				}
			} catch (e) {
				console.warn("failed to store network cache: ", e);
			}
		}
		set(e, t) {
			if (this.config.enabled) {
				this.load();
				try {
					let n = {
						value: t,
						expires: Date.now() + this.config.ttl,
						purgeable: this.config.purgeable
					}, r = new Blob([JSON.stringify({ [e]: n })], { endings: "native" }).size / 1024;
					if (r > this.config.maxSize) {
						console.warn(`Cache object size (${r.toFixed(2)}KB) exceeds maxSize (${this.config.maxSize}KB), skipping cache`);
						return;
					}
					let i = new Blob([JSON.stringify(this.memoryCache)], { endings: "native" }).size / 1024;
					for (; i + r > this.config.maxSize;) {
						let e = Object.keys(this.memoryCache).filter((e) => this.memoryCache[e].purgeable).sort((e, t) => this.memoryCache[e].expires - this.memoryCache[t].expires)[0];
						if (!e) break;
						delete this.memoryCache[e], i = new Blob([JSON.stringify(this.memoryCache)], { endings: "native" }).size / 1024;
					}
					if (i + r > this.config.maxSize) {
						console.warn(`Unable to cache entry for key "${e}" without exceeding maxSize (${this.config.maxSize}KB), skipping cache`);
						return;
					}
					this.memoryCache[e] = n, typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage" && window.sessionStorage.setItem(Bu, JSON.stringify(this.memoryCache));
				} catch (e) {
					console.warn("something went wrong setting to cache: ", e);
				}
			}
		}
		clear() {
			try {
				this.memoryCache = {}, typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage" && window.sessionStorage.setItem(Bu, "");
			} catch (e) {
				console.warn("something went wrong clearing cache: ", e);
			}
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/apis/Abstract.js
function Wu(e, t = "") {
	return Object.keys(e).map((n) => {
		let r = t + (t.length ? `[${n}]` : n), i = e[n];
		if (i instanceof Array) {
			let e = i.map((e) => encodeURIComponent(String(e))).join(`&${encodeURIComponent(r)}=`);
			return `${encodeURIComponent(r)}=${e}`;
		}
		return i instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(i.toISOString())}` : i instanceof Object ? Wu(i, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(i))}`;
	}).filter((e) => e.length > 0).join("&");
}
var Gu, Ku, qu, Ju, Yu = o((() => {
	Gu = /* @__PURE__ */ u(U()), Iu(), Ru(), Uu(), Ku = (e) => typeof Blob < "u" && e instanceof Blob, qu = class {
		constructor(e) {
			this.configuration = e, this.retryDelay = 1e3, this.retryCount = 0, this.cache = new Hu(this.configuration.cache);
		}
		get mode() {
			return this.configuration.mode;
		}
		async request(e, t) {
			let { url: n, init: r } = this.createFetchParams(e);
			if (t) {
				let n = this.cache.get(`${e.path}/${t}`) || this.cache.get(`${e.path}/*`);
				if (n) return this.retryCount = 0, this.retryDelay = 1e3, n;
			}
			let i, a;
			try {
				if (i = await this.fetchApi(n, r), a = await i?.json(), i.status >= 200 && i.status < 300) return this.retryCount = 0, this.retryDelay = 1e3, t && this.cache.set(`${e.path}/${t}`, a), a;
				throw i.status == 429 ? this.retryCount < this.configuration.maxRetry ? (await new Promise((e) => setTimeout(e, this.retryDelay)), this.retryDelay = Lu(this.retryCount) * 1e3, this.retryCount++, Error("Rate limited.")) : Error("Retry rate limit exceeded.") : i.status == 404 && a?.message == "Profile is currently paused" ? Error(`${a.message}: ${e.query?.tag}`) : Error("Unexpected Response Status.");
			} catch (a) {
				if (a.message == "Rate limited.") return await this.request(e, t);
				throw {
					err: a,
					fetchDetails: {
						status: i?.status,
						message: i?.statusText || "FAILED",
						url: n,
						...r
					}
				};
			}
		}
		createFetchParams(e) {
			let t = e?.body?.siteId || e?.query?.siteId;
			if (!t) throw Error("Request failed. Missing \"siteId\" parameter.");
			let n = `https://${t}.a${e.subDomain ? `.${e.subDomain}` : ""}.athoscommerce.net`, r = `${(e.origin || this.configuration.origin || n).replace(/\/$/, "")}/${e.path.replace(/^\//, "")}`, i = (0, Gu.default)(e.query || {}, this.configuration.globals);
			Object.keys(i).length !== 0 && (r += "?" + this.configuration.queryParamsStringify(i));
			let a = typeof FormData < "u" && e.body instanceof FormData || e.body instanceof URLSearchParams || Ku(e.body) ? e.body : JSON.stringify(e.body ? (0, Gu.default)(e.body, this.configuration.globals) : e.body), o = {
				...this.configuration.headers,
				...e.headers
			}, s = {
				method: e.method,
				headers: o,
				body: a
			};
			return {
				url: r,
				init: s
			};
		}
		async fetchApi(e, t) {
			return await this.configuration.fetchApi(e, t);
		}
	}, Ju = class {
		constructor(e = {}) {
			this.config = e, e.maxRetry || (this.config.maxRetry = 8), this.config.cache = this.config.cache || {}, this.config.mode = this.config.mode || ku.production, this.config.mode == ku.development && (this.config.cache.enabled = !1);
		}
		get cache() {
			return this.config?.cache || {};
		}
		get maxRetry() {
			return this.config.maxRetry || 8;
		}
		get origin() {
			return this.config.origin || "";
		}
		get initiator() {
			return this.config.initiator || `snap/client/${Su}`;
		}
		get fetchApi() {
			return this.config.fetchApi || (typeof window < "u" ? window.fetch?.bind(window) : fetch);
		}
		get queryParamsStringify() {
			return this.config.queryParamsStringify || Wu;
		}
		get headers() {
			return this.config.headers || {};
		}
		set headers(e) {
			this.config.headers = e;
		}
		get globals() {
			return this.config.globals || {};
		}
		set globals(e) {
			this.config.globals = e;
		}
		get mode() {
			return this.config.mode;
		}
		get paths() {
			return this.config.paths || {};
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/searchResponse.js
function Xu(e, t) {
	return {
		pagination: Xu.pagination(e),
		results: Xu.results(e),
		filters: Xu.filters(e),
		facets: Xu.facets(e, t),
		sorting: Xu.sorting(e),
		merchandising: Xu.merchandising(e),
		search: Xu.search(e, t),
		tracking: Xu.tracking(e)
	};
}
function Zu(e) {
	return Array.isArray(e) ? e.map((e) => typeof e == "string" ? $l(String(e)) : e) : $l(typeof e == "string" ? e : JSON.stringify(e));
}
var Qu, $u, ed = o((() => {
	Iu(), Qu = [
		"uid",
		"sku",
		"available",
		"name",
		"url",
		"addToCartUrl",
		"parentId",
		"parentImageUrl",
		"price",
		"msrp",
		"imageUrl",
		"secureImageUrl",
		"thumbnailImageUrl",
		"secureThumbnailImageUrl",
		"rating",
		"ratingCount",
		"description",
		"stockMessage",
		"brand",
		"popularity",
		"caption"
	], $u = class {
		constructor(e) {
			Object.assign(this, e);
		}
	}, Xu.pagination = (e) => {
		let t = e?.pagination;
		return {
			totalResults: t?.totalResults,
			page: t?.currentPage,
			pageSize: t?.perPage,
			totalPages: t?.totalPages
		};
	}, Xu.results = (e) => (e?.results || []).map((t) => Xu.result(t, e)), Xu.result = (e, t) => {
		let n = Qu.reduce((t, n) => e[n] === void 0 ? t : {
			...t,
			[n]: Zu(e[n] || "")
		}, {});
		n.price &&= +n.price, n.msrp &&= +n.msrp, n.available?.toString() === "true" ? n.available = !0 : n.available?.toString() === "false" && (n.available = !1);
		let r = Object.keys(e).filter((e) => Qu.indexOf(e) == -1).filter((t) => !(t == "badges" && Array.isArray(e[t]) && typeof e[t]?.[0] == "object")).filter((e) => e != "variants").reduce((t, n) => ({
			...t,
			[n]: Zu(e[n] || "")
		}), {});
		return new $u({
			id: e.uid,
			responseId: t.responseId,
			mappings: { core: n },
			attributes: r,
			badges: Array.isArray(e.badges) && typeof e.badges[0] == "object" ? e.badges : [],
			variants: e.variants
		});
	}, Xu.filters = (e) => (e?.filterSummary || []).map((e) => {
		let t = e.value, n = "value";
		return typeof e.value == "object" && e && e.value && e.value.rangeHigh != null && e.value.rangeLow != null && (n = "range", t = {
			low: +e.value.rangeLow,
			high: +e.value.rangeHigh
		}), {
			type: n,
			field: e.field,
			label: e.filterValue,
			value: t
		};
	}), Xu.facets = (e, t = {}) => {
		let n = t.filters || [], r = e?.facets || [], i = t?.facets?.limit, a = t?.facets?.valueLimit, o = r.map((e) => {
			let t = {
				field: e.field,
				type: "value",
				filtered: !!e.facet_active
			};
			if (e.step) e.range && (t = {
				...t,
				type: "range",
				step: e.step,
				range: {
					low: e.range[0] == "*" ? void 0 : +e.range[0],
					high: e.range[1] == "*" ? void 0 : +e.range[1]
				}
			}), e.active && typeof e.active != "boolean" && e.active.length > 1 && (t.active = {
				low: e.active[0] == "*" ? void 0 : +e.active[0],
				high: e.active[1] == "*" ? void 0 : +e.active[1]
			});
			else if (e.values instanceof Array) {
				if (e.type == "hierarchy") {
					t.type = "value", t.values = (e.values || []).map((e) => ({
						filtered: !!e.active,
						value: e.value,
						label: e.label,
						count: e.count
					}));
					let r = n.find((t) => t.field == e.field), i = [];
					if (r && !r.background) {
						let t = r.value?.split(e.hierarchyDelimiter || ">");
						if (t) for (let n = t.length - 1; n >= 0; n--) {
							let a = t.slice(0, n + 1), o = a.join(e.hierarchyDelimiter);
							i.unshift({
								value: o,
								filtered: o == r.value,
								label: a[a.length - 1]
							});
						}
						i.unshift({
							value: void 0,
							filtered: !1,
							label: "View All"
						});
					}
					t.values = i.concat(t.values);
				} else e.values[0].type == "value" ? (t.type = "value", t.values = e.values.map((e) => ({
					filtered: e.active,
					value: e.value,
					label: e.label,
					count: e.count
				}))) : e.values[0].type == "range" && (t.type = "range-buckets", t.values = e.values.map((e) => ({
					filtered: e.active,
					low: e.low == "*" || e.low == null ? null : +e.low,
					high: e.high == "*" || e.high == null ? null : +e.high,
					label: e.label,
					count: e.count
				})));
			}
			return t;
		});
		return i && (o = o.slice(0, i)), a && (o = o.map((e) => (e.values &&= e.values.slice(0, a), e))), o;
	}, Xu.sorting = (e) => (e?.sorting?.options || []).filter((e) => e.active).map((e) => ({
		field: e.field,
		direction: e.direction
	})), Xu.merchandising = (e) => {
		let t = e?.merchandising;
		return t?.content && Array.isArray(t.content) && !t.content.length && (t.content = {}), {
			redirect: t?.redirect || "",
			content: t?.content || {},
			campaigns: t?.triggeredCampaigns || [],
			personalized: t?.personalized,
			experiments: t?.experiments || []
		};
	}, Xu.search = (e, t) => {
		let n = {
			query: t?.search?.query?.string,
			didYouMean: e?.didYouMean?.query,
			matchType: e?.query?.matchType,
			subject: e?.query?.subject
		};
		return e?.query?.corrected && e?.query.original && (n.query = e?.query?.corrected, n.originalQuery = e?.query?.original), n;
	}, Xu.tracking = (e) => ({ responseId: e.responseId });
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/utils/mergeParams.js
function td(...e) {
	let t = {};
	return e.reverse().forEach((e) => {
		Object.keys(e).forEach((n) => {
			let r = e[n], i = t[n];
			if (r instanceof Array) {
				let e = i === void 0 ? [] : i instanceof Array ? i : [i];
				t[n] = e.concat(r.filter((t) => e.indexOf(t) === -1));
			} else i instanceof Array ? t[n] = i.indexOf(r) === -1 ? [r].concat(i) : i : t[n] = r;
		});
	}), t;
}
var nd = o((() => {})), rd = o((() => {
	nd();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/searchRequest.js
function id(e) {
	return td(id.sorts(e), id.search(e), id.filters(e), id.merchandising(e), id.pagination(e), id.siteId(e), id.facets(e), id.tracking(e), id.personalization(e));
}
var ad = o((() => {
	rd(), id.sorts = (e = {}) => (e.sorts || []).reduce((e, t) => !t.field || !t.direction || t.direction != "asc" && t.direction != "desc" ? e : {
		...e,
		["sort." + t.field]: (e[t.field] || []).concat([t.direction])
	}, {}), id.search = (e = {}) => {
		let t = e.search || {}, n = {};
		return t.query && t.query.string && (n.q = t.query.string), t.subQuery && (n.rq = t.subQuery.trim()), t.originalQuery && (n.originalQuery = t.originalQuery.trim()), t.fallbackQuery && (n.fallbackQuery = t.fallbackQuery.trim()), t.redirectResponse && (n.redirectResponse = t.redirectResponse), t.source && (n.source = t.source), t.input && (n.input = t.input), n;
	}, id.filters = (e = {}) => (e.filters || []).reduce((e, t) => {
		let n = t.background ? "bgfilter" : "filter";
		if (t.type == "value") {
			let r = n + "." + t.field;
			return {
				...e,
				[r]: (e[r] || []).concat([t.value])
			};
		}
		if (t.type == "range") {
			let r = n + "." + t.field + ".low", i = n + "." + t.field + ".high", a = t?.value?.low ?? "*", o = t?.value?.high ?? "*";
			return {
				...e,
				[r]: (e[r] || []).concat([a]),
				[i]: (e[i] || []).concat([o])
			};
		}
		return e;
	}, {}), id.merchandising = (e = {}) => {
		let t = e.merchandising || {}, n = t.disabled ? { disableMerchandising: !0 } : {};
		return t.landingPage && (n["landing-page"] = t.landingPage), t.segments instanceof Array && t.segments.length && (n.tag = t.segments.map((e) => `merch.segment/${e}`)), t.disableInlineBanners && (n.disableInlineBanners = t.disableInlineBanners), n;
	}, id.pagination = (e = {}) => {
		let t = e.pagination || {}, n = {};
		return t.page && (n.page = t.page), (t.pageSize || t.pageSize === 0) && (n.resultsPerPage = t.pageSize), n;
	}, id.siteId = (e = {}) => e.siteId ? { siteId: e.siteId } : {}, id.facets = (e = {}) => {
		let t = e.facets || {}, n = {};
		if (t.include && t.include.length && t.exclude && t.exclude.length) throw "cannot use facet include and exclude at the same time";
		return t.include?.length && (n.includedFacets = t.include), t.exclude?.length && (n.excludedFacets = t.exclude), t.autoDrillDown === !1 && (n.disableFacetDrillDown = !0), n;
	}, id.tracking = (e = {}) => {
		let t = e.tracking || {}, n = {};
		return t.userId && (n.userId = t.userId), t.domain && (n.domain = t.domain), t.sessionId && (n.sessionId = t.sessionId), t.pageLoadId && (n.pageLoadId = t.pageLoadId), n;
	}, id.personalization = (e = {}) => {
		let t = e.personalization || {}, n = {};
		return t.disabled && (n.skipPersonalization = t.disabled), t.cart && (n.cart = t.cart), t.lastViewed && (n.lastViewed = t.lastViewed), t.shopper && (n.shopper = t.shopper), n;
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/suggestResponse.js
function od(e) {
	return {
		query: e?.query,
		correctedQuery: e?.["corrected-query"],
		suggested: od.suggested(e),
		alternatives: od.alternatives(e)
	};
}
var sd = o((() => {
	od.suggested = (e) => typeof e != "object" || !e.suggested || typeof e.suggested != "object" ? {} : {
		text: e.suggested?.text,
		type: e.suggested?.type,
		source: e.suggested?.source
	}, od.alternatives = (e) => (e?.alternatives || []).map((e) => ({ text: e.text }));
})), cd, ld = o((() => {
	cd = (e) => {
		if (!e) return;
		let t = [];
		return e.map((e) => {
			if (e.type == "value") {
				let n = t.findIndex((t) => t.field == e.field);
				if (n > -1) t[n].values.push(e.value);
				else {
					let n = {
						field: e.field,
						type: "=",
						values: [e.value]
					};
					t.push(n);
				}
			} else if (e.type == "range") {
				if (typeof e.value.low == "number") {
					let n = {
						field: e.field,
						type: ">=",
						values: [e.value.low]
					}, r = t.findIndex((t) => t.field == e.field && t.type == ">=");
					r > -1 ? t[r] = n : t.push(n);
				}
				if (typeof e.value.high == "number") {
					let n = {
						field: e.field,
						type: "<=",
						values: [e.value.high]
					}, r = t.findIndex((t) => t.field == e.field && t.type == "<=");
					r > -1 ? t[r] = n : t.push(n);
				}
			}
		}), t;
	};
})), ud = o((() => {
	ad(), ed(), sd(), ld();
})), dd, fd, pd = o((() => {
	wd(), Iu(), ed(), ud(), dd = "test", fd = class extends qu {
		async getEndpoint(e, t) {
			let n = id(e);
			n.ajaxCatalog = this.configuration.initiator, n.resultsFormat = "native", this.configuration.mode == ku.development && (n[dd] = !0);
			let r = { ...n };
			return delete r.pageLoadId, delete r.domain, delete r.input, delete r.redirectResponse, Xu(await this.request({
				path: t,
				method: "GET",
				headers: {},
				query: n
			}, JSON.stringify(r)), e);
		}
		async getAutocomplete(e) {
			return this.getEndpoint(e, this.configuration.paths.autocomplete || "/v1/autocomplete");
		}
		async getSearch(e) {
			return this.getEndpoint(e, this.configuration.paths.search || "/v1/search");
		}
		async getCategory(e) {
			return this.getEndpoint(e, this.configuration.paths.category || "/v1/category");
		}
		async getFinder(e) {
			return this.getEndpoint(e, this.configuration.paths.finder || "/v1/finder");
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/apis/Recommend.js
function md(e, t) {
	let n = e.request, r = t.request, i = n.order ?? n.profile?.order, a = r.order ?? r.profile?.order;
	return i == null && a == null ? 0 : i == null && a != null ? 1 : a == null && i != null || i < a ? -1 : +(i > a);
}
function hd(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var gd, _d, vd, yd = o((() => {
	Yu(), Iu(), ud(), pd(), gd = class {
		constructor() {
			this.promise = new Promise((e, t) => {
				this.reject = t, this.resolve = e;
			});
		}
	}, _d = 150, vd = class extends qu {
		constructor() {
			super(...arguments), this.batches = {};
		}
		async getProfile(e) {
			return await this.request({
				path: this.configuration.paths.profile || "/v1/profile",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async batchRecommendations(e) {
			let t = e.batchId || 1, n = e.batched ? `${e.profile?.siteId || e.siteId}:${t}` : `${Math.random()}:${t}`, r = this.batches[n] = this.batches[n] || {
				timeout: null,
				request: { profiles: [] },
				entries: []
			}, i = new gd();
			r.entries.push({
				request: e,
				deferred: i
			});
			let a = typeof window < "u" ? window.clearTimeout : clearTimeout, o = typeof window < "u" ? window.setTimeout : setTimeout;
			return a && a(r.timeout), r.timeout = o(async () => {
				delete this.batches[n], r.entries.sort(md), r.entries.map((e) => {
					if (e.request.product && (Array.isArray(e.request.products) && e.request.products.indexOf(e.request.product) == -1 ? e.request.products = e.request.products.concat(e.request.product) : e.request.products = [e.request.product]), e.request.profile) {
						let { tag: t, profile: { categories: n, brands: i, blockedItems: a, limit: o, query: s, filters: c, dedupe: l } } = e.request, u = {
							tag: t,
							...hd({
								categories: n,
								brands: i,
								blockedItems: a,
								limit: o,
								searchTerm: s,
								filters: cd(c),
								dedupe: l
							})
						};
						r.request.profiles?.push(u);
					} else {
						let { tag: t, categories: n, brands: i, limit: a, query: o, dedupe: s } = e.request, c = {
							tag: t,
							...hd({
								categories: n,
								brands: i,
								limit: a,
								searchTerm: o,
								dedupe: s
							})
						};
						r.request.profiles?.push(c);
					}
					let { products: t, blockedItems: n, filters: i, test: a, cart: o, lastViewed: s, shopper: c, withRecInfo: l } = e.request, u = Array.from(new Set((r.request.products || []).concat(t || []))), d = Array.from(new Set((r.request.blockedItems || []).concat(n || []))), f = Array.from(new Set((r.request.filters || []).concat(cd(i) || []).map((e) => JSON.stringify(e)))).map((e) => JSON.parse(e)), p = r.request.withRecInfo || l || void 0;
					r.request = {
						...r.request,
						...hd({
							siteId: e.request.profile?.siteId || e.request.siteId,
							products: u.length ? u : void 0,
							blockedItems: d.length ? d : void 0,
							filters: f.length ? f : void 0,
							test: a,
							cart: o,
							lastViewed: s,
							shopper: c,
							withRecInfo: p
						})
					}, this.configuration.mode == ku.development && (r.request[dd] = !0);
				});
				try {
					this.configuration.mode == ku.development && (r.request.test = !0);
					let e = await this.postRecommendations(r.request);
					r.entries?.forEach((t, n) => {
						t.deferred.resolve(e[n]);
					});
				} catch (e) {
					r.entries?.forEach((t) => {
						t.deferred.reject(e);
					});
				}
			}, _d), i.promise;
		}
		async postRecommendations(e) {
			let t = {};
			return t["Content-Type"] = "text/plain", await this.request({
				path: this.configuration.paths.recommend || "/v1/recommend",
				method: "POST",
				headers: t,
				body: e,
				subDomain: "p13n"
			}, JSON.stringify(e));
		}
	};
})), bd, xd = o((() => {
	Yu(), bd = class extends qu {
		async getSuggest(e) {
			return await this.request({
				path: this.configuration.paths.suggest || "/v1/suggest",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async postSuggest(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.suggest || "/v1/suggest",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
		async getTrending(e) {
			return await this.request({
				path: this.configuration.paths.trending || "/v1/trending",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async postTrending(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.trending || "/v1/trending",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
	};
})), Sd, Cd = o((() => {
	wd(), Sd = class extends qu {
		async postMeta(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.meta || "/v1/meta",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
		async getMeta(e) {
			return await this.request({
				path: this.configuration.paths.meta || "/v1/meta",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
	};
})), wd = o((() => {
	Yu(), pd(), yd(), xd(), Cd();
})), Td, Ed, Dd, Od = o((() => {
	Iu(), wd(), Td = /* @__PURE__ */ u(U()), ud(), Ed = {
		mode: ku.production,
		meta: { cache: { purgeable: !1 } }
	}, Dd = class {
		constructor(e, t = {}) {
			if (this.mode = ku.production, !e?.siteId) throw "no siteId specified!";
			this.globals = e, this.config = (0, Td.default)(Ed, t), Object.values(ku).includes(this.config.mode) && (this.mode = this.config.mode), this.requesters = {
				meta: new Sd(new Ju({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.meta?.origin,
					headers: this.config.meta?.headers,
					cache: this.config.meta?.cache,
					globals: this.config.meta?.globals,
					paths: this.config.meta?.paths
				})),
				recommend: new vd(new Ju({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.recommend?.origin,
					headers: this.config.recommend?.headers,
					cache: this.config.recommend?.cache,
					globals: this.config.recommend?.globals,
					paths: this.config.recommend?.paths
				})),
				search: new fd(new Ju({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.search?.origin,
					headers: this.config.search?.headers,
					cache: this.config.search?.cache,
					globals: this.config.search?.globals,
					paths: this.config.search?.paths
				})),
				suggest: new bd(new Ju({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.suggest?.origin,
					headers: this.config.suggest?.headers,
					cache: this.config.suggest?.cache,
					globals: this.config.suggest?.globals,
					paths: this.config.suggest?.paths
				}))
			};
		}
		async meta(e) {
			let t = { siteId: this.globals.siteId };
			return e = (0, Td.default)(t, e || {}), this.requesters.meta.getMeta(e);
		}
		async autocomplete(e = {}) {
			if (!e.search?.query?.string) throw "query string parameter is required";
			e = (0, Td.default)(this.globals, e);
			let t = this.meta({ siteId: e.siteId || "" }), n = {
				siteId: e.siteId || "",
				language: "en",
				query: e.search?.query?.string || "",
				suggestionCount: (e.suggestions || {}).count || 5
			};
			e.search?.query?.spellCorrection === !1 && (n.disableSpellCorrect = !0);
			let r = od(await this.requesters.suggest.getSuggest(n)), i = (r.suggested || {}).text || r.query || r.correctedQuery;
			e.search = e.search || {}, e.search.redirectResponse = "full", i && e.search?.query?.string && (e.search.query.string = i);
			let a = {
				...await this.requesters.search.getAutocomplete(e),
				autocomplete: r
			}, [o, s] = await Promise.all([t, a]);
			return {
				meta: o,
				search: s
			};
		}
		async search(e = {}) {
			e = (0, Td.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getSearch(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async category(e = {}) {
			e = (0, Td.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getCategory(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async finder(e = {}) {
			e = (0, Td.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getFinder(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async trending(e) {
			return e = (0, Td.default)({ siteId: this.globals.siteId }, e || {}), this.requesters.suggest.getTrending(e);
		}
		async recommend(e) {
			let { tag: t, ...n } = e;
			if (!t) throw "tag parameter is required";
			let r = {
				tag: t,
				siteId: e.siteId || this.globals.siteId
			};
			n.branch && (r.branch = n.branch, delete n.branch);
			let i = {
				tag: t,
				...n,
				siteId: e.siteId || this.globals.siteId
			}, [a, o, s] = await Promise.all([
				this.meta(e.siteId ? { siteId: e.siteId } : void 0),
				this.requesters.recommend.getProfile(r),
				this.requesters.recommend.batchRecommendations(i)
			]);
			return {
				...o,
				meta: a,
				results: s && s.results,
				responseId: s ? s.responseId : ""
			};
		}
	};
})), kd = o((() => {
	Od();
})), Ad, jd = o((() => {
	Ad = {
		blue: "#3379c1",
		bluelight: "#688BA3",
		bluedark: "#1B3141",
		bluegreen: "#318495",
		grey: "#61717B",
		green: "#507B43",
		greendark: "#63715F",
		greenblue: "#46927D",
		indigo: "#4c3ce2",
		orange: "#ecaa15",
		orangelight: "#ff6600",
		orangedark: "#c59600",
		red: "#cc1212",
		redlight: "#f30707",
		reddark: "#8E111C",
		yellow: "#d1d432"
	};
})), Md, Nd = o((() => {
	Md = {
		bang: String.fromCodePoint(8252),
		bright: String.fromCodePoint(128262),
		check: String.fromCodePoint(10004),
		clock: String.fromCodePoint(128342),
		cloud: String.fromCodePoint(9729),
		dim: String.fromCodePoint(128261),
		gear: String.fromCodePoint(9881),
		interobang: String.fromCodePoint(8265),
		lightning: String.fromCodePoint(9889),
		magic: String.fromCodePoint(10024),
		rocket: String.fromCodePoint(128640),
		search: String.fromCodePoint(128269),
		snap: String.fromCodePoint(128165),
		ufo: String.fromCodePoint(128760),
		vortex: String.fromCodePoint(127744),
		warning: String.fromCodePoint(9888)
	};
})), Pd, Fd = o((() => {
	Iu(), jd(), Nd(), Pd = class {
		constructor(e) {
			this.mode = ku.production, this.emoji = Md, this.colors = Ad, this.prefix = "", this.prefix = e?.prefix || "", this.mode = e?.mode || ku.production;
		}
		setNamespace(e) {
			this.prefix = ` [${e}] :: `;
		}
		error(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), console.log(`%c ${Md.bang} %c${this.prefix}${t}`, `color: ${Ad.red}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${Ad.red}; font-weight: bold;`, ...n);
		}
		warn(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), console.log(`%c ${Md.warning} %c${this.prefix}%c${t}`, `color: ${Ad.yellow}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${Ad.yellow}; font-weight: normal;`, `color: ${Ad.yellow}; font-weight: bold;`, ...n);
		}
		image({ url: e, width: t, height: n }, ...r) {
			let i = {
				size: `font-size: 1px; padding: ${n || t} ${t || n};`,
				background: `background: url("${e}") no-repeat; background-size: contain;`
			};
			this.dev("%c...", `${i.size} ${i.background}`, ...r);
		}
		imageText({ url: e, text: t = "", style: n }, ...r) {
			let i = {
				background: `margin-left: 6px; background: url("${e}") no-repeat; background-size: contain;`,
				custom: n
			}, a = t, o = r;
			!a && r?.length && ([a, ...o] = r), this.dev(`%c ${"  " + this.prefix}${a}`, `${i.background} ${i.custom}`, ...o);
		}
		debug(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), this.dev(`%c ${Md.interobang} %c${this.prefix}${t}`, `color: ${Ad.orangelight}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${Ad.orangelight}; font-weight: bold;`, ...n);
		}
		profile(e, ...t) {
			this.dev(`%c ${Md.gear} %c${this.prefix}%c${e.type}  %c~  ${e.name}  ::  %c${e.status.toUpperCase()}${e.status == "finished" ? "  ::  %c" + e.time.run + "ms" : ""}`, `color: ${Ad.orange}; font-size: 14px; line-height: 12px;`, `color: ${Ad.orange};`, `color: ${Ad.orange}; font-style: italic;`, `color: ${Ad.orange};`, `color: ${Ad.orange}; font-weight: bold;`, `color: ${Ad.grey};`, ...t);
		}
		dev(...e) {
			this.mode === ku.development && console.log(...e);
		}
	};
})), Id = o((() => {
	Fd(), jd(), Nd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AttributionInner.js
function Ld(e) {
	return Rd(e, !1);
}
function Rd(e, t = !1) {
	return e == null ? e : {
		type: e.type,
		id: e.id
	};
}
var zd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Currency.js
function Bd(e) {
	return Vd(e, !1);
}
function Vd(e, t = !1) {
	return e == null ? e : { code: e.code };
}
var Hd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Context.js
function Ud(e) {
	return Wd(e, !1);
}
function Wd(e, t = !1) {
	return e == null ? e : {
		initiator: e.initiator,
		pageLoadId: e.pageLoadId,
		pageUrl: e.pageUrl,
		sessionId: e.sessionId,
		timestamp: e.timestamp,
		userId: e.userId,
		attribution: e.attribution == null ? void 0 : e.attribution.map(Ld),
		currency: Bd(e.currency),
		dev: e.dev,
		IP: e.iP,
		shopperId: e.shopperId,
		userAgent: e.userAgent
	};
}
var Gd = o((() => {
	zd(), Hd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Product.js
function Kd(e) {
	return qd(e, !1);
}
function qd(e, t = !1) {
	return e == null ? e : {
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku,
		qty: e.qty,
		price: e.price
	};
}
var Jd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AddtocartSchemaData.js
function Yd(e) {
	return Xd(e, !1);
}
function Xd(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(Kd)
	};
}
var Zd = o((() => {
	Jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AddtocartSchema.js
function Qd(e) {
	return $d(e, !1);
}
function $d(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Yd(e.data)
	};
}
var ef = o((() => {
	Gd(), Zd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BannersInner.js
function tf(e) {
	return nf(e, !1);
}
function nf(e, t = !1) {
	return e == null ? e : { uid: e.uid };
}
var rf = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesAddtocartSchemaData.js
function af(e) {
	return of(e, !1);
}
function of(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		tag: e.tag,
		results: e.results.map(Kd)
	};
}
var sf = o((() => {
	Jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesAddtocartSchema.js
function cf(e) {
	return lf(e, !1);
}
function lf(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: af(e.data)
	};
}
var uf = o((() => {
	Gd(), sf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersInner.js
function df(e) {
	return ff(e, !1);
}
function ff(e, t = !1) {
	return e == null ? e : { uid: e.uid };
}
var pf = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersSchema1.js
function mf(e) {
	return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function hf(e) {
	return gf(e, !1);
}
function gf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		banners: e.banners.map(df)
	};
}
var _f = o((() => {
	pf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultProductType.js
function vf(e) {
	return e;
}
var yf = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultProduct.js
function bf(e) {
	return !(!("type" in e) || e.type === void 0 || !("parentId" in e) || e.parentId === void 0 || !("uid" in e) || e.uid === void 0);
}
function xf(e) {
	return Sf(e, !1);
}
function Sf(e, t = !1) {
	return e == null ? e : {
		type: vf(e.type),
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var Cf = o((() => {
	yf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultResultBanner.js
function wf(e) {
	return !(!("type" in e) || e.type === void 0 || !("uid" in e) || e.uid === void 0);
}
function Tf(e) {
	return Ef(e, !1);
}
function Ef(e, t = !1) {
	return e == null ? e : {
		type: vf(e.type),
		uid: e.uid
	};
}
var Df = o((() => {
	yf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsInner.js
function Of(e) {
	return kf(e, !1);
}
function kf(e, t = !1) {
	return typeof e != "object" || !e ? e : bf(e) ? xf(e) : wf(e) ? Tf(e) : {};
}
var Af = o((() => {
	Cf(), Df();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsSchema1.js
function jf(e) {
	return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function Mf(e) {
	return Nf(e, !1);
}
function Nf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results.map(Of)
	};
}
var Pf = o((() => {
	Af();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesClickthroughSchemaData.js
function Ff(e) {
	return If(e, !1);
}
function If(e, t = !1) {
	return typeof e != "object" || !e ? e : mf(e) ? hf(e) : jf(e) ? Mf(e) : {};
}
var Lf = o((() => {
	_f(), Pf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesClickthroughSchema.js
function Rf(e) {
	return zf(e, !1);
}
function zf(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Ff(e.data)
	};
}
var Bf = o((() => {
	Gd(), Lf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultsInner.js
function Vf(e) {
	return Hf(e, !1);
}
function Hf(e, t = !1) {
	return typeof e != "object" || !e ? e : bf(e) ? xf(e) : wf(e) ? Tf(e) : {};
}
var Uf = o((() => {
	Cf(), Df();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesImpressionSchemaData.js
function Wf(e) {
	return Gf(e, !1);
}
function Gf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results == null ? void 0 : e.results.map(Vf),
		banners: e.banners.map(tf)
	};
}
var Kf = o((() => {
	rf(), Uf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesImpressionSchema.js
function qf(e) {
	return Jf(e, !1);
}
function Jf(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Wf(e.data)
	};
}
var Yf = o((() => {
	Gd(), Kf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesRenderSchemaData.js
function Xf(e) {
	return Zf(e, !1);
}
function Zf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId
	};
}
var Qf = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesRenderSchema.js
function $f(e) {
	return ep(e, !1);
}
function ep(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Xf(e.data)
	};
}
var tp = o((() => {
	Gd(), Qf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/CartSchemaData.js
function np(e) {
	return rp(e, !1);
}
function rp(e, t = !1) {
	return e == null ? e : {
		results: e.results.map(Kd),
		cart: e.cart.map(Kd)
	};
}
var ip = o((() => {
	Jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/CartSchema.js
function ap(e) {
	return op(e, !1);
}
function op(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: np(e.data)
	};
}
var sp = o((() => {
	ip(), Gd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatAddtocartSchemaData.js
function cp(e) {
	return lp(e, !1);
}
function lp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(Kd)
	};
}
var up = o((() => {
	Jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatAddtocartSchema.js
function dp(e) {
	return fp(e, !1);
}
function fp(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: cp(e.data)
	};
}
var pp = o((() => {
	Gd(), up();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatResultProductType.js
function mp(e) {
	return e;
}
var hp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatResultProduct.js
function gp(e) {
	return _p(e, !1);
}
function _p(e, t = !1) {
	return e == null ? e : {
		type: mp(e.type),
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var vp = o((() => {
	hp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatClickthroughSchemaData.js
function yp(e) {
	return bp(e, !1);
}
function bp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(gp)
	};
}
var xp = o((() => {
	vp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatClickthroughSchema.js
function Sp(e) {
	return Cp(e, !1);
}
function Cp(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: yp(e.data)
	};
}
var wp = o((() => {
	Gd(), xp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatFeedbackSchemaData.js
function Tp(e) {
	return Ep(e, !1);
}
function Ep(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		feedback: e.feedback
	};
}
var Dp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatFeedbackSchema.js
function Op(e) {
	return kp(e, !1);
}
function kp(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Tp(e.data)
	};
}
var Ap = o((() => {
	Dp(), Gd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatImpressionSchemaData.js
function jp(e) {
	return Mp(e, !1);
}
function Mp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(gp)
	};
}
var Np = o((() => {
	vp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatImpressionSchema.js
function Pp(e) {
	return Fp(e, !1);
}
function Fp(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: jp(e.data)
	};
}
var Ip = o((() => {
	Gd(), Np();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersSchema.js
function Lp(e) {
	return !(!("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function Rp(e) {
	return zp(e, !1);
}
function zp(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		banners: e.banners.map(df)
	};
}
var Bp = o((() => {
	pf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsSchema.js
function Vp(e) {
	return !(!("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function Hp(e) {
	return Up(e, !1);
}
function Up(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(Of)
	};
}
var Wp = o((() => {
	Af();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughSchemaData.js
function Gp(e) {
	return Kp(e, !1);
}
function Kp(e, t = !1) {
	return typeof e != "object" || !e ? e : Lp(e) ? Rp(e) : Vp(e) ? Hp(e) : {};
}
var qp = o((() => {
	Bp(), Wp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughSchema.js
function Jp(e) {
	return Yp(e, !1);
}
function Yp(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Gp(e.data)
	};
}
var Xp = o((() => {
	Gd(), qp();
})), Zp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ImpressionSchemaData.js
function Qp(e) {
	return $p(e, !1);
}
function $p(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(Vf),
		banners: e.banners.map(tf)
	};
}
var em = o((() => {
	rf(), Uf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ImpressionSchema.js
function tm(e) {
	return nm(e, !1);
}
function nm(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Qp(e.data)
	};
}
var rm = o((() => {
	Gd(), em();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/InlineObject.js
function im(e) {
	return am(e, !1);
}
function am(e, t) {
	return e == null ? e : { success: e.success == null ? void 0 : e.success };
}
var om = o((() => {})), sm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/LogSchemaData.js
function cm(e) {
	return lm(e, !1);
}
function lm(e, t = !1) {
	return e == null ? e : {
		message: e.message,
		stack: e.stack,
		details: e.details
	};
}
var um = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/LogSchema.js
function dm(e) {
	return fm(e, !1);
}
function fm(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: cm(e.data)
	};
}
var pm = o((() => {
	Gd(), um();
})), mm = o((() => {})), hm = o((() => {})), gm = o((() => {
	mm(), hm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/OrderTransactionSchemaData.js
function _m(e) {
	return vm(e, !1);
}
function vm(e, t = !1) {
	return e == null ? e : {
		orderId: e.orderId,
		transactionTotal: e.transactionTotal,
		total: e.total,
		vat: e.vat,
		city: e.city,
		state: e.state,
		country: e.country,
		results: e.results.map(Kd)
	};
}
var ym = o((() => {
	Jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/OrderTransactionSchema.js
function bm(e) {
	return xm(e, !1);
}
function xm(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: _m(e.data)
	};
}
var Sm = o((() => {
	Gd(), ym();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogContext.js
function Cm(e) {
	return wm(e, !1);
}
function wm(e, t = !1) {
	return e == null ? e : {
		timestamp: e.timestamp,
		dev: e.dev
	};
}
var Tm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogSchemaData.js
function Em(e) {
	return Dm(e, !1);
}
function Dm(e, t = !1) {
	return e == null ? e : {
		message: e.message,
		stack: e.stack,
		details: e.details
	};
}
var Om = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogSchema.js
function km(e) {
	return Am(e, !1);
}
function Am(e, t = !1) {
	return e == null ? e : {
		context: Cm(e.context),
		data: Em(e.data)
	};
}
var jm = o((() => {
	Om(), Tm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchemaDataResult.js
function Mm(e) {
	return Nm(e, !1);
}
function Nm(e, t = !1) {
	return e == null ? e : {
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var Pm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchemaData.js
function Fm(e) {
	return Im(e, !1);
}
function Im(e, t = !1) {
	return e == null ? e : { result: Mm(e.result) };
}
var Lm = o((() => {
	Pm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchema.js
function Rm(e) {
	return zm(e, !1);
}
function zm(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Fm(e.data)
	};
}
var Bm = o((() => {
	Gd(), Lm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsAddtocartSchemaData.js
function Vm(e) {
	return Hm(e, !1);
}
function Hm(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		tag: e.tag,
		results: e.results.map(Kd)
	};
}
var Um = o((() => {
	Jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsAddtocartSchema.js
function Wm(e) {
	return Gm(e, !1);
}
function Gm(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: Vm(e.data)
	};
}
var Km = o((() => {
	Gd(), Um();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsClickthroughSchemaData.js
function qm(e) {
	return Jm(e, !1);
}
function Jm(e, t = !1) {
	return typeof e != "object" || !e ? e : mf(e) ? hf(e) : jf(e) ? Mf(e) : {};
}
var Ym = o((() => {
	_f(), Pf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsClickthroughSchema.js
function Xm(e) {
	return Zm(e, !1);
}
function Zm(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: qm(e.data)
	};
}
var Qm = o((() => {
	Gd(), Ym();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsImpressionSchemaData.js
function $m(e) {
	return eh(e, !1);
}
function eh(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results == null ? void 0 : e.results.map(Vf),
		banners: e.banners.map(tf)
	};
}
var th = o((() => {
	rf(), Uf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsImpressionSchema.js
function nh(e) {
	return rh(e, !1);
}
function rh(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: $m(e.data)
	};
}
var ih = o((() => {
	Gd(), th();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsRenderSchemaData.js
function ah(e) {
	return oh(e, !1);
}
function oh(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId
	};
}
var sh = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsRenderSchema.js
function ch(e) {
	return lh(e, !1);
}
function lh(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: ah(e.data)
	};
}
var uh = o((() => {
	Gd(), sh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RedirectSchemaData.js
function dh(e) {
	return fh(e, !1);
}
function fh(e, t = !1) {
	return e == null ? e : {
		redirect: e.redirect,
		responseId: e.responseId
	};
}
var ph = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RedirectSchema.js
function mh(e) {
	return hh(e, !1);
}
function hh(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: dh(e.data)
	};
}
var gh = o((() => {
	Gd(), ph();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RenderSchemaData.js
function _h(e) {
	return vh(e, !1);
}
function vh(e, t = !1) {
	return e == null ? e : { responseId: e.responseId };
}
var yh = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RenderSchema.js
function bh(e) {
	return xh(e, !1);
}
function xh(e, t = !1) {
	return e == null ? e : {
		context: Ud(e.context),
		data: _h(e.data)
	};
}
var Sh = o((() => {
	Gd(), yh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ShopperContext.js
function Ch(e) {
	return wh(e, !1);
}
function wh(e, t = !1) {
	return e == null ? e : {
		initiator: e.initiator,
		pageLoadId: e.pageLoadId,
		pageUrl: e.pageUrl,
		sessionId: e.sessionId,
		shopperId: e.shopperId,
		timestamp: e.timestamp,
		userId: e.userId,
		attribution: e.attribution == null ? void 0 : e.attribution.map(Ld),
		currency: Bd(e.currency),
		dev: e.dev,
		IP: e.iP,
		userAgent: e.userAgent
	};
}
var Th = o((() => {
	zd(), Hd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ShopperLoginSchema.js
function Eh(e) {
	return Dh(e, !1);
}
function Dh(e, t = !1) {
	return e == null ? e : { context: Ch(e.context) };
}
var Oh = o((() => {
	Th();
})), kh = o((() => {})), Ah = o((() => {
	ef(), Zd(), zd(), rf(), uf(), sf(), Bf(), Lf(), Yf(), Kf(), tp(), Qf(), sp(), ip(), pp(), up(), wp(), xp(), Ap(), Dp(), Ip(), Np(), vp(), hp(), pf(), Bp(), _f(), Af(), Wp(), Pf(), Xp(), qp(), Gd(), Hd(), Zp(), rm(), em(), om(), sm(), pm(), um(), gm(), mm(), hm(), Sm(), ym(), Tm(), jm(), Om(), Jd(), Bm(), Lm(), Pm(), Km(), Um(), Qm(), Ym(), ih(), th(), uh(), sh(), gh(), ph(), Sh(), yh(), Cf(), yf(), Df(), Uf(), Th(), Oh(), kh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/runtime.js
function jh(e) {
	return typeof Blob < "u" && e instanceof Blob;
}
function Mh(e) {
	return typeof FormData < "u" && e instanceof FormData;
}
function Nh(e, t = "") {
	return Object.keys(e).map((n) => Ph(n, e[n], t)).filter((e) => e.length > 0).join("&");
}
function Ph(e, t, n = "") {
	let r = n + (n.length ? `[${e}]` : e);
	if (t instanceof Array) {
		let e = t.map((e) => encodeURIComponent(String(e))).join(`&${encodeURIComponent(r)}=`);
		return `${encodeURIComponent(r)}=${e}`;
	}
	return t instanceof Set ? Ph(e, Array.from(t), n) : t instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(t.toISOString())}` : t instanceof Object ? Nh(t, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(t))}`;
}
var Fh, Ih, Lh, Rh, zh, Bh, J, Y, Vh = o((() => {
	Fh = "https://analytics.athoscommerce.net/beacon/v2".replace(/\/+$/, ""), Ih = class {
		constructor(e = {}) {
			this.configuration = e;
		}
		set config(e) {
			this.configuration = e;
		}
		get basePath() {
			return this.configuration.basePath == null ? Fh : this.configuration.basePath;
		}
		get fetchApi() {
			return this.configuration.fetchApi;
		}
		get middleware() {
			return this.configuration.middleware || [];
		}
		get queryParamsStringify() {
			return this.configuration.queryParamsStringify || Nh;
		}
		get username() {
			return this.configuration.username;
		}
		get password() {
			return this.configuration.password;
		}
		get apiKey() {
			let e = this.configuration.apiKey;
			if (e) return typeof e == "function" ? e : () => e;
		}
		get accessToken() {
			let e = this.configuration.accessToken;
			if (e) return typeof e == "function" ? e : async () => e;
		}
		get headers() {
			return this.configuration.headers;
		}
		get credentials() {
			return this.configuration.credentials;
		}
	}, Lh = new Ih(), Rh = class e {
		constructor(e = Lh) {
			this.configuration = e, this.fetchApi = async (e, t) => {
				let n = {
					url: e,
					init: t
				};
				for (let e of this.middleware) e.pre && (n = await e.pre({
					fetch: this.fetchApi,
					...n
				}) || n);
				let r;
				try {
					r = await (this.configuration.fetchApi || fetch)(n.url, n.init);
				} catch (e) {
					for (let t of this.middleware) t.onError && (r = await t.onError({
						fetch: this.fetchApi,
						url: n.url,
						init: n.init,
						error: e,
						response: r ? r.clone() : void 0
					}) || r);
					if (r === void 0) throw e instanceof Error ? new Bh(e, "The request failed and the interceptors did not return an alternative response") : e;
				}
				for (let e of this.middleware) e.post && (r = await e.post({
					fetch: this.fetchApi,
					url: n.url,
					init: n.init,
					response: r.clone()
				}) || r);
				return r;
			}, this.middleware = e.middleware;
		}
		withMiddleware(...e) {
			let t = this.clone();
			return t.middleware = t.middleware.concat(...e), t;
		}
		withPreMiddleware(...e) {
			let t = e.map((e) => ({ pre: e }));
			return this.withMiddleware(...t);
		}
		withPostMiddleware(...e) {
			let t = e.map((e) => ({ post: e }));
			return this.withMiddleware(...t);
		}
		isJsonMime(t) {
			return t ? e.jsonRegex.test(t) : !1;
		}
		async request(e, t) {
			let { url: n, init: r } = await this.createFetchParams(e, t), i = await this.fetchApi(n, r);
			if (i && i.status >= 200 && i.status < 300) return i;
			throw new zh(i, "Response returned an error code");
		}
		async createFetchParams(e, t) {
			let n = this.configuration.basePath + e.path;
			e.query !== void 0 && Object.keys(e.query).length !== 0 && (n += "?" + this.configuration.queryParamsStringify(e.query));
			let r = Object.assign({}, this.configuration.headers, e.headers);
			Object.keys(r).forEach((e) => r[e] === void 0 ? delete r[e] : {});
			let i = typeof t == "function" ? t : async () => t, a = {
				method: e.method,
				headers: r,
				body: e.body,
				credentials: this.configuration.credentials
			}, o = {
				...a,
				...await i({
					init: a,
					context: e
				})
			}, s;
			s = Mh(o.body) || o.body instanceof URLSearchParams || jh(o.body) ? o.body : this.isJsonMime(r["Content-Type"]) ? JSON.stringify(o.body) : o.body;
			let c = {
				...o,
				body: s
			};
			return {
				url: n,
				init: c
			};
		}
		clone() {
			let e = this.constructor, t = new e(this.configuration);
			return t.middleware = this.middleware.slice(), t;
		}
	}, Rh.jsonRegex = /* @__PURE__ */ RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i"), zh = class extends Error {
		constructor(e, t) {
			super(t), this.response = e, this.name = "ResponseError";
		}
	}, Bh = class extends Error {
		constructor(e, t) {
			super(t), this.cause = e, this.name = "FetchError";
		}
	}, J = class extends Error {
		constructor(e, t) {
			super(t), this.field = e, this.name = "RequiredError";
		}
	}, Y = class {
		constructor(e, t = (e) => e) {
			this.raw = e, this.transformer = t;
		}
		async value() {
			return this.transformer(await this.raw.json());
		}
	};
})), Hh, Uh = o((() => {
	Vh(), Ah(), Hh = class extends Rh {
		async autocompleteAddtocartRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteAddtocart().");
			if (e.addtocartSchema == null) throw new J("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling autocompleteAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Qd(e.addtocartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async autocompleteAddtocart(e, t) {
			return await (await this.autocompleteAddtocartRaw(e, t)).value();
		}
		async autocompleteClickthroughRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteClickthrough().");
			if (e.clickthroughSchema == null) throw new J("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling autocompleteClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Jp(e.clickthroughSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async autocompleteClickthrough(e, t) {
			return await (await this.autocompleteClickthroughRaw(e, t)).value();
		}
		async autocompleteImpressionRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteImpression().");
			if (e.impressionSchema == null) throw new J("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling autocompleteImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: tm(e.impressionSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async autocompleteImpression(e, t) {
			return await (await this.autocompleteImpressionRaw(e, t)).value();
		}
		async autocompleteRedirectRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteRedirect().");
			if (e.redirectSchema == null) throw new J("redirectSchema", "Required parameter \"redirectSchema\" was null or undefined when calling autocompleteRedirect().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/redirect";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: mh(e.redirectSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async autocompleteRedirect(e, t) {
			return await (await this.autocompleteRedirectRaw(e, t)).value();
		}
		async autocompleteRenderRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteRender().");
			if (e.renderSchema == null) throw new J("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling autocompleteRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: bh(e.renderSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async autocompleteRender(e, t) {
			return await (await this.autocompleteRenderRaw(e, t)).value();
		}
	};
})), Wh, Gh = o((() => {
	Vh(), Ah(), Wh = class extends Rh {
		async bundlesAddtocartRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesAddtocart().");
			if (e.bundlesAddtocartSchema == null) throw new J("bundlesAddtocartSchema", "Required parameter \"bundlesAddtocartSchema\" was null or undefined when calling bundlesAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: cf(e.bundlesAddtocartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async bundlesAddtocart(e, t) {
			return await (await this.bundlesAddtocartRaw(e, t)).value();
		}
		async bundlesClickthroughRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesClickthrough().");
			if (e.bundlesClickthroughSchema == null) throw new J("bundlesClickthroughSchema", "Required parameter \"bundlesClickthroughSchema\" was null or undefined when calling bundlesClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Rf(e.bundlesClickthroughSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async bundlesClickthrough(e, t) {
			return await (await this.bundlesClickthroughRaw(e, t)).value();
		}
		async bundlesImpressionRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesImpression().");
			if (e.bundlesImpressionSchema == null) throw new J("bundlesImpressionSchema", "Required parameter \"bundlesImpressionSchema\" was null or undefined when calling bundlesImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: qf(e.bundlesImpressionSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async bundlesImpression(e, t) {
			return await (await this.bundlesImpressionRaw(e, t)).value();
		}
		async bundlesRenderRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesRender().");
			if (e.bundlesRenderSchema == null) throw new J("bundlesRenderSchema", "Required parameter \"bundlesRenderSchema\" was null or undefined when calling bundlesRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: $f(e.bundlesRenderSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async bundlesRender(e, t) {
			return await (await this.bundlesRenderRaw(e, t)).value();
		}
	};
})), Kh, qh = o((() => {
	Vh(), Ah(), Kh = class extends Rh {
		async cartAddRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling cartAdd().");
			if (e.cartSchema == null) throw new J("cartSchema", "Required parameter \"cartSchema\" was null or undefined when calling cartAdd().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/cart/add";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: ap(e.cartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async cartAdd(e, t) {
			return await (await this.cartAddRaw(e, t)).value();
		}
		async cartRemoveRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling cartRemove().");
			if (e.cartSchema == null) throw new J("cartSchema", "Required parameter \"cartSchema\" was null or undefined when calling cartRemove().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/cart/remove";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: ap(e.cartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async cartRemove(e, t) {
			return await (await this.cartRemoveRaw(e, t)).value();
		}
	};
})), Jh, Yh = o((() => {
	Vh(), Ah(), Jh = class extends Rh {
		async categoryAddtocartRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryAddtocart().");
			if (e.addtocartSchema == null) throw new J("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling categoryAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Qd(e.addtocartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async categoryAddtocart(e, t) {
			return await (await this.categoryAddtocartRaw(e, t)).value();
		}
		async categoryClickthroughRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryClickthrough().");
			if (e.clickthroughSchema == null) throw new J("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling categoryClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Jp(e.clickthroughSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async categoryClickthrough(e, t) {
			return await (await this.categoryClickthroughRaw(e, t)).value();
		}
		async categoryImpressionRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryImpression().");
			if (e.impressionSchema == null) throw new J("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling categoryImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: tm(e.impressionSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async categoryImpression(e, t) {
			return await (await this.categoryImpressionRaw(e, t)).value();
		}
		async categoryRenderRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryRender().");
			if (e.renderSchema == null) throw new J("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling categoryRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: bh(e.renderSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async categoryRender(e, t) {
			return await (await this.categoryRenderRaw(e, t)).value();
		}
	};
})), Xh, Zh = o((() => {
	Vh(), Ah(), Xh = class extends Rh {
		async chatAddtocartRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling chatAddtocart().");
			if (e.chatAddtocartSchema == null) throw new J("chatAddtocartSchema", "Required parameter \"chatAddtocartSchema\" was null or undefined when calling chatAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: dp(e.chatAddtocartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async chatAddtocart(e, t) {
			return await (await this.chatAddtocartRaw(e, t)).value();
		}
		async chatClickthroughRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling chatClickthrough().");
			if (e.chatClickthroughSchema == null) throw new J("chatClickthroughSchema", "Required parameter \"chatClickthroughSchema\" was null or undefined when calling chatClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Sp(e.chatClickthroughSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async chatClickthrough(e, t) {
			return await (await this.chatClickthroughRaw(e, t)).value();
		}
		async chatFeedbackRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling chatFeedback().");
			if (e.chatFeedbackSchema == null) throw new J("chatFeedbackSchema", "Required parameter \"chatFeedbackSchema\" was null or undefined when calling chatFeedback().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/feedback";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Op(e.chatFeedbackSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async chatFeedback(e, t) {
			return await (await this.chatFeedbackRaw(e, t)).value();
		}
		async chatImpressionRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling chatImpression().");
			if (e.chatImpressionSchema == null) throw new J("chatImpressionSchema", "Required parameter \"chatImpressionSchema\" was null or undefined when calling chatImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Pp(e.chatImpressionSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async chatImpression(e, t) {
			return await (await this.chatImpressionRaw(e, t)).value();
		}
	};
})), Qh, $h = o((() => {
	Vh(), Ah(), Qh = class extends Rh {
		async logPersonalizationRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling logPersonalization().");
			if (e.personalizationLogSchema == null) throw new J("personalizationLogSchema", "Required parameter \"personalizationLogSchema\" was null or undefined when calling logPersonalization().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/personalization";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: km(e.personalizationLogSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async logPersonalization(e, t) {
			return await (await this.logPersonalizationRaw(e, t)).value();
		}
		async logShopifypixelRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling logShopifypixel().");
			if (e.logSchema == null) throw new J("logSchema", "Required parameter \"logSchema\" was null or undefined when calling logShopifypixel().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/shopifypixel";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: dm(e.logSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async logShopifypixel(e, t) {
			return await (await this.logShopifypixelRaw(e, t)).value();
		}
		async logSnapRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling logSnap().");
			if (e.logSchema == null) throw new J("logSchema", "Required parameter \"logSchema\" was null or undefined when calling logSnap().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/snap";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: dm(e.logSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async logSnap(e, t) {
			return await (await this.logSnapRaw(e, t)).value();
		}
	};
})), eg = o((() => {
	Vh(), Ah();
})), tg, ng = o((() => {
	Vh(), Ah(), tg = class extends Rh {
		async orderTransactionRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling orderTransaction().");
			if (e.orderTransactionSchema == null) throw new J("orderTransactionSchema", "Required parameter \"orderTransactionSchema\" was null or undefined when calling orderTransaction().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/order/transaction";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: bm(e.orderTransactionSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async orderTransaction(e, t) {
			return await (await this.orderTransactionRaw(e, t)).value();
		}
	};
})), rg, ig = o((() => {
	Vh(), Ah(), rg = class extends Rh {
		async productPageviewRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling productPageview().");
			if (e.productPageviewSchema == null) throw new J("productPageviewSchema", "Required parameter \"productPageviewSchema\" was null or undefined when calling productPageview().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/product/pageview";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Rm(e.productPageviewSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async productPageview(e, t) {
			return await (await this.productPageviewRaw(e, t)).value();
		}
	};
})), ag, og = o((() => {
	Vh(), Ah(), ag = class extends Rh {
		async recommendationsAddtocartRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsAddtocart().");
			if (e.recommendationsAddtocartSchema == null) throw new J("recommendationsAddtocartSchema", "Required parameter \"recommendationsAddtocartSchema\" was null or undefined when calling recommendationsAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Wm(e.recommendationsAddtocartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async recommendationsAddtocart(e, t) {
			return await (await this.recommendationsAddtocartRaw(e, t)).value();
		}
		async recommendationsClickthroughRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsClickthrough().");
			if (e.recommendationsClickthroughSchema == null) throw new J("recommendationsClickthroughSchema", "Required parameter \"recommendationsClickthroughSchema\" was null or undefined when calling recommendationsClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Xm(e.recommendationsClickthroughSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async recommendationsClickthrough(e, t) {
			return await (await this.recommendationsClickthroughRaw(e, t)).value();
		}
		async recommendationsImpressionRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsImpression().");
			if (e.recommendationsImpressionSchema == null) throw new J("recommendationsImpressionSchema", "Required parameter \"recommendationsImpressionSchema\" was null or undefined when calling recommendationsImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: nh(e.recommendationsImpressionSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async recommendationsImpression(e, t) {
			return await (await this.recommendationsImpressionRaw(e, t)).value();
		}
		async recommendationsRenderRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsRender().");
			if (e.recommendationsRenderSchema == null) throw new J("recommendationsRenderSchema", "Required parameter \"recommendationsRenderSchema\" was null or undefined when calling recommendationsRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: ch(e.recommendationsRenderSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async recommendationsRender(e, t) {
			return await (await this.recommendationsRenderRaw(e, t)).value();
		}
	};
})), sg, cg = o((() => {
	Vh(), Ah(), sg = class extends Rh {
		async searchAddtocartRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling searchAddtocart().");
			if (e.addtocartSchema == null) throw new J("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling searchAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Qd(e.addtocartSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async searchAddtocart(e, t) {
			return await (await this.searchAddtocartRaw(e, t)).value();
		}
		async searchClickthroughRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling searchClickthrough().");
			if (e.clickthroughSchema == null) throw new J("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling searchClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Jp(e.clickthroughSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async searchClickthrough(e, t) {
			return await (await this.searchClickthroughRaw(e, t)).value();
		}
		async searchImpressionRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling searchImpression().");
			if (e.impressionSchema == null) throw new J("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling searchImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: tm(e.impressionSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async searchImpression(e, t) {
			return await (await this.searchImpressionRaw(e, t)).value();
		}
		async searchRedirectRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling searchRedirect().");
			if (e.redirectSchema == null) throw new J("redirectSchema", "Required parameter \"redirectSchema\" was null or undefined when calling searchRedirect().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/redirect";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: mh(e.redirectSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async searchRedirect(e, t) {
			return await (await this.searchRedirectRaw(e, t)).value();
		}
		async searchRenderRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling searchRender().");
			if (e.renderSchema == null) throw new J("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling searchRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: bh(e.renderSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async searchRender(e, t) {
			return await (await this.searchRenderRaw(e, t)).value();
		}
	};
})), lg, ug = o((() => {
	Vh(), Ah(), lg = class extends Rh {
		async loginRaw(e, t) {
			if (e.siteId == null) throw new J("siteId", "Required parameter \"siteId\" was null or undefined when calling login().");
			if (e.shopperLoginSchema == null) throw new J("shopperLoginSchema", "Required parameter \"shopperLoginSchema\" was null or undefined when calling login().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/shopper/login";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Eh(e.shopperLoginSchema)
			}, t);
			return new Y(a, (e) => im(e));
		}
		async login(e, t) {
			return await (await this.loginRaw(e, t)).value();
		}
	};
})), dg = o((() => {
	Uh(), Gh(), qh(), Yh(), Zh(), $h(), eg(), ng(), ig(), og(), cg(), ug();
})), fg, pg, mg, hg, gg, _g, vg, yg, bg, xg, Sg, Cg, wg, Tg, Eg = o((() => {
	fg = "@athoscommerce/beacon", pg = "1.2.0", mg = "athoscommerce", hg = "Javascript library for utilizing Athos Commerce beacon tracking.", gg = "dist/cjs/src/index.js", _g = "dist/esm/src/index.js", vg = {
		type: "git",
		url: "https://github.com/AthosCommerce/beacon.js.git"
	}, yg = "@searchspring/prettier", bg = {
		build: "rm -rf ./dist && npm run generate && tsc && tsc -p tsconfig.cjs.json && npm run build:cdn",
		"build:cdn": "webpack --config webpack.prod.js",
		dev: "tsc --watch & webpack serve --config webpack.dev.js",
		commit: "cz",
		test: "jest",
		"test:watch": "jest --watch",
		generate: "rm -fr ./src/client && openapi-generator-cli generate -i ./beacon.v2.snap.types.oas.yaml -g typescript-fetch -o ./src/client && npm run format",
		format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
		lint: "eslint src --ext .ts,.tsx",
		prepare: "husky",
		version: "standard-version -a",
		postpublish: "git push && git push --tags"
	}, xg = { uuid: "9.0.1" }, Sg = {
		"@babel/core": "^7.21.4",
		"@babel/preset-env": "^7.21.4",
		"@babel/runtime": "^7.21.0",
		"@openapitools/openapi-generator-cli": "^2.25.2",
		"@searchspring/browserslist-config-snap": "^1.0.7",
		"@searchspring/prettier": "1.0.2",
		"@types/jest": "^29.5.14",
		"@types/uuid": "^10.0.0",
		"babel-loader": "^9.1.2",
		"cz-conventional-changelog": "3.3.0",
		eslint: "9.23.0",
		"eslint-config-prettier": "10.1.1",
		husky: "9.1.7",
		jest: "29.7.0",
		"jest-environment-jsdom": "^29.7.0",
		jsdom: "26.0.0",
		"lint-staged": "15.5.0",
		prettier: "3.5.3",
		"standard-version": "9.5.0",
		"ts-jest": "^29.3.0",
		"ts-loader": "9.4.2",
		typedoc: "0.28.1",
		typescript: "5.8.2",
		"typescript-eslint": "^8.55.0",
		webpack: "^5.77.0",
		"webpack-cli": "^5.0.1",
		"webpack-dev-server": "^4.13.2",
		"webpack-merge": "^5.8.0",
		"whatwg-fetch": "^3.6.20"
	}, Cg = { commitizen: { path: "./node_modules/cz-conventional-changelog" } }, wg = { universal: "extends @searchspring/browserslist-config-snap/universal" }, Tg = {
		name: fg,
		version: pg,
		author: mg,
		license: "MIT",
		description: hg,
		main: gg,
		module: _g,
		repository: vg,
		prettier: yg,
		scripts: bg,
		dependencies: xg,
		devDependencies: Sg,
		"lint-staged": { "*.{js,ts,tsx}": ["prettier --write", "eslint"] },
		config: Cg,
		browserslist: wg
	};
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/utils/featureFlags.js
function Dg() {
	return {
		cookies: function() {
			return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
		},
		storage: function() {
			let e = "ss-test";
			if (typeof window > "u") return !1;
			try {
				return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
			} catch {
				return !1;
			}
		}
	};
}
var Og, kg, Ag = o((() => {
	Og = Dg(), kg = {
		cookies: Og.cookies(),
		storage: Og.storage()
	};
})), jg, Mg = o((() => {
	jg = (e, t, n, r, i) => {
		let a = window.location.protocol == "https:" ? "Secure;" : "", o = "SameSite=" + (n || "Lax") + ";", s = "";
		if (r) {
			let e = /* @__PURE__ */ new Date();
			e.setTime(e.getTime() + r), s = "expires=" + e.toUTCString() + ";";
		}
		let c = encodeURIComponent(t) + ";";
		if (i) return e + "=" + c + s + o + a + "path=/; domain=" + i;
		let l = window?.location?.hostname;
		if (!l || l.split(".").length === 1) return e + "=" + c + s + o + a + "path=/";
		let u = l.split(".");
		return u.shift(), i = "." + u.join("."), e + "=" + c + s + o + a + "path=/; domain=" + i;
	};
})), Ng = o((() => {
	Ag(), Mg();
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/rng.js
function Pg() {
	if (!Fg && (Fg = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Fg)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return Fg(Ig);
}
var Fg, Ig, Lg = o((() => {
	Ig = /* @__PURE__ */ new Uint8Array(16);
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/stringify.js
function Rg(e, t = 0) {
	return zg[e[t + 0]] + zg[e[t + 1]] + zg[e[t + 2]] + zg[e[t + 3]] + "-" + zg[e[t + 4]] + zg[e[t + 5]] + "-" + zg[e[t + 6]] + zg[e[t + 7]] + "-" + zg[e[t + 8]] + zg[e[t + 9]] + "-" + zg[e[t + 10]] + zg[e[t + 11]] + zg[e[t + 12]] + zg[e[t + 13]] + zg[e[t + 14]] + zg[e[t + 15]];
}
var zg, Bg = o((() => {
	zg = [];
	for (let e = 0; e < 256; ++e) zg.push((e + 256).toString(16).slice(1));
})), Vg, Hg, Ug = o((() => {
	Vg = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Hg = { randomUUID: Vg };
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/v4.js
function Wg(e, t, n) {
	if (Hg.randomUUID && !t && !e) return Hg.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || Pg)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return Rg(r);
}
var Gg = o((() => {
	Ug(), Lg(), Bg();
})), Kg = o((() => {
	Lg(), Bg(), Gg();
})), qg = o((() => {
	Vh(), dg(), Ah();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/Beacon.js
function Jg(e, t, n, r) {
	if (!e.batches[t]) e.batches[t] = JSON.parse(JSON.stringify(r));
	else {
		let i = e.batches[t].payload, a = r.payload, o = i[n], s = a[n];
		if (s?.data?.results) {
			let e = o.data.results || [], t = s.data.results, n = [...e, ...t];
			o.data.results = n;
		}
		if (s?.data?.banners) {
			let e = o?.data?.banners || [], t = s.data.banners, n = [...e, ...t];
			o.data.banners = n;
		}
	}
}
function Yg(e, t) {
	let n = "";
	return n += `||${t.context.pageLoadId}`, n += `||${t.context.sessionId}`, t.data?.chatSessionId ? n += `||chatSessionId=${t.data.chatSessionId}||responseId=${t.data.responseId}` : t.data?.responseId ? n += `||responseId=${t.data.responseId}` : e === "shopper" && t.context.shopperId && (n += `||shopperId=${t.context.shopperId}`), (e === "recommendation" || e === "bundle") && (n += `||tag=${t.data.tag}`), n;
}
function Xg(e) {
	if (typeof window < "u" && kg.cookies) {
		let t = e + "=", n = window.document.cookie.split(";");
		for (let e = 0; e < n.length; e++) {
			let r = n[e];
			for (; r.charAt(0) == " ";) r = r.substring(1);
			if (r.indexOf(t) == 0) return decodeURIComponent(r.substring(t.length, r.length));
		}
		return "";
	}
	return "";
}
function Zg(e, t) {
	let n = m_[e];
	return t.trim().toLowerCase().startsWith("at") ? [n.primary, n.legacy] : [n.legacy, n.primary];
}
function Qg(e, t) {
	let n = m_[e];
	return t.trim().toLowerCase().startsWith("at") ? [n.primary] : [n.legacy];
}
function $g(e) {
	let t = m_[e];
	typeof window < "u" && (window.localStorage?.removeItem(t.primary), window.localStorage?.removeItem(t.legacy));
}
function e_(e, t, n, r) {
	if (e instanceof Error && e.name === "QuotaExceededError") {
		let e = m_[n];
		t.events.error.snap({ data: {
			message: "QuotaExceededError",
			details: {
				key: e.legacy,
				keyPrimary: e.primary,
				value: r
			}
		} });
	}
}
var t_, n_, r_, i_, a_, o_, s_, c_, l_, u_, d_, f_, p_, m_, h_, g_ = o((() => {
	Eg(), Ng(), Kg(), qg(), dg(), {version: t_} = Tg, n_ = 47304e6, r_ = 18e5, i_ = 20, a_ = -1, o_ = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, s_ = "userId", c_ = "pageLoadId", l_ = "sessionId", u_ = "shopperId", d_ = "cartProducts", f_ = "viewedProducts", p_ = "attribution", m_ = {
		[s_]: {
			primary: "athosUserId",
			legacy: "ssUserId"
		},
		[c_]: {
			primary: "athosPageLoadId",
			legacy: "ssPageLoadId"
		},
		[l_]: {
			primary: "athosSessionId",
			legacy: "ssSessionId"
		},
		[u_]: {
			primary: "athosShopperId",
			legacy: "ssShopperId"
		},
		[d_]: {
			primary: "athosCartProducts",
			legacy: "ssCartProducts"
		},
		[f_]: {
			primary: "athosViewedProducts",
			legacy: "ssViewedProducts"
		},
		[p_]: {
			primary: "athosAttribution",
			legacy: "ssAttribution"
		}
	}, h_ = class {
		constructor(e, t) {
			if (this.mode = "production", this.pageLoadId = "", this.userId = "", this.sessionId = "", this.shopperId = "", this.currency = { code: "" }, this.initiator = "", this.batchIntervalTimeout = 0, this.preflightTimeout = 0, this.requests = [], this.storage = {
				cart: {
					get: () => {
						let e = this.getLocalStorageItem(d_);
						if (e) try {
							if (Array.isArray(e)) return e;
						} catch {
							$g(d_), this.setCookie(d_, "", "Lax", 0, o_);
						}
						else return this.getCookie(d_).split(",").filter((e) => e).map((e) => ({
							parentId: e,
							uid: e,
							sku: e,
							qty: 1,
							price: 0
						}));
						return [];
					},
					set: (e) => {
						let t = this.storage.cart.get(), n = JSON.stringify(e);
						try {
							this.setLocalStorageItem(d_, e);
						} catch (e) {
							e_(e, this, d_, n);
						}
						let r = e.map((e) => this.getProductId(e)).join(",");
						this.setCookie(d_, r, "Lax", 0, o_), JSON.stringify(t) !== n && this._sendPreflight();
					},
					add: (e) => {
						if (e.length) {
							let t = [...this.storage.cart.get()];
							e.filter((e) => typeof e == "object" && e.uid).reverse().forEach((e) => {
								let n = t.find((t) => t.uid === e.uid);
								n ? (n.qty += e.qty, n.price = e.price || n.price, (e.parentId !== n.parentId || e.sku !== n.sku) && (n.parentId = e.parentId, n.sku = e.sku)) : t.unshift(e);
							}), this.storage.cart.set(t);
						}
					},
					remove: (e) => {
						if (e.length) {
							let t = [...this.storage.cart.get()];
							e.forEach((e) => {
								let n = t.find((t) => t.uid === e.uid);
								n && n.qty > 0 && (n.qty -= e.qty || 1, (e.parentId !== n.parentId || e.sku !== n.sku) && (n.parentId = e.parentId, n.sku = e.sku));
							});
							let n = t.filter((e) => e.qty > 0);
							this.storage.cart.set(n);
						}
					},
					clear: () => {
						this.storage.cart.set([]);
					}
				},
				viewed: {
					get: () => {
						let e = this.getLocalStorageItem(f_);
						if (e) try {
							if (Array.isArray(e)) return e;
						} catch {
							$g(f_), this.setCookie(f_, "", "Lax", n_, o_);
						}
						else return this.getCookie(f_).split(",").filter((e) => e).map((e) => ({
							parentId: e,
							uid: e,
							sku: e
						}));
						return [];
					},
					set: (e) => {
						let t = this.storage.viewed.get(), n = e.map((e) => ({
							sku: e.sku,
							parentId: e.parentId,
							uid: e.uid
						})).slice(0, i_), r = JSON.stringify(n);
						try {
							this.setLocalStorageItem(f_, n);
						} catch (e) {
							e_(e, this, f_, r);
						}
						let i = n.map((e) => this.getProductId(e)).join(",");
						this.setCookie(f_, i, "Lax", n_, o_), JSON.stringify(t) !== r && this._sendPreflight();
					},
					add: (e) => {
						if (e.length) {
							let t = this.storage.viewed.get();
							e.forEach((e) => {
								let n = {
									sku: e.sku,
									parentId: e.parentId,
									uid: e.uid
								}, r = t.find((e) => e.uid === n.uid);
								if (r) {
									let e = t.indexOf(r);
									t.splice(e, 1);
								}
								t.unshift(n);
							}), this.storage.viewed.set(t);
						}
					}
				}
			}, this.events = {
				shopper: { login: (e) => {
					let t = this.getContext();
					if (!t.shopperId || t.shopperId !== e.data.id) {
						this.setShopperId(e.data.id);
						return;
					}
					if (t.shopperId = e.data?.id, e.data?.id) {
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							shopperLoginSchema: { context: t }
						}, r = this.createRequest("shopper", "login", n);
						this.queueRequest(r);
					}
				} },
				autocomplete: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteClickthrough", t);
						this.sendRequests([n]);
					},
					redirect: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							redirectSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteRedirect", t);
						this.sendRequests([n]);
					}
				},
				search: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchClickthrough", t);
						this.sendRequests([n]);
					},
					redirect: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							redirectSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchRedirect", t);
						this.sendRequests([n]);
					}
				},
				category: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryClickthrough", t);
						this.sendRequests([n]);
					}
				},
				bundles: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesRenderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesClickthrough", t);
						this.sendRequests([n]);
					}
				},
				chat: {
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatClickthrough", t);
						this.sendRequests([n]);
					},
					feedback: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatFeedbackSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatFeedback", t);
						this.sendRequests([n]);
					}
				},
				recommendations: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsRenderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsClickthrough", t);
						this.sendRequests([n]);
					}
				},
				product: { pageView: (e) => {
					let t = {
						siteId: e?.siteId || this.globals.siteId,
						productPageviewSchema: {
							context: this.getContext(),
							data: e.data
						}
					}, n = this.createRequest("product", "productPageview", t);
					this.sendRequests([n]);
					let r = e.data.result;
					this.storage.viewed.add([r]);
				} },
				cart: {
					add: (e) => {
						let t = { ...e.data };
						t.cart ? this.storage.cart.set(t.cart) : (t.results && this.storage.cart.add(t.results), t.cart = this.storage.cart.get());
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							cartSchema: {
								context: this.getContext(),
								data: t
							}
						}, r = this.createRequest("cart", "cartAdd", n);
						this.sendRequests([r]);
					},
					remove: (e) => {
						let t = { ...e.data };
						t.cart ? this.storage.cart.set(t.cart) : (t.results && this.storage.cart.remove(t.results), t.cart = this.storage.cart.get());
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							cartSchema: {
								context: this.getContext(),
								data: t
							}
						}, r = this.createRequest("cart", "cartRemove", n);
						this.sendRequests([r]);
					}
				},
				order: { transaction: (e) => {
					let t = {
						siteId: e?.siteId || this.globals.siteId,
						orderTransactionSchema: {
							context: this.getContext(),
							data: e.data
						}
					}, n = this.createRequest("order", "orderTransaction", t);
					this.sendRequests([n]), this.storage.cart.clear();
				} },
				error: {
					shopifypixel: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							logSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("error", "logShopifypixel", t);
						this.sendRequests([n]);
					},
					snap: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							logSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("error", "logSnap", t);
						this.sendRequests([n]);
					}
				}
			}, typeof e != "object" || typeof e.siteId != "string") throw Error("Invalid config passed to tracker. The \"siteId\" attribute must be provided.");
			this.config = {
				mode: "production",
				...t || {}
			}, this.config.mode && ["production", "development"].includes(this.config.mode) && (this.mode = this.config.mode);
			let n = this.config.apis?.fetch, r = `${e.siteId}`.trim().toLowerCase().startsWith("at") ? "athos" : "searchspring", i = r === "searchspring" ? "https://analytics.searchspring.net/beacon/v2" : void 0, a = new Ih({
				fetchApi: n,
				basePath: this.config.requesters?.beacon?.origin || i,
				headers: { "Content-Type": "text/plain" }
			});
			if (this.apis = {
				shopper: new lg(a),
				autocomplete: new Hh(a),
				search: new sg(a),
				category: new Jh(a),
				recommendations: new ag(a),
				bundles: new Wh(a),
				chat: new Xh(a),
				product: new rg(a),
				cart: new Kh(a),
				order: new tg(a),
				error: new Qh(a)
			}, this.initiator = this.config.initiator || `${r}/beaconjs/${t_}`, this.globals = e, this.pageLoadId = this.getPageLoadId(), this.globals?.siteId) this.globals.siteId = `${this.globals.siteId}`.trim().toLowerCase();
			else throw Error("Beacon: No siteId found in globals. Beacon will not initialize.");
		}
		setCookie(e, t, n, r, i) {
			kg.cookies && Qg(e, this.globals.siteId).forEach((e) => {
				try {
					if (window.document.cookie = jg(e, t, n, r, i), Xg(e) == null || Xg(e) != t) {
						let i = "." + window.location.hostname;
						window.document.cookie = jg(e, t, n, r, i);
					}
				} catch (t) {
					console.error(`Failed to set '${e}' cookie:`, t);
				}
			});
		}
		getLocalStorageItem(e) {
			let t = Zg(e, this.globals.siteId);
			if (typeof window < "u" && kg.storage) {
				let e = "";
				for (let n of t) {
					let t = window.localStorage.getItem(n);
					if (t) {
						e = t;
						break;
					}
				}
				try {
					let n = JSON.parse(e);
					if (n && n.value) return n.value;
					t.forEach((e) => {
						window.localStorage.removeItem(e);
					});
				} catch {}
			}
		}
		setLocalStorageItem(e, t) {
			let n = Qg(e, this.globals.siteId);
			if (typeof window < "u" && kg.storage) try {
				let e = JSON.stringify({ value: t });
				n.forEach((t) => {
					window.localStorage.setItem(t, e);
				});
			} catch (t) {
				throw console.warn(`Something went wrong setting local storage item '${e}':`, t), t;
			}
		}
		getCookie(e) {
			let t = Zg(e, this.globals.siteId);
			for (let e of t) {
				let t = Xg(e);
				if (t) return t;
			}
			return "";
		}
		queueRequest(e) {
			this.requests.push(e), clearTimeout(this.batchIntervalTimeout), this.batchIntervalTimeout = setTimeout(() => {
				this.processRequests();
			}, 300);
		}
		updateContext(e, t) {
			if (t !== void 0) switch (e) {
				case s_:
				case l_:
				case u_:
				case c_:
				case p_:
					this[e] = t;
					break;
				case "pageUrl":
					this.config.href = t;
					break;
				case "userAgent":
					this.config.userAgent = t;
					break;
				case "dev": ["production", "development"].includes(t) && (this.mode = t);
			}
		}
		getContext() {
			let e = {
				userAgent: this.config.userAgent,
				timestamp: this.getTimestamp(),
				pageUrl: this.config.href || typeof window < "u" && window.location.href || "",
				userId: this.userId || this.getUserId(),
				sessionId: this.sessionId || this.getSessionId(),
				pageLoadId: this.pageLoadId,
				shopperId: this.shopperId || this.getShopperId(),
				initiator: this.initiator,
				dev: this.mode === "development" || void 0,
				attribution: this.attribution || this.getAttribution()
			};
			return this.currency.code && (e.currency = { ...this.currency }), e;
		}
		getStoredId(e, t) {
			let n = "", r = "";
			try {
				r = this.getCookie(e);
				let i = this.getLocalStorageItem(e);
				i.timestamp && new Date(i.timestamp).getTime() < Date.now() - t ? (n = this.generateId(), this.attribution = void 0) : n = i.value;
			} catch {}
			let i = {
				value: r || n || this.generateId(),
				timestamp: this.getTimestamp()
			};
			e === "userId" && (this.userId = i.value), e === l_ && (this.sessionId = i.value), this.setCookie(e, i.value, "Lax", a_, o_), this.setCookie(e, i.value, "Lax", t);
			try {
				this.setLocalStorageItem(e, i);
			} catch (t) {
				e_(t, this, e, i.value);
			}
			return i.value;
		}
		getPageLoadId() {
			if (this.pageLoadId) return this.pageLoadId;
			let e = this.generateId(), t = this.getLocalStorageItem(c_), n = this.config.href || typeof window < "u" && window.location.href || "";
			if (t) {
				let { href: r, value: i, timestamp: a } = t;
				r === n && i && a && new Date(a).getTime() > Date.now() - 1e4 && (e = i);
			}
			this.pageLoadId = e;
			try {
				this.setLocalStorageItem(c_, {
					href: n,
					value: e,
					timestamp: this.getTimestamp()
				});
			} catch (t) {
				e_(t, this, c_, e);
			}
			return e;
		}
		getUserId() {
			return this.userId || this.getStoredId("userId", n_);
		}
		getSessionId() {
			return this.sessionId || this.getStoredId(l_, r_);
		}
		getShopperId() {
			try {
				let e = this.getCookie(u_), t = this.getLocalStorageItem(u_), n = e || (t ? "" + t : void 0);
				n && (this.shopperId = n);
			} catch {}
			return this.shopperId || "";
		}
		setShopperId(e) {
			if (!e) return;
			let t = this.getShopperId();
			this.shopperId = "" + e, this.setCookie(u_, this.shopperId, "Lax", n_, o_);
			try {
				this.setLocalStorageItem(u_, this.shopperId);
			} catch (e) {
				e_(e, this, u_, this.shopperId);
			}
			t !== e && (this.events.shopper.login({ data: { id: this.shopperId } }), this._sendPreflight());
		}
		getAttribution() {
			let e = [], t = null;
			try {
				let e = new URL(this.config.href || typeof window < "u" && window.location.href || "");
				t = e.searchParams.get("athos_attribution") || e.searchParams.get("ss_attribution");
			} catch {}
			let n = this.getCookie(p_) || this.getLocalStorageItem(p_);
			if (n) try {
				typeof n == "string" ? e = JSON.parse(n) : Array.isArray(n) && (e = n);
			} catch {}
			if (t) try {
				let [n, r] = decodeURIComponent(t).split(":");
				n && r && !e.find((e) => e.type === n && e.id === r) && e.unshift({
					type: n,
					id: r
				});
			} catch {}
			if (e.length) {
				let t = JSON.stringify(e);
				this.setCookie(p_, t, "Lax", r_, o_);
				try {
					this.setLocalStorageItem(p_, e);
				} catch (e) {
					e_(e, this, p_, t);
				}
				return this.attribution = e, [...e];
			}
		}
		generateId() {
			return Wg();
		}
		getTimestamp() {
			return (/* @__PURE__ */ new Date()).toISOString();
		}
		setCurrency(e) {
			e && e.code && this.currency?.code !== e.code && (this.currency = e);
		}
		pageLoad() {
			return this.pageLoadId = this.generateId(), this.pageLoadId;
		}
		createRequest(e, t, n) {
			return {
				apiType: e,
				endpoint: t,
				payload: n
			};
		}
		getApiClient(e) {
			return this.apis[e];
		}
		sendRequests(e) {
			for (let t of e) this.getApiClient(t.apiType)[t.endpoint](t.payload, async ({ init: e }) => {
				let t = {
					...e.headers,
					...this.config.requesters?.beacon?.headers || {}
				}, n = t && "Content-Type" in t && t["Content-Type"] === "application/json";
				return {
					keepalive: this.mode === "production" || void 0,
					body: n ? e.body : JSON.stringify(e.body),
					headers: t
				};
			}).catch((e) => {
				this.mode === "development" && console.debug(e);
			});
		}
		processRequests() {
			let e = this.requests.reduce((e, t) => {
				let n = `${t.payload.siteId}||${t.endpoint}`;
				switch (t.endpoint) {
					case "recommendationsAddtocart": {
						let r = t.payload.recommendationsAddtocartSchema;
						n += Yg("recommendation", r), Jg(e, n, "recommendationsAddtocartSchema", t);
						break;
					}
					case "recommendationsImpression": {
						let r = t.payload.recommendationsImpressionSchema;
						n += Yg("recommendation", r), Jg(e, n, "recommendationsImpressionSchema", t);
						break;
					}
					case "bundlesAddtocart": {
						let r = t.payload.bundlesAddtocartSchema;
						n += Yg("bundle", r), Jg(e, n, "bundlesAddtocartSchema", t);
						break;
					}
					case "bundlesImpression": {
						let r = t.payload.bundlesImpressionSchema;
						n += Yg("bundle", r), Jg(e, n, "bundlesImpressionSchema", t);
						break;
					}
					case "chatAddtocart": {
						let r = t.payload.chatAddtocartSchema;
						n += Yg("chat", r), Jg(e, n, "chatAddtocartSchema", t);
						break;
					}
					case "chatImpression": {
						let r = t.payload.chatImpressionSchema;
						n += Yg("chat", r), Jg(e, n, "chatImpressionSchema", t);
						break;
					}
					case "searchAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Yg("search", r), Jg(e, n, "addtocartSchema", t);
						break;
					}
					case "searchImpression": {
						let r = t.payload.impressionSchema;
						n += Yg("search", r), Jg(e, n, "impressionSchema", t);
						break;
					}
					case "autocompleteAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Yg("autocomplete", r), Jg(e, n, "addtocartSchema", t);
						break;
					}
					case "autocompleteImpression": {
						let r = t.payload.impressionSchema;
						n += Yg("autocomplete", r), Jg(e, n, "impressionSchema", t);
						break;
					}
					case "categoryAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Yg("category", r), Jg(e, n, "addtocartSchema", t);
						break;
					}
					case "categoryImpression": {
						let r = t.payload.impressionSchema;
						n += Yg("category", r), Jg(e, n, "impressionSchema", t);
						break;
					}
					case "login": {
						let r = t.payload.shopperLoginSchema;
						n += Yg("shopper", r), Jg(e, n, "shopperLoginSchema", t);
						break;
					}
					default: e.nonBatched.push(t);
				}
				return e;
			}, {
				nonBatched: [],
				batches: {}
			});
			this.requests = [];
			let t = Object.values(e.batches).reduce((e, t) => (e.push(t), e), e.nonBatched);
			this.sendRequests(t);
		}
		_sendPreflight() {
			clearTimeout(this.preflightTimeout), this.preflightTimeout = setTimeout(() => {
				this.sendPreflight();
			}, 300);
		}
		sendPreflight(e) {
			let t = e?.userId || this.getUserId(), n = e?.siteId || this.globals.siteId, r = e?.shopper || this.getShopperId(), i = e?.cart || this.storage.cart.get(), a = e?.lastViewed || this.storage.viewed.get();
			if (t && typeof t == "string" && n) {
				let e = {
					userId: t,
					siteId: n
				};
				r && (e.shopper = r), i.length && (e.cart = i.map((e) => this.getProductId(e))), a.length && (e.lastViewed = a.map((e) => this.getProductId(e)));
				let o = `${n}`.toLowerCase().startsWith("at") ? "athoscommerce.net" : "searchspring.io", s = `${this.config.requesters?.personalization?.origin || `https://${n}.a.${o}`}/v1/preflight`;
				(this.config.apis?.fetch || typeof fetch < "u") && (this.config.apis?.fetch || fetch)(s, {
					method: "POST",
					headers: {
						"Content-Type": "text/plain",
						...this.config.requesters?.personalization?.headers || {}
					},
					body: JSON.stringify(e),
					keepalive: !0
				});
			}
		}
		getProductId(e) {
			return `${e.sku || e.uid || ""}`.trim();
		}
	};
})), __ = o((() => {
	Ah(), dg(), Vh(), g_();
})), v_, y_, b_, x_ = o((() => {
	v_ = /* @__PURE__ */ u(U()), Iu(), __(), y_ = {
		id: "track",
		framework: "snap",
		mode: ku.production
	}, b_ = class extends h_ {
		constructor(e, t) {
			if (t = (0, v_.default)(y_, t || {}), t.initiator || (t.initiator = `athos/${t.framework}/${Su}`), typeof e != "object" || typeof e.siteId != "string") throw Error("Invalid config passed to tracker. The \"siteId\" attribute must be provided.");
			super(e, t), this.targeters = [], this.track = {
				error: (e, t) => {
					if (this.doNotTrack?.includes("error") || this.mode === ku.development || !e?.stack && !e?.message) return;
					let { stack: n, message: r, ...i } = e, { pageUrl: a } = this.getContext();
					r?.includes("Profile is currently paused") || a.includes("//localhost") || a.includes("//snapui.searchspring.io/") || a.includes("//snapui.athoscommerce.io/") || this.events.error.snap({
						data: {
							message: r || "unknown",
							stack: n,
							details: i
						},
						siteId: t
					});
				},
				shopper: { login: (e, t) => {
					this.doNotTrack?.includes("shopper.login") || this.events.shopper.login({
						data: { id: e.id },
						siteId: t
					});
				} },
				product: {
					view: (e, t) => {
						if (this.doNotTrack?.includes("product.view")) return;
						let n = { result: {
							parentId: e.parentId || e.uid || "",
							uid: e.uid || e.parentId || e.sku || "",
							sku: e.sku
						} };
						(e.childSku || e.childUid) && (n = { result: {
							parentId: e.parentId || e.uid || e.childUid || "",
							uid: e.childUid || e.uid || "",
							sku: e.childSku || e.sku
						} }), this.events.product.pageView({
							data: n,
							siteId: t
						});
					},
					click: () => {
						console.warn("tracker.track.product.click() is deprecated and is no longer functional. Use tracker.events['search' | 'category'].clickThrough() instead"), this.events.error.snap({ data: { message: "tracker.track.product.click was called" } });
					}
				},
				cart: { view: () => {
					console.warn("tracker.cart.view is deprecated and no longer functional. Use tracker.events.cart.add() and tracker.events.cart.remove() instead"), this.events.error.snap({ data: { message: "tracker.track.cart.view was called" } });
				} },
				order: { transaction: (e, t) => {
					if (this.doNotTrack?.includes("order.transaction")) return;
					let n = e.order, r = e.items, i = {
						orderId: `${n?.id || ""}`,
						transactionTotal: Number(n?.transactionTotal || 0),
						total: Number(n?.total || 0),
						city: n?.city,
						state: n?.state,
						country: n?.country,
						results: r.map((e) => ({
							parentId: e.parentId || e.uid || "",
							uid: e.uid || e.parentId || e.sku || "",
							sku: e.sku,
							qty: Number(e.qty),
							price: Number(e.price)
						}))
					};
					this.events.order.transaction({
						data: i,
						siteId: t
					});
				} }
			}, this.cookies = {
				cart: {
					get: () => this.storage.cart.get().map((e) => this.getProductId(e)),
					set: (e) => {
						let t = e.map((e) => `${e}`.trim()), n = Array.from(new Set(t)).map((e) => ({
							parentId: e,
							uid: e,
							sku: e,
							price: 0,
							qty: 1
						}));
						this.storage.cart.set(n);
					},
					add: (e) => {
						if (e.length) {
							let t = e.map((e) => `${e}`.trim()).map((e) => ({
								parentId: e,
								uid: e,
								sku: e,
								price: 0,
								qty: 1
							}));
							this.storage.cart.add(t);
						}
					},
					remove: (e) => {
						if (e.length) {
							let t = e.map((e) => `${e}`.trim()).map((e) => ({
								parentId: e,
								uid: e,
								sku: e,
								price: 0,
								qty: 1
							}));
							this.storage.cart.remove(t);
						}
					},
					clear: () => {
						this.storage.cart.clear();
					}
				},
				viewed: { get: () => this.storage.viewed.get().map((e) => this.getProductId(e)) }
			}, this.config = t, this.doNotTrack = this.config.doNotTrack || [], Object.values(ku).includes(this.config.mode) && (this.mode = this.config.mode), this.localStorage = new Eu({
				type: "local",
				key: `athos-${this.config.id}`
			}), this.localStorage.set("siteId", this.globals.siteId);
			let n = this.globals?.currency;
			n && this.setCurrency(n), window.athos?.tracker || (window.athos = window.athos || {}, window.athos.tracker = this, window.athos.version = Su), setTimeout(() => {
				this.targeters.push(new Vl([{
					selector: "script[type^=\"athos/track/\"], script[type^=\"searchspring/track/\"]",
					emptyTarget: !1
				}], (e, t) => {
					let { item: n, items: r, siteId: i, shopper: a, order: o, type: s, currency: c } = tu([
						"item",
						"items",
						"siteId",
						"shopper",
						"order",
						"type",
						"currency"
					], t);
					switch (this.setCurrency(c), s) {
						case "searchspring/track/shopper/login":
						case "athos/track/shopper/login":
							this.track.shopper.login(a, i);
							break;
						case "searchspring/track/product/view":
						case "athos/track/product/view":
							this.track.product.view(n, i);
							break;
						case "searchspring/track/cart/view":
						case "athos/track/cart/view":
							this.track.cart.view();
							break;
						case "searchspring/track/order/transaction":
						case "athos/track/order/transaction":
							this.track.order.transaction({
								order: o,
								items: r
							}, i);
							break;
						default: console.error(`event '${s}' is not supported`);
					}
				}));
			});
			let r = this.globals.cart;
			if (Array.isArray(r)) {
				if (r.length === 0) {
					let e = this.storage.cart.get();
					e.length && this.events.cart.remove({ data: {
						results: e,
						cart: []
					} }), this.storage.cart.clear();
				} else if (r.length) {
					let e = r.filter((e) => typeof e == "object" && (e.parentId || e.uid || e.sku) && e.qty !== void 0 && e.price !== void 0).map((e) => ({
						parentId: e.parentId || e.uid,
						uid: e.uid,
						sku: e.sku,
						price: e.price,
						qty: e.qty
					}));
					e.length || this.events.error.snap({ data: {
						message: "cart globals missing properties",
						details: { cart: r }
					} });
					let t = this.storage.cart.get(), n = [], i = [];
					!t?.length && e.length ? n.push(...e) : e.length && (e.forEach((e) => {
						let r = t.find((t) => t.parentId === e.parentId && t.uid === e.uid && t.sku === e.sku);
						if (!r) n.push(e);
						else if (r) {
							e.qty > r.qty ? n.push({
								...e,
								qty: e.qty - r.qty
							}) : e.qty < r.qty && i.push({
								...r,
								qty: r.qty - e.qty
							});
							let a = t.indexOf(r);
							a !== -1 && t.splice(a, 1);
						}
					}), t.length && i.push(...t)), n.length && this.events.cart.add({ data: {
						results: n,
						cart: e
					} }), i.length && this.events.cart.remove({ data: {
						results: i,
						cart: e
					} });
				}
			}
		}
		getGlobals() {
			return JSON.parse(JSON.stringify(this.globals));
		}
		retarget() {
			this.targeters.forEach((e) => {
				e.retarget();
			});
		}
	};
})), S_ = o((() => {})), C_ = o((() => {
	x_(), S_();
})), w_, T_ = o((() => {
	kl(), w_ = class {
		constructor(e) {
			this.custom = {}, this.loading = !1, this.loaded = !1, this.config = e, ss(this, {
				custom: K,
				loading: K,
				loaded: K,
				config: K
			});
		}
		setConfig(e) {
			this.config = e;
		}
		toJSON(e = this) {
			return Zo(e);
		}
	};
})), E_, D_, O_, k_ = o((() => {
	(function(e) {
		e.HEADER = "header", e.BANNER = "banner", e.FOOTER = "footer", e.LEFT = "left", e.INLINE = "inline";
	})(E_ ||= {}), D_ = class {
		constructor(e) {
			this.redirect = "", this.responseId = "", this.content = {}, this.campaigns = [], this.personalized = !1, this.experiments = [];
			let { merchandising: t } = e?.data?.search || {};
			t && (this.redirect = t.redirect || "", this.responseId = e?.data?.search?.tracking?.responseId || e?.data?.tracking?.responseId || "", t.content && Object.values(E_).forEach((e) => {
				if (t.content && t.content[e]) {
					let n = t.content[e]?.[0] || "", r = typeof n == "string" && n.match(/data-banner-id="(\d+)"/), i = r ? r[1] : "";
					this.content[e] = new O_([{
						value: t.content[e],
						uid: i,
						responseId: this.responseId
					}]);
				}
			}), t.campaigns && (this.campaigns = t.campaigns, t.campaigns.forEach((e) => {
				e.type == "landing-page" && (this.landingPage = e);
			})), t.experiments && (this.experiments = t.experiments), this.personalized = !!t.personalized);
		}
	}, O_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			super(...e);
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Search/Stores/SearchFacetStore.js
function A_(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var j_, M_, N_, P_, F_, I_, L_, R_, z_ = o((() => {
	j_ = /* @__PURE__ */ u(U()), kl(), M_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = e?.config || {}, { services: n, stores: r, data: i } = e || {}, { search: a, meta: o } = i || {}, { facets: s, merchandising: c, pagination: l } = a || {}, { storage: u } = r || {}, d = s?.filter((e) => {
				let n = e.field && o.facets && o.facets[e.field];
				if (!n || n.display == "slider" && e.type !== "range" || e.type == "range" && n.display !== "slider") return !1;
				let r = t.settings?.facets?.fields && e.field && t.settings?.facets?.fields[e.field];
				if (typeof r?.trim == "boolean" ? r?.trim : t.settings?.facets?.trim) {
					if (e.type === "range" && e?.range?.low == e?.range?.high || e.values?.length == 0) return !1;
					if (!e.filtered && e.values?.length == 1) return c?.content?.inline ? e.values[0].count + c.content?.inline.length != l.totalResults : e.values[0].count != l.totalResults;
				}
				return !0;
			}).map((e) => {
				let r = e.field && o.facets && o.facets[e.field], i = (0, j_.default)({
					...t.settings?.facets,
					fields: void 0
				}, t.settings?.facets?.fields && e.field && t.settings?.facets?.fields[e.field] || {});
				switch (delete i.fields, e.type) {
					case "range": return new P_(n, u, e, r || {}, i);
					default: return new F_(n, u, e, r || {}, i);
				}
			}) || [];
			super(...d);
		}
	}, N_ = class {
		constructor(e, t, n, r, i) {
			this.filtered = !1, this.custom = {}, this.collapsed = !1, this.display = "", this.label = "", this.services = e, this.storage = t, Object.assign(this, r, n), ss(this, {
				type: K,
				field: K,
				filtered: K,
				custom: K,
				collapsed: K,
				display: K,
				label: K,
				clear: hc,
				toggleCollapse: Uc
			});
			let a = this.storage.get(`facets.${this.field}.collapsed`);
			this.collapsed = a ?? this.collapsed, this.filtered && this.collapsed && a === void 0 && i.autoOpenActive && this.toggleCollapse();
		}
		get clear() {
			return { url: this.services.urlManager.remove("page").remove(`filter.${this.field}`) };
		}
		toggleCollapse() {
			this.collapsed = !this.collapsed, this.storage.set(`facets.${this.field}.collapsed`, this.collapsed);
		}
	}, P_ = class extends N_ {
		constructor(e, t, n, r, i) {
			super(e, t, n, r, i), this.range = {
				low: 0,
				high: 0
			}, this.active = {
				low: 0,
				high: 0
			}, this.step = n?.step;
			let a = i.storeRange && this.storage.get(`facets.${this.field}.range`);
			a && n.filtered && (n.range?.low > a.low || n.range?.high < a.high) ? this.range = this.storage.get(`facets.${this.field}.range`) : (this.storage.set(`facets.${this.field}.range`, n.range), this.range = n.range), this.active = n.active || n.range, this.formatSeparator = r?.formatSeparator || "-", this.formatValue = r?.formatValue || "%01.2f", ss(this, {
				step: K,
				range: K,
				active: K,
				formatSeparator: K,
				formatValue: K
			});
		}
		get filteredCount() {
			return Number(this.filtered);
		}
	}, F_ = class extends N_ {
		constructor(e, t, n, r, i) {
			super(e, t, n, r, i), this.values = [], this.search = { input: "" }, this.overflow = {
				enabled: !1,
				limited: !0,
				limit: 0,
				remaining: void 0,
				setLimit: function(e) {
					e != this.limit && (this.enabled = !0, this.limit = e, this.calculate());
				},
				toggle: (e) => {
					e === void 0 ? this.overflow.limited = !this.overflow.limited : this.overflow.limited = e, this.storage.set(`facets.${this.field}.overflow.limited`, this.overflow.limited), this.overflow.calculate();
				},
				calculate: () => {
					if (this.overflow.limit > 0) {
						let e = this.values.length - this.overflow.limit;
						e > 0 && !this.search.input ? (this.overflow.enabled = !0, this.overflow.limited ? this.overflow.remaining = e : this.overflow.remaining = 0) : this.overflow.enabled = !1;
					}
				}
			}, this.multiple = this.multiple, this.values = n.values && n.values.map((t) => {
				switch (n.type) {
					case "value":
						if (r.display === "hierarchy") {
							let r = n?.values?.filter((e) => e.filtered) || [];
							return new L_(e, this, t, r);
						}
						return t.value = t?.value?.toString(), new I_(e, this, t);
					case "range-buckets": return new R_(e, this, t);
				}
			}) || [], i.pinFiltered && r.display !== "hierarchy" && this.values.sort((e, t) => Number(t.filtered) - Number(e.filtered));
			let a = this.storage.get(`facets.${this.field}.overflow.limited`);
			a !== void 0 && this.overflow.toggle(a), ss(this, {
				values: K,
				search: K,
				multiple: K,
				overflow: K,
				refinedValues: hc
			}), Po(() => this.search.input, () => {
				this.overflow.calculate();
			});
		}
		get filteredCount() {
			return this.values.filter((e) => e?.filtered).length;
		}
		get refinedValues() {
			let e = this.values || [];
			if (this.search.input) {
				let t = new RegExp(A_(this.search.input), "i");
				e = this.values.filter((e) => String(e?.label || "").match(t));
			}
			return this.overflow.enabled && this.overflow.limited && (e = e.slice(0, this.overflow.limit)), e;
		}
	}, I_ = class {
		constructor(e, t, n) {
			if (Object.assign(this, n), this.filtered) this.url = e.urlManager.remove("page").remove(`filter.${t.field}`, n.value);
			else {
				let r = e.urlManager.remove("page");
				t.multiple == "single" && (r = r?.remove(`filter.${t.field}`)), this.url = r?.merge(`filter.${t.field}`, n.value);
			}
		}
	}, L_ = class extends I_ {
		constructor(e, t, n, r) {
			if (super(e, t, n), this.level = 0, this.history = !1, n.value && t.hierarchyDelimiter && (this.level = n.value.split(t.hierarchyDelimiter).length), t.filtered && r?.length) {
				let e = t?.hierarchyDelimiter && r[0].value?.split(t.hierarchyDelimiter).length;
				e && this.level <= e && (this.history = !0);
			}
			this.url = n.value ? e.urlManager.remove("page").set(`filter.${t.field}`, n.value) : e.urlManager.remove("page").remove(`filter.${t.field}`);
		}
	}, R_ = class {
		constructor(e, t, n) {
			if (Object.assign(this, n), this.filtered) this.url = e.urlManager.remove("page").remove(`filter.${t.field}`, [{
				low: this.low,
				high: this.high
			}]);
			else {
				let n = e.urlManager.remove("page");
				t.multiple == "single" && (n = n?.remove(`filter.${t.field}`)), this.url = n?.merge(`filter.${t.field}`, [{
					low: this.low,
					high: this.high
				}]);
			}
		}
	};
})), B_, V_, H_, U_ = o((() => {
	kl(), Iu(), B_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { services: t, data: n, config: r } = e || {}, { search: i, meta: a } = n || {}, { filters: o } = i || {}, s = o?.map((e) => {
				let n = e.field, i = a.facets && a.facets[n];
				switch (e.type) {
					case "range":
						let n = e, a = r?.settings?.filters?.fields?.[e.field]?.rangeFormatValue || r?.settings?.filters?.rangeFormatValue;
						return a && (n.label = Pu(a, n.value?.low, n.value?.high)), new H_(t, n, i);
					default: return new V_(t, e, i);
				}
			}) || [];
			super(...s);
		}
	}, V_ = class {
		constructor(e, t, n) {
			this.facet = {
				field: t.field,
				label: n?.label || t.field
			}, this.value = {
				value: t.value,
				label: t.label
			}, this.label = `${this.facet.label}: ${this.value.label}`, this.url = e?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, this.value.value), ss(this, {
				facet: K,
				value: K,
				label: K
			});
		}
	}, H_ = class {
		constructor(e, t, n) {
			this.facet = {
				field: t.field,
				label: n?.label || t.field
			}, this.value = {
				low: t?.value?.low,
				high: t?.value?.high,
				label: t.label || `${t?.value?.low} - ${t?.value?.high}`
			}, this.label = `${this.facet.label}: ${this.value.label}`, this.url = e?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, {
				low: this.value.low,
				high: this.value.high
			}), ss(this, {
				facet: K,
				value: K,
				label: K
			});
		}
	};
})), W_, G_, K_, q_ = o((() => {
	kl(), W_ = class {
		constructor(e) {
			let { services: t, data: n, config: r } = e || {}, { search: i, meta: a } = n || {}, { pagination: o } = i || {}, s = r?.settings?.pagination;
			this.services = t, this.controllerConfig = r, this.page = o?.page, this.pageSize = o?.pageSize, this.totalResults = o?.totalResults, this.defaultPageSize = a?.pagination?.defaultPageSize, this.totalPages = o?.totalPages;
			let c = s?.pageSizeOptions || [
				{
					label: `Show ${this.defaultPageSize}`,
					value: this.defaultPageSize
				},
				{
					label: `Show ${this.defaultPageSize * 2}`,
					value: this.defaultPageSize * 2
				},
				{
					label: `Show ${this.defaultPageSize * 3}`,
					value: this.defaultPageSize * 3
				}
			];
			this.pageSizeOptions = c.filter((e) => e.value <= 100).map((e) => new G_(this.services, this.pageSize, {
				label: e.label,
				value: e.value
			})), this.pageSizeOption = this.pageSizeOptions.find((e) => e.active), ss(this, {
				page: K,
				pageSize: K,
				totalResults: K,
				totalPages: K,
				begin: hc,
				end: hc,
				multiplePages: hc,
				current: hc,
				first: hc,
				last: hc,
				next: hc,
				previous: hc,
				getPages: Uc,
				setPageSize: Uc
			});
		}
		get begin() {
			return this.controllerConfig?.settings?.infinite?.enabled ? 1 : this.pageSize * (this.page - 1) + 1;
		}
		get end() {
			return this.pageSize * this.page > this.totalResults ? this.totalResults : this.pageSize * this.page;
		}
		get multiplePages() {
			return this.pageSize < this.totalResults;
		}
		get current() {
			return new K_(this.services, {
				number: this.page,
				active: !0
			});
		}
		get first() {
			return new K_(this.services, {
				number: 1,
				active: this.page == 1
			});
		}
		get last() {
			return new K_(this.services, {
				number: this.totalPages,
				active: this.totalPages == this.page
			});
		}
		get next() {
			if (this.page < this.totalPages) return new K_(this.services, { number: this.page + 1 });
		}
		get previous() {
			if (this.page > 1) return new K_(this.services, { number: this.page - 1 });
		}
		getPages(e = 5, t) {
			if (!Number.isInteger(e)) return [];
			if (t === void 0 || !Number.isInteger(t)) {
				let n = e - 1, r = this.page, i = this.page, a = i - r;
				do {
					if (a = i - r, i < this.totalPages && i++, i - r >= n) break;
					r > 1 && r--;
				} while (a != i - r && i - r < n);
				e = r - this.page, t = i - this.page;
			} else e = -Math.abs(e), t = Math.abs(t);
			let n = [];
			for (let r = this.page + e; r <= this.page + t; r++) r > 0 && r <= this.totalPages && n.push(new K_(this.services, {
				number: r,
				active: r == this.page
			}));
			return n;
		}
		setPageSize(e) {
			e !== void 0 && this.services.urlManager.remove("page").set("pageSize", e).go();
		}
	}, G_ = class {
		constructor(e, t, n) {
			this.services = e, this.value = n.value, this.label = n.label, this.url = this.services?.urlManager.remove("page").set("pageSize", n.value), this.active = t == n.value;
		}
	}, K_ = class {
		constructor(e, t) {
			this.services = e, this.number = t.number, this.active = t.active || !1, this.url = this.services?.urlManager?.set("page", this.number), this.key = this.url.href;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Search/Stores/SearchResultStore.js
function J_(e, t, n, r) {
	let i = [...t], a = r.pageSize * (r.page - 1) + 1, o = r.pageSize * r.page;
	e?.settings?.infinite?.enabled && (a = 1), r.pageSize * r.page > r.totalResults && (o = r.totalResults);
	let s = n.filter((e) => !i.some((t) => t.id == e.id)), c = s.filter((e) => {
		let t = e.config.position.index;
		return t >= a - 1 && t <= o - 1;
	}), l = s.filter((e) => e.config.position.index >= r.totalResults);
	return c.forEach((e) => {
		let t = e.config.position.index - (a - 1);
		i.splice(t, 0, e);
	}), l.forEach((e, t) => {
		let n = r.totalResults - (l.length - t);
		n >= a - 1 && n <= o - 1 && i.splice(n, 0, e);
	}), e?.settings?.infinite && i.forEach((e, t) => {
		if (e.type === "banner") {
			let n = r.pageSize, a = (Math.floor(t / n) + 1 - 1) * n, o = a + n - 1;
			for (let t = a; t < o; t++) if (i[t].type === "product") {
				e.responseId = i[t].responseId;
				break;
			}
		}
	}), i;
}
function Y_(e, t, n) {
	let r = {}, i = e.getAttribute(Q_);
	if (i) {
		let [a, o] = i.split(":");
		!a || !o ? console.error("Error!: realtime variant is missing option or value (option:value)!", e, i) : (r[a.toLowerCase()] = [o.toLowerCase()], X_(t, r, n));
	}
}
function X_(e, t, n) {
	let r = n;
	e.realtime?.filters?.forEach((e) => {
		e == "first" && (r = [r[0]]), e == "unaltered" && (r = r.filter((e) => !e.variants?.selections.some((e) => e.previouslySelected)));
	}), r.forEach((e) => {
		e.type == "product" && e.variants?.makeSelections(t);
	});
}
var Z_, Q_, $_, ev, tv, nv, rv, iv, av, ov, sv, cv = o((() => {
	kl(), Z_ = /* @__PURE__ */ u(U()), wi(), Q_ = "ss-variant-option", $_ = "ss-variant-option-selected", ev = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { config: t, data: n, state: r, stores: i } = e || {}, { search: a, meta: o, previousSearch: s } = n || {}, { results: c, merchandising: l, pagination: u } = a || {}, { previousResults: d } = i || {}, { loaded: f } = r || {}, p = (c || []).map((n, r) => new nv({
				config: t,
				data: {
					result: n,
					meta: o
				},
				position: r + 1,
				responseId: e.data.search?.tracking?.responseId || ""
			})), m = t?.settings?.variants;
			if (m?.realtime?.enabled) {
				if (!f && p?.length) {
					let e = /* @__PURE__ */ new Set();
					document.querySelectorAll(`[${Q_}]`).forEach((t) => {
						if (t.tagName == "OPTION") {
							let n = t.closest("select");
							n ? e.has(n) || (e.add(n), n.addEventListener("change", (e) => {
								let t = e.target?.value, r = Array.from(n.querySelectorAll(`[${Q_}]`)).filter((e) => e.value == t);
								r.length > 0 && Y_(r[0], m, p);
							})) : console.warn("Warning: unable to add realtime variant event listener for element - ", t);
						} else t.addEventListener("click", () => {
							Y_(t, m, p);
						});
					});
				}
				if (p.length) {
					let e = {};
					document.querySelectorAll(`[${$_}]`).forEach((t) => {
						let n = t.getAttribute(Q_);
						if (n) {
							let [t, r] = n.split(":");
							t && r && (e[t.toLowerCase()] = [r.toLowerCase()]);
						}
					}), X_(m, e, p);
				}
			}
			if (t?.settings?.infinite?.enabled && d && u?.page && s?.pagination?.page && u.page == s.pagination.page + 1 && (p = (d || []).concat(p)), u && l?.content?.inline) {
				let n = l.content.inline.sort(function(e, t) {
					return e.config.position.index - t.config.position.index;
				}).map((t) => new tv({ data: {
					banner: t,
					responseId: e.data.search?.tracking?.responseId || ""
				} }));
				n && u.totalResults && (p = J_(t, p, n, u));
			}
			super(...p);
		}
	}, tv = class {
		constructor(e) {
			this.type = "banner", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {};
			let { banner: t, responseId: n } = e?.data || {}, r = t.value, i = typeof r == "string" && r.match(/data-banner-id="(\d+)"/), a = i ? i[1] : "ss-ib-" + t.config.position.index;
			this.id = a, this.responseId = n, this.config = t.config, this.value = t.value, ss(this, {
				id: K,
				mappings: K,
				attributes: K,
				custom: K,
				state: K
			});
		}
	}, nv = class {
		constructor(e) {
			this.type = "product", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {}, this.quantity = 1, this.mask = new iv();
			let { config: t } = e || {}, { result: n, meta: r } = e?.data || {};
			this.id = n.id, this.attributes = n.attributes, this.mappings = n.mappings, this.position = e.position, this.badges = new rv({ data: {
				meta: r,
				result: n
			} }), this.responseId = n.responseId || e.responseId, n.bundleSeed && (this.bundleSeed = !!n.bundleSeed), n.variants && n.variants.data && (this.variants = new av({
				data: {
					mask: this.mask,
					variants: n.variants.data,
					optionConfig: n.variants.optionConfig,
					preferences: n.variants?.preferences,
					meta: r
				},
				config: t?.settings?.variants
			})), ss(this, {
				id: K,
				display: hc,
				mappings: K,
				attributes: K,
				custom: K,
				state: K,
				quantity: K
			});
		}
		get display() {
			return (0, Z_.default)({
				id: this.id,
				mappings: this.mappings,
				attributes: this.attributes,
				badges: this.badges
			}, this.mask.data, { isMergeableObject: Ci });
		}
	}, rv = class {
		constructor(e) {
			this.all = [];
			let { data: t } = e || {}, { meta: n, result: r } = t || {};
			this.all = (r.badges || []).filter((e) => !!(e?.tag && n.badges?.tags && n.badges?.tags[e.tag] && n.badges?.tags[e.tag].enabled)).map((e) => {
				let t = n.badges?.tags?.[e.tag];
				return {
					...e,
					...t
				};
			}).sort((e, t) => e.priority - t.priority), ss(this, {
				all: K,
				tags: hc,
				locations: hc
			});
		}
		atLocation(e) {
			let t = Array.isArray(e) ? e : [e];
			return this.all.filter((e) => t.some((t) => e.location.startsWith(`${t}/`) || e.location == t));
		}
		get tags() {
			return this.all.reduce((e, t) => (e[t.tag] = t, e), {});
		}
		get locations() {
			return this.all.reduce((e, t) => {
				let [n, r] = t.location.split("/");
				return e[n] = e[n] || {}, e[n][r] = (e[n][r] || []).concat(t), e;
			}, {});
		}
	}, iv = class {
		constructor() {
			this.data = {}, ss(this, { data: K });
		}
		merge(e) {
			JSON.stringify((0, Z_.default)(this.data, e)) != JSON.stringify(this.data) && (this.data = (0, Z_.default)(this.data, e));
		}
		set(e) {
			JSON.stringify(e) != JSON.stringify(this.data) && (this.data = e);
		}
		reset() {
			this.data = {};
		}
	}, av = class {
		constructor(e) {
			this.data = [], this.selections = [];
			let { config: t, data: n } = e || {}, { variants: r, mask: i, meta: a } = n || {}, o = e?.data?.preferences || {};
			this.setActive = (e) => {
				this.active = e;
				let t = new rv({ data: {
					meta: a,
					result: e
				} });
				i.set({
					mappings: this.active.mappings,
					attributes: this.active.attributes,
					badges: t,
					state: this.active.state,
					custom: this.active.custom
				});
			}, t && (this.config = t), n.optionConfig && (this.optionConfig = n.optionConfig), this.update(r, t, o);
		}
		update(e, t = this.config, n) {
			try {
				let r = [];
				this.data = e.filter((e) => this.config?.showDisabledSelectionValues || e.mappings.core?.available !== !1).map((e) => (e.mappings.core?.price && (e.mappings.core.price = Number(e.mappings.core?.price)), e.mappings.core?.msrp && (e.mappings.core.msrp = Number(e.mappings.core?.msrp)), e)).map((e) => (e.options && Object.keys(e.options).forEach((e) => {
					r.includes(e) || r.push(e);
				}), new sv({ data: { variant: e } }))), this.selections = [], r.map((e) => {
					let t = this.config?.options && this.config.options[e];
					this.selections.push(new ov({
						config: t,
						optionConfig: this.optionConfig?.[e],
						data: {
							variants: this,
							selectorField: e
						}
					}));
				});
				let i = {};
				n && Object.keys(n).forEach((e) => {
					i[e] = n[e];
				}), t?.options && Object.keys(t?.options).forEach((e) => {
					t.options[e].preSelected && (i[e] = t.options[e].preSelected);
				}), t?.autoSelect && this.makeSelections(i);
			} catch (e) {
				console.error(e, "Failed to update variants!");
			}
		}
		makeSelections(e) {
			!e || !Object.keys(e).length ? this.selections.forEach((e) => {
				let t = e.values.find((e) => e.available);
				t && e.select(t.value, !0);
			}) : this.selections.forEach((t, n) => {
				let r = t.values.filter((e) => n == 0 || e.available), i = e[t.field.toLowerCase()], a = t.selected || r[0];
				if (i) {
					let e = (e) => {
						let t = r.find((t) => t.value.toString().toLowerCase() == e?.toString().toLowerCase());
						t && (a = t);
					};
					Array.isArray(i) ? i.forEach((t) => {
						e(t);
					}) : e(i);
				}
				a && t.select(a.value, !0);
			});
		}
		refineSelections(e) {
			let t = [...this.selections];
			t.sort((t) => t.field == e.field ? 1 : -1), t.forEach((e) => e.refineValues(this));
			let n = this.selections.filter((e) => e.selected?.value?.length);
			if (n.length) {
				let e = this.data;
				for (let t of n) e = e.filter((e) => t.selected?.value == e.options[t.field]?.value && e.available);
				if (e.length == 1) {
					let t = e[0];
					this.selections.filter((e) => !e.selected).forEach((e) => {
						let n = e.field, r = t.options[n].value;
						e.select(r);
					}), this.setActive(t);
				}
			}
		}
	}, ov = class {
		constructor(e) {
			this.selected = void 0, this.previouslySelected = void 0, this.values = [];
			let { data: t, config: n, optionConfig: r } = e || {}, { variants: i, selectorField: a } = t || {};
			this.field = a, this.type = r?.type, this.count = r?.count, this.label = n?.label || a, this.config = n || {}, this.variantsUpdate = () => i.refineSelections(this), this.refineValues(i), ss(this, {
				selected: K,
				values: K
			});
		}
		refineValues(e) {
			let t = e.selections.filter((e) => e.field != this.field && e.selected), n = e.data.filter((e) => e.available);
			for (let e of t) n = n.filter((t) => e.selected?.value == t.options?.[e.field]?.value && t.available);
			let r = e.data.filter((e) => e.options[this.field]).reduce((t, r) => {
				if (!t.some((e) => r.options[this.field].value == e.value)) {
					let i = r.options[this.field].value, a = r.mappings.core?.thumbnailImageUrl, o = !e.data.filter((e) => e.available).some((e) => e.options[this.field].value === i), s = {
						value: i,
						label: i,
						thumbnailImageUrl: a,
						available: !!n.some((e) => e.options[this.field].value == r.options[this.field].value),
						disabled: o
					};
					if (this.config.thumbnailBackgroundImages ? s.backgroundImageUrl = a : r.options[this.field].backgroundImageUrl && (s.backgroundImageUrl = r.options[this.field].backgroundImageUrl), r.options[this.field].background && (s.background = r.options[this.field].background), this.config.mappings && this.config.mappings && this.config.mappings[i.toString().toLowerCase()]) {
						let e = this.config.mappings[i.toString().toLowerCase()];
						e.label && (s.label = e.label), e.background && (s.background = e.background), e.backgroundImageUrl && (s.backgroundImageUrl = e.backgroundImageUrl);
					}
					t.push(s);
				}
				return t;
			}, []);
			if (this.selected && !r.some((e) => e.value == this.selected?.value && e.available)) {
				if (this.selected !== this.previouslySelected && this.previouslySelected && r.some((e) => e.value == this.previouslySelected?.value && e.available)) this.select(this.previouslySelected.value, !0);
				else {
					let e = r.filter((e) => e.available);
					if (r.length && e.length) {
						let t = e[0].value;
						this.selected.value !== t && this.select(t, !0);
					}
				}
			}
			this.values = r;
		}
		reset() {
			this.selected = void 0, this.values.forEach((e) => e.available = !1);
		}
		select(e, t = !1) {
			let n = this.values.find((t) => t.value == e);
			n && (t || (this.previouslySelected = this.selected), this.selected = n, this.variantsUpdate());
		}
	}, sv = class {
		constructor(e) {
			this.type = "variant", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {};
			let { data: t } = e || {}, { variant: n } = t || {};
			this.attributes = n.attributes || {}, this.mappings = n.mappings, this.options = n.options, this.badges = n.badges || [], this.available = this.mappings.core?.available ?? !0, ss(this, {
				attributes: K,
				mappings: K,
				custom: K,
				state: K,
				available: K
			});
		}
	};
})), lv, uv, dv = o((() => {
	kl(), lv = class {
		constructor(e) {
			this.options = [];
			let { services: t, data: n } = e || {}, { meta: r } = n || {}, { sorting: i, search: a } = n?.search || {};
			if (t && r.sortOptions) {
				let e = i?.length && i[0], n = (r.sortOptions || []).filter((e) => a?.query ? e : e.type == "field").map((n, r) => (n.active = !1, (e && e.field == n.field && String(e.direction) == String(n.direction) || !e && r === 0) && (n.active = !0), n.default = !1, r === 0 && (n.default = !0), new uv(t, n, r)));
				this.options = n, ss(this, {
					options: K,
					current: hc
				});
			}
		}
		get current() {
			return this.options.filter((e) => e.active).pop();
		}
	}, uv = class {
		constructor(e, t, n) {
			this.active = t.active, this.default = t.default, this.field = t.field, this.label = t.label, this.direction = t.direction, this.type = t.type, this.value = `${t.label}:${t.field}:${t.direction}:${n}`, this.url = this.default ? e.urlManager.remove("page").remove("sort") : e.urlManager.remove("page").set("sort", [{
				field: this.field,
				direction: this.direction
			}]), ss(this, {
				field: K,
				label: K,
				direction: K,
				type: K,
				value: K
			});
		}
	};
})), fv, pv, mv = o((() => {
	kl(), Iu(), fv = class {
		constructor(e) {
			let { services: t, data: n } = e || {}, { search: r } = n.search || {}, i = {};
			r?.query && (this.query = new pv(t, r.query), i.query = K), r?.didYouMean && (this.didYouMean = new pv(t, r.didYouMean), i.didYouMean = K), r?.originalQuery && (this.originalQuery = new pv(t, r.originalQuery), i.originalQuery = K), r?.subject && (this.subject = new pv(t, r.subject), i.subject = K), this.matchType = r?.matchType, i.matchType = K, ss(this, i);
		}
	}, pv = class {
		constructor(e, t) {
			this.string = Zl(t), this.url = e?.urlManager?.remove("page").remove("filter").set("query", this.string), ss(this, { string: K });
		}
	};
})), hv, gv = o((() => {
	Iu(), mv(), hv = class {
		constructor(e) {
			let { services: t, config: n } = e || {};
			this.config = n, this.services = t, this.max = this.config.settings?.history?.max ?? 25, this.config.settings?.history?.url && (this.services.urlManager = this.services.urlManager.withConfig((e) => ({
				...e,
				urlRoot: this.config.settings?.history?.url
			}))), this.storage = new Eu({
				type: "local",
				key: `athos-history${this.config.globals?.siteId ? `-${this.config.globals?.siteId}` : ""}`
			}), this.max === 0 && this.reset(), this.queries.length > this.max && this.getStoredData().forEach((e, t) => {
				t > this.max - 1 && this.remove(e);
			});
		}
		get queries() {
			return this.getStoredData().map((e) => new pv(this.services, e));
		}
		save(e) {
			if (this.max) {
				let t = this.getStoredData(), n = t.indexOf(e);
				n != -1 && t.splice(n, 1), t.unshift(e), t.length > this.max && t.pop(), this.storage.set("history", JSON.stringify(t));
			}
		}
		remove(e) {
			let t = this.getStoredData(), n = t.indexOf(e);
			n != -1 && (t.splice(n, 1), this.storage.set("history", JSON.stringify(t)));
		}
		reset() {
			this.storage.clear();
		}
		getStoredData(e) {
			let t = this.storage.get("history");
			if (t) try {
				let n = JSON.parse(t);
				if (Array.isArray(n)) return e && Number.isInteger(e) ? n.slice(0, e) : n;
			} catch {
				this.reset();
			}
			return [];
		}
	};
})), _v = o((() => {
	k_(), z_(), U_(), q_(), cv(), dv(), mv(), gv();
})), vv, yv = o((() => {
	_v(), vv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { services: t, state: n } = e || {}, r = new M_({
				...e,
				services: {
					...t,
					urlManager: t.urlManager.remove("filter")
				}
			});
			r.forEach((e) => {
				e.values?.forEach((t) => {
					t.preview = () => {
						r.map((e) => {
							e.filtered = !1, e.values?.map((e) => {
								e.filtered = !1;
							});
						}), e.filtered = !0, t.filtered = !0, n?.autocomplete.locks.facets.lock(), t.url.go();
					};
				});
			}), super(...r);
		}
	};
})), bv, xv, Sv = o((() => {
	kl(), bv = class {
		constructor(e) {
			let { services: t, data: n } = e || {}, { search: r, autocomplete: i } = n?.autocomplete || {}, a = {};
			r?.query && (this.query = new xv(t.urlManager, r.query), a.query = K), i?.correctedQuery && (this.correctedQuery = new xv(t.urlManager, i.correctedQuery), a.correctedQuery = K), r?.subject && (this.subject = new xv(t.urlManager, r.subject), a.subject = K), this.matchType = r?.matchType, a.matchType = K, ss(this, a);
		}
	}, xv = class {
		constructor(e, t) {
			this.string = t, this.url = e.set({ query: this.string }), ss(this, { string: K });
		}
	};
})), Cv, wv, Tv = o((() => {
	kl(), Cv = class {
		constructor(e) {
			this.focusedInput = void 0, this.input = void 0, this.source = "input";
			let { services: t } = e || {};
			this.locks = {
				terms: new wv(!1),
				facets: new wv(!1)
			}, this.url = t.urlManager, ss(this, {
				focusedInput: K,
				locks: K,
				input: K,
				reset: Uc
			});
		}
		reset() {
			this.input = void 0, this.locks.terms.reset(), this.locks.facets.reset();
		}
	}, wv = class {
		constructor(e = !1) {
			this.state = this.startState = e;
		}
		reset() {
			this.state = this.startState;
		}
		get locked() {
			return this.state;
		}
		lock() {
			this.state = !0;
		}
		unlock() {
			this.state = !1;
		}
	};
})), Ev, Dv, Ov = o((() => {
	kl(), Ev = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { data: t } = e || {}, { autocomplete: n, search: r } = t?.autocomplete || {}, i = [...(n?.alternatives ? n.alternatives : []).map((e) => e.text)];
			n?.correctedQuery && r?.query && n.correctedQuery.toLowerCase() != r.query.toLowerCase() && i.unshift(n.correctedQuery), r?.query && i.unshift(r.query);
			let a = [];
			i.map((t, n) => a.push(new Dv({
				...e,
				data: {
					term: {
						active: n === 0,
						value: t
					},
					terms: a
				},
				functions: e.functions,
				state: e.state,
				type: "suggested"
			}))), super(...a);
		}
	}, Dv = class {
		constructor(e) {
			let { services: t, functions: n, state: r, data: i, type: a } = e || {}, { term: o, terms: s } = i || {};
			this.active = o?.active, this.value = o?.value, this.type = a, this.url = t?.urlManager?.set({ query: this.value }), this.preview = () => {
				n.resetTerms(), s.map((e) => {
					e.active = !1;
				}), r.rootState.source = a, this.active = !0, r.rootState.locks.terms.lock(), r.rootState.locks.facets.unlock(), this.url?.set({ query: this.value }).go();
			}, ss(this, {
				active: K,
				value: K
			});
		}
	};
})), kv, Av = o((() => {
	Ov(), kv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = [], { data: n } = e || {}, { trending: r } = n?.trending || {};
			r?.queries?.map((n) => {
				t.push(new Dv({
					...e,
					data: {
						term: {
							active: !1,
							value: n.searchQuery
						},
						terms: t
					},
					functions: e.functions,
					state: e.state,
					type: "popular"
				}));
			}), super(...t);
		}
	};
})), jv, Mv = o((() => {
	Ov(), jv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { data: t } = e || {}, { queries: n } = t || {}, r = [];
			n?.map((t) => {
				r.push(new Dv({
					...e,
					data: {
						term: {
							active: !1,
							value: t
						},
						terms: r
					},
					functions: e.functions,
					state: e.state,
					type: "historical"
				}));
			}), super(...r);
		}
	};
})), Nv = o((() => {
	yv(), Sv(), Tv(), Ov(), Av(), Mv();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Meta/MetaStore.js
function Pv(e, t) {
	return t ? Pv(t, e % t) : e;
}
function Fv(e, t) {
	let n = Pv(e, t);
	return e * t / n;
}
var Iv, Lv, Rv = o((() => {
	Iv = class {
		constructor(e) {
			let { meta: t } = e?.data || {};
			this.data = t ?? {}, this.badges = new Lv(this.data);
		}
	}, Lv = class {
		constructor(e) {
			this.groups = {};
			let t = { overlay: { sections: ["left", "right"] } };
			Object.keys(t).map((n) => {
				let r = t[n], i = r.sections.map((t) => ({
					areas: e?.badges?.locations?.[t]?.map((e) => e.tag) || [],
					grid: []
				})), a = i.map((e) => e.areas.length).reduce(Fv);
				i.forEach((e) => {
					e.grid = Array.from({ length: a }).map((t, n) => e.areas[Math.floor(n / (a / e.areas.length))]);
				});
				let o = Array.from({ length: a }).map((e, t) => i.map((e) => e.grid[t]));
				this.groups[n] = {
					sections: r.sections,
					grid: o
				};
			});
		}
	};
})), zv, Bv = o((() => {
	kl(), Iu(), T_(), _v(), Nv(), Rv(), zv = class extends w_ {
		constructor(e, t) {
			if (super(e), typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, this.state = new Cv({ services: this.services }), this.storage = new Eu(), this.trending = [], this.history = [], this.initHistory(), this.reset(), ss(this, {
				state: K,
				search: K,
				terms: K,
				facets: K,
				filters: K,
				merchandising: K,
				results: K,
				pagination: K,
				sorting: K,
				history: K,
				trending: K
			});
		}
		get hasQuery() {
			return !!(this.state.input && this.loaded || this.search.query?.string);
		}
		reset() {
			this.state.reset(), this.update(), this.resetTerms();
		}
		initHistory() {
			let e = this.config.settings?.history?.limit;
			if (e && this.config.settings?.history?.enabled !== !1) {
				let t = new hv({
					services: this.services,
					config: {
						id: this.config.id,
						globals: this.config.globals
					}
				});
				this.history = new jv({
					services: this.services,
					functions: { resetTerms: () => {
						this.resetTerms();
					} },
					state: { rootState: this.state },
					data: { queries: t.getStoredData(e) }
				});
			} else this.history = [];
		}
		resetTerms() {
			this.resetSuggestions(), this.resetTrending(), this.resetHistory();
		}
		resetSuggestions() {
			this.terms?.forEach((e) => e.active = !1);
		}
		resetTrending() {
			this.trending?.forEach((e) => e.active = !1);
		}
		resetHistory() {
			this.history?.forEach((e) => e.active = !1);
		}
		setService(e, t) {
			this.services[e] && t && (this.services[e] = t, e === "urlManager" && (this.state.url = t, this.history?.forEach((e) => {
				e.url = t.set({ query: e.value });
			})));
		}
		updateTrendingTerms(e) {
			this.trending = new kv({
				services: this.services,
				functions: { resetTerms: () => {
					this.resetTerms();
				} },
				state: { rootState: this.state },
				data: { trending: e }
			});
		}
		update(e) {
			let { meta: t, search: n } = e || {};
			this.meta = new Iv({ data: { meta: t } }), n?.search && (this.state.url = this.services.urlManager = this.services.urlManager.set("query", n.search.query)), this.state.locks.terms.locked || (this.terms = new Ev({
				config: this.config,
				services: this.services,
				functions: { resetTerms: () => {
					this.resetTerms();
				} },
				state: { rootState: this.state },
				data: { autocomplete: n }
			}), n?.autocomplete && this.state.locks.terms.lock()), this.merchandising = new D_({ data: { search: n } }), this.search = new bv({
				config: this.config,
				services: this.services,
				data: { autocomplete: n }
			}), this.state.locks.facets.locked || (this.facets = new vv({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				state: { autocomplete: this.state },
				data: {
					search: n,
					meta: this.meta.data
				}
			})), this.filters = new B_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.results = new ev({
				config: this.config,
				state: { loaded: this.loaded },
				data: {
					search: n,
					meta: this.meta.data
				}
			}), (this.results.length === 0 && !this.trending.filter((e) => e.active).length || this.terms?.filter((e) => e.active).length) && this.resetTrending(), this.pagination = new W_({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.sorting = new lv({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.error = void 0, this.loaded = !!n?.pagination;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Finder/Stores/FinderSelectionStore.js
function Vv(e, t) {
	return `ss-finder-${e}.${t}`;
}
var Hv, Uv, Wv, Gv, Kv = o((() => {
	Hv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = e.config, { services: n, data: r, stores: i, state: a } = e || {}, { storage: o } = i || {}, { search: s, meta: c, selections: l } = r || {}, { facets: u } = s || {}, d = [];
			l?.length ? t.fields.forEach((e) => {
				let r = l.find((t) => t.facet.field === e.field);
				if (r) {
					let { facet: s, selected: c } = r || {};
					if (s?.hierarchyDelimiter) l.forEach((r, c) => {
						let l = e?.levels || s?.values[s?.values.length - 1]?.value.split(s.hierarchyDelimiter), u = {
							index: c,
							label: e.levels ? l[c] : "",
							key: `ss-${c}`
						}, f = Vv(t.id, s.field);
						o.set(`${f}.${u.key}.values`, r.data), o.set(`${f}.${u.key}.selected`, r.selected);
						let p = new Gv({
							config: u,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: s
							}
						});
						t.persist?.lockSelections && (p.disabled = !0), r.selected && (n.urlManager = n.urlManager.set(`filter.${r.facet.field}`, r.selected)), d.push(p);
					});
					else {
						let r = new Wv({
							config: e,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: s
							}
						});
						r.selected = c, r.storage.set("selected", c), r.data = s.values, c && (n.urlManager = n.urlManager.set(`filter.${s.field}`, c)), t.persist?.lockSelections && (r.disabled = !0), d.push(r);
					}
				}
			}) : u && c && (t?.fields && u.sort((e, n) => {
				let r = t.fields.map((e) => e.field);
				return r.indexOf(e.field) - r.indexOf(n.field);
			}), t?.fields?.forEach((e) => {
				let r = u.filter((t) => t.field == e.field).pop();
				if (r = {
					...c?.facets && c.facets[e.field] || {},
					...r
				}, r?.display === "hierarchy") {
					let o = r.values?.filter((e) => e.filtered).pop();
					if (o) {
						let e = o.value?.split(r?.hierarchyDelimiter).length;
						r.values = r.values?.filter((t, n) => t.value && t.value.split(r?.hierarchyDelimiter).length > e || n == r.values?.length - 1);
					}
					(e?.levels || r?.values && r?.values[r?.values?.length - 1].value?.split(r.hierarchyDelimiter))?.map((o, s) => {
						let c = {
							index: s,
							label: e.levels ? o : "",
							key: `ss-${s}`
						};
						d.push(new Gv({
							config: c,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: r
							}
						}));
					});
				} else d.push(new Wv({
					config: e,
					services: n,
					stores: i,
					state: a,
					data: {
						id: t.id,
						facet: r
					}
				}));
			})), super(...d);
		}
	}, Uv = class {
		constructor(e) {
			this.filtered = !1, this.collapsed = !1, this.display = "", this.disabled = !1, this.selected = "", this.custom = {};
			let { config: t, services: n, stores: r, state: i, data: a } = e || {}, { storage: o } = r || {}, { id: s, facet: c } = a || {}, { persisted: l } = i;
			this.services = n, this.persisted = l, this.id = s, this.config = t, this.facet = c, this.type = c.type, this.field = c.field, this.filtered = c.filtered, this.collapsed = c.collapsed, this.display = c.display, this.label = c.label, this.multiple = c.multiple, this.storage = {
				key: Vv(this.id, this.field),
				get: function(e) {
					let t = this.key + (e ? `.${e}` : "");
					return o.get(t);
				},
				set: function(e, t) {
					let n = this.key + (e ? `.${e}` : "");
					return o.set(n, t);
				}
			};
		}
		get values() {
			let e = [...this.data || []];
			return e.unshift({
				filtered: !1,
				value: "",
				label: this.config.label || this.label
			}), e;
		}
	}, Wv = class extends Uv {
		constructor(e) {
			super(e);
			let { data: t } = e || {}, { facet: n } = t || {};
			this.storage.set("values", n.values);
			let r = this.storage.get();
			this.data = r.values || [], this.disabled = !this.values.length, this.selected = this.disabled ? "" : r.selected || "";
		}
		select(e = "") {
			this.selected = e, this.storage.set("selected", e), this.persisted = !1, e ? this.services.urlManager.set(`filter.${this.field}`, e).go() : this.services.urlManager.remove(`filter.${this.field}`).go();
		}
	}, Gv = class extends Uv {
		constructor(e) {
			super(e);
			let { data: t } = e || {}, { facet: n } = t || {};
			this.hierarchyDelimiter = n.hierarchyDelimiter;
			let r = this.storage.get();
			if (!r) this.storage.set(`${this.config.key}.values`, n.values), r = this.storage.get();
			else if (r[this.config.key]?.values) this.selected = r[this.config.key]?.selected || "";
			else {
				let e = this.storage.get(), t = Object.keys(e).map((e, t) => `ss-${t}`);
				!t.includes(this.config.key) && t.push(this.config.key);
				let r = Object.keys(e).filter((t) => e[t].selected), i = r[r.length - 1], a = t.indexOf(this.config.key), o = t.indexOf(i);
				o != -1 && a == o + 1 ? this.storage.set(`${this.config.key}.values`, n.values) : this.disabled = !0;
			}
			this.data = r[this.config.key]?.values || [];
		}
		select(e = "") {
			this.selected = e, this.persisted = !1;
			let t = this.config.index, n = this.storage.get(), r = Object.keys(n).slice(t);
			Object.keys(n).reverse().forEach((t) => {
				t == this.config.key ? this.storage.set(`${t}.selected`, e) : r.includes(t) && this.storage.set(`${t}`, {}), e ||= this.storage.get(`${t}.selected`);
			}), e ? this.services.urlManager.set(`filter.${this.field}`, e).go() : this.services.urlManager.remove(`filter.${this.field}`).go();
		}
	};
})), qv = o((() => {
	Kv();
})), Jv, Yv = o((() => {
	kl(), Iu(), T_(), _v(), qv(), Rv(), Jv = class extends w_ {
		constructor(e, t) {
			if (super(e), this.persisted = !1, this.save = () => {}, this.reset = () => {
				this.config.persist?.enabled && (this.persistedStorage?.clear(), this.persisted = !1), this.services.urlManager.state.filter && (this.storage.clear(), this.selections = [], this.loaded = !1);
			}, typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, this.config.persist?.enabled && (this.persistedStorage = new Eu({
				type: "local",
				key: `athos-${this.config.id}-persisted`
			})), this.storage = new Eu(), this.update(), ss(this, {
				selections: K,
				pagination: K
			});
		}
		setService(e, t) {
			this.services[e] && t && (this.services[e] = t);
		}
		loadPersisted() {
			if (this.config.persist?.enabled && this.persistedStorage) {
				let e = this.persistedStorage.get("date"), t = this.persistedStorage.get("data"), n = this.persistedStorage.get("config"), r = this.persistedStorage.get("selections"), i = this.config.persist.expiration && Date.now() - e > this.config.persist.expiration;
				t && r.filter((e) => e.selected).length && (JSON.stringify({
					...n,
					plugins: [],
					middleware: {}
				}) === JSON.stringify({
					...this.config,
					plugins: [],
					middleware: {}
				}) && !i ? (this.update(t, r), this.persisted = !0, this.services.urlManager.go()) : this.reset());
			}
		}
		update(e, t) {
			let { meta: n, search: r } = e || {};
			this.error = void 0, this.loaded = !!r?.pagination, this.meta = new Iv({ data: { meta: n || {} } }), this.pagination = new W_({
				config: this.config,
				services: this.services,
				data: {
					search: r,
					meta: this.meta.data
				}
			}), this.selections = new Hv({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				state: { persisted: this.persisted },
				data: {
					search: r,
					meta: this.meta.data,
					selections: t || []
				}
			}), this.save = () => {
				this.config.persist?.enabled && this.persistedStorage && this?.selections?.filter((e) => e.selected).length && (this.persistedStorage.set("config", this.config), this.persistedStorage.set("data", e), this.persistedStorage.set("date", Date.now()), this.persistedStorage.set("selections", this.selections.map((e) => ({
					selected: e.selected,
					data: e.data,
					facet: e.facet
				}))));
			}, this.error = void 0, this.loaded = !!r?.pagination;
		}
	};
})), Xv, Zv = o((() => {
	kl(), Iu(), _v(), T_(), Rv(), Xv = class extends w_ {
		constructor(e, t) {
			if (super(e), typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to SearchStore. Missing \"subscribe\" function.");
			this.services = t, this.storage = new Eu(), this.history = new hv({
				services: this.services,
				config: this.config
			}), this.update(), ss(this, {
				search: K,
				merchandising: K,
				facets: K,
				filters: K,
				results: K,
				pagination: K,
				sorting: K
			});
		}
		reset() {
			this.update();
		}
		update(e) {
			let { meta: t, search: n } = e || {};
			this.meta = new Iv({ data: { meta: t } }), this.merchandising = new D_({ data: { search: n } }), this.search = new fv({
				services: this.services,
				data: { search: n }
			}), this.facets = new M_({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.filters = new B_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.results = new ev({
				config: this.config,
				state: { loaded: this.loaded },
				stores: {},
				data: {
					previousSearch: this.previousSearch,
					search: n,
					meta: this.meta.data
				}
			}), this.pagination = new W_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.sorting = new lv({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.error = void 0, this.loaded = !!n?.pagination, this.previousSearch = n;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-event-manager/dist/esm/MiddlewareManager.js
async function Qv(e, t) {
	let n = !1;
	return await $v(e, t, (e) => {
		e === !1 && (n = !0);
	}), n;
}
async function $v(e, t, n) {
	if (!t.length) return;
	let r = t[0];
	n(await r(e, async () => {
		await $v(e, t.slice(1), n);
	}));
}
var ey, ty = o((() => {
	ey = class {
		constructor() {
			this.functions = [];
		}
		use(...e) {
			this.functions.push(...e);
		}
		remove(e) {
			let t = e.toString();
			this.functions = this.functions.filter((n) => e.name !== n.name || n.toString() != t);
		}
		clear() {
			this.functions = [];
		}
		async dispatch(e) {
			if (await Qv(e || {}, this.functions) == 1) throw Error("cancelled");
		}
	};
})), ny, ry = o((() => {
	ty(), ny = class {
		constructor() {
			this.events = {};
		}
		async fire(e, t) {
			return this.events[e] && await this.events[e].dispatch(t), Promise.resolve();
		}
		on(e, ...t) {
			this.events[e] || (this.events[e] = new ey()), this.events[e].use(...t);
		}
	};
})), iy = o((() => {})), ay = o((() => {
	ry(), iy();
})), oy, sy = o((() => {
	kl(), ay(), oy = class {
		constructor() {
			this.items = [], ss(this, {
				items: K,
				price: hc,
				count: hc,
				msrp: hc
			}), this.eventManager = new ny();
		}
		on(e, ...t) {
			this.eventManager.on(e, ...t);
		}
		get count() {
			let e = 0;
			return this.items.forEach((t) => {
				e += t.quantity;
			}), e;
		}
		get price() {
			let e = 0;
			return this.items.forEach((t) => {
				e = (e * 100 + +(+((t.display.mappings.core?.price || 0) * 100) * t.quantity)) / 100 || 0;
			}), e;
		}
		get msrp() {
			let e = 0;
			return this.items.forEach((t) => {
				e = (e * 100 + +((+((t.display.mappings.core?.msrp || 0) * 100) || +((t.display.mappings.core?.price || 0) * 100) || 0) * t.quantity)) / 100 || 0;
			}), e;
		}
		addItems(e) {
			e.forEach((e) => {
				this.items.findIndex((t) => t.id == e.id) == -1 && this.items.push(e);
			}), this.eventManager.fire("addItems", {
				cart: this,
				items: e
			});
		}
		removeItems(e) {
			let t = [...this.items];
			e.forEach((e) => {
				let n = t.findIndex((t) => t.id == e.id);
				n > -1 && (t.splice(n, 1), t.length == 0 && this.eventManager.fire("emptied", { cart: this }));
			}), this.items = t, this.eventManager.fire("removeItems", {
				cart: this,
				items: e
			});
		}
		reset() {
			this.items = [], this.eventManager.fire("reset", { cart: this });
		}
	};
})), cy, ly = o((() => {
	kl(), cy = class {
		constructor(e) {
			this.display = {}, this.type = "default";
			let { data: t } = e || {}, { profile: n } = t?.profile || {};
			if (n?.tag) {
				if (!n.display.template) throw Error(`Recommendation Profile Store found a profile without a set template: ${n.tag}`);
				this.tag = n.tag, this.placement = n.placement, this.display = n.display, this.type = n.isBundle ? "bundle" : "default", ss(this, {
					tag: K,
					placement: K,
					display: K,
					type: K
				});
			}
		}
	};
})), uy = o((() => {
	ly();
})), dy, fy, py = o((() => {
	kl(), dy = /* @__PURE__ */ u(U()), T_(), _v(), sy(), uy(), Rv(), fy = class extends w_ {
		constructor(e, t) {
			if (super(e), this.loaded = !1, this.profile = {}, this.results = [], typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, ss(this, {
				profile: K,
				results: K
			});
		}
		reset() {
			this.error = void 0, this.loaded = !1, this.profile = {}, this.results = [];
		}
		update(e) {
			let { meta: t, profile: n, results: r } = e || {};
			this.error = void 0, this.meta = new Iv({ data: { meta: t } }), this.profile = new cy({ data: { profile: { profile: n } } }), this.profile.type == "bundle" && (this.config.settings = (0, dy.default)(this.config.settings || {}, { variants: { autoSelect: !0 } }), this.cart = new oy()), this.results = new ev({
				config: this.config,
				state: { loaded: this.loaded },
				data: {
					search: {
						results: r,
						tracking: { responseId: e.responseId }
					},
					meta: this.meta.data
				}
			}), this.loaded = !!n;
		}
	};
})), my, hy = o((() => {
	(function(e) {
		e.WARNING = "warning", e.INFO = "info", e.ERROR = "error";
	})(my ||= {});
})), gy = o((() => {
	T_(), Bv(), Yv(), Zv(), _v(), Nv(), py(), sy(), Iu(), Rv(), hy();
})), _y, vy = o((() => {
	Iu(), _y = class {
		get initialized() {
			return this._initialized;
		}
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c = {}) {
			if (this.type = "abstract", this.targeters = {}, this._initialized = !1, this.handleError = (e, t) => {
				let n;
				if (e instanceof ErrorEvent) n = e;
				else if (e instanceof Error) n = new ErrorEvent("error", {
					error: e,
					message: e.message
				});
				else if (typeof e == "string" || typeof e == "number") n = new ErrorEvent("error", { error: Error(e.toString()) });
				else if (typeof e == "object" && Object.keys(e).length) try {
					n = new ErrorEvent("error", { error: Error(JSON.stringify(e)) });
				} catch {}
				if (n) {
					let { filename: r, colno: i, lineno: a, error: { stack: o }, message: s, timeStamp: c } = n, l = {
						filename: r,
						stack: o,
						message: s,
						colno: i,
						lineno: a,
						errortimestamp: c,
						details: t,
						context: { controller: {
							id: this.id,
							type: this.type
						} }
					};
					this.tracker.track.error(l), this.eventManager.fire("error", {
						controller: this,
						error: e
					});
				}
			}, typeof e != "object" || typeof e.id != "string" || !e.id.match(/^[a-zA-Z0-9_-]*$/)) throw Error("Invalid config passed to controller. The \"id\" attribute must be an alphanumeric string.");
			if (typeof t != "object" || typeof t.search != "function") throw Error("Invalid service 'client' passed to controller. Missing \"search\" function.");
			if (typeof n != "object" || typeof n.update != "function") throw Error("Invalid service 'store' passed to controller. Missing \"update\" function.");
			if (typeof r != "object" || typeof r.subscribe != "function") throw Error("Invalid service 'urlManager' passed to controller. Missing \"subscribe\" function.");
			if (typeof i != "object" || typeof i.on != "function") throw Error("Invalid service 'eventManager' passed to controller. Missing \"on\" function.");
			if (typeof i != "object" || typeof i.fire != "function") throw Error("Invalid service 'eventManager' passed to controller. Missing \"fire\" function.");
			if (typeof a != "object" || typeof a.setNamespace != "function") throw Error("Invalid service 'profiler' passed to controller. Missing \"setNamespace\" function.");
			if (typeof a != "object" || typeof a.create != "function") throw Error("Invalid service 'profiler' passed to controller. Missing \"create\" function.");
			if (typeof o != "object" || typeof o.dev != "function") throw Error("Invalid service 'logger' passed to controller. Missing \"dev\" function.");
			if (typeof s != "object" || typeof s.track != "object") throw Error("Invalid service 'tracker' passed to controller. Missing \"track\" object.");
			this.id = e.id, this.config = e, this.client = t, this.store = n, this.urlManager = r, this.eventManager = i, this.profiler = a, this.log = o, this.tracker = s, this.context = c, this.log.setNamespace(this.config.id), this.profiler.setNamespace(this.config.id);
		}
		createTargeter(e, t, n) {
			return this.addTargeter(new Vl([e], t, n));
		}
		addTargeter(e) {
			let t = e.getTargets()[0], n = t?.name ?? t?.selector;
			if (n && !this.targeters[n]) return this.targeters[n] = e, e;
		}
		async init() {
			this._initialized && this.log.warn("'init' middleware recalled");
			let e = this.profiler.create({
				type: "event",
				name: "init",
				context: this.config
			}).start();
			try {
				try {
					await this.eventManager.fire("init", { controller: this });
				} catch (e) {
					if (e?.message == "cancelled") this.log.warn("'init' middleware cancelled");
					else throw this.log.error("error in 'init' middleware"), e;
				}
			} catch (e) {
				e && (console.error(e), this.handleError(e));
			}
			this._initialized ||= (this.urlManager.subscribe((e, t) => {
				try {
					JSON.stringify(e) !== JSON.stringify(t) && this.search();
				} catch (e) {
					this.log.error("URL state is invalid", e);
				}
			}), !0), e.stop(), this.log.profile(e);
		}
		retarget() {
			Object.keys(this.targeters).forEach((e) => {
				this.targeters[e].retarget();
			});
		}
		async plugin(e, ...t) {
			await e(this, ...t);
		}
		on(e, ...t) {
			this.eventManager.on(e, ...t);
		}
		use(e) {
			if (e?.plugins) try {
				if (!Array.isArray(e?.plugins)) throw "invalid format";
				e?.plugins.forEach((e) => {
					if (!Array.isArray(e)) throw "invalid format";
					let [t, ...n] = e;
					this.plugin(t, ...n);
				});
			} catch {
				this.log.warn("plugins not attached - use format [func, ...args?][]");
			}
			e?.middleware && Object.keys(e.middleware).forEach((t) => {
				let n = e.middleware[t], r;
				r = Array.isArray(n) ? n : [n], r.forEach((e) => {
					this.on(t, e);
				});
			});
		}
		setConfig(e) {
			this.config = e, this.store.setConfig(e);
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/utils/getParams.js
function yy(e) {
	let t = {};
	if (e.tag && (t.merchandising = t.merchandising || {}, t.merchandising.landingPage = e.tag), e.query && (t.search = t.search || {}, t.search.query = t.search.query || {}, t.search.query.string = e.query), e.rq && (t.search = t.search || {}, t.search.subQuery = e.rq), e.fallbackQuery && (t.search = t.search || {}, t.search.fallbackQuery = e.fallbackQuery), e.page && (t.pagination = t.pagination || {}, t.pagination.page = e.page), e.pageSize && (t.pagination = t.pagination || {}, t.pagination.pageSize = e.pageSize), e.sort) {
		t.sorts = t.sorts || [];
		let n = (Array.isArray(e.sort) ? e.sort : [e.sort])[0];
		n && n.field && n.direction && t.sorts.push({
			field: n.field,
			direction: n.direction
		});
	}
	return e.filter && (t.filters = t.filters || [], Object.keys(e.filter).forEach((n) => {
		if (typeof n != "string") return;
		let r = e.filter[n];
		(Array.isArray(r) ? r : [r]).forEach((e) => {
			typeof e == "object" ? e.low !== void 0 && e.high !== void 0 && t.filters.push({
				type: "range",
				field: n,
				value: e
			}) : t.filters.push({
				type: "value",
				field: n,
				value: e
			});
		});
	})), t;
}
var by = o((() => {})), xy, Sy = o((() => {
	(function(e) {
		e.search = "search", e.autocomplete = "autocomplete", e.finder = "finder", e.recommendation = "recommendation";
	})(xy ||= {});
})), Cy, wy, Ty, Ey = o((() => {
	Cy = /* @__PURE__ */ u(U()), gy(), vy(), by(), Sy(), wy = {
		id: "finder",
		beacon: { enabled: !0 },
		globals: { pagination: { pageSize: 0 } },
		fields: [],
		persist: {
			enabled: !1,
			lockSelections: !0,
			expiration: 0
		}
	}, Ty = class extends _y {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = xy.finder, this.find = async () => {
				await this.store.save();
				try {
					await this.eventManager.fire("beforeFind", { controller: this }), window.location.href = this.urlManager.href;
				} catch (e) {
					e?.message == "cancelled" ? this.log.warn("'beforeFind' middleware cancelled") : (this.log.error("error in 'beforeFind' middleware"), this.log.error(e));
				}
			}, this.reset = () => {
				this.store.reset(), this.urlManager.remove("filter").go(), this.store.setService("urlManager", this.urlManager);
			}, this.search = async () => {
				try {
					if (this.initialized || await this.init(), this.store.persisted) return;
					let e = this.params;
					this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, search: r } = await this.client.finder(e);
					t.stop(), this.log.profile(t);
					let i = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), i.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					i.stop(), this.log.profile(i), this.store.update({
						meta: n,
						search: r
					});
					let a = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), a.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					a.stop(), this.log.profile(a);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: my.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: my.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: my.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: my.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.config = (0, Cy.default)(wy, this.config), this.store.setConfig(this.config), this.config.url && (this.urlManager = this.urlManager.withConfig((e) => ({
				...e,
				urlRoot: this.config.url
			}))), this.use(this.config), this.store.loadPersisted();
		}
		get params() {
			let e = this.urlManager.state, { userId: t, sessionId: n, pageLoadId: r } = this.tracker.getContext(), i = {};
			t && (i.userId = t), n && (i.sessionId = n), r && (i.pageLoadId = r), i.domain = window.location.href;
			let a = {
				facets: {
					include: this.config.fields.map((e) => e.field),
					autoDrillDown: !1
				},
				tracking: i
			};
			return (0, Cy.default)({ ...yy(e) }, (0, Cy.default)(a, this.config.globals));
		}
	};
})), Dy = /* @__PURE__ */ s(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = r(n) : typeof define == "function" && define.amd ? define([], r.bind(n, n)) : r(n);
	})(typeof global < "u" ? global : e, function(e) {
		if (e.CSS && e.CSS.escape) return e.CSS.escape;
		var t = function(e) {
			if (arguments.length == 0) throw TypeError("`CSS.escape` requires an argument.");
			for (var t = String(e), n = t.length, r = -1, i, a = "", o = t.charCodeAt(0); ++r < n;) {
				if (i = t.charCodeAt(r), i == 0) {
					a += "�";
					continue;
				}
				if (i >= 1 && i <= 31 || i == 127 || r == 0 && i >= 48 && i <= 57 || r == 1 && i >= 48 && i <= 57 && o == 45) {
					a += "\\" + i.toString(16) + " ";
					continue;
				}
				if (r == 0 && n == 1 && i == 45) {
					a += "\\" + t.charAt(r);
					continue;
				}
				if (i >= 128 || i == 45 || i == 95 || i >= 48 && i <= 57 || i >= 65 && i <= 90 || i >= 97 && i <= 122) {
					a += t.charAt(r);
					continue;
				}
				a += "\\" + t.charAt(r);
			}
			return a;
		};
		return e.CSS ||= {}, e.CSS.escape = t, t;
	});
})), Oy, ky, Ay = o((() => {
	Oy = 1e3, ky = (e, t) => {
		let n = t?.display?.mappings.core?.url || "", r = t?.mappings.core?.url || "", i = (e.composedPath ? e.composedPath() : [e.target]).slice(0, 12);
		for (let e of i) if (e instanceof Element) {
			let t = e.getAttribute("href");
			if (t && (r && t.includes(r) || n && t.includes(n))) return !0;
		}
		return !1;
	};
})), jy, My, Ny = o((() => {
	Ay(), jy = "sstracking", My = (e) => {
		let t = e.target, n = null, r = 0;
		for (; t && (r < 12 || !t.getAttribute(jy));) {
			n = t.getAttribute("href");
			let e = t.tagName.toLowerCase() === "a";
			if (n && e) return !0;
			t = t.parentElement, r++;
		}
		return !1;
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/Search/SearchController.js
function Py(e) {
	return {
		siteId: e.siteId,
		sorts: e.sorts,
		search: {
			query: { string: e?.search?.query?.string || "" },
			subQuery: e?.search?.subQuery || ""
		},
		filters: e.filters,
		pagination: e.pagination,
		facets: e.facets,
		merchandising: { landingPage: e.merchandising?.landingPage || "" }
	};
}
function Fy(e, t, n = 7) {
	let r = 0, i = e;
	for (; i && r <= n;) {
		let e = null;
		try {
			e = i.querySelector(`[href*="${t}"]`);
		} catch {
			try {
				e = i.querySelector((0, Ly.default)(`[href*="${t}"]`));
			} catch {}
		}
		if (e) {
			let n = "", r = e;
			for (; r && r != i.parentElement;) {
				let e = r.classList.value.trim().split(" ").reduce((e, t) => t.trim() ? `${e}.${(0, Ly.default)(t.trim())}` : e, "");
				n = `${r.tagName}${e}${n ? ` ${n}` : ""}`, r = r.parentElement;
			}
			return `${n}[href*="${t}"]`;
		}
		i = i.parentElement, r++;
	}
}
var Iy, Ly, Ry, zy, By, Vy, Hy = o((() => {
	Iy = /* @__PURE__ */ u(U()), Ly = /* @__PURE__ */ u(Dy()), vy(), gy(), Iu(), by(), Sy(), Ay(), Ny(), Ry = [
		"collection",
		"category",
		"categories",
		"hierarchy",
		"brand",
		"manufacturer"
	], zy = [
		1,
		0,
		"1",
		"0",
		"true",
		"false",
		!0,
		!1
	], By = {
		id: "search",
		globals: {},
		beacon: { enabled: !0 },
		settings: {
			redirects: {
				merchandising: !0,
				singleResult: !0
			},
			facets: {
				trim: !0,
				pinFiltered: !0,
				storeRange: !0,
				autoOpenActive: !0
			}
		}
	}, Vy = class extends _y {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = xy.search, this.previousResults = [], this.page = { type: "search" }, this.events = {}, this.track = {
				banner: {
					impression: ({ uid: e, responseId: t }) => {
						if (!e) {
							this.log.warn("No banner provided to track.banner.impression");
							return;
						}
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events[t]?.banner[e]?.impression) return;
						let n = {
							responseId: t,
							banners: [{ uid: e }],
							results: []
						};
						this.eventManager.fire("track.banner.impression", {
							controller: this,
							product: { uid: e },
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].impression({
							data: n,
							siteId: this.config.globals?.siteId
						}), this.events[t].banner[e] = this.events[t].banner[e] || {}, this.events[t].banner[e].impression = !0;
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.click");
							return;
						}
						let { responseId: n, uid: r } = t;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (My(e)) {
							if (this.events?.[n]?.banner[r]?.clickThrough) return;
							this.track.banner.clickThrough(e, t), this.events[n].banner[r] = this.events[n].banner[r] || {}, this.events[n].banner[r].clickThrough = !0, setTimeout(() => {
								this.events[n].banner[r].clickThrough = !1;
							}, Oy);
						}
					},
					clickThrough: (e, { uid: t, responseId: n }) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.clickThrough");
							return;
						}
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = {
							responseId: n,
							banners: [{ uid: t }]
						};
						this.eventManager.fire("track.banner.clickThrough", {
							controller: this,
							event: e,
							product: { uid: t },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].clickThrough({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[n].banner[t] = this.events[n].banner[t] || {}, this.events[n].banner[t].clickThrough = !0, setTimeout(() => {
							this.events[n].banner[t].clickThrough = !1;
						}, Oy);
					}
				},
				product: {
					clickThrough: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.clickThrough");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = e.target, i = t.display?.mappings.core?.url || t.mappings.core?.url || "", a = r?.getAttribute("href"), o = a?.indexOf(i) == -1 && a || i, s = {}, c = Fy(r, o), l = c ? document?.querySelector(c)?.getBoundingClientRect() : void 0;
						if (c || o || l) try {
							let e = this.storage.get("lastStringyParams");
							if (e) {
								let t = Py(JSON.parse(e)), n = JSON.stringify(t);
								s[n] = {
									domRect: l,
									href: o,
									selector: c
								};
							}
						} catch (e) {
							this.log.warn("Failed to save srcollMap!", e);
						}
						this.storage.set("scrollMap", s);
						let u = ["product", "banner"].includes(t.type) ? t.type : "product", d = {
							responseId: n,
							results: [{
								type: u,
								uid: t.id ? "" + t.id : "",
								...u === "product" ? {
									parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
									sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
								} : {}
							}]
						};
						this.eventManager.fire("track.product.clickThrough", {
							controller: this,
							event: e,
							product: t,
							trackEvent: d
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].clickThrough({
							data: d,
							siteId: this.config.globals?.siteId
						});
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.click");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (t.type === "banner" && My(e)) {
							if (this.events?.[n]?.product[t.id]?.inlineBannerClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].inlineBannerClickThrough = !1;
							}, Oy);
						} else if (ky(e, t)) {
							if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].productClickThrough = !1;
							}, Oy);
						}
					},
					impression: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.impression");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events[t]?.product[e.id]?.impression) return;
						let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
							responseId: t,
							results: [{
								type: n,
								uid: e.id ? "" + e.id : "",
								...n === "product" ? {
									parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
									sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
								} : {}
							}],
							banners: []
						};
						this.eventManager.fire("track.product.impression", {
							controller: this,
							product: e,
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
					},
					addToCart: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.addToCart");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let n = {
							responseId: t,
							results: [{
								parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
								uid: e.display.mappings.core?.uid || e.display.id,
								sku: e.display.mappings.core?.sku,
								qty: e.quantity || 1,
								price: Number(e.display.mappings.core?.price) || 0
							}]
						};
						this.eventManager.fire("track.product.addToCart", {
							controller: this,
							product: e,
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].addToCart({
							data: n,
							siteId: this.config.globals?.siteId
						});
					}
				},
				redirect: ({ redirectURL: e, responseId: t }) => {
					if (!e) {
						this.log.warn("No redirectURL provided to track.redirect");
						return;
					}
					let n = {
						responseId: t,
						redirect: e
					};
					this.eventManager.fire("track.redirect", {
						controller: this,
						redirectURL: e,
						trackEvent: n
					}), this.config.beacon?.enabled && this.tracker.events.search.redirect({
						data: n,
						siteId: this.config.globals?.siteId
					});
				}
			}, this.search = async () => {
				try {
					this.initialized || await this.init();
					let e = this.params;
					e.search?.query?.string && e.search?.query?.string.length && this.store.history.save(e.search.query.string), this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = JSON.stringify(Py(e)), n = this.storage.get("lastStringyParams");
					if (this.store.loaded && t === n) return;
					let r = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), i = {}, a;
					if (this.config.settings?.infinite?.enabled && e.pagination?.page && e.pagination.page > 1) {
						let t = this.config.settings.infinite?.backfill && !this.store.results.length && e.pagination.page > this.config.settings.infinite.backfill, n = !this.config.settings.infinite?.backfill && !this.store.results.length;
						if (t || n) {
							this.storage.set("scrollMap", {}), this.urlManager.set("page", 1).go();
							return;
						}
						if (this.config.settings?.infinite.backfill && !this.store.loaded) {
							let t = [], n = Array(e.pagination.page).fill("backfill").map((n, r) => {
								let i = (0, Iy.default)({ ...e }, {
									pagination: { page: r + 1 },
									search: { redirectResponse: "full" }
								});
								return r + 1 == 1 && (delete i?.pagination?.page, this.config.settings?.redirects?.merchandising && delete i?.search?.redirectResponse), t.push(i), this.client[this.page.type](i);
							}), r = await Promise.all(n);
							i = r[0].meta, a = r[0].search;
							let o = r.reduce((e, t) => {
								let n = t.search.tracking.responseId;
								return this.events[n] = this.events[n] || {
									product: {},
									banner: {}
								}, e.concat(...t.search.results);
							}, []);
							a.pagination.totalPages = Math.ceil(a.pagination.totalResults / a.pagination.pageSize), a.pagination.page = e.pagination?.page, a.results = o;
						} else {
							let t = await this.client[this.page.type](e);
							i = t.meta, a = t.search;
							let n = a.tracking.responseId;
							this.events[n] = this.events[n] || {
								product: {},
								banner: {}
							}, a.results = [...this.previousResults, ...a.results || []];
						}
					} else {
						this.previousResults = [];
						let t = await this.client[this.page.type](e);
						i = t.meta, a = t.search;
						let n = a.tracking.responseId;
						this.events[n] = {
							product: {},
							banner: {}
						};
					}
					let o = {
						meta: i,
						search: a
					};
					r.stop(), this.log.profile(r);
					let s = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: o
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), s.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					s.stop(), this.log.profile(s), this.previousResults = JSON.parse(JSON.stringify(o.search.results)), this.store.update(o);
					let c = { responseId: o.search.tracking.responseId };
					this.config.beacon?.enabled && this.tracker.events[this.page.type].render({
						data: c,
						siteId: this.config.globals?.siteId
					});
					let l = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: o
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), l.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					l.stop(), this.log.profile(l);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: my.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: my.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: my.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: my.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to search controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, this.config = (0, Iy.default)(By, this.config), this.config.settings?.infinite && typeof this.config.settings?.infinite == "object" && (Object.keys(this.config.settings?.infinite).length == 0 || this.config.settings?.infinite?.backfill !== void 0) && (this.config.settings = {
				...this.config.settings,
				infinite: {
					enabled: !0,
					...this.config.settings.infinite
				}
			}), this.config.settings?.infinite?.enabled && this.config.settings.restorePosition === void 0 && (this.config.settings.restorePosition = { enabled: !0 }), this.store.setConfig(this.config), this.storage = new Eu({
				type: "session",
				key: `athos-controller-${this.config.id}`
			}), typeof this.context?.page == "object" && ["search", "category"].includes(this.context.page.type) && (this.page = (0, Iy.default)(this.page, this.context.page)), this.eventManager.on("beforeSearch", async ({ request: e }, t) => {
				await t();
				let n = e;
				n.search?.query || n.filters?.filter((e) => e.background).filter((e) => Ry.find((t) => e.field?.toLowerCase().includes(t))).filter((e) => zy.every((t) => {
					switch (e.type) {
						case "range": return e.value !== t;
						default: return e.value !== t;
					}
				}))?.length && (this.page = (0, Iy.default)(this.page, { type: "category" }));
			}), this.eventManager.on("afterSearch", async (e, t) => {
				let n = e.controller.config, r = e.response?.search?.merchandising?.redirect, i = e.controller.store;
				if (r && n?.settings?.redirects?.merchandising && !e?.response?.search?.filters?.length && !i.loaded) return i.loaded = !0, this.track.redirect({
					redirectURL: r,
					responseId: e.response.search.tracking.responseId
				}), window.location.replace(r), !1;
				await t();
			}), this.eventManager.on("afterStore", async (e, t) => {
				await t();
				let n = Py(e.request), r = JSON.stringify(n);
				this.storage.set("lastStringyParams", r);
				let i = (this.storage.get("scrollMap") || {})[r];
				i || this.storage.set("scrollMap", {}), this.eventManager.fire("restorePosition", {
					controller: this,
					element: i
				});
			}), this.eventManager.on("afterSearch", async (e, t) => {
				await t();
				let n = e.response.search.facets;
				n && n.forEach((t) => {
					if (e.response.meta?.facets && t.field) {
						let n = t.field || "", r = e.response.meta.facets[n], i = r?.hierarchyDelimiter || " / ", a = this.config?.settings?.filters?.fields ? this.config?.settings?.filters?.fields[n] : this.config?.settings?.filters, o = a?.hierarchy?.displayDelimiter ?? " / ", s = a?.hierarchy?.showFullPath ?? !1;
						if (a?.hierarchy?.enabled && r && r.display === "hierarchy" && t.filtered && t.values?.length > 0) {
							let n = t.values?.filter((e) => e?.filtered === !0);
							if (n && n.length) {
								let r = {
									field: t.field,
									label: s ? (n[0].value ?? n[0].label ?? "").replace(new RegExp(i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"), o) : n[0].label,
									type: "value"
								};
								e.response.search.filters ? e.response.search.filters.push(r) : e.response.search.filters = [r];
							}
						}
					}
				});
			}), this.eventManager.on("afterStore", async (e, t) => {
				await t();
				let n = e.controller, r = e.response.search;
				if (n.store.loaded && !n.store.error) {
					let t = e.controller.config, n = e?.request?.filters?.filter((e) => !e.background), i = r?.results?.length && r?.results[0].mappings?.core?.url;
					if (t?.settings?.redirects?.singleResult && r.search?.query && r.pagination?.totalResults === 1 && !n?.length && i) return window.location.replace(i), !1;
				}
			}), this.config.settings?.restorePosition?.enabled && (this.eventManager.on("restorePosition", async ({ controller: e, element: t }, n) => {
				if (!t?.selector) {
					let e = this.storage.get("lastStringyParams");
					if (e) {
						let n = Py(JSON.parse(e)), r = JSON.stringify(n);
						t = (this.storage.get("scrollMap") || {})[r];
					}
				}
				t && await new Promise(async (n) => {
					let r = 0, i = 0, a, o = () => {
						let e = t?.domRect?.top || 0, n = document.querySelector(t?.selector);
						for (; n && !n.getBoundingClientRect().height;) n = n.parentElement, e = 0;
						if (n) {
							let { y: t } = n.getBoundingClientRect();
							r++, t > e + 1 || t < e - 1 ? window.scrollBy(0, t - e) : a = n;
						} else i++;
						return !0;
					};
					for (; o() && r <= 10 && i <= 12;) await new Promise((e) => setTimeout(e, 60));
					a ? e.log.debug("restored position to: ", a) : e.log.debug("attempted to scroll back to element with selector: ", t?.selector), n();
				}), await n();
			}), this.config.settings?.restorePosition?.onPageShow && window.addEventListener("pageshow", (e) => {
				e.persisted && this.store.loaded && this.eventManager.fire("restorePosition", {
					controller: this,
					element: {}
				});
			})), this.use(this.config);
		}
		get params() {
			let e = (0, Iy.default)({ ...yy(this.urlManager.state) }, this.config.globals || {});
			(!this.config.settings?.redirects?.merchandising || this.store.loaded) && (e.search = e.search || {}, e.search.redirectResponse = "full"), e.tracking = e.tracking || {}, e.tracking.domain = window.location.href;
			let { userId: t, sessionId: n, pageLoadId: r, shopperId: i } = this.tracker.getContext();
			if (t && (e.tracking.userId = t), n && (e.tracking.sessionId = n), r && (e.tracking.pageLoadId = r), !this.config.globals?.personalization?.disabled) {
				let t = this.tracker.cookies.cart.get();
				t.length && (e.personalization = e.personalization || {}, e.personalization.cart = t.join(","));
				let n = this.tracker.cookies.viewed.get();
				n.length && (e.personalization = e.personalization || {}, e.personalization.lastViewed = n.join(",")), i && (e.personalization = e.personalization || {}, e.personalization.shopper = i);
			}
			return e;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/Autocomplete/AutocompleteController.js
function Uy(e, t, n) {
	let r = document.createElement("input");
	r.type = "hidden", r.name = t, r.value = n, e.querySelector(`[type="hidden"][name="${t}"]`)?.remove(), e.append(r);
}
async function Wy(e) {
	return new Promise((t) => {
		window.setTimeout(t, e);
	});
}
function Gy(e, t) {
	let n = {};
	if (typeof e == "object" && e.nodeName == "FORM") for (let r = e.elements.length - 1; r >= 0; r--) {
		let i = e.elements[r];
		typeof t == "function" && !t(i) || i.name && !tb.includes(i.type) && (i.type != "checkbox" && i.type != "radio" || i.checked) && (n[i.name] = i.value);
	}
	return n;
}
function Ky(e, t, n) {
	if (typeof e == "object" && e.nodeName == "FORM") for (let r = e.elements.length - 1; r >= 0; r--) {
		let i = e.elements[r];
		typeof n == "function" && !n(i) || i.name && !tb.includes(i.type) && i.addEventListener("change", t);
	}
}
function qy(e, t) {
	if (typeof e == "object" && e.nodeName == "FORM") for (let n = e.elements.length - 1; n >= 0; n--) {
		let r = e.elements[n];
		r.name && !tb.includes(r.type) && r.removeEventListener("change", t);
	}
}
var Jy, Yy, Xy, Zy, Qy, $y, eb, tb, nb = o((() => {
	Jy = /* @__PURE__ */ u(U()), gy(), Iu(), vy(), by(), Sy(), Ay(), Ny(), Yy = "ss-autocomplete-input", Xy = 13, Zy = 27, Qy = "fallbackQuery", $y = {
		id: "autocomplete",
		selector: "",
		action: "",
		globals: {},
		beacon: { enabled: !0 },
		settings: {
			initializeFromUrl: !0,
			syncInputs: !0,
			serializeForm: !1,
			facets: {
				trim: !0,
				pinFiltered: !0
			},
			redirects: {
				merchandising: !0,
				singleResult: !1
			},
			bind: {
				input: !0,
				submit: !0
			}
		}
	}, eb = class extends _y {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = xy.autocomplete, this.events = {}, this.track = {
				banner: {
					impression: (e) => {
						if (!e) {
							this.log.warn("No banner provided to track.banner.impression");
							return;
						}
						let { responseId: t, uid: n } = e;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events?.[t]?.banner?.[n]?.impression) return;
						let r = {
							responseId: t,
							banners: [{ uid: n }],
							results: []
						};
						this.eventManager.fire("track.banner.impression", {
							controller: this,
							product: { uid: n },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].banner[n] = this.events[t].banner[n] || {}, this.events[t].banner[n].impression = !0;
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.click");
							return;
						}
						let { responseId: n, uid: r } = t;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (My(e)) {
							if (this.events?.[n]?.banner[r]?.clickThrough) return;
							this.track.banner.clickThrough(e, t), this.events[n].banner[r] = this.events[n].banner[r] || {}, this.events[n].banner[r].clickThrough = !0, setTimeout(() => {
								this.events[n].banner[r].clickThrough = !1;
							}, Oy);
						}
					},
					clickThrough: (e, { uid: t, responseId: n }) => {
						if (!t) {
							this.log.warn("No banner uid provided to track.banner.clickThrough");
							return;
						}
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = {
							responseId: n,
							banners: [{ uid: t }]
						};
						this.eventManager.fire("track.banner.clickThrough", {
							controller: this,
							event: e,
							product: { uid: t },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.clickThrough({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[n].banner[t] = this.events[n].banner[t] || {}, this.events[n].banner[t].clickThrough = !0, setTimeout(() => {
							this.events[n].banner[t].clickThrough = !1;
						}, Oy);
					}
				},
				product: {
					clickThrough: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.clickThrough");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = ["product", "banner"].includes(t.type) ? t.type : "product", i = {
							responseId: n,
							results: [{
								type: r,
								uid: t.id ? "" + t.id : "",
								...r === "product" ? {
									parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
									sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
								} : {}
							}]
						};
						this.eventManager.fire("track.product.clickThrough", {
							controller: this,
							event: e,
							product: t,
							trackEvent: i
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.clickThrough({
							data: i,
							siteId: this.config.globals?.siteId
						});
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.click");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (t.type === "banner" && My(e)) {
							if (this.events?.[n]?.product[t.id]?.inlineBannerClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].inlineBannerClickThrough = !1;
							}, Oy);
						} else if (ky(e, t)) {
							if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].productClickThrough = !1;
							}, Oy);
						}
					},
					impression: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.impression");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events?.[t]?.product[e.id]?.impression) return;
						let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
							responseId: t,
							results: [{
								type: n,
								uid: e.id ? "" + e.id : "",
								...n === "product" ? {
									parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
									sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
								} : {}
							}],
							banners: []
						};
						this.eventManager.fire("track.product.impression", {
							controller: this,
							product: e,
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
					},
					addToCart: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.addToCart");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let n = {
							responseId: t,
							results: [{
								parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
								uid: e.display.mappings.core?.uid || e.display.id,
								sku: e.display.mappings.core?.sku,
								qty: e.quantity || 1,
								price: Number(e.display.mappings.core?.price) || 0
							}]
						};
						this.eventManager.fire("track.product.addToCart", {
							controller: this,
							product: e,
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.addToCart({
							data: n,
							siteId: this.config.globals?.siteId
						});
					}
				},
				redirect: ({ redirectURL: e, responseId: t }) => {
					if (!e) {
						this.log.warn("No redirectURL provided to track.redirect");
						return;
					}
					let n = {
						responseId: t,
						redirect: e
					};
					this.eventManager.fire("track.redirect", {
						controller: this,
						redirectURL: e,
						trackEvent: n
					}), this.config.beacon?.enabled && this.tracker.events.autocomplete.redirect({
						data: n,
						siteId: this.config.globals?.siteId
					});
				}
			}, this.handlers = {
				input: {
					enterKey: async (e) => {
						if (e.keyCode == Xy) {
							let t = e.target, n = this.store.services.urlManager;
							for (e.preventDefault(); this.store.loading;) await Wy(200);
							this.store.search.correctedQuery && (n = n?.set(Qy, this.store.search.correctedQuery.string)), n = n?.set("query", t.value), await Wy(201);
							try {
								await this.eventManager.fire("beforeSubmit", {
									controller: this,
									input: t
								});
							} catch (e) {
								if (e?.message == "cancelled") {
									this.log.warn("'beforeSubmit' middleware cancelled");
									return;
								}
								this.log.error("error in 'beforeSubmit' middleware"), console.error(e);
							}
							window.location.href = n?.href || "";
						}
					},
					escKey: (e) => {
						e.keyCode == Zy && (e.target.blur(), this.setFocused());
					},
					focus: (e) => {
						e.stopPropagation(), setTimeout(() => {
							this.setFocused(e.target);
						});
					},
					formSubmit: async (e) => {
						let t = e.target, n = t.querySelector(`input[${Yy}]`);
						for (e.preventDefault(); this.store.loading;) await Wy(200);
						this.store.search.correctedQuery && Uy(t, Qy, this.store.search.correctedQuery.string), await Wy(201);
						try {
							await this.eventManager.fire("beforeSubmit", {
								controller: this,
								input: n
							});
						} catch (e) {
							if (e?.message == "cancelled") {
								this.log.warn("'beforeSubmit' middleware cancelled");
								return;
							}
							this.log.error("error in 'beforeSubmit' middleware"), console.error(e);
						}
						t.submit();
					},
					formElementChange: (e) => {
						let t = e.target?.form, n = t?.querySelector(`input[${Yy}]`);
						if (t && n && this.config.settings?.serializeForm) {
							let e = Gy(t, function(e) {
								return e != n;
							});
							this.store.setService("urlManager", this.store.services.urlManager.reset().withGlobals(e)), this.store.reset(), this.config.settings?.trending?.enabled && this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0 && this.searchTrending();
						}
					},
					input: (e) => {
						e.isTrusted && this.store.state.focusedInput !== e.target && this.setFocused(e.target);
						let t = e.target.value;
						if ((!this.store.state.input && !t || this.store.state.input == t) && this.store.loaded) return;
						this.store.state.source = "input", this.store.state.input = t, this.store.merchandising.redirect = "", this.config?.settings?.syncInputs && document.querySelectorAll(this.config.selector).forEach((e) => {
							e.value = t;
						}), clearTimeout(this.handlers.input.timeoutDelay);
						let n = this.store.trending?.length && this.config.settings?.trending?.enabled && this.config.settings?.trending?.showResults, r = this.store.history?.length && this.config.settings?.history?.enabled && this.config.settings?.history?.showResults;
						this.handlers.input.timeoutDelay = setTimeout(() => {
							t ? (this.store.state.locks.terms.unlock(), this.store.state.locks.facets.unlock(), this.urlManager.set({ query: this.store.state.input }).go()) : (this.store.reset(), n ? this.store.trending[0].preview() : r ? this.store.history[0].preview() : this.urlManager.reset().go());
						}, 200);
					},
					timeoutDelay: void 0
				},
				document: { click: (e) => {
					let t = document.querySelectorAll(this.config.selector);
					Array.from(t).includes(e.target) || e.target?.nodeName == "FORM" && e.target.querySelectorAll(this.config.selector).length ? e.stopPropagation() : this.setFocused();
				} }
			}, this.searchTrending = async (e) => {
				let t, n = this.storage.get("terms");
				if (n && !e?.limit) t = JSON.parse(n);
				else {
					let n = { limit: e?.limit || this.config.settings?.trending?.limit || 5 }, r = this.profiler.create({
						type: "event",
						name: "trending",
						context: n
					}).start();
					t = await this.client.trending(n), r.stop(), this.log.profile(r), t?.trending.queries?.length && this.storage.set("terms", JSON.stringify(t));
				}
				this.store.updateTrendingTerms(t);
			}, this.search = async () => {
				try {
					if (this.initialized || await this.init(), !this.urlManager.state.query) return;
					let e = this.params;
					if (!e?.search?.query?.string) return;
					this.store.loading = !0, this.store.merchandising.redirect = "";
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, search: r } = await this.client.autocomplete(e);
					t.stop(), this.log.profile(t);
					let i = r.tracking.responseId;
					this.events[i] = this.events[i] || {
						product: {},
						banner: {}
					};
					let a = this.store.results[0]?.responseId, o = a && a === i;
					if (o) {
						let e = Object.keys(this.events[i].product || {}).filter((e) => this.events[i].product?.[e]?.impression);
						this.events[i] = {
							product: e.reduce((e, t) => (e[t] = { impression: !0 }, e), {}),
							banner: this.events[i].banner
						};
					} else this.events[i] = {
						product: {},
						banner: {}
					};
					let s = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), s.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					if (s.stop(), this.log.profile(s), this.store.update({
						meta: n,
						search: r
					}), !o) {
						let e = { responseId: i };
						this.config.beacon?.enabled && this.tracker.events.autocomplete.render({
							data: e,
							siteId: this.config.globals?.siteId
						});
					}
					let c = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), c.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					c.stop(), this.log.profile(c);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: my.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: my.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: my.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: my.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to autocomplete controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, this.config = (0, Jy.default)($y, this.config), this.config.settings?.trending?.limit && this.config.settings?.trending?.enabled === void 0 && (this.config.settings = {
				...this.config.settings,
				trending: {
					enabled: !0,
					...this.config.settings.trending
				}
			}), this.config.settings?.history?.limit && this.config.settings?.history?.enabled === void 0 && (this.config.settings = {
				...this.config.settings,
				history: {
					enabled: !0,
					...this.config.settings.history
				}
			}), this.store.setConfig(this.config), this.config.settings.initializeFromUrl && (this.store.state.input = this.urlManager.state.query, this.urlManager.reset().go()), this.storage = new Eu({
				type: "session",
				key: `athos-controller-${this.config.id}`
			}), this.eventManager.on("afterSearch", async (e, t) => {
				if (await t(), e.response.search.autocomplete?.query != e.controller.urlManager.state.query) return !1;
			}), this.eventManager.on("beforeSubmit", async (e, t) => {
				if (await t(), e.controller.store.loading) return;
				let n = e.controller.store.state.input, r = e.controller.store.merchandising?.redirect;
				if (this.config?.settings?.redirects?.merchandising && n && r) return this.track.redirect({
					redirectURL: r,
					responseId: e.controller.store.merchandising?.responseId
				}), window.location.href = r, !1;
				if (this.config?.settings?.redirects?.singleResult) {
					let { results: t } = e.controller.store, n = t.filter((e) => e.type == "product"), r = n.length === 1 && n[0].mappings.core?.url;
					if (r) return window.location.href = r, !1;
				}
			}), this.use(this.config);
		}
		get params() {
			let e = this.urlManager.state, t = (0, Jy.default)({ ...yy(e) }, this.config.globals || {}), { userId: n, sessionId: r, pageLoadId: i, shopperId: a } = this.tracker.getContext();
			if (t.tracking = t.tracking || {}, t.tracking.domain = window.location.href, n && (t.tracking.userId = n), r && (t.tracking.sessionId = r), i && (t.tracking.pageLoadId = i), this.store.state.input && (t.search = t.search || {}, t.search.input = this.store.state.input), this.store.state.source && (t.search = t.search || {}, t.search.source = this.store.state.source), !this.config.globals?.personalization?.disabled) {
				let e = this.tracker.cookies.cart.get();
				e.length && (t.personalization = t.personalization || {}, t.personalization.cart = e.join(","));
				let n = this.tracker.cookies.viewed.get();
				n.length && (t.personalization = t.personalization || {}, t.personalization.lastViewed = n.join(",")), a && (t.personalization = t.personalization || {}, t.personalization.shopper = a);
			}
			return t;
		}
		async setFocused(e) {
			if (this.store.state.focusedInput !== e) {
				this.store.state.focusedInput = e;
				try {
					try {
						await this.eventManager.fire("focusChange", { controller: this });
					} catch (e) {
						if (e?.message == "cancelled") this.log.warn("'focusChange' middleware cancelled");
						else throw this.log.error("error in 'focusChange' middleware"), e;
					}
				} catch (e) {
					e && console.error(e);
				}
			}
			e?.dispatchEvent(new Event("input"));
		}
		reset() {
			document.querySelectorAll(this.config.selector).forEach((e) => {
				e.value = "";
			}), this.store.reset();
		}
		unbind() {
			document.querySelectorAll(`input[${Yy}]`)?.forEach((e) => {
				e.removeEventListener("input", this.handlers.input.input), e.removeEventListener("keydown", this.handlers.input.enterKey), e.removeEventListener("keydown", this.handlers.input.escKey), e.removeEventListener("focus", this.handlers.input.focus), e.form && (e.form.removeEventListener("submit", this.handlers.input.formSubmit), qy(e.form, this.handlers.input.formElementChange));
			}), document.removeEventListener("click", this.handlers.document.click);
		}
		async bind() {
			this.initialized || await this.init(), this.unbind(), document.querySelectorAll(this.config.selector).forEach((e) => {
				e.setAttribute("spellcheck", "false"), e.setAttribute("autocomplete", "off"), e.setAttribute("autocorrect", "off"), e.setAttribute("autocapitalize", "none"), e.setAttribute(Yy, ""), this.config.settings?.bind?.input && e.addEventListener("input", this.handlers.input.input), this.config?.settings?.initializeFromUrl && !e.value && this.store.state.input && (e.value = this.store.state.input), e.addEventListener("focus", this.handlers.input.focus), e.addEventListener("keydown", this.handlers.input.escKey);
				let t = e.form, n;
				if (this.config.action) this.config.settings?.bind?.submit && e.addEventListener("keydown", this.handlers.input.enterKey), n = this.config.action;
				else if (t) {
					if (this.config.settings?.bind?.submit && t.addEventListener("submit", this.handlers.input.formSubmit), n = t.action || "", this.config.settings?.serializeForm) {
						Ky(t, this.handlers.input.formElementChange, function(t) {
							return t != e;
						});
						let n = Gy(t, function(t) {
							return t != e;
						});
						this.store.setService("urlManager", this.urlManager.reset().withGlobals(n));
					}
				} else this.config.settings?.bind?.submit && this.log.warn("Missing form action url! Input element is not inside a <form> and no 'action' URL is configured. Enter key will not submit. Set the 'action' url in the config to enable submission.", e);
				n && this.store.setService("urlManager", this.store.services.urlManager.withConfig((e) => ({
					...e,
					urlRoot: n
				}))), document.activeElement === e && !this.store.loading && this.setFocused(e);
			}), this.config.settings?.trending?.enabled && this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0 && !this.store.trending?.length && this.searchTrending(), this.config.settings?.disableClickOutside || document.addEventListener("click", this.handlers.document.click);
		}
	}, tb = [
		"file",
		"reset",
		"submit",
		"button",
		"image",
		"password"
	];
})), rb, ib, ab, ob = o((() => {
	rb = /* @__PURE__ */ u(U()), gy(), vy(), Sy(), Ay(), ib = {
		id: "recommend",
		beacon: { enabled: !0 },
		tag: "",
		batched: !0,
		realtime: !1,
		globals: {}
	}, ab = class extends _y {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			if (super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = xy.recommendation, this.beaconType = "recommendations", this.events = {}, this.track = { product: {
				clickThrough: (e, t) => {
					if (!t) {
						this.log.warn("No result provided to track.product.clickThrough");
						return;
					}
					let n = t.responseId;
					if (!this.events[n]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (this.events[n]?.product[t.id]?.productClickThrough) return;
					let r = ["product", "banner"].includes(t.type) ? t.type : "product", i = {
						type: r,
						uid: t.id ? "" + t.id : "",
						...r === "product" ? {
							parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
							sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
						} : {}
					}, a = {
						tag: this.store.profile.tag,
						responseId: n,
						results: [i]
					};
					this.eventManager.fire("track.product.clickThrough", {
						controller: this,
						event: e,
						product: t,
						trackEvent: a
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].clickThrough({
						data: a,
						siteId: this.config.globals?.siteId
					}), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0;
				},
				click: (e, t) => {
					if (!t) {
						this.log.warn("No result provided to track.product.click");
						return;
					}
					let n = t.responseId;
					if (!this.events[n]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (t.type === "banner") {
						if (this.events[n]?.product[t.id]?.inlineBannerClickThrough) return;
						this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
							this.events[n].product[t.id].inlineBannerClickThrough = !1;
						}, Oy);
					} else if (ky(e, t)) {
						if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
						this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
							this.events[n].product[t.id].productClickThrough = !1;
						}, Oy);
					}
				},
				impression: (e) => {
					if (!e) {
						this.log.warn("No result provided to track.product.impression");
						return;
					}
					let t = e.responseId;
					if (!this.events[t]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (this.events[t]?.product[e.id]?.impression) return;
					let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
						type: n,
						uid: e.id ? "" + e.id : "",
						...n === "product" ? {
							parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
							sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
						} : {}
					}, i = {
						tag: this.store.profile.tag,
						responseId: t,
						results: [r],
						banners: []
					};
					this.eventManager.fire("track.product.impression", {
						controller: this,
						product: e,
						trackEvent: i
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].impression({
						data: i,
						siteId: this.config.globals?.siteId
					}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
				},
				addToCart: (e) => {
					if (!e) {
						this.log.warn("No result provided to track.product.addToCart");
						return;
					}
					let t = e.responseId;
					if (!this.events[t]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					let n = {
						parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
						uid: e.display.mappings.core?.uid || e.display.id,
						sku: e.display.mappings.core?.sku,
						qty: e.quantity || 1,
						price: Number(e.display.mappings.core?.price) || 0
					}, r = {
						responseId: t,
						tag: this.store.profile.tag,
						results: [n]
					};
					this.eventManager.fire("track.product.addToCart", {
						controller: this,
						product: e,
						trackEvent: r
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].addToCart({
						data: r,
						siteId: this.config.globals?.siteId
					});
				}
			} }, this.search = async () => {
				try {
					this.initialized || await this.init();
					let e = this.params;
					this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, profile: r, results: i, responseId: a } = await this.client.recommend(e);
					t.stop(), this.log.profile(t), this.events[a] = this.events[a] || { product: {} };
					let o = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								profile: r,
								results: i
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), o.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					o.stop(), this.log.profile(o), this.store.update({
						meta: n,
						profile: r,
						results: i,
						responseId: a
					}), this.beaconType = this.store.profile.type === "bundle" ? "bundles" : "recommendations";
					let s = {
						responseId: a,
						tag: this.store.profile.tag
					};
					this.config.beacon?.enabled && this.tracker.events[this.beaconType].render({
						data: s,
						siteId: this.config.globals?.siteId
					});
					let c = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								profile: r,
								results: i,
								responseId: a
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), c.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					c.stop(), this.log.profile(c);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: my.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: my.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: my.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: my.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to recommendation controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, !e.tag) throw Error("Invalid config passed to RecommendationController. The \"tag\" attribute is required.");
			e.settings?.searchOnPageShow !== !1 && window.addEventListener("pageshow", (e) => {
				e.persisted && !this.store.error && this.store.loaded && !this.store.loading && this.search();
			}), this.config = (0, rb.default)(ib, this.config), this.store.setConfig(this.config), this.use(this.config);
		}
		get params() {
			let e = {
				tag: this.config.tag,
				batched: this.config.batched,
				branch: this.config.branch || "production",
				batchId: this.config.batchId,
				...this.config.globals
			}, { shopperId: t } = this.tracker.getContext();
			if (t && (e.shopper = t), !e.siteId || e.siteId == this.tracker.getGlobals().siteId) {
				let t = this.tracker.cookies.cart.get(), n = this.tracker.cookies.viewed.get();
				t?.length && (e.cart = t), n?.length && (e.lastViewed = n);
			}
			return e;
		}
	};
})), sb = o((() => {
	Ey(), Hy(), nb(), ob(), vy(), Sy();
})), cb = ["merge", "set"], lb = [
	"query",
	"tag",
	"fallbackQuery"
], ub = (e, t) => {
	let { parameters: n } = e, r = e.settings?.useDefaultIgnoreParameters ?? !0, i = e?.settings?.ignoreParameters || [];
	i = r ? i.concat(lb) : i;
	let a = t, o = t.merge({});
	return Object.keys(n).forEach((e) => {
		let t = n[e].action || "merge", { state: r } = n[e], s = n[e].ignoreParameters || [], c = n[e].useGlobalIgnoreParameters ?? !0 ? i.concat(s) : s, l = Object.keys(a.state).filter((e) => !c.includes(e)).length == 0;
		r && l && cb.includes(t) && (o = o[t](e, r));
	}), o;
}, db = /* @__PURE__ */ s(((e, t) => {
	(function() {
		function n(e) {
			var t = typeof Symbol == "function" && Symbol.for && Symbol.for("react.element"), r = 60103, i = { use_static: !1 };
			a(e) && e.use_static !== void 0 && (i.use_static = !!e.use_static);
			function a(e) {
				return typeof e == "object" && !Array.isArray(e) && e !== null;
			}
			function o(e) {
				var t = Object.getPrototypeOf(e);
				return t ? Object.create(t) : {};
			}
			function s(e, t, n) {
				Object.defineProperty(e, t, {
					enumerable: !1,
					configurable: !1,
					writable: !1,
					value: n
				});
			}
			function c(e, t) {
				s(e, t, function() {
					throw new y("The " + t + " method cannot be invoked on an Immutable data structure.");
				});
			}
			var l = "__immutable_invariants_hold";
			function u(e) {
				s(e, l, !0);
			}
			function d(e) {
				return typeof e != "object" || !e || !!Object.getOwnPropertyDescriptor(e, l);
			}
			function f(e, t) {
				return e === t || e !== e && t !== t;
			}
			function p(e) {
				return typeof e == "object" && !!e && !Array.isArray(e) && !(e instanceof Date);
			}
			var m = ["setPrototypeOf"], h = ["keys"], g = m.concat([
				"push",
				"pop",
				"sort",
				"splice",
				"shift",
				"unshift",
				"reverse"
			]), _ = h.concat([
				"map",
				"filter",
				"slice",
				"concat",
				"reduce",
				"reduceRight"
			]), v = m.concat([
				"setDate",
				"setFullYear",
				"setHours",
				"setMilliseconds",
				"setMinutes",
				"setMonth",
				"setSeconds",
				"setTime",
				"setUTCDate",
				"setUTCFullYear",
				"setUTCHours",
				"setUTCMilliseconds",
				"setUTCMinutes",
				"setUTCMonth",
				"setUTCSeconds",
				"setYear"
			]);
			function y(e) {
				this.name = "MyError", this.message = e, this.stack = (/* @__PURE__ */ Error()).stack;
			}
			y.prototype = /* @__PURE__ */ Error(), y.prototype.constructor = Error;
			function b(e, t) {
				for (var n in u(e), t) t.hasOwnProperty(n) && c(e, t[n]);
				return Object.freeze(e), e;
			}
			function x(e, t) {
				var n = e[t];
				s(e, t, function() {
					return P(n.apply(e, arguments));
				});
			}
			function S(e, t, n) {
				var r = n && n.deep;
				if (e in this && (r && this[e] !== t && p(t) && p(this[e]) && (t = P.merge(this[e], t, {
					deep: !0,
					mode: "replace"
				})), f(this[e], t))) return this;
				var i = A.call(this);
				return i[e] = P(t), T(i);
			}
			var C = P([]);
			function w(e, t, n) {
				var r = e[0];
				if (e.length === 1) return S.call(this, r, t, n);
				var i = e.slice(1), a = this[r], o;
				if (typeof a == "object" && a) o = P.setIn(a, i, t);
				else {
					var s = i[0];
					o = s !== "" && isFinite(s) ? w.call(C, i, t) : ie.call(re, i, t);
				}
				if (r in this && a === o) return this;
				var c = A.call(this);
				return c[r] = o, T(c);
			}
			function T(e) {
				for (var t in _) if (_.hasOwnProperty(t)) {
					var n = _[t];
					x(e, n);
				}
				i.use_static || (s(e, "flatMap", O), s(e, "asObject", j), s(e, "asMutable", A), s(e, "set", S), s(e, "setIn", w), s(e, "update", oe), s(e, "updateIn", ce), s(e, "getIn", le));
				for (var r = 0, a = e.length; r < a; r++) e[r] = P(e[r]);
				return b(e, g);
			}
			function E(e) {
				return i.use_static || s(e, "asMutable", D), b(e, v);
			}
			function D() {
				return new Date(this.getTime());
			}
			function O(e) {
				if (arguments.length === 0) return this;
				var t = [], n = this.length, r;
				for (r = 0; r < n; r++) {
					var i = e(this[r], r, this);
					Array.isArray(i) ? t.push.apply(t, i) : t.push(i);
				}
				return T(t);
			}
			function k(e) {
				if (e === void 0 && arguments.length === 0) return this;
				if (typeof e != "function") {
					var t = Array.isArray(e) ? e.slice() : Array.prototype.slice.call(arguments);
					t.forEach(function(e, t, n) {
						typeof e == "number" && (n[t] = e.toString());
					}), e = function(e, n) {
						return t.indexOf(n) !== -1;
					};
				}
				var n = o(this);
				for (var r in this) this.hasOwnProperty(r) && e(this[r], r) === !1 && (n[r] = this[r]);
				return N(n);
			}
			function A(e) {
				var t = [], n, r;
				if (e && e.deep) for (n = 0, r = this.length; n < r; n++) t.push(M(this[n]));
				else for (n = 0, r = this.length; n < r; n++) t.push(this[n]);
				return t;
			}
			function j(e) {
				typeof e != "function" && (e = function(e) {
					return e;
				});
				var t = {}, n = this.length, r;
				for (r = 0; r < n; r++) {
					var i = e(this[r], r, this), a = i[0];
					t[a] = i[1];
				}
				return N(t);
			}
			function M(e) {
				return !e || typeof e != "object" || !Object.getOwnPropertyDescriptor(e, l) || e instanceof Date ? e : P.asMutable(e, { deep: !0 });
			}
			function ee(e, t) {
				for (var n in e) Object.getOwnPropertyDescriptor(e, n) && (t[n] = e[n]);
				return t;
			}
			function te(e, t) {
				if (arguments.length === 0) return this;
				if (typeof e != "object" || !e) throw TypeError("Immutable#merge can only be invoked with objects or arrays, not " + JSON.stringify(e));
				var n = Array.isArray(e), r = t && t.deep, i = t && t.mode || "merge", a = t && t.merger, s;
				function c(e, n, i) {
					var c = P(n[i]), l = a && a(e[i], c, t), u = e[i];
					if (s !== void 0 || l !== void 0 || !e.hasOwnProperty(i) || !f(c, u)) {
						var d = l === void 0 ? r && p(u) && p(c) ? P.merge(u, c, t) : c : l;
						(!f(u, d) || !e.hasOwnProperty(i)) && (s === void 0 && (s = ee(e, o(e))), s[i] = d);
					}
				}
				function l(e, t) {
					for (var n in e) t.hasOwnProperty(n) || (s === void 0 && (s = ee(e, o(e))), delete s[n]);
				}
				var u;
				if (n) for (var d = 0, m = e.length; d < m; d++) {
					var h = e[d];
					for (u in h) h.hasOwnProperty(u) && c(s === void 0 ? this : s, h, u);
				}
				else {
					for (u in e) Object.getOwnPropertyDescriptor(e, u) && c(this, e, u);
					i === "replace" && l(this, e);
				}
				return s === void 0 ? this : N(s);
			}
			function ne(e, t) {
				var n = t && t.deep;
				if (arguments.length === 0) return this;
				if (typeof e != "object" || !e) throw TypeError("Immutable#replace can only be invoked with objects or arrays, not " + JSON.stringify(e));
				return P.merge(this, e, {
					deep: n,
					mode: "replace"
				});
			}
			var re = P({});
			function ie(e, t, n) {
				if (!Array.isArray(e) || e.length === 0) throw TypeError("The first argument to Immutable#setIn must be an array containing at least one \"key\" string.");
				var r = e[0];
				if (e.length === 1) return ae.call(this, r, t, n);
				var i = e.slice(1), a, s = this[r];
				if (a = this.hasOwnProperty(r) && typeof s == "object" && s ? P.setIn(s, i, t) : ie.call(re, i, t), this.hasOwnProperty(r) && s === a) return this;
				var c = ee(this, o(this));
				return c[r] = a, N(c);
			}
			function ae(e, t, n) {
				var r = n && n.deep;
				if (this.hasOwnProperty(e) && (r && this[e] !== t && p(t) && p(this[e]) && (t = P.merge(this[e], t, {
					deep: !0,
					mode: "replace"
				})), f(this[e], t))) return this;
				var i = ee(this, o(this));
				return i[e] = P(t), N(i);
			}
			function oe(e, t) {
				var n = Array.prototype.slice.call(arguments, 2), r = this[e];
				return P.set(this, e, t.apply(r, [r].concat(n)));
			}
			function se(e, t) {
				for (var n = 0, r = t.length; e != null && n < r; n++) e = e[t[n]];
				return n && n == r ? e : void 0;
			}
			function ce(e, t) {
				var n = Array.prototype.slice.call(arguments, 2), r = se(this, e);
				return P.setIn(this, e, t.apply(r, [r].concat(n)));
			}
			function le(e, t) {
				var n = se(this, e);
				return n === void 0 ? t : n;
			}
			function ue(e) {
				var t = o(this), n;
				if (e && e.deep) for (n in this) this.hasOwnProperty(n) && (t[n] = M(this[n]));
				else for (n in this) this.hasOwnProperty(n) && (t[n] = this[n]);
				return t;
			}
			function de() {
				return {};
			}
			function N(e) {
				return i.use_static || (s(e, "merge", te), s(e, "replace", ne), s(e, "without", k), s(e, "asMutable", ue), s(e, "set", ae), s(e, "setIn", ie), s(e, "update", oe), s(e, "updateIn", ce), s(e, "getIn", le)), b(e, m);
			}
			function fe(e) {
				return typeof e == "object" && !!e && (e.$$typeof === r || e.$$typeof === t);
			}
			function pe(e) {
				return typeof File < "u" && e instanceof File;
			}
			function me(e) {
				return typeof Blob < "u" && e instanceof Blob;
			}
			function he(e) {
				return typeof e == "object" && typeof e.then == "function";
			}
			function ge(e) {
				return e instanceof Error;
			}
			function P(e, t, n) {
				if (d(e) || fe(e) || pe(e) || me(e) || ge(e)) return e;
				if (he(e)) return e.then(P);
				if (Array.isArray(e)) return T(e.slice());
				if (e instanceof Date) return E(new Date(e.getTime()));
				var r = t && t.prototype, i = (!r || r === Object.prototype ? de : (function() {
					return Object.create(r);
				}))();
				if (n ??= 64, n <= 0) throw new y("Attempt to construct Immutable from a deeply nested object was detected. Have you tried to wrap an object with circular references (e.g. React element)? See https://github.com/rtfeldman/seamless-immutable/wiki/Deeply-nested-object-was-detected for details.");
				for (var a in --n, e) Object.getOwnPropertyDescriptor(e, a) && (i[a] = P(e[a], void 0, n));
				return N(i);
			}
			function _e(e) {
				function t() {
					var t = [].slice.call(arguments), n = t.shift();
					return e.apply(n, t);
				}
				return t;
			}
			function ve(e, t) {
				function n() {
					var n = [].slice.call(arguments), r = n.shift();
					return Array.isArray(r) ? t.apply(r, n) : e.apply(r, n);
				}
				return n;
			}
			function ye(e, t, n) {
				function r() {
					var r = [].slice.call(arguments), i = r.shift();
					return Array.isArray(i) ? t.apply(i, r) : i instanceof Date ? n.apply(i, r) : e.apply(i, r);
				}
				return r;
			}
			return P.from = P, P.isImmutable = d, P.ImmutableError = y, P.merge = _e(te), P.replace = _e(ne), P.without = _e(k), P.asMutable = ye(ue, A, D), P.set = ve(ae, S), P.setIn = ve(ie, w), P.update = _e(oe), P.updateIn = _e(ce), P.getIn = _e(le), P.flatMap = _e(O), P.asObject = _e(j), i.use_static || (P.static = n({ use_static: !0 })), Object.freeze(P), P;
		}
		var r = n();
		/* istanbul ignore if */
		typeof define == "function" && define.amd ? define(function() {
			return r;
		}) : typeof t == "object" ? t.exports = r : typeof e == "object" ? e.Immutable = r : typeof window == "object" ? window.Immutable = r : typeof global == "object" && (global.Immutable = r);
	})();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/UrlManager/UrlManager.js
function fb(e) {
	return Array.isArray(e) && e.length ? e.reduce((e, t) => (e.some((e) => mb(e, t)) || e.push(t), e), [e[0]]) : e;
}
function pb(e, t) {
	if (e instanceof Array && t instanceof Array) return fb([...e, ...t]);
}
function mb(e, t) {
	if (!e && !t) return !0;
	if (!e && t || e && !t) return !1;
	let n = [
		"string",
		"number",
		"boolean",
		"undefined"
	], r = typeof e;
	if (r !== typeof t) return !1;
	if (n.includes(r)) return e === t;
	let i = Array.isArray(e);
	if (i !== Array.isArray(t)) return !1;
	if (i) {
		if (e.length != t.length) return !1;
		for (let n = 0; n < e.length; n++) if (!mb(e[n], t[n])) return !1;
	} else {
		if (!mb(Object.keys(e).sort(), Object.keys(t).sort())) return !1;
		let n = !0;
		return Object.keys(e).forEach((r) => {
			mb(e[r], t[r]) || (n = !1);
		}), n;
	}
	return !0;
}
var hb, gb, _b, vb = o((() => {
	hb = /* @__PURE__ */ u(db()), gb = class {
		constructor() {
			this.callbacks = [];
		}
		subscribe(e) {
			return this.callbacks.push(e), () => this.callbacks = this.callbacks.filter((t) => t != e);
		}
		notify() {
			this.callbacks.forEach((e) => e());
		}
	}, _b = class e {
		constructor(e, t, n, r, i, a = [], o) {
			this.linker = t, this.omissions = a, this.detached = o, this.urlState = (0, hb.default)({}), this.globalState = (0, hb.default)({}), this.localState = (0, hb.default)({}), this.mergedState = (0, hb.default)({}), this.localState = (0, hb.default)(r || {}), this.globalState = (0, hb.default)(n || {}), this.translator = e;
			let s = this.getTranslatorConfig();
			s.urlRoot && s.settings?.serializeUrlRoot && (this.globalState = this.globalState.merge((0, hb.default)(this.translator.deserialize(s.urlRoot)), {
				deep: !0,
				merger: pb
			})), i ? this.watcherPool = i : (this.watcherPool = new gb(), this.translator.bindExternalEvents instanceof Function && this.translator.bindExternalEvents(() => this.watcherPool.notify())), this.subscribe(() => {
				this.refresh();
			}), this.refresh();
		}
		without(e, t, n) {
			let r = t.slice(0, -1), i = t[t.length - 1];
			if (!r.length) return n?.length ? a(i, e) : e.without(i);
			if (!e.getIn(r)) return e;
			return e.updateIn(r, (e) => a(i, e));
			function a(e, t) {
				return t[i] === void 0 ? t : t[i] instanceof Array ? !n || !n.length ? t.without(i) : t.set(i, t[i].filter((e) => !n.some((t) => mb(e, t)))) : typeof t == "object" ? t.without(i) : t;
			}
		}
		getTranslatorUrl() {
			return this.detached ? this.detached.url : this.translator.getCurrentUrl();
		}
		refresh() {
			this.prevState = this.mergedState, this.urlState = this.omissions.reduce((e, t) => this.without(e, t.path, t.values), (0, hb.default)(this.translator.deserialize(this.getTranslatorUrl()))), this.mergedState = this.globalState.merge(this.urlState, {
				deep: !0,
				merger: pb
			}), this.mergedState = this.mergedState.merge(this.localState, {
				deep: !0,
				merger: pb
			});
		}
		get state() {
			return this.mergedState;
		}
		unpackPathAndState(e, t) {
			return {
				path: e instanceof Array ? e : typeof e == "string" ? e.split(".") : [],
				state: !(e instanceof Array) && typeof e == "object" ? e : t === void 0 ? {} : t
			};
		}
		set(...t) {
			let { path: n, state: r } = this.unpackPathAndState(t[0], t[1]), i = n.length ? this.localState.setIn(n, fb(r)) : fb(r), a = fb(this.omissions.concat(n.length ? { path: n } : Object.keys(this.urlState).map((e) => ({ path: [e] }))));
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, a, this.detached);
		}
		merge(...t) {
			let { path: n, state: r } = this.unpackPathAndState(t[0], t[1]), i = n.length ? this.localState.updateIn(n, (e) => {
				if (e instanceof Array) {
					let t = Array.isArray(r) ? r : [r];
					return fb(e.concat(t));
				}
				if (typeof e == "object") return Array.isArray(r) ? r.length ? fb([e].concat(r)) : e : e.merge(r, {
					deep: !0,
					merger: pb
				});
				if (e !== void 0) {
					let t = (Array.isArray(r) ? r : [r]).filter((t) => !mb(t, e));
					return t.length ? fb([e].concat(t)) : e;
				}
				return e === void 0 && this.urlState.getIn(n) instanceof Array && !Array.isArray(r) ? [r] : r;
			}) : this.localState.merge(r, {
				deep: !0,
				merger: pb
			});
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, this.omissions, this.detached);
		}
		remove(t, n) {
			let { path: r } = this.unpackPathAndState(t, {});
			n = n === void 0 ? [] : n instanceof Array ? n : [n];
			let i = this.without(this.localState, r, n), a = fb(this.omissions.concat({
				path: r,
				values: n
			}));
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, a, this.detached);
		}
		reset() {
			return this.detached && (this.detached.url = ""), new e(this.translator, this.linker, this.globalState, {}, this.watcherPool, Object.keys(this.urlState).map((e) => ({ path: [e] })), this.detached);
		}
		withConfig(t) {
			return t instanceof Function && (t = t(this.translator.getConfig())), new e(new (Object.getPrototypeOf(this.translator)).constructor(t), this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
		}
		withGlobals(t) {
			return this.globalState = this.globalState.merge((0, hb.default)(t), {
				deep: !0,
				merger: pb
			}), new e(this.translator, this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
		}
		getTranslatorConfig() {
			return this.translator.getConfig();
		}
		get href() {
			return this.translator.serialize(this.state);
		}
		go(e) {
			this.detached ? this.detached.url = this.href : this.translator.go(this.href, e), this.watcherPool.notify();
		}
		detach(t = !1) {
			return new e(this.translator, this.linker, this.globalState, this.localState, new gb(), this.omissions, { url: t ? "" : this.getTranslatorUrl() });
		}
		get link() {
			return this.linker ? this.linker(this) : {};
		}
		subscribe(e) {
			return this.watcherPool.subscribe(() => {
				let t = this.prevState, n = this.mergedState;
				e(t, n);
			});
		}
	};
})), yb, bb, xb = o((() => {
	(function(e) {
		e.LOW = "low", e.HIGH = "high";
	})(yb ||= {}), (function(e) {
		e.hash = "hash", e.query = "query";
	})(bb ||= {});
})), Sb = o((() => {
	U(), db();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/Translators/Url/UrlTranslator.js
function Cb(e) {
	return typeof e == "string" && (e = e.replace(/%2425/g, "$$25"), e = e.replace(/\$25/g, "%"), e = decodeURIComponent(e)), e;
}
function wb(e) {
	return typeof e == "string" && (e = encodeURIComponent(e), e = e.replace(/%/g, "$$25")), e;
}
var Tb, Eb, Db, Ob, kb = o((() => {
	Tb = /* @__PURE__ */ u(U()), xb(), Eb = {
		urlRoot: "",
		settings: {
			corePrefix: "",
			customType: bb.query,
			serializeUrlRoot: !0
		},
		parameters: {
			core: {
				query: {
					name: "q",
					type: bb.query
				},
				rq: {
					name: "rq",
					type: bb.query
				},
				tag: {
					name: "tag",
					type: bb.query
				},
				page: {
					name: "page",
					type: bb.query
				},
				pageSize: {
					name: "pageSize",
					type: bb.hash
				},
				sort: {
					name: "sort",
					type: bb.hash
				},
				filter: {
					name: "filter",
					type: bb.hash
				},
				fallbackQuery: {
					name: "fallbackQuery",
					type: bb.query
				}
			},
			custom: {}
		}
	}, Db = [
		"query",
		"fallbackQuery",
		"rq",
		"tag",
		"page",
		"pageSize",
		"sort",
		"filter"
	], Ob = class {
		constructor(e) {
			this.reverseMapping = {}, this.coreNames = {}, this.config = (0, Tb.default)(Eb, e || {}), Object.keys(this.config.parameters.core).forEach((t) => {
				let n = this.config.parameters.core[t], r = this.config.settings.corePrefixParams, i = (!r || r.includes(t)) && this.config.settings.corePrefix || "";
				this.coreNames[t] = i + n.name;
				let a = this.config.settings?.coreType;
				a && Object.values(bb).includes(a) && (n.type = e?.parameters?.core && e.parameters?.core[t]?.type ? e.parameters?.core[t]?.type : a), this.reverseMapping[this.coreNames[t]] = t;
			});
			let t = this.config.settings?.customType;
			t && !Object.values(bb).includes(t) && (this.config.settings.customType = bb.hash);
		}
		bindExternalEvents(e) {
			window.addEventListener("popstate", e);
		}
		getCurrentUrl() {
			return window.location.search + window.location.hash;
		}
		getConfig() {
			return (0, Tb.default)({}, this.config);
		}
		deserialize(e) {
			let t = this.parseUrlParams(e);
			return this.paramsToState(t);
		}
		parseUrlParams(e) {
			let t = e.includes("?") && (e.split("?").pop() || "").split("#").shift() || "", n = e.includes("#") && e.substring(e.indexOf("#") + 1) || "";
			return [...this.parseHashString(n), ...this.parseQueryString(t)];
		}
		parseQueryString(e) {
			return (e.split("?").pop() || "").split("&").filter((e) => e).map((e) => {
				try {
					let [t, n] = e.split("=").map((e) => decodeURIComponent(e.replace(/\+/g, " ")));
					return {
						key: t.split("."),
						value: n,
						type: bb.query
					};
				} catch {
					return console.warn("Snap UrlTranslator: URI malformed - ignoring parameter", e), {
						key: ["ss__delete"],
						value: "ss__delete",
						type: bb.query
					};
				}
			}).filter((e) => {
				let t = this.reverseMapping[e.key[0]];
				return e.value === "ss__delete" ? "" : !t || t && e.value;
			});
		}
		parseHashString(e) {
			let t = [];
			return (e.split("#").pop() || "").split("/").filter((e) => e).map((e) => {
				try {
					return e.split(":").map((e) => Cb(e));
				} catch {
					return console.warn("Snap UrlTranslator: URI malformed - ignoring parameter", e), [];
				}
			}).filter((e) => {
				let [t, n] = e, r = this.reverseMapping[t];
				return !r || r && n;
			}).forEach((e) => {
				if (e.length == 1) t.push({
					key: [e[0]],
					value: "",
					type: bb.hash
				});
				else if (e.length && e.length >= 2) {
					let n = this.reverseMapping[e[0]];
					if (n && n == "filter" && e.length == 4) {
						let [n, r, i, a] = e;
						t.push({
							key: [
								n,
								r,
								"low"
							],
							value: i,
							type: bb.hash
						}), t.push({
							key: [
								n,
								r,
								"high"
							],
							value: a,
							type: bb.hash
						});
					} else {
						let [n, ...r] = e.reverse();
						t.push({
							key: r.reverse(),
							value: n,
							type: bb.hash
						});
					}
				}
			}), t;
		}
		paramsToState(e) {
			let t = [], n = [], r = [], i = [];
			return e?.forEach((e) => {
				let a = this.reverseMapping[e.key[0]], o = this.config.parameters.core[a], s = this.config.parameters.custom[e.key[0]];
				if (a) switch (a) {
					case "filter":
						o.type == e.type && n.push(e);
						break;
					case "sort":
						o.type == e.type && r.push(e);
						break;
					default: o.type == e.type && t.push(e);
				}
				else Db.includes(e.key[0]) || (s || (this.config.parameters.custom[e.key[0]] = { type: e.type || this.config.settings.customType }), i.push(e));
			}), {
				...this.parseCoreOther(t),
				...this.parseCoreFilter(n),
				...this.parseCoreSort(r),
				...this.parseOther(i)
			};
		}
		parseCoreOther(e) {
			let t = {}, n = ["page", "pageSize"];
			return e ? (e.forEach((e) => {
				let r = this.reverseMapping[e.key[0]];
				if (n.includes(r)) {
					let n = Number(e.value);
					(r == "page" && n > 1 || r != "page") && (t[r] = n);
				} else t[r] = e.value;
			}), t) : {};
		}
		parseCoreFilter(e) {
			let t = e.filter((e) => e.key.length == 2), n = e.filter((e) => e.key.length == 3), r = t.reduce((e, t) => {
				let n = (e.filter || {})[t.key[1]] || [];
				return { filter: {
					...e.filter,
					[t.key[1]]: [...Array.isArray(n) ? n : [n], t.value]
				} };
			}, {}), i = n.reduce((e, t, r) => {
				let i = e, a = n[r + 1];
				if (r % 2 == 0 && a && a.key[1] == t.key[1] && t.key[2] == yb.LOW && a.key[2] == yb.HIGH) {
					let n = (e.filter || {})[t.key[1]] || [];
					i = { filter: {
						...e.filter,
						[t.key[1]]: [...Array.isArray(n) ? n : [n], {
							[yb.LOW]: isNaN(+t.value) ? null : +t.value,
							[yb.HIGH]: isNaN(+a.value) ? null : +a.value
						}]
					} };
				}
				return i;
			}, {});
			return { ...r.filter || i.filter ? { filter: {
				...r.filter,
				...i.filter
			} } : {} };
		}
		parseCoreSort(e) {
			return e.length ? { sort: e.map((e) => ({
				field: e.key[1],
				direction: e.value
			})) } : {};
		}
		parseOther(e) {
			let t = {};
			return e.forEach((e) => {
				let n = t;
				e.key.forEach((t, r) => {
					r == e.key.length - 1 ? (n[t] = n[t] || [], e.value && n[t].push(e.value)) : (n[t] = n[t] || {}, n = n[t]);
				});
			}), t;
		}
		serialize(e) {
			let t = this.config.urlRoot.includes("?") ? this.config.urlRoot.split("?")[0] : this.config.urlRoot.includes("#") ? this.config.urlRoot.split("#")[0] : this.config.urlRoot || window.location.pathname, n = this.stateToParams(e), r = n.filter((e) => e.type == bb.query), i = n.filter((e) => e.type == bb.hash);
			return `${t}${r.length ? "?" + r.map((e) => encodeURIComponent(e.key.join(".")) + (e.value ? "=" + encodeURIComponent(e.value) : "")).join("&") : ""}${i.length ? "#/" + i.map((e) => e.key.map((e) => wb(e)).join(":") + (e.value ? ":" + wb(e.value) : "")).join("/") : ""}`;
		}
		stateToParams(e) {
			return [
				...this.encodeOther(e),
				...this.encodeCoreOther(e, ["filter", "sort"]),
				...this.encodeCoreFilters(e),
				...this.encodeCoreSorts(e)
			];
		}
		encodeCoreFilters(e) {
			let t = this.config.parameters.core.filter, n = this.coreNames.filter;
			return !e.filter || !t ? [] : Object.keys(e.filter).flatMap((r) => {
				if (!e.filter || !e.filter[r]) return [];
				let i = e.filter[r];
				return (i instanceof Array ? i : [i]).flatMap((e) => {
					if (typeof e == "string" || typeof e == "number" || typeof e == "boolean") return [{
						key: [n, r],
						value: "" + e,
						type: t.type
					}];
					if (typeof e == "object" && e[yb.LOW] !== void 0 && e[yb.HIGH] !== void 0) {
						if (t.type == bb.query) return [{
							key: [
								n,
								r,
								yb.LOW
							],
							value: "" + (e[yb.LOW] ?? "*"),
							type: t.type
						}, {
							key: [
								n,
								r,
								yb.HIGH
							],
							value: "" + (e[yb.HIGH] ?? "*"),
							type: t.type
						}];
						if (t.type == bb.hash) return [{
							key: [
								n,
								r,
								"" + (e[yb.LOW] ?? "*")
							],
							value: "" + (e[yb.HIGH] ?? "*"),
							type: t.type
						}];
					}
					return [];
				});
			});
		}
		encodeCoreSorts(e) {
			let t = this.config.parameters.core.sort;
			return !e.sort || !t ? [] : (e.sort instanceof Array ? e.sort : [e.sort]).map((e) => ({
				key: [this.coreNames.sort, e.field],
				value: e.direction,
				type: t.type
			}));
		}
		encodeCoreOther(e, t) {
			let n = [];
			return Object.keys(e).sort(function(e, t) {
				return Db.indexOf(e) - Db.indexOf(t);
			}).map((r) => {
				if (Db.includes(r) && !t.includes(r)) {
					let t = this.config.parameters.core[r];
					r == "page" && e[r] == 1 || n.push({
						key: [this.coreNames[r]],
						value: "" + e[r],
						type: t.type
					});
				}
			}), n;
		}
		encodeOther(e) {
			let t = [], n = (e, r) => {
				Object.keys(e).forEach((i) => {
					if (r.length == 0 && Db.includes(i)) return;
					let a = e[i];
					if (a instanceof Array) {
						let e = this.config.parameters.custom[r[0] || i]?.type || this.config.settings.customType;
						t = a.length ? t.concat(a.map((t) => ({
							key: [...r, i],
							value: t,
							type: e
						}))) : t.concat({
							key: [...r, i],
							value: "",
							type: e
						});
					} else if (typeof a == "object" && Object.keys(a || {}).length) n(a, [...r, i]);
					else {
						let e = this.config.parameters.custom[r[0] || i]?.type || this.config.settings.customType, n = typeof a == "object" ? void 0 : a;
						t = t.concat([{
							key: [...r, i],
							value: n,
							type: e
						}]);
					}
				});
			};
			return n(e, []), t;
		}
		go(e, t) {
			e != this.getCurrentUrl() && (t?.history == "replace" ? history.replaceState(null, "", e) : history.pushState(null, "", e));
		}
	};
})), Ab = o((() => {})), jb = o((() => {
	Sb(), kb(), Ab();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/linkers/react/react.js
function Mb(e) {
	return {
		href: e.href,
		onClick: (t) => {
			e?.detached || t?.preventDefault(), e.go();
		}
	};
}
var Nb = o((() => {})), Pb = o((() => {
	Nb();
})), Fb = o((() => {
	vb(), jb(), Pb();
})), Ib, Lb, Rb = o((() => {
	Ib = class {
		constructor(e) {
			this.namespace = e || "", this.profiles = [];
		}
		setNamespace(e) {
			this.namespace ||= e;
		}
		create({ type: e, name: t, context: n }) {
			if (!t) throw Error("Profile name is required.");
			let r = new Lb(this.namespace, {
				type: e,
				name: t,
				context: n
			});
			return this.profiles.push(r), r;
		}
	}, Lb = class {
		constructor(e, { type: t, name: n, context: r }) {
			this.status = "pending", this.time = {
				date: 0,
				begin: 0,
				end: 0,
				run: 0
			}, this.namespace = e, this.type = t, this.name = n, this.context = r;
		}
		start() {
			return this.time.begin || (this.time.date = Date.now(), this.time.begin = window.performance.now(), this.status = "started"), this;
		}
		stop() {
			return !this.time.end && this.time.begin && (this.time.date = Date.now(), this.time.end = window.performance.now(), this.time.run = +(this.time.end - this.time.begin).toFixed(3), this.status = "finished"), this;
		}
	};
})), zb = o((() => {
	Rb();
})), Bb = /* @__PURE__ */ c({ default: () => Vb }), Vb, Hb = o((() => {
	sb(), kd(), gy(), Fb(), ay(), zb(), Id(), C_(), Vb = (e, t) => {
		let n = t?.urlManager || new _b(new Ob(e.url), Mb);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new Vy(e.controller, {
			client: t?.client || new Dd(e.client.globals, e.client.config),
			store: t?.store || new Xv(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new ny(),
			profiler: t?.profiler || new Ib(),
			logger: t?.logger || new Pd({ mode: e.mode }),
			tracker: t?.tracker || new b_(e.client.globals)
		}, e.context);
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/src/utils/configureSnapFeatures/configureSnapFeatures.js
function Ub(e) {
	Wb(e);
}
function Wb(e) {
	let t;
	try {
		t = window.sessionStorage?.getItem(Gb);
	} catch {}
	if (t) try {
		if (JSON.parse(t)?.enabled) {
			let t = [
				"product.view",
				"cart.view",
				"order.transaction"
			];
			e.tracker = e.tracker || {}, e.tracker.config = e.tracker.config || {}, e.tracker.config.doNotTrack = (e.tracker.config.doNotTrack || []).concat(t);
		}
	} catch {}
}
var Gb, Kb = o((() => {
	Gb = "ssWebPixel";
})), qb = o((() => {
	Kb();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/src/setupEvents.js
ay();
var Jb = () => {
	let e = new ny();
	return e.on("controller/selectVariantOptions", async (e, t) => {
		let { options: n, controllerIds: r } = e;
		Yb(r).map((e) => {
			e.store?.results && e.store?.results.forEach((e) => {
				e.type == "product" && e.variants?.makeSelections(n);
			});
		}), await t();
	}), e.on("controller/recommendation/update", async (e, t) => {
		let { controllerIds: n } = e || {};
		Yb(n).filter((e) => !!(e.type === "recommendation" && e.config?.realtime)).map((e) => {
			e.search();
		}), await t();
	}), e;
}, Yb = (e) => Object.keys(window.athos.controller || {}).reduce((t, n) => {
	let r = window.athos.controller[n];
	return (!e || (Array.isArray(e) && e.forEach((e) => {
		if (e instanceof RegExp) {
			if (n.match(e)?.length) return t.push(r), t;
		} else if (n == e) return t.push(r), t;
	}), typeof e == "string" && e === n)) && t.push(r), t;
}, []), Xb = /* @__PURE__ */ c({ default: () => Zb }), Zb, Qb = o((() => {
	sb(), kd(), gy(), Fb(), ay(), zb(), Id(), C_(), Zb = (e, t) => {
		let { globals: n, ...r } = e.url || {}, i = (t?.urlManager || new _b(new Ob(r), Mb)).detach();
		return n?.length && (i = i.withGlobals(Object.fromEntries(n.map(({ param: e, value: t }) => [e, [t]])))), e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new eb(e.controller, {
			client: t?.client || new Dd(e.client.globals, e.client.config),
			store: t?.store || new zv(e.controller, { urlManager: i }),
			urlManager: i,
			eventManager: t?.eventManager || new ny(),
			profiler: t?.profiler || new Ib(),
			logger: t?.logger || new Pd({ mode: e.mode }),
			tracker: t?.tracker || new b_(e.client.globals)
		}, e.context);
	};
})), $b = /* @__PURE__ */ c({ default: () => ex }), ex, tx = o((() => {
	sb(), kd(), gy(), Fb(), ay(), zb(), Id(), C_(), ex = (e, t) => {
		let n = (t?.urlManager || new _b(new Ob(e.url), Mb)).detach(!0);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new Ty(e.controller, {
			client: t?.client || new Dd(e.client.globals, e.client.config),
			store: t?.store || new Jv(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new ny(),
			profiler: t?.profiler || new Ib(),
			logger: t?.logger || new Pd({ mode: e.mode }),
			tracker: t?.tracker || new b_(e.client.globals)
		}, e.context);
	};
})), nx = /* @__PURE__ */ c({ default: () => rx }), rx, ix = o((() => {
	sb(), kd(), gy(), Fb(), ay(), zb(), Id(), C_(), rx = (e, t) => {
		let n = (t?.urlManager || new _b(new Ob(e.url), Mb)).detach(!0);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new ab(e.controller, {
			client: t?.client || new Dd(e.client.globals, e.client.config),
			store: t?.store || new fy(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new ny(),
			profiler: t?.profiler || new Ib(),
			logger: t?.logger || new Pd({ mode: e.mode }),
			tracker: t?.tracker || new b_(e.client.globals)
		}, e.context);
	};
})), ax = /* @__PURE__ */ c({ getBundleDetails: () => ox }), ox, sx = o((() => {
	ox = async (e) => new Promise((t, n) => {
		let r = new XMLHttpRequest();
		r.open("HEAD", e, !0), r.onreadystatechange = () => {
			if (r.readyState === r.DONE) {
				let i = r.status, a = r.getResponseHeader("Last-Modified");
				a && i === 0 || i >= 200 && i < 400 ? t({
					url: e,
					lastModified: a?.split(",")[1]?.trim() || ""
				}) : n({
					message: "Branch not found!",
					description: "Incorrect branch name or branch no longer exists."
				});
			}
		}, r.onerror = () => n({
			message: "Branch load fail!",
			description: "There was an error with the request."
		}), r.send();
	});
}));
//#endregion
//#region node_modules/@emotion/react/dist/emotion-react.browser.esm.js
function cx() {
	return Jr([...arguments]);
}
var lx, ux = o((() => {
	bi(), ln(), li(), ai(), Lr(), lx = function(e, t) {
		var n = arguments;
		if (t == null || !hi.call(t, "css")) return m.apply(void 0, n);
		var r = n.length, i = Array(r);
		i[0] = yi, i[1] = _i(e, t);
		for (var a = 2; a < r; a++) i[a] = n[a];
		return m.apply(null, i);
	};
})), X = /* @__PURE__ */ s(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})), dx = o((() => {
	if (kl(), ln(), !I) throw Error("mobx-react-lite requires React with Hooks support");
	if (!ss) throw Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
})), fx = o((() => {
	ln();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/utils/observerBatching.js
function px(e) {
	e();
}
function mx(e) {
	e ||= px, zo({ reactionScheduler: e });
}
var hx = o((() => {
	kl();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/utils/printDebugValue.js
function gx(e) {
	return Vo(e);
}
var _x = o((() => {
	kl();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/staticRendering.js
function vx() {
	return yx;
}
var yx, bx = o((() => {
	yx = !1;
})), xx, Sx, Cx, wx, Tx = o((() => {
	xx = 1e4, Sx = 1e4, Cx = function() {
		function e(e) {
			var t = this;
			Object.defineProperty(this, "finalize", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: e
			}), Object.defineProperty(this, "registrations", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: /* @__PURE__ */ new Map()
			}), Object.defineProperty(this, "sweepTimeout", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: void 0
			}), Object.defineProperty(this, "sweep", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: function(e) {
					e === void 0 && (e = xx), clearTimeout(t.sweepTimeout), t.sweepTimeout = void 0;
					var n = Date.now();
					t.registrations.forEach(function(r, i) {
						n - r.registeredAt >= e && (t.finalize(r.value), t.registrations.delete(i));
					}), t.registrations.size > 0 && t.scheduleSweep();
				}
			}), Object.defineProperty(this, "finalizeAllImmediately", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: function() {
					t.sweep(0);
				}
			});
		}
		return Object.defineProperty(e.prototype, "register", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function(e, t, n) {
				this.registrations.set(n, {
					value: t,
					registeredAt: Date.now()
				}), this.scheduleSweep();
			}
		}), Object.defineProperty(e.prototype, "unregister", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function(e) {
				this.registrations.delete(e);
			}
		}), Object.defineProperty(e.prototype, "scheduleSweep", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function() {
				this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, Sx));
			}
		}), e;
	}(), wx = typeof FinalizationRegistry < "u" ? FinalizationRegistry : Cx;
})), Ex, Dx = o((() => {
	Tx(), Ex = new wx(function(e) {
		var t;
		(t = e.reaction) == null || t.dispose(), e.reaction = null;
	});
})), Ox = /* @__PURE__ */ s(((e) => {
	var t = (ln(), d(ct));
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var f = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? f : t.useSyncExternalStore;
})), kx = /* @__PURE__ */ s(((e, t) => {
	t.exports = Ox();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/useObserver.js
function Ax(e) {
	e.reaction = new Ac(`observer${e.name}`, function() {
		var t;
		e.stateVersion = Symbol(), (t = e.onStoreChange) == null || t.call(e);
	});
}
function jx(e, t) {
	if (t === void 0 && (t = "observed"), vx()) return e();
	var n = z.useRef(null);
	if (!n.current) {
		var r = {
			reaction: null,
			onStoreChange: null,
			stateVersion: Symbol(),
			name: t,
			subscribe: function(e) {
				return Ex.unregister(r), r.onStoreChange = e, r.reaction || (Ax(r), r.stateVersion = Symbol()), function() {
					var e;
					r.onStoreChange = null, (e = r.reaction) == null || e.dispose(), r.reaction = null;
				};
			},
			getSnapshot: function() {
				return r.stateVersion;
			}
		};
		n.current = r;
	}
	var i = n.current;
	i.reaction || (Ax(i), Ex.register(n, i, i)), z.useDebugValue(i.reaction, gx), (0, Mx.useSyncExternalStore)(i.subscribe, i.getSnapshot, i.getSnapshot);
	var a, o;
	if (i.reaction.track(function() {
		try {
			a = e();
		} catch (e) {
			o = e;
		}
	}), o) throw o;
	return a;
}
var Mx, Nx = o((() => {
	kl(), ln(), _x(), bx(), Dx(), Mx = kx();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/observer.js
function Z(e, t) {
	if (Rx && e.$$typeof === Rx) throw Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
	if (vx()) return e;
	var n = t?.forwardRef ?? !1, r = e, i = e.displayName || e.name;
	if (Lx && e.$$typeof === Lx && (n = !0, r = e.render, typeof r != "function")) throw Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
	var a = function(e, t) {
		return jx(function() {
			return r(e, t);
		}, i);
	};
	return a.displayName = e.displayName, Ix && Object.defineProperty(a, "name", {
		value: e.name,
		writable: !0,
		configurable: !0
	}), e.contextTypes && (a.contextTypes = e.contextTypes), n && (a = vt(a)), a = _t(a), Px(e, a), a;
}
function Px(e, t) {
	Object.keys(e).forEach(function(n) {
		zx[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
	});
}
var Fx, Ix, Lx, Rx, zx, Bx = o((() => {
	ln(), bx(), Nx(), Fx = typeof Symbol == "function" && Symbol.for, Ix = Object.getOwnPropertyDescriptor(function() {}, "name")?.configurable ?? !1, Lx = Fx ? Symbol.for("react.forward_ref") : typeof vt == "function" && vt(function(e) {
		return null;
	}).$$typeof, Rx = Fx ? Symbol.for("react.memo") : typeof _t == "function" && _t(function(e) {
		return null;
	}).$$typeof, zx = {
		$$typeof: !0,
		render: !0,
		compare: !0,
		type: !0,
		displayName: !0
	};
})), Vx = o((() => {
	Nx();
})), Hx = o((() => {
	ln();
})), Ux = o((() => {
	ln();
})), Wx = o((() => {
	ln(), Ux();
})), Q = o((() => {
	dx(), fx(), hx(), Nx(), Dx(), bx(), Bx(), Vx(), Hx(), Wx(), Ux(), mx(on), Ex.finalizeAllImmediately;
})), Gx, Kx, qx = o((() => {
	H(), ux(), Pr(), Gx = Nr({
		key: "ss",
		prepend: !0
	}), Kx = (e) => B(di, {
		value: e.cache || Gx,
		children: e.children
	});
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/providers/controller.js
function Jx(e) {
	return ((t) => B(e, {
		controller: Qx(),
		...t
	}));
}
var Yx, Xx, Zx, Qx, $x = o((() => {
	H(), Oe(), R(), Yx = ue(null), Xx = Yx.Provider, Zx = ({ children: e, controller: t }) => B(Xx, {
		value: t,
		children: e
	}), Qx = () => Re(Yx);
})), eS = o((() => {
	Oe(), R();
})), tS = o((() => {
	Oe(), R(), ux();
})), nS, rS = o((() => {
	Oe(), nS = (e, t) => {
		if (e) return typeof e == "function" ? m(e, t) : typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? e : Array.isArray(e) ? e.map((e) => nS(e, t)) : typeof e?.type == "string" ? e : typeof e?.type == "function" ? m(e.type, {
			...e.props,
			...t
		}) : le(e, t, e.props?.children && nS(e.props.children, t));
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/defined.js
function $(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var iS = o((() => {})), aS = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/sprintf.js
function oS(e, t) {
	for (var n = []; t > 0; n[--t] = e);
	return n.join("");
}
function sS(...e) {
	for (var t = 0, n, r = e[t++], i = [], a, o, s, c; r;) {
		if (a = /^[^\x25]+/.exec(r)) i.push(a[0]);
		else if (a = /^\x25{2}/.exec(r)) i.push("%");
		else if (a = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(r)) {
			if ((n = e[a[1] || t++]) == null || n == null) throw "Too few arguments.";
			if (/[^s]/.test(a[7]) && typeof n != "number") throw "Expecting number but found " + typeof n;
			switch (a[7]) {
				case "b":
					n = n.toString(2);
					break;
				case "c":
					n = String.fromCharCode(n);
					break;
				case "d":
					n = parseInt(n);
					break;
				case "e":
					n = a[6] ? n.toExponential(a[6]) : n.toExponential();
					break;
				case "f":
					n = a[6] ? parseFloat(n).toFixed(a[6]) : parseFloat(n);
					break;
				case "o":
					n = n.toString(8);
					break;
				case "s":
					n = (n = String(n)) && a[6] ? n.substring(0, a[6]) : n;
					break;
				case "u":
					n = Math.abs(n);
					break;
				case "x":
					n = n.toString(16);
					break;
				case "X": n = n.toString(16).toUpperCase();
			}
			n = /[def]/.test(a[7]) && a[2] && n > 0 ? "+" + n : n, s = a[3] ? a[3] == "0" ? "0" : a[3].charAt(1) : " ", c = a[5] - String(n).length, o = a[5] ? oS(s, c) : "", i.push(a[4] ? n + o : o + n);
		} else throw "Huh ?!";
		r = r.substring(a[0].length);
	}
	return i.join("");
}
var cS = o((() => {})), lS = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/mergeProps.js
function uS(e, t, n, r) {
	let i = r.theme, a = r?.name || n.name, o = r.treePath || n.treePath || "";
	o += `${o ? " " : ""}${e}`;
	let s = { ...n };
	if (t?.type !== "templates") {
		let n = t?.components && t.components[e];
		n && (s = dS(n, s)), s = {
			...s,
			...r,
			treePath: o
		};
		let a = i?.components && i.components[e];
		a && (s = dS(a, s));
	} else {
		s = {
			...s,
			...r
		}, o += a?.match(/^[A-Za-z0-9-]+$/) ? `.${a}` : "";
		let e = pS(t?.components || {}, o).sort(fS), n = e.filter((e) => e.includes("*")), c = e.filter((e) => !e.includes("*")), l = /* @__PURE__ */ new Set();
		n.forEach((e) => {
			let n = t.components?.[e];
			n && (e.replace(/^\*/, "").replace(/\([MDT]\)$/, "").trim().split(" ").length > 1 && Object.keys(n).forEach((e) => l.add(e)), s = dS(n, s));
		});
		let u = r.theme?.[mS];
		if (u instanceof Map && u.size > 0) {
			let e = {}, t = Array.from(u.values());
			for (let n of Object.keys(r)) {
				if (n === "treePath" || n === "theme" || n === "name" || l.has(n)) continue;
				let i = r[n];
				i !== void 0 && t.indexOf(i) !== -1 && (e[n] = i);
			}
			Object.keys(e).length > 0 && (s = {
				...s,
				...e
			});
		}
		c.forEach((e) => {
			let n = t.components?.[e];
			n && (s = dS(n, s, !0));
		}), pS(i?.components || {}, o).sort(fS).forEach((e) => {
			let t = i?.components?.[e];
			t && (s = dS(t, s));
		}), s = {
			...s,
			theme: {
				...s.theme,
				name: t.name,
				...t.activeBreakpoint ? { activeBreakpoint: t.activeBreakpoint } : {}
			},
			treePath: o
		}, r.lang && (s.lang = r.lang), t.variables && s.theme && (s.theme.variables = t.variables);
		let d = s[mS] || /* @__PURE__ */ new Map();
		if (d.size > 0 && s.theme) {
			let e = new Map(d);
			u instanceof Map && u.forEach((t, n) => {
				e.has(n) || e.set(n, t);
			}), s.theme[mS] = e;
		}
		o && (o.indexOf("customComponent") > -1 || o.startsWith("storybook") && o.split(" ").length == 2) && (s = {
			...s,
			...r,
			treePath: o
		});
	}
	return s;
}
function dS(e, t, n = !1) {
	if (e) {
		let r = t[mS] || /* @__PURE__ */ new Map();
		for (let [t, i] of Object.entries(e)) i != null && typeof i != "function" && (!n || !r.has(t)) && r.set(t, i);
		t = {
			...t,
			...e
		}, t[mS] = r;
	}
	return t;
}
function fS(e, t) {
	return e.split(" ").map((e, t) => (t * 2) ** (e.includes(".") ? 2 : 1)).reduce((e, t) => e + t, (e.includes("*") ? 0 : 1e3) + (e.match(/\([MDT]\)/) ? 2e3 : 0)) - t.split(" ").map((e, t) => (t * 2) ** (e.includes(".") ? 2 : 1)).reduce((e, t) => e + t, (t.includes("*") ? 0 : 1e3) + (t.match(/\([MDT]\)/) ? 2e3 : 0));
}
function pS(e, t) {
	let n = Object.keys(e), r = t.split(" "), [i, a] = (r.slice(-1).pop() ?? "").split("."), o = r.map((e) => {
		let [t, n] = e.split(".");
		return {
			type: t,
			name: n,
			path: e
		};
	});
	return n = a ? n.filter((e) => {
		let t = e.split(" "), n = t[t.length - 1].replace(/\*?(\([MDT]\))?/g, "");
		if (n == i || n == `${i}.${a}`) return !0;
	}) : n.filter((e) => e.endsWith(i)), n.filter((e) => {
		let t = e.replace(/\*?(\([MDT]\))?/g, "").split(" ").slice(0, -1);
		if (t.length == 0) return !0;
		for (let e = 0; e < t.length; e++) {
			let n = -1, r = t[e];
			for (let t = n == -1 ? 0 : n; t < o.length; t++) {
				let i = o[t];
				if (r === i.path || r === i.type) {
					n = e;
					break;
				}
			}
			if (n == -1) return !1;
		}
		return !0;
	});
}
var mS, hS = o((() => {
	mS = Symbol.for("__themePropsMap__");
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/mergeStyles.js
function gS(e, t) {
	let { name: n, treePath: r, style: i, styleScript: a, themeStyleScript: o, disableStyles: s } = e, c = {
		"ss-name": n,
		"ss-path": r,
		css: []
	};
	return s || c.css.push(t(e)), o && c.css.push(o(e)), a && c.css.push(a(e)), i && c.css.push(i), c.css?.length == 0 && delete c.css, c;
}
var _S = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/selectionKey.js
function vS(e) {
	return (e == null ? [] : Array.isArray(e) ? e : [e]).map((e) => `${e?.value}:${e?.label}`).join("|");
}
var yS = o((() => {})), bS = o((() => {
	R();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/hooks/useClickOutside.js
function xS(e) {
	let t = Pe(), n = Pe();
	return L(() => {
		t.current = e;
	}), L(() => {
		return document.addEventListener("click", e), () => document.removeEventListener("click", e);
		function e(e) {
			n.current && t.current && !n.current.contains(e.target) && t.current(e);
		}
	}, []), n;
}
var SS = o((() => {
	R();
})), CS = o((() => {
	R();
})), wS = o((() => {
	R();
})), TS = o((() => {
	R();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/hooks/useIntersectionAdvanced.js
function ES(e) {
	return e && "checkVisibility" in e ? e.checkVisibility({
		contentVisibilityAuto: !0,
		opacityProperty: !0,
		visibilityProperty: !0
	}) : !0;
}
var DS, OS, kS = o((() => {
	R(), DS = 250, OS = (e, t = {}) => {
		let { rootMargin: n = "0px", fireOnce: r = !1, threshold: i = 0, minVisibleTime: a = 0 } = t, [o, s] = I(!1), c = Pe(null), l = Pe(null), [u, d] = I(0), f = Le((t) => {
			e.current = t, d((e) => e + 1);
		}, []);
		return L(() => {
			s(!1);
			let t = null, o = null;
			if (!window.IntersectionObserver || !e.current) return;
			let u = () => {
				o &&= (window.clearInterval(o), null);
			}, d = () => {
				a > 0 ? (l.current = Date.now(), c.current && window.clearTimeout(c.current), c.current = window.setTimeout(() => {
					s(!0), r && e.current && t && t.unobserve(e.current);
				}, a)) : (s(!0), r && e.current && t && t.unobserve(e.current));
			}, f = () => {
				c.current && window.clearTimeout(c.current), c.current = null, l.current = null, s(!1);
			};
			return t = new IntersectionObserver(([t]) => {
				t.isIntersecting ? e.current && ES(e.current) ? (u(), d()) : (f(), o ||= window.setInterval(() => {
					if (!e.current) {
						u();
						return;
					}
					ES(e.current) && (u(), d());
				}, DS)) : (u(), f());
			}, {
				rootMargin: n,
				threshold: i
			}), e.current && t.observe(e.current), () => {
				s(!1), u(), c.current && window.clearTimeout(c.current), t && e.current && t.unobserve(e.current);
			};
		}, [e, u]), {
			inViewport: o,
			updateRef: f
		};
	};
}));
//#endregion
//#region node_modules/dequal/dist/index.mjs
function AS(e, t, n) {
	for (n of e.keys()) if (jS(n, t)) return n;
}
function jS(e, t) {
	var n, r, i;
	if (e === t) return !0;
	if (e && t && (n = e.constructor) === t.constructor) {
		if (n === Date) return e.getTime() === t.getTime();
		if (n === RegExp) return e.toString() === t.toString();
		if (n === Array) {
			if ((r = e.length) === t.length) for (; r-- && jS(e[r], t[r]););
			return r === -1;
		}
		if (n === Set) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r, i && typeof i == "object" && (i = AS(t, i), !i) || !t.has(i)) return !1;
			return !0;
		}
		if (n === Map) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r[0], i && typeof i == "object" && (i = AS(t, i), !i) || !jS(r[1], t.get(i))) return !1;
			return !0;
		}
		if (n === ArrayBuffer) e = new Uint8Array(e), t = new Uint8Array(t);
		else if (n === DataView) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e.getInt8(r) === t.getInt8(r););
			return r === -1;
		}
		if (ArrayBuffer.isView(e)) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e[r] === t[r];);
			return r === -1;
		}
		if (!n || typeof e == "object") {
			for (n in r = 0, e) if (MS.call(e, n) && ++r && !MS.call(t, n) || !(n in t) || !jS(e[n], t[n])) return !1;
			return Object.keys(t).length === r;
		}
	}
	return e !== e && t !== t;
}
var MS, NS = o((() => {
	MS = Object.prototype.hasOwnProperty;
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/hooks/useDeepCompareEffect.js
function PS(e) {
	let t = Pe(e), n = Pe(0);
	return jS(e, t.current) || (t.current = e, n.current += 1), Ie(() => t.current, [n.current]);
}
function FS(e, t) {
	return L(e, [PS(t)]);
}
var IS = o((() => {
	R(), NS();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/hooks/useDisplaySettings.js
function LS(e) {
	if (!e || !Object.keys(e).length) return;
	let [t, n] = I(RS(e)), r, i = () => {
		function t() {
			n(RS(e));
		}
		r = Ul(() => {
			t();
		}, 50), window.addEventListener("resize", r);
	};
	return L(() => (i(), () => window.removeEventListener("resize", r)), []), FS(() => {
		n(RS(e)), i();
	}, [e]), t;
}
var RS, zS = o((() => {
	R(), Iu(), IS(), RS = (e) => {
		let t, n = window.innerWidth, r = Object.keys(e).map((e) => +e).sort((e, t) => e - t).map((t) => ({ [t]: e[t] }));
		if (r.length) {
			for (let e = 0; e < r.length; e++) {
				let i = r[e], a = parseInt(Object.keys(i)[0]);
				if (e + 1 === r.length || e === 0 && n < a) {
					t = r[e][a];
					break;
				}
				{
					let i = parseInt(Object.keys(r[e + 1])[0]);
					if (n >= a && n < i) {
						t = r[e][a];
						break;
					}
				}
			}
			return t;
		}
		return t;
	};
})), BS = o((() => {
	R();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/hooks/useA11y.js
function VS(e, t, n, r) {
	let i = "ssA11yFocusStyle";
	if (!document.querySelector(`#${i}`)) {
		let e = document.createElement("style");
		e.type = "text/css", e.id = i, e.innerHTML = `[${WS}]:focus-visible { outline: -webkit-focus-ring-color auto 1px !important; }`, document.getElementsByTagName("head")[0].appendChild(e);
	}
	e && !e.attributes?.["ss-a11y"] && (e.setAttribute(WS, !0), e.setAttribute("tabIndex", `${t || 0}`), e.addEventListener("keydown", (t) => {
		(t.code === "Space" || t.code === "Enter") && e.click();
	}), n && e.addEventListener("keydown", function(t) {
		let n = e.querySelectorAll(GS), i = n[0], a = n[n.length - 1];
		if (t.keyCode == US) {
			e.focus(), r && r(t), t.preventDefault(), t.stopPropagation();
			return;
		}
		(t.key === "Tab" || t.keyCode === HS) && (t.shiftKey ? document.activeElement === i && (a.focus(), t.preventDefault()) : document.activeElement === a && (i.focus(), t.preventDefault()));
	}));
}
var HS, US, WS, GS, KS = o((() => {
	HS = 9, US = 27, WS = "ss-a11y", GS = "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type=\"text\"]:not([disabled]), input[type=\"radio\"]:not([disabled]), input[type=\"checkbox\"]:not([disabled]), select:not([disabled]), [tabindex]";
})), qS, JS = o((() => {
	qS = (e, t, n) => {
		let r = n ? {
			...t,
			...n
		} : t, i = {};
		return Object.keys(e).forEach((t) => {
			let n = e && e[t], a = {};
			n && (n?.value && (a.value = typeof n.value == "function" ? {
				"ss-lang": t,
				dangerouslySetInnerHTML: { __html: n.value(r) }
			} : {
				"ss-lang": t,
				dangerouslySetInnerHTML: { __html: n.value }
			}), n?.attributes && Object.keys(n?.attributes).length && (a.attributes = { "ss-lang": t }, n?.attributes?.["aria-label"] && (typeof n.attributes?.["aria-label"] == "function" ? a.attributes["aria-label"] = n.attributes["aria-label"](r) : a.attributes["aria-label"] = n.attributes["aria-label"]), n?.attributes?.["aria-valuetext"] && (typeof n.attributes?.["aria-valuetext"] == "function" ? a.attributes["aria-valuetext"] = n.attributes["aria-valuetext"](r) : a.attributes["aria-valuetext"] = n.attributes["aria-valuetext"]), n?.attributes?.title && (typeof n.attributes?.title == "function" ? a.attributes.title = n.attributes.title(r) : a.attributes.title = n.attributes.title), n?.attributes?.alt && (typeof n.attributes?.alt == "function" ? a.attributes.alt = n.attributes.alt(r) : a.attributes.alt = n.attributes.alt), n?.attributes?.placeholder && (typeof n.attributes?.placeholder == "function" ? a.attributes.placeholder = n.attributes.placeholder(r) : a.attributes.placeholder = n.attributes.placeholder)), a.all = {
				...a.value,
				...a.attributes,
				"ss-lang": t
			}), i[t] = a;
		}), i;
	};
})), YS = o((() => {
	R();
})), XS, ZS = o((() => {
	R(), XS = (e, t) => {
		let [n, r] = I(void 0), [i, a] = I(!1);
		return L(() => {
			let n = !0;
			if (!t) return r(void 0), () => {
				n = !1;
			};
			a(!1);
			let i = e[t];
			if (i && typeof i == "function") {
				let e = i();
				e instanceof Promise ? e.then((e) => {
					n && r(() => e);
				}).catch((e) => {
					n && (a(!0), r(void 0), console.warn(`Failed to load component "${t}".`, e));
				}) : n && r(() => e);
			} else r(void 0), console.warn(`Component "${t}" not found in component map.`);
			return () => {
				n = !1;
			};
		}, [e, t]), {
			ComponentOverride: n,
			shouldWaitForNamedOverride: !!(t && typeof e[t] == "function") && !n && !i
		};
	};
})), QS, $S = o((() => {
	H(), BC(), ZS(), QS = (e, t) => {
		let n = FC()?.templates?.library.import.component?.[e] || {}, { customComponent: r } = t, { ComponentOverride: i, shouldWaitForNamedOverride: a } = XS(n, r), o = r && i ? B(i, {
			...t,
			customComponent: void 0
		}) : null;
		return {
			overrideElement: o,
			shouldRenderDefault: !a && !o,
			shouldWaitForNamedOverride: a
		};
	};
})), eC = o((() => {
	R();
})), tC = o((() => {
	SS(), CS(), wS(), TS(), kS(), zS(), BS(), KS(), JS(), IS(), YS(), ZS(), $S(), eC();
})), nC, rC, iC, aC = o((() => {
	H(), ux(), nC = /* @__PURE__ */ u(X()), Q(), BC(), OC(), tC(), rC = ({ colorText: e }) => cx({
		display: "inline-block",
		boxSizing: "border-box",
		padding: "0.3em 0.9em",
		color: e,
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		overflow: "hidden",
		maxWidth: "100%"
	}), iC = Z((e) => {
		let t = uS("badgeText", mi(), {
			colorText: "#000000",
			treePath: RC()
		}, e), { value: n, tag: r, className: i, internalClassName: a } = t, { overrideElement: o, shouldRenderDefault: s } = QS("badgeText", t);
		if (!s) return o;
		let c = gS(t, rC);
		return n ? B(Kx, { children: B("div", {
			...c,
			className: (0, nC.default)("ss__badge-text", `ss__badge-text--${r}`, i, a),
			children: B("span", {
				className: "ss__badge-text__value",
				children: n
			})
		}) }) : null;
	});
})), oC = o((() => {
	aC();
})), sC, cC, lC, uC = o((() => {
	H(), ux(), sC = /* @__PURE__ */ u(X()), Q(), BC(), OC(), tC(), cC = ({ color: e, colorText: t }) => cx({
		display: "inline-block",
		boxSizing: "border-box",
		padding: "0.3em 0.9em",
		background: e,
		color: t,
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		overflow: "hidden",
		maxWidth: "100%",
		borderRadius: "1em"
	}), lC = Z((e) => {
		let t = uS("badgePill", mi(), {
			color: "rgba(58, 35, 173, 1)",
			colorText: "#fff",
			treePath: RC()
		}, e), { value: n, tag: r, className: i, internalClassName: a } = t, { overrideElement: o, shouldRenderDefault: s } = QS("badgePill", t);
		if (!s) return o;
		let c = gS(t, cC);
		return n ? B(Kx, { children: B("div", {
			...c,
			className: (0, sC.default)("ss__badge-pill", `ss__badge-pill--${r}`, i, a),
			children: B("span", {
				className: "ss__badge-pill__value",
				children: n
			})
		}) }) : null;
	});
})), dC = o((() => {
	uC();
})), fC, pC, mC, hC = o((() => {
	H(), ux(), fC = /* @__PURE__ */ u(X()), Q(), BC(), OC(), tC(), pC = ({ color: e, colorText: t }) => cx({
		display: "inline-block",
		boxSizing: "border-box",
		padding: "0.3em 0.9em",
		background: e,
		color: t,
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		overflow: "hidden",
		maxWidth: "100%"
	}), mC = Z((e) => {
		let t = uS("badgeRectangle", mi(), {
			color: "rgba(58, 35, 173, 1)",
			colorText: "#fff",
			treePath: RC()
		}, e), { value: n, tag: r, className: i, internalClassName: a } = t, { overrideElement: o, shouldRenderDefault: s } = QS("badgeRectangle", t);
		if (!s) return o;
		let c = gS(t, pC);
		return n ? B(Kx, { children: B("div", {
			...c,
			className: (0, fC.default)("ss__badge-rectangle", `ss__badge-rectangle--${r}`, i, a),
			children: B("span", {
				className: "ss__badge-rectangle__value",
				children: n
			})
		}) }) : null;
	});
})), gC = o((() => {
	hC();
})), _C, vC, yC, bC = o((() => {
	H(), ux(), _C = /* @__PURE__ */ u(X()), Q(), BC(), OC(), tC(), vC = () => cx({
		maxHeight: "100%",
		maxWidth: "100%"
	}), yC = Z((e) => {
		let t = uS("badgeImage", mi(), { treePath: RC() }, e), { label: n, url: r, tag: i, className: a, internalClassName: o } = t, { overrideElement: s, shouldRenderDefault: c } = QS("badgeImage", t);
		if (!c) return s;
		let l = gS(t, vC);
		return r ? B(Kx, { children: B("img", {
			...l,
			className: (0, _C.default)("ss__badge-image", `ss__badge-image--${i}`, a, o),
			alt: n || `${i} badge`,
			src: r
		}) }) : null;
	});
})), xC = o((() => {
	bC();
})), SC, CC = o((() => {
	oC(), dC(), gC(), xC(), SC = {
		BadgeText: () => iC,
		BadgePill: () => lC,
		BadgeRectangle: () => mC,
		BadgeImage: () => yC
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/createImpressionObserver.js
function wC(e) {
	let t = Pe(null), { inViewport: n, updateRef: r } = OS(t, {
		...e,
		fireOnce: !0,
		threshold: TC,
		minVisibleTime: EC
	});
	return {
		ref: t,
		inViewport: n,
		updateRef: r
	};
}
var TC, EC, DC = o((() => {
	R(), tC(), TC = .7, EC = 1e3;
})), OC = o((() => {
	rS(), iS(), aS(), cS(), lS(), hS(), _S(), yS(), bS(), CC(), DC();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/providers/withTracking.js
function kC(e) {
	let t = e;
	return (e) => {
		let { controller: n, result: r, banner: i, type: a, content: o, ...s } = e;
		if (e.trackingRef) return B(t, { ...e });
		!n && (!a || !o) && console.warn("Warning: No controller provided to withTracking", e), !r && !i && (!a || !o) && console.warn("Warning: No result or banner provided to withTracking");
		let { ref: c, inViewport: l, updateRef: u } = wC(), d = (r || i || a && o?.[a]?.[0])?.responseId, f = Pe(d), p = Pe(!1);
		f.current !== d && (p.current = !0), L(() => {
			f.current !== d && (f.current = d, u(c.current));
		}, [d, u]), L(() => {
			p.current && !l && (p.current = !1);
		}, [l, d]);
		let m = a && o && !r && ["search", "autocomplete"].includes(n?.type || "");
		l && !p.current && (m ? n?.track.banner.impression(o[a][0]) : r?.bundleSeed || n?.track.product.impression(r || i));
		let h = Le((e) => {
			m ? n?.track.banner.click(e, o[a][0]) : n?.track.product.click(e, r || i);
		}, [
			n,
			r,
			i,
			a,
			o
		]);
		L(() => {
			let e = c.current;
			if (e) return e.setAttribute(AC, "true"), e.addEventListener("click", h, !0), () => {
				e.removeEventListener("click", h, !0);
			};
		}, [h]);
		let g = {
			...s,
			controller: n,
			result: r,
			banner: i,
			type: a,
			content: o,
			trackingRef: Le((e) => {
				u(e);
			}, [u])
		};
		return B(t, { ...g });
	};
}
var AC, jC = o((() => {
	H(), OC(), R(), AC = "sstracking";
})), MC = o((() => {})), NC = o((() => {})), PC, FC, IC = o((() => {
	Oe(), R(), PC = ue(void 0), PC.Provider, FC = () => Re(PC);
})), LC, RC, zC = o((() => {
	Oe(), R(), LC = ue(null), LC.Provider, RC = () => Re(LC) || void 0;
})), BC = o((() => {
	qx(), $x(), eS(), tS(), jC(), MC(), NC(), IC(), zC();
})), VC, HC, UC = o((() => {
	VC = {
		layoutGrid2: "M25.846 34.461v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM25.846 8.615v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM56 34.461v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM56 8.615v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308z",
		layoutGrid3: "M16 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3z"
	}, HC = {
		"angle-up": "M56 39.671c0 0.449-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.786 0.561-1.291 0.561-0.449 0-0.954-0.224-1.291-0.561l-22.052-22.052-22.052 22.052c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z",
		"angle-down": "M56 16.329c0 0.449-0.224 0.954-0.561 1.291l-26.148 26.148c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-26.148-26.148c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l2.806-2.806c0.337-0.337 0.786-0.561 1.291-0.561 0.449 0 0.954 0.224 1.291 0.561l22.052 22.052 22.052-22.052c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l2.806 2.806c0.337 0.337 0.561 0.842 0.561 1.291z",
		"angle-left": "M44.329 4.657c0 0.449-0.224 0.954-0.561 1.291l-22.052 22.052 22.052 22.052c0.337 0.337 0.561 0.842 0.561 1.291s-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-26.148-26.148c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l2.806 2.806c0.337 0.337 0.561 0.786 0.561 1.291z",
		"angle-right": "M44.329 28c0 0.449-0.224 0.954-0.561 1.291l-26.148 26.148c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.786-0.561-1.291 0-0.449 0.224-0.954 0.561-1.291l22.052-22.052-22.052-22.052c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l2.806-2.806c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z",
		bag: "M46.5435 18.6657C46.142 15.4166 43.9379 13.1711 40.4449 13.1711H37.3295C36.8838 5.75827 35.1521 0 28.4228 0C21.5677 0 19.8993 5.75827 19.4922 13.1711H16.1019C12.6083 13.1711 10.3416 15.5058 10.0027 18.6657L6.01336 49.5651L6 49.7409C6 53.1533 8.79407 56 12.1 56H44.4455C47.7521 56 50.5455 53.1407 50.5455 49.729L46.5435 18.6657ZM28.4228 3.29383C32.3475 3.29383 33.6011 6.58138 33.9913 13.1704H22.8164C23.1574 6.58138 24.3442 3.29383 28.4228 3.29383ZM44.4455 52.7055H12.1C10.6488 52.7055 9.372 51.4045 9.32279 49.8448L13.3226 18.7676C13.5301 17.0614 14.8195 16.4643 16.1019 16.4643H19.3833C19.3608 17.2881 19.3601 19.3249 19.3601 20.7598C19.3601 21.6694 20.1032 22.4311 21.02 22.4311C21.9369 22.4311 22.6807 21.6589 22.6807 20.7486C22.6807 19.2391 22.6871 17.2888 22.7096 16.4643H34.1242C34.1544 17.2881 34.1656 19.2635 34.1656 20.7598C34.1656 21.6694 34.9081 22.4311 35.8256 22.4311C36.7418 22.4311 37.4856 21.6589 37.4856 20.7486C37.4856 19.3465 37.4842 18.1119 37.4575 16.4643H40.4449C41.7266 16.4643 42.995 17.0397 43.2235 18.7787L47.2234 49.8218C47.1742 51.3808 45.8981 52.7055 44.4455 52.7055Z",
		ban: "M47.769 27.982c0-3.961-1.163-7.631-3.162-10.72l-27.4 27.364c3.125 2.035 6.832 3.234 10.793 3.234 10.902 0 19.769-8.903 19.769-19.878zM11.465 38.848l27.437-27.4c-3.125-2.108-6.868-3.307-10.902-3.307-10.902 0-19.769 8.903-19.769 19.842 0 4.034 1.199 7.74 3.234 10.866zM55.909 27.982c0 15.481-12.501 28.018-27.909 28.018s-27.909-12.537-27.909-28.018c0-15.445 12.501-27.982 27.909-27.982s27.909 12.537 27.909 27.982z",
		check: "M56 14.921c0 0.903-0.361 1.806-1.012 2.457l-31.071 31.071c-0.65 0.65-1.554 1.012-2.457 1.012s-1.806-0.361-2.457-1.012l-17.992-17.992c-0.65-0.65-1.012-1.554-1.012-2.457s0.361-1.806 1.012-2.457l4.914-4.914c0.65-0.65 1.554-1.012 2.457-1.012s1.806 0.361 2.457 1.012l10.622 10.658 23.701-23.737c0.65-0.65 1.554-1.012 2.457-1.012s1.806 0.361 2.457 1.012l4.914 4.914c0.65 0.65 1.012 1.554 1.012 2.457z",
		"check-thin": "M17.771 40.395l33.749-33.749 4.48 4.48-38.229 38.229-17.771-17.771 4.48-4.48z",
		"chevron-up": "M55.349 39.589l-5.769 5.734c-0.869 0.869-2.259 0.869-3.128 0l-18.452-18.452-18.452 18.452c-0.869 0.869-2.259 0.869-3.128 0l-5.769-5.734c-0.869-0.869-0.869-2.293 0-3.162l25.785-25.75c0.869-0.869 2.259-0.869 3.128 0l25.785 25.75c0.869 0.869 0.869 2.293 0 3.162z",
		"chevron-down": "M55.348 19.573l-25.785 25.75c-0.869 0.869-2.259 0.869-3.128 0l-25.785-25.75c-0.869-0.869-0.869-2.293 0-3.162l5.768-5.734c0.869-0.869 2.259-0.869 3.128 0l18.452 18.452 18.452-18.452c0.869-0.869 2.259-0.869 3.128 0l5.768 5.734c0.869 0.869 0.869 2.293 0 3.162z",
		"chevron-left": "M45.34 9.548l-18.452 18.452 18.452 18.452c0.869 0.869 0.869 2.259 0 3.128l-5.769 5.769c-0.869 0.869-2.259 0.869-3.128 0l-25.785-25.785c-0.869-0.869-0.869-2.259 0-3.128l25.785-25.785c0.869-0.869 2.259-0.869 3.128 0l5.769 5.769c0.869 0.869 0.869 2.259 0 3.128z",
		"chevron-right": "M45.34 29.564l-25.785 25.785c-0.869 0.869-2.259 0.869-3.128 0l-5.768-5.768c-0.869-0.869-0.869-2.259 0-3.128l18.452-18.452-18.452-18.452c-0.869-0.869-0.869-2.259 0-3.128l5.768-5.768c0.869-0.869 2.259-0.869 3.128 0l25.785 25.785c0.869 0.869 0.869 2.259 0 3.128z",
		circle: "M56 28c0 15.458-12.542 28-28 28s-28-12.542-28-28 12.542-28 28-28 28 12.542 28 28z",
		close: "M56 45.064c0 1.178-0.471 2.357-1.32 3.205l-6.411 6.411c-0.849 0.849-2.027 1.32-3.205 1.32s-2.357-0.471-3.205-1.32l-13.859-13.859-13.859 13.859c-0.849 0.849-2.027 1.32-3.205 1.32s-2.357-0.471-3.205-1.32l-6.411-6.411c-0.849-0.849-1.32-2.027-1.32-3.205s0.471-2.357 1.32-3.205l13.859-13.859-13.859-13.859c-0.849-0.849-1.32-2.027-1.32-3.205s0.471-2.357 1.32-3.205l6.411-6.411c0.849-0.849 2.027-1.32 3.205-1.32s2.357 0.471 3.205 1.32l13.859 13.859 13.859-13.859c0.849-0.849 2.027-1.32 3.205-1.32s2.357 0.471 3.205 1.32l6.411 6.411c0.849 0.849 1.32 2.027 1.32 3.205s-0.471 2.357-1.32 3.205l-13.859 13.859 13.859 13.859c0.849 0.849 1.32 2.027 1.32 3.205z",
		"close-thin": "M56 5.638l-22.362 22.362 22.362 22.362-5.638 5.638-22.362-22.362-22.362 22.362-5.638-5.638 22.362-22.362-22.362-22.362 5.638-5.638 22.362 22.362 22.362-22.362z",
		cog: "M37.333 28c0-5.141-4.193-9.333-9.333-9.333s-9.333 4.193-9.333 9.333 4.193 9.333 9.333 9.333 9.333-4.193 9.333-9.333zM56 24.026v8.094c0 0.547-0.438 1.203-1.021 1.312l-6.745 1.021c-0.401 1.167-0.839 2.26-1.422 3.318 1.24 1.786 2.552 3.391 3.901 5.031 0.219 0.255 0.365 0.583 0.365 0.911s-0.109 0.583-0.328 0.839c-0.875 1.167-5.797 6.526-7.036 6.526-0.328 0-0.656-0.146-0.948-0.328l-5.031-3.938c-1.057 0.547-2.188 1.021-3.318 1.385-0.255 2.224-0.474 4.594-1.057 6.781-0.146 0.583-0.656 1.021-1.312 1.021h-8.094c-0.656 0-1.24-0.474-1.312-1.094l-1.021-6.708c-1.13-0.365-2.224-0.802-3.281-1.349l-5.141 3.901c-0.255 0.219-0.583 0.328-0.911 0.328s-0.656-0.146-0.911-0.401c-1.932-1.75-4.484-4.010-6.016-6.125-0.182-0.255-0.255-0.547-0.255-0.839 0-0.328 0.109-0.583 0.292-0.839 1.24-1.677 2.589-3.281 3.828-4.995-0.62-1.167-1.13-2.37-1.495-3.609l-6.672-0.984c-0.62-0.109-1.057-0.693-1.057-1.312v-8.094c0-0.547 0.438-1.203 0.984-1.312l6.781-1.021c0.365-1.167 0.839-2.26 1.422-3.354-1.24-1.75-2.552-3.391-3.901-5.031-0.219-0.255-0.365-0.547-0.365-0.875s0.146-0.583 0.328-0.839c0.875-1.203 5.797-6.526 7.036-6.526 0.328 0 0.656 0.146 0.948 0.365l5.031 3.901c1.057-0.547 2.188-1.021 3.318-1.385 0.255-2.224 0.474-4.594 1.057-6.781 0.146-0.583 0.656-1.021 1.312-1.021h8.094c0.656 0 1.24 0.474 1.312 1.094l1.021 6.708c1.13 0.365 2.224 0.802 3.281 1.349l5.177-3.901c0.219-0.219 0.547-0.328 0.875-0.328s0.656 0.146 0.911 0.365c1.932 1.786 4.484 4.047 6.016 6.198 0.182 0.219 0.255 0.51 0.255 0.802 0 0.328-0.109 0.583-0.292 0.839-1.24 1.677-2.589 3.281-3.828 4.995 0.62 1.167 1.13 2.37 1.495 3.573l6.672 1.021c0.62 0.109 1.057 0.693 1.057 1.312z",
		cogs: "M26.133 27.985c0-4.113-3.354-7.467-7.467-7.467s-7.467 3.354-7.467 7.467 3.354 7.467 7.467 7.467 7.467-3.354 7.467-7.467zM48.533 42.919c0-2.042-1.692-3.733-3.733-3.733s-3.733 1.692-3.733 3.733c0 2.071 1.692 3.733 3.733 3.733 2.071 0 3.733-1.692 3.733-3.733zM48.533 13.052c0-2.042-1.692-3.733-3.733-3.733s-3.733 1.692-3.733 3.733c0 2.071 1.692 3.733 3.733 3.733 2.071 0 3.733-1.692 3.733-3.733zM37.333 25.331v5.396c0 0.379-0.292 0.817-0.671 0.875l-4.521 0.7c-0.233 0.758-0.554 1.487-0.933 2.217 0.817 1.167 1.692 2.246 2.625 3.354 0.117 0.175 0.204 0.35 0.204 0.583 0 0.204-0.058 0.408-0.204 0.554-0.583 0.787-3.85 4.346-4.696 4.346-0.233 0-0.438-0.088-0.613-0.204l-3.354-2.625c-0.729 0.379-1.458 0.671-2.246 0.904-0.146 1.487-0.292 3.092-0.671 4.521-0.117 0.408-0.467 0.7-0.875 0.7h-5.425c-0.408 0-0.817-0.321-0.875-0.729l-0.671-4.462c-0.758-0.233-1.488-0.554-2.188-0.904l-3.442 2.596c-0.146 0.146-0.379 0.204-0.583 0.204-0.233 0-0.438-0.087-0.612-0.233-0.758-0.7-4.2-3.821-4.2-4.667 0-0.204 0.087-0.379 0.204-0.554 0.846-1.108 1.721-2.188 2.567-3.325-0.408-0.788-0.758-1.575-1.021-2.392l-4.433-0.7c-0.408-0.058-0.7-0.438-0.7-0.846v-5.396c0-0.379 0.292-0.817 0.671-0.875l4.521-0.7c0.233-0.758 0.554-1.488 0.933-2.217-0.817-1.167-1.692-2.246-2.625-3.354-0.117-0.175-0.204-0.379-0.204-0.583s0.058-0.408 0.204-0.583c0.583-0.787 3.85-4.317 4.696-4.317 0.233 0 0.438 0.087 0.612 0.204l3.354 2.625c0.729-0.379 1.458-0.671 2.246-0.933 0.146-1.458 0.292-3.063 0.671-4.492 0.117-0.408 0.467-0.7 0.875-0.7h5.425c0.408 0 0.817 0.321 0.875 0.729l0.671 4.463c0.758 0.233 1.488 0.554 2.188 0.904l3.442-2.596c0.175-0.146 0.379-0.204 0.583-0.204 0.233 0 0.438 0.088 0.613 0.233 0.758 0.7 4.2 3.85 4.2 4.667 0 0.204-0.087 0.379-0.204 0.554-0.846 1.138-1.721 2.188-2.537 3.325 0.379 0.787 0.729 1.575 0.992 2.392l4.433 0.671c0.408 0.087 0.7 0.467 0.7 0.875zM56 40.877v4.083c0 0.438-3.762 0.846-4.346 0.904-0.233 0.554-0.525 1.050-0.875 1.517 0.263 0.583 1.488 3.5 1.488 4.025 0 0.087-0.029 0.146-0.117 0.204-0.35 0.204-3.471 2.071-3.617 2.071-0.379 0-2.567-2.917-2.858-3.354-0.292 0.029-0.583 0.058-0.875 0.058s-0.583-0.029-0.875-0.058c-0.292 0.438-2.479 3.354-2.858 3.354-0.146 0-3.267-1.867-3.617-2.071-0.087-0.058-0.117-0.146-0.117-0.204 0-0.496 1.225-3.442 1.488-4.025-0.35-0.467-0.642-0.963-0.875-1.517-0.583-0.058-4.346-0.467-4.346-0.904v-4.083c0-0.438 3.762-0.846 4.346-0.904 0.233-0.525 0.525-1.050 0.875-1.517-0.262-0.583-1.488-3.529-1.488-4.025 0-0.058 0.029-0.146 0.117-0.204 0.35-0.175 3.471-2.042 3.617-2.042 0.379 0 2.567 2.887 2.858 3.325 0.292-0.029 0.583-0.058 0.875-0.058s0.583 0.029 0.875 0.058c0.817-1.137 1.692-2.275 2.683-3.267l0.175-0.058c0.146 0 3.267 1.837 3.617 2.042 0.087 0.058 0.117 0.146 0.117 0.204 0 0.525-1.225 3.442-1.488 4.025 0.35 0.467 0.642 0.992 0.875 1.517 0.583 0.058 4.346 0.467 4.346 0.904zM56 11.010v4.083c0 0.438-3.762 0.846-4.346 0.904-0.233 0.554-0.525 1.050-0.875 1.517 0.263 0.583 1.488 3.5 1.488 4.025 0 0.088-0.029 0.146-0.117 0.204-0.35 0.204-3.471 2.071-3.617 2.071-0.379 0-2.567-2.917-2.858-3.354-0.292 0.029-0.583 0.058-0.875 0.058s-0.583-0.029-0.875-0.058c-0.292 0.438-2.479 3.354-2.858 3.354-0.146 0-3.267-1.867-3.617-2.071-0.087-0.058-0.117-0.146-0.117-0.204 0-0.496 1.225-3.442 1.488-4.025-0.35-0.467-0.642-0.963-0.875-1.517-0.583-0.058-4.346-0.467-4.346-0.904v-4.083c0-0.438 3.762-0.846 4.346-0.904 0.233-0.525 0.525-1.050 0.875-1.517-0.262-0.583-1.488-3.529-1.488-4.025 0-0.058 0.029-0.146 0.117-0.204 0.35-0.175 3.471-2.042 3.617-2.042 0.379 0 2.567 2.888 2.858 3.325 0.292-0.029 0.583-0.058 0.875-0.058s0.583 0.029 0.875 0.058c0.817-1.138 1.692-2.275 2.683-3.267l0.175-0.058c0.146 0 3.267 1.837 3.617 2.042 0.087 0.058 0.117 0.146 0.117 0.204 0 0.525-1.225 3.442-1.488 4.025 0.35 0.467 0.642 0.992 0.875 1.517 0.583 0.058 4.346 0.467 4.346 0.904z",
		dollar: "M42.565 37.031c0 6.375-4.563 11.406-11.187 12.5v5.469c0 0.563-0.438 1-1 1h-4.219c-0.531 0-1-0.438-1-1v-5.469c-7.312-1.031-11.312-5.406-11.469-5.594-0.312-0.375-0.344-0.906-0.063-1.281l3.219-4.219c0.156-0.219 0.438-0.344 0.719-0.375s0.563 0.063 0.75 0.281c0.063 0.031 4.438 4.219 9.969 4.219 3.063 0 6.375-1.625 6.375-5.156 0-3-3.688-4.469-7.906-6.156-5.625-2.219-12.625-5.031-12.625-12.875 0-5.75 4.5-10.5 11.031-11.75v-5.625c0-0.563 0.469-1 1-1h4.219c0.563 0 1 0.438 1 1v5.5c6.344 0.719 9.719 4.156 9.844 4.281 0.312 0.344 0.375 0.812 0.156 1.187l-2.531 4.563c-0.156 0.281-0.406 0.469-0.719 0.5-0.312 0.063-0.594-0.031-0.844-0.219-0.031-0.031-3.812-3.375-8.5-3.375-3.969 0-6.719 1.969-6.719 4.812 0 3.312 3.812 4.781 8.25 6.5 5.75 2.219 12.25 4.75 12.25 12.281z",
		envelope: "M56 20.188v24.812c0 2.75-2.25 5-5 5h-46c-2.75 0-5-2.25-5-5v-24.812c0.938 1.031 2 1.938 3.156 2.719 5.187 3.531 10.437 7.063 15.531 10.781 2.625 1.938 5.875 4.312 9.281 4.312h0.063c3.406 0 6.656-2.375 9.281-4.312 5.094-3.688 10.344-7.25 15.562-10.781 1.125-0.781 2.188-1.687 3.125-2.719zM56 11c0 3.5-2.594 6.656-5.344 8.562-4.875 3.375-9.781 6.75-14.625 10.156-2.031 1.406-5.469 4.281-8 4.281h-0.063c-2.531 0-5.969-2.875-8-4.281-4.844-3.406-9.75-6.781-14.594-10.156-2.219-1.5-5.375-5.031-5.375-7.875 0-3.063 1.656-5.688 5-5.688h46c2.719 0 5 2.25 5 5z",
		error: "M28 0c15.458 0 28 12.542 28 28s-12.542 28-28 28-28-12.542-28-28 12.542-28 28-28zM32.667 45.464v-6.927c0-0.656-0.51-1.203-1.13-1.203h-7c-0.656 0-1.203 0.547-1.203 1.203v6.927c0 0.656 0.547 1.203 1.203 1.203h7c0.62 0 1.13-0.547 1.13-1.203zM32.594 32.922l0.656-22.641c0-0.255-0.109-0.51-0.365-0.656-0.219-0.182-0.547-0.292-0.875-0.292h-8.021c-0.328 0-0.656 0.109-0.875 0.292-0.255 0.146-0.365 0.401-0.365 0.656l0.62 22.641c0 0.51 0.547 0.911 1.24 0.911h6.745c0.656 0 1.203-0.401 1.24-0.911z",
		eye: "M28 20.374q3.098 0 5.362 2.264t2.264 5.362-2.264 5.362-5.362 2.264-5.362-2.264-2.264-5.362 2.264-5.362 5.362-2.264zM28 40.749q5.243 0 8.996-3.753t3.753-8.996-3.753-8.996-8.996-3.753-8.996 3.753-3.753 8.996 3.753 8.996 8.996 3.753zM28 8.936q9.413 0 17.038 5.243t10.962 13.821q-3.336 8.579-10.962 13.821t-17.038 5.243-17.038-5.243-10.962-13.821q3.336-8.579 10.962-13.821t17.038-5.243z",
		"eye-thin": "M52 28c-2.969-4.594-7.031-8.531-11.906-11.031 1.25 2.125 1.906 4.563 1.906 7.031 0 7.719-6.281 14-14 14s-14-6.281-14-14c0-2.469 0.656-4.906 1.906-7.031-4.875 2.5-8.938 6.437-11.906 11.031 5.344 8.25 13.969 14 24 14s18.656-5.75 24-14zM29.5 16c0-0.812-0.687-1.5-1.5-1.5-5.219 0-9.5 4.281-9.5 9.5 0 0.812 0.687 1.5 1.5 1.5s1.5-0.687 1.5-1.5c0-3.563 2.937-6.5 6.5-6.5 0.812 0 1.5-0.687 1.5-1.5zM56 28c0 0.781-0.25 1.5-0.625 2.156-5.75 9.469-16.281 15.844-27.375 15.844s-21.625-6.406-27.375-15.844c-0.375-0.656-0.625-1.375-0.625-2.156s0.25-1.5 0.625-2.156c5.75-9.437 16.281-15.844 27.375-15.844s21.625 6.406 27.375 15.844c0.375 0.656 0.625 1.375 0.625 2.156z",
		filter: "M25.519 21.889c0 0-0.241-4.089-0.241-4.089s0-13.471 0-13.471c0.002-1.162-0.005-2.636 0.825-3.553 1.104-1.224 3.156-0.929 4.022 0.435 0.498 0.787 0.443 1.744 0.445 2.636 0 0 0 25.258 0 25.258s-5.052 0-5.052 0c0 0 0-7.217 0-7.217zM42.358 3.848c0.019-1.576 0.281-3.476 2.165-3.794 2.798-0.471 3.125 2.24 3.127 4.275 0 0 0 11.546 0 11.546s-2.646-0.233-2.646-0.233c0 0-2.646 0.233-2.646 0.233s0-12.028 0-12.028zM8.44 3.848c0.014-1.181 0.147-2.442 1.229-3.163 1.484-0.986 3.286-0.156 3.825 1.479 0.322 0.984 0.238 2.545 0.238 3.608 0 0 0 6.014 0 6.014s-2.646-0.197-2.646-0.197c0 0-2.646 0.197-2.646 0.197s0-7.938 0-7.938zM13.010 13.556c5.509 1.855 5.477 10.377-1.203 11.551-5.121 0.902-8.455-5.015-5.867-9.23 0.907-1.475 2.314-2.151 3.943-2.535 1.176-0.166 1.985-0.171 3.127 0.214zM46.207 28.993c-5.564 1.051-8.874-4.833-6.348-9.028 1.046-1.737 2.533-2.357 4.424-2.774 7.57-0.883 9.36 10.399 1.924 11.802zM13.732 26.46c0 0 0 24.536 0 24.536-0.002 1.215-0.067 3.079-0.844 4.063-1.066 1.352-3.094 1.222-3.984-0.226-0.496-0.808-0.462-1.958-0.464-2.875 0 0 0-25.499 0-25.499s5.292 0 5.292 0zM33.219 33.436c1.936 3.286-0.019 8.15-3.851 8.821-1.169 0.207-3.019 0.135-4.089-0.402-4.71-2.355-4.39-9.803 1.443-11.193 2.673-0.375 5.056 0.33 6.497 2.774zM45.004 30.77c0 0 2.646-0.221 2.646-0.221s0 21.409 0 21.409c-0.002 1.034 0.034 2.215-0.649 3.074-0.977 1.224-3.017 1.224-3.993 0-0.637-0.799-0.645-1.867-0.649-2.834 0 0 0-21.65 0-21.65s2.646 0.221 2.646 0.221zM27.684 43.998c0 0 2.887-0.219 2.887-0.219s0 8.66 0 8.66c-0.022 1.758-0.654 3.861-2.887 3.517-1.912-0.296-2.384-2.114-2.406-3.757 0 0 0-8.419 0-8.419s2.406 0.219 2.406 0.219z",
		filters: [
			{
				type: "path",
				attributes: {
					x1: "1",
					y1: "17",
					x2: "55",
					y2: "17",
					"stroke-width": "4",
					"stroke-linecap": "round",
					"stroke-linejoin": "round",
					stroke: "currentColor"
				}
			},
			{
				type: "line",
				attributes: {
					x1: "1",
					y1: "39",
					x2: "55",
					y2: "39",
					"stroke-width": "4",
					"stroke-linecap": "round",
					"stroke-linejoin": "round",
					stroke: "currentColor"
				}
			},
			{
				type: "circle",
				attributes: {
					cx: "18",
					cy: "17",
					r: "8",
					fill: "white",
					"stroke-width": "4",
					stroke: "currentColor"
				}
			},
			{
				type: "circle",
				attributes: {
					cx: "38",
					cy: "39",
					r: "8",
					fill: "white",
					stroke: "currentColor",
					"stroke-width": "4"
				}
			}
		],
		bullet: [{
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "20",
				"stroke-width": "3",
				fill: "white",
				stroke: "currentColor"
			}
		}, {
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "13",
				"stroke-width": "0"
			}
		}],
		"bullet-o": [{
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "20",
				"stroke-width": "3",
				fill: "white",
				stroke: "currentColor"
			}
		}],
		heart: "M28 52c-0.5 0-1-0.188-1.375-0.563l-19.5-18.813c-0.25-0.219-7.125-6.5-7.125-14 0-9.156 5.594-14.625 14.938-14.625 5.469 0 10.594 4.312 13.062 6.75 2.469-2.437 7.594-6.75 13.062-6.75 9.344 0 14.938 5.469 14.938 14.625 0 7.5-6.875 13.781-7.156 14.063l-19.469 18.75c-0.375 0.375-0.875 0.563-1.375 0.563z",
		"heart-o": "M52 18.625c0-8.781-5.937-10.625-10.938-10.625-4.656 0-9.906 5.031-11.531 6.969-0.75 0.906-2.313 0.906-3.063 0-1.625-1.938-6.875-6.969-11.531-6.969-5 0-10.938 1.844-10.938 10.625 0 5.719 5.781 11.031 5.844 11.094l18.156 17.5 18.125-17.469c0.094-0.094 5.875-5.406 5.875-11.125zM56 18.625c0 7.5-6.875 13.781-7.156 14.063l-19.469 18.75c-0.375 0.375-0.875 0.563-1.375 0.563s-1-0.188-1.375-0.563l-19.5-18.813c-0.25-0.219-7.125-6.5-7.125-14 0-9.156 5.594-14.625 14.938-14.625 5.469 0 10.594 4.312 13.062 6.75 2.469-2.437 7.594-6.75 13.062-6.75 9.344 0 14.938 5.469 14.938 14.625z",
		info: "M56.1425 28.2143C56.1425 43.6783 43.6065 56.2143 28.1425 56.2143C12.6786 56.2143 0.142578 43.6783 0.142578 28.2143C0.142578 12.7504 12.6786 0.214325 28.1425 0.214325C43.6065 0.214325 56.1425 12.7504 56.1425 28.2143ZM32.2543 16.7406C33.1441 15.8361 33.587 14.7358 33.587 13.4469C33.587 12.1603 33.1441 11.0578 32.2543 10.1417C31.3665 9.22792 30.2961 8.76988 29.0452 8.76988C27.7901 8.76988 26.7156 9.22562 25.8194 10.1417C24.9232 11.0578 24.4741 12.1603 24.4741 13.4469C24.4741 14.7358 24.9232 15.8361 25.8194 16.7406C26.7177 17.6498 27.7901 18.1032 29.0452 18.1032C30.2961 18.1032 31.3665 17.6498 32.2543 16.7406ZM29.9419 45.5994C30.7373 45.2628 31.8057 44.7746 33.1417 44.1326C33.1417 44.1326 32.9859 42.1999 32.4746 42.3716C31.9633 42.5432 31.5033 42.6302 31.0983 42.6302C30.237 42.6302 29.6304 42.4585 29.2785 42.113C28.9285 41.7675 28.7544 41.1188 28.7544 40.1669C28.7544 39.7902 28.8076 39.2285 28.9175 38.4928C29.0238 37.7527 29.1466 37.0951 29.2822 36.52L30.9462 29.3555C31.1093 28.6979 31.2211 27.9756 31.2816 27.1865C31.342 26.3996 31.3714 25.849 31.3714 25.5369C31.3714 24.0255 30.9352 22.7995 30.0647 21.8543C29.1942 20.9091 27.9536 20.4365 26.3464 20.4365C25.4521 20.4365 24.5065 20.6305 23.5059 21.0161C22.5053 21.4018 21.4588 21.8654 20.3648 22.4071C20.3648 22.4071 20.6323 24.3198 21.0868 24.157C21.5395 23.9943 21.983 23.9096 22.4155 23.9096C23.2969 23.9096 23.8907 24.0924 24.2022 24.4535C24.5138 24.8146 24.6695 25.4566 24.6695 26.3751C24.6695 26.8833 24.6201 27.4473 24.5174 28.0603C24.4167 28.6778 24.2902 29.3309 24.1418 30.0198L22.4704 37.2111C22.322 37.9667 22.2139 38.6444 22.1461 39.2441C22.0783 39.8437 22.0453 40.4322 22.0453 41.0051C22.0453 42.483 22.4943 43.7024 23.3922 44.6632C24.2902 45.6217 25.5492 46.1032 27.1674 46.1032C28.2211 46.1032 29.1466 45.936 29.9419 45.5994Z",
		"layout-grid-4": "M11 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM11 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM11 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3z",
		"layout-grid-3": VC.layoutGrid3,
		"layout-grid-2": VC.layoutGrid2,
		"layout-grid": VC.layoutGrid3,
		"layout-grid-1": "M56 9v38c0 1.656-1.344 3-3 3h-50c-1.656 0-3-1.344-3-3v-38c0-1.656 1.344-3 3-3h50c1.656 0 3 1.344 3 3z",
		"layout-large": VC.layoutGrid2,
		"layout-list": "M16 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3zM16 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3z",
		minus: "M56 24.182v7.636c0 2.108-1.71 3.818-3.818 3.818h-48.364c-2.108 0-3.818-1.71-3.818-3.818v-7.636c0-2.108 1.71-3.818 3.818-3.818h48.364c2.108 0 3.818 1.71 3.818 3.818z",
		"minus-thin": "M0 23.297h56v9.406h-56v-9.406z",
		plus: "M56 24.182v7.636c0 2.108-1.71 3.818-3.818 3.818h-16.545v16.545c0 2.108-1.71 3.818-3.818 3.818h-7.636c-2.108 0-3.818-1.71-3.818-3.818v-16.545h-16.545c-2.108 0-3.818-1.71-3.818-3.818v-7.636c0-2.108 1.71-3.818 3.818-3.818h16.545v-16.545c0-2.108 1.71-3.818 3.818-3.818h7.636c2.108 0 3.818 1.71 3.818 3.818v16.545h16.545c2.108 0 3.818 1.71 3.818 3.818z",
		"plus-thin": "M56 31.946h-24.054v24.054h-7.893v-24.054h-24.054v-7.893h24.054v-24.054h7.893v24.054h24.054v7.893z",
		"rotate-left": "M56 28c0 15.422-12.578 28-28 28-8.349 0-16.224-3.682-21.547-10.099-0.365-0.474-0.328-1.167 0.073-1.568l4.995-5.031c0.255-0.219 0.583-0.328 0.911-0.328 0.328 0.036 0.656 0.182 0.839 0.438 3.573 4.63 8.932 7.255 14.729 7.255 10.281 0 18.667-8.385 18.667-18.667s-8.385-18.667-18.667-18.667c-4.776 0-9.297 1.823-12.687 4.995l4.995 5.031c0.693 0.656 0.875 1.677 0.51 2.516-0.365 0.875-1.203 1.458-2.151 1.458h-16.333c-1.276 0-2.333-1.057-2.333-2.333v-16.333c0-0.948 0.583-1.786 1.458-2.151 0.839-0.365 1.859-0.182 2.516 0.51l4.74 4.703c5.141-4.849 12.104-7.729 19.286-7.729 15.422 0 28 12.578 28 28z",
		"rotate-right": "M56 4.667v16.333c0 1.276-1.057 2.333-2.333 2.333h-16.333c-0.948 0-1.786-0.583-2.151-1.458-0.365-0.839-0.182-1.859 0.51-2.516l5.031-5.031c-3.427-3.172-7.948-4.995-12.724-4.995-10.281 0-18.667 8.385-18.667 18.667s8.385 18.667 18.667 18.667c5.797 0 11.156-2.625 14.729-7.255 0.182-0.255 0.51-0.401 0.839-0.438 0.328 0 0.656 0.109 0.911 0.328l4.995 5.031c0.438 0.401 0.438 1.094 0.073 1.568-5.323 6.417-13.198 10.099-21.547 10.099-15.422 0-28-12.578-28-28s12.578-28 28-28c7.182 0 14.146 2.88 19.286 7.729l4.74-4.703c0.656-0.693 1.677-0.875 2.552-0.51 0.839 0.365 1.422 1.203 1.422 2.151z",
		search: "M35.385 23.692c0-6.457-5.235-11.692-11.693-11.692s-11.693 5.235-11.693 11.692 5.235 11.692 11.693 11.692 11.693-5.235 11.693-11.692zM54.243 45.757A6 6 0 0 1 45.757 54.243L35.656 44.141A23.692 23.692 0 1 1 44.141 35.656L54.243 45.757z",
		"search-thin": "M38.769 23.692c0-8.313-6.764-15.077-15.077-15.077s-15.077 6.764-15.077 15.077 6.764 15.077 15.077 15.077 15.077-6.764 15.077-15.077zM56 51.692c0 2.356-1.952 4.308-4.308 4.308-1.144 0-2.255-0.471-3.029-1.279l-11.543-11.51c-3.937 2.726-8.649 4.173-13.428 4.173-13.091 0-23.692-10.601-23.692-23.692s10.601-23.692 23.692-23.692 23.692 10.601 23.692 23.692c0 4.779-1.447 9.49-4.173 13.428l11.543 11.543c0.774 0.774 1.245 1.885 1.245 3.029z",
		sort: "M48.364 35.636c0 0.676-0.278 1.312-0.756 1.79l-17.818 17.818c-0.477 0.477-1.114 0.756-1.79 0.756s-1.312-0.278-1.79-0.756l-17.818-17.818c-0.477-0.477-0.756-1.114-0.756-1.79 0-1.392 1.153-2.545 2.545-2.545h35.636c1.392 0 2.545 1.153 2.545 2.545zM48.364 20.364c0 1.392-1.153 2.545-2.545 2.545h-35.636c-1.392 0-2.545-1.153-2.545-2.545 0-0.676 0.278-1.312 0.756-1.79l17.818-17.818c0.477-0.477 1.114-0.756 1.79-0.756s1.312 0.278 1.79 0.756l17.818 17.818c0.477 0.477 0.756 1.114 0.756 1.79z",
		spinner: "M16.009 45.176c0 2.268-1.847 4.148-4.148 4.148-2.268 0-4.148-1.88-4.148-4.148 0-2.301 1.88-4.148 4.148-4.148 2.301 0 4.148 1.847 4.148 4.148zM32.148 51.852c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM9.333 29.037c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM48.287 45.176c0 2.268-1.88 4.148-4.148 4.148-2.301 0-4.148-1.88-4.148-4.148 0-2.301 1.847-4.148 4.148-4.148 2.268 0 4.148 1.847 4.148 4.148zM17.046 12.898c0 2.852-2.333 5.185-5.185 5.185s-5.185-2.333-5.185-5.185 2.333-5.185 5.185-5.185 5.185 2.333 5.185 5.185zM54.963 29.037c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM34.222 6.222c0 3.435-2.787 6.222-6.222 6.222s-6.222-2.787-6.222-6.222 2.787-6.222 6.222-6.222 6.222 2.787 6.222 6.222zM51.398 12.898c0 4.018-3.273 7.259-7.259 7.259-4.018 0-7.259-3.241-7.259-7.259 0-3.986 3.241-7.259 7.259-7.259 3.986 0 7.259 3.273 7.259 7.259z",
		square: "M0 0h56v56h-56z",
		star: "M56 21.993c0 0.606-0.438 1.178-0.875 1.615l-12.216 11.913 2.894 16.827c0.034 0.236 0.034 0.438 0.034 0.673 0 0.875-0.404 1.683-1.38 1.683-0.471 0-0.942-0.168-1.346-0.404l-15.111-7.942-15.111 7.942c-0.438 0.236-0.875 0.404-1.346 0.404-0.976 0-1.413-0.808-1.413-1.683 0-0.236 0.034-0.438 0.067-0.673l2.894-16.827-12.25-11.913c-0.404-0.438-0.841-1.010-0.841-1.615 0-1.010 1.043-1.413 1.885-1.548l16.894-2.457 7.572-15.312c0.303-0.639 0.875-1.38 1.649-1.38s1.346 0.74 1.649 1.38l7.572 15.312 16.894 2.457c0.808 0.135 1.885 0.538 1.885 1.548z",
		"star-half": "M39.919 32.426l8.651-8.415-14.205-2.087-1.010-2.020-5.352-10.839v32.415l1.986 1.043 10.704 5.655-2.020-11.949-0.404-2.222zM55.134 23.607l-12.219 11.916 2.895 16.83c0.236 1.481-0.303 2.356-1.346 2.356-0.37 0-0.842-0.135-1.346-0.404l-15.113-7.944-15.113 7.944c-0.505 0.269-0.976 0.404-1.346 0.404-1.043 0-1.582-0.875-1.346-2.356l2.895-16.83-12.252-11.916c-1.447-1.447-0.976-2.861 1.043-3.164l16.897-2.457 7.574-15.315c0.438-0.909 1.043-1.38 1.649-1.38v0c0.606 0 1.178 0.471 1.649 1.38l7.574 15.315 16.897 2.457c2.020 0.303 2.491 1.717 1.010 3.164z",
		"star-o": "M38.264 34.007l10.298-9.995-14.202-2.087-6.361-12.856-6.361 12.856-14.202 2.087 10.298 9.995-2.457 14.168 12.721-6.697 12.688 6.697zM56 21.993c0 0.606-0.438 1.178-0.875 1.615l-12.216 11.913 2.894 16.827c0.034 0.236 0.034 0.438 0.034 0.673 0 0.909-0.404 1.683-1.38 1.683-0.471 0-0.942-0.168-1.346-0.404l-15.111-7.942-15.111 7.942c-0.438 0.236-0.875 0.404-1.346 0.404-0.976 0-1.413-0.808-1.413-1.683 0-0.236 0.034-0.438 0.067-0.673l2.894-16.827-12.25-11.913c-0.404-0.438-0.841-1.010-0.841-1.615 0-1.010 1.043-1.413 1.885-1.548l16.894-2.457 7.572-15.312c0.303-0.639 0.875-1.38 1.649-1.38s1.346 0.74 1.649 1.38l7.572 15.312 16.894 2.457c0.808 0.135 1.885 0.538 1.885 1.548z",
		"video-camera": "M56 11v34c0 0.812-0.5 1.531-1.219 1.844-0.25 0.094-0.531 0.156-0.781 0.156-0.531 0-1.031-0.188-1.406-0.594l-12.594-12.594v5.187c0 4.969-4.031 9-9 9h-22c-4.969 0-9-4.031-9-9v-22c0-4.969 4.031-9 9-9h22c4.969 0 9 4.031 9 9v5.156l12.594-12.562c0.375-0.406 0.875-0.594 1.406-0.594 0.25 0 0.531 0.063 0.781 0.156 0.719 0.312 1.219 1.031 1.219 1.844z",
		warn: "M31.2981 5.28228C29.8323 2.74341 26.1677 2.74341 24.7019 5.28228L0.515899 47.1737C-0.94992 49.7126 0.88235 52.8861 3.81399 52.8861H52.186C55.1176 52.8861 56.9499 49.7126 55.4841 47.1737L31.2981 5.28228ZM25.2229 35.0037L24.8264 18.837C24.8264 18.655 24.8923 18.4729 25.047 18.3686C25.1794 18.2387 25.3776 18.1601 25.5759 18.1601H30.4241C30.6223 18.1601 30.8206 18.238 30.953 18.3686C31.1071 18.4729 31.1736 18.655 31.1736 18.837L30.7988 35.0037C30.7988 35.3679 30.4682 35.6542 30.0493 35.6542H25.9724C25.5759 35.6542 25.2453 35.3679 25.2229 35.0037ZM25.1788 43.9593V39.0131C25.1788 38.5447 25.487 38.1541 25.8618 38.1541H30.0929C30.4894 38.1541 30.82 38.5447 30.82 39.0131V43.9593C30.82 44.4277 30.4894 44.8183 30.0929 44.8183H25.8618C25.487 44.8183 25.1788 44.4277 25.1788 43.9593Z",
		wrench: "M12.407 45.809c0-1.193-0.988-2.181-2.181-2.181s-2.181 0.988-2.181 2.181 0.988 2.181 2.181 2.181 2.181-0.988 2.181-2.181zM34.357 31.494l-23.245 23.245c-0.784 0.784-1.909 1.261-3.068 1.261s-2.284-0.477-3.102-1.261l-3.613-3.681c-0.818-0.784-1.295-1.909-1.295-3.068s0.477-2.284 1.295-3.102l23.211-23.211c1.772 4.465 5.351 8.044 9.816 9.816zM55.966 16.667c0 1.125-0.409 2.522-0.784 3.613-2.147 6.067-7.976 10.259-14.418 10.259-8.419 0-15.27-6.851-15.27-15.27s6.851-15.27 15.27-15.27c2.488 0 5.726 0.75 7.805 2.147 0.341 0.239 0.545 0.545 0.545 0.954 0 0.375-0.239 0.75-0.545 0.954l-9.987 5.76v7.635l6.578 3.647c1.125-0.648 9.032-5.624 9.714-5.624s1.091 0.511 1.091 1.193z"
	};
})), WC, GC, KC, qC = o((() => {
	H(), ux(), WC = /* @__PURE__ */ u(X()), Q(), BC(), UC(), OC(), tC(), GC = ({ color: e, fill: t, stroke: n, theme: r, width: i, height: a, size: o }) => cx({
		color: e || t || r?.variables?.colors?.primary,
		fill: t || e || r?.variables?.colors?.primary,
		stroke: n,
		width: isNaN(Number(i || o)) ? i || o : `${i || o}px`,
		height: isNaN(Number(a || o)) ? a || o : `${a || o}px`,
		position: "relative"
	}), KC = Z((e) => {
		let t = uS("icon", mi(), {
			size: "16px",
			viewBox: "0 0 56 56",
			treePath: RC()
		}, e), { color: n, icon: r, fill: i, path: a, children: o, size: s, width: c, title: l, height: u, viewBox: d, svg: f, disableStyles: p, className: m, internalClassName: h, style: g, styleScript: _, themeStyleScript: v, name: y, treePath: b, ...x } = t, { overrideElement: S, shouldRenderDefault: C } = QS("icon", t);
		if (!C) return S;
		let w = gS(t, GC), T = (0, WC.default)("ss__icon", r && !f ? `ss__icon--${r}` : null, m, h);
		if (f) {
			let e = f?.props?.className || f?.props?.class, t = {
				...w,
				className: (0, WC.default)(T, e),
				...x
			};
			return p && (t.width = c || s, t.height = u || s), B(Kx, { children: lx(f.type, {
				...f.props,
				...t,
				children: f.props.children
			}) });
		}
		let E = HC[r] || a, D = typeof E;
		return o || E && (D === "string" || D === "object" && Array.isArray(E)) ? B(Kx, { children: V("svg", {
			...w,
			className: T,
			viewBox: d,
			xmlns: "http://www.w3.org/2000/svg",
			width: p ? c || s : void 0,
			height: p ? u || s : void 0,
			...x,
			children: [l ? B("title", { children: l }) : null, (() => {
				if (o) return o;
				if (D === "string") return B("path", {
					fill: p && (i || n) || void 0,
					d: E
				});
				if (E && D === "object" && Array.isArray(E)) return E.map((e, t) => B(e.type, { ...e.attributes }, t));
			})()]
		}) }) : null;
	});
})), JC, YC, XC, ZC, QC = o((() => {
	H(), ux(), JC = /* @__PURE__ */ u(X()), R(), qC(), OC(), BC(), tC(), YC = ({ componentTheme: e }) => cx({
		width: "360px",
		height: "120px",
		overflow: "hidden",
		fontSize: "14px",
		position: "fixed",
		zIndex: "9999",
		cursor: "auto",
		bottom: "50px",
		right: 0,
		padding: "0 5px",
		background: e.main.background,
		color: e.main.color,
		border: e.main.border,
		borderTopLeftRadius: "10px",
		borderBottomLeftRadius: "10px",
		boxShadow: e.main.boxShadow,
		transition: "height ease 0.2s, right ease 0.5s 0.2s",
		"&.ss__branch-override--collapsed": {
			transition: "height ease 0.5s 0.5s, right ease 0.5s",
			right: "-323px",
			height: "50px",
			cursor: "pointer"
		},
		".ss__branch-override__top": {
			padding: "10px 5px",
			background: e.top.background,
			borderBottom: e.top.border,
			".ss__branch-override__top__logo": {
				display: "inline-block",
				height: "30px",
				maxHeight: "30px",
				verticalAlign: "middle"
			},
			".ss__branch-override__top__collapse": {
				display: "inline-block",
				float: "right",
				paddingTop: "7px",
				cursor: "pointer"
			},
			".ss__branch-override__top__button": {
				borderRadius: "5px",
				padding: "6px",
				height: "100%",
				lineHeight: "14px",
				textAlign: "center",
				cursor: "pointer",
				fontSize: "10px",
				border: e.top.button.border,
				color: e.top.button.color,
				float: "right",
				marginRight: "14px"
			}
		},
		".ss__branch-override__bottom": {
			padding: "10px 15px",
			fontSize: "12px",
			".ss__branch-override__bottom__left": {
				fontWeight: "bold",
				fontStyle: e.bottom.branch.style,
				color: e.bottom.branch.color,
				fontSize: "14px",
				lineHeight: "20px",
				display: "inline-flex",
				alignItems: "center",
				maxWidth: "180px",
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				svg: { marginRight: "10px" }
			},
			".ss__branch-override__bottom__right": {
				float: "right",
				fontStyle: "italic",
				color: e.bottom.additional.color,
				fontSize: "12px",
				lineHeight: "20px"
			},
			".ss__branch-override__bottom__content": { marginTop: "10px" }
		}
	}), XC = {
		darkTheme: {
			class: "ss__branch-override--dark",
			main: {
				border: "0",
				background: "rgba(26, 29, 36, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #454c5f",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "STOP PREVIEW"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Preview functionality may differ from production.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		},
		lightTheme: {
			class: "ss__branch-override--light",
			main: {
				border: "0",
				background: "rgba(29, 73, 144, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #3c78d7",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "STOP PREVIEW"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Preview functionality may differ from production.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		},
		failureTheme: {
			class: "ss__branch-override--error",
			main: {
				border: "0",
				background: "rgba(130, 6, 6, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #e50b0b",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "REMOVE"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Incorrect branch name or branch no longer exists.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		}
	}, ZC = (e) => {
		let t = uS("branchOverride", mi(), { treePath: RC() }, e), { branch: n, details: r, error: i, className: a, internalClassName: o, darkMode: s, disableStyles: c, onRemoveClick: l, treePath: u } = t, { overrideElement: d, shouldRenderDefault: f } = QS("branchOverride", t);
		if (!f) return d;
		let p = { icon: {
			internalClassName: "ss__branch-override__bottom__left__icon",
			size: "12px",
			...$({ disableStyles: c }),
			theme: t?.theme,
			treePath: u
		} }, [m, h] = I((typeof s == "boolean" ? s : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) ? "darkTheme" : "lightTheme"), [g, _] = I(0);
		i && h("failureTheme");
		let v = gS({
			...t,
			componentTheme: XC[m]
		}, YC);
		return (r || i) && n ? V("div", {
			className: (0, JC.default)("ss__branch-override", XC[m].class, { "ss__branch-override--collapsed": g }, a, o),
			...v,
			onClick: (e) => {
				e.preventDefault(), e.stopPropagation(), _(0);
			},
			children: [V("div", {
				className: "ss__branch-override__top",
				children: [
					B("img", {
						className: "ss__branch-override__top__logo",
						src: XC[m].top.logo.src
					}),
					B("div", {
						className: "ss__branch-override__top__collapse",
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), _(1);
						},
						children: B(KC, {
							size: "18px",
							color: XC[m].top.close.fill,
							...p.icon,
							icon: "close-thin"
						})
					}),
					B("div", {
						className: "ss__branch-override__top__button",
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), l && l(e, n);
						},
						children: XC[m].top.button.content
					})
				]
			}), V("div", {
				className: "ss__branch-override__bottom",
				children: [
					B("span", {
						className: "ss__branch-override__bottom__left",
						children: i ? V(xi, { children: [B(KC, {
							size: "12px",
							color: XC[m].bottom.branch.color,
							...p.icon,
							icon: "warn"
						}), B("span", { children: i.message })] }) : n
					}),
					B("span", {
						className: "ss__branch-override__bottom__right",
						children: i ? n : r?.lastModified
					}),
					B("div", {
						className: "ss__branch-override__bottom__content",
						children: i?.description || XC[m].bottom.content
					})
				]
			})]
		}) : null;
	};
})), $C = /* @__PURE__ */ c({ BranchOverride: () => ZC }), ew = o((() => {
	QC();
})), tw = o((() => {
	Qb(), tx(), ix(), Hb();
})), nw = /* @__PURE__ */ c({
	RecommendationInstantiator: () => lw,
	defined: () => ow
});
async function rw(e, t, n, r, i, a, o, s, c) {
	let { profile: l, batchId: u, cart: d, tag: f } = o, p = l?.batched ?? o.batched ?? !0;
	if (!f) {
		e.logger.warn("'tag' is missing from <script> tag, skipping this profile", a);
		return;
	}
	Array.isArray(d) && e.tracker.cookies.cart.set(d);
	let m = sw.default.all([
		e.config.client?.globals || {},
		e.config.config?.globals || {},
		o
	]), h = {
		tag: f,
		batched: p ?? e.config.config?.batched ?? !0,
		realtime: !!(r.options?.realtime ?? r.profile?.options?.realtime ?? e.config.config?.realtime),
		batchId: u,
		middleware: e.config.config.middleware,
		plugins: e.config.config.plugins,
		branch: e.config.config?.branch || "production",
		limit: e.config.config?.limit,
		beacon: e.config.config?.beacon || { enabled: !0 },
		settings: { variants: e.config.config?.variants },
		globals: m
	};
	l?.branch && (h.branch = l?.branch), i[f] = i[f] + 1 || 1;
	let g = {
		id: `recommend_${f}_${i[f] - 1}`,
		...h
	}, _ = rx({
		url: e.config.url,
		controller: g,
		context: r,
		mode: e.config.mode
	}, {
		client: e.client,
		tracker: e.tracker
	});
	n && n.setAttribute("ss-controller-id", _.id), e.uses.forEach((e) => _.use(e)), e.plugins.forEach((e) => _.plugin(e.func, ...e.args)), e.middleware.forEach((e) => _.on(e.event, ...e.func)), e.controller[_.config.id] = _, window.athos.controller = window.athos.controller || {}, window.athos.controller[_.config.id] = _, _.addTargeter(c), _.store.loading || await _.search();
	let v = _.store.profile.display?.templateParameters;
	if (!_.store.error) {
		if (!_.store.profile.display.template) {
			e.logger.error(`profile '${f}' found on the following element is missing a template!\n${a?.outerHTML}`);
			return;
		}
		if (!v) {
			e.logger.error(`profile '${f}' found on the following element is missing templateParameters!\n${a?.outerHTML}`);
			return;
		}
		return n && await iw(e, t, _, n, a, s), _;
	}
}
async function iw(e, t, n, r, i, a) {
	r && r.setAttribute("ss-controller-id", n.id);
	let o = n.config.tag, s = n.store.profile.display?.template?.component;
	if (!s) {
		e.logger.error(`profile '${o}' found on the following element is missing a component!\n${i?.outerHTML}`);
		return;
	}
	let c = {}, l;
	if (c.className = `ss__recommendation-${s.toLowerCase()}`, e.config.components[s]?.onTarget?.(a, i, r, n), e.config.components[s] && typeof e.config.components[s] == "function") l = await e.config.components[s]();
	else if (e.config.components[s] && typeof e.config.components[s] == "object") {
		c = e.config.components[s].props || {};
		let t = [];
		t.push(e.config.components[s].component()), l = (await Promise.all(t))[0];
	}
	if (!l) {
		e.logger.error(`profile '${o}' found on the following element is expecting component mapping for '${s}' - verify instantiator config.\n${i?.outerHTML}`);
		return;
	}
	setTimeout(() => {
		se(B(l, {
			controller: n,
			snap: t?.snap,
			...c
		}), r);
	});
}
function aw(e) {
	if (typeof e == "function") try {
		let t = e();
		if (Array.isArray(t)) return t;
	} catch {}
	else if (Array.isArray(e)) return e;
	return [];
}
function ow(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var sw, cw, lw, uw = o((() => {
	H(), Oe(), sw = /* @__PURE__ */ u(U()), Iu(), kd(), Id(), C_(), tw(), cw = "production", lw = class {
		constructor(e, t, n) {
			if (this.mode = ku.production, this.controller = {}, this.uses = [], this.plugins = [], this.middleware = [], this.config = e, !this.config) throw Error("Recommendation Instantiator config is required");
			if (this.config.config?.branch || (this.config.config = this.config.config || {}, this.config.config.branch = cw), !this.config.components || typeof this.config.components != "object" || !Object.keys(this.config.components).length) throw Error("Recommendation Instantiator config must contain 'components' mapping property");
			if ((!t?.client || !t?.tracker) && !this.config?.client?.globals?.siteId) throw Error("Recommendation Instantiator config must contain a valid config.client.globals.siteId value");
			this.config.mode && Object.values(ku).includes(this.config.mode) && (this.mode = this.config.mode, this.config?.client?.globals?.siteId && (this.config.client.config = this.config.client.config || {}, this.config.client.config.mode = this.config.client.config.mode || this.mode)), window.athos = window.athos || {}, this.context = (0, sw.default)(n || {}, e.context || {}), this.client = t?.client || new Dd(this.config.client.globals, this.config.client.config), this.tracker = t?.tracker || new b_(this.config.client.globals), this.logger = t?.logger || new Pd({
				prefix: "RecommendationInstantiator ",
				mode: this.mode
			});
			let r = {};
			this.targeter = new Vl([{
				selector: `${this.config.selector || "script[type=\"searchspring/recommend\"], script[type=\"searchspring/personalized-recommendations\"], script[type=\"athos/recommend\"], script[type=\"athos/personalized-recommendations\"]"}, script[type="searchspring/recommend"][profile="email"], script[type="athos/recommend"][profile="email"]`,
				autoRetarget: !0,
				clickRetarget: !0,
				navigationRetarget: !0,
				emptyTarget: !1
			}, {
				selector: "script[type=\"searchspring/recommendations\"], script[type=\"athos/recommendations\"]",
				autoRetarget: !0,
				clickRetarget: !0,
				navigationRetarget: !0,
				emptyTarget: !1
			}], async (e, n) => {
				this.cleanupStaleControllers();
				let i = n, a = tu([
					"shopperId",
					"shopper",
					"product",
					"products",
					"seed",
					"cart",
					"filters",
					"blockedItems",
					"options",
					"profile",
					"custom",
					"profiles",
					"globals"
				], i);
				if (a.profiles && a.profiles.length) {
					let e = a.profiles, n = a.globals, o = { ...ow({
						blockedItems: n?.blockedItems,
						filters: n?.filters,
						cart: n?.cart && aw(n.cart),
						products: n?.products,
						shopper: n?.shopper?.id,
						batchId: Math.floor(Math.random() * (2 ** 53 - 1))
					}) };
					e.forEach((e, s) => {
						if (e.selector) {
							let c = {
								selector: e.selector,
								autoRetarget: !0,
								profile: e,
								order: s
							}, l;
							new Vl([c], async (e, s, c, u) => {
								if (i.isConnected === !1) {
									s && u?.releaseTargets([s]);
									return;
								}
								if (e.profile?.profile || e.profile?.tag) {
									let c = {
										...o,
										profile: {
											...e.profile?.options,
											order: e.order
										},
										tag: e.profile.tag || e.profile.profile
									}, d = (0, sw.default)(this.context, ow({
										globals: n,
										profile: e.profile
									}));
									if (a.custom && (d.custom = (0, sw.default)(d.custom, a.custom)), !l) l = rw(this, t || {}, s, d, r, i, c, e, u);
									else {
										let n = await l;
										n && s && iw(this, t || {}, n, s, i, e);
									}
								}
							});
						}
					});
				} else {
					let { profile: n, products: o, product: s, seed: c, filters: l, blockedItems: u, options: d, shopper: f, shopperId: p } = a, m = [].concat(o || s || c || []), h = [
						f,
						f?.id,
						p,
						p?.id
					].filter((e) => e && typeof e == "string").pop(), g = {
						tag: n,
						...ow({
							products: m.length ? m : void 0,
							cart: a.cart && aw(a.cart),
							shopper: h,
							filters: l,
							blockedItems: u,
							profile: d
						})
					}, _ = i.getAttribute("profile") || "", v = i.ownerDocument.createElement("div");
					v.setAttribute("searchspring-recommend", _), i.before(v);
					let y = (0, sw.default)(this.context, a);
					new Vl([{
						selector: `[searchspring-recommend="${_}"]`,
						name: `legacy_${n}_${r[n || ""] || 0}`
					}], async (n, a, o, s) => {
						if (i.isConnected === !1) {
							a && s?.releaseTargets([a]);
							return;
						}
						rw(this, t || {}, a, y, r, i, g, e, s);
					});
				}
			});
		}
		plugin(e, ...t) {
			this.plugins.push({
				func: e,
				args: t
			});
		}
		on(e, ...t) {
			this.middleware.push({
				event: e,
				func: t
			});
		}
		use(e) {
			this.uses.push(e);
		}
		cleanupStaleControllers() {
			Object.keys(this.controller).forEach((e) => {
				let t = this.controller[e];
				Object.values(t.targeters).some((t) => t.getTargetedElems().some((t) => (t.isConnected !== !1 && t.getAttribute("ss-controller-id")) === e)) || (Object.keys(t.targeters).forEach((e) => t.targeters[e].destroy()), t.targeters = {}, delete this.controller[e], window.athos?.controller && delete window.athos.controller[e]);
			});
		}
	};
}));
H(), Oe();
var dw = /* @__PURE__ */ u(U());
wi(), kl(), kd(), Id(), C_(), Iu(), sb(), Hb(), qb(), zo({
	useProxies: "never",
	isolateGlobalState: !0,
	enforceActions: "never"
});
var fw = "athosBranch", pw = "athos-preview", mw = "athos-Dev", hw = "athos-snap-bundle-styles", gw = 3, _w = "Uncaught Error - Invalid value passed as the component.\nThis usually happens when you pass a JSX Element, and not a function that returns the component, in the snap config. \n		\n		instead of - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: <Content/>,\n		},\n	]\n\n		or - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: Content,\n		},\n	]\n\n		please try - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: () => Content\n		},\n	]\n\nThe error above happened in the following targeter in the Snap Config", vw = class {
	constructor(e, t) {
		this.mode = ku.production, this._instantiatorPromises = {}, this._controllerPromises = {}, this.controllers = {}, this.getInstantiator = (e) => this._instantiatorPromises[e] || Promise.reject(`getInstantiator could not find instantiator with id: ${e}`), this.getController = (e) => this._controllerPromises[e] || Promise.reject(`getController could not find controller with id: ${e}`), this.getControllers = (...e) => {
			let t = [];
			return e.forEach((e) => t.push(this.getController(e))), Promise.all(t);
		}, this.createController = async (e, t, n, r, i, a) => {
			if (this._controllerPromises[t.id] !== void 0) throw Error(`Controller with id '${t.id}' is already defined`);
			return this._controllerPromises[t.id] = new Promise((o) => this._createController(e, t, n, r, i, async (e) => {
				typeof a == "function" && await a(e), o(e);
			})), this._controllerPromises[t.id];
		}, this._createController = async (e, t, n, r, i, a) => {
			let o;
			switch (e) {
				case xy.autocomplete:
					o = Promise.resolve().then(() => (Qb(), Xb));
					break;
				case xy.finder:
					o = Promise.resolve().then(() => (tx(), $b));
					break;
				case xy.recommendation:
					o = Promise.resolve().then(() => (ix(), nx));
					break;
				case xy.search:
				default: o = Promise.resolve().then(() => (Hb(), Bb));
			}
			let s = (await o).default;
			return this.controllers[t.id] || (window.athos.controller = window.athos.controller || {}, window.athos.controller[t.id] = this.controllers[t.id] = s({
				mode: this.mode,
				url: (0, dw.default)(this.config.url || {}, r || {}),
				controller: t,
				context: (0, dw.default)(this.context || {}, i || {})
			}, {
				client: n?.client || this.client,
				store: n?.store,
				urlManager: n?.urlManager,
				eventManager: n?.eventManager,
				profiler: n?.profiler,
				logger: n?.logger,
				tracker: n?.tracker || this.tracker
			})), a && await a(this.controllers[t.id]), this.controllers[t.id];
		}, this.handlers = {
			attributes: (e) => {
				let t = this.tracker.config.id, n = [
					`ss-${t}-cart-add`,
					`ss-${t}-cart-remove`,
					`ss-${t}-cart-clear`,
					`ss-${t}-cart-view`,
					`ss-${t}-intellisuggest`,
					`ss-${t}-intellisuggest-signature`,
					"href"
				], r = {}, i = 0, a = null;
				for (a = e && e.target; Object.keys(r).length == 0 && a !== null && i <= gw;) a.attributes && Object.values(a.attributes).forEach((e) => {
					let t = e.nodeName;
					n.indexOf(t) != -1 && (r[t] = a && a.getAttribute(t));
				}), a = a.parentElement, i++;
				if (r[`ss-${t}-cart-add`]) {
					let e = r[`ss-${t}-cart-add`].split(",");
					this.tracker.cookies.cart.add(e), this.eventManager.fire("controller/recommendation/update");
				} else if (r[`ss-${t}-cart-remove`]) {
					let e = r[`ss-${t}-cart-remove`].split(",");
					this.tracker.cookies.cart.remove(e), this.eventManager.fire("controller/recommendation/update");
				} else `ss-${t}-cart-clear` in r ? (this.tracker.cookies.cart.clear(), this.eventManager.fire("controller/recommendation/update")) : `ss-${t}-cart-view` in r ? this.eventManager.fire("controller/recommendation/update") : r[`ss-${t}-intellisuggest`] && r[`ss-${t}-intellisuggest-signature`] && this.tracker.track.product.click();
			},
			error: (e) => {
				try {
					let { filename: t } = e;
					if ((t.includes("snapui.searchspring.io") || t.includes("snapui.athoscommerce.io")) && t.endsWith(".js") && this.tracker.track.error) {
						let { colno: n, lineno: r, error: { stack: i }, message: a, timeStamp: o } = e, s = {
							href: window.location.href,
							filename: t,
							stack: i,
							message: a,
							colno: n,
							lineno: r,
							errortimestamp: o
						};
						this.tracker.track.error(s);
					}
				} catch {}
			}
		}, window.removeEventListener("error", this.handlers.error), window.addEventListener("error", this.handlers.error), document.removeEventListener("click", this.handlers.attributes), document.addEventListener("click", this.handlers.attributes), this.config = e;
		let n = {};
		try {
			n = tu([
				"shopper",
				"config",
				"custom",
				"merchandising",
				"siteId",
				"currency",
				"page",
				"backgroundFilters",
				"collection",
				"tags",
				"category",
				"brand"
			]);
		} catch {
			console.error("Snap failed to find global context");
		}
		if (this.config = (0, dw.default)(this.config || {}, n.config || {}, { isMergeableObject: Ci }), this.context = (0, dw.default)(this.config.context || {}, n || {}, { isMergeableObject: Ci }), !this.config?.client?.globals?.siteId && this.context.siteId) {
			let e = { globals: { siteId: this.context.siteId } };
			this.config.client = (0, dw.default)(e, this.config.client || {});
		}
		if ((!t?.client || !t?.tracker) && !this.config?.client?.globals?.siteId) throw t?.templatesStore ? Error("SnapTemplates: config provided must contain a valid config.siteId value") : Error("Snap: config provided must contain a valid config.client.globals.siteId value");
		this.config.client?.globals && this.context.merchandising?.segments && (this.config.client.globals?.merchandising ? this.config.client.globals.merchandising.segments = (0, dw.default)(this.config.client.globals.merchandising.segments, this.context.merchandising.segments) : this.config.client.globals.merchandising = { segments: this.context.merchandising.segments }), t?.templatesStore && (this.templates = t.templatesStore);
		try {
			let e = ou(window.location.href), n = e?.params?.query["athos-preview"] || Yl.get("athosBranch"), r = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0;
			Object.values(ku).includes("production") && (this.mode = "production"), this.config.mode && Object.values(ku).includes(this.config.mode) && (this.mode = this.config.mode), (e?.params?.query && "dev" in e.params.query || Yl.get("athos-Dev")) && (e?.params.query?.dev == "false" || e?.params.query?.dev == "0" ? (Yl.unset(mw, r), this.mode = ku.production) : (Yl.set(mw, "1", "Lax", 0, r), this.mode = ku.development));
			let i = window?.athos?.managed ? "managed/" : "";
			this.config.client && (this.config.client.config = this.config.client.config || {}, this.config.client.config.initiator || (this.config.client.config.initiator = `athos/${i}snap/preact/${Su}`), this.config.client.config.mode = this.config.client.config.mode || this.mode), Ub(this.config), this.client = t?.client || new Dd(this.config.client.globals, this.config.client.config), this.logger = t?.logger || new Pd({
				prefix: `${this.config.tracker?.config?.framework == "snap/templates" ? "Snap Preact Templates " : this.config.tracker?.config?.framework == "snap/hybrid" ? "Snap Preact Hybrid " : "Snap Preact "}`,
				mode: this.mode
			});
			let a = this.config.tracker?.globals || this.config.client.globals;
			this.context.currency?.code && (a = (0, dw.default)(a || {}, { currency: this.context.currency })), this.context.shopper?.cart && (a = (0, dw.default)(a || {}, { cart: this.context.shopper.cart }));
			let o = (0, dw.default)(this.config.tracker?.config || {}, {
				framework: `${i}${this.config.tracker?.config?.framework || "snap"}/preact`,
				mode: this.mode
			});
			if (this.tracker = t?.tracker || new b_(a, o), this.logger.imageText({
				url: "https://snapui.athoscommerce.io/favicon.svg",
				text: `[${Su}]`,
				style: `color: ${this.logger.colors.indigo}; font-weight: bold;`
			}), n && !document.querySelector("script[athosBranch]")) {
				this.logger.warn(`:: loading branch override ~ '${n}' ...`), ql.cookies ? Yl.set(fw, n, "Lax", 36e5, r) : this.logger.warn("Cookies are not supported/enabled by this browser, branch overrides will not persist!");
				let e = `https://snapui.athoscommerce.io/${this.config.client?.globals?.siteId}/`, t = document.querySelector("script[src*=\"//snapui.searchspring.io\"], script[src*=\"//snapui.athoscommerce.io\"]");
				if (t) {
					let n = t.getAttribute("src").match(/\/\/snapui.searchspring.io\/[a-zA-Z0-9]{6}\//);
					n ? e = n.toString() : (n = t.getAttribute("src").match(/\/\/snapui.athoscommerce.io\/[a-zA-Z0-9]{6}\//), n && (e = n.toString()));
				}
				let i = document.createElement("script"), a = `${e}${n}/bundle.js`;
				throw i.src = a, i.setAttribute(fw, n), new Vl([{
					selector: "body",
					inject: {
						action: "append",
						element: () => {
							let e = document.createElement("div");
							return e.id = "athos-branch-override", e;
						}
					}
				}], async (e, t) => {
					let o = {};
					try {
						let e = (await Promise.resolve().then(() => (sx(), ax))).getBundleDetails;
						o.details = await e(a);
					} catch (e) {
						o.error = e;
					}
					let s = (await Promise.resolve().then(() => (ew(), $C))).BranchOverride;
					se(B(s, {
						...o,
						branch: n,
						onRemoveClick: () => {
							Yl.unset(fw, r);
							let e = ou(window.location.href);
							delete e?.params.query[pw];
							let t = e?.url();
							t && t != window.location.href ? window.location.href = t : window.location.reload();
						}
					}), t);
					try {
						delete window.athos;
					} catch {
						window.athos = void 0;
					}
					document.head.appendChild(i);
				}), document.querySelectorAll(`.${hw}`).forEach((e) => e.remove()), "branch override";
			}
		} catch (e) {
			if (e == "branch override") throw `${this.logger.emoji.bang} Snap instantiation halted - using branch override.`;
			this.logger.error(e);
		}
		if (window.athos = window.athos || {}, window.athos.build = window.athos.build || "modern", window.athos.context = this.context, this.client && (window.athos.client = this.client), t?.templatesStore && (window.athos.templates = this.templates), this.eventManager = Jb(), this.eventManager && (window.athos.on = (e, ...t) => {
			this.eventManager.on(e, ...t);
		}, window.athos.fire = (e, ...t) => {
			this.eventManager.fire(e, ...t);
		}), this.context?.shopper?.id && this.tracker.track.shopper.login({ id: this.context.shopper.id }), Object.keys(this.config?.controllers || {}).forEach((e) => {
			switch (e) {
				case "search":
					this.config.controllers[e].forEach((t, n) => {
						try {
							if (this._controllerPromises[t.config.id] !== void 0) {
								this.logger.error(`Controller with id '${t.config.id}' is already defined`);
								return;
							}
							let e = Vb({
								mode: this.mode,
								url: (0, dw.default)(this.config.url || {}, t.url || {}),
								controller: t.config,
								context: (0, dw.default)(this.context || {}, t.context || {})
							}, {
								client: t.services?.client || this.client,
								store: t.services?.store,
								urlManager: t.services?.urlManager,
								eventManager: t.services?.eventManager,
								profiler: t.services?.profiler,
								logger: t.services?.logger,
								tracker: t.services?.tracker || this.tracker
							});
							window.athos.controller = window.athos.controller || {}, window.athos.controller[e.config.id] = this.controllers[e.config.id] = e, this._controllerPromises[e.config.id] = new Promise((t) => t(e));
							let n = null, r = async () => (n ||= (t.url?.initial && ub(t.url.initial, e.urlManager).go({ history: "replace" }), this.controllers[t.config.id].search()), n), i = async (e, n, i) => {
								let a = [];
								e.renderAfterSearch ? a.push(r()) : (a.push(Promise.resolve()), r());
								let o = e.onTarget;
								o && await o(e, n, i);
								try {
									a.push(e.component());
									let [r, i] = await Promise.all(a);
									setTimeout(() => {
										se(B(i, {
											controller: this.controllers[t.config.id],
											snap: this,
											...e.props
										}), n);
									});
								} catch (t) {
									this.logger.error(t), this.logger.error(_w, e);
								}
							};
							t?.targeters?.forEach((t, n) => {
								if (!t.selector) throw Error(`Targets at index ${n} missing selector value (string).`);
								if (!t.component) throw Error(`Targets at index ${n} missing component value (Component).`);
								let a = this.context.pageType && `${this.context.pageType}`.toLowerCase().trim();
								(t.prefetch || ["search", "category"].includes(a)) && (r(), t.component()), e.createTargeter({
									controller: e,
									...t
								}, async (e, t, n) => {
									if (e && e.skeleton && t) {
										let n = await e.skeleton();
										setTimeout(() => {
											se(B(n, {}), t);
										});
									}
									await i(e, t, n);
								});
							});
						} catch (t) {
							this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
						}
					});
					break;
				case "autocomplete":
					this.config.controllers[e].forEach((t, n) => {
						if (this._controllerPromises[t.config.id] !== void 0) {
							this.logger.error(`Controller with id '${t.config.id}' is already defined`);
							return;
						}
						this._controllerPromises[t.config.id] = new Promise(async (r) => {
							try {
								let e = !1, n = () => {
									e || (e = !0, setTimeout(() => {
										this.controllers[t.config.id].bind();
									}));
								}, i = async (e, n, r) => {
									let i = e.onTarget;
									i && await i(e, n, r);
									try {
										let i = [];
										i.push(e.component());
										let a = (await Promise.all(i))[0];
										setTimeout(() => {
											se(B(a, {
												controller: this.controllers[t.config.id],
												input: r,
												snap: this,
												...e.props
											}), n);
										});
									} catch (t) {
										this.logger.error(t), this.logger.error(_w, e);
									}
								};
								(!t?.targeters || t?.targeters.length === 0) && (await this._createController(xy.autocomplete, t.config, t.services, t.url, t.context, (e) => {
									e && r(e);
								}), n()), t?.targeters?.forEach((e, a) => {
									if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
									if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
									let o = new Vl([{
										inject: {
											action: "after",
											element: () => {
												let e = document.createElement("div");
												return e.className = "ss__autocomplete--target", e.addEventListener("click", (e) => {
													e.stopPropagation();
												}), e;
											}
										},
										...e
									}], async (e, a, s) => {
										let c = await this._createController(xy.autocomplete, t.config, t.services, t.url, t.context, (e) => {
											e && r(e);
										});
										n(), i({
											controller: c,
											...e
										}, a, s), c.addTargeter(o);
									});
								});
							} catch (t) {
								this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
							}
						});
					});
					break;
				case "finder":
					this.config.controllers[e].forEach((t, n) => {
						if (this._controllerPromises[t.config.id] !== void 0) {
							this.logger.error(`Controller with id '${t.config.id}' is already defined`);
							return;
						}
						this._controllerPromises[t.config.id] = new Promise((r) => {
							try {
								let e = !1, n = () => {
									e ||= (this.controllers[t.config.id].search(), !0);
								}, i = async (e, n, r) => {
									let i = e.onTarget;
									i && await i(e, n, r);
									try {
										let r = await e.component();
										setTimeout(() => {
											se(B(r, {
												controller: this.controllers[t.config.id],
												snap: this,
												...e.props
											}), n);
										});
									} catch (t) {
										this.logger.error(t), this.logger.error(_w, e);
									}
								};
								(!t?.targeters || t?.targeters.length === 0) && this._createController(xy.finder, t.config, t.services, t.url, t.context, (e) => {
									e && r(e);
								}), t?.targeters?.forEach((e, a) => {
									if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
									if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
									let o = new Vl([{ ...e }], async (e, a, s) => {
										let c = await this._createController(xy.finder, t.config, t.services, t.url, t.context, (e) => {
											e && r(e);
										});
										n(), i({
											controller: c,
											...e
										}, a, s), c.addTargeter(o);
									});
								});
							} catch (t) {
								this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
							}
						});
					});
					break;
				case "recommendation": this.config.controllers[e].forEach((t, n) => {
					if (this._controllerPromises[t.config.id] !== void 0) {
						this.logger.error(`Controller with id '${t.config.id}' is already defined`);
						return;
					}
					this._controllerPromises[t.config.id] = new Promise((r) => {
						try {
							let e = !1, n = () => {
								e ||= (this.controllers[t.config.id].search(), !0);
							}, i = async (e, n, r) => {
								let i = e.onTarget;
								i && await i(e, n, r);
								try {
									let r = await e.component();
									setTimeout(() => {
										se(B(r, {
											controller: this.controllers[t.config.id],
											snap: this,
											...e.props
										}), n);
									});
								} catch (t) {
									this.logger.error(t), this.logger.error(_w, e);
								}
							};
							(!t?.targeters || t?.targeters.length === 0) && this._createController(xy.recommendation, t.config, t.services, t.url, t.context, (e) => {
								e && r(e);
							}), t?.targeters?.forEach((e, a) => {
								if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
								if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
								let o = new Vl([{ ...e }], async (e, a, s) => {
									let c = await this._createController(xy.recommendation, t.config, t.services, t.url, t.context, (e) => {
										e && r(e);
									});
									n(), i({
										controller: c,
										...e
									}, a, s), c.addTargeter(o);
								});
							});
						} catch (t) {
							this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
						}
					});
				});
			}
		}), this.config?.instantiators?.recommendation) try {
			this._instantiatorPromises.recommendation = Promise.resolve().then(() => (uw(), nw)).then(({ RecommendationInstantiator: e }) => (this.config.instantiators.recommendation.mode = this.config.instantiators.recommendation.mode || this.mode, new e(this.config.instantiators.recommendation, {
				client: this.client,
				tracker: this.tracker,
				logger: this.logger,
				snap: this
			}, this.context)));
		} catch (e) {
			this.logger.error("Failed to create Recommendations Instantiator.", e);
		}
	}
}, yw = o((() => {})), bw, xw, Sw, Cw, ww, Tw, Ew, Dw, Ow, kw, Aw, jw, Mw, Nw, Pw, Fw, Iw, Lw, Rw, zw, Bw, Vw, Hw, Uw, Ww, Gw, Kw, qw, Jw, Yw, Xw, Zw, Qw, $w, eT = o((() => {
	for (bw = {
		grad: .9,
		turn: 360,
		rad: 360 / (2 * Math.PI)
	}, xw = function(e) {
		return typeof e == "string" ? e.length > 0 : typeof e == "number";
	}, Sw = function(e, t, n) {
		return t === void 0 && (t = 0), n === void 0 && (n = 10 ** t), Math.round(n * e) / n + 0;
	}, Cw = function(e, t, n) {
		return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e > t ? e : t;
	}, ww = function(e) {
		return (e = isFinite(e) ? e % 360 : 0) < 0 ? e + 360 : e;
	}, Tw = function(e, t) {
		return t === void 0 && (t = 0), Sw(e, t) % 360;
	}, Ew = function(e) {
		return {
			r: Cw(e.r, 0, 255),
			g: Cw(e.g, 0, 255),
			b: Cw(e.b, 0, 255),
			a: Cw(e.a)
		};
	}, Dw = function(e) {
		return {
			r: Sw(e.r),
			g: Sw(e.g),
			b: Sw(e.b),
			a: Sw(e.a, 3)
		};
	}, Ow = /^#([0-9a-f]{3,8})$/i, kw = function(e, t) {
		var n = e.charCodeAt(t);
		return (15 & n) + 9 * (n >> 6);
	}, Aw = function(e, t) {
		return kw(e, t) << 4 | kw(e, t + 1);
	}, jw = [], Mw = 0; Mw < 256; Mw++) jw.push((Mw < 16 ? "0" : "") + Mw.toString(16));
	Nw = function(e) {
		return jw[Cw(e, 0, 255)];
	}, Pw = function(e) {
		var t = e.r, n = e.g, r = e.b, i = e.a, a = Math.max(t, n, r), o = a - Math.min(t, n, r), s = o ? a === t ? (n - r) / o : a === n ? 2 + (r - t) / o : 4 + (t - n) / o : 0;
		return {
			h: 60 * (s < 0 ? s + 6 : s),
			s: a ? o / a * 100 : 0,
			v: a / 255 * 100,
			a: i
		};
	}, Fw = function(e) {
		var t = e.h, n = e.s, r = e.v, i = e.a;
		t = t / 360 * 6, n /= 100, r /= 100;
		var a = Math.floor(t), o = r * (1 - n), s = r * (1 - (t - a) * n), c = r * (1 - (1 - t + a) * n), l = a % 6;
		return {
			r: 255 * [
				r,
				s,
				o,
				o,
				c,
				r
			][l],
			g: 255 * [
				c,
				r,
				r,
				s,
				o,
				o
			][l],
			b: 255 * [
				o,
				o,
				c,
				r,
				r,
				s
			][l],
			a: i
		};
	}, Iw = function(e) {
		return {
			h: ww(e.h),
			s: Cw(e.s, 0, 100),
			l: Cw(e.l, 0, 100),
			a: Cw(e.a)
		};
	}, Lw = function(e) {
		return {
			h: Tw(e.h),
			s: Sw(e.s),
			l: Sw(e.l),
			a: Sw(e.a, 3)
		};
	}, Rw = function(e) {
		return Fw((n = (t = e).s, {
			h: t.h,
			s: (n *= ((r = t.l) < 50 ? r : 100 - r) / 100) > 0 ? 2 * n / (r + n) * 100 : 0,
			v: r + n,
			a: t.a
		}));
		var t, n, r;
	}, zw = function(e) {
		return {
			h: (t = Pw(e)).h,
			s: (i = (200 - (n = t.s)) * (r = t.v) / 100) > 0 && i < 200 ? n * r / 100 / (i <= 100 ? i : 200 - i) * 100 : 0,
			l: i / 2,
			a: t.a
		};
		var t, n, r, i;
	}, Bw = /^hsla?\(\s*([+-]?(?:\d*\.\d+|\d+))(deg|rad|grad|turn)?\s*,\s*([+-]?(?:\d*\.\d+|\d+))%\s*,\s*([+-]?(?:\d*\.\d+|\d+))%\s*(?:,\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s*)?\)$/i, Vw = /^hsla?\(\s*([+-]?(?:\d*\.\d+|\d+))(deg|rad|grad|turn)?\s+([+-]?(?:\d*\.\d+|\d+))%\s+([+-]?(?:\d*\.\d+|\d+))%\s*(?:\/\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s*)?\)$/i, Hw = /^rgba?\(\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s*,\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s*,\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s*(?:,\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s*)?\)$/i, Uw = /^rgba?\(\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s+([+-]?(?:\d*\.\d+|\d+))(%)?\s+([+-]?(?:\d*\.\d+|\d+))(%)?\s*(?:\/\s*([+-]?(?:\d*\.\d+|\d+))(%)?\s*)?\)$/i, Ww = {
		string: [
			[function(e) {
				if (!Ow.test(e)) return null;
				var t = e.length;
				return t <= 5 ? {
					r: 17 * kw(e, 1),
					g: 17 * kw(e, 2),
					b: 17 * kw(e, 3),
					a: t === 5 ? Sw(17 * kw(e, 4) / 255, 2) : 1
				} : t === 7 || t === 9 ? {
					r: Aw(e, 1),
					g: Aw(e, 3),
					b: Aw(e, 5),
					a: t === 9 ? Sw(Aw(e, 7) / 255, 2) : 1
				} : null;
			}, "hex"],
			[function(e) {
				var t = Hw.exec(e) || Uw.exec(e);
				return t ? t[2] !== t[4] || t[4] !== t[6] ? null : Ew({
					r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
					g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
					b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
					a: t[7] === void 0 ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
				}) : null;
			}, "rgb"],
			[function(e) {
				var t = Bw.exec(e) || Vw.exec(e);
				if (!t) return null;
				var n, r;
				return Rw(Iw({
					h: (n = t[1], r = t[2], r === void 0 && (r = "deg"), Number(n) * (bw[r] || 1)),
					s: Number(t[3]),
					l: Number(t[4]),
					a: t[5] === void 0 ? 1 : Number(t[5]) / (t[6] ? 100 : 1)
				}));
			}, "hsl"]
		],
		object: [
			[function(e) {
				var t = e.r, n = e.g, r = e.b, i = e.a, a = i === void 0 ? 1 : i;
				return xw(t) && xw(n) && xw(r) ? Ew({
					r: Number(t),
					g: Number(n),
					b: Number(r),
					a: Number(a)
				}) : null;
			}, "rgb"],
			[function(e) {
				var t = e.h, n = e.s, r = e.l, i = e.a, a = i === void 0 ? 1 : i;
				return !xw(t) || !xw(n) || !xw(r) ? null : Rw(Iw({
					h: Number(t),
					s: Number(n),
					l: Number(r),
					a: Number(a)
				}));
			}, "hsl"],
			[function(e) {
				var t = e.h, n = e.s, r = e.v, i = e.a, a = i === void 0 ? 1 : i;
				return !xw(t) || !xw(n) || !xw(r) ? null : Fw(function(e) {
					return {
						h: ww(e.h),
						s: Cw(e.s, 0, 100),
						v: Cw(e.v, 0, 100),
						a: Cw(e.a)
					};
				}({
					h: Number(t),
					s: Number(n),
					v: Number(r),
					a: Number(a)
				}));
			}, "hsv"]
		]
	}, Gw = function(e, t) {
		for (var n = 0; n < t.length; n++) {
			var r = t[n][0](e);
			if (r) return [r, t[n][1]];
		}
		return [null, void 0];
	}, Kw = function(e) {
		return typeof e == "string" ? Gw(e.trim(), Ww.string) : typeof e == "object" && e ? Gw(e, Ww.object) : [null, void 0];
	}, qw = function(e, t) {
		var n = zw(e);
		return {
			h: n.h,
			s: Cw(n.s + 100 * t, 0, 100),
			l: n.l,
			a: n.a
		};
	}, Jw = function(e) {
		return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
	}, Yw = function(e, t) {
		var n = zw(e);
		return {
			h: n.h,
			s: n.s,
			l: Cw(n.l + 100 * t, 0, 100),
			a: n.a
		};
	}, Xw = function() {
		function e(e) {
			this.parsed = Kw(e)[0], this.rgba = this.parsed || {
				r: 0,
				g: 0,
				b: 0,
				a: 1
			};
		}
		return e.prototype.isValid = function() {
			return this.parsed !== null;
		}, e.prototype.brightness = function() {
			return Sw(Jw(this.rgba), 2);
		}, e.prototype.isDark = function() {
			return Jw(this.rgba) < .5;
		}, e.prototype.isLight = function() {
			return Jw(this.rgba) >= .5;
		}, e.prototype.toHex = function() {
			return e = Dw(this.rgba), t = e.r, n = e.g, r = e.b, a = (i = e.a) < 1 ? Nw(Sw(255 * i)) : "", "#" + Nw(t) + Nw(n) + Nw(r) + a;
			var e, t, n, r, i, a;
		}, e.prototype.toRgb = function() {
			return Dw(this.rgba);
		}, e.prototype.toRgbString = function() {
			return e = Dw(this.rgba), t = e.r, n = e.g, r = e.b, (i = e.a) < 1 ? "rgba(" + t + ", " + n + ", " + r + ", " + i + ")" : "rgb(" + t + ", " + n + ", " + r + ")";
			var e, t, n, r, i;
		}, e.prototype.toHsl = function() {
			return Lw(zw(this.rgba));
		}, e.prototype.toHslString = function() {
			return e = Lw(zw(this.rgba)), t = e.h, n = e.s, r = e.l, (i = e.a) < 1 ? "hsla(" + t + ", " + n + "%, " + r + "%, " + i + ")" : "hsl(" + t + ", " + n + "%, " + r + "%)";
			var e, t, n, r, i;
		}, e.prototype.toHsv = function() {
			return e = Pw(this.rgba), {
				h: Tw(e.h),
				s: Sw(e.s),
				v: Sw(e.v),
				a: Sw(e.a, 3)
			};
			var e;
		}, e.prototype.invert = function() {
			return Zw({
				r: 255 - (e = this.rgba).r,
				g: 255 - e.g,
				b: 255 - e.b,
				a: e.a
			});
			var e;
		}, e.prototype.saturate = function(e) {
			return e === void 0 && (e = .1), Zw(qw(this.rgba, e));
		}, e.prototype.desaturate = function(e) {
			return e === void 0 && (e = .1), Zw(qw(this.rgba, -e));
		}, e.prototype.grayscale = function() {
			return Zw(qw(this.rgba, -1));
		}, e.prototype.lighten = function(e) {
			return e === void 0 && (e = .1), Zw(Yw(this.rgba, e));
		}, e.prototype.darken = function(e) {
			return e === void 0 && (e = .1), Zw(Yw(this.rgba, -e));
		}, e.prototype.rotate = function(e) {
			return e === void 0 && (e = 15), this.hue(zw(this.rgba).h + e);
		}, e.prototype.alpha = function(e) {
			return typeof e == "number" ? Zw({
				r: (t = this.rgba).r,
				g: t.g,
				b: t.b,
				a: e
			}) : Sw(this.rgba.a, 3);
			var t;
		}, e.prototype.hue = function(e) {
			var t = zw(this.rgba);
			return typeof e == "number" ? Zw({
				h: e,
				s: t.s,
				l: t.l,
				a: t.a
			}) : Tw(t.h);
		}, e.prototype.isEqual = function(e) {
			return this.toHex() === Zw(e).toHex();
		}, e;
	}(), Zw = function(e) {
		return e instanceof Xw ? e : new Xw(e);
	}, Qw = [], $w = function(e) {
		e.forEach(function(e) {
			Qw.indexOf(e) < 0 && (e(Xw, Ww), Qw.push(e));
		});
	};
})), tT = o((() => {})), nT, rT, iT = o((() => {
	(function(e) {
		e.grid = "grid", e.list = "list";
	})(nT ||= {}), (function(e) {
		e.GRID = "grid", e.PALETTE = "palette", e.LIST = "list", e.SLIDER = "slider", e.HIERARCHY = "hierarchy", e.TOGGLE = "toggle";
	})(rT ||= {});
})), aT, oT, sT, cT = o((() => {
	H(), ux(), aT = /* @__PURE__ */ u(X()), BC(), OC(), KS(), iT(), Q(), tC(), oT = ({ width: e }) => cx({
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		width: e,
		"&.ss__inline-banner--grid": { flexDirection: "column" },
		"&.ss__inline-banner--list": {
			flexDirection: "row",
			display: "block",
			width: "100%"
		},
		"& iframe": { maxWidth: "100%" }
	}), sT = Jx(kC(Z((e) => {
		let t = mi(), n = RC(), r = uS("inlineBanner", t, {
			layout: nT.grid,
			width: "auto",
			treePath: n
		}, e), { banner: i, className: a, internalClassName: o, disableA11y: s, layout: c, onClick: l } = r, { overrideElement: u, shouldRenderDefault: d } = QS("inlineBanner", r);
		if (!d) return u;
		let f = gS(r, oT);
		return i && i.value ? B(Kx, { children: B("div", {
			onClick: (e) => {
				l && l(e, i);
			},
			role: "article",
			ref: (t) => {
				!s && VS(t), e.trackingRef(t);
			},
			className: (0, aT.default)("ss__inline-banner", `ss__inline-banner--${c}`, a, o),
			...f,
			dangerouslySetInnerHTML: { __html: i.value }
		}) }) : null;
	})));
})), lT = o((() => {
	cT();
})), uT, dT, fT, pT, mT = o((() => {
	H(), R(), ux(), uT = /* @__PURE__ */ u(X()), Q(), BC(), OC(), tC(), dT = "//cdn.athoscommerce.net/snap/images/fallback.png", fT = ({ height: e }) => cx({
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		height: e || "auto",
		"& img": {
			flexShrink: "0",
			objectFit: "contain",
			maxWidth: "100%",
			maxHeight: "100%"
		},
		"&.ss__image--hidden": { "& img": { visibility: "hidden" } }
	}), pT = Z((e) => {
		let t = mi(), n = RC(), r = uS("image", t, {
			fallback: dT,
			lazy: !0,
			treePath: n
		}, e), { alt: i, src: a, fallback: o, title: s, hoverSrc: c, lazy: l, onMouseOver: u, onMouseOut: d, onError: f, onLoad: p, onClick: m, className: h, internalClassName: g } = r, { overrideElement: _, shouldRenderDefault: v } = QS("image", r);
		if (!v) return _;
		let [y, b] = I(!1), [x, S] = I(!1), C = Pe("");
		L(() => {
			C.current = a;
		}), C.current && C.current != a && b(!1);
		let w = gS(r, fT);
		return B(Kx, { children: B("div", {
			...w,
			className: (0, uT.default)("ss__image", { "ss__image--hidden": !y }, h, g),
			children: B("img", {
				src: (x ? c : a) || o,
				alt: i,
				title: s || i,
				loading: l ? "lazy" : void 0,
				onLoad: (e) => {
					b(!0), p && p(e);
				},
				onClick: (e) => m && m(e),
				onError: (e) => {
					e.target.src = o || "", f && f(e);
				},
				onMouseOver: (e) => {
					c && S(!0), u && u(e);
				},
				onMouseOut: (e) => {
					c && S(!1), d && d(e);
				}
			})
		}) });
	});
})), hT = o((() => {
	mT();
})), gT, _T, vT, yT = o((() => {
	H(), Q(), Iu(), ux(), gT = /* @__PURE__ */ u(X()), BC(), OC(), tC(), _T = ({ theme: e }) => cx({
		color: e?.variables?.colors?.primary,
		"&.ss__price--strike": {
			textDecoration: "line-through",
			color: "initial"
		}
	}), vT = Z((e) => {
		let t = uS("price", mi(), {
			symbol: "$",
			decimalPlaces: 2,
			padDecimalPlaces: !0,
			thousandsSeparator: ",",
			decimalSeparator: ".",
			symbolAfter: !1,
			lineThrough: !1,
			treePath: RC()
		}, e), { lineThrough: n, value: r, format: i, symbol: a, decimalPlaces: o, padDecimalPlaces: s, thousandsSeparator: c, decimalSeparator: l, symbolAfter: u, raw: d, className: f, internalClassName: p } = t, { overrideElement: m, shouldRenderDefault: h } = QS("price", t);
		if (!h) return m;
		let g;
		r && (g = i ? i(r) : Nl(r, {
			symbol: "",
			decimalPlaces: o,
			padDecimalPlaces: s,
			thousandsSeparator: c,
			decimalSeparator: l
		}));
		let _ = gS(t, _T);
		return g ? d ? B(xi, { children: g }) : B(Kx, { children: V("span", {
			..._,
			className: (0, gT.default)("ss__price", { "ss__price--strike": n }, f, p),
			children: [
				!i && a && !u ? B("span", {
					className: "ss__price__symbol",
					children: a
				}) : B(xi, {}),
				B("span", {
					className: "ss__price__value",
					children: g
				}),
				!i && a && u ? B("span", {
					className: "ss__price__symbol",
					children: a
				}) : B(xi, {})
			]
		}) }) : null;
	});
})), bT = o((() => {
	yT();
})), xT, ST, CT, wT, TT = o((() => {
	H(), ux(), xT = /* @__PURE__ */ u(X()), Q(), BC(), OC(), tC(), ST = () => cx({
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		gap: "5px"
	}), CT = ({ badge: e, badgeComponentMap: t, treePath: n }) => {
		let { ComponentOverride: r } = XS(t, e.component);
		return r ? B(r, {
			...e,
			...e.parameters,
			treePath: n
		}) : null;
	}, wT = Z((e) => {
		let t = mi(), n = FC(), r = uS("calloutBadge", t, {
			tag: "callout",
			limit: 1,
			treePath: RC()
		}, e), { result: i, tag: a, renderEmpty: o, limit: s, className: c, internalClassName: l, treePath: u } = r, { overrideElement: d, shouldRenderDefault: f } = QS("calloutBadge", r);
		if (!f) return d;
		let p = {
			...SC,
			...n?.templates?.library.import.component.badge || {},
			...r.componentMap
		}, m = gS(r, ST), h = i?.display.badges?.atLocation(a).slice(0, s);
		return o || h?.length ? B(Kx, { children: B("div", {
			...m,
			className: (0, xT.default)("ss__callout-badge", `ss__callout-badge--${a?.replace("/", "-")}`, c, l),
			children: h.map((e, t) => B(CT, {
				badge: e,
				badgeComponentMap: p,
				treePath: u
			}, `${e.component}-${t}`))
		}) }) : null;
	});
})), ET = o((() => {
	TT();
})), DT, OT, kT, AT, jT, MT = o((() => {
	H(), ux(), DT = /* @__PURE__ */ u(X()), Q(), BC(), OC(), tC(), OT = ({ section: e, top: t, bottom: n, index: r, tag: i }) => cx({
		position: "relative",
		display: "flex",
		flexDirection: "column",
		alignItems: e == "right" ? "flex-end" : "flex-start",
		justifyContent: !t && !n ? "center" : n && !t ? "flex-end" : "flex-start",
		gap: "0.5em",
		gridArea: i,
		boxSizing: "border-box",
		zIndex: Math.max(100 - r, 1),
		width: "100%",
		height: "100%"
	}), kT = ({ controller: e }) => {
		let t = e?.store?.meta?.badges?.groups?.overlay?.grid, n = {};
		if (t?.length && t[0]?.length) {
			let e = t.map((e) => `"${e.join(" ")}"`).join(" ");
			n = {
				gridTemplateColumns: `repeat(${t[0].length}, minmax(0, 1fr))`,
				gridTemplateRows: `repeat(${t.length}, minmax(0, 1fr))`,
				gridTemplateAreas: e
			};
		}
		return cx({
			position: "relative",
			"& .ss__overlay-badge__grid-wrapper": {
				pointerEvents: "none",
				display: "grid",
				position: "absolute",
				top: 0,
				right: 0,
				bottom: 0,
				left: 0,
				...n
			}
		});
	}, AT = ({ badge: e, badgeComponentMap: t, treePath: n }) => {
		let { ComponentOverride: r } = XS(t, e.component);
		return r ? B(r, {
			...e,
			...e.parameters,
			treePath: n
		}) : null;
	}, jT = Z((e) => {
		let t = mi(), n = FC(), r = uS("overlayBadge", t, {
			limit: 1,
			treePath: RC()
		}, e), { result: i, children: a, controller: o, renderEmpty: s, limit: c, className: l, internalClassName: u, treePath: d } = r, { overrideElement: f, shouldRenderDefault: p } = QS("overlayBadge", r);
		if (!p) return f;
		if (!a) return o?.log?.warn("OverlayBadge component must have children"), null;
		let m = o?.store?.meta;
		if (!m) return o?.log?.warn("Controller must have a meta store"), B(xi, { children: a });
		let h = {
			...SC,
			...n?.templates?.library.import.component.badge || {},
			...r.componentMap
		}, g = (m?.badges?.groups?.overlay?.sections)?.map((e) => {
			let t = m?.data?.badges?.locations[e];
			return {
				section: e,
				slots: t?.map((n, r) => ({
					tag: n.tag,
					name: n.name,
					top: r == 0,
					bottom: r == t.length - 1,
					badges: i?.display.badges?.atLocation(`${e}/${n.tag}`).slice(0, c)
				})).filter((e) => e.badges?.length)
			};
		}).filter((e) => e.slots?.length), _ = gS(r, kT);
		return s || g?.length ? B(Kx, { children: V("div", {
			..._,
			className: (0, DT.default)("ss__overlay-badge", l, u),
			children: [B("div", {
				className: "ss__overlay-badge__grid-wrapper",
				children: g.map((e, t) => e.slots?.map((n) => {
					let i = OT({
						...r,
						tag: n.tag,
						section: e.section,
						index: t,
						top: n.top,
						bottom: n.bottom
					});
					return B("div", {
						className: (0, DT.default)("ss__overlay-badge__grid-wrapper__slot", `ss__overlay-badge__grid-wrapper__slot--${n.tag}`),
						css: [i],
						children: n.badges.map((e, t) => B(AT, {
							badge: e,
							badgeComponentMap: h,
							treePath: d
						}, `${n.tag}-${e.component}-${t}`))
					}, `${e.section}-${n.tag}`);
				}))
			}), a]
		}) }) : B(xi, { children: a });
	});
})), NT = o((() => {
	MT();
})), PT = o((() => {
	qC(), UC();
})), FT, IT, LT, RT = o((() => {
	H(), Q(), ux(), FT = /* @__PURE__ */ u(X()), BC(), OC(), PT(), tC(), IT = () => cx({
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"& .ss__rating__icons": { position: "relative" },
		"& .ss__rating__stars": {
			width: "100%",
			display: "inline-grid",
			gridTemplateColumns: "20% 20% 20% 20% 20%",
			"&.ss__rating__stars--full": {
				position: "absolute",
				top: 0,
				left: 0
			},
			"&.ss__rating__stars--empty": { position: "relative" }
		},
		"& .ss__rating__stars__star": { overflow: "hidden" },
		"& .ss__icon": { maxWidth: "max-content" }
	}), LT = Z((e) => {
		let t = uS("rating", mi(), {
			fullIcon: "star",
			emptyIcon: "star-o",
			treePath: RC()
		}, e), { alwaysRender: n, count: r, text: i, disablePartialFill: a, emptyIcon: o, fullIcon: s, disableStyles: c, className: l, internalClassName: u, treePath: d } = t, { overrideElement: f, shouldRenderDefault: p } = QS("rating", t);
		if (!p) return f;
		let m = {
			fullIcon: {
				name: "star--full",
				...$({ disableStyles: c }),
				theme: t?.theme,
				treePath: d
			},
			emptyIcon: {
				name: "star--empty",
				color: "#ccc",
				...$({ disableStyles: c }),
				theme: t?.theme,
				treePath: d
			}
		}, h = t.value;
		isNaN(h) && (h = Number(h) || 0), h < 0 && (h = 0), h > 5 && (h = 5);
		let g = gS(t, IT), _ = a ? Math.floor(h) : Math.ceil(h);
		return n || h || r ? B(Kx, { children: V("div", {
			className: (0, FT.default)("ss__rating", l, u),
			...g,
			children: [
				V("div", {
					className: "ss__rating__icons",
					children: [B("div", {
						className: "ss__rating__stars ss__rating__stars--empty",
						children: [...[
							,
							,
							,
							,
							,
						]].map(() => B("span", {
							className: "ss__rating__stars__star ss__rating__stars__star--empty",
							children: B(KC, {
								...m.emptyIcon,
								...typeof o == "string" ? { icon: o } : o
							})
						}))
					}), B("div", {
						className: "ss__rating__stars ss__rating__stars--full",
						children: [...Array(_)].map((e, t) => {
							let n = 100;
							return t + 1 == _ && !a && h % 1 != 0 && (n = (h % 1 || 1) * 100), B("span", {
								className: "ss__rating__stars__star ss__rating__stars__star--full",
								style: { width: `${n}%` },
								children: B(KC, {
									...m.fullIcon,
									...typeof s == "string" ? { icon: s } : s
								})
							});
						})
					})]
				}),
				r ? V("span", {
					className: "ss__rating__count",
					children: [
						"(",
						r,
						")"
					]
				}) : B(xi, {}),
				i ? B("span", {
					className: "ss__rating__text",
					children: i
				}) : B(xi, {})
			]
		}) }) : null;
	});
})), zT = o((() => {
	RT();
})), BT, VT, HT, UT, WT = o((() => {
	H(), ux(), BT = /* @__PURE__ */ u(X()), Q(), BC(), KS(), OC(), PT(), tC(), VT = /* @__PURE__ */ u(U()), HT = ({ native: e, color: t, backgroundColor: n, borderColor: r, theme: i }) => cx(e ? {} : {
		display: "inline-flex",
		alignItems: "center",
		gap: "5px",
		padding: "5px 10px",
		position: "relative",
		color: t || i?.variables?.colors?.primary,
		outline: 0,
		backgroundColor: n || "#fff",
		border: `1px solid ${r || t || i?.variables?.colors?.primary || "#333"}`,
		"&:not(.ss__button--disabled):hover": { cursor: "pointer" },
		"&.ss__button--disabled": {
			opacity: .7,
			"&:hover": { cursor: "default" }
		},
		".ss__button__content": { width: "100%" },
		label: { cursor: "pointer" }
	}), UT = Z((e) => {
		let t = mi(), n = uS("button", t, {
			disableA11y: !1,
			treePath: RC()
		}, e), { content: r, children: i, disabled: a, native: o, onClick: s, disableA11y: c, disableStyles: l, className: u, internalClassName: d, icon: f, lang: p, treePath: m, style: h, styleScript: g, themeStyleScript: _, ...v } = n, { overrideElement: y, shouldRenderDefault: b } = QS("button", n);
		if (!b) return y;
		let x = { icon: {
			internalClassName: "ss__button__icon",
			...$({ disableStyles: l }),
			theme: n?.theme,
			treePath: m
		} }, S = {
			...gS(n, HT),
			className: (0, BT.default)("ss__button", {
				"ss__button--native": o,
				"ss__button--disabled": a
			}, u, d),
			disabled: a,
			onClick: (e) => !a && s && s(e),
			...v
		}, C = { ref: (e) => VS(e) }, w = (0, VT.default)({}, p || {}), T = qS(w, {}, { activeBreakpoint: t?.activeBreakpoint }), E = !!v.dangerouslySetInnerHTML;
		return r || i || f || p?.button?.value || E ? B(Kx, { children: o ? V("button", {
			...S,
			children: [V("span", {
				className: "ss__button__content",
				...T.button?.all,
				children: [nS(r, { treePath: m }), nS(i, { treePath: m })]
			}), f && B(KC, {
				...x.icon,
				...typeof f == "string" ? { icon: f } : f
			})]
		}) : V("div", {
			...c ? {} : C,
			role: "button",
			"aria-disabled": a,
			...S,
			...T.button?.attributes,
			children: [r || i || T.button?.value ? V("span", {
				className: "ss__button__content",
				...T.button?.value,
				children: [nS(r, { treePath: m }), nS(i, { treePath: m })]
			}) : void 0, f && B(KC, {
				...x.icon,
				...typeof f == "string" ? { icon: f } : f
			})]
		}) }) : null;
	});
})), GT = o((() => {
	WT();
})), KT, qT, JT, YT, XT = o((() => {
	H(), R(), ux(), KT = /* @__PURE__ */ u(X()), Q(), OC(), BC(), PT(), KS(), tC(), qT = /* @__PURE__ */ u(U()), JT = ({ size: e, color: t, theme: n, native: r }) => {
		let i = isNaN(Number(e)) ? e : `${e}px`;
		return cx(r ? {} : {
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "center",
			height: i,
			width: i,
			border: `1px solid ${t || n?.variables?.colors?.primary || "#333"}`,
			"&.ss__checkbox--disabled": { opacity: .7 },
			"& .ss__checkbox__empty": {
				display: "inline-block",
				width: `calc(${e} - 30%)`,
				height: `calc(${e} - 30%)`
			}
		});
	}, YT = Z((e) => {
		let t = mi(), n = uS("checkbox", t, {
			size: "12px",
			startChecked: !1,
			disableA11y: !1,
			treePath: RC()
		}, e), { checked: r, color: i, disabled: a, icon: o, iconColor: s, onClick: c, size: l, startChecked: u, native: d, disableA11y: f, disableStyles: p, className: m, internalClassName: h, theme: g, treePath: _, lang: v, style: y, styleScript: b, themeStyleScript: x, name: S, ...C } = n, { overrideElement: w, shouldRenderDefault: T } = QS("checkbox", n);
		if (!T) return w;
		let E = isNaN(Number(l)) ? l : `${l}px`, D = { icon: {
			internalClassName: "ss__checkbox__icon",
			icon: "check-thin",
			...$({
				color: s || i || g?.variables?.colors?.primary,
				disableStyles: p,
				icon: o,
				size: E && `calc(${E} - 30%)`
			}),
			theme: n.theme,
			treePath: _
		} }, O, k, A = r === void 0;
		A ? [O, k] = I(u) : O = r;
		let j = (e) => {
			a || (A && k && k((e) => !e), c && c(e));
		}, M = gS(n, JT), ee = (0, qT.default)({ checkbox: {} }, v || {}), te = qS(ee, {
			checkedState: O,
			disabled: a
		}, { activeBreakpoint: t?.activeBreakpoint });
		return B(Kx, { children: d ? B("input", {
			...M,
			className: (0, KT.default)("ss__checkbox", "ss__checkbox--native", {
				"ss__checkbox--disabled": a,
				"ss__checkbox--active": O
			}, m, h),
			type: "checkbox",
			"aria-checked": O,
			onClick: (e) => j(e),
			disabled: a,
			checked: O
		}) : B("span", {
			...M,
			className: (0, KT.default)("ss__checkbox", {
				"ss__checkbox--disabled": a,
				"ss__checkbox--active": O
			}, m, h),
			onClick: (e) => j(e),
			ref: (e) => f ? null : VS(e),
			"aria-disabled": a,
			role: "checkbox",
			"aria-checked": O,
			...C,
			...te.checkbox.all,
			children: O ? B(KC, {
				...D.icon,
				...typeof o == "string" ? { icon: o } : o
			}) : B("span", { className: "ss__checkbox__empty" })
		}) });
	});
})), ZT = o((() => {
	XT();
})), QT, $T, eE, tE, nE = o((() => {
	H(), R(), ux(), QT = /* @__PURE__ */ u(X()), $T = /* @__PURE__ */ u(U()), Iu(), Q(), BC(), OC(), ZT(), tC(), PT(), eE = ({ horizontal: e }) => cx({
		display: "flex",
		flexDirection: e ? "row" : "column",
		alignItems: e ? "center" : void 0,
		justifyItems: "flex-start",
		gap: "5px",
		".ss__list__options": {
			border: "none",
			listStyle: "none",
			padding: "0px",
			margin: "0px",
			display: "flex",
			flexDirection: e ? "row" : "column",
			alignItems: e ? "center" : void 0,
			justifyItems: "flex-start",
			gap: "5px"
		},
		".ss__list__option": {
			cursor: "pointer",
			display: "flex",
			alignItems: "center",
			gap: "5px",
			".ss__list__option__label , .ss__list__option__icon": { cursor: "pointer" }
		},
		"&.ss__list--disabled, .ss__list__option--disabled": {
			cursor: "none",
			pointerEvents: "none",
			opacity: .5
		},
		"&.ss__list--disabled, .ss__list__option--unavailable": {
			cursor: "pointer",
			opacity: .5
		},
		".ss__list__option--selected": { fontWeight: "bold" }
	}), tE = Z((e) => {
		let t = mi(), n = uS("list", t, { treePath: RC() }, e), { titleText: r, onSelect: i, native: a, multiSelect: o, hideOptionLabels: s, hideOptionIcons: c, hideOptionCheckboxes: l, disabled: u, hideTitleText: d, options: f, requireSelection: p, disableStyles: m, className: h, internalClassName: g, treePath: _ } = n, { overrideElement: v, shouldRenderDefault: y } = QS("list", n);
		if (!y) return v;
		let b = n.selected, x = {
			checkbox: {
				native: a,
				...$({ disableStyles: m }),
				theme: n?.theme,
				treePath: _
			},
			icon: {
				internalClassName: "ss__list__option__icon",
				size: "16px",
				...$({ disableStyles: m }),
				theme: n?.theme,
				treePath: _
			}
		}, S = gS(n, eE);
		b && !Array.isArray(b) && (b = [b]);
		let [C, w] = I(b || []), [T, E] = I(() => vS(b));
		if (b) {
			let e = vS(b);
			e !== T && (E(e), w(b));
		}
		let D = (e, t) => {
			let n;
			o ? C.find((e) => e.value === t.value) ? (n = [...C], n.splice(n.findIndex((e) => e.value === t.value), 1), n.length == 0 && p && (n = [t])) : n = [...C, t] : n = !p && C.find((e) => e.value === t.value) ? [] : [t], i && i(e, t, n), w(n);
		}, O = (0, $T.default)({}, n.lang || {}), k = qS(O, {
			options: f,
			selectedOptions: C
		}, { activeBreakpoint: t?.activeBreakpoint });
		return typeof f == "object" && f?.length ? B(Kx, { children: V("div", {
			...S,
			className: (0, QT.default)("ss__list", {
				"ss__list--native": a,
				"ss__list--disabled": u
			}, h, g),
			children: [(r || O?.title?.value) && !d && B("h5", {
				className: "ss__list__title",
				...k.title?.all,
				children: r
			}), B("ul", {
				className: "ss__list__options",
				role: "listbox",
				"aria-label": r,
				children: f.map((e) => {
					let t = C.some((t) => t.value == e.value);
					return V("li", {
						className: (0, QT.default)(`ss__list__option ss__list__option--${Fl(e.value?.toString())}`, {
							"ss__list__option--selected": t,
							"ss__list__option--disabled": e?.disabled,
							"ss__list__option--unavailable": e?.available === !1
						}),
						ref: (e) => VS(e),
						onClick: (t) => !u && !e?.disabled && D(t, e),
						title: e.label,
						role: "option",
						"aria-selected": t,
						"aria-disabled": e.disabled || e?.available === !1,
						children: [
							!l && B(YT, {
								...x.checkbox,
								checked: t,
								disableA11y: !0,
								"aria-label": e.label
							}),
							e.icon && !c && B(KC, {
								...x.icon,
								...typeof e.icon == "string" ? { icon: e.icon } : e.icon
							}),
							!s && (e.label || !e.icon) && B("label", {
								className: "ss__list__option__label",
								children: e.label || e.value
							})
						]
					});
				})
			})]
		}) }) : null;
	});
})), rE = o((() => {
	nE();
})), iE, aE = o((() => {
	iE = function(e, t) {
		var n = {
			white: "#ffffff",
			bisque: "#ffe4c4",
			blue: "#0000ff",
			cadetblue: "#5f9ea0",
			chartreuse: "#7fff00",
			chocolate: "#d2691e",
			coral: "#ff7f50",
			antiquewhite: "#faebd7",
			aqua: "#00ffff",
			azure: "#f0ffff",
			whitesmoke: "#f5f5f5",
			papayawhip: "#ffefd5",
			plum: "#dda0dd",
			blanchedalmond: "#ffebcd",
			black: "#000000",
			gold: "#ffd700",
			goldenrod: "#daa520",
			gainsboro: "#dcdcdc",
			cornsilk: "#fff8dc",
			cornflowerblue: "#6495ed",
			burlywood: "#deb887",
			aquamarine: "#7fffd4",
			beige: "#f5f5dc",
			crimson: "#dc143c",
			cyan: "#00ffff",
			darkblue: "#00008b",
			darkcyan: "#008b8b",
			darkgoldenrod: "#b8860b",
			darkkhaki: "#bdb76b",
			darkgray: "#a9a9a9",
			darkgreen: "#006400",
			darkgrey: "#a9a9a9",
			peachpuff: "#ffdab9",
			darkmagenta: "#8b008b",
			darkred: "#8b0000",
			darkorchid: "#9932cc",
			darkorange: "#ff8c00",
			darkslateblue: "#483d8b",
			gray: "#808080",
			darkslategray: "#2f4f4f",
			darkslategrey: "#2f4f4f",
			deeppink: "#ff1493",
			deepskyblue: "#00bfff",
			wheat: "#f5deb3",
			firebrick: "#b22222",
			floralwhite: "#fffaf0",
			ghostwhite: "#f8f8ff",
			darkviolet: "#9400d3",
			magenta: "#ff00ff",
			green: "#008000",
			dodgerblue: "#1e90ff",
			grey: "#808080",
			honeydew: "#f0fff0",
			hotpink: "#ff69b4",
			blueviolet: "#8a2be2",
			forestgreen: "#228b22",
			lawngreen: "#7cfc00",
			indianred: "#cd5c5c",
			indigo: "#4b0082",
			fuchsia: "#ff00ff",
			brown: "#a52a2a",
			maroon: "#800000",
			mediumblue: "#0000cd",
			lightcoral: "#f08080",
			darkturquoise: "#00ced1",
			lightcyan: "#e0ffff",
			ivory: "#fffff0",
			lightyellow: "#ffffe0",
			lightsalmon: "#ffa07a",
			lightseagreen: "#20b2aa",
			linen: "#faf0e6",
			mediumaquamarine: "#66cdaa",
			lemonchiffon: "#fffacd",
			lime: "#00ff00",
			khaki: "#f0e68c",
			mediumseagreen: "#3cb371",
			limegreen: "#32cd32",
			mediumspringgreen: "#00fa9a",
			lightskyblue: "#87cefa",
			lightblue: "#add8e6",
			midnightblue: "#191970",
			lightpink: "#ffb6c1",
			mistyrose: "#ffe4e1",
			moccasin: "#ffe4b5",
			mintcream: "#f5fffa",
			lightslategray: "#778899",
			lightslategrey: "#778899",
			navajowhite: "#ffdead",
			navy: "#000080",
			mediumvioletred: "#c71585",
			powderblue: "#b0e0e6",
			palegoldenrod: "#eee8aa",
			oldlace: "#fdf5e6",
			paleturquoise: "#afeeee",
			mediumturquoise: "#48d1cc",
			mediumorchid: "#ba55d3",
			rebeccapurple: "#663399",
			lightsteelblue: "#b0c4de",
			mediumslateblue: "#7b68ee",
			thistle: "#d8bfd8",
			tan: "#d2b48c",
			orchid: "#da70d6",
			mediumpurple: "#9370db",
			purple: "#800080",
			pink: "#ffc0cb",
			skyblue: "#87ceeb",
			springgreen: "#00ff7f",
			palegreen: "#98fb98",
			red: "#ff0000",
			yellow: "#ffff00",
			slateblue: "#6a5acd",
			lavenderblush: "#fff0f5",
			peru: "#cd853f",
			palevioletred: "#db7093",
			violet: "#ee82ee",
			teal: "#008080",
			slategray: "#708090",
			slategrey: "#708090",
			aliceblue: "#f0f8ff",
			darkseagreen: "#8fbc8f",
			darkolivegreen: "#556b2f",
			greenyellow: "#adff2f",
			seagreen: "#2e8b57",
			seashell: "#fff5ee",
			tomato: "#ff6347",
			silver: "#c0c0c0",
			sienna: "#a0522d",
			lavender: "#e6e6fa",
			lightgreen: "#90ee90",
			orange: "#ffa500",
			orangered: "#ff4500",
			steelblue: "#4682b4",
			royalblue: "#4169e1",
			turquoise: "#40e0d0",
			yellowgreen: "#9acd32",
			salmon: "#fa8072",
			saddlebrown: "#8b4513",
			sandybrown: "#f4a460",
			rosybrown: "#bc8f8f",
			darksalmon: "#e9967a",
			lightgoldenrodyellow: "#fafad2",
			snow: "#fffafa",
			lightgrey: "#d3d3d3",
			lightgray: "#d3d3d3",
			dimgray: "#696969",
			dimgrey: "#696969",
			olivedrab: "#6b8e23",
			olive: "#808000"
		}, r = {};
		for (var i in n) r[n[i]] = i;
		var a = {};
		e.prototype.toName = function(t) {
			if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
			var i, o, s = r[this.toHex()];
			if (s) return s;
			if (t?.closest) {
				var c = this.toRgb(), l = 1 / 0, u = "black";
				if (!a.length) for (var d in n) a[d] = new e(n[d]).toRgb();
				for (var f in n) {
					var p = (i = c, o = a[f], (i.r - o.r) ** 2 + (i.g - o.g) ** 2 + (i.b - o.b) ** 2);
					p < l && (l = p, u = f);
				}
				return u;
			}
		}, t.string.push([function(t) {
			var r = t.toLowerCase(), i = r === "transparent" ? "#0000" : n[r];
			return i ? new e(i).toRgb() : null;
		}, "name"]);
	};
})), oE, sE, cE, lE, uE = o((() => {
	H(), ux(), R(), oE = /* @__PURE__ */ u(X()), sE = /* @__PURE__ */ u(U()), Iu(), Q(), BC(), tC(), hT(), OC(), eT(), aE(), $w([iE]), cE = ({ gapSize: e, columns: t, theme: n, disableOverflowAction: r }) => cx({
		".ss__grid__options": {
			display: "flex",
			flexFlow: "row wrap",
			gridTemplateColumns: `repeat(${t}, 1fr)`,
			gap: e,
			gridAutoRows: "1fr",
			".ss__grid__option": {
				display: "flex",
				flexDirection: "column",
				boxSizing: "content-box",
				backgroundRepeat: "no-repeat",
				backgroundSize: `calc(100% / ${t} - ${2 * Math.round((t + 2) / 2)}px)`,
				backgroundPosition: "center !important",
				justifyContent: "center",
				alignItems: "center",
				flex: "0 1 auto",
				border: `1px solid ${n?.variables?.colors?.primary || "#333"}`,
				textAlign: "center",
				wordBreak: "break-all",
				padding: "1em 0",
				width: `calc(100% / ${t} - ${2 * Math.round((t + 2) / 2)}px)`,
				margin: `0 ${e} ${e} 0`,
				".ss__grid__option__inner": {
					aspectRatio: "1/1",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					margin: "auto",
					height: "100%",
					".ss__image": { aspectRatio: "1/1" }
				},
				".ss__grid__option__label": { cursor: "pointer" },
				[`:nth-of-type(${t}n)`]: { marginRight: "0" },
				"&.ss__grid__option--selected": { border: `2px solid ${n?.variables?.colors?.primary || "#333"}` },
				"&.ss__grid__option--disabled": {
					position: "relative",
					opacity: ".5",
					cursor: "none",
					pointerEvents: "none"
				},
				"&.ss__grid__option--unavailable": {
					position: "relative",
					opacity: ".5"
				},
				"&.ss__grid__option--disabled:before, &.ss__grid__option--unavailable:before": {
					content: "\"\"",
					display: "block",
					position: "absolute",
					top: "50%",
					width: "90%",
					height: "1px",
					borderTop: "3px solid #eee",
					outline: "1px solid #ffff",
					transform: "rotate(-45deg)"
				},
				"&.ss__grid__option--dark": { color: "#fff" },
				"&:hover:not(.ss__grid__option--selected)": { cursor: "pointer" }
			},
			"@supports (display: grid)": {
				display: "grid",
				".ss__grid__option": {
					padding: "0",
					margin: "0",
					width: "initial"
				},
				"&::before": {
					content: "\"\"",
					width: 0,
					paddingBottom: "100%",
					gridRow: "1 / 1",
					gridColumn: "1 / 1"
				},
				"&> *:first-of-type": {
					gridRow: "1 / 1",
					gridColumn: "1 / 1"
				}
			}
		},
		".ss__grid__show-more-wrapper": {
			"&:not(.ss__grid__option)": { margin: "8px" },
			"&:hover": { cursor: r ? "initial !important" : "pointer !important" }
		}
	}), lE = Z((e) => {
		let t = mi(), n = uS("grid", t, {
			multiSelect: !1,
			columns: 4,
			gapSize: "8px",
			treePath: RC()
		}, e), { titleText: r, onSelect: i, hideLabels: a, disableOverflowAction: o, multiSelect: s, overflowButton: c, columns: l, rows: u, hideShowLess: d, overflowButtonInGrid: f, disabled: p, options: m, disableStyles: h, onOverflowButtonClick: g, className: _, internalClassName: v, treePath: y, disableA11y: b } = n, { overrideElement: x, shouldRenderDefault: S } = QS("grid", n);
		if (!S) return x;
		let C = { image: {
			internalClassName: "ss__grid__image",
			...$({ disableStyles: h }),
			theme: n?.theme,
			treePath: y
		} }, w = n.selected, T = gS(n, cE);
		w && !Array.isArray(w) && (w = [w]);
		let [E, D] = I(w || []), [O, k] = I(() => vS(w));
		if (w) {
			let e = vS(w);
			e !== O && (k(e), D(w));
		}
		let A = (e, t) => {
			if (s) {
				let n;
				E.find((e) => e.value === t.value) ? (n = [...E], n.splice(n.findIndex((e) => e.value === t.value), 1)) : n = [...E, t], i && i(e, t, n), D(n);
			} else i && i(e, t, [t]), D([t]);
		}, j = u && l ? l * u : m.length, M = Math.max(0, m.length - (j - +!!f)), [ee, te] = I(!!M), ne = () => {
			let e = !d || ee, r = {
				showMoreText: { value: f ? `+ ${M}` : "Show More" },
				showLessText: { value: f ? `- ${M}` : "Show Less" }
			}, i = (0, sE.default)(r, n.lang || {}), a = qS(i, {
				limited: ee,
				remainder: M
			}, { activeBreakpoint: t?.activeBreakpoint });
			return e && M > 0 && m.length !== j ? B("div", {
				className: `ss__grid__show-more-wrapper ${f ? "ss__grid__option" : ""}`,
				onClick: (e) => {
					!o && te(!ee), g && g(e, !!ee, M);
				},
				role: "button",
				ref: (e) => !b && !o ? VS(e) : null,
				...ee ? a.showMoreText.attributes : a.showLessText.attributes,
				children: c ? nS(c, {
					limited: ee,
					remainder: M,
					treePath: y
				}) : ee ? B("span", {
					className: "ss__grid__show-more",
					...a.showMoreText.value
				}) : M ? B("span", {
					className: "ss__grid__show-less",
					...a.showLessText.value
				}) : null
			}) : null;
		};
		return typeof m == "object" && m?.length ? B(Kx, { children: V("div", {
			...T,
			className: (0, oE.default)("ss__grid", p ? "ss__grid--disabled" : "", _, v),
			children: [
				r && B("h5", {
					className: "ss__grid__title",
					children: r
				}),
				V("div", {
					className: "ss__grid__options",
					children: [m.map((e, t) => {
						let n = E.some((t) => t.value == e.value), r = !1, i = e.background?.toLowerCase() || (e.backgroundImageUrl ? null : e.value.toString().toLowerCase());
						if (i) try {
							let e = Zw(i);
							e.isValid() && (r = e.isDark());
						} catch {}
						if (!ee || m.length == j || t < j - +!!f) return B("div", {
							className: (0, oE.default)("ss__grid__option", {
								"ss__grid__option--selected": n,
								"ss__grid__option--disabled": e?.disabled,
								"ss__grid__option--unavailable": e?.available === !1,
								"ss__grid__option--dark": r
							}),
							onClick: (t) => !p && !e?.disabled && A(t, e),
							ref: (e) => VS(e),
							title: e.label || e.value.toString(),
							role: "option",
							"aria-selected": n,
							"aria-disabled": e.disabled,
							children: V("div", {
								className: (0, oE.default)("ss__grid__option__inner", `ss__grid__option__inner--${Fl(e.value.toString())}`),
								style: { background: e.background ? e.background : e.backgroundImageUrl ? void 0 : e.value },
								children: [!e.background && e.backgroundImageUrl ? B(pT, {
									...C.image,
									src: e.backgroundImageUrl,
									alt: e.label || e.value.toString()
								}) : null, a ? null : B("label", {
									className: "ss__grid__option__label",
									children: e.label || e.value
								})]
							})
						});
					}), f ? B(ne, {}) : null]
				}),
				f ? null : B(ne, {})
			]
		}) }) : null;
	});
})), dE = o((() => {
	uE();
})), fE, pE, mE, hE, gE = o((() => {
	H(), R(), ux(), fE = /* @__PURE__ */ u(X()), Q(), BC(), OC(), hT(), GT(), tC(), pE = /* @__PURE__ */ u(U()), mE = ({ theme: e, slidesToShow: t = 1, slideWidth: n, gap: r = 16, overlayNavigation: i = !1, showNavigation: a }) => cx({
		position: "relative",
		overflow: "hidden",
		".ss__slideshow__container": {
			position: "relative",
			width: `calc(100% - ${i || !a ? 0 : 60}px)`,
			margin: "auto",
			overflow: "hidden",
			touchAction: "pan-y pinch-zoom"
		},
		".ss__slideshow__track": {
			display: "flex",
			width: "100%",
			transition: "transform 0.3s ease-in-out",
			"&.ss__slideshow__track--dragging": { transition: "none" },
			"&.ss__slideshow__track--centered": { justifyContent: "center" }
		},
		".ss__slideshow__slide": {
			...n ? {
				maxWidth: `${n}px`,
				minWidth: `${n}px`
			} : {
				maxWidth: `calc((100% - ${t * r}px) / ${t})`,
				minWidth: `calc((100% - ${t * r}px) / ${t})`
			},
			marginLeft: `calc(${r}px / 2)`,
			marginRight: `calc(${r}px / 2)`,
			position: "relative",
			userSelect: "none",
			img: {
				width: "100%",
				height: "100%",
				objectFit: "cover",
				display: "block",
				pointerEvents: "none"
			}
		},
		".ss__slideshow__slide--content": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			"> *": { width: "100%" }
		},
		".ss__slideshow__slide--clickable": {
			cursor: "pointer",
			"&:hover img": {
				opacity: .9,
				transition: "opacity 0.2s ease"
			},
			"&:focus-visible": {
				outline: "2px solid #005fcc",
				outlineOffset: "2px"
			}
		},
		".ss__slideshow__navigation": {
			position: "absolute",
			top: "50%",
			transform: "translateY(-50%)",
			zIndex: 10,
			".ss__button": {
				border: "none",
				width: "10px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				cursor: "pointer",
				"&:disabled": { cursor: "not-allowed" },
				"&:focus-visible": {
					outline: "2px solid #005fcc",
					outlineOffset: "2px"
				}
			},
			"&--prev": { left: `${i ? 10 : 0}px` },
			"&--next": { right: `${i ? 10 : 0}px` }
		},
		".ss__slideshow__pagination": {
			position: "relative",
			margin: "10px auto",
			width: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: "8px",
			".ss__slideshow__dot": {
				width: "8px",
				height: "8px",
				borderRadius: "50%",
				background: "#000",
				opacity: ".2",
				border: "none",
				cursor: "pointer",
				padding: 0,
				"&.ss__slideshow__dot--active": {
					opacity: "0.8",
					background: e?.variables?.colors?.primary || "#000"
				},
				"&:focus-visible": { outline: "-webkit-focus-ring-color auto 1px !important" }
			}
		},
		".ss__slideshow__sr-only": {
			position: "absolute",
			width: "1px",
			height: "1px",
			padding: 0,
			margin: "-1px",
			overflow: "hidden",
			clip: "rect(0, 0, 0, 0)",
			whiteSpace: "nowrap",
			border: 0
		}
	}), hE = Z((e) => {
		let t = mi(), n = uS("slideshow", t, {
			treePath: RC(),
			fallbackImage: "//cdn.athoscommerce.net/snap/images/fallback.png",
			autoPlay: !1,
			autoPlayInterval: 3e3,
			showNavigation: !0,
			showPagination: !0,
			centerInsufficientSlides: !0,
			slidesToShow: e.slideWidth ? void 0 : 4,
			slidesToMove: 1,
			gap: 10,
			ariaLabel: "slideshow",
			touchDragging: !0,
			dragThreshold: 50
		}, e), { className: r, slides: i, fallbackImage: a, autoPlay: o, autoPlayInterval: s, showNavigation: c, showPagination: l, loop: u, alwaysShowNavigation: d, slidesToShow: f, slideImageAlt: p, centerInsufficientSlides: m, ariaLabel: h, ariaLabelledBy: g, disableStyles: _, slideWidth: v, gap: y, treePath: b, overlayNavigation: x, dragThreshold: S } = n, { overrideElement: C, shouldRenderDefault: w } = QS("slideshow", n);
		if (!w) return C;
		let T = n.touchDragging, E = {
			Image: {
				fallback: a,
				...$({ disableStyles: _ }),
				theme: n.theme,
				treePath: b
			},
			NextButton: {
				backgroundColor: x ? "rgba(255, 255, 255, 0.9)" : void 0,
				name: "next",
				...$({ disableStyles: _ }),
				theme: n.theme,
				treePath: b
			},
			PrevButton: {
				backgroundColor: x ? "rgba(255, 255, 255, 0.9)" : void 0,
				name: "prev",
				...$({ disableStyles: _ }),
				theme: n.theme,
				treePath: b
			},
			PauseButton: {
				name: "pause",
				...$({ disableStyles: _ }),
				theme: n.theme,
				treePath: b
			},
			PaginationButton: {
				name: "pagination",
				...$({ disableStyles: _ }),
				theme: n.theme,
				treePath: b
			},
			PaginationCurrentButton: {
				name: "pagination-current",
				...$({ disableStyles: _ }),
				theme: n.theme,
				treePath: b
			}
		}, D = n.slidesToMove;
		D ||= 1;
		let [O, k] = I(0), [A, j] = I(o), [M, ee] = I(0), te = Pe(null), ne = Pe(null), re = Pe(null);
		L(() => {
			let e = re.current?.parentElement;
			if (!e) return;
			let t = new ResizeObserver((e) => {
				for (let t of e) ee(t.contentRect.width);
			});
			return t.observe(e), ee(e.offsetWidth), () => t.disconnect();
		}, []);
		let [ie, ae] = I(!1), [oe, se] = I(0), [ce, le] = I(0), [ue, de] = I(0), N = i.map((e, t) => typeof e == "string" ? { src: e } : e && typeof e == "object" && "props" in e && "type" in e ? {
			content: e,
			alt: `Slide ${t + 1}`
		} : e && typeof e == "object" ? e : {
			content: e,
			alt: `Slide ${t + 1}`
		}), fe = N.length, pe = v && M > 0 ? Math.max(1, Math.floor(M / (v + (y ?? 0)))) : f ?? 4, me = Math.min(pe, fe), he = Math.max(0, fe - me), ge = [];
		for (let e = 0; e <= he; e += D) ge.push(e);
		let P = ge.length, _e = ge.findIndex((e) => O >= e && O < e + D);
		L(() => {
			if (A && N.length > pe && !ie) return te.current = setInterval(() => {
				k((e) => {
					let t = e + D;
					return u ? t > he ? 0 : t : t >= he ? (j(!1), he) : t;
				});
			}, s), () => {
				te.current && clearInterval(te.current);
			};
			te.current && clearInterval(te.current);
		}, [
			A,
			s,
			N.length,
			pe,
			D,
			u,
			he,
			ie
		]), fe <= me && (T = !1);
		let ve = (e) => {
			T && (j(!1), ae(!0), se(e), le(e), te.current && clearInterval(te.current));
		}, ye = (e) => {
			if (!ie || !T) return;
			le(e);
			let t = e - oe;
			de(t);
		}, be = () => {
			if (!ie || !T) return;
			let e = ce - oe, t = (re.current?.parentElement?.offsetWidth || 0) / me, n = Math.min(S, t * .3);
			Math.abs(e) > n && (e > 0 && (u || O > 0) ? De() : e < 0 && (u || O < he) && Oe()), ae(!1), de(0), A && N.length > pe && (te.current = setInterval(() => {
				k((e) => {
					let t = e + D;
					return u ? t > he ? 0 : t : t >= he ? (j(!1), he) : t;
				});
			}, s));
		}, xe = (e) => {
			ye(e.clientX);
		};
		L(() => {
			if (ie && T) return document.addEventListener("mousemove", xe), document.addEventListener("mouseup", be), () => {
				document.removeEventListener("mousemove", xe), document.removeEventListener("mouseup", be);
			};
		}, [ie, T]);
		let Se = () => {
			A && te.current && !ie && clearInterval(te.current);
		}, Ce = () => {
			A && N.length > pe && !ie && (te.current = setInterval(() => {
				k((e) => {
					let t = e + D;
					return u ? t > he ? 0 : t : t >= he ? (j(!1), he) : t;
				});
			}, s));
		}, we = (e, t) => {
			e.onClick && !ie && e.onClick(e, t);
		}, Te = (e, t, n) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), we(t, n));
		}, Ee = (e) => {
			switch (e.key) {
				case "ArrowLeft":
					e.preventDefault(), De();
					break;
				case "ArrowRight":
					e.preventDefault(), Oe();
					break;
				case "Home":
					e.preventDefault(), k(0);
					break;
				case "End":
					e.preventDefault(), k(he);
					break;
				case " ":
				case "Spacebar":
					e.preventDefault(), ke();
					break;
				case "Escape": e.preventDefault(), j(!1);
			}
		}, De = () => {
			k((e) => {
				let t;
				return t = u ? e - D < 0 ? he : e - D : Math.max(0, e - D), t;
			});
		}, Oe = () => {
			k((e) => {
				let t;
				return t = u ? e + D > he ? 0 : e + D : Math.min(he, e + D), t;
			});
		}, F = (e) => {
			let t = ge[e] || 0;
			k(t);
		}, ke = () => {
			j(!A);
		}, Ae = gS(n, mE);
		if (!N || N.length === 0) return B(xi, {});
		let je, Me;
		if (v) je = -(O * (v + (y ?? 0))), Me = "px", ie && (je += ue);
		else if (je = -(100 / me * O), Me = "%", ie && re.current) {
			let e = ue / (re.current.parentElement?.offsetWidth || 0) * 100;
			je += e;
		}
		let Ne = !u && O === 0, Fe = !u && O >= he, Ie = {
			pauseButton: {
				value: A ? "Pause" : "Play",
				attributes: { "aria-label": A ? "Pause slideshow" : "Resume slideshow" }
			},
			nextButton: { attributes: { "aria-label": `Next slides${Fe ? " (disabled)" : ""}` } },
			prevButton: { attributes: { "aria-label": `Previous slides${Ne ? " (disabled)" : ""}` } },
			srInstructions: { value: `Use arrow keys to navigate slides. Press spacebar to pause autoplay. Press home or end to go to first or last slide group. ${T && "Swipe left or right to navigate on touch devices."}` }
		}, Le = (0, pE.default)(Ie, n.lang || {}), Re = qS(Le, {
			isPlaying: A,
			isNextDisabled: Fe,
			isPrevDisabled: Ne
		}, { activeBreakpoint: t?.activeBreakpoint });
		return B(Kx, { children: V("div", {
			...Ae,
			className: (0, fE.default)("ss__slideshow", r),
			ref: ne,
			role: "region",
			"aria-label": h,
			"aria-labelledby": g,
			"aria-roledescription": "slideshow",
			onMouseEnter: Se,
			onMouseLeave: Ce,
			onKeyDown: Ee,
			tabIndex: 0,
			children: [
				B("div", {
					className: "ss__slideshow__sr-only",
					...Re.srInstructions.all
				}),
				B("div", {
					className: "ss__slideshow__container",
					children: B("div", {
						ref: re,
						className: (0, fE.default)("ss__slideshow__track", {
							"ss__slideshow__track--dragging": ie,
							"ss__slideshow__track--centered": m && fe <= pe
						}),
						style: { transform: `translateX(${je}${Me})` },
						role: "group",
						"aria-label": `Slide group ${O} of ${P}`,
						onTouchStart: T ? (e) => ve(e.touches[0]) : void 0,
						onTouchMove: T ? (e) => {
							ie && e.preventDefault();
							let t = e.touches[0];
							ye(t.clientX);
						} : void 0,
						onTouchEnd: T ? be : void 0,
						onMouseDown: T ? (e) => {
							e.preventDefault(), ve(e.clientX);
						} : void 0,
						onMouseUp: T ? be : void 0,
						onMouseMove: T ? xe : void 0,
						children: N.map((e, r) => {
							let i = r >= O && r < O + pe, o = !!e.onClick, s = !!e.content, c = e.alt || p || `Image ${r + 1}`, l = { slide: { attributes: { "aria-label": o ? `Click to view ${c}` : `${c} ${r + 1} of ${N.length}` } } }, u = (0, pE.default)(l, n.lang || {});
							return B("div", {
								...qS(u, {
									hasClickHandler: o,
									imageAlt: c,
									index: r,
									slidesLength: N.length
								}, { activeBreakpoint: t?.activeBreakpoint }).slide.all,
								className: (0, fE.default)("ss__slideshow__slide", {
									"ss__slideshow__slide--clickable": o,
									"ss__slideshow__slide--content": s
								}),
								role: o ? "button" : s ? "presentation" : "img",
								"aria-hidden": !i,
								tabIndex: o && i ? 0 : -1,
								onClick: o ? () => we(e, r) : void 0,
								onKeyDown: o ? (t) => Te(t, e, r) : void 0,
								children: s ? e.content : B(pT, {
									...E.Image,
									src: e.src || a,
									alt: i ? c : ""
								})
							}, r);
						})
					})
				}),
				!!(d || c && N.length > pe) && V(xi, { children: [B("div", {
					className: "ss__slideshow__navigation ss__slideshow__navigation--prev",
					children: B(UT, {
						icon: "angle-left",
						className: "ss__slideshow__prev",
						disabled: Ne,
						...Re.prevButton.all,
						...E.PrevButton,
						onClick: De
					})
				}), B("div", {
					className: "ss__slideshow__navigation ss__slideshow__navigation--next",
					children: B(UT, {
						className: "ss__slideshow__next",
						icon: "angle-right",
						disabled: Fe,
						...Re.nextButton.all,
						...E.NextButton,
						onClick: Oe
					})
				})] }),
				l && fe > me && B("div", {
					className: "ss__slideshow__pagination",
					role: "tablist",
					"aria-label": "Slide navigation",
					children: ge.map((e, r) => {
						let i = { paginationButton: { attributes: { "aria-label": `Go to slide group ${r + 1} of ${P}` } } }, a = (0, pE.default)(i, n.lang || {}), o = qS(a, {
							index: r,
							totalDots: P
						}, { activeBreakpoint: t?.activeBreakpoint }), s = _e === r, c = s ? E.PaginationCurrentButton : E.PaginationButton;
						return B(UT, {
							className: (0, fE.default)("ss__slideshow__dot", { "ss__slideshow__dot--active": s }),
							onClick: () => F(r),
							"aria-selected": s,
							...o.paginationButton.all,
							...c,
							children: B("span", { className: "ss__slideshow__dot-inner" })
						}, r);
					})
				}),
				o && B(UT, {
					className: "ss__slideshow__sr-only",
					...E.PauseButton,
					onClick: ke,
					...Re.pauseButton.all
				})
			]
		}) });
	});
})), _E = o((() => {
	gE();
})), vE, yE, bE, xE, SE = o((() => {
	H(), vE = /* @__PURE__ */ u(X()), ux(), BC(), tC(), OC(), dE(), hT(), Q(), yE = /* @__PURE__ */ u(U()), Iu(), eT(), aE(), _E(), R(), $w([iE]), bE = ({ theme: e }) => cx({ ".ss__swatches__slideshow__swatch": {
		boxSizing: "content-box",
		cursor: "pointer",
		backgroundRepeat: "no-repeat",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		border: `1px solid ${e?.variables?.colors?.primary || "#333"}`,
		aspectRatio: "1/1",
		flexDirection: "column",
		".ss__swatches__slideshow__swatch__inner": {
			aspectRatio: "1/1",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			width: "100%"
		},
		"&.ss__swatches__slideshow__swatch--selected": { border: `2px solid ${e?.variables?.colors?.primary || "#333"}` },
		"&.ss__swatches__slideshow__swatch--disabled:before, &.ss__swatches__slideshow__swatch--unavailable:before": {
			content: "\"\"",
			display: "block",
			position: "absolute",
			top: "50%",
			width: "90%",
			height: "1px",
			borderTop: "3px solid #eee",
			outline: "1px solid #ffff",
			transform: "rotate(-45deg)"
		},
		"&.ss__swatches__slideshow__swatch--disabled": {
			position: "relative",
			cursor: "none",
			pointerEvents: "none",
			opacity: .5
		},
		"&.ss__swatches__slideshow__swatch--unavailable": {
			cursor: "pointer",
			opacity: .5
		},
		"&.ss__swatches__slideshow__swatch--dark": { color: "#fff" }
	} }), xE = Z((e) => {
		let t = mi(), n = RC(), r = {
			0: { carousel: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 10
			} },
			768: { carousel: {
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 10
			} },
			1200: { carousel: {
				slidesPerView: 5,
				slidesPerGroup: 5,
				spaceBetween: 10
			} }
		}, i = uS("swatches", t, {
			type: "slideshow",
			hideLabels: !0,
			treePath: n
		}, e), a = i.breakpoints || (i.type == "slideshow" ? r : {}), o = LS(a);
		if (o && Object.keys(o).length) {
			let e = (0, yE.default)(i?.theme || {}, o?.theme || {}, { arrayMerge: (e, t) => t });
			i = {
				...i,
				...o,
				theme: e
			};
		}
		let { onSelect: s, disabled: c, options: l, hideLabels: u, disableStyles: d, className: f, internalClassName: p, type: m, slideshow: h, grid: g, treePath: _ } = i, { overrideElement: v, shouldRenderDefault: y } = QS("swatches", i);
		if (!y) return v;
		let b = {
			slideshow: {
				internalClassName: "ss__swatches__slideshow",
				loop: !1,
				slidesToShow: 6,
				slidesToMove: 1,
				gap: 8,
				showNavigation: !0,
				showPagination: !1,
				autoPlay: !1,
				...h,
				...$({
					breakpoints: a,
					disableStyles: d
				}),
				theme: i?.theme,
				treePath: _
			},
			grid: {
				internalClassName: "ss__swatches__grid",
				hideLabels: u,
				overflowButtonInGrid: !0,
				disableOverflowAction: !0,
				rows: 1,
				columns: 6,
				...g,
				...$({ disableStyles: d }),
				theme: i?.theme,
				treePath: _
			},
			image: {
				internalClassName: "ss__swatches__image",
				...$({ disableStyles: d }),
				theme: i?.theme,
				treePath: _
			}
		}, x = i.selected, S = gS(i, bE), [C, w] = I(x || void 0), T = (e, t) => {
			s && s(e, t), w(t);
		}, E = [];
		return m == "slideshow" && l.forEach((e) => {
			let t = e.label, n = C?.value == e.value, r = !1, i = e.background?.toLowerCase() || (e.backgroundImageUrl ? null : e.value?.toString().toLowerCase());
			if (i) try {
				let e = Zw(i);
				e.isValid() && (r = e.isDark());
			} catch {}
			E.push({
				onClick: (t) => !c && !e?.disabled && T(t, e),
				content: B("div", {
					className: (0, vE.default)("ss__swatches__slideshow__swatch", {
						"ss__swatches__slideshow__swatch--selected": n,
						"ss__swatches__slideshow__swatch--disabled": e?.disabled,
						"ss__swatches__slideshow__swatch--unavailable": e?.available === !1,
						"ss__swatches__slideshow__swatch--dark": r
					}),
					title: t,
					ref: (e) => VS(e),
					"aria-disabled": e.disabled || e?.available === !1,
					role: "option",
					"aria-selected": n,
					children: V("div", {
						className: (0, vE.default)("ss__swatches__slideshow__swatch__inner", `ss__swatches__slideshow__swatch__inner--${Fl(e.value?.toString())}`),
						style: { background: e.background ? e.background : e.backgroundImageUrl ? "" : e.value },
						children: [!e.background && e.backgroundImageUrl ? B(pT, {
							...b.image,
							src: e.backgroundImageUrl,
							alt: e.label || e.value?.toString()
						}) : null, !u && B("span", {
							className: "ss__swatches__slideshow__swatch__value",
							children: t || e.value
						})]
					})
				})
			});
		}), typeof l == "object" && l?.length ? B(Kx, { children: B("div", {
			...S,
			className: (0, vE.default)("ss__swatches", f, p),
			children: m == "slideshow" ? B(hE, {
				slides: E,
				...b.slideshow
			}) : B(lE, {
				...b.grid,
				options: l,
				onSelect: (e, t) => {
					!c && T(e, t);
				},
				selected: x
			})
		}) }) : null;
	});
})), CE = o((() => {
	SE();
})), wE, TE, EE, DE = o((() => {
	H(), ln(), R(), ux(), wE = /* @__PURE__ */ u(X()), Q(), BC(), tC(), OC(), KS(), TE = ({ disableOverlay: e }) => cx({
		position: "relative",
		"&.ss__dropdown--open, &.ss__dropdown__portal--open": { "& .ss__dropdown__content": {
			position: e ? "relative" : void 0,
			visibility: "visible",
			opacity: 1
		} },
		".ss__dropdown__button": { cursor: `${e ? "default" : "pointer"}` },
		".ss__dropdown__content": {
			backgroundColor: "#fff",
			position: "absolute",
			minWidth: "100%",
			visibility: "hidden",
			opacity: 0,
			top: "auto",
			left: 0
		}
	}), EE = Z((e) => {
		let t = uS("dropdown", mi(), {
			startOpen: !1,
			disableA11y: !1,
			treePath: RC()
		}, e), { button: n, content: r, children: i, disabled: a, open: o, toggleOnHover: s, onMouseEnter: c, onMouseLeave: l, disableClick: u, onClick: d, onToggle: f, focusTrapContent: p, startOpen: m, disableClickOutside: h, disableA11y: g, className: _, internalClassName: v, treePath: y, usePortal: b } = t, { overrideElement: x, shouldRenderDefault: S } = QS("dropdown", t);
		if (!S) return x;
		let C, w, T = o === void 0;
		T ? [C, w] = I(m) : C = o;
		let [E, D] = I(!1), O = Pe(null), k = Pe(null), [A, j] = I({
			top: 0,
			left: 0,
			width: 0
		}), M;
		h || (M = xS((e) => {
			b && k.current && k.current.contains(e.target) || C && (a || (T && w && w(!1), f && f(e, !1)));
		})), L(() => {
			if (b && C) {
				let e = () => {
					if (O.current) {
						let e = O.current.getBoundingClientRect();
						j({
							top: e.bottom + window.scrollY,
							left: e.left + window.scrollX,
							width: e.width
						});
					}
				};
				return e(), window.addEventListener("resize", e), window.addEventListener("scroll", e, !0), () => {
					window.removeEventListener("resize", e), window.removeEventListener("scroll", e, !0);
				};
			}
		}, [b, C]);
		let ee = (e, t) => {
			T && w && w((n) => {
				let r = t ?? !n;
				return r != n && f && f(e, r), r;
			});
		}, te = gS(t, TE), ne = {
			onMouseEnter: (s || c) && ((e) => {
				E || (s && !a && ee(e, !0), c && c(e));
			}),
			onMouseLeave: (s || l) && ((e) => {
				E || (s && !a && ee(e, !1), l && l(e));
			})
		}, re = V("div", {
			className: "ss__dropdown__content",
			ref: (e) => {
				k.current = e, g || VS(e, 0, !!p, (e) => {
					T ? ee(e) : d && d(e);
				});
			},
			children: [nS(r, {
				open: C,
				toggleOpen: ee,
				treePath: y
			}), nS(i, {
				open: C,
				toggleOpen: ee,
				treePath: y
			})]
		});
		return B(Kx, { children: V("div", {
			...te,
			className: (0, wE.default)("ss__dropdown", { "ss__dropdown--open": C }, _, v),
			ref: M,
			...ne,
			children: [B("div", {
				className: "ss__dropdown__button",
				ref: (e) => {
					O.current = e, g || VS(e);
				},
				"aria-expanded": C,
				role: "button",
				onTouchStart: () => {
					D(!0);
				},
				onClick: (e) => {
					!a && !u && (ee(e), d && d(e)), setTimeout(() => {
						D(!1);
					}, 300);
				},
				children: nS(n, {
					open: C,
					toggleOpen: ee,
					treePath: y
				})
			}), b ? (r || i) && Dt(B("div", {
				className: (0, wE.default)("ss__dropdown__portal", _, v, { "ss__dropdown__portal--open": C }),
				css: te.css,
				style: {
					position: "absolute",
					top: A.top,
					left: A.left,
					width: A.width,
					zIndex: 9999,
					pointerEvents: C ? "auto" : "none"
				},
				children: re
			}), document.body) : (r || i) && re]
		}) });
	});
})), OE = o((() => {
	DE();
})), kE, AE, jE, ME, NE = o((() => {
	H(), Q(), ux(), kE = /* @__PURE__ */ u(X()), BC(), OC(), rE(), CE(), OE(), PT(), tC(), Iu(), AE = () => cx({ ".ss__variant-selection__dropdown": { ".ss__dropdown__button": {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		".ss__dropdown__button-wrapper": {
			display: "flex",
			gap: "5px"
		}
	} } }), jE = () => cx({
		margin: "0px",
		padding: "5px",
		background: "white",
		zIndex: 10,
		border: "1px solid black",
		".ss__variant-selection__option": {
			cursor: "pointer",
			position: "relative"
		},
		".ss__variant-selection__option:hover": { fontWeight: "bold" },
		".ss__variant-selection__option--selected": { fontWeight: "bold" },
		".ss__variant-selection__option--disabled": {
			pointerEvents: "none",
			cursor: "initial",
			color: "red"
		},
		".ss__variant-selection__option--disabled, .ss__variant-selection__option--unavailable": {
			textDecoration: "line-through",
			opacity: .5
		}
	}), ME = Z((e) => {
		let t = mi(), n = RC(), r = uS("variantSelection", t, {
			name: ju(e.selection.field),
			treePath: n
		}, e), { selection: i, onSelect: a, disableStyles: o, className: s, internalClassName: c, treePath: l } = r, { overrideElement: u, shouldRenderDefault: d } = QS("variantSelection", r);
		if (!d) return u;
		let f = r.type;
		f ||= i.type == "swatch" ? "swatches" : "dropdown";
		let p = (e, t) => {
			a && a(e, t), i.select(t.value);
		}, m = {
			dropdown: {
				internalClassName: "ss__variant-selection__dropdown",
				usePortal: !0,
				...$({ disableStyles: o }),
				theme: r?.theme,
				treePath: l
			},
			icon: {
				internalClassName: "ss__variant-selection__icon",
				size: "12px",
				...$({ disableStyles: o }),
				theme: r?.theme,
				treePath: l
			},
			list: {
				titleText: i.field,
				internalClassName: "ss__variant-selection__list",
				multiSelect: !1,
				hideOptionCheckboxes: !0,
				onSelect: (e, t) => p(e, t),
				selected: i.selected,
				...$({ disableStyles: o }),
				theme: r?.theme,
				treePath: l
			},
			swatches: {
				internalClassName: "ss__variant-selection__swatches",
				onSelect: (e, t) => p(e, t),
				selected: i.selected,
				...$({ disableStyles: o }),
				theme: r?.theme,
				treePath: l
			}
		}, h = gS(r, AE), g = gS(r, jE), _ = (e) => {
			let { toggleOpen: t } = e;
			return B("ul", {
				...g,
				className: "ss__variant-selection__options",
				ref: (e) => VS(e, -1, !0, () => t()),
				children: i.values.map((e) => {
					let t = i.selected?.value == e.value;
					return B("li", {
						className: (0, kE.default)("ss__variant-selection__option", {
							"ss__variant-selection__option--selected": t,
							"ss__variant-selection__option--disabled": e.disabled,
							"ss__variant-selection__option--unavailable": e.available === !1
						}),
						onClick: (t) => !e.disabled && p(t, e),
						ref: (e) => VS(e),
						"aria-selected": t,
						"aria-disabled": e.disabled || e.available === !1,
						children: e.label
					});
				})
			});
		};
		return i.values.length ? B(Kx, { children: B("div", {
			...h,
			className: (0, kE.default)("ss__variant-selection", `ss__variant-selection--${f}`, `ss__variant-selection--${i.field}`, s, c),
			children: (() => {
				switch (f) {
					case "dropdown": return B(xi, { children: B(EE, {
						button: B((e) => {
							let { open: t } = e;
							return V(xi, { children: [V("div", {
								className: "ss__dropdown__button-wrapper",
								children: [B("span", {
									className: "ss__dropdown__button-wrapper__label",
									children: i.label
								}), i.selected ? V("span", {
									className: "ss__dropdown__button-wrapper__selection",
									children: [
										"(",
										i.selected.value,
										")"
									]
								}) : null]
							}), B(KC, {
								icon: t ? "angle-up" : "angle-down",
								...m.icon,
								treePath: e.treePath
							})] });
						}, { treePath: l }),
						...m.dropdown,
						content: B(_, {})
					}) });
					case "list": return B(xi, { children: B(tE, {
						...m.list,
						options: i.values
					}) });
					case "swatches": return B(xi, { children: B(xE, {
						...m.swatches,
						options: i.values
					}) });
				}
			})()
		}) }) : null;
	});
})), PE = o((() => {
	NE();
})), FE, IE, LE, RE, zE = o((() => {
	H(), R(), Q(), ux(), FE = /* @__PURE__ */ u(X()), hT(), bT(), BC(), OC(), Iu(), iT(), ET(), NT(), zT(), GT(), IE = /* @__PURE__ */ u(U()), tC(), PE(), LE = () => cx({
		"&.ss__result--grid": {
			display: "flex",
			flexDirection: "column",
			"& .ss__result__image-wrapper": {
				flex: "1 0 auto",
				minHeight: "0%"
			}
		},
		"&.ss__result--list": {
			display: "flex",
			flexDirection: "row",
			"& .ss__result__image-wrapper": { flex: "0 0 33%" },
			"& .ss__result__details": {
				flex: "1 1 auto",
				textAlign: "left",
				marginLeft: "20px",
				padding: 0
			}
		},
		"& .ss__result__image-wrapper": {
			position: "relative",
			"& .ss__result__badge": {
				background: "rgba(255, 255, 255, 0.5)",
				padding: "10px"
			}
		},
		"& .ss__result__details": {
			padding: "10px",
			textAlign: "center",
			"& .ss__result__details__title": { marginBottom: "10px" },
			"& .ss__result__details__pricing": {
				marginBottom: "10px",
				"& .ss__result__price": { fontSize: "1.2em" },
				"& .ss__price--strike": { fontSize: "80%" }
			}
		}
	}), RE = Z((e) => {
		let t = mi(), n = RC(), r = uS("result", t, {
			layout: nT.grid,
			treePath: n,
			addToCartButtonText: "Add To Cart",
			addToCartButtonSuccessText: "Added!",
			addToCartButtonSuccessTimeout: 2e3,
			hideAddToCartButton: !0,
			hideRating: !0
		}, e), { result: i, hideBadge: a, hideTitle: o, hidePricing: s, hideImage: c, detailSlot: l, fallback: u, disableStyles: d, className: f, internalClassName: p, layout: m, onClick: h, controller: g, hideVariantSelections: _, hideAddToCartButton: v, onAddToCartClick: y, addToCartButtonText: b, addToCartButtonSuccessText: x, addToCartButtonSuccessTimeout: S, hideRating: C, trackingRef: w, treePath: T } = r, { overrideElement: E, shouldRenderDefault: D } = QS("result", {
			...r,
			customComponent: r.customComponent && r.customComponent !== "Result" ? r.customComponent : void 0
		});
		if (!D) return E;
		let O = i?.display?.mappings.core || i?.mappings?.core, [k, A] = I(!1), j = {
			variantSelection: {
				internalClassName: "ss__result__variant-selection",
				...$({ disableStyles: d }),
				theme: r.theme,
				treePath: T
			},
			price: {
				internalClassName: "ss__result__price",
				...$({ disableStyles: d }),
				theme: r.theme,
				treePath: T
			},
			calloutBadge: {
				internalClassName: "ss__result__callout-badge",
				result: i,
				...$({ disableStyles: d }),
				theme: r.theme,
				treePath: T
			},
			overlayBadge: {
				internalClassName: "ss__result__overlay-badge",
				result: i,
				controller: g,
				...$({ disableStyles: d }),
				theme: r.theme,
				treePath: T
			},
			image: {
				internalClassName: "ss__result__image",
				alt: O?.name || "",
				src: O?.imageUrl || "",
				...$({
					disableStyles: d,
					fallback: u
				}),
				theme: r.theme,
				treePath: T
			},
			rating: {
				internalClassName: "ss__result__rating",
				value: O?.rating || 0,
				count: Number(O?.ratingCount || 0),
				...$({ disableStyles: d }),
				theme: r.theme,
				treePath: T
			},
			button: {
				internalClassName: "ss__result__button--addToCart",
				onClick: (e) => {
					A(!0), y && y(e, i), g?.addToCart([i]), setTimeout(() => A(!1), S);
				},
				...$({ disableStyles: d }),
				theme: r.theme,
				treePath: T
			}
		}, M = O?.name;
		r.truncateTitle && (M = Ll(O?.name || "", r.truncateTitle.limit, r.truncateTitle.append));
		let ee = gS(r, LE), te = (0, IE.default)({ addToCartButtonText: { value: k ? x : b } }, r.lang || {}), ne = qS(te, {
			result: i,
			controller: g
		}, { activeBreakpoint: t?.activeBreakpoint }), re = !!(O?.msrp && O?.price && O?.price < O?.msrp), ie = !g?.store?.config?.asyncState?.product?.price || i.state.priceFetched;
		return O ? B(Kx, { children: V("article", {
			...ee,
			className: (0, FE.default)("ss__result", `ss__result--${m}`, { "ss__result--sale": re }, f, p),
			ref: w,
			children: [!c && B("div", {
				className: "ss__result__image-wrapper",
				children: B("a", {
					href: O.url,
					onClick: (e) => {
						h && h(e);
					},
					children: a ? B(pT, { ...j.image }) : B(jT, {
						...j.overlayBadge,
						controller: g,
						children: B(pT, { ...j.image })
					})
				})
			}), V("div", {
				className: "ss__result__details",
				children: [
					!a && B(wT, {
						...j.calloutBadge,
						controller: g
					}),
					!o && B("div", {
						className: "ss__result__details__title",
						children: B("a", {
							href: O.url,
							onClick: (e) => {
								h && h(e);
							},
							dangerouslySetInnerHTML: { __html: M || "" }
						})
					}),
					!C && B(LT, { ...j.rating }),
					!s && ie && O.price && O.price > 0 ? B("div", {
						className: "ss__result__details__pricing",
						children: re ? V(xi, { children: [
							B(vT, {
								...j.price,
								value: O.msrp,
								lineThrough: !0,
								name: "msrp"
							}),
							"\xA0",
							B(vT, {
								...j.price,
								value: O.price,
								name: "price"
							})
						] }) : B(vT, {
							...j.price,
							value: O.price
						})
					}) : null,
					nS(l, {
						result: i,
						treePath: T
					}),
					!_ && i.variants?.selections.length ? B("div", {
						className: "ss__result__details__variant-selection",
						children: i.variants?.selections.map((e) => B(ME, {
							...j.variantSelection,
							type: e.type,
							selection: e
						}))
					}) : null,
					!v && B("div", {
						className: "ss__result__add-to-cart-wrapper",
						children: B(UT, {
							...j.button,
							...ne.addToCartButtonText.all
						})
					})
				]
			})]
		}) }) : null;
	});
})), BE = o((() => {
	zE();
})), VE, HE, UE, WE = o((() => {
	H(), ux(), Q(), VE = /* @__PURE__ */ u(X()), BC(), OC(), HE = { ResultTracker: () => cx({}) }, UE = Z((e) => {
		let t = uS("resultTracker", mi(), {}, e), n = {
			impression: !0,
			click: !0
		}, { children: r, result: i, track: a, controller: o, className: s, internalClassName: c, disableStyles: l, style: u } = t, d = {
			...n,
			...a
		}, { ref: f, inViewport: p } = wC();
		p && d.impression && o?.track.product.impression(i);
		let m = {};
		return l ? u && (m.css = [u]) : m.css = [HE.ResultTracker(), u], B("div", {
			className: (0, VE.default)("ss__result-tracker", `ss__${o?.type}-result-tracker`, s, c),
			onClick: (e) => {
				d.click && o?.track.product.click(e, i);
			},
			ref: f,
			...m,
			children: r
		});
	});
})), GE = o((() => {
	WE();
})), KE, qE, JE, YE, XE, ZE = o((() => {
	H(), ux(), Q(), KE = /* @__PURE__ */ u(X()), qE = /* @__PURE__ */ u(U()), gy(), lT(), BE(), iT(), OC(), BC(), zS(), GE(), tC(), JE = ({ gapSize: e, columns: t }) => cx({
		display: "flex",
		flexFlow: "row wrap",
		gap: e,
		gridTemplateRows: "auto",
		gridTemplateColumns: `repeat(${t}, 1fr)`,
		"& .ss__result, & .ss__result-layout": {
			boxSizing: "border-box",
			flex: "0 1 auto",
			width: `calc(${100 / t}% - (${t - 1} * ${e} / ${t} ) )`,
			marginRight: e,
			marginBottom: e,
			[`&:nth-of-type(${t}n)`]: { marginRight: "0" },
			[`&:nth-last-of-type(-n+${t})`]: { marginBottom: "0" }
		},
		"@supports (display: grid)": {
			display: "grid",
			"& .ss__result, & .ss__result-layout": {
				width: "initial",
				flex: void 0,
				margin: 0
			}
		}
	}), YE = kC(RE), XE = Z((e) => {
		let t = mi(), n = FC(), r = RC(), i = {
			0: { columns: e.columns || 1 },
			540: { columns: e.columns || 2 },
			768: { columns: e.columns || 3 },
			991: { columns: e.columns || 4 }
		}, a = uS("results", t, {
			results: e.controller?.store?.results,
			columns: 4,
			gapSize: "20px",
			layout: nT.grid,
			breakpoints: i,
			treePath: r
		}, e);
		if (e.theme?.type != "templates" && t?.type != "templates") {
			let e = LS(a?.breakpoints || {}), t = (0, qE.default)(a?.theme || {}, e?.theme || {}, { arrayMerge: (e, t) => t });
			a = {
				...a,
				...e,
				theme: t
			};
		}
		let { disableStyles: o, className: s, internalClassName: c, layout: l, theme: u, excludeBanners: d, controller: f, treePath: p } = a, m = a.resultComponent, { overrideElement: h, shouldRenderDefault: g } = QS("results", a);
		if (!g) return h;
		let _ = typeof m == "string", v = _ ? m : "", y = n?.templates?.library.import.component.result || {}, { ComponentOverride: b, shouldWaitForNamedOverride: x } = XS(y, _ ? v : void 0), S = _ ? b : m, C = {
			result: {
				internalClassName: "ss__results__result",
				...$({ disableStyles: o }),
				theme: a?.theme,
				treePath: p
			},
			inlineBanner: {
				controller: f,
				internalClassName: "ss__results__inline-banner",
				...$({ disableStyles: o }),
				theme: a?.theme,
				treePath: p
			}
		}, w = d ? a.results?.filter((e) => e.type !== E_.BANNER) : a.results;
		a?.columns && a?.rows && a.columns > 0 && a.rows > 0 && (w = w?.slice(0, a.columns * a.rows));
		let T = gS({
			...a,
			columns: l == nT.list ? 1 : a.columns
		}, JE), E = _ ? (0, qE.default)(u || {}, { components: { result: { customComponent: m } } }) : u;
		return w?.length ? B(Kx, { children: B("div", {
			...T,
			className: (0, KE.default)("ss__results", `ss__results-${a.layout}`, s, c),
			children: w.map((e) => (() => {
				switch (e.type) {
					case E_.BANNER: return lx(sT, {
						...C.inlineBanner,
						key: `${f?.id ? `${f?.id}-` : ""}${e.id}`,
						banner: e,
						layout: a.layout
					});
					default: return x ? null : S && f ? B(UE, {
						result: e,
						controller: f,
						children: nS(S, {
							key: `${f?.id ? `${f?.id}-` : ""}${e.id}`,
							controller: f,
							result: e,
							theme: E,
							treePath: p
						})
					}) : B(YE, {
						...C.result,
						result: e,
						layout: a.layout,
						controller: f
					}, `${f?.id ? `${f?.id}-` : ""}${e.id}`);
				}
			})())
		}) }) : null;
	});
})), QE = o((() => {
	ZE();
})), $E, eD, tD, nD = o((() => {
	H(), Q(), ux(), $E = /* @__PURE__ */ u(X()), BC(), OC(), tC(), gy(), R(), eD = () => cx({
		" *": { boxSizing: "border-box" },
		"& iframe, img": {
			maxWidth: "100%",
			height: "auto"
		}
	}), tD = Jx(Z((e) => {
		let t = uS("banner", mi(), { treePath: RC() }, e), { controller: n, type: r, className: i, internalClassName: a } = t, o = t.content || n?.store?.merchandising.content, { overrideElement: s, shouldRenderDefault: c } = QS("banner", t);
		if (!c) return s;
		if (r === E_.INLINE) return console.warn(`BannerType '${E_.INLINE}' is not supported in <Banner /> component`), null;
		let l = gS(t, eD), u = o?.[r]?.[0]?.value;
		if (!r || !u) return null;
		let d = Le(kC((e) => B("div", {
			className: (0, $E.default)("ss__banner", `ss__banner--${r}`, i, a),
			...l,
			ref: e.trackingRef,
			dangerouslySetInnerHTML: { __html: typeof u == "string" ? u : u.join("") }
		})), [u, r]);
		return B(Kx, { children: B(d, { ...t }) });
	}));
})), rD = o((() => {
	nD();
})), iD, aD = o((() => {
	iD = (e, t = {
		delay: 333,
		focusElem: !0
	}) => {
		let n;
		return {
			onMouseEnter: (r) => {
				clearTimeout(n), n = window.setTimeout(() => {
					t.focusElem && r.target.focus(), e && e();
				}, t.delay || 333);
			},
			onMouseLeave: () => {
				clearTimeout(n);
			}
		};
	};
})), oD = o((() => {
	aD();
})), sD, cD, lD, uD, dD = o((() => {
	H(), R(), ux(), sD = /* @__PURE__ */ u(X()), Q(), OC(), BC(), PT(), KS(), tC(), cD = /* @__PURE__ */ u(U()), lD = ({ size: e, native: t }) => cx(t ? {} : {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		height: e,
		width: e,
		cursor: "pointer",
		"&.ss__radio--disabled": {
			opacity: .3,
			cursor: "default"
		}
	}), uD = Z((e) => {
		let t = mi(), n = RC(), r = uS("radio", t, {
			size: "20px",
			startChecked: !1,
			disableA11y: !1,
			checkedIcon: "bullet",
			unCheckedIcon: "bullet-o",
			color: t.variables?.colors.primary || "#000000",
			treePath: n
		}, e), { checked: i, color: a, disabled: o, checkedIcon: s, unCheckedIcon: c, onClick: l, startChecked: u, native: d, disableA11y: f, disableStyles: p, className: m, internalClassName: h, size: g, treePath: _, lang: v, style: y, styleScript: b, themeStyleScript: x, name: S, ...C } = r, { overrideElement: w, shouldRenderDefault: T } = QS("radio", r);
		if (!T) return w;
		let E = {
			activeIcon: {
				name: "active",
				internalClassName: "ss__radio__icon",
				...$({
					size: g,
					color: a,
					disableStyles: p
				}),
				theme: r.theme,
				treePath: _
			},
			inactiveIcon: {
				name: "inactive",
				internalClassName: "ss__radio__icon",
				...$({
					size: g,
					color: a,
					disableStyles: p
				}),
				theme: r.theme,
				treePath: _
			}
		}, D, O, k = i === void 0;
		k ? [D, O] = I(u) : D = i;
		let A = (e) => {
			o || (k && O && O((e) => !e), l && l(e));
		}, j = gS(r, lD), M = (0, cD.default)({ radio: {} }, v || {}), ee = qS(M, {
			disabled: o,
			checkedState: D
		}, { activeBreakpoint: t?.activeBreakpoint });
		return B(Kx, { children: d ? B("div", {
			className: (0, sD.default)("ss__radio", "ss__radio--native", { "ss__radio--disabled": o }, m, h),
			...j,
			children: B("input", {
				className: (0, sD.default)("ss__radio__input"),
				"aria-checked": D,
				type: "radio",
				onClick: (e) => A(e),
				disabled: o,
				checked: D,
				tabIndex: f ? -1 : 0
			})
		}) : B("span", {
			...j,
			className: (0, sD.default)("ss__radio", {
				"ss__radio--disabled": o,
				"ss__radio--active": D
			}, m, h),
			onClick: (e) => A(e),
			ref: (e) => f ? null : VS(e),
			...ee.radio?.all,
			role: "radio",
			"aria-checked": D,
			"aria-disabled": o,
			...C,
			children: D ? B(KC, {
				...E.activeIcon,
				...typeof s == "string" ? { icon: s } : s
			}) : B(KC, {
				...E.inactiveIcon,
				...typeof c == "string" ? { icon: c } : c
			})
		}) });
	});
})), fD = o((() => {
	dD();
})), pD, mD, hD, gD, _D = o((() => {
	H(), ux(), pD = /* @__PURE__ */ u(X()), Q(), BC(), OC(), XT(), oD(), tC(), mD = /* @__PURE__ */ u(U()), fD(), hD = ({ horizontal: e, theme: t, hideCheckbox: n }) => cx({
		display: e ? "flex" : void 0,
		flexWrap: e ? "wrap" : void 0,
		"& .ss__facet-list-options__option": {
			display: e ? void 0 : "flex",
			alignItems: e ? void 0 : "center",
			flex: e ? "0 1 auto" : void 0,
			padding: "6px",
			textDecoration: "none",
			"&:hover": { cursor: "pointer" },
			"&.ss__facet-list-options__option--filtered": {
				fontWeight: "bold",
				color: t?.variables?.colors?.primary
			},
			"& .ss__facet-list-options__option__value": {
				marginLeft: n ? "" : "8px",
				"& .ss__facet-list-options__option__value__count": {
					fontSize: "0.8em",
					marginLeft: "6px"
				}
			}
		}
	}), gD = Z((e) => {
		let t = mi(), n = RC(), r = uS("facetListOptions", t, {
			hideCheckbox: !!e.horizontal,
			treePath: n
		}, e), { values: i, hideCheckbox: a, hideCount: o, onClick: s, previewOnFocus: c, hideCountParenthesis: l, respectSingleSelect: u, valueProps: d, facet: f, disableStyles: p, className: m, internalClassName: h, treePath: g } = r, { overrideElement: _, shouldRenderDefault: v } = QS("facetListOptions", r);
		if (!v) return _;
		let y = !1;
		u && f?.multiple == "single" && (y = !0);
		let b = {
			checkbox: {
				internalClassName: "ss__facet-list-options__checkbox",
				...$({ disableStyles: p }),
				theme: r?.theme,
				treePath: g
			},
			radio: {
				internalClassName: "ss__facet-list-options__radio",
				...$({ disableStyles: p }),
				theme: r?.theme,
				treePath: g
			}
		}, x = gS(r, hD), S = i || f?.refinedValues;
		return S?.length ? B(Kx, { children: B("div", {
			...x,
			className: (0, pD.default)("ss__facet-list-options", m, h),
			children: S.map((e) => {
				let n = { listOption: { attributes: { "aria-label": `${e.filtered ? `remove selected filter ${f?.label || ""} - ${e.label}` : f?.label ? `filter by ${f?.label} - ${e.label}` : `filter by ${e.label}`}` } } }, i = (0, mD.default)(n, r.lang || {}), u = qS(i, {
					facet: f,
					value: e
				}, { activeBreakpoint: t?.activeBreakpoint });
				return V("a", {
					className: (0, pD.default)("ss__facet-list-options__option", { "ss__facet-list-options__option--filtered": e.filtered }),
					href: e.url?.link?.href,
					...d,
					onClick: (t) => {
						e.url?.link?.onClick(t), s && s(t);
					},
					...c ? iD(() => e?.preview && e.preview()) : {},
					...u.listOption?.all,
					children: [y ? !a && B(uD, {
						...b.radio,
						checked: e.filtered,
						disableA11y: !0,
						...u.listOption.attributes
					}) : !a && B(YT, {
						...b.checkbox,
						checked: e.filtered,
						disableA11y: !0,
						...u.listOption.attributes
					}), V("span", {
						className: "ss__facet-list-options__option__value",
						children: [B("span", {
							className: "ss__facet-list-options__option__value__label",
							children: e.label
						}), !o && e?.count > 0 && B("span", {
							className: "ss__facet-list-options__option__value__count",
							children: l ? `${e.count}` : `(${e.count})`
						})]
					})]
				});
			})
		}) }) : null;
	});
})), vD = o((() => {
	_D();
})), yD, bD, xD, SD, CD = o((() => {
	H(), ux(), yD = /* @__PURE__ */ u(X()), Q(), BC(), OC(), oD(), tC(), bD = /* @__PURE__ */ u(U()), xD = ({ columns: e, gapSize: t, gridSize: n, theme: r }) => cx({
		display: "flex",
		flexFlow: "row wrap",
		gridTemplateColumns: e ? `repeat(${e}, 1fr)` : `repeat(auto-fill, minmax(${n}, 1fr))`,
		gap: t,
		gridAutoRows: "1fr",
		"& .ss__facet-grid-options__option": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			flex: "0 1 auto",
			border: "1px solid",
			borderColor: r?.variables?.colors?.primary || "initial",
			textAlign: "center",
			wordBreak: "break-all",
			boxSizing: "border-box",
			padding: "1em 0",
			width: `calc(100% / ${e} - ${2 * Math.round((e + 2) / 2)}px)`,
			margin: `0 ${t} ${t} 0`,
			[`:nth-of-type(${e}n)`]: { marginRight: "0" },
			"&.ss__facet-grid-options__option--filtered": {
				background: "#ccc",
				color: "#333"
			},
			"&:hover:not(.ss__facet-grid-options__option--filtered)": {
				cursor: "pointer",
				background: "#f8f8f8",
				color: "#333"
			},
			"& .ss__facet-grid-options__option__value": { "&.ss__facet-grid-options__option__value--smaller": { fontSize: "70%" } }
		},
		"@supports (display: grid)": {
			display: "grid",
			"& .ss__facet-grid-options__option": {
				padding: "0",
				margin: "0",
				width: "initial"
			},
			"&::before": {
				content: "\"\"",
				width: 0,
				paddingBottom: "100%",
				gridRow: "1 / 1",
				gridColumn: "1 / 1"
			},
			"&> *:first-of-type": {
				gridRow: "1 / 1",
				gridColumn: "1 / 1"
			}
		}
	}), SD = Z((e) => {
		let t = mi(), n = uS("facetGridOptions", t, {
			columns: 4,
			gapSize: "8px",
			gridSize: "45px",
			treePath: RC()
		}, e), { values: r, onClick: i, previewOnFocus: a, valueProps: o, facet: s, horizontal: c, className: l, internalClassName: u } = n, { overrideElement: d, shouldRenderDefault: f } = QS("facetGridOptions", n);
		if (!f) return d;
		c && (n.columns = 0);
		let p = gS(n, xD), m = r || s?.refinedValues;
		return m?.length ? B(Kx, { children: B("div", {
			...p,
			className: (0, yD.default)("ss__facet-grid-options", l, u),
			children: m.map((e) => {
				let r = { gridOption: { attributes: { "aria-label": `${e.filtered ? `remove selected filter ${s?.label || ""} - ${e.label}` : s?.label ? `filter by ${s?.label} - ${e.label}` : `filter by ${e.label}`}` } } }, c = (0, bD.default)(r, n.lang || {}), l = qS(c, {
					facet: s,
					value: e
				}, { activeBreakpoint: t?.activeBreakpoint });
				return B("a", {
					className: (0, yD.default)("ss__facet-grid-options__option", { "ss__facet-grid-options__option--filtered": e.filtered }),
					href: e.url?.link?.href,
					...o,
					onClick: (t) => {
						e.url?.link?.onClick(t), i && i(t);
					},
					...a ? iD(() => e?.preview && e.preview()) : {},
					...l.gridOption?.all,
					children: B("span", {
						className: (0, yD.default)("ss__facet-grid-options__option__value", { "ss__facet-grid-options__option__value--smaller": e.label.length > 3 }),
						children: e.label
					})
				});
			})
		}) }) : null;
	});
})), wD = o((() => {
	CD();
})), TD, ED, DD, OD, kD = o((() => {
	H(), ux(), TD = /* @__PURE__ */ u(X()), Q(), Iu(), OC(), PT(), BC(), oD(), ZT(), tC(), ED = /* @__PURE__ */ u(U()), eT(), aE(), hT(), $w([iE]), DD = ({ columns: e, gridSize: t, gapSize: n, horizontal: r, theme: i }) => cx({
		display: "flex",
		flexFlow: "row wrap",
		gridTemplateColumns: e ? `repeat(${e}, calc((100% - (${e - 1} * ${n}))/ ${e}))` : `repeat(auto-fill, minmax(${t}, 1fr))`,
		gap: n,
		".ss__facet-palette-options__option--list": {
			display: "flex",
			flexDirection: "row"
		},
		".ss__facet-palette-options__option": {
			width: `calc(100% / ${e} - ${2 * Math.round((e + 2) / 2)}px )`,
			marginRight: n,
			marginBottom: n,
			[`:nth-of-type(${e}n)`]: { marginRight: "0" },
			".ss__facet-palette-options__option__wrapper": {
				border: "2px solid transparent",
				borderRadius: "100%",
				padding: "2px"
			},
			".ss__facet-palette-options__option__palette": {
				paddingTop: "calc(100% - 2px)",
				border: "1px solid #EBEBEB",
				borderRadius: "100%",
				position: "relative",
				".ss__facet-palette-options__icon": {
					position: "absolute",
					top: 0,
					right: 0,
					left: 0,
					margin: "auto",
					bottom: 0,
					textAlign: "center",
					stroke: "black",
					strokeWidth: "3px",
					strokeLinejoin: "round",
					opacity: 0
				},
				"&.ss__facet-palette-options__option__palette--image": {
					paddingTop: "0",
					height: "auto"
				}
			},
			".ss__facet-palette-options__option__value": {
				display: "block",
				textAlign: "center",
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap"
			}
		},
		"@supports (display: grid)": {
			display: "grid",
			".ss__facet-palette-options__option": {
				margin: "0",
				width: "initial"
			}
		},
		"&.ss__facet-palette-options--list": {
			display: "flex",
			flexDirection: r ? "row" : "column",
			".ss__facet-palette-options__option__wrapper": {
				borderColor: "transparent",
				width: "16px",
				height: "fit-content"
			},
			".ss__facet-palette-options__option--filtered": { ".ss__facet-palette-options__option__value": { fontWeight: "bold" } },
			".ss__facet-palette-options__option--list": { alignItems: "center" },
			".ss__facet-palette-options__option__value__count": { marginLeft: "5px" },
			".ss__facet-palette-options__checkbox": { marginRight: "5px" }
		},
		"&.ss__facet-palette-options--grid": {
			".ss__facet-palette-options__checkbox": {
				display: "flex",
				textAlign: "center",
				overflow: "hidden",
				margin: "auto",
				marginBottom: "5px"
			},
			".ss__facet-palette-options__option--filtered": { ".ss__facet-palette-options__option__wrapper": {
				borderColor: i?.variables?.colors?.primary || "#333 !important",
				padding: "0px",
				borderWidth: "4px"
			} },
			".ss__facet-palette-options__option": { "&:hover": {
				cursor: "pointer",
				".ss__facet-palette-options__option__wrapper": { borderColor: "#EBEBEB" },
				".ss__facet-palette-options__option__palette": { ".ss__facet-palette-options__icon": { opacity: 1 } }
			} }
		},
		".ss__facet-palette-options__option__value__count": {
			fontSize: "0.8em",
			display: "block",
			textAlign: "center",
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap"
		}
	}), OD = Z((e) => {
		let t = mi(), n = RC(), r = uS("facetPaletteOptions", t, {
			columns: 4,
			layout: "grid",
			gridSize: "45px",
			gapSize: e.layout == "list" ? "2px" : "8px",
			hideCount: !0,
			hideCheckbox: !0,
			treePath: n
		}, e), { values: i, hideLabel: a, layout: o, hideCount: s, hideCheckbox: c, colorMapping: l, hideIcon: u, onClick: d, previewOnFocus: f, valueProps: p, facet: m, horizontal: h, disableStyles: g, className: _, internalClassName: v, treePath: y } = r, { overrideElement: b, shouldRenderDefault: x } = QS("facetPaletteOptions", r);
		if (!x) return b;
		h && (r.columns = 0);
		let S = {
			icon: {
				internalClassName: "ss__facet-palette-options__icon",
				...$({
					disableStyles: g,
					icon: "close-thin",
					color: "white",
					size: "40%"
				}),
				theme: r?.theme,
				treePath: y
			},
			image: {
				internalClassName: "ss__facet-palette-options__image",
				...$({ disableStyles: g }),
				theme: r?.theme,
				treePath: y
			},
			checkbox: {
				internalClassName: "ss__facet-palette-options__checkbox",
				...$({ disableStyles: g }),
				theme: r?.theme,
				treePath: y
			}
		}, C = gS(r, DD), w = i || m?.values;
		return w?.length ? B(Kx, { children: B("div", {
			...C,
			className: (0, TD.default)("ss__facet-palette-options", `ss__facet-palette-options--${o?.toLowerCase()}`, _, v),
			children: w.map((e) => {
				let n = { paletteOption: { attributes: { "aria-label": `${e.filtered ? `remove selected filter ${m?.label || ""} - ${e.label}` : m?.label ? `filter by ${m?.label} - ${e.label}` : `filter by ${e.label}`}` } } }, i = (0, ED.default)(n, r.lang || {}), h = qS(i, {
					facet: m,
					value: e
				}, { activeBreakpoint: t?.activeBreakpoint }), g;
				l && (g = Object.fromEntries(Object.entries(l).map(([e, t]) => [e.toLowerCase(), t])));
				let _ = g && g[e.label.toLowerCase()] && g[e.label.toLowerCase()].background ? g[e.label.toLowerCase()].background : e.value, v = g && g[e.label.toLowerCase()] && g[e.label.toLowerCase()].backgroundImageUrl ? g[e.label.toLowerCase()].backgroundImageUrl : void 0, y = !1;
				if (_) try {
					y = Zw(_.toLowerCase()).isDark();
				} catch {}
				return V("a", {
					className: (0, TD.default)("ss__facet-palette-options__option", { "ss__facet-palette-options__option--filtered": e.filtered }, { "ss__facet-palette-options__option--dark": y }, `ss__facet-palette-options__option--${o?.toLowerCase()}`),
					href: e.url?.link?.href,
					...a ? { title: e.label } : {},
					...p,
					onClick: (t) => {
						e.url?.link?.onClick(t), d && d(t);
					},
					"aria-atomic": "false",
					...f ? iD(() => e?.preview && e.preview()) : {},
					...h.paletteOption?.all,
					children: [
						!c && B(YT, {
							...S.checkbox,
							checked: e.filtered,
							disableA11y: !0,
							...h.paletteOption.attributes
						}),
						B("div", {
							className: "ss__facet-palette-options__option__wrapper",
							children: V("div", {
								className: (0, TD.default)("ss__facet-palette-options__option__palette", `ss__facet-palette-options__option__palette--${Fl(e.value)}`, { "ss__facet-palette-options__option__palette--image": v }),
								style: { background: _ },
								children: [v ? B(pT, {
									...S.image,
									src: v,
									alt: e.label || e.value.toString()
								}) : null, !u && e.filtered && o?.toLowerCase() == "grid" && B(KC, { ...S.icon })]
							})
						}),
						!a && B("span", {
							className: "ss__facet-palette-options__option__value",
							children: g?.[e.label.toLowerCase()]?.label ?? e.label
						}),
						!s && e?.count > 0 && V("span", {
							className: "ss__facet-palette-options__option__value__count",
							children: [
								"(",
								e.count,
								")"
							]
						})
					]
				}, e.value);
			})
		}) }) : null;
	});
})), AD = o((() => {
	kD();
})), jD, MD, ND, PD, FD = o((() => {
	H(), ux(), jD = /* @__PURE__ */ u(X()), Q(), BC(), OC(), oD(), tC(), MD = /* @__PURE__ */ u(U()), PT(), ND = ({ theme: e, horizontal: t, returnIcon: n }) => cx(t ? {
		display: "flex",
		flexWrap: "wrap",
		"& .ss__facet-hierarchy-options__option": {
			margin: "0 5px 5px 0",
			padding: "6px",
			textDecoration: "none",
			flex: "0 1 auto",
			"&:hover": { cursor: "pointer" },
			"&.ss__facet-hierarchy-options__option--filtered": {
				fontWeight: "bold",
				color: e?.variables?.colors?.primary,
				marginRight: "2em",
				"&:hover": {
					cursor: "default",
					background: "unset"
				}
			},
			"&.ss__facet-hierarchy-options__option--return": {
				".ss__icon": { padding: "0 0 0 2px" },
				[n ? "" : "&:before"]: {
					content: `${n ? "\"\"" : "'\\0000ab'"}`,
					padding: "0 2px 0 0",
					color: e?.variables?.colors?.primary
				}
			},
			"& .ss__facet-hierarchy-options__option__value": { "& .ss__facet-hierarchy-options__option__value__count": {
				fontSize: "0.8em",
				marginLeft: "6px"
			} }
		}
	} : { "& .ss__facet-hierarchy-options__option": {
		display: "flex",
		padding: "6px 0",
		textDecoration: "none",
		alignItems: "center",
		"&:hover": { cursor: "pointer" },
		"&.ss__facet-hierarchy-options__option--filtered": {
			fontWeight: "bold",
			color: e?.variables?.colors?.primary,
			"&:hover": {
				cursor: "default",
				background: "unset"
			},
			"& ~ .ss__facet-hierarchy-options__option:not(.ss__facet-hierarchy-options__option--filtered)": { paddingLeft: "16px" }
		},
		"&.ss__facet-hierarchy-options__option--return": {
			".ss__icon": { padding: "0 0 0 2px" },
			[n ? "" : "&:before"]: {
				content: `${n ? "\"\"" : "'\\0000ab'"}`,
				padding: "0 2px 0 0",
				color: e?.variables?.colors?.primary
			}
		},
		"& .ss__facet-hierarchy-options__option__value": {
			marginLeft: "8px",
			"& .ss__facet-hierarchy-options__option__value__count": {
				fontSize: "0.8em",
				marginLeft: "6px"
			}
		}
	} }), PD = Z((e) => {
		let t = mi(), n = uS("facetHierarchyOptions", t, { treePath: RC() }, e), { values: r, hideCount: i, returnIcon: a, onClick: o, previewOnFocus: s, horizontal: c, valueProps: l, facet: u, disableStyles: d, treePath: f, className: p, internalClassName: m } = n, { overrideElement: h, shouldRenderDefault: g } = QS("facetHierarchyOptions", n);
		if (!g) return h;
		let _ = { icon: {
			internalClassName: "ss__facet-hierarchy-options__icon",
			...$({ disableStyles: d }),
			theme: n?.theme,
			treePath: f
		} }, v = gS(n, ND), y = r || u?.refinedValues;
		return y?.length ? B(Kx, { children: B("div", {
			...v,
			className: (0, jD.default)("ss__facet-hierarchy-options", { "ss__facet-hierarchy-options--horizontal": c }, p, m),
			children: y.map((e) => {
				let r = { hierarchyOption: { attributes: { "aria-label": `${e.filtered ? `selected ${e.label}` : u?.label ? `filter by ${u?.label} - ${e.label}` : `filter by ${e.label}`}` } } }, c = (0, MD.default)(r, n.lang || {}), d = qS(c, {
					facet: u,
					value: e
				}, { activeBreakpoint: t?.activeBreakpoint });
				return V("a", {
					className: (0, jD.default)("ss__facet-hierarchy-options__option", { "ss__facet-hierarchy-options__option--filtered": e.filtered }, { "ss__facet-hierarchy-options__option--return": e.history && !e.filtered }),
					href: e.url?.link?.href,
					...l,
					onClick: (t) => {
						e.url?.link?.onClick(t), o && o(t);
					},
					...s ? iD(() => e?.preview && e.preview()) : {},
					...d.hierarchyOption?.all,
					children: [a && e.history && !e.filtered && B(KC, {
						..._.icon,
						...typeof a == "string" ? { icon: a } : a
					}), V("span", {
						className: "ss__facet-hierarchy-options__option__value",
						children: [e.label, !i && e?.count > 0 && !e.filtered && V("span", {
							className: "ss__facet-hierarchy-options__option__value__count",
							children: [
								"(",
								e.count,
								")"
							]
						})]
					})]
				});
			})
		}) }) : null;
	});
})), ID = o((() => {
	FD();
}));
//#endregion
//#region node_modules/react-ranger/dist/react-ranger.mjs
function LD() {
	return LD = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, LD.apply(this, arguments);
}
function RD(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.keys(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
	return n;
}
function zD(e) {
	var t = e.interpolator, n = t === void 0 ? UD : t, r = e.tickSize, i = r === void 0 ? 10 : r, a = e.values, o = e.min, s = e.max, c = e.ticks, l = e.steps, u = e.onChange, d = e.onDrag, f = e.stepSize, p = z.useState(null), m = p[0], h = p[1], g = z.useState(), _ = g[0], v = g[1], y = HD({
		activeHandleIndex: m,
		onChange: u,
		onDrag: d,
		values: a,
		tempValues: _
	}), b = z.useRef(), x = z.useCallback(function(e) {
		var t = BD(b.current);
		return n.getValueForClientX(e, t, o, s);
	}, [
		n,
		s,
		o
	]), S = z.useCallback(function(e, t) {
		if (l) {
			var n = l.indexOf(e) + t;
			return n >= 0 && n < l.length ? l[n] : e;
		}
		var r = e + f * t;
		return r >= o && r <= s ? r : e;
	}, [
		s,
		o,
		f,
		l
	]), C = z.useCallback(function(e) {
		var t = o, n = s;
		if (l) l.forEach(function(r) {
			r <= e && r > t && (t = r), r >= e && r < n && (n = r);
		});
		else {
			for (; t < e && t + f < e;) t += f;
			n = Math.min(t + f, s);
		}
		return e - t < n - e ? t : n;
	}, [
		s,
		o,
		f,
		l
	]), w = z.useCallback(function(e) {
		var t = y(), n = t.activeHandleIndex, r = t.onDrag, i = C(x(e.type === "touchmove" ? e.changedTouches[0].clientX : e.clientX)), o = [].concat(a.slice(0, n), [i], a.slice(n + 1));
		r ? r(o) : v(o);
	}, [
		y,
		x,
		C,
		a
	]), T = z.useCallback(function(e, t) {
		var n = y(), r = n.values, i = n.onChange, a = i === void 0 ? function() {} : i;
		if (e.keyCode === 37 || e.keyCode === 39) {
			h(t);
			var o = e.keyCode === 37 ? -1 : 1, s = S(r[t], o);
			a(VD([].concat(r.slice(0, t), [s], r.slice(t + 1))));
		}
	}, [y, S]), E = z.useCallback(function(e, t) {
		h(t);
		var n = function e(t) {
			var n = y(), r = n.tempValues, i = n.values, a = n.onChange, o = a === void 0 ? function() {} : a, s = n.onDrag, c = s === void 0 ? function() {} : s;
			document.removeEventListener("mousemove", w), document.removeEventListener("touchmove", w), document.removeEventListener("mouseup", e), document.removeEventListener("touchend", e);
			var l = VD(r || i);
			o(l), c(l), h(null), v();
		};
		document.addEventListener("mousemove", w), document.addEventListener("touchmove", w), document.addEventListener("mouseup", n), document.addEventListener("touchend", n);
	}, [y, w]), D = z.useCallback(function(e) {
		return n.getPercentageForValue(e, o, s);
	}, [
		n,
		s,
		o
	]);
	return {
		activeHandleIndex: m,
		getTrackProps: function(e) {
			var t = e === void 0 ? {} : e, n = t.style, r = n === void 0 ? {} : n, i = t.ref, a = RD(t, ["style", "ref"]);
			return LD({
				ref: function(e) {
					b.current = e, i && (typeof i == "function" ? i(e) : i.current = e);
				},
				style: LD({
					position: "relative",
					userSelect: "none"
				}, r)
			}, a);
		},
		ticks: z.useMemo(function() {
			var e = c || l;
			if (!e) {
				for (e = [o]; e[e.length - 1] < s - i;) e.push(e[e.length - 1] + i);
				e.push(s);
			}
			return e.map(function(e, t) {
				return {
					value: e,
					getTickProps: function(n) {
						var r = n === void 0 ? {} : n, i = r.key, a = i === void 0 ? t : i, o = r.style, s = o === void 0 ? {} : o, c = RD(r, ["key", "style"]);
						return LD({
							key: a,
							style: LD({
								position: "absolute",
								width: 0,
								left: D(e) + "%",
								transform: "translateX(-50%)"
							}, s)
						}, c);
					}
				};
			});
		}, [
			c,
			D,
			s,
			o,
			l,
			i
		]),
		segments: z.useMemo(function() {
			var e = VD(_ || a);
			return [].concat(e, [s]).map(function(t, n) {
				return {
					value: t,
					getSegmentProps: function(r) {
						var i = r === void 0 ? {} : r, a = i.key, s = a === void 0 ? n : a, c = i.style, l = c === void 0 ? {} : c, u = RD(i, ["key", "style"]), d = D(e[n - 1] ? e[n - 1] : o), f = D(t) - d;
						return LD({
							key: s,
							style: LD({
								position: "absolute",
								left: d + "%",
								width: f + "%"
							}, l)
						}, u);
					}
				};
			});
		}, [
			D,
			s,
			o,
			_,
			a
		]),
		handles: z.useMemo(function() {
			return (_ || a).map(function(e, t) {
				return {
					value: e,
					active: t === m,
					getHandleProps: function(n) {
						var r = n === void 0 ? {} : n, i = r.key, a = i === void 0 ? t : i;
						r.ref, r.innerRef;
						var c = r.onKeyDown, l = r.onMouseDown, u = r.onTouchStart, d = r.style, f = d === void 0 ? {} : d, p = RD(r, [
							"key",
							"ref",
							"innerRef",
							"onKeyDown",
							"onMouseDown",
							"onTouchStart",
							"style"
						]);
						return LD({
							key: a,
							onKeyDown: function(e) {
								e.persist(), T(e, t), c && c(e);
							},
							onMouseDown: function(e) {
								e.persist(), E(e, t), l && l(e);
							},
							onTouchStart: function(e) {
								e.persist(), E(e, t), u && u(e);
							},
							role: "slider",
							"aria-valuemin": o,
							"aria-valuemax": s,
							"aria-valuenow": e,
							style: LD({
								position: "absolute",
								top: "50%",
								left: D(e) + "%",
								zIndex: t === m ? "1" : "0",
								transform: "translate(-50%, -50%)"
							}, f)
						}, p);
					}
				};
			});
		}, [
			m,
			D,
			T,
			E,
			o,
			s,
			_,
			a
		])
	};
}
var BD, VD, HD, UD, WD = o((() => {
	ln(), BD = function(e) {
		var t = e.getBoundingClientRect();
		return {
			left: Math.ceil(t.left),
			width: Math.ceil(t.width)
		};
	}, VD = function(e) {
		return [].concat(e).sort(function(e, t) {
			return Number(e) - Number(t);
		});
	}, HD = function(e) {
		var t = z.useRef(e);
		return t.current = e, z.useCallback(function() {
			return t.current;
		}, []);
	}, UD = {
		getPercentageForValue: function(e, t, n) {
			return Math.max(0, Math.min(100, (e - t) / (n - t) * 100));
		},
		getValueForClientX: function(e, t, n, r) {
			var i = t.left, a = t.width, o = (e - i) / a;
			return (r - n) * o + n;
		}
	};
})), GD, KD, qD, JD, YD = o((() => {
	H(), R(), Q(), ux(), GD = /* @__PURE__ */ u(X()), WD(), BC(), OC(), tC(), KD = /* @__PURE__ */ u(U()), qD = ({ railColor: e, trackColor: t, handleColor: n, valueTextColor: r, handleDraggingColor: i, showTicks: a, stickyHandleLabel: o, tickTextColor: s, theme: c }) => cx({
		display: "flex",
		flexDirection: "column",
		marginTop: "5px",
		marginBottom: a && o ? "20px" : a || o ? "10px" : "5px",
		"& .ss__facet-slider__slider": {
			position: "relative",
			display: "inline-block",
			height: "8px",
			width: "calc(100% - 2rem)",
			margin: o ? "1rem" : "0 1rem",
			top: "10px"
		},
		"& .ss__facet-slider__tick": {
			"&:before": {
				content: "''",
				position: "absolute",
				left: "0",
				background: "rgba(0, 0, 0, 0.2)",
				height: "5px",
				width: "2px",
				transform: "translate(-50%, 0.7rem)"
			},
			"& .ss__facet-slider__tick__label": {
				position: "absolute",
				fontSize: "0.6rem",
				color: s,
				top: "100%",
				transform: "translate(-50%, 1.2rem)",
				whiteSpace: "nowrap"
			}
		},
		"& .ss__facet-slider__rail": {
			background: e || c?.variables?.colors?.primary || "#333",
			height: "100%"
		},
		"& .ss__facet-slider__segment": {
			background: t || c?.variables?.colors?.secondary || "#ccc",
			height: "100%"
		},
		"& .ss__facet-slider__handles": {
			textAlign: "center",
			"& button": { "& .ss__facet-slider__handle": {
				background: n || c?.variables?.colors?.primary || "#333",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				width: "1.6rem",
				height: "1.6rem",
				borderRadius: "100%",
				fontSize: "0.7rem",
				whiteSpace: "nowrap",
				color: r || "initial",
				fontWeight: "normal",
				transform: "translateY(0) scale(0.9)",
				transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
				position: "relative",
				cursor: "pointer",
				"&:after": {
					backgroundColor: "#ffffff",
					width: "30%",
					height: "30%",
					top: "0",
					bottom: "0",
					left: "0",
					content: "\"\"",
					position: "absolute",
					right: "0",
					borderRadius: "12px",
					margin: "auto",
					cursor: "pointer"
				},
				"&.ss__facet-slider__handle--active": {
					background: i || n || c?.variables?.colors?.primary || "#000",
					"& label.ss__facet-slider__handle__label": {
						background: "#fff",
						padding: "0 5px"
					}
				},
				"& label.ss__facet-slider__handle__label": {
					display: "inline-block",
					marginTop: a && !o ? "35px" : "20px",
					"&.ss__facet-slider__handle__label--pinleft": { left: "0px" },
					"&.ss__facet-slider__handle__label--pinright": { right: "0px" },
					"&.ss__facet-slider__handle__label--sticky": {
						position: "absolute",
						top: "-20px",
						fontFamily: "Roboto, Helvetica, Arial",
						fontSize: "14px",
						marginTop: "0px"
					}
				}
			} }
		},
		"& .ss__facet-slider__labels": {
			textAlign: "center",
			marginTop: a && !o ? "40px" : "20px",
			color: r,
			"& .ss__facet-slider__label--0": { "&:after": {
				content: "\"-\"",
				padding: "5px"
			} }
		}
	}), JD = Z((e) => {
		let t = mi(), n = RC(), r = uS("facetSlider", t, {
			tickSize: e.facet?.step ? e.facet?.step * 10 : 20,
			treePath: n
		}, e), { showTicks: i, facet: a, stickyHandleLabel: o, separateHandles: s, onChange: c, onDrag: l, className: u, internalClassName: d } = r, { overrideElement: f, shouldRenderDefault: p } = QS("facetSlider", r);
		if (!p) return f;
		let { tickSize: m } = r;
		m = isNaN(Number(m)) || Number(m) <= 0 ? e.facet?.step ? e.facet?.step * 10 : 20 : Number(m);
		let [h, g] = I([a.active?.low, a.active?.high]), [_, v] = I([a.active?.low, a.active?.high]), y = (e) => {
			if (!s || !a.step) return e;
			let [t, n] = e, r = a.range?.low, i = a.range?.high, o = a.step;
			return t === n ? n + o <= i ? [t, n + o] : t - o >= r ? [t - o, n] : e : e;
		};
		((a.active?.low || a.active?.low === 0) && a.active?.high && h[0] != a.active?.low || h[1] != a.active?.high) && (v([a.active?.low, a.active?.high]), g([a.active?.low, a.active?.high]));
		let { getTrackProps: b, ticks: x, segments: S, handles: C } = zD({
			values: _,
			onChange: (e) => {
				let t = y(e);
				v(t), c && c(t), a?.services?.urlManager && (t[0] == a.range.low && t[1] == a.range.high ? a.services.urlManager.remove("page").remove(`filter.${a.field}`).go() : a.services.urlManager.remove("page").set(`filter.${a.field}`, {
					low: t[0],
					high: t[1]
				}).go()), c && c(e);
			},
			onDrag: (e) => {
				let t = y(e);
				v(t), l && l(t);
			},
			min: a.range?.low,
			max: a.range?.high,
			stepSize: a.step,
			tickSize: m
		}), w = gS(r, qD);
		return a.range && a.active && a.step ? B(Kx, { children: V("div", {
			className: (0, GD.default)("ss__facet-slider", u, d),
			...b(),
			...w,
			children: [V("div", {
				className: "ss__facet-slider__slider",
				children: [
					i && x.map(({ value: e, getTickProps: t }) => B("div", {
						className: "ss__facet-slider__tick",
						...t(),
						children: B("div", {
							className: "ss__facet-slider__tick__label",
							children: e
						})
					})),
					S.map(({ getSegmentProps: e }, t) => B("div", {
						className: `${t === 1 ? "ss__facet-slider__rail" : "ss__facet-slider__segment"}`,
						...e()
					})),
					B("div", {
						className: "ss__facet-slider__handles",
						children: C.map(({ value: e, active: n, getHandleProps: i }, s) => {
							let c = { sliderHandle: { attributes: { "aria-label": `${a.label} button, current value ${e}, ${a.range?.low ? `min value ${a.range?.low},` : ""} ${a.range?.high ? `max value ${a.range?.high}` : ""}` } } }, l = (0, KD.default)(c, r.lang || {}), u = qS(l, {
								facet: a,
								value: e
							}, { activeBreakpoint: t?.activeBreakpoint });
							return B("button", {
								type: "button",
								...i({ style: {
									appearance: "none",
									border: "none",
									background: "transparent",
									outline: "none"
								} }),
								...u.sliderHandle?.all,
								ref: (e) => VS(e),
								children: B("div", {
									className: (0, GD.default)("ss__facet-slider__handle", { "ss__facet-slider__handle--active": n }),
									children: o && B("label", {
										className: (0, GD.default)("ss__facet-slider__handle__label", "ss__facet-slider__handle__label--sticky", `ss__facet-slider__handle__label--${s}`, { "ss__facet-slider__handle__label--pinleft": s == 0 && e == a?.range?.low }, { "ss__facet-slider__handle__label--pinright": s == 1 && e == a?.range?.high }),
										children: sS(a.formatValue, e)
									})
								})
							});
						})
					})
				]
			}), !o && B("div", {
				className: "ss__facet-slider__labels",
				children: C.map(({ value: e }, t) => B("label", {
					className: (0, GD.default)("ss__facet-slider__label", `ss__facet-slider__label--${t}`),
					children: sS(a.formatValue, e)
				}))
			})]
		}) }) : null;
	});
})), XD = o((() => {
	YD();
})), ZD, QD, $D, eO, tO = o((() => {
	H(), ux(), ZD = /* @__PURE__ */ u(X()), Q(), OC(), BC(), R(), GT(), QD = /* @__PURE__ */ u(U()), JS(), tC(), $D = ({ theme: e }) => cx({
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		border: `1px solid ${e?.variables?.colors?.primary || "#ccc"}`,
		"& .ss__icon": { padding: "5px" },
		"& .ss__search-input__input": {
			width: "100%",
			outline: "none",
			border: "0",
			boxSizing: "border-box"
		},
		"& .ss__search-input__button--close-search-button": {
			padding: "0px",
			border: "0px"
		},
		"& .ss__search-input__icons": {
			display: "flex",
			alignItems: "center",
			"& .ss__button": {
				padding: "0px",
				border: "0px"
			}
		}
	}), eO = Z((e) => {
		let t = mi(), n = {
			placeholderText: "Search",
			treePath: RC(),
			submitSearchButton: { icon: "search-thin" },
			clearSearchButton: { icon: "close-thin" }
		}, r = uS("searchInput", t, n, e);
		r.submitSearchButton = {
			...n.submitSearchButton,
			...r.submitSearchButton,
			...e?.submitSearchButton
		}, r.clearSearchButton = {
			...n.clearSearchButton,
			...r.clearSearchButton,
			...e?.clearSearchButton
		}, r.closeSearchButton = {
			...n.closeSearchButton,
			...r.closeSearchButton,
			...e?.closeSearchButton
		};
		let { placeholderText: i, value: a, submitSearchButton: o, closeSearchButton: s, clearSearchButton: c, hideSubmitSearchButton: l, hideClearSearchButton: u, hideCloseSearchButton: d, inputRef: f, inputName: p, onChange: m, onClick: h, onKeyDown: g, onKeyUp: _, disabled: v, disableStyles: y, className: b, internalClassName: x, treePath: S } = r, { overrideElement: C, shouldRenderDefault: w } = QS("searchInput", r);
		if (!w) return C;
		let T, E;
		a === void 0 ? [T, E] = I("") : T = a;
		let D = {
			submitSearchButton: {
				...o,
				internalClassName: "ss__search-input__button--submit-search-button",
				name: "submit-search",
				...$({ disableStyles: y }),
				theme: r?.theme,
				treePath: S
			},
			clearSearchButton: {
				...c,
				internalClassName: "ss__search-input__button--clear-search-button",
				name: "clear-search",
				onClick: (e) => {
					f?.current && ((f?.current).value = "", (f?.current).dispatchEvent(new Event("input", { bubbles: !0 }))), E && E(""), c?.onClick && c.onClick(e);
				},
				...$({ disableStyles: y }),
				theme: r?.theme,
				treePath: S
			},
			closeSearchButton: {
				...s,
				internalClassName: "ss__search-input__button--close-search-button",
				name: "close-search",
				...$({ disableStyles: y }),
				theme: r?.theme,
				treePath: S
			}
		}, O = gS(r, $D), k = (0, QD.default)({
			placeholderText: { attributes: { placeholder: i } },
			closeSearchButton: { attributes: { "aria-label": "Close Search" } },
			clearSearchButton: { attributes: { "aria-label": "Clear Search" } },
			submitSearchButton: { attributes: { "aria-label": "Submit Search" } }
		}, r.lang || {}), A = qS(k, {}, { activeBreakpoint: t?.activeBreakpoint });
		return B(Kx, { children: V("div", {
			...O,
			className: (0, ZD.default)("ss__search-input", { "ss__input--disabled": v }, b, x),
			onClick: (e) => !v && h && h(e),
			children: [
				!d && s && B(UT, {
					...D.closeSearchButton,
					...A.closeSearchButton.all
				}),
				B("input", {
					type: "text",
					className: "ss__search-input__input",
					...A.placeholderText.attributes,
					value: T,
					name: p,
					ref: f,
					onKeyDown: (e) => g && g(e),
					onKeyUp: (e) => _ && _(e),
					onChange: (e) => {
						E && E(e.target.value || ""), m && m(e);
					},
					disabled: v
				}),
				V("div", {
					className: "ss__search-input__icons",
					children: [!u && c && T?.length ? B(UT, {
						...D.clearSearchButton,
						...A.clearSearchButton.all
					}) : null, !l && o && B(UT, {
						...D.submitSearchButton,
						...A.submitSearchButton.all
					})]
				})
			]
		}) });
	});
})), nO = o((() => {
	tO();
})), rO, iO, aO, oO, sO, cO = o((() => {
	H(), R(), ux(), rO = /* @__PURE__ */ u(X()), Q(), vD(), wD(), AD(), ID(), XD(), nO(), PT(), OE(), iT(), OC(), BC(), KS(), tC(), iO = /* @__PURE__ */ u(U()), GT(), Iu(), aO = ({ disableCollapse: e, color: t, theme: n }) => cx({
		width: "100%",
		margin: "0 0 20px 0",
		"& .ss__facet__header": {
			cursor: e ? void 0 : "pointer",
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			color: t || n?.variables?.colors?.primary,
			border: "none",
			borderBottom: `2px solid ${n?.variables?.colors?.primary || "#ccc"}`,
			padding: "6px 0",
			"& .ss__facet__header__inner": { display: "flex" }
		},
		"& .ss__facet__header__clear-all": {
			cursor: "pointer",
			display: "flex",
			alignItems: "center",
			marginLeft: "10px",
			border: "none",
			padding: "0",
			color: t || n?.variables?.colors?.primary,
			"&:hover": { textDecoration: "underline" },
			"& .ss__icon": { marginLeft: "5px" }
		},
		"& .ss__facet__options": {
			marginTop: "8px",
			maxHeight: "300px",
			overflowY: "auto",
			overflowX: "hidden"
		},
		"& .ss__facet__show-more-less": {
			display: "block",
			margin: "8px",
			cursor: "pointer",
			"& .ss__icon": { marginRight: "8px" }
		},
		"& .ss__search-input": {
			margin: "16px 0 0 0",
			".ss__search-input__button--submit-search-button": { pointerEvents: "none" }
		},
		"& .ss__facet__header__selected-count": { margin: "0px 5px" },
		".ss__facet__range-inputs": {
			display: "flex",
			flexDirection: "column",
			".ss__facet__range-inputs__separator": { margin: "5px" }
		},
		".ss__facet__range-inputs__row": {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			"&.ss__facet__range-inputs__row--button-wrapper": {
				justifyContent: "center",
				".ss__facet__range-input__button--submit": { margin: "10px" }
			}
		},
		".ss__facet__range-input": {
			flexDirection: "row",
			display: "flex",
			border: `1px solid ${n?.variables?.colors?.secondary || "#ccc"}`,
			backgroundColor: "white",
			alignItems: "center",
			".ss__facet__range-input__prefix": { padding: "0 5px" },
			".ss__facet__range-input__input": {
				width: "100%",
				border: "none",
				minHeight: "35px"
			}
		}
	}), oO = Z((e) => {
		let t = mi(), n = uS("facet", t, {
			limit: 12,
			disableOverflow: !1,
			iconCollapse: "angle-up",
			iconExpand: "angle-down",
			showMoreText: "Show More",
			showLessText: "Show Less",
			iconOverflowMore: "plus",
			iconOverflowLess: "minus",
			clearAllText: "Clear All",
			rangeInputsSubmitButtonText: "Submit",
			rangeInputsSeparatorText: " - ",
			searchable: !1,
			treePath: RC(),
			name: ju(e.facet.field)
		}, e), r = [
			rT.LIST,
			rT.GRID,
			rT.PALETTE
		], i = () => {
			let e = n.facet?.display;
			return n.displayType && r.includes(e) && r.includes(n.displayType) ? n.displayType : e;
		}, a = i();
		n.display && n.display[a] && (n = {
			...n,
			...n.display[a]
		}), n.fields && n.fields[n.facet?.field] && (n = {
			...n,
			...n.fields[n.facet?.field]
		}), a = i();
		let { disableCollapse: o, facet: s, iconCollapse: c, iconExpand: l, limit: u, statefulOverflow: d, disableOverflow: f, iconColor: p, color: m, previewOnFocus: h, valueProps: g, showSelectedCount: _, hideSelectedCountParenthesis: v, clearAllIcon: y, showClearAllText: b, justContent: x, horizontal: S, disableStyles: C, className: w, internalClassName: T, treePath: E } = n, { overrideElement: D, shouldRenderDefault: O } = QS("facet", n);
		if (!O) return D;
		let k = {
			dropdown: {
				internalClassName: "ss__facet__dropdown",
				disableClickOutside: !0,
				disableOverlay: !0,
				...$({ disableStyles: C }),
				theme: n?.theme,
				treePath: E
			},
			icon: {
				internalClassName: "ss__facet__dropdown__icon",
				size: "12px",
				fill: p || m,
				...$({ disableStyles: C }),
				theme: n?.theme,
				treePath: `${E} dropdown`
			},
			button: {
				...$({ disableStyles: C }),
				theme: n?.theme,
				treePath: `${E} dropdown`
			},
			showMoreLessIcon: {
				internalClassName: "ss__facet__show-more-less__icon",
				size: "10px",
				fill: p || m,
				...$({ disableStyles: C }),
				theme: n?.theme,
				treePath: E
			},
			facetHierarchyOptions: {
				internalClassName: "ss__facet__facet-hierarchy-options",
				...$({
					disableStyles: C,
					previewOnFocus: h,
					valueProps: g,
					horizontal: S
				}),
				theme: n?.theme,
				treePath: E
			},
			facetListOptions: {
				internalClassName: "ss__facet__facet-list-options",
				...$({
					disableStyles: C,
					previewOnFocus: h,
					valueProps: g,
					horizontal: S
				}),
				theme: n?.theme,
				treePath: E
			},
			facetGridOptions: {
				internalClassName: "ss__facet__facet-grid-options",
				...$({
					disableStyles: C,
					previewOnFocus: h,
					valueProps: g,
					horizontal: S
				}),
				theme: n?.theme,
				treePath: E
			},
			facetPaletteOptions: {
				internalClassName: "ss__facet__facet-palette-options",
				...$({
					disableStyles: C,
					previewOnFocus: h,
					valueProps: g,
					horizontal: S
				}),
				theme: n?.theme,
				treePath: E
			},
			facetSlider: {
				internalClassName: "ss__facet__facet-slider",
				...$({ disableStyles: C }),
				theme: n?.theme,
				treePath: E
			},
			searchInput: {
				internalClassName: "ss__facet__search-input",
				clearSearchButton: { onClick: () => {
					s?.search && (s.search.input = "");
				} },
				submitSearchButton: { disableA11y: !0 },
				...$({ disableStyles: C }),
				theme: n?.theme,
				treePath: E
			}
		}, A;
		function j(e) {
			return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
		}
		let [M, ee] = I();
		if (L(() => {
			d && ee({
				enabled: !1,
				limited: !0,
				limit: 0,
				remaining: void 0,
				setLimit: function(e) {
					e != this.limit && (this.enabled = !0, this.limit = e, this.calculate());
				},
				toggle: function(e) {
					this.limited = e === void 0 ? !this.limited : e, this.calculate();
				},
				calculate: function() {
					if (this.limit > 0) {
						let e = s?.values?.length - this.limit;
						e > 0 && !s?.search?.input ? (this.enabled = !0, this.remaining = this.limited ? e : 0) : this.enabled = !1;
					}
					ee({ ...this });
				}
			});
		}, []), s?.overflow && u && Number.isInteger(u) && !f) {
			if (d) {
				let e = s?.values || [];
				if (s?.search?.input) {
					let t = new RegExp(j(s?.search?.input), "i");
					e = s?.values.filter((e) => String(e?.label || "").match(t));
				}
				M?.enabled && M?.limited && (e = e.slice(0, M?.limit)), M?.limit !== u && M?.setLimit(u), A = e;
			} else s.overflow?.setLimit(u), A = s?.refinedValues;
		} else A = s?.overflow && Number.isInteger(u) ? s?.values.slice(0, u) : s?.values;
		let te = gS(n, aO), ne = {
			allowableTypes: e.treePath?.includes("autocomplete") ? [] : [
				"list",
				"grid",
				"palette"
			],
			searchFilter: (e) => {
				s?.search && (s.search.input = e.target.value);
			}
		}, re = !0;
		s.display == rT.TOGGLE && s && s?.values.length !== 1 && (re = !1);
		let ie = {
			limitedValues: A,
			overflowState: M,
			searchableFacet: ne,
			subProps: k,
			className: w,
			internalClassName: T,
			...n,
			displayType: a
		}, ae = {
			showMoreText: { value: ie.showMoreText },
			showLessText: { value: ie.showLessText },
			dropdownButton: { attributes: { "aria-label": `currently ${s?.collapsed ? "collapsed" : "open"} ${s.label} facet dropdown ${s.values?.length ? s.values?.length + " options" : ""}` } },
			clearAllText: { value: ie.clearAllText },
			submitRangeButton: { value: ie.rangeInputsSubmitButtonText }
		}, oe = (0, iO.default)(ae, n.lang || {}), se = qS(oe, { facet: s }, { activeBreakpoint: t?.activeBreakpoint }), ce = s?.values?.filter((e) => e?.filtered).length || s?.active?.high !== s?.range?.high || s?.active?.low !== s?.range?.low;
		return s && re ? B(Kx, { children: B("div", {
			...te,
			className: (0, rO.default)("ss__facet", `ss__facet--${s.field}`, `${s.collapsed ? "ss__facet--collapsed" : ""}`, w, T, `${a ? `ss__facet--${a}` : ""}`, (d ? M?.remaining : (s?.overflow?.remaining || 0) > 0) || s?.display == "slider" ? "" : "ss__facet--showing-all"),
			children: x ? B(sO, {
				...ie,
				mergedLang: se
			}) : B(EE, {
				...k.dropdown,
				open: o || !s?.collapsed,
				onClick: () => !o && s.toggleCollapse && s?.toggleCollapse(),
				disableA11y: !0,
				button: V("div", {
					className: "ss__facet__header",
					ref: (e) => VS(e, o ? -1 : 0),
					role: "heading",
					"aria-level": 3,
					...se.dropdownButton.attributes,
					children: [V("span", {
						className: "ss__facet__header__inner",
						children: [
							B("span", {
								...se.dropdownButton.value,
								children: s?.label
							}),
							_ && ce && s.type !== "range" ? B("span", {
								className: "ss__facet__header__selected-count",
								children: v ? ce : `(${ce})`
							}) : null,
							(se.clearAllText.value || y) && ce ? B(UT, {
								...k.button,
								internalClassName: "ss__facet__header__clear-all",
								name: "reset-facet",
								onClick: (e) => {
									e.stopPropagation(), s?.clear.url.link.onClick();
								},
								icon: y || void 0,
								children: se.clearAllText.value && b ? B("label", { ...se.clearAllText.all }) : null
							}) : B(xi, {})
						]
					}), !o && B(KC, {
						...k.icon,
						...s?.collapsed ? { ...typeof l == "string" ? { icon: l } : l } : { ...typeof c == "string" ? { icon: c } : c },
						name: s?.collapsed ? "expand" : "collapse"
					})]
				}),
				children: B(sO, {
					...ie,
					mergedLang: se
				})
			})
		}) }) : null;
	}), sO = (e) => {
		let { searchableFacet: t, subProps: n, className: r, internalClassName: i, limitedValues: a, facet: o, statefulOverflow: s, limit: c, overflowSlot: l, optionsSlot: u, searchable: d, iconOverflowMore: f, iconOverflowLess: p, disableOverflow: m, previewOnFocus: h, rangeInputs: g, rangeInputsPrefix: _, rangeInputsInheritDefaultValues: v, rangeInputsSeparatorText: y, rangeInputsSubmitOnBlur: b, hideRangeInputsSubmitButton: x, justContent: S, valueProps: C, hideShowMoreLessText: w, treePath: T, mergedLang: E, displayType: D } = e, [O, k] = I(v && o.type === "range" ? o?.range?.low : void 0), [A, j] = I(v && o.type === "range" ? o?.range?.high : void 0);
		L(() => {
			v && o.type === "range" && o?.active?.high !== A && j(o?.active?.high), v && o.type === "range" && o?.active?.low !== O && k(o?.active?.low);
		}, [o]);
		let M = (e) => {
			k(e[0]), j(e[1]);
		}, ee = () => {
			if (o?.services?.urlManager && typeof O == "number" && Number.isFinite(O) && typeof A == "number" && Number.isFinite(A)) {
				let e = O, t = A;
				t < e && (e = A, t = O, k(e), j(t)), o?.range?.low !== void 0 && e < o?.range?.low && (e = o?.range?.low, k(e)), o?.range?.high !== void 0 && e > o?.range?.high && (e = o?.range?.high, k(e)), o?.range?.low !== void 0 && t < o?.range?.low && (t = o?.range?.low, j(t)), o?.range?.high !== void 0 && t > o?.range?.high && (t = o?.range?.high, j(t)), o.services.urlManager.remove("page").set(`filter.${o.field}`, {
					low: e,
					high: t
				}).go();
			}
		}, te = (e) => {
			e.key === "Enter" && ee();
		}, ne = () => {
			b && ee();
		}, re;
		return re = s ? e.overflowState : o.overflow, V(xi, { children: [
			d && t.allowableTypes.includes(D) && B(eO, {
				...n.searchInput,
				onChange: t.searchFilter,
				placeholderText: `Search ${o.label}`,
				treePath: T
			}),
			B("div", {
				className: (0, rO.default)("ss__facet__options", S ? r : "", S ? i : ""),
				children: (() => {
					if (u) return nS(u, {
						facet: o,
						valueProps: C,
						limit: c,
						previewOnFocus: h,
						treePath: T
					});
					switch (D) {
						case rT.SLIDER: return B(JD, {
							...n.facetSlider,
							onChange: M,
							facet: o,
							treePath: T
						});
						case rT.GRID: return B(SD, {
							...n.facetGridOptions,
							values: a,
							facet: o,
							treePath: T
						});
						case rT.PALETTE: return B(OD, {
							...n.facetPaletteOptions,
							values: a,
							facet: o,
							treePath: T
						});
						case rT.HIERARCHY: return B(PD, {
							...n.facetHierarchyOptions,
							values: a,
							facet: o,
							treePath: T
						});
						default: return B(gD, {
							...n.facetListOptions,
							values: a,
							facet: o,
							treePath: T
						});
					}
				})()
			}),
			g && (o.type === "range" || o.type === "range-buckets") && V("div", {
				className: "ss__facet__range-inputs",
				children: [V("div", {
					className: "ss__facet__range-inputs__row",
					children: [
						V("div", {
							className: "ss__facet__range-input ss__facet__range-input--low",
							children: [_ && B("span", {
								className: "ss__facet__range-input__prefix",
								children: _
							}), B("input", {
								type: "number",
								className: "ss__facet__range-input__input",
								value: O,
								onInput: (e) => e.currentTarget.value ? k(Number(e.currentTarget.value)) : k(void 0),
								onKeyUp: te,
								onBlur: ne
							})]
						}),
						B("span", {
							className: "ss__facet__range-inputs__separator",
							children: y
						}),
						V("div", {
							className: "ss__facet__range-input ss__facet__range-input--high",
							children: [_ && B("span", {
								className: "ss__facet__range-input__prefix",
								children: _
							}), B("input", {
								type: "number",
								className: "ss__facet__range-input__input",
								value: A,
								onInput: (e) => e.currentTarget.value ? j(Number(e.currentTarget.value)) : j(void 0),
								onKeyUp: te,
								onBlur: ne
							})]
						})
					]
				}), !x && B("div", {
					className: "ss__facet__range-inputs__row ss__facet__range-inputs__row--button-wrapper",
					children: B(UT, {
						internalClassName: "ss__facet__range-input__button--submit",
						onClick: ee,
						children: E.submitRangeButton.value ? B("label", { ...E.submitRangeButton.all }) : null
					})
				})]
			}),
			!m && re?.enabled && B("div", {
				className: "ss__facet__show-more-less",
				"aria-live": "polite",
				onClick: () => re?.toggle(),
				ref: (e) => VS(e),
				children: l ? nS(l, {
					facet: o,
					treePath: T
				}) : V(xi, { children: [B(KC, {
					...n.showMoreLessIcon,
					treePath: T,
					name: (re?.remaining || 0) > 0 ? "overflow-more" : "overflow-less",
					...(re?.remaining || 0) > 0 ? { ...typeof f == "string" ? { icon: f } : f } : { ...typeof p == "string" ? { icon: p } : p }
				}), !w && B("span", { ...(re?.remaining || 0) > 0 ? E.showMoreText?.all : E.showLessText?.all })] })
			})
		] });
	};
})), lO = o((() => {
	cO();
})), uO = o((() => {
	X(), U(), Q();
})), dO = o((() => {
	uO();
})), fO = o((() => {
	Q(), X(), U();
})), pO = o((() => {
	Q(), X();
})), mO = o((() => {
	pO();
})), hO = o((() => {
	fO();
})), gO = o((() => {
	X(), Q();
})), _O = o((() => {
	gO();
})), vO = o((() => {
	R(), Q(), X();
})), yO = o((() => {
	vO();
})), bO = o((() => {
	Q(), X(), U();
})), xO = o((() => {
	bO();
})), SO = o((() => {
	X(), Q(), U();
})), CO = o((() => {
	SO();
})), wO = o((() => {
	Q(), X(), U();
})), TO = o((() => {
	wO();
})), EO = o((() => {
	R(), X(), Q(), U();
})), DO = o((() => {
	EO();
})), OO = o((() => {
	R(), Q(), X(), U();
})), kO = o((() => {
	OO();
})), AO = o((() => {
	X(), Q(), ln(), U();
})), jO = o((() => {
	AO();
})), MO = o((() => {
	Q(), X(), U();
})), NO = o((() => {
	MO();
})), PO = o((() => {
	Q(), X(), U();
})), FO = o((() => {
	PO();
})), IO = o((() => {
	Q(), X(), U();
})), LO = o((() => {
	IO();
})), RO = o((() => {
	Q(), X(), U();
})), zO = o((() => {
	Q(), X(), U();
})), BO = o((() => {
	X(), Q();
})), VO = o((() => {
	BO();
})), HO = o((() => {
	X(), Q(), U();
})), UO = o((() => {
	HO();
})), WO = o((() => {
	X(), Q(), U();
})), GO = o((() => {
	WO();
})), KO = o((() => {
	R(), X(), Q(), U();
})), qO = o((() => {
	KO();
})), JO = o((() => {
	R(), X(), Q();
})), YO = o((() => {
	JO();
})), XO = o((() => {
	X(), Q();
})), ZO = o((() => {
	XO();
})), QO = o((() => {
	Q(), X(), U();
})), $O = o((() => {
	QO();
})), ek = o((() => {
	R(), Q(), X(), U();
})), tk = o((() => {
	Q();
})), nk = o((() => {
	tk();
})), rk = o((() => {
	ek();
})), ik = o((() => {
	Q();
})), ak = o((() => {
	ik();
}));
//#endregion
//#region node_modules/swiper/shared/ssr-window.esm.mjs
function ok(e) {
	return typeof e == "object" && !!e && "constructor" in e && e.constructor === Object;
}
function sk(e, t) {
	e === void 0 && (e = {}), t === void 0 && (t = {}), Object.keys(t).forEach((n) => {
		e[n] === void 0 ? e[n] = t[n] : ok(t[n]) && ok(e[n]) && Object.keys(t[n]).length > 0 && sk(e[n], t[n]);
	});
}
function ck() {
	let e = typeof document < "u" ? document : {};
	return sk(e, uk), e;
}
function lk() {
	let e = typeof window < "u" ? window : {};
	return sk(e, dk), e;
}
var uk, dk, fk = o((() => {
	uk = {
		body: {},
		addEventListener() {},
		removeEventListener() {},
		activeElement: {
			blur() {},
			nodeName: ""
		},
		querySelector() {
			return null;
		},
		querySelectorAll() {
			return [];
		},
		getElementById() {
			return null;
		},
		createEvent() {
			return { initEvent() {} };
		},
		createElement() {
			return {
				children: [],
				childNodes: [],
				style: {},
				setAttribute() {},
				getElementsByTagName() {
					return [];
				}
			};
		},
		createElementNS() {
			return {};
		},
		importNode() {
			return null;
		},
		location: {
			hash: "",
			host: "",
			hostname: "",
			href: "",
			origin: "",
			pathname: "",
			protocol: "",
			search: ""
		}
	}, dk = {
		document: uk,
		navigator: { userAgent: "" },
		location: {
			hash: "",
			host: "",
			hostname: "",
			href: "",
			origin: "",
			pathname: "",
			protocol: "",
			search: ""
		},
		history: {
			replaceState() {},
			pushState() {},
			go() {},
			back() {}
		},
		CustomEvent: function() {
			return this;
		},
		addEventListener() {},
		removeEventListener() {},
		getComputedStyle() {
			return { getPropertyValue() {
				return "";
			} };
		},
		Image() {},
		Date() {},
		screen: {},
		setTimeout() {},
		clearTimeout() {},
		matchMedia() {
			return {};
		},
		requestAnimationFrame(e) {
			return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
		},
		cancelAnimationFrame(e) {
			typeof setTimeout > "u" || clearTimeout(e);
		}
	};
}));
//#endregion
//#region node_modules/swiper/shared/utils.mjs
function pk(e) {
	return e === void 0 && (e = ""), e.trim().split(" ").filter((e) => !!e.trim());
}
function mk(e) {
	let t = e;
	Object.keys(t).forEach((e) => {
		try {
			t[e] = null;
		} catch {}
		try {
			delete t[e];
		} catch {}
	});
}
function hk(e, t) {
	return t === void 0 && (t = 0), setTimeout(e, t);
}
function gk() {
	return Date.now();
}
function _k(e) {
	let t = lk(), n;
	return t.getComputedStyle && (n = t.getComputedStyle(e, null)), !n && e.currentStyle && (n = e.currentStyle), n ||= e.style, n;
}
function vk(e, t) {
	t === void 0 && (t = "x");
	let n = lk(), r, i, a, o = _k(e);
	return n.WebKitCSSMatrix ? (i = o.transform || o.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((e) => e.replace(",", ".")).join(", ")), a = new n.WebKitCSSMatrix(i === "none" ? "" : i)) : (a = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = a.toString().split(",")), t === "x" && (i = n.WebKitCSSMatrix ? a.m41 : r.length === 16 ? parseFloat(r[12]) : parseFloat(r[4])), t === "y" && (i = n.WebKitCSSMatrix ? a.m42 : r.length === 16 ? parseFloat(r[13]) : parseFloat(r[5])), i || 0;
}
function yk(e) {
	return typeof e == "object" && !!e && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function bk(e) {
	return typeof window < "u" && window.HTMLElement !== void 0 ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function xk() {
	let e = Object(arguments.length <= 0 ? void 0 : arguments[0]), t = [
		"__proto__",
		"constructor",
		"prototype"
	];
	for (let n = 1; n < arguments.length; n += 1) {
		let r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
		if (r != null && !bk(r)) {
			let n = Object.keys(Object(r)).filter((e) => t.indexOf(e) < 0);
			for (let t = 0, i = n.length; t < i; t += 1) {
				let i = n[t], a = Object.getOwnPropertyDescriptor(r, i);
				a !== void 0 && a.enumerable && (yk(e[i]) && yk(r[i]) ? r[i].__swiper__ ? e[i] = r[i] : xk(e[i], r[i]) : !yk(e[i]) && yk(r[i]) ? (e[i] = {}, r[i].__swiper__ ? e[i] = r[i] : xk(e[i], r[i])) : e[i] = r[i]);
			}
		}
	}
	return e;
}
function Sk(e, t, n) {
	e.style.setProperty(t, n);
}
function Ck(e) {
	let { swiper: t, targetPosition: n, side: r } = e, i = lk(), a = -t.translate, o = null, s, c = t.params.speed;
	t.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(t.cssModeFrameID);
	let l = n > a ? "next" : "prev", u = (e, t) => l === "next" && e >= t || l === "prev" && e <= t, d = () => {
		s = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = s);
		let e = Math.max(Math.min((s - o) / c, 1), 0), l = .5 - Math.cos(e * Math.PI) / 2, f = a + l * (n - a);
		if (u(f, n) && (f = n), t.wrapperEl.scrollTo({ [r]: f }), u(f, n)) {
			t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
				t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({ [r]: f });
			}), i.cancelAnimationFrame(t.cssModeFrameID);
			return;
		}
		t.cssModeFrameID = i.requestAnimationFrame(d);
	};
	d();
}
function wk(e, t) {
	return t === void 0 && (t = ""), [...e.children].filter((e) => e.matches(t));
}
function Tk(e) {
	try {
		console.warn(e);
		return;
	} catch {}
}
function Ek(e, t) {
	t === void 0 && (t = []);
	let n = document.createElement(e);
	return n.classList.add(...Array.isArray(t) ? t : pk(t)), n;
}
function Dk(e, t) {
	let n = [];
	for (; e.previousElementSibling;) {
		let r = e.previousElementSibling;
		t ? r.matches(t) && n.push(r) : n.push(r), e = r;
	}
	return n;
}
function Ok(e, t) {
	let n = [];
	for (; e.nextElementSibling;) {
		let r = e.nextElementSibling;
		t ? r.matches(t) && n.push(r) : n.push(r), e = r;
	}
	return n;
}
function kk(e, t) {
	return lk().getComputedStyle(e, null).getPropertyValue(t);
}
function Ak(e) {
	let t = e, n;
	if (t) {
		for (n = 0; (t = t.previousSibling) !== null;) t.nodeType === 1 && (n += 1);
		return n;
	}
}
function jk(e, t) {
	let n = [], r = e.parentElement;
	for (; r;) t ? r.matches(t) && n.push(r) : n.push(r), r = r.parentElement;
	return n;
}
function Mk(e, t, n) {
	let r = lk();
	return n ? e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom")) : e.offsetWidth;
}
var Nk = o((() => {
	fk();
}));
//#endregion
//#region node_modules/swiper/shared/swiper-core.mjs
function Pk() {
	let e = lk(), t = ck();
	return {
		smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style,
		touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch)
	};
}
function Fk() {
	return RA ||= Pk(), RA;
}
function Ik(e) {
	let { userAgent: t } = e === void 0 ? {} : e, n = Fk(), r = lk(), i = r.navigator.platform, a = t || r.navigator.userAgent, o = {
		ios: !1,
		android: !1
	}, s = r.screen.width, c = r.screen.height, l = a.match(/(Android);?[\s\/]+([\d.]+)?/), u = a.match(/(iPad).*OS\s([\d_]+)/), d = a.match(/(iPod)(.*OS\s([\d_]+))?/), f = !u && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), p = i === "Win32", m = i === "MacIntel";
	return !u && m && n.touch && [
		"1024x1366",
		"1366x1024",
		"834x1194",
		"1194x834",
		"834x1112",
		"1112x834",
		"768x1024",
		"1024x768",
		"820x1180",
		"1180x820",
		"810x1080",
		"1080x810"
	].indexOf(`${s}x${c}`) >= 0 && (u = a.match(/(Version)\/([\d.]+)/), u ||= [
		0,
		1,
		"13_0_0"
	], m = !1), l && !p && (o.os = "android", o.android = !0), (u || f || d) && (o.os = "ios", o.ios = !0), o;
}
function Lk(e) {
	return e === void 0 && (e = {}), zA ||= Ik(e), zA;
}
function Rk() {
	let e = lk(), t = Lk(), n = !1;
	function r() {
		let t = e.navigator.userAgent.toLowerCase();
		return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
	}
	if (r()) {
		let t = String(e.navigator.userAgent);
		if (t.includes("Version/")) {
			let [e, r] = t.split("Version/")[1].split(" ")[0].split(".").map((e) => Number(e));
			n = e < 16 || e === 16 && r < 2;
		}
	}
	let i = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), a = r(), o = a || i && t.ios;
	return {
		isSafari: n || a,
		needPerspectiveFix: n,
		need3dFix: o,
		isWebView: i
	};
}
function zk() {
	return BA ||= Rk(), BA;
}
function Bk(e) {
	let { swiper: t, on: n, emit: r } = e, i = lk(), a = null, o = null, s = () => {
		!t || t.destroyed || !t.initialized || (r("beforeResize"), r("resize"));
	}, c = () => {
		!t || t.destroyed || !t.initialized || (a = new ResizeObserver((e) => {
			o = i.requestAnimationFrame(() => {
				let { width: n, height: r } = t, i = n, a = r;
				e.forEach((e) => {
					let { contentBoxSize: n, contentRect: r, target: o } = e;
					o && o !== t.el || (i = r ? r.width : (n[0] || n).inlineSize, a = r ? r.height : (n[0] || n).blockSize);
				}), (i !== n || a !== r) && s();
			});
		}), a.observe(t.el));
	}, l = () => {
		o && i.cancelAnimationFrame(o), a && a.unobserve && t.el && (a.unobserve(t.el), a = null);
	}, u = () => {
		!t || t.destroyed || !t.initialized || r("orientationchange");
	};
	n("init", () => {
		if (t.params.resizeObserver && i.ResizeObserver !== void 0) {
			c();
			return;
		}
		i.addEventListener("resize", s), i.addEventListener("orientationchange", u);
	}), n("destroy", () => {
		l(), i.removeEventListener("resize", s), i.removeEventListener("orientationchange", u);
	});
}
function Vk(e) {
	let { swiper: t, extendParams: n, on: r, emit: i } = e, a = [], o = lk(), s = function(e, n) {
		n === void 0 && (n = {});
		let r = new (o.MutationObserver || o.WebkitMutationObserver)((e) => {
			if (t.__preventObserver__) return;
			if (e.length === 1) {
				i("observerUpdate", e[0]);
				return;
			}
			let n = function() {
				i("observerUpdate", e[0]);
			};
			o.requestAnimationFrame ? o.requestAnimationFrame(n) : o.setTimeout(n, 0);
		});
		r.observe(e, {
			attributes: n.attributes === void 0 || n.attributes,
			childList: n.childList === void 0 || n.childList,
			characterData: n.characterData === void 0 || n.characterData
		}), a.push(r);
	};
	n({
		observer: !1,
		observeParents: !1,
		observeSlideChildren: !1
	}), r("init", () => {
		if (t.params.observer) {
			if (t.params.observeParents) {
				let e = jk(t.hostEl);
				for (let t = 0; t < e.length; t += 1) s(e[t]);
			}
			s(t.hostEl, { childList: t.params.observeSlideChildren }), s(t.wrapperEl, { attributes: !1 });
		}
	}), r("destroy", () => {
		a.forEach((e) => {
			e.disconnect();
		}), a.splice(0, a.length);
	});
}
function Hk() {
	let e = this, t, n, r = e.el;
	t = e.params.width !== void 0 && e.params.width !== null ? e.params.width : r.clientWidth, n = e.params.height !== void 0 && e.params.height !== null ? e.params.height : r.clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt(kk(r, "padding-left") || 0, 10) - parseInt(kk(r, "padding-right") || 0, 10), n = n - parseInt(kk(r, "padding-top") || 0, 10) - parseInt(kk(r, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
		width: t,
		height: n,
		size: e.isHorizontal() ? t : n
	}));
}
function Uk() {
	let e = this;
	function t(t, n) {
		return parseFloat(t.getPropertyValue(e.getDirectionLabel(n)) || 0);
	}
	let n = e.params, { wrapperEl: r, slidesEl: i, size: a, rtlTranslate: o, wrongRTL: s } = e, c = e.virtual && n.virtual.enabled, l = c ? e.virtual.slides.length : e.slides.length, u = wk(i, `.${e.params.slideClass}, swiper-slide`), d = c ? e.virtual.slides.length : u.length, f = [], p = [], m = [], h = n.slidesOffsetBefore;
	typeof h == "function" && (h = n.slidesOffsetBefore.call(e));
	let g = n.slidesOffsetAfter;
	typeof g == "function" && (g = n.slidesOffsetAfter.call(e));
	let _ = e.snapGrid.length, v = e.slidesGrid.length, y = n.spaceBetween, b = -h, x = 0, S = 0;
	if (a === void 0) return;
	typeof y == "string" && y.indexOf("%") >= 0 ? y = parseFloat(y.replace("%", "")) / 100 * a : typeof y == "string" && (y = parseFloat(y)), e.virtualSize = -y, u.forEach((e) => {
		o ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = "";
	}), n.centeredSlides && n.cssMode && (Sk(r, "--swiper-centered-offset-before", ""), Sk(r, "--swiper-centered-offset-after", ""));
	let C = n.grid && n.grid.rows > 1 && e.grid;
	C ? e.grid.initSlides(u) : e.grid && e.grid.unsetSlides();
	let w, T = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((e) => n.breakpoints[e].slidesPerView !== void 0).length > 0;
	for (let r = 0; r < d; r += 1) {
		w = 0;
		let i;
		if (u[r] && (i = u[r]), C && e.grid.updateSlide(r, i, u), !(u[r] && kk(i, "display") === "none")) {
			if (n.slidesPerView === "auto") {
				T && (u[r].style[e.getDirectionLabel("width")] = "");
				let a = getComputedStyle(i), o = i.style.transform, s = i.style.webkitTransform;
				if (o && (i.style.transform = "none"), s && (i.style.webkitTransform = "none"), n.roundLengths) w = e.isHorizontal() ? Mk(i, "width", !0) : Mk(i, "height", !0);
				else {
					let e = t(a, "width"), n = t(a, "padding-left"), r = t(a, "padding-right"), o = t(a, "margin-left"), s = t(a, "margin-right"), c = a.getPropertyValue("box-sizing");
					if (c && c === "border-box") w = e + o + s;
					else {
						let { clientWidth: t, offsetWidth: a } = i;
						w = e + n + r + o + s + (a - t);
					}
				}
				o && (i.style.transform = o), s && (i.style.webkitTransform = s), n.roundLengths && (w = Math.floor(w));
			} else w = (a - (n.slidesPerView - 1) * y) / n.slidesPerView, n.roundLengths && (w = Math.floor(w)), u[r] && (u[r].style[e.getDirectionLabel("width")] = `${w}px`);
			u[r] && (u[r].swiperSlideSize = w), m.push(w), n.centeredSlides ? (b = b + w / 2 + x / 2 + y, x === 0 && r !== 0 && (b = b - a / 2 - y), r === 0 && (b = b - a / 2 - y), Math.abs(b) < 1 / 1e3 && (b = 0), n.roundLengths && (b = Math.floor(b)), S % n.slidesPerGroup === 0 && f.push(b), p.push(b)) : (n.roundLengths && (b = Math.floor(b)), (S - Math.min(e.params.slidesPerGroupSkip, S)) % e.params.slidesPerGroup === 0 && f.push(b), p.push(b), b = b + w + y), e.virtualSize += w + y, x = w, S += 1;
		}
	}
	if (e.virtualSize = Math.max(e.virtualSize, a) + g, o && s && (n.effect === "slide" || n.effect === "coverflow") && (r.style.width = `${e.virtualSize + y}px`), n.setWrapperSize && (r.style[e.getDirectionLabel("width")] = `${e.virtualSize + y}px`), C && e.grid.updateWrapperSize(w, f), !n.centeredSlides) {
		let t = [];
		for (let r = 0; r < f.length; r += 1) {
			let i = f[r];
			n.roundLengths && (i = Math.floor(i)), f[r] <= e.virtualSize - a && t.push(i);
		}
		f = t, Math.floor(e.virtualSize - a) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - a);
	}
	if (c && n.loop) {
		let t = m[0] + y;
		if (n.slidesPerGroup > 1) {
			let r = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / n.slidesPerGroup), i = t * n.slidesPerGroup;
			for (let e = 0; e < r; e += 1) f.push(f[f.length - 1] + i);
		}
		for (let r = 0; r < e.virtual.slidesBefore + e.virtual.slidesAfter; r += 1) n.slidesPerGroup === 1 && f.push(f[f.length - 1] + t), p.push(p[p.length - 1] + t), e.virtualSize += t;
	}
	if (f.length === 0 && (f = [0]), y !== 0) {
		let t = e.isHorizontal() && o ? "marginLeft" : e.getDirectionLabel("marginRight");
		u.filter((e, t) => !n.cssMode || n.loop ? !0 : t !== u.length - 1).forEach((e) => {
			e.style[t] = `${y}px`;
		});
	}
	if (n.centeredSlides && n.centeredSlidesBounds) {
		let e = 0;
		m.forEach((t) => {
			e += t + (y || 0);
		}), e -= y;
		let t = e - a;
		f = f.map((e) => e <= 0 ? -h : e > t ? t + g : e);
	}
	if (n.centerInsufficientSlides) {
		let e = 0;
		if (m.forEach((t) => {
			e += t + (y || 0);
		}), e -= y, e < a) {
			let t = (a - e) / 2;
			f.forEach((e, n) => {
				f[n] = e - t;
			}), p.forEach((e, n) => {
				p[n] = e + t;
			});
		}
	}
	if (Object.assign(e, {
		slides: u,
		snapGrid: f,
		slidesGrid: p,
		slidesSizesGrid: m
	}), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
		Sk(r, "--swiper-centered-offset-before", `${-f[0]}px`), Sk(r, "--swiper-centered-offset-after", `${e.size / 2 - m[m.length - 1] / 2}px`);
		let t = -e.snapGrid[0], n = -e.slidesGrid[0];
		e.snapGrid = e.snapGrid.map((e) => e + t), e.slidesGrid = e.slidesGrid.map((e) => e + n);
	}
	if (d !== l && e.emit("slidesLengthChange"), f.length !== _ && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), p.length !== v && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !c && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
		let t = `${n.containerModifierClass}backface-hidden`, r = e.el.classList.contains(t);
		d <= n.maxBackfaceHiddenSlides ? r || e.el.classList.add(t) : r && e.el.classList.remove(t);
	}
}
function Wk(e) {
	let t = this, n = [], r = t.virtual && t.params.virtual.enabled, i = 0, a;
	typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
	let o = (e) => r ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
	if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1) {
		if (t.params.centeredSlides) (t.visibleSlides || []).forEach((e) => {
			n.push(e);
		});
		else for (a = 0; a < Math.ceil(t.params.slidesPerView); a += 1) {
			let e = t.activeIndex + a;
			if (e > t.slides.length && !r) break;
			n.push(o(e));
		}
	} else n.push(o(t.activeIndex));
	for (a = 0; a < n.length; a += 1) if (n[a] !== void 0) {
		let e = n[a].offsetHeight;
		i = e > i ? e : i;
	}
	(i || i === 0) && (t.wrapperEl.style.height = `${i}px`);
}
function Gk() {
	let e = this, t = e.slides, n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
	for (let r = 0; r < t.length; r += 1) t[r].swiperSlideOffset = (e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop) - n - e.cssOverflowAdjustment();
}
function Kk(e) {
	e === void 0 && (e = this && this.translate || 0);
	let t = this, n = t.params, { slides: r, rtlTranslate: i, snapGrid: a } = t;
	if (r.length === 0) return;
	r[0].swiperSlideOffset === void 0 && t.updateSlidesOffset();
	let o = -e;
	i && (o = e), r.forEach((e) => {
		e.classList.remove(n.slideVisibleClass, n.slideFullyVisibleClass);
	}), t.visibleSlidesIndexes = [], t.visibleSlides = [];
	let s = n.spaceBetween;
	typeof s == "string" && s.indexOf("%") >= 0 ? s = parseFloat(s.replace("%", "")) / 100 * t.size : typeof s == "string" && (s = parseFloat(s));
	for (let e = 0; e < r.length; e += 1) {
		let c = r[e], l = c.swiperSlideOffset;
		n.cssMode && n.centeredSlides && (l -= r[0].swiperSlideOffset);
		let u = (o + (n.centeredSlides ? t.minTranslate() : 0) - l) / (c.swiperSlideSize + s), d = (o - a[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) / (c.swiperSlideSize + s), f = -(o - l), p = f + t.slidesSizesGrid[e], m = f >= 0 && f <= t.size - t.slidesSizesGrid[e];
		(f >= 0 && f < t.size - 1 || p > 1 && p <= t.size || f <= 0 && p >= t.size) && (t.visibleSlides.push(c), t.visibleSlidesIndexes.push(e), r[e].classList.add(n.slideVisibleClass)), m && r[e].classList.add(n.slideFullyVisibleClass), c.progress = i ? -u : u, c.originalProgress = i ? -d : d;
	}
}
function qk(e) {
	let t = this;
	if (e === void 0) {
		let n = t.rtlTranslate ? -1 : 1;
		e = t && t.translate && t.translate * n || 0;
	}
	let n = t.params, r = t.maxTranslate() - t.minTranslate(), { progress: i, isBeginning: a, isEnd: o, progressLoop: s } = t, c = a, l = o;
	if (r === 0) i = 0, a = !0, o = !0;
	else {
		i = (e - t.minTranslate()) / r;
		let n = Math.abs(e - t.minTranslate()) < 1, s = Math.abs(e - t.maxTranslate()) < 1;
		a = n || i <= 0, o = s || i >= 1, n && (i = 0), s && (i = 1);
	}
	if (n.loop) {
		let n = t.getSlideIndexByData(0), r = t.getSlideIndexByData(t.slides.length - 1), i = t.slidesGrid[n], a = t.slidesGrid[r], o = t.slidesGrid[t.slidesGrid.length - 1], c = Math.abs(e);
		s = c >= i ? (c - i) / o : (c + o - a) / o, s > 1 && --s;
	}
	Object.assign(t, {
		progress: i,
		progressLoop: s,
		isBeginning: a,
		isEnd: o
	}), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), a && !c && t.emit("reachBeginning toEdge"), o && !l && t.emit("reachEnd toEdge"), (c && !a || l && !o) && t.emit("fromEdge"), t.emit("progress", i);
}
function Jk() {
	let e = this, { slides: t, params: n, slidesEl: r, activeIndex: i } = e, a = e.virtual && n.virtual.enabled, o = e.grid && n.grid && n.grid.rows > 1, s = (e) => wk(r, `.${n.slideClass}${e}, swiper-slide${e}`)[0];
	t.forEach((e) => {
		e.classList.remove(n.slideActiveClass, n.slideNextClass, n.slidePrevClass);
	});
	let c, l, u;
	if (a) {
		if (n.loop) {
			let t = i - e.virtual.slidesBefore;
			t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), c = s(`[data-swiper-slide-index="${t}"]`);
		} else c = s(`[data-swiper-slide-index="${i}"]`);
	} else o ? (c = t.filter((e) => e.column === i)[0], u = t.filter((e) => e.column === i + 1)[0], l = t.filter((e) => e.column === i - 1)[0]) : c = t[i];
	c && (c.classList.add(n.slideActiveClass), o ? (u && u.classList.add(n.slideNextClass), l && l.classList.add(n.slidePrevClass)) : (u = Ok(c, `.${n.slideClass}, swiper-slide`)[0], n.loop && !u && (u = t[0]), u && u.classList.add(n.slideNextClass), l = Dk(c, `.${n.slideClass}, swiper-slide`)[0], n.loop, l && l.classList.add(n.slidePrevClass))), e.emitSlidesClasses();
}
function Yk(e) {
	let { slidesGrid: t, params: n } = e, r = e.rtlTranslate ? e.translate : -e.translate, i;
	for (let e = 0; e < t.length; e += 1) t[e + 1] === void 0 ? r >= t[e] && (i = e) : r >= t[e] && r < t[e + 1] - (t[e + 1] - t[e]) / 2 ? i = e : r >= t[e] && r < t[e + 1] && (i = e + 1);
	return n.normalizeSlideIndex && (i < 0 || i === void 0) && (i = 0), i;
}
function Xk(e) {
	let t = this, n = t.rtlTranslate ? t.translate : -t.translate, { snapGrid: r, params: i, activeIndex: a, realIndex: o, snapIndex: s } = t, c = e, l, u = (e) => {
		let n = e - t.virtual.slidesBefore;
		return n < 0 && (n = t.virtual.slides.length + n), n >= t.virtual.slides.length && (n -= t.virtual.slides.length), n;
	};
	if (c === void 0 && (c = Yk(t)), r.indexOf(n) >= 0) l = r.indexOf(n);
	else {
		let e = Math.min(i.slidesPerGroupSkip, c);
		l = e + Math.floor((c - e) / i.slidesPerGroup);
	}
	if (l >= r.length && (l = r.length - 1), c === a && !t.params.loop) {
		l !== s && (t.snapIndex = l, t.emit("snapIndexChange"));
		return;
	}
	if (c === a && t.params.loop && t.virtual && t.params.virtual.enabled) {
		t.realIndex = u(c);
		return;
	}
	let d = t.grid && i.grid && i.grid.rows > 1, f;
	if (t.virtual && i.virtual.enabled && i.loop) f = u(c);
	else if (d) {
		let e = t.slides.filter((e) => e.column === c)[0], n = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
		Number.isNaN(n) && (n = Math.max(t.slides.indexOf(e), 0)), f = Math.floor(n / i.grid.rows);
	} else if (t.slides[c]) {
		let e = t.slides[c].getAttribute("data-swiper-slide-index");
		f = e ? parseInt(e, 10) : c;
	} else f = c;
	Object.assign(t, {
		previousSnapIndex: s,
		snapIndex: l,
		previousRealIndex: o,
		realIndex: f,
		previousIndex: a,
		activeIndex: c
	}), t.initialized && WA(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (o !== f && t.emit("realIndexChange"), t.emit("slideChange"));
}
function Zk(e, t) {
	let n = this, r = n.params, i = e.closest(`.${r.slideClass}, swiper-slide`);
	!i && n.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
		!i && e.matches && e.matches(`.${r.slideClass}, swiper-slide`) && (i = e);
	});
	let a = !1, o;
	if (i) {
		for (let e = 0; e < n.slides.length; e += 1) if (n.slides[e] === i) {
			a = !0, o = e;
			break;
		}
	}
	if (i && a) n.clickedSlide = i, n.clickedIndex = n.virtual && n.params.virtual.enabled ? parseInt(i.getAttribute("data-swiper-slide-index"), 10) : o;
	else {
		n.clickedSlide = void 0, n.clickedIndex = void 0;
		return;
	}
	r.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
function Qk(e) {
	e === void 0 && (e = this.isHorizontal() ? "x" : "y");
	let t = this, { params: n, rtlTranslate: r, translate: i, wrapperEl: a } = t;
	if (n.virtualTranslate) return r ? -i : i;
	if (n.cssMode) return i;
	let o = vk(a, e);
	return o += t.cssOverflowAdjustment(), r && (o = -o), o || 0;
}
function $k(e, t) {
	let n = this, { rtlTranslate: r, params: i, wrapperEl: a, progress: o } = n, s = 0, c = 0;
	n.isHorizontal() ? s = r ? -e : e : c = e, i.roundLengths && (s = Math.floor(s), c = Math.floor(c)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? s : c, i.cssMode ? a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -s : -c : i.virtualTranslate || (n.isHorizontal() ? s -= n.cssOverflowAdjustment() : c -= n.cssOverflowAdjustment(), a.style.transform = `translate3d(${s}px, ${c}px, 0px)`);
	let l, u = n.maxTranslate() - n.minTranslate();
	l = u === 0 ? 0 : (e - n.minTranslate()) / u, l !== o && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function eA() {
	return -this.snapGrid[0];
}
function tA() {
	return -this.snapGrid[this.snapGrid.length - 1];
}
function nA(e, t, n, r, i) {
	e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), r === void 0 && (r = !0);
	let a = this, { params: o, wrapperEl: s } = a;
	if (a.animating && o.preventInteractionOnTransition) return !1;
	let c = a.minTranslate(), l = a.maxTranslate(), u;
	if (u = r && e > c ? c : r && e < l ? l : e, a.updateProgress(u), o.cssMode) {
		let e = a.isHorizontal();
		if (t === 0) s[e ? "scrollLeft" : "scrollTop"] = -u;
		else {
			if (!a.support.smoothScroll) return Ck({
				swiper: a,
				targetPosition: -u,
				side: e ? "left" : "top"
			}), !0;
			s.scrollTo({
				[e ? "left" : "top"]: -u,
				behavior: "smooth"
			});
		}
		return !0;
	}
	return t === 0 ? (a.setTransition(0), a.setTranslate(u), n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionEnd"))) : (a.setTransition(t), a.setTranslate(u), n && (a.emit("beforeTransitionStart", t, i), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd ||= function(e) {
		!a || a.destroyed || e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, n && a.emit("transitionEnd"));
	}, a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
}
function rA(e, t) {
	let n = this;
	n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`, n.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), n.emit("setTransition", e, t);
}
function iA(e) {
	let { swiper: t, runCallbacks: n, direction: r, step: i } = e, { activeIndex: a, previousIndex: o } = t, s = r;
	if (s ||= a > o ? "next" : a < o ? "prev" : "reset", t.emit(`transition${i}`), n && a !== o) {
		if (s === "reset") {
			t.emit(`slideResetTransition${i}`);
			return;
		}
		t.emit(`slideChangeTransition${i}`), s === "next" ? t.emit(`slideNextTransition${i}`) : t.emit(`slidePrevTransition${i}`);
	}
}
function aA(e, t) {
	e === void 0 && (e = !0);
	let n = this, { params: r } = n;
	r.cssMode || (r.autoHeight && n.updateAutoHeight(), iA({
		swiper: n,
		runCallbacks: e,
		direction: t,
		step: "Start"
	}));
}
function oA(e, t) {
	e === void 0 && (e = !0);
	let n = this, { params: r } = n;
	n.animating = !1, !r.cssMode && (n.setTransition(0), iA({
		swiper: n,
		runCallbacks: e,
		direction: t,
		step: "End"
	}));
}
function sA(e, t, n, r, i) {
	e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
	let a = this, o = e;
	o < 0 && (o = 0);
	let { params: s, snapGrid: c, slidesGrid: l, previousIndex: u, activeIndex: d, rtlTranslate: f, wrapperEl: p, enabled: m } = a;
	if (a.animating && s.preventInteractionOnTransition || !m && !r && !i || a.destroyed) return !1;
	let h = Math.min(a.params.slidesPerGroupSkip, o), g = h + Math.floor((o - h) / a.params.slidesPerGroup);
	g >= c.length && (g = c.length - 1);
	let _ = -c[g];
	if (s.normalizeSlideIndex) for (let e = 0; e < l.length; e += 1) {
		let t = -Math.floor(_ * 100), n = Math.floor(l[e] * 100), r = Math.floor(l[e + 1] * 100);
		l[e + 1] === void 0 ? t >= n && (o = e) : t >= n && t < r - (r - n) / 2 ? o = e : t >= n && t < r && (o = e + 1);
	}
	if (a.initialized && o !== d && (!a.allowSlideNext && (f ? _ > a.translate && _ > a.minTranslate() : _ < a.translate && _ < a.minTranslate()) || !a.allowSlidePrev && _ > a.translate && _ > a.maxTranslate() && (d || 0) !== o)) return !1;
	o !== (u || 0) && n && a.emit("beforeSlideChangeStart"), a.updateProgress(_);
	let v;
	if (v = o > d ? "next" : o < d ? "prev" : "reset", f && -_ === a.translate || !f && _ === a.translate) return a.updateActiveIndex(o), s.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), s.effect !== "slide" && a.setTranslate(_), v !== "reset" && (a.transitionStart(n, v), a.transitionEnd(n, v)), !1;
	if (s.cssMode) {
		let e = a.isHorizontal(), n = f ? _ : -_;
		if (t === 0) {
			let t = a.virtual && a.params.virtual.enabled;
			t && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), t && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
				p[e ? "scrollLeft" : "scrollTop"] = n;
			})) : p[e ? "scrollLeft" : "scrollTop"] = n, t && requestAnimationFrame(() => {
				a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
			});
		} else {
			if (!a.support.smoothScroll) return Ck({
				swiper: a,
				targetPosition: n,
				side: e ? "left" : "top"
			}), !0;
			p.scrollTo({
				[e ? "left" : "top"]: n,
				behavior: "smooth"
			});
		}
		return !0;
	}
	return a.setTransition(t), a.setTranslate(_), a.updateActiveIndex(o), a.updateSlidesClasses(), a.emit("beforeTransitionStart", t, r), a.transitionStart(n, v), t === 0 ? a.transitionEnd(n, v) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd ||= function(e) {
		!a || a.destroyed || e.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(n, v));
	}, a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
}
function cA(e, t, n, r) {
	e === void 0 && (e = 0), t === void 0 && (t = this.params.speed), n === void 0 && (n = !0), typeof e == "string" && (e = parseInt(e, 10));
	let i = this;
	if (i.destroyed) return;
	let a = i.grid && i.params.grid && i.params.grid.rows > 1, o = e;
	if (i.params.loop) {
		if (i.virtual && i.params.virtual.enabled) o += i.virtual.slidesBefore;
		else {
			let e;
			if (a) {
				let t = o * i.params.grid.rows;
				e = i.slides.filter((e) => e.getAttribute("data-swiper-slide-index") * 1 === t)[0].column;
			} else e = i.getSlideIndexByData(o);
			let t = a ? Math.ceil(i.slides.length / i.params.grid.rows) : i.slides.length, { centeredSlides: n } = i.params, r = i.params.slidesPerView;
			r === "auto" ? r = i.slidesPerViewDynamic() : (r = Math.ceil(parseFloat(i.params.slidesPerView, 10)), n && r % 2 == 0 && (r += 1));
			let s = t - e < r;
			if (n && (s ||= e < Math.ceil(r / 2)), s) {
				let r = n ? e < i.activeIndex ? "prev" : "next" : e - i.activeIndex - 1 < i.params.slidesPerView ? "next" : "prev";
				i.loopFix({
					direction: r,
					slideTo: !0,
					activeSlideIndex: r === "next" ? e + 1 : e - t + 1,
					slideRealIndex: r === "next" ? i.realIndex : void 0
				});
			}
			if (a) {
				let e = o * i.params.grid.rows;
				o = i.slides.filter((t) => t.getAttribute("data-swiper-slide-index") * 1 === e)[0].column;
			} else o = i.getSlideIndexByData(o);
		}
	}
	return requestAnimationFrame(() => {
		i.slideTo(o, t, n, r);
	}), i;
}
function lA(e, t, n) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
	let r = this, { enabled: i, params: a, animating: o } = r;
	if (!i || r.destroyed) return r;
	let s = a.slidesPerGroup;
	a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (s = Math.max(r.slidesPerViewDynamic("current", !0), 1));
	let c = r.activeIndex < a.slidesPerGroupSkip ? 1 : s, l = r.virtual && a.virtual.enabled;
	if (a.loop) {
		if (o && !l && a.loopPreventsSliding) return !1;
		if (r.loopFix({ direction: "next" }), r._clientLeft = r.wrapperEl.clientLeft, r.activeIndex === r.slides.length - 1 && a.cssMode) return requestAnimationFrame(() => {
			r.slideTo(r.activeIndex + c, e, t, n);
		}), !0;
	}
	return a.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + c, e, t, n);
}
function uA(e, t, n) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
	let r = this, { params: i, snapGrid: a, slidesGrid: o, rtlTranslate: s, enabled: c, animating: l } = r;
	if (!c || r.destroyed) return r;
	let u = r.virtual && i.virtual.enabled;
	if (i.loop) {
		if (l && !u && i.loopPreventsSliding) return !1;
		r.loopFix({ direction: "prev" }), r._clientLeft = r.wrapperEl.clientLeft;
	}
	let d = s ? r.translate : -r.translate;
	function f(e) {
		return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
	}
	let p = f(d), m = a[a.map((e) => f(e)).indexOf(p) - 1];
	if (m === void 0 && i.cssMode) {
		let e;
		a.forEach((t, n) => {
			p >= t && (e = n);
		}), e !== void 0 && (m = a[e > 0 ? e - 1 : e]);
	}
	let h = 0;
	if (m !== void 0 && (h = o.indexOf(m), h < 0 && (h = r.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (h = h - r.slidesPerViewDynamic("previous", !0) + 1, h = Math.max(h, 0))), i.rewind && r.isBeginning) {
		let i = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
		return r.slideTo(i, e, t, n);
	}
	return i.loop && r.activeIndex === 0 && i.cssMode ? (requestAnimationFrame(() => {
		r.slideTo(h, e, t, n);
	}), !0) : r.slideTo(h, e, t, n);
}
function dA(e, t, n) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0);
	let r = this;
	if (!r.destroyed) return r.slideTo(r.activeIndex, e, t, n);
}
function fA(e, t, n, r) {
	e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), r === void 0 && (r = .5);
	let i = this;
	if (i.destroyed) return;
	let a = i.activeIndex, o = Math.min(i.params.slidesPerGroupSkip, a), s = o + Math.floor((a - o) / i.params.slidesPerGroup), c = i.rtlTranslate ? i.translate : -i.translate;
	if (c >= i.snapGrid[s]) {
		let e = i.snapGrid[s], t = i.snapGrid[s + 1];
		c - e > (t - e) * r && (a += i.params.slidesPerGroup);
	} else {
		let e = i.snapGrid[s - 1], t = i.snapGrid[s];
		c - e <= (t - e) * r && (a -= i.params.slidesPerGroup);
	}
	return a = Math.max(a, 0), a = Math.min(a, i.slidesGrid.length - 1), i.slideTo(a, e, t, n);
}
function pA() {
	let e = this;
	if (e.destroyed) return;
	let { params: t, slidesEl: n } = e, r = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView, i = e.clickedIndex, a, o = e.isElement ? "swiper-slide" : `.${t.slideClass}`;
	if (t.loop) {
		if (e.animating) return;
		a = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? i < e.loopedSlides - r / 2 || i > e.slides.length - e.loopedSlides + r / 2 ? (e.loopFix(), i = e.getSlideIndex(wk(n, `${o}[data-swiper-slide-index="${a}"]`)[0]), hk(() => {
			e.slideTo(i);
		})) : e.slideTo(i) : i > e.slides.length - r ? (e.loopFix(), i = e.getSlideIndex(wk(n, `${o}[data-swiper-slide-index="${a}"]`)[0]), hk(() => {
			e.slideTo(i);
		})) : e.slideTo(i);
	} else e.slideTo(i);
}
function mA(e) {
	let t = this, { params: n, slidesEl: r } = t;
	if (!n.loop || t.virtual && t.params.virtual.enabled) return;
	let i = () => {
		wk(r, `.${n.slideClass}, swiper-slide`).forEach((e, t) => {
			e.setAttribute("data-swiper-slide-index", t);
		});
	}, a = t.grid && n.grid && n.grid.rows > 1, o = n.slidesPerGroup * (a ? n.grid.rows : 1), s = t.slides.length % o !== 0, c = a && t.slides.length % n.grid.rows !== 0, l = (e) => {
		for (let r = 0; r < e; r += 1) {
			let e = t.isElement ? Ek("swiper-slide", [n.slideBlankClass]) : Ek("div", [n.slideClass, n.slideBlankClass]);
			t.slidesEl.append(e);
		}
	};
	s ? (n.loopAddBlankSlides ? (l(o - t.slides.length % o), t.recalcSlides(), t.updateSlides()) : Tk("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"), i()) : (c && (n.loopAddBlankSlides ? (l(n.grid.rows - t.slides.length % n.grid.rows), t.recalcSlides(), t.updateSlides()) : Tk("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)")), i()), t.loopFix({
		slideRealIndex: e,
		direction: n.centeredSlides ? void 0 : "next"
	});
}
function hA(e) {
	let { slideRealIndex: t, slideTo: n = !0, direction: r, setTranslate: i, activeSlideIndex: a, byController: o, byMousewheel: s } = e === void 0 ? {} : e, c = this;
	if (!c.params.loop) return;
	c.emit("beforeLoopFix");
	let { slides: l, allowSlidePrev: u, allowSlideNext: d, slidesEl: f, params: p } = c, { centeredSlides: m } = p;
	if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && p.virtual.enabled) {
		n && (!p.centeredSlides && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : p.centeredSlides && c.snapIndex < p.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = u, c.allowSlideNext = d, c.emit("loopFix");
		return;
	}
	let h = p.slidesPerView;
	h === "auto" ? h = c.slidesPerViewDynamic() : (h = Math.ceil(parseFloat(p.slidesPerView, 10)), m && h % 2 == 0 && (h += 1));
	let g = p.slidesPerGroupAuto ? h : p.slidesPerGroup, _ = g;
	_ % g !== 0 && (_ += g - _ % g), _ += p.loopAdditionalSlides, c.loopedSlides = _;
	let v = c.grid && p.grid && p.grid.rows > 1;
	l.length < h + _ ? Tk("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : v && p.grid.fill === "row" && Tk("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
	let y = [], b = [], x = c.activeIndex;
	a === void 0 ? a = c.getSlideIndex(l.filter((e) => e.classList.contains(p.slideActiveClass))[0]) : x = a;
	let S = r === "next" || !r, C = r === "prev" || !r, w = 0, T = 0, E = v ? Math.ceil(l.length / p.grid.rows) : l.length, D = (v ? l[a].column : a) + (m && i === void 0 ? -h / 2 + .5 : 0);
	if (D < _) {
		w = Math.max(_ - D, g);
		for (let e = 0; e < _ - D; e += 1) {
			let t = e - Math.floor(e / E) * E;
			if (v) {
				let e = E - t - 1;
				for (let t = l.length - 1; t >= 0; --t) l[t].column === e && y.push(t);
			} else y.push(E - t - 1);
		}
	} else if (D + h > E - _) {
		T = Math.max(D - (E - _ * 2), g);
		for (let e = 0; e < T; e += 1) {
			let t = e - Math.floor(e / E) * E;
			v ? l.forEach((e, n) => {
				e.column === t && b.push(n);
			}) : b.push(t);
		}
	}
	if (c.__preventObserver__ = !0, requestAnimationFrame(() => {
		c.__preventObserver__ = !1;
	}), C && y.forEach((e) => {
		l[e].swiperLoopMoveDOM = !0, f.prepend(l[e]), l[e].swiperLoopMoveDOM = !1;
	}), S && b.forEach((e) => {
		l[e].swiperLoopMoveDOM = !0, f.append(l[e]), l[e].swiperLoopMoveDOM = !1;
	}), c.recalcSlides(), p.slidesPerView === "auto" ? c.updateSlides() : v && (y.length > 0 && C || b.length > 0 && S) && c.slides.forEach((e, t) => {
		c.grid.updateSlide(t, e, c.slides);
	}), p.watchSlidesProgress && c.updateSlidesOffset(), n) {
		if (y.length > 0 && C) {
			if (t === void 0) {
				let e = c.slidesGrid[x], t = c.slidesGrid[x + w] - e;
				s ? c.setTranslate(c.translate - t) : (c.slideTo(x + Math.ceil(w), 0, !1, !0), i && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t));
			} else if (i) {
				let e = v ? y.length / p.grid.rows : y.length;
				c.slideTo(c.activeIndex + e, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
			}
		} else if (b.length > 0 && S) {
			if (t === void 0) {
				let e = c.slidesGrid[x], t = c.slidesGrid[x - T] - e;
				s ? c.setTranslate(c.translate - t) : (c.slideTo(x - T, 0, !1, !0), i && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t));
			} else {
				let e = v ? b.length / p.grid.rows : b.length;
				c.slideTo(c.activeIndex - e, 0, !1, !0);
			}
		}
	}
	if (c.allowSlidePrev = u, c.allowSlideNext = d, c.controller && c.controller.control && !o) {
		let e = {
			slideRealIndex: t,
			direction: r,
			setTranslate: i,
			activeSlideIndex: a,
			byController: !0
		};
		Array.isArray(c.controller.control) ? c.controller.control.forEach((t) => {
			!t.destroyed && t.params.loop && t.loopFix({
				...e,
				slideTo: t.params.slidesPerView === p.slidesPerView && n
			});
		}) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
			...e,
			slideTo: c.controller.control.params.slidesPerView === p.slidesPerView && n
		});
	}
	c.emit("loopFix");
}
function gA() {
	let e = this, { params: t, slidesEl: n } = e;
	if (!t.loop || e.virtual && e.params.virtual.enabled) return;
	e.recalcSlides();
	let r = [];
	e.slides.forEach((e) => {
		let t = e.swiperSlideIndex === void 0 ? e.getAttribute("data-swiper-slide-index") * 1 : e.swiperSlideIndex;
		r[t] = e;
	}), e.slides.forEach((e) => {
		e.removeAttribute("data-swiper-slide-index");
	}), r.forEach((e) => {
		n.append(e);
	}), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
function _A(e) {
	let t = this;
	if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
	let n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
	t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
		t.__preventObserver__ = !1;
	});
}
function vA() {
	let e = this;
	e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
		e.__preventObserver__ = !1;
	}));
}
function yA(e, t) {
	t === void 0 && (t = this);
	function n(t) {
		if (!t || t === ck() || t === lk()) return null;
		t.assignedSlot && (t = t.assignedSlot);
		let r = t.closest(e);
		return !r && !t.getRootNode ? null : r || n(t.getRootNode().host);
	}
	return n(t);
}
function bA(e, t, n) {
	let r = lk(), { params: i } = e, a = i.edgeSwipeDetection, o = i.edgeSwipeThreshold;
	return a && (n <= o || n >= r.innerWidth - o) ? a === "prevent" && (t.preventDefault(), !0) : !0;
}
function xA(e) {
	let t = this, n = ck(), r = e;
	r.originalEvent && (r = r.originalEvent);
	let i = t.touchEventsData;
	if (r.type === "pointerdown") {
		if (i.pointerId !== null && i.pointerId !== r.pointerId) return;
		i.pointerId = r.pointerId;
	} else r.type === "touchstart" && r.targetTouches.length === 1 && (i.touchId = r.targetTouches[0].identifier);
	if (r.type === "touchstart") {
		bA(t, r, r.targetTouches[0].pageX);
		return;
	}
	let { params: a, touches: o, enabled: s } = t;
	if (!s || !a.simulateTouch && r.pointerType === "mouse" || t.animating && a.preventInteractionOnTransition) return;
	!t.animating && a.cssMode && a.loop && t.loopFix();
	let c = r.target;
	if (a.touchEventsTarget === "wrapper" && !t.wrapperEl.contains(c) || "which" in r && r.which === 3 || "button" in r && r.button > 0 || i.isTouched && i.isMoved) return;
	let l = !!a.noSwipingClass && a.noSwipingClass !== "", u = r.composedPath ? r.composedPath() : r.path;
	l && r.target && r.target.shadowRoot && u && (c = u[0]);
	let d = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`, f = !!(r.target && r.target.shadowRoot);
	if (a.noSwiping && (f ? yA(d, c) : c.closest(d))) {
		t.allowClick = !0;
		return;
	}
	if (a.swipeHandler && !c.closest(a.swipeHandler)) return;
	o.currentX = r.pageX, o.currentY = r.pageY;
	let p = o.currentX, m = o.currentY;
	if (!bA(t, r, p)) return;
	Object.assign(i, {
		isTouched: !0,
		isMoved: !1,
		allowTouchCallbacks: !0,
		isScrolling: void 0,
		startMoving: void 0
	}), o.startX = p, o.startY = m, i.touchStartTime = gk(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, a.threshold > 0 && (i.allowThresholdMove = !1);
	let h = !0;
	c.matches(i.focusableElements) && (h = !1, c.nodeName === "SELECT" && (i.isTouched = !1)), n.activeElement && n.activeElement.matches(i.focusableElements) && n.activeElement !== c && n.activeElement.blur();
	let g = h && t.allowTouchMove && a.touchStartPreventDefault;
	(a.touchStartForcePreventDefault || g) && !c.isContentEditable && r.preventDefault(), a.freeMode && a.freeMode.enabled && t.freeMode && t.animating && !a.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", r);
}
function SA(e) {
	let t = ck(), n = this, r = n.touchEventsData, { params: i, touches: a, rtlTranslate: o, enabled: s } = n;
	if (!s || !i.simulateTouch && e.pointerType === "mouse") return;
	let c = e;
	if (c.originalEvent && (c = c.originalEvent), c.type === "pointermove" && (r.touchId !== null || c.pointerId !== r.pointerId)) return;
	let l;
	if (c.type === "touchmove") {
		if (l = [...c.changedTouches].filter((e) => e.identifier === r.touchId)[0], !l || l.identifier !== r.touchId) return;
	} else l = c;
	if (!r.isTouched) {
		r.startMoving && r.isScrolling && n.emit("touchMoveOpposite", c);
		return;
	}
	let u = l.pageX, d = l.pageY;
	if (c.preventedByNestedSwiper) {
		a.startX = u, a.startY = d;
		return;
	}
	if (!n.allowTouchMove) {
		c.target.matches(r.focusableElements) || (n.allowClick = !1), r.isTouched && (Object.assign(a, {
			startX: u,
			startY: d,
			currentX: u,
			currentY: d
		}), r.touchStartTime = gk());
		return;
	}
	if (i.touchReleaseOnEdges && !i.loop) {
		if (n.isVertical()) {
			if (d < a.startY && n.translate <= n.maxTranslate() || d > a.startY && n.translate >= n.minTranslate()) {
				r.isTouched = !1, r.isMoved = !1;
				return;
			}
		} else if (u < a.startX && n.translate <= n.maxTranslate() || u > a.startX && n.translate >= n.minTranslate()) return;
	}
	if (t.activeElement && c.target === t.activeElement && c.target.matches(r.focusableElements)) {
		r.isMoved = !0, n.allowClick = !1;
		return;
	}
	r.allowTouchCallbacks && n.emit("touchMove", c), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = u, a.currentY = d;
	let f = a.currentX - a.startX, p = a.currentY - a.startY;
	if (n.params.threshold && Math.sqrt(f ** 2 + p ** 2) < n.params.threshold) return;
	if (r.isScrolling === void 0) {
		let e;
		n.isHorizontal() && a.currentY === a.startY || n.isVertical() && a.currentX === a.startX ? r.isScrolling = !1 : f * f + p * p >= 25 && (e = Math.atan2(Math.abs(p), Math.abs(f)) * 180 / Math.PI, r.isScrolling = n.isHorizontal() ? e > i.touchAngle : 90 - e > i.touchAngle);
	}
	if (r.isScrolling && n.emit("touchMoveOpposite", c), r.startMoving === void 0 && (a.currentX !== a.startX || a.currentY !== a.startY) && (r.startMoving = !0), r.isScrolling) {
		r.isTouched = !1;
		return;
	}
	if (!r.startMoving) return;
	n.allowClick = !1, !i.cssMode && c.cancelable && c.preventDefault(), i.touchMoveStopPropagation && !i.nested && c.stopPropagation();
	let m = n.isHorizontal() ? f : p, h = n.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
	i.oneWayMovement && (m = Math.abs(m) * (o ? 1 : -1), h = Math.abs(h) * (o ? 1 : -1)), a.diff = m, m *= i.touchRatio, o && (m = -m, h = -h);
	let g = n.touchesDirection;
	n.swipeDirection = m > 0 ? "prev" : "next", n.touchesDirection = h > 0 ? "prev" : "next";
	let _ = n.params.loop && !i.cssMode, v = n.touchesDirection === "next" && n.allowSlideNext || n.touchesDirection === "prev" && n.allowSlidePrev;
	if (!r.isMoved) {
		if (_ && v && n.loopFix({ direction: n.swipeDirection }), r.startTranslate = n.getTranslate(), n.setTransition(0), n.animating) {
			let e = new window.CustomEvent("transitionend", {
				bubbles: !0,
				cancelable: !0
			});
			n.wrapperEl.dispatchEvent(e);
		}
		r.allowMomentumBounce = !1, i.grabCursor && (n.allowSlideNext === !0 || n.allowSlidePrev === !0) && n.setGrabCursor(!0), n.emit("sliderFirstMove", c);
	}
	if ((/* @__PURE__ */ new Date()).getTime(), r.isMoved && r.allowThresholdMove && g !== n.touchesDirection && _ && v && Math.abs(m) >= 1) {
		Object.assign(a, {
			startX: u,
			startY: d,
			currentX: u,
			currentY: d,
			startTranslate: r.currentTranslate
		}), r.loopSwapReset = !0, r.startTranslate = r.currentTranslate;
		return;
	}
	n.emit("sliderMove", c), r.isMoved = !0, r.currentTranslate = m + r.startTranslate;
	let y = !0, b = i.resistanceRatio;
	if (i.touchReleaseOnEdges && (b = 0), m > 0 ? (_ && v && r.allowThresholdMove && r.currentTranslate > (i.centeredSlides ? n.minTranslate() - n.slidesSizesGrid[n.activeIndex + 1] : n.minTranslate()) && n.loopFix({
		direction: "prev",
		setTranslate: !0,
		activeSlideIndex: 0
	}), r.currentTranslate > n.minTranslate() && (y = !1, i.resistance && (r.currentTranslate = n.minTranslate() - 1 + (-n.minTranslate() + r.startTranslate + m) ** b))) : m < 0 && (_ && v && r.allowThresholdMove && r.currentTranslate < (i.centeredSlides ? n.maxTranslate() + n.slidesSizesGrid[n.slidesSizesGrid.length - 1] : n.maxTranslate()) && n.loopFix({
		direction: "next",
		setTranslate: !0,
		activeSlideIndex: n.slides.length - (i.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
	}), r.currentTranslate < n.maxTranslate() && (y = !1, i.resistance && (r.currentTranslate = n.maxTranslate() + 1 - (n.maxTranslate() - r.startTranslate - m) ** b))), y && (c.preventedByNestedSwiper = !0), !n.allowSlideNext && n.swipeDirection === "next" && r.currentTranslate < r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && n.swipeDirection === "prev" && r.currentTranslate > r.startTranslate && (r.currentTranslate = r.startTranslate), !n.allowSlidePrev && !n.allowSlideNext && (r.currentTranslate = r.startTranslate), i.threshold > 0) {
		if (Math.abs(m) > i.threshold || r.allowThresholdMove) {
			if (!r.allowThresholdMove) {
				r.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, r.currentTranslate = r.startTranslate, a.diff = n.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
				return;
			}
		} else {
			r.currentTranslate = r.startTranslate;
			return;
		}
	}
	!i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && n.freeMode || i.watchSlidesProgress) && (n.updateActiveIndex(), n.updateSlidesClasses()), i.freeMode && i.freeMode.enabled && n.freeMode && n.freeMode.onTouchMove(), n.updateProgress(r.currentTranslate), n.setTranslate(r.currentTranslate));
}
function CA(e) {
	let t = this, n = t.touchEventsData, r = e;
	r.originalEvent && (r = r.originalEvent);
	let i;
	if (r.type !== "touchend" && r.type !== "touchcancel") {
		if (n.touchId !== null || r.pointerId !== n.pointerId) return;
		i = r;
	} else if (i = [...r.changedTouches].filter((e) => e.identifier === n.touchId)[0], !i || i.identifier !== n.touchId) return;
	if ([
		"pointercancel",
		"pointerout",
		"pointerleave",
		"contextmenu"
	].includes(r.type) && !(["pointercancel", "contextmenu"].includes(r.type) && (t.browser.isSafari || t.browser.isWebView))) return;
	n.pointerId = null, n.touchId = null;
	let { params: a, touches: o, rtlTranslate: s, slidesGrid: c, enabled: l } = t;
	if (!l || !a.simulateTouch && r.pointerType === "mouse") return;
	if (n.allowTouchCallbacks && t.emit("touchEnd", r), n.allowTouchCallbacks = !1, !n.isTouched) {
		n.isMoved && a.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
		return;
	}
	a.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
	let u = gk(), d = u - n.touchStartTime;
	if (t.allowClick) {
		let e = r.path || r.composedPath && r.composedPath();
		t.updateClickedSlide(e && e[0] || r.target, e), t.emit("tap click", r), d < 300 && u - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", r);
	}
	if (n.lastClickTime = gk(), hk(() => {
		t.destroyed || (t.allowClick = !0);
	}), !n.isTouched || !n.isMoved || !t.swipeDirection || o.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
		n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
		return;
	}
	n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
	let f;
	if (f = a.followFinger ? s ? t.translate : -t.translate : -n.currentTranslate, a.cssMode) return;
	if (a.freeMode && a.freeMode.enabled) {
		t.freeMode.onTouchEnd({ currentPos: f });
		return;
	}
	let p = f >= -t.maxTranslate() && !t.params.loop, m = 0, h = t.slidesSizesGrid[0];
	for (let e = 0; e < c.length; e += e < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
		let t = e < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
		c[e + t] === void 0 ? (p || f >= c[e]) && (m = e, h = c[c.length - 1] - c[c.length - 2]) : (p || f >= c[e] && f < c[e + t]) && (m = e, h = c[e + t] - c[e]);
	}
	let g = null, _ = null;
	a.rewind && (t.isBeginning ? _ = a.virtual && a.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (g = 0));
	let v = (f - c[m]) / h, y = m < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
	if (d > a.longSwipesMs) {
		if (!a.longSwipes) {
			t.slideTo(t.activeIndex);
			return;
		}
		t.swipeDirection === "next" && (v >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? g : m + y) : t.slideTo(m)), t.swipeDirection === "prev" && (v > 1 - a.longSwipesRatio ? t.slideTo(m + y) : _ !== null && v < 0 && Math.abs(v) > a.longSwipesRatio ? t.slideTo(_) : t.slideTo(m));
	} else {
		if (!a.shortSwipes) {
			t.slideTo(t.activeIndex);
			return;
		}
		t.navigation && (r.target === t.navigation.nextEl || r.target === t.navigation.prevEl) ? r.target === t.navigation.nextEl ? t.slideTo(m + y) : t.slideTo(m) : (t.swipeDirection === "next" && t.slideTo(g === null ? m + y : g), t.swipeDirection === "prev" && t.slideTo(_ === null ? m : _));
	}
}
function wA() {
	let e = this, { params: t, el: n } = e;
	if (n && n.offsetWidth === 0) return;
	t.breakpoints && e.setBreakpoint();
	let { allowSlideNext: r, allowSlidePrev: i, snapGrid: a } = e, o = e.virtual && e.params.virtual.enabled;
	e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
	let s = o && t.loop;
	(t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !s ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.params.loop && !o ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
		e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
	}, 500)), e.allowSlidePrev = i, e.allowSlideNext = r, e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
}
function TA(e) {
	let t = this;
	t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function EA() {
	let e = this, { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
	if (!r) return;
	e.previousTranslate = e.translate, e.translate = e.isHorizontal() ? -t.scrollLeft : -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
	let i, a = e.maxTranslate() - e.minTranslate();
	i = a === 0 ? 0 : (e.translate - e.minTranslate()) / a, i !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function DA(e) {
	let t = this;
	HA(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function OA() {
	let e = this;
	e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
function kA() {
	let e = this, { params: t } = e;
	e.onTouchStart = xA.bind(e), e.onTouchMove = SA.bind(e), e.onTouchEnd = CA.bind(e), e.onDocumentTouchStart = OA.bind(e), t.cssMode && (e.onScroll = EA.bind(e)), e.onClick = TA.bind(e), e.onLoad = DA.bind(e), ZA(e, "on");
}
function AA() {
	let e = this;
	ZA(e, "off");
}
function jA() {
	let e = this, { realIndex: t, initialized: n, params: r, el: i } = e, a = r.breakpoints;
	if (!a || a && Object.keys(a).length === 0) return;
	let o = e.getBreakpoint(a, e.params.breakpointsBase, e.el);
	if (!o || e.currentBreakpoint === o) return;
	let s = (o in a ? a[o] : void 0) || e.originalParams, c = $A(e, r), l = $A(e, s), u = r.enabled;
	c && !l ? (i.classList.remove(`${r.containerModifierClass}grid`, `${r.containerModifierClass}grid-column`), e.emitContainerClasses()) : !c && l && (i.classList.add(`${r.containerModifierClass}grid`), (s.grid.fill && s.grid.fill === "column" || !s.grid.fill && r.grid.fill === "column") && i.classList.add(`${r.containerModifierClass}grid-column`), e.emitContainerClasses()), [
		"navigation",
		"pagination",
		"scrollbar"
	].forEach((t) => {
		if (s[t] === void 0) return;
		let n = r[t] && r[t].enabled, i = s[t] && s[t].enabled;
		n && !i && e[t].disable(), !n && i && e[t].enable();
	});
	let d = s.direction && s.direction !== r.direction, f = r.loop && (s.slidesPerView !== r.slidesPerView || d), p = r.loop;
	d && n && e.changeDirection(), xk(e.params, s);
	let m = e.params.enabled, h = e.params.loop;
	Object.assign(e, {
		allowTouchMove: e.params.allowTouchMove,
		allowSlideNext: e.params.allowSlideNext,
		allowSlidePrev: e.params.allowSlidePrev
	}), u && !m ? e.disable() : !u && m && e.enable(), e.currentBreakpoint = o, e.emit("_beforeBreakpoint", s), n && (f ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !p && h ? (e.loopCreate(t), e.updateSlides()) : p && !h && e.loopDestroy()), e.emit("breakpoint", s);
}
function MA(e, t, n) {
	if (t === void 0 && (t = "window"), !e || t === "container" && !n) return;
	let r = !1, i = lk(), a = t === "window" ? i.innerHeight : n.clientHeight, o = Object.keys(e).map((e) => {
		if (typeof e == "string" && e.indexOf("@") === 0) {
			let t = parseFloat(e.substr(1));
			return {
				value: a * t,
				point: e
			};
		}
		return {
			value: e,
			point: e
		};
	});
	o.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
	for (let e = 0; e < o.length; e += 1) {
		let { point: a, value: s } = o[e];
		t === "window" ? i.matchMedia(`(min-width: ${s}px)`).matches && (r = a) : s <= n.clientWidth && (r = a);
	}
	return r || "max";
}
function NA(e, t) {
	let n = [];
	return e.forEach((e) => {
		typeof e == "object" ? Object.keys(e).forEach((r) => {
			e[r] && n.push(t + r);
		}) : typeof e == "string" && n.push(t + e);
	}), n;
}
function PA() {
	let e = this, { classNames: t, params: n, rtl: r, el: i, device: a } = e, o = NA([
		"initialized",
		n.direction,
		{ "free-mode": e.params.freeMode && n.freeMode.enabled },
		{ autoheight: n.autoHeight },
		{ rtl: r },
		{ grid: n.grid && n.grid.rows > 1 },
		{ "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column" },
		{ android: a.android },
		{ ios: a.ios },
		{ "css-mode": n.cssMode },
		{ centered: n.cssMode && n.centeredSlides },
		{ "watch-progress": n.watchSlidesProgress }
	], n.containerModifierClass);
	t.push(...o), i.classList.add(...t), e.emitContainerClasses();
}
function FA() {
	let e = this, { el: t, classNames: n } = e;
	t.classList.remove(...n), e.emitContainerClasses();
}
function IA() {
	let e = this, { isLocked: t, params: n } = e, { slidesOffsetBefore: r } = n;
	if (r) {
		let t = e.slides.length - 1, n = e.slidesGrid[t] + e.slidesSizesGrid[t] + r * 2;
		e.isLocked = e.size > n;
	} else e.isLocked = e.snapGrid.length === 1;
	n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
function LA(e, t) {
	return function(n) {
		n === void 0 && (n = {});
		let r = Object.keys(n)[0], i = n[r];
		if (typeof i != "object" || !i) {
			xk(t, n);
			return;
		}
		if (e[r] === !0 && (e[r] = { enabled: !0 }), r === "navigation" && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = !0), !(r in e && "enabled" in i)) {
			xk(t, n);
			return;
		}
		typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = !0), e[r] || (e[r] = { enabled: !1 }), xk(t, n);
	};
}
var RA, zA, BA, VA, HA, UA, WA, GA, KA, qA, JA, YA, XA, ZA, QA, $A, ej, tj, nj, rj, ij, aj, oj, sj = o((() => {
	fk(), Nk(), VA = {
		on(e, t, n) {
			let r = this;
			if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
			let i = n ? "unshift" : "push";
			return e.split(" ").forEach((e) => {
				r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t);
			}), r;
		},
		once(e, t, n) {
			let r = this;
			if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
			function i() {
				r.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
				var n = [...arguments];
				t.apply(r, n);
			}
			return i.__emitterProxy = t, r.on(e, i, n);
		},
		onAny(e, t) {
			let n = this;
			if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
			let r = t ? "unshift" : "push";
			return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
		},
		offAny(e) {
			let t = this;
			if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
			let n = t.eventsAnyListeners.indexOf(e);
			return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
		},
		off(e, t) {
			let n = this;
			return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((e) => {
				t === void 0 ? n.eventsListeners[e] = [] : n.eventsListeners[e] && n.eventsListeners[e].forEach((r, i) => {
					(r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[e].splice(i, 1);
				});
			}), n;
		},
		emit() {
			let e = this;
			if (!e.eventsListeners || e.destroyed || !e.eventsListeners) return e;
			let t, n, r;
			var i = [...arguments];
			return typeof i[0] == "string" || Array.isArray(i[0]) ? (t = i[0], n = i.slice(1, i.length), r = e) : (t = i[0].events, n = i[0].data, r = i[0].context || e), n.unshift(r), (Array.isArray(t) ? t : t.split(" ")).forEach((t) => {
				e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((e) => {
					e.apply(r, [t, ...n]);
				}), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach((e) => {
					e.apply(r, n);
				});
			}), e;
		}
	}, HA = (e, t) => {
		if (!e || e.destroyed || !e.params) return;
		let n = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
		if (n) {
			let t = n.querySelector(`.${e.params.lazyPreloaderClass}`);
			!t && e.isElement && (n.shadowRoot ? t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
				n.shadowRoot && (t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), t && t.remove());
			})), t && t.remove();
		}
	}, UA = (e, t) => {
		if (!e.slides[t]) return;
		let n = e.slides[t].querySelector("[loading=\"lazy\"]");
		n && n.removeAttribute("loading");
	}, WA = (e) => {
		if (!e || e.destroyed || !e.params) return;
		let t = e.params.lazyPreloadPrevNext, n = e.slides.length;
		if (!n || !t || t < 0) return;
		t = Math.min(t, n);
		let r = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), i = e.activeIndex;
		if (e.params.grid && e.params.grid.rows > 1) {
			let n = i, a = [n - t];
			a.push(...Array.from({ length: t }).map((e, t) => n + r + t)), e.slides.forEach((t, n) => {
				a.includes(t.column) && UA(e, n);
			});
			return;
		}
		let a = i + r - 1;
		if (e.params.rewind || e.params.loop) for (let r = i - t; r <= a + t; r += 1) {
			let t = (r % n + n) % n;
			(t < i || t > a) && UA(e, t);
		}
		else for (let r = Math.max(i - t, 0); r <= Math.min(a + t, n - 1); r += 1) r !== i && (r > a || r < i) && UA(e, r);
	}, GA = {
		updateSize: Hk,
		updateSlides: Uk,
		updateAutoHeight: Wk,
		updateSlidesOffset: Gk,
		updateSlidesProgress: Kk,
		updateProgress: qk,
		updateSlidesClasses: Jk,
		updateActiveIndex: Xk,
		updateClickedSlide: Zk
	}, KA = {
		getTranslate: Qk,
		setTranslate: $k,
		minTranslate: eA,
		maxTranslate: tA,
		translateTo: nA
	}, qA = {
		setTransition: rA,
		transitionStart: aA,
		transitionEnd: oA
	}, JA = {
		slideTo: sA,
		slideToLoop: cA,
		slideNext: lA,
		slidePrev: uA,
		slideReset: dA,
		slideToClosest: fA,
		slideToClickedSlide: pA
	}, YA = {
		loopCreate: mA,
		loopFix: hA,
		loopDestroy: gA
	}, XA = {
		setGrabCursor: _A,
		unsetGrabCursor: vA
	}, ZA = (e, t) => {
		let n = ck(), { params: r, el: i, wrapperEl: a, device: o } = e, s = !!r.nested, c = t === "on" ? "addEventListener" : "removeEventListener", l = t;
		n[c]("touchstart", e.onDocumentTouchStart, {
			passive: !1,
			capture: s
		}), i[c]("touchstart", e.onTouchStart, { passive: !1 }), i[c]("pointerdown", e.onTouchStart, { passive: !1 }), n[c]("touchmove", e.onTouchMove, {
			passive: !1,
			capture: s
		}), n[c]("pointermove", e.onTouchMove, {
			passive: !1,
			capture: s
		}), n[c]("touchend", e.onTouchEnd, { passive: !0 }), n[c]("pointerup", e.onTouchEnd, { passive: !0 }), n[c]("pointercancel", e.onTouchEnd, { passive: !0 }), n[c]("touchcancel", e.onTouchEnd, { passive: !0 }), n[c]("pointerout", e.onTouchEnd, { passive: !0 }), n[c]("pointerleave", e.onTouchEnd, { passive: !0 }), n[c]("contextmenu", e.onTouchEnd, { passive: !0 }), (r.preventClicks || r.preventClicksPropagation) && i[c]("click", e.onClick, !0), r.cssMode && a[c]("scroll", e.onScroll), r.updateOnWindowResize ? e[l](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", wA, !0) : e[l]("observerUpdate", wA, !0), i[c]("load", e.onLoad, { capture: !0 });
	}, QA = {
		attachEvents: kA,
		detachEvents: AA
	}, $A = (e, t) => e.grid && t.grid && t.grid.rows > 1, ej = {
		setBreakpoint: jA,
		getBreakpoint: MA
	}, tj = {
		addClasses: PA,
		removeClasses: FA
	}, nj = { checkOverflow: IA }, rj = {
		init: !0,
		direction: "horizontal",
		oneWayMovement: !1,
		swiperElementNodeName: "SWIPER-CONTAINER",
		touchEventsTarget: "wrapper",
		initialSlide: 0,
		speed: 300,
		cssMode: !1,
		updateOnWindowResize: !0,
		resizeObserver: !0,
		nested: !1,
		createElements: !1,
		eventsPrefix: "swiper",
		enabled: !0,
		focusableElements: "input, select, option, textarea, button, video, label",
		width: null,
		height: null,
		preventInteractionOnTransition: !1,
		userAgent: null,
		url: null,
		edgeSwipeDetection: !1,
		edgeSwipeThreshold: 20,
		autoHeight: !1,
		setWrapperSize: !1,
		virtualTranslate: !1,
		effect: "slide",
		breakpoints: void 0,
		breakpointsBase: "window",
		spaceBetween: 0,
		slidesPerView: 1,
		slidesPerGroup: 1,
		slidesPerGroupSkip: 0,
		slidesPerGroupAuto: !1,
		centeredSlides: !1,
		centeredSlidesBounds: !1,
		slidesOffsetBefore: 0,
		slidesOffsetAfter: 0,
		normalizeSlideIndex: !0,
		centerInsufficientSlides: !1,
		watchOverflow: !0,
		roundLengths: !1,
		touchRatio: 1,
		touchAngle: 45,
		simulateTouch: !0,
		shortSwipes: !0,
		longSwipes: !0,
		longSwipesRatio: .5,
		longSwipesMs: 300,
		followFinger: !0,
		allowTouchMove: !0,
		threshold: 5,
		touchMoveStopPropagation: !1,
		touchStartPreventDefault: !0,
		touchStartForcePreventDefault: !1,
		touchReleaseOnEdges: !1,
		uniqueNavElements: !0,
		resistance: !0,
		resistanceRatio: .85,
		watchSlidesProgress: !1,
		grabCursor: !1,
		preventClicks: !0,
		preventClicksPropagation: !0,
		slideToClickedSlide: !1,
		loop: !1,
		loopAddBlankSlides: !0,
		loopAdditionalSlides: 0,
		loopPreventsSliding: !0,
		rewind: !1,
		allowSlidePrev: !0,
		allowSlideNext: !0,
		swipeHandler: null,
		noSwiping: !0,
		noSwipingClass: "swiper-no-swiping",
		noSwipingSelector: null,
		passiveListeners: !0,
		maxBackfaceHiddenSlides: 10,
		containerModifierClass: "swiper-",
		slideClass: "swiper-slide",
		slideBlankClass: "swiper-slide-blank",
		slideActiveClass: "swiper-slide-active",
		slideVisibleClass: "swiper-slide-visible",
		slideFullyVisibleClass: "swiper-slide-fully-visible",
		slideNextClass: "swiper-slide-next",
		slidePrevClass: "swiper-slide-prev",
		wrapperClass: "swiper-wrapper",
		lazyPreloaderClass: "swiper-lazy-preloader",
		lazyPreloadPrevNext: 0,
		runCallbacksOnInit: !0,
		_emitClasses: !1
	}, ij = {
		eventsEmitter: VA,
		update: GA,
		translate: KA,
		transition: qA,
		slide: JA,
		loop: YA,
		grabCursor: XA,
		events: QA,
		breakpoints: ej,
		checkOverflow: nj,
		classes: tj
	}, aj = {}, oj = class e {
		constructor() {
			let t, n;
			var r = [...arguments];
			r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? n = r[0] : [t, n] = r, n ||= {}, n = xk({}, n), t && !n.el && (n.el = t);
			let i = ck();
			if (n.el && typeof n.el == "string" && i.querySelectorAll(n.el).length > 1) {
				let t = [];
				return i.querySelectorAll(n.el).forEach((r) => {
					let i = xk({}, n, { el: r });
					t.push(new e(i));
				}), t;
			}
			let a = this;
			a.__swiper__ = !0, a.support = Fk(), a.device = Lk({ userAgent: n.userAgent }), a.browser = zk(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], n.modules && Array.isArray(n.modules) && a.modules.push(...n.modules);
			let o = {};
			return a.modules.forEach((e) => {
				e({
					params: n,
					swiper: a,
					extendParams: LA(n, o),
					on: a.on.bind(a),
					once: a.once.bind(a),
					off: a.off.bind(a),
					emit: a.emit.bind(a)
				});
			}), a.params = xk({}, xk({}, rj, o), aj, n), a.originalParams = xk({}, a.params), a.passedParams = xk({}, n), a.params && a.params.on && Object.keys(a.params.on).forEach((e) => {
				a.on(e, a.params.on[e]);
			}), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
				enabled: a.params.enabled,
				el: t,
				classNames: [],
				slides: [],
				slidesGrid: [],
				snapGrid: [],
				slidesSizesGrid: [],
				isHorizontal() {
					return a.params.direction === "horizontal";
				},
				isVertical() {
					return a.params.direction === "vertical";
				},
				activeIndex: 0,
				realIndex: 0,
				isBeginning: !0,
				isEnd: !1,
				translate: 0,
				previousTranslate: 0,
				progress: 0,
				velocity: 0,
				animating: !1,
				cssOverflowAdjustment() {
					return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
				},
				allowSlideNext: a.params.allowSlideNext,
				allowSlidePrev: a.params.allowSlidePrev,
				touchEventsData: {
					isTouched: void 0,
					isMoved: void 0,
					allowTouchCallbacks: void 0,
					touchStartTime: void 0,
					isScrolling: void 0,
					currentTranslate: void 0,
					startTranslate: void 0,
					allowThresholdMove: void 0,
					focusableElements: a.params.focusableElements,
					lastClickTime: 0,
					clickTimeout: void 0,
					velocities: [],
					allowMomentumBounce: void 0,
					startMoving: void 0,
					pointerId: null,
					touchId: null
				},
				allowClick: !0,
				allowTouchMove: a.params.allowTouchMove,
				touches: {
					startX: 0,
					startY: 0,
					currentX: 0,
					currentY: 0,
					diff: 0
				},
				imagesToLoad: [],
				imagesLoaded: 0
			}), a.emit("_swiper"), a.params.init && a.init(), a;
		}
		getDirectionLabel(e) {
			return this.isHorizontal() ? e : {
				width: "height",
				"margin-top": "margin-left",
				"margin-bottom ": "margin-right",
				"margin-left": "margin-top",
				"margin-right": "margin-bottom",
				"padding-left": "padding-top",
				"padding-right": "padding-bottom",
				marginRight: "marginBottom"
			}[e];
		}
		getSlideIndex(e) {
			let { slidesEl: t, params: n } = this, r = Ak(wk(t, `.${n.slideClass}, swiper-slide`)[0]);
			return Ak(e) - r;
		}
		getSlideIndexByData(e) {
			return this.getSlideIndex(this.slides.filter((t) => t.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
		}
		recalcSlides() {
			let e = this, { slidesEl: t, params: n } = e;
			e.slides = wk(t, `.${n.slideClass}, swiper-slide`);
		}
		enable() {
			let e = this;
			e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
		}
		disable() {
			let e = this;
			e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
		}
		setProgress(e, t) {
			let n = this;
			e = Math.min(Math.max(e, 0), 1);
			let r = n.minTranslate(), i = (n.maxTranslate() - r) * e + r;
			n.translateTo(i, t === void 0 ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
		}
		emitContainerClasses() {
			let e = this;
			if (!e.params._emitClasses || !e.el) return;
			let t = e.el.className.split(" ").filter((t) => t.indexOf("swiper") === 0 || t.indexOf(e.params.containerModifierClass) === 0);
			e.emit("_containerClasses", t.join(" "));
		}
		getSlideClasses(e) {
			let t = this;
			return t.destroyed ? "" : e.className.split(" ").filter((e) => e.indexOf("swiper-slide") === 0 || e.indexOf(t.params.slideClass) === 0).join(" ");
		}
		emitSlidesClasses() {
			let e = this;
			if (!e.params._emitClasses || !e.el) return;
			let t = [];
			e.slides.forEach((n) => {
				let r = e.getSlideClasses(n);
				t.push({
					slideEl: n,
					classNames: r
				}), e.emit("_slideClass", n, r);
			}), e.emit("_slideClasses", t);
		}
		slidesPerViewDynamic(e, t) {
			e === void 0 && (e = "current"), t === void 0 && (t = !1);
			let { params: n, slides: r, slidesGrid: i, slidesSizesGrid: a, size: o, activeIndex: s } = this, c = 1;
			if (typeof n.slidesPerView == "number") return n.slidesPerView;
			if (n.centeredSlides) {
				let e = r[s] ? Math.ceil(r[s].swiperSlideSize) : 0, t;
				for (let n = s + 1; n < r.length; n += 1) r[n] && !t && (e += Math.ceil(r[n].swiperSlideSize), c += 1, e > o && (t = !0));
				for (let n = s - 1; n >= 0; --n) r[n] && !t && (e += r[n].swiperSlideSize, c += 1, e > o && (t = !0));
			} else if (e === "current") for (let e = s + 1; e < r.length; e += 1) (t ? i[e] + a[e] - i[s] < o : i[e] - i[s] < o) && (c += 1);
			else for (let e = s - 1; e >= 0; --e) i[s] - i[e] < o && (c += 1);
			return c;
		}
		update() {
			let e = this;
			if (!e || e.destroyed) return;
			let { snapGrid: t, params: n } = e;
			n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll("[loading=\"lazy\"]")].forEach((t) => {
				t.complete && HA(e, t);
			}), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
			function r() {
				let t = e.rtlTranslate ? e.translate * -1 : e.translate, n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
				e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
			}
			let i;
			if (n.freeMode && n.freeMode.enabled && !n.cssMode) r(), n.autoHeight && e.updateAutoHeight();
			else {
				if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
					let t = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
					i = e.slideTo(t.length - 1, 0, !1, !0);
				} else i = e.slideTo(e.activeIndex, 0, !1, !0);
				i || r();
			}
			n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
		}
		changeDirection(e, t) {
			t === void 0 && (t = !0);
			let n = this, r = n.params.direction;
			return e ||= r === "horizontal" ? "vertical" : "horizontal", e === r || e !== "horizontal" && e !== "vertical" ? n : (n.el.classList.remove(`${n.params.containerModifierClass}${r}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((t) => {
				e === "vertical" ? t.style.width = "" : t.style.height = "";
			}), n.emit("changeDirection"), t && n.update(), n);
		}
		changeLanguageDirection(e) {
			let t = this;
			t.rtl && e === "rtl" || !t.rtl && e === "ltr" || (t.rtl = e === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
		}
		mount(e) {
			let t = this;
			if (t.mounted) return !0;
			let n = e || t.params.el;
			if (typeof n == "string" && (n = document.querySelector(n)), !n) return !1;
			n.swiper = t, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
			let r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`, i = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(r()) : wk(n, r())[0];
			return !i && t.params.createElements && (i = Ek("div", t.params.wrapperClass), n.append(i), wk(n, `.${t.params.slideClass}`).forEach((e) => {
				i.append(e);
			})), Object.assign(t, {
				el: n,
				wrapperEl: i,
				slidesEl: t.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : i,
				hostEl: t.isElement ? n.parentNode.host : n,
				mounted: !0,
				rtl: n.dir.toLowerCase() === "rtl" || kk(n, "direction") === "rtl",
				rtlTranslate: t.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || kk(n, "direction") === "rtl"),
				wrongRTL: kk(i, "display") === "-webkit-box"
			}), !0;
		}
		init(e) {
			let t = this;
			if (t.initialized || t.mount(e) === !1) return t;
			t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
			let n = [...t.el.querySelectorAll("[loading=\"lazy\"]")];
			return t.isElement && n.push(...t.hostEl.querySelectorAll("[loading=\"lazy\"]")), n.forEach((e) => {
				e.complete ? HA(t, e) : e.addEventListener("load", (e) => {
					HA(t, e.target);
				});
			}), WA(t), t.initialized = !0, WA(t), t.emit("init"), t.emit("afterInit"), t;
		}
		destroy(e, t) {
			e === void 0 && (e = !0), t === void 0 && (t = !0);
			let n = this, { params: r, el: i, wrapperEl: a, slides: o } = n;
			return n.params === void 0 || n.destroyed ? null : (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), r.loop && n.loopDestroy(), t && (n.removeClasses(), i.removeAttribute("style"), a.removeAttribute("style"), o && o.length && o.forEach((e) => {
				e.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
			})), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((e) => {
				n.off(e);
			}), e !== !1 && (n.el.swiper = null, mk(n)), n.destroyed = !0, null);
		}
		static extendDefaults(e) {
			xk(aj, e);
		}
		static get extendedDefaults() {
			return aj;
		}
		static get defaults() {
			return rj;
		}
		static installModule(t) {
			e.prototype.__modules__ || (e.prototype.__modules__ = []);
			let n = e.prototype.__modules__;
			typeof t == "function" && n.indexOf(t) < 0 && n.push(t);
		}
		static use(t) {
			return Array.isArray(t) ? (t.forEach((t) => e.installModule(t)), e) : (e.installModule(t), e);
		}
	}, Object.keys(ij).forEach((e) => {
		Object.keys(ij[e]).forEach((t) => {
			oj.prototype[t] = ij[e][t];
		});
	}), oj.use([Bk, Vk]);
}));
//#endregion
//#region node_modules/swiper/shared/update-swiper.mjs
function cj(e) {
	return typeof e == "object" && !!e && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object" && !e.__swiper__;
}
function lj(e, t) {
	let n = [
		"__proto__",
		"constructor",
		"prototype"
	];
	Object.keys(t).filter((e) => n.indexOf(e) < 0).forEach((n) => {
		e[n] === void 0 ? e[n] = t[n] : cj(t[n]) && cj(e[n]) && Object.keys(t[n]).length > 0 ? t[n].__swiper__ ? e[n] = t[n] : lj(e[n], t[n]) : e[n] = t[n];
	});
}
function uj(e) {
	return e === void 0 && (e = {}), e.navigation && e.navigation.nextEl === void 0 && e.navigation.prevEl === void 0;
}
function dj(e) {
	return e === void 0 && (e = {}), e.pagination && e.pagination.el === void 0;
}
function fj(e) {
	return e === void 0 && (e = {}), e.scrollbar && e.scrollbar.el === void 0;
}
function pj(e) {
	e === void 0 && (e = "");
	let t = e.split(" ").map((e) => e.trim()).filter((e) => !!e), n = [];
	return t.forEach((e) => {
		n.indexOf(e) < 0 && n.push(e);
	}), n.join(" ");
}
function mj(e) {
	return e === void 0 && (e = ""), e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function hj(e) {
	let { swiper: t, slides: n, passedParams: r, changedParams: i, nextEl: a, prevEl: o, scrollbarEl: s, paginationEl: c } = e, l = i.filter((e) => e !== "children" && e !== "direction" && e !== "wrapperClass"), { params: u, pagination: d, navigation: f, scrollbar: p, virtual: m, thumbs: h } = t, g, _, v, y, b, x, S, C;
	i.includes("thumbs") && r.thumbs && r.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (g = !0), i.includes("controller") && r.controller && r.controller.control && u.controller && !u.controller.control && (_ = !0), i.includes("pagination") && r.pagination && (r.pagination.el || c) && (u.pagination || u.pagination === !1) && d && !d.el && (v = !0), i.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || s) && (u.scrollbar || u.scrollbar === !1) && p && !p.el && (y = !0), i.includes("navigation") && r.navigation && (r.navigation.prevEl || o) && (r.navigation.nextEl || a) && (u.navigation || u.navigation === !1) && f && !f.prevEl && !f.nextEl && (b = !0);
	let w = (e) => {
		t[e] && (t[e].destroy(), e === "navigation" ? (t.isElement && (t[e].prevEl.remove(), t[e].nextEl.remove()), u[e].prevEl = void 0, u[e].nextEl = void 0, t[e].prevEl = void 0, t[e].nextEl = void 0) : (t.isElement && t[e].el.remove(), u[e].el = void 0, t[e].el = void 0));
	};
	i.includes("loop") && t.isElement && (u.loop && !r.loop ? x = !0 : !u.loop && r.loop ? S = !0 : C = !0), l.forEach((e) => {
		if (cj(u[e]) && cj(r[e])) Object.assign(u[e], r[e]), (e === "navigation" || e === "pagination" || e === "scrollbar") && "enabled" in r[e] && !r[e].enabled && w(e);
		else {
			let t = r[e];
			(t === !0 || t === !1) && (e === "navigation" || e === "pagination" || e === "scrollbar") ? t === !1 && w(e) : u[e] = r[e];
		}
	}), l.includes("controller") && !_ && t.controller && t.controller.control && u.controller && u.controller.control && (t.controller.control = u.controller.control), i.includes("children") && n && m && u.virtual.enabled ? (m.slides = n, m.update(!0)) : i.includes("virtual") && m && u.virtual.enabled && (n && (m.slides = n), m.update(!0)), i.includes("children") && n && u.loop && (C = !0), g && h.init() && h.update(!0), _ && (t.controller.control = u.controller.control), v && (t.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-pagination"), c.part.add("pagination"), t.el.appendChild(c)), c && (u.pagination.el = c), d.init(), d.render(), d.update()), y && (t.isElement && (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-scrollbar"), s.part.add("scrollbar"), t.el.appendChild(s)), s && (u.scrollbar.el = s), p.init(), p.updateSize(), p.setTranslate()), b && (t.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = t.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), t.el.appendChild(a)), (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-prev"), o.innerHTML = t.hostEl.constructor.prevButtonSvg, o.part.add("button-prev"), t.el.appendChild(o))), a && (u.navigation.nextEl = a), o && (u.navigation.prevEl = o), f.init(), f.update()), i.includes("allowSlideNext") && (t.allowSlideNext = r.allowSlideNext), i.includes("allowSlidePrev") && (t.allowSlidePrev = r.allowSlidePrev), i.includes("direction") && t.changeDirection(r.direction, !1), (x || C) && t.loopDestroy(), (S || C) && t.loopCreate(), t.update();
}
var gj, _j = o((() => {
	gj = /* @__PURE__ */ "eventsPrefix.injectStyles.injectStylesUrls.modules.init._direction.oneWayMovement.swiperElementNodeName.touchEventsTarget.initialSlide._speed.cssMode.updateOnWindowResize.resizeObserver.nested.focusableElements._enabled._width._height.preventInteractionOnTransition.userAgent.url._edgeSwipeDetection._edgeSwipeThreshold._freeMode._autoHeight.setWrapperSize.virtualTranslate._effect.breakpoints.breakpointsBase._spaceBetween._slidesPerView.maxBackfaceHiddenSlides._grid._slidesPerGroup._slidesPerGroupSkip._slidesPerGroupAuto._centeredSlides._centeredSlidesBounds._slidesOffsetBefore._slidesOffsetAfter.normalizeSlideIndex._centerInsufficientSlides._watchOverflow.roundLengths.touchRatio.touchAngle.simulateTouch._shortSwipes._longSwipes.longSwipesRatio.longSwipesMs._followFinger.allowTouchMove._threshold.touchMoveStopPropagation.touchStartPreventDefault.touchStartForcePreventDefault.touchReleaseOnEdges.uniqueNavElements._resistance._resistanceRatio._watchSlidesProgress._grabCursor.preventClicks.preventClicksPropagation._slideToClickedSlide._loop.loopAdditionalSlides.loopAddBlankSlides.loopPreventsSliding._rewind._allowSlidePrev._allowSlideNext._swipeHandler._noSwiping.noSwipingClass.noSwipingSelector.passiveListeners.containerModifierClass.slideClass.slideActiveClass.slideVisibleClass.slideFullyVisibleClass.slideNextClass.slidePrevClass.slideBlankClass.wrapperClass.lazyPreloaderClass.lazyPreloadPrevNext.runCallbacksOnInit.observer.observeParents.observeSlideChildren.a11y._autoplay._controller.coverflowEffect.cubeEffect.fadeEffect.flipEffect.creativeEffect.cardsEffect.hashNavigation.history.keyboard.mousewheel._navigation._pagination.parallax._scrollbar._thumbs.virtual.zoom.control".split(".");
}));
//#endregion
//#region node_modules/swiper/shared/update-on-virtual-data.mjs
function vj(e, t) {
	e === void 0 && (e = {}), t === void 0 && (t = !0);
	let n = { on: {} }, r = {}, i = {};
	lj(n, rj), n._emitClasses = !0, n.init = !1;
	let a = {}, o = gj.map((e) => e.replace(/_/, "")), s = Object.assign({}, e);
	return Object.keys(s).forEach((s) => {
		e[s] !== void 0 && (o.indexOf(s) >= 0 ? cj(e[s]) ? (n[s] = {}, i[s] = {}, lj(n[s], e[s]), lj(i[s], e[s])) : (n[s] = e[s], i[s] = e[s]) : s.search(/on[A-Z]/) === 0 && typeof e[s] == "function" ? t ? r[`${s[2].toLowerCase()}${s.substr(3)}`] = e[s] : n.on[`${s[2].toLowerCase()}${s.substr(3)}`] = e[s] : a[s] = e[s]);
	}), [
		"navigation",
		"pagination",
		"scrollbar"
	].forEach((e) => {
		n[e] === !0 && (n[e] = {}), n[e] === !1 && delete n[e];
	}), {
		params: n,
		passedParams: i,
		rest: a,
		events: r
	};
}
function yj(e, t) {
	let { el: n, nextEl: r, prevEl: i, paginationEl: a, scrollbarEl: o, swiper: s } = e;
	uj(t) && r && i && (s.params.navigation.nextEl = r, s.originalParams.navigation.nextEl = r, s.params.navigation.prevEl = i, s.originalParams.navigation.prevEl = i), dj(t) && a && (s.params.pagination.el = a, s.originalParams.pagination.el = a), fj(t) && o && (s.params.scrollbar.el = o, s.originalParams.scrollbar.el = o), s.init(n);
}
function bj(e, t, n, r, i) {
	let a = [];
	if (!t) return a;
	let o = (e) => {
		a.indexOf(e) < 0 && a.push(e);
	};
	if (n && r) {
		let e = r.map(i), t = n.map(i);
		e.join("") !== t.join("") && o("children"), r.length !== n.length && o("children");
	}
	return gj.filter((e) => e[0] === "_").map((e) => e.replace(/_/, "")).forEach((n) => {
		if (n in e && n in t) {
			if (cj(e[n]) && cj(t[n])) {
				let r = Object.keys(e[n]), i = Object.keys(t[n]);
				r.length === i.length ? (r.forEach((r) => {
					e[n][r] !== t[n][r] && o(n);
				}), i.forEach((r) => {
					e[n][r] !== t[n][r] && o(n);
				})) : o(n);
			} else e[n] !== t[n] && o(n);
		}
	}), a;
}
var xj, Sj = o((() => {
	_j(), sj(), xj = (e) => {
		!e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
	};
}));
//#endregion
//#region node_modules/swiper/swiper-react.mjs
function Cj() {
	return Cj = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Cj.apply(this, arguments);
}
function wj(e) {
	return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function Tj(e) {
	let t = [];
	return z.Children.toArray(e).forEach((e) => {
		wj(e) ? t.push(e) : e.props && e.props.children && Tj(e.props.children).forEach((e) => t.push(e));
	}), t;
}
function Ej(e) {
	let t = [], n = {
		"container-start": [],
		"container-end": [],
		"wrapper-start": [],
		"wrapper-end": []
	};
	return z.Children.toArray(e).forEach((e) => {
		if (wj(e)) t.push(e);
		else if (e.props && e.props.slot && n[e.props.slot]) n[e.props.slot].push(e);
		else if (e.props && e.props.children) {
			let r = Tj(e.props.children);
			r.length > 0 ? r.forEach((e) => t.push(e)) : n["container-end"].push(e);
		} else n["container-end"].push(e);
	}), {
		slides: t,
		slots: n
	};
}
function Dj(e, t, n) {
	if (!n) return null;
	let r = (e) => {
		let n = e;
		return e < 0 ? n = t.length + e : n >= t.length && (n -= t.length), n;
	}, i = e.isHorizontal() ? { [e.rtlTranslate ? "right" : "left"]: `${n.offset}px` } : { top: `${n.offset}px` }, { from: a, to: o } = n, s = e.params.loop ? -t.length : 0, c = e.params.loop ? t.length * 2 : t.length, l = [];
	for (let e = s; e < c; e += 1) e >= a && e <= o && l.push(t[r(e)]);
	return l.map((t, n) => /*#__PURE__*/ z.cloneElement(t, {
		swiper: e,
		style: i,
		key: t.props.virtualIndex || t.key || `slide-${n}`
	}));
}
function Oj(e, t) {
	return typeof window > "u" ? L(e, t) : Ne(e, t);
}
var kj, Aj, jj, Mj, Nj = o((() => {
	ln(), sj(), Sj(), _j(), kj = /*#__PURE__*/ ue(null), Aj = /*#__PURE__*/ ue(null), jj = /*#__PURE__*/ vt(function(e, t) {
		let { className: n, tag: r = "div", wrapperTag: i = "div", children: a, onSwiper: o, ...s } = e === void 0 ? {} : e, c = !1, [l, u] = I("swiper"), [d, f] = I(null), [p, m] = I(!1), h = Pe(!1), g = Pe(null), _ = Pe(null), v = Pe(null), y = Pe(null), b = Pe(null), x = Pe(null), S = Pe(null), C = Pe(null), { params: w, passedParams: T, rest: E, events: D } = vj(s), { slides: O, slots: k } = Ej(a), A = () => {
			m(!p);
		};
		Object.assign(w.on, { _containerClasses(e, t) {
			u(t);
		} });
		let j = () => {
			Object.assign(w.on, D), c = !0;
			let e = { ...w };
			if (delete e.wrapperClass, _.current = new oj(e), _.current.virtual && _.current.params.virtual.enabled) {
				_.current.virtual.slides = O;
				let e = {
					cache: !1,
					slides: O,
					renderExternal: f,
					renderExternalUpdate: !1
				};
				lj(_.current.params.virtual, e), lj(_.current.originalParams.virtual, e);
			}
		};
		g.current || j(), _.current && _.current.on("_beforeBreakpoint", A);
		let M = () => {
			c || !D || !_.current || Object.keys(D).forEach((e) => {
				_.current.on(e, D[e]);
			});
		}, ee = () => {
			!D || !_.current || Object.keys(D).forEach((e) => {
				_.current.off(e, D[e]);
			});
		};
		L(() => () => {
			_.current && _.current.off("_beforeBreakpoint", A);
		}), L(() => {
			!h.current && _.current && (_.current.emitSlidesClasses(), h.current = !0);
		}), Oj(() => {
			if (t && (t.current = g.current), g.current) return _.current.destroyed && j(), yj({
				el: g.current,
				nextEl: b.current,
				prevEl: x.current,
				paginationEl: S.current,
				scrollbarEl: C.current,
				swiper: _.current
			}, w), o && !_.current.destroyed && o(_.current), () => {
				_.current && !_.current.destroyed && _.current.destroy(!0, !1);
			};
		}, []), Oj(() => {
			M();
			let e = bj(T, v.current, O, y.current, (e) => e.key);
			return v.current = T, y.current = O, e.length && _.current && !_.current.destroyed && hj({
				swiper: _.current,
				slides: O,
				passedParams: T,
				changedParams: e,
				nextEl: b.current,
				prevEl: x.current,
				scrollbarEl: C.current,
				paginationEl: S.current
			}), () => {
				ee();
			};
		}), Oj(() => {
			xj(_.current);
		}, [d]);
		function te() {
			return w.virtual ? Dj(_.current, O, d) : O.map((e, t) => /*#__PURE__*/ z.cloneElement(e, {
				swiper: _.current,
				swiperSlideIndex: t
			}));
		}
		return /*#__PURE__*/ z.createElement(r, Cj({
			ref: g,
			className: pj(`${l}${n ? ` ${n}` : ""}`)
		}, E), /*#__PURE__*/ z.createElement(Aj.Provider, { value: _.current }, k["container-start"], /*#__PURE__*/ z.createElement(i, { className: mj(w.wrapperClass) }, k["wrapper-start"], te(), k["wrapper-end"]), uj(w) && /*#__PURE__*/ z.createElement(z.Fragment, null, /*#__PURE__*/ z.createElement("div", {
			ref: x,
			className: "swiper-button-prev"
		}), /*#__PURE__*/ z.createElement("div", {
			ref: b,
			className: "swiper-button-next"
		})), fj(w) && /*#__PURE__*/ z.createElement("div", {
			ref: C,
			className: "swiper-scrollbar"
		}), dj(w) && /*#__PURE__*/ z.createElement("div", {
			ref: S,
			className: "swiper-pagination"
		}), k["container-end"]));
	}), jj.displayName = "Swiper", Mj = /*#__PURE__*/ vt(function(e, t) {
		let { tag: n = "div", children: r, className: i = "", swiper: a, zoom: o, lazy: s, virtualIndex: c, swiperSlideIndex: l, ...u } = e === void 0 ? {} : e, d = Pe(null), [f, p] = I("swiper-slide"), [m, h] = I(!1);
		function g(e, t, n) {
			t === d.current && p(n);
		}
		Oj(() => {
			if (l !== void 0 && (d.current.swiperSlideIndex = l), t && (t.current = d.current), !(!d.current || !a)) {
				if (a.destroyed) {
					f !== "swiper-slide" && p("swiper-slide");
					return;
				}
				return a.on("_slideClass", g), () => {
					a && a.off("_slideClass", g);
				};
			}
		}), Oj(() => {
			a && d.current && !a.destroyed && p(a.getSlideClasses(d.current));
		}, [a]);
		let _ = {
			isActive: f.indexOf("swiper-slide-active") >= 0,
			isVisible: f.indexOf("swiper-slide-visible") >= 0,
			isPrev: f.indexOf("swiper-slide-prev") >= 0,
			isNext: f.indexOf("swiper-slide-next") >= 0
		}, v = () => typeof r == "function" ? r(_) : r;
		return /*#__PURE__*/ z.createElement(n, Cj({
			ref: d,
			className: pj(`${f}${i ? ` ${i}` : ""}`),
			"data-swiper-slide-index": c,
			onLoad: () => {
				h(!0);
			}
		}, u), o && /*#__PURE__*/ z.createElement(kj.Provider, { value: _ }, /*#__PURE__*/ z.createElement("div", {
			className: "swiper-zoom-container",
			"data-swiper-zoom": typeof o == "number" ? o : void 0
		}, v(), s && !m && /*#__PURE__*/ z.createElement("div", { className: "swiper-lazy-preloader" }))), !o && /*#__PURE__*/ z.createElement(kj.Provider, { value: _ }, v(), s && !m && /*#__PURE__*/ z.createElement("div", { className: "swiper-lazy-preloader" })));
	}), Mj.displayName = "SwiperSlide";
})), Pj = o((() => {
	R(), X(), Q(), U(), Nj();
})), Fj = o((() => {
	Pj();
})), Ij = o((() => {
	Oe(), Q(), X();
})), Lj = o((() => {
	Ij();
})), Rj = o((() => {
	X(), R(), Q(), U();
})), zj = o((() => {
	Rj();
})), Bj = o((() => {
	Q();
})), Vj = o((() => {
	Bj();
})), Hj = o((() => {
	Q(), X(), R(), U();
})), Uj = o((() => {
	Hj();
})), Wj = o((() => {
	Q();
})), Gj = o((() => {
	Wj();
})), Kj = o((() => {
	R(), X(), Q(), U();
})), qj = o((() => {
	Kj();
})), Jj = o((() => {
	Q(), X(), U(), ln(), R();
})), Yj = o((() => {
	Jj();
})), Xj = o((() => {
	Q(), U(), X();
})), Zj = o((() => {
	Xj();
})), Qj = o((() => {
	Q(), X();
})), $j = o((() => {
	Qj();
})), eM = o((() => {
	Q(), X();
})), tM = o((() => {
	eM();
})), nM = o((() => {
	RO();
})), rM = o((() => {
	zO();
})), iM = o((() => {
	X(), Q();
})), aM = o((() => {
	iM();
})), oM = o((() => {
	X(), Q(), U();
})), sM = o((() => {
	oM();
})), cM = o((() => {
	X(), Q();
})), lM = o((() => {
	cM();
})), uM = o((() => {
	R(), Q(), X(), U();
})), dM = o((() => {
	uM();
})), fM = o((() => {})), pM = o((() => {})), mM = o((() => {})), hM = o((() => {
	yw(), fM(), tT(), pM(), mM();
})), gM = o((() => {
	xC(), dC(), gC(), oC(), rD(), VO(), GT(), OE(), $j(), PT(), hT(), lT(), tM(), _O(), nM(), bT(), rM(), aM(), ET(), Fj(), ZT(), sM(), wD(), ID(), vD(), AD(), XD(), xO(), LO(), rE(), DO(), dE(), rE(), YO(), NT(), TO(), FO(), fD(), jO(), zT(), BE(), nO(), kO(), yO(), NO(), UO(), lM(), CE(), _E(), PE(), hO(), ew(), lO(), dO(), qO(), CO(), $O(), QE(), GO(), ZO(), dM(), mO(), qj(), zj(), Vj(), Uj(), Gj(), Yj(), Zj(), rk(), ak(), nk(), iT(), Lj(), GE(), GE(), SS(), CS(), wS(), TS(), kS(), zS(), BS(), KS(), JS(), IS(), YS(), eC(), BC(), oD(), hM();
}));
//#endregion
//#region src/athos/utils/activeFilters.js
gM();
var _M = (e) => Array.from(e || []), vM = (e) => String(e.facet?.field ?? e.field ?? "").trim(), yM = (e) => String(e.facet?.label ?? e.field ?? "").trim(), bM = (e) => e.value && typeof e.value == "object" ? String(e.value.label ?? e.value.value ?? "").trim() : String(e.valueLabel ?? e.label ?? e.value ?? "").trim(), xM = (e) => {
	let t = vM(e), n = yM(e), r = bM(e), i = e.value?.low ?? e.low ?? e.range?.low, a = e.value?.high ?? e.high ?? e.range?.high;
	if (i != null && a != null) {
		let e = (e) => `${Math.round(Number(e))} €`;
		return `${n || "Hinta"}: ${e(i)} - ${e(a)}`;
	}
	return t === "tags" || n.toLowerCase() === "tags" ? r.replace(/:\s*/, ": ") : e.label && !String(e.label).toLowerCase().startsWith("tags:") ? e.label : n && r ? `${n}: ${r}` : r;
}, SM = (e) => _M(e).filter((e) => !e.background && vM(e) !== "collection_handle").map((e, t) => ({
	key: `${vM(e) || "filter"}-${e.value?.value ?? e.value?.low ?? e.value ?? t}`,
	label: xM(e),
	remove: () => e.url?.go()
}));
Q(), Ae();
var CM = () => /* @__PURE__ */ F("svg", {
	role: "presentation",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	width: "16",
	height: "16",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "2",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-x",
	children: [/* @__PURE__ */ F("line", {
		x1: "18",
		y1: "6",
		x2: "6",
		y2: "18"
	}), /* @__PURE__ */ F("line", {
		x1: "6",
		y1: "6",
		x2: "18",
		y2: "18"
	})]
}), wM = Z(({ controller: e }) => {
	let t = SM(e.store.filters);
	return t.length === 0 ? null : /* @__PURE__ */ F("div", {
		className: "active-filters athos-active-filters flex",
		style: { gap: "12px" },
		children: t.map((e) => /* @__PURE__ */ F("a", {
			className: "btn btn--with-icon size--tiny athos-active-filter-chip",
			href: "#",
			onClick: (t) => {
				t.preventDefault(), e.remove();
			},
			children: [/* @__PURE__ */ F("span", { children: e.label }), /* @__PURE__ */ F(CM, {})]
		}, e.key))
	});
});
//#endregion
//#region src/athos/components/AthosGridSkeleton.jsx
Ae();
var TM = 8, EM = ({ loadingLabel: e }) => /* @__PURE__ */ F("div", {
	className: "athos-grid-skeleton",
	"aria-busy": "true",
	"aria-live": "polite",
	children: [
		/* @__PURE__ */ F("p", {
			className: "visually-hidden",
			role: "status",
			children: e
		}),
		/* @__PURE__ */ F("div", {
			className: "athos-grid-skeleton__actions",
			children: [/* @__PURE__ */ F("span", { className: "athos-grid-skeleton__line athos-grid-skeleton__line--short" }), /* @__PURE__ */ F("span", { className: "athos-grid-skeleton__line athos-grid-skeleton__line--sort" })]
		}),
		/* @__PURE__ */ F("div", {
			className: "athos-grid-skeleton__grid",
			children: Array.from({ length: TM }, (e, t) => /* @__PURE__ */ F("div", {
				className: "athos-grid-skeleton__card",
				children: [
					/* @__PURE__ */ F("span", { className: "athos-grid-skeleton__media" }),
					/* @__PURE__ */ F("span", { className: "athos-grid-skeleton__line athos-grid-skeleton__line--vendor" }),
					/* @__PURE__ */ F("span", { className: "athos-grid-skeleton__line athos-grid-skeleton__line--title" }),
					/* @__PURE__ */ F("span", { className: "athos-grid-skeleton__line athos-grid-skeleton__line--price" })
				]
			}, t))
		})
	]
}), DM = "athos-results", OM = null, kM = !1, AM = (e, t) => e != null && t != null && e !== t, jM = () => {
	kM = !0;
}, MM = (e) => kM || AM(OM, e), NM = (e) => {
	OM = e;
}, PM = (e) => {
	kM = !1, OM = e;
}, FM = (e = typeof document < "u" ? document : void 0) => {
	if (!e?.documentElement) return 0;
	let t = e.defaultView?.getComputedStyle?.(e.documentElement) || globalThis.getComputedStyle?.(e.documentElement), n = parseFloat(t?.getPropertyValue("--sticky-header-margin-top")) || 0, r = parseFloat(t?.getPropertyValue("--header-height")) || 0;
	if (n > 0) return n;
	if (r > 0) return r;
	let i = e.querySelector(".site-header, header.header");
	return Number(i?.getBoundingClientRect?.().height) || 0;
}, IM = (e, { reducedMotion: t = !1, scrollTo: n = typeof window < "u" ? window.scrollTo.bind(window) : void 0, headerOffset: r = FM() } = {}) => {
	if (!e) return;
	e.focus({ preventScroll: !0 });
	let i = e.getBoundingClientRect?.() || { top: 0 }, a = Number(typeof window < "u" ? window.scrollY : 0) || 0;
	n?.({
		top: Math.max(0, a + (Number(i.top) || 0) - (Number(r) || 0)),
		behavior: t ? "auto" : "smooth"
	});
};
Q(), Ae();
var LM = () => /* @__PURE__ */ F("svg", {
	role: "presentation",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	width: "20",
	height: "20",
	viewBox: "0 0 20 20",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "2",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-chevron-left",
	children: /* @__PURE__ */ F("polyline", { points: "12 6 8 10 12 14" })
}), RM = () => /* @__PURE__ */ F("svg", {
	role: "presentation",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	width: "20",
	height: "20",
	viewBox: "0 0 20 20",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "2",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-chevron-left",
	children: /* @__PURE__ */ F("polyline", { points: "8 14 12 10 8 6" })
}), zM = (e, t) => String(e || "Page __NUMBER__").replace("__NUMBER__", String(t)), BM = (e = {}) => ({
	...e,
	onClick: (t) => {
		jM(), e.onClick?.(t);
	}
}), VM = Z(({ pagination: e, labels: t = {} }) => {
	if (!e?.totalResults || e.totalPages <= 1) return null;
	let n = e.getPages?.(5) || [];
	return /* @__PURE__ */ F("nav", {
		className: `pagination mt-48 mb-48${n.length > 5 ? " wide-parts" : ""} size--tiny`,
		role: "navigation",
		"aria-label": t.paginationLabel || "Pagination",
		children: [
			e.previous ? /* @__PURE__ */ F("a", {
				...BM(e.previous.url?.link),
				className: "pagination-item arrow-link arrow-link--prev",
				"aria-label": t.paginationPrevious,
				children: /* @__PURE__ */ F(LM, {})
			}) : /* @__PURE__ */ F("span", {
				className: "pagination-item arrow-link arrow-link--prev disabled",
				children: /* @__PURE__ */ F(LM, {})
			}),
			/* @__PURE__ */ F("div", {
				className: "pagination-parts",
				children: n.map((e) => e.active ? /* @__PURE__ */ F("span", {
					className: "pagination-item current-page",
					"aria-current": "page",
					"aria-label": zM(t.paginationPage, e.number),
					children: /* @__PURE__ */ F("span", { children: e.number })
				}, e.number) : /* @__PURE__ */ F("a", {
					...BM(e.url?.link),
					className: "pagination-item page-link",
					"aria-label": zM(t.paginationPage, e.number),
					children: /* @__PURE__ */ F("span", { children: e.number })
				}, e.number))
			}),
			e.next ? /* @__PURE__ */ F("a", {
				...BM(e.next.url?.link),
				className: "pagination-item arrow-link arrow-link--next",
				"aria-label": t.paginationNext,
				children: /* @__PURE__ */ F(RM, {})
			}) : /* @__PURE__ */ F("span", {
				className: "pagination-item arrow-link arrow-link--next disabled",
				children: /* @__PURE__ */ F(RM, {})
			})
		]
	});
}), HM = (e, t, n) => String(e || "__CURRENT__ / __TOTAL__").replaceAll("__CURRENT__", String(t)).replaceAll("__TOTAL__", String(n)), UM = (e = {}, t) => {
	let n = Number(e.totalResults) || 0, r = Number(e.end), i = t == null ? r : Number(t), a = Math.min(Number.isFinite(i) && i > 0 ? i : r, n);
	return {
		shown: a,
		total: n,
		percent: n > 0 ? Math.min(100, a / n * 100) : 0
	};
};
Q(), Ae();
var WM = ({ pagination: e, displayedCount: t, labels: n }) => {
	let { shown: r, total: i, percent: a } = UM(e, t), o = HM(n.loadMoreProgress, r, i);
	return /* @__PURE__ */ F("div", {
		className: "athos-load-more__status",
		children: [/* @__PURE__ */ F("p", {
			className: "athos-load-more__progress-text",
			children: o
		}), /* @__PURE__ */ F("div", {
			className: "athos-load-more__progress-shell",
			role: "progressbar",
			"aria-valuenow": r,
			"aria-valuemin": 0,
			"aria-valuemax": i,
			"aria-label": o,
			children: /* @__PURE__ */ F("div", {
				className: "athos-load-more__progress-meter",
				style: { transform: `scaleX(${a / 100})` }
			})
		})]
	});
}, GM = Z(({ pagination: e, displayedCount: t, loading: n, labels: r = {} }) => !e?.totalResults || e.totalPages <= 1 ? null : /* @__PURE__ */ F("div", {
	className: "mt-48 mb-48 athos-load-more",
	children: [/* @__PURE__ */ F(WM, {
		pagination: e,
		displayedCount: t,
		labels: r
	}), e.next ? /* @__PURE__ */ F("button", {
		type: "button",
		className: `btn btn--primary size--medium${n ? " loading" : ""}`,
		disabled: n,
		"aria-busy": n || void 0,
		onClick: (t) => {
			t.preventDefault(), e.next.url?.link?.onClick?.(t);
		},
		children: /* @__PURE__ */ F("span", { children: r.loadMore })
	}) : null]
})), KM = (e) => {
	if (e == null || e === "") return null;
	let t = Number(String(e).trim().replace(/,/g, ""));
	return Number.isFinite(t) && t > 0 ? t : null;
}, qM = (e) => e.reduce((e, t) => {
	let n = KM(t?.price);
	if (n == null) return e;
	let r = KM(e?.price);
	return r == null || n < r ? t : e;
}, null), JM = ({ core: e = {}, variants: t = [] } = {}) => {
	let n = t.map((e) => KM(e?.price)).filter((e) => e != null), r = qM(t), i = KM(r?.price), a = KM(e.price), o = KM(e.msrp) ?? KM(e.compare_at_price), s = i ?? a ?? 0, c = r ? KM(r.compare_at_price) ?? o ?? 0 : o ?? 0;
	return {
		price: s,
		msrp: c,
		onSale: s > 0 && c > s,
		priceVaries: new Set(n).size > 1
	};
}, YM = (e) => /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(e), XM = (e) => {
	if (!e) return e || "";
	try {
		let t = new URL(e, "https://example.invalid");
		if (!t.searchParams.has("variant")) return e;
		t.searchParams.delete("variant");
		let n = t.searchParams.toString(), r = `${t.pathname}${n ? `?${n}` : ""}${t.hash}`;
		return YM(e) ? `${t.origin}${r}` : r;
	} catch {
		return e;
	}
}, ZM = 12, QM = (e) => {
	let t = e?.display?.mappings?.core || e?.mappings?.core || {}, n = e?.display?.mappings?.core?.url || "";
	return {
		coreUrl: t.url || "",
		displayUrl: n
	};
}, $M = (e, t) => !e || !t ? !1 : e.includes(t), eN = (e, t) => {
	if (!e || !t) return !1;
	let n = XM(t);
	if (!n) return !1;
	if (e === n || e.startsWith(`${n}?`)) return !0;
	try {
		return new URL(e, "https://example.invalid").pathname === new URL(n, "https://example.invalid").pathname;
	} catch {
		return !1;
	}
}, tN = (e, t) => {
	let { coreUrl: n, displayUrl: r } = QM(t), i = (e.composedPath ? e.composedPath() : [e.target]).slice(0, ZM);
	for (let e of i) {
		if (!(e instanceof Element)) continue;
		let t = e.getAttribute("href");
		if (t && ($M(t, n) || $M(t, r))) return !0;
	}
	return !1;
}, nN = (e, t, n) => {
	if (!t?.track?.product || !n || tN(e, n)) return;
	let { coreUrl: r, displayUrl: i } = QM(n), a = e.composedPath ? e.composedPath() : [e.target];
	for (let o of a.slice(0, ZM)) {
		if (!(o instanceof Element)) continue;
		let a = o.getAttribute("href");
		if (a && (eN(a, r) || eN(a, i))) {
			t.track.product.clickThrough(e, n);
			return;
		}
	}
}, rN = [
	180,
	390,
	540,
	768,
	1080,
	1500
], iN = "cdn.shopify.com", aN = (e, t = "https://www.stemma.fi") => {
	if (typeof e != "string") return null;
	let n = e.trim();
	if (!n) return null;
	try {
		let e = new URL(n, t);
		return e.protocol !== "http:" && e.protocol !== "https:" ? null : e;
	} catch {
		return null;
	}
}, oN = (e) => {
	let t = aN(e);
	return t ? t.href : "";
}, sN = (e) => {
	let t = aN(e);
	return t ? t.hostname === iN || t.pathname.startsWith("/cdn/shop/") : !1;
}, cN = (e, t) => {
	let n = aN(e);
	return n ? (n.searchParams.set("width", String(t)), n.href) : "";
}, lN = (e, { sizes: t = "", widths: n = rN } = {}) => {
	let r = oN(e);
	if (!r) return {
		src: "",
		srcSet: void 0,
		sizes: t || void 0
	};
	if (!sN(r)) return {
		src: r,
		srcSet: void 0,
		sizes: t || void 0
	};
	let i = n.map((e) => `${cN(r, e)} ${e}w`).join(", ");
	return {
		src: cN(r, 1500),
		srcSet: i,
		sizes: t || void 0
	};
}, uN = (e) => {
	if (typeof document > "u") return e;
	let t = document.createElement("textarea");
	return t.innerHTML = e, t.value;
}, dN = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", fN = (e) => {
	if (!e) return null;
	if (typeof e == "string") return {
		image: e,
		alt: ""
	};
	if (typeof e == "object") {
		let t = e.image || e.url || e.src;
		return t ? {
			image: t,
			alt: e.alt || ""
		} : null;
	}
	return null;
}, pN = (e) => {
	if (dN(e)) return Array.from(e).map(fN).filter(Boolean);
	if (!e || typeof e != "string") return [];
	try {
		let t = JSON.parse(uN(e));
		if (dN(t)) return Array.from(t).map(fN).filter(Boolean);
		let n = fN(t);
		return n ? [n] : [];
	} catch {
		return e.split("|").map((e) => e.trim()).filter(Boolean).map((e) => ({
			image: e,
			alt: ""
		}));
	}
}, mN = (e = {}) => {
	let t = pN(e.ss_alt_images);
	if (t.length > 0) return t;
	let n = pN(e.images);
	return n.length > 0 ? n : [];
}, hN = (e, t, n) => {
	if (n?.showSecondaryImage === !1) return null;
	let r = e?.imageUrl || e?.thumbnailImageUrl || "";
	return mN(t).find((e) => e?.image && e.image !== r) || null;
}, gN = [
	"sileäksi kudottu matto",
	"viskoosimatto",
	"nukkamatto"
], _N = (e) => {
	let t = String(e || "").trim();
	if (!t) return "";
	let n = t.toLowerCase(), r = [...gN].sort((e, t) => t.length - e.length);
	for (let e of r) {
		let r = e.toLowerCase();
		if (!n.endsWith(r) || t.length <= e.length + 1) continue;
		let i = t[t.length - e.length - 1];
		if (!(i && !/\s/.test(i))) return t.slice(-e.length);
	}
	let i = t.search(/\s+/);
	return i === -1 ? "" : t.slice(i).trim() || "";
}, vN = (e, t) => {
	let n = String(e || "").trim(), r = String(t || "").trim();
	if (!r || !n) return "";
	let i = n.toLowerCase(), a = r.toLowerCase();
	if (!i.includes(a)) return "";
	let o = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	return n.replace(new RegExp(o, "gi"), "").trim();
}, yN = (e, t, n = "", r = !1) => {
	let i = String(e || "").trim(), a = String(t || "").trim(), o = a ? vN(i, a) : "", s = a && i.toLowerCase().includes(a.toLowerCase()), c = s ? o : "";
	return !c && r && (c = String(n || "").trim()), {
		displayVendor: c,
		displayTitle: s ? a : i
	};
}, bN = (e = {}, t = {}) => {
	let n = (e) => e == null || e === "" ? "" : Array.isArray(e) ? String(e[0] || "").trim() : String(e).trim();
	return n(e.product_type) || n(e.ss_product_type) || n(e.type) || n(t.productType) || n(t.product_type) || n(t.type) || _N(t.name || n(e.title));
}, xN = "€{{amount}}", SN = (e) => Number.isFinite(e) && Math.abs(e - Math.round(e)) < 1e-9, CN = (e = {}) => e.moneyFormat ? e.moneyFormat : typeof window < "u" && window.theme?.settings?.moneyFormat ? window.theme.settings.moneyFormat : xN, wN = (e, t) => t ? e.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, "{{amount_no_decimals_with_comma_separator}}").replace(/\{\{\s*amount\s*\}\}/g, "{{amount_no_decimals}}") : e.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, "{{amount_with_comma_separator}}").replace(/\{\{\s*amount_no_decimals\s*\}\}/g, "{{amount}}"), TN = (e, t, n = ",", r = ".") => {
	if (Number.isNaN(e) || e == null) return "0";
	let i = (Number(e) / 100).toFixed(t).split(".");
	return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${n}`) + (i[1] ? r + i[1] : "");
}, EN = (e, t = xN) => {
	let n = /\{\{\s*(\w+)\s*\}\}/, r = t.match(n);
	if (!r) return String(e);
	let i;
	switch (r[1]) {
		case "amount_no_decimals":
			i = TN(e, 0);
			break;
		case "amount_with_comma_separator":
			i = TN(e, 2, ".", ",");
			break;
		case "amount_no_decimals_with_comma_separator":
			i = TN(e, 0, ".", ",");
			break;
		default: i = TN(e, 2);
	}
	return t.replace(n, i);
}, DN = (e, t = {}) => {
	let n = Math.round(Number(e) * 100);
	return t.applyCurrencyRate !== !1 && typeof window < "u" && window.Shopify?.currency?.rate && (n = Math.round(n * parseFloat(window.Shopify.currency.rate || 1))), n;
}, ON = (e, t = {}) => {
	let n = Number(e);
	if (!Number.isFinite(n)) return "";
	let r = wN(CN(t), SN(n)), i = DN(n, t);
	return typeof window < "u" && window.Woolman?.Utils?.formatMoney ? window.Woolman.Utils.formatMoney(i, r) : EN(i, r);
}, kN = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", AN = (e) => {
	if (e == null || e === "") return [];
	if (kN(e)) return Array.from(e).flatMap(AN);
	if (typeof e == "string") {
		let t = e.trim();
		if (!t) return [];
		if (t.startsWith("[")) try {
			return AN(JSON.parse(t));
		} catch {}
		return t.split(",").map((e) => e.trim()).filter(Boolean);
	}
	return [e];
}, jN = [
	"tags",
	"ss_tags",
	"_tags"
], MN = (e) => {
	let t = e?.display?.attributes || e?.attributes || {}, n = [];
	for (let e of jN) n.push(...AN(t[e]));
	n.push(...AN(e?.tags));
	let r = [], i = /* @__PURE__ */ new Set();
	return n.forEach((e) => {
		let t = String(e).trim();
		!t || i.has(t) || (i.add(t), r.push(t));
	}), r;
}, NN = (e, t) => {
	let n = String(t || "").trim();
	return n ? e.some((e) => String(e).trim() === n) : !1;
};
Q(), Ae();
var PN = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", FN = (e) => e == null || e === "" ? [] : PN(e) ? Array.from(e) : [e], IN = (e) => {
	let t = document.createElement("textarea");
	return t.innerHTML = e, t.value;
}, LN = (e) => {
	if (PN(e)) return Array.from(e);
	if (!e || typeof e != "string") return [];
	try {
		let t = JSON.parse(IN(e));
		return Array.isArray(t) ? t : [];
	} catch {
		return [];
	}
}, RN = [
	"color",
	"colour",
	"väri"
], zN = (e) => {
	let t = String(e?.colorSwatchIdentifiers || "").split(",").map((e) => e.trim().toLowerCase()).filter(Boolean);
	return t.length > 0 ? t : RN;
}, BN = (e, t) => {
	let n = String(e || "").toLowerCase();
	return n ? t.some((e) => n === e || e.includes(n) || n.includes(e)) : !1;
}, VN = (e, t) => {
	let n = (Array.isArray(e?.selected_options) ? e.selected_options : []).find((e) => BN(e?.name, t));
	return n?.value ? {
		name: n.name,
		value: n.value
	} : null;
}, HN = (e, t) => {
	let n = e?.options || {}, r = Object.entries(n).find(([e]) => BN(e, t));
	if (!r) return null;
	let [i, a] = r, o = a?.value || a;
	return o ? {
		name: i,
		value: o
	} : null;
}, UN = (e, t, n, r) => ({
	cssColor: GN(e),
	fallbackImageUrl: r,
	imageUrl: `/cdn/shop/files/${GN(e)}.png?crop=center&height=32&width=32`,
	label: e,
	optionName: t,
	url: n
}), WN = (e, t, n) => {
	let r = ON(e);
	return t ? (n.fromPriceHtml || "Alkaen {{ price }}").replace("{{ price }}", r).replace("__PRICE__", r) : r;
}, GN = (e) => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""), KN = (e) => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9_]+/g, "-").replace(/^-|-$/g, ""), qN = (e) => e ? e.split(";").map((e) => e.trim()).filter(Boolean).map((e) => {
	let [t, , , n] = e.split(":"), r = n || t;
	return {
		className: `custom-${KN(t)}`,
		label: r,
		tag: t
	};
}) : [], JN = (e, t, n) => qN(t).filter((t) => e.includes(t.tag)).map((e) => ({
	...e,
	ariaLabel: n?.replace("__LABEL__", e.label) || e.label
})), YN = (e, t, n) => {
	let r = zN(n), i = /* @__PURE__ */ new Map();
	return e.length > 0 ? (e.forEach((e) => {
		let t = VN(e, r);
		!t || i.has(t.value) || i.set(t.value, UN(t.value, t.name, e.url || e.shop_url));
	}), [...i.values()]) : (t.forEach((e) => {
		let t = HN(e, r);
		if (!t || i.has(t.value)) return;
		let n = e?.mappings?.core || {};
		i.set(t.value, UN(t.value, t.name, n.url, n.thumbnailImageUrl || n.imageUrl));
	}), [...i.values()]);
}, XN = ({ imageUrl: e, alt: t, labels: n }) => {
	let { src: r, srcSet: i, sizes: a } = lN(e, { sizes: n.imageSizes });
	return /* @__PURE__ */ F("figure", {
		className: "media contain square",
		children: r ? /* @__PURE__ */ F("img", {
			src: r,
			srcSet: i,
			sizes: a,
			alt: t,
			width: "600",
			height: "600",
			loading: n.imageLoading || "lazy",
			decoding: "async"
		}) : null
	});
}, ZN = ({ onSale: e, salePercentage: t, isPreorder: n, isNew: r, showSoldOut: i, customBadges: a, labels: o }) => !e && !n && !r && !i && a.length === 0 ? null : /* @__PURE__ */ F("div", {
	className: "badges",
	children: [
		e && /* @__PURE__ */ F("div", {
			className: "badge sale",
			"aria-label": o.badgeSale,
			children: [
				"-",
				t,
				"%"
			]
		}),
		n && /* @__PURE__ */ F("div", {
			className: "badge preorder",
			"aria-label": o.badgePreorder,
			children: o.preorder
		}),
		r && /* @__PURE__ */ F("div", {
			className: "badge new",
			"aria-label": o.badgeNew,
			children: o.newProduct
		}),
		i && /* @__PURE__ */ F("div", {
			className: "badge soldout",
			"aria-label": o.badgeSoldOut,
			children: o.soldOut
		}),
		a.map((e) => /* @__PURE__ */ F("div", {
			className: `badge ${e.className}`,
			"aria-label": e.ariaLabel,
			children: e.label
		}, e.tag))
	]
}), QN = Z(({ result: e, labels: t, controller: n }) => {
	let r = e?.display?.mappings?.core || e?.mappings?.core || {}, i = e?.display?.attributes || e?.attributes || {}, a = MN(e), o = bN(i, r), s = FN(i.vendor)[0] || r.brand || "", c = r.name || "", { displayVendor: l, displayTitle: u } = yN(c, o, s, t.showVendor === !0), d = LN(i.all_variants), { price: f, msrp: p, onSale: m, priceVaries: h } = JM({
		core: r,
		variants: d
	}), g = WN(f, h, t), _ = !!(t.customPriceTag && t.customPriceColor && NN(a, t.customPriceTag)), v = m ? Math.round((p - f) / p * 100) : 0, y = r.available === !0 || r.available === "true" || i.ss_available === "1", b = hN(r, i, t), x = FN(i.handle)[0], S = XM(r.url), C = r.parentId || FN(i.groupId)[0], w = Number(r.rating || 0), T = Number(r.ratingCount || 0), E = e?.variants?.data || [], D = t.enableSwatches === !1 ? [] : YN(d, E, t), O = NN(a, "New") || NN(a, "new"), k = NN(a, "Preorder") || NN(a, "preorder"), A = JN(a, t.customBadges, t.badgeCustomAria), j = NN(a, "Myymälätuote"), M = !y && !j, ee = t.cardType || "default", te = t.imagePadding || "default", ne = t.textAlign || "text-align-left", re = t.cardLayoutClass || "", ie = [
		"card-title",
		t.titleFontClass,
		t.titleSizeClass,
		t.titleSmSizeClass
	].filter(Boolean).join(" "), ae = !!re, oe = {
		onSale: m,
		salePercentage: v,
		isPreorder: k,
		isNew: O,
		showSoldOut: M,
		customBadges: A,
		labels: t
	}, se = (t) => {
		nN(t, n, e);
	};
	return /* @__PURE__ */ F("div", {
		className: [
			"card",
			"card--product",
			`card--${ee}`,
			re,
			b ? "on-hover" : ""
		].filter(Boolean).join(" "),
		children: [
			/* @__PURE__ */ F("a", {
				href: S,
				className: `card-media p-${te}`,
				"aria-hidden": "true",
				tabIndex: -1,
				onClick: se,
				children: [b ? /* @__PURE__ */ F("div", {
					className: "card-hover-images",
					children: [/* @__PURE__ */ F(XN, {
						imageUrl: r.imageUrl,
						alt: c,
						labels: t
					}), /* @__PURE__ */ F(XN, {
						imageUrl: b.image,
						alt: b.alt || "",
						labels: t
					})]
				}) : /* @__PURE__ */ F(XN, {
					imageUrl: r.imageUrl,
					alt: c,
					labels: t
				}), /* @__PURE__ */ F("div", {
					className: `card-media-overlay flex ${t.badgePosition || ""}`,
					children: !ae && /* @__PURE__ */ F(ZN, { ...oe })
				})]
			}),
			t.quickBuyEnabled && y && x && C && /* @__PURE__ */ F("quick-buy", {
				"data-product": C,
				"data-url": S,
				class: "js quick-buy quick-buy-or-add",
				children: /* @__PURE__ */ F("a", {
					className: "btn size--tiny btn--primary btn--full quick-buy_link",
					"data-product-handle": x,
					"data-url": S,
					href: `#modal-${C}-product`,
					"aria-haspopup": "dialog",
					"aria-label": t.quickBuyLabel.replace("__PRODUCT__", c),
					children: [/* @__PURE__ */ F("span", {
						className: "quick-buy_text",
						children: t.quickBuy
					}), /* @__PURE__ */ F("span", {
						className: "quick-buy_icon",
						"aria-hidden": "true",
						children: "+"
					})]
				})
			}),
			/* @__PURE__ */ F("div", {
				className: `card-body ${ne}`,
				children: [
					ae && /* @__PURE__ */ F(ZN, { ...oe }),
					t.stampedEnabled && C && /* @__PURE__ */ F("span", {
						className: "stamped-product-reviews-badge",
						"data-id": C,
						"data-product-sku": x,
						"data-product-title": c,
						"data-product-type": o
					}),
					!t.stampedEnabled && T > 0 && /* @__PURE__ */ F("div", {
						className: "athos-rating",
						"aria-label": `${w} / 5, ${T} ${t.reviews}`,
						children: [/* @__PURE__ */ F("span", {
							"aria-hidden": "true",
							children: ["★".repeat(Math.round(w)), "☆".repeat(5 - Math.round(w))]
						}), /* @__PURE__ */ F("span", {
							"aria-hidden": "true",
							children: [
								" (",
								T,
								")"
							]
						})]
					}),
					/* @__PURE__ */ F("div", {
						className: "card-info-grid",
						children: [
							l ? /* @__PURE__ */ F("span", {
								className: "card-vendor",
								children: l
							}) : null,
							/* @__PURE__ */ F("h3", {
								className: ie,
								children: /* @__PURE__ */ F("a", {
									href: S,
									onClick: se,
									children: u
								})
							}),
							f > 0 && /* @__PURE__ */ F("div", {
								className: [
									"price",
									"card-price-grid",
									m ? "price--on-sale" : "",
									_ ? "price--custom-color" : ""
								].filter(Boolean).join(" "),
								style: _ ? { "--price-custom-color": t.customPriceColor } : void 0,
								children: /* @__PURE__ */ F("div", {
									className: "flex",
									children: [/* @__PURE__ */ F("div", {
										className: "price__regular",
										children: [/* @__PURE__ */ F("span", {
											className: "visually-hidden",
											children: t.regularPrice
										}), /* @__PURE__ */ F("span", {
											className: "price-item price-item--regular",
											children: g
										})]
									}), /* @__PURE__ */ F("div", {
										className: "price__sale",
										children: [
											/* @__PURE__ */ F("span", {
												className: "visually-hidden",
												children: t.salePrice
											}),
											/* @__PURE__ */ F("span", {
												className: "price-item price-item--sale",
												children: g
											}),
											/* @__PURE__ */ F("span", {
												className: "visually-hidden",
												children: t.regularPrice
											}),
											/* @__PURE__ */ F("span", { children: /* @__PURE__ */ F("s", {
												className: "price-item price-item--regular price-item--last",
												children: ON(p)
											}) })
										]
									})]
								})
							})
						]
					}),
					D.length > 0 && /* @__PURE__ */ F("div", {
						className: "mt-12 swatches flex athos-swatches",
						children: [/* @__PURE__ */ F("span", {
							className: "visually-hidden",
							children: t.availableIn
						}), D.map((e) => {
							let t = oN(e.imageUrl), n = oN(e.fallbackImageUrl);
							return /* @__PURE__ */ F("a", {
								className: "swatch",
								href: e.url || S,
								children: [
									/* @__PURE__ */ F("span", {
										className: "color",
										style: { "--color": e.cssColor },
										"aria-hidden": "true"
									}),
									t ? /* @__PURE__ */ F("img", {
										className: "color",
										src: t,
										alt: e.label,
										width: "16",
										height: "16",
										loading: "lazy",
										style: { "--color": e.cssColor },
										onError: (e) => {
											if (n && !e.currentTarget.dataset.fallbackAttempted) {
												e.currentTarget.dataset.fallbackAttempted = "true", e.currentTarget.src = n;
												return;
											}
											e.currentTarget.hidden = !0;
										}
									}) : null,
									/* @__PURE__ */ F("span", {
										className: "visually-hidden",
										children: e.label
									})
								]
							}, `${e.optionName}-${e.label}`);
						})]
					})
				]
			})
		]
	});
}), $N = "drawer-filter", eP = "drawer-filter-sidebar", tP = () => window.matchMedia("(min-width: 1024px)").matches, nP = () => document.querySelector("#athos-content .athos-results-layout"), rP = () => {
	let e = document.getElementById(eP), t = nP();
	if (!e || !t) return;
	let n = e.classList.contains("is-open") && tP();
	t.classList.toggle("athos-filters-open", n), e.setAttribute("aria-hidden", n ? "false" : "true"), n ? e.removeAttribute("inert") : e.setAttribute("inert", "");
}, iP = (e) => {
	e?.querySelector(".drawer-header .close")?.focus();
}, aP = () => {
	let e = document.getElementById(eP), t = nP();
	!e || !t || t.contains(e) || (t.insertBefore(e, t.firstChild), rP());
}, oP = () => {
	let e = document.getElementById(eP);
	e && (new MutationObserver(() => {
		rP();
	}).observe(e, {
		attributes: !0,
		attributeFilter: ["class"]
	}), document.addEventListener("woolman:resize", rP), document.addEventListener("click", (e) => {
		tP() && e.target.closest("[data-athos-filter-close], [data-close]")?.closest("#drawer-filter-sidebar") && queueMicrotask(rP);
	}));
}, sP = () => {
	let e = document.getElementById(eP);
	e && (e.classList.remove("is-open"), rP(), document.querySelector(".athos-filters-toggle")?.focus());
}, cP = () => {
	let e = document.getElementById(eP);
	e && (aP(), e.classList.add("initialized", "is-open"), rP(), iP(e));
}, lP = (e) => {
	if (e.preventDefault(), !tP()) {
		let e = window.Woolman?.ModalsAndDrawers, t = document.getElementById($N);
		if (!t || !e) return;
		if (t.classList.contains("is-open")) {
			e.closeModalOrDrawer($N);
			return;
		}
		e.showModalOrDrawer($N), iP(t);
		return;
	}
	let t = document.getElementById(eP);
	if (t) {
		if (t.classList.contains("is-open")) {
			sP();
			return;
		}
		cP();
	}
}, uP = (e) => {
	e?.urlManager?.remove("filter")?.remove("page")?.go();
}, dP = ({ filteredCount: e, totalCount: t, labels: n = {} }) => {
	let r = Number(e) || 0, i = t == null || t === "" ? NaN : Number(t);
	if (Number.isFinite(i) && r !== i) {
		let e = r === 1 ? n.productCountOne : n.productCountOther;
		return e ? e.replaceAll("__FILTERED__", String(r)).replaceAll("__TOTAL__", String(i)) : `${r} / ${i} ${n.products || ""}`.trim();
	}
	let a = r === 1 ? n.productCountSimpleOne : n.productCountSimpleOther;
	return a ? a.replaceAll("__COUNT__", String(r)) : `${r} ${n.products || ""}`.trim();
}, fP = {
	columns: 1,
	smColumns: 3,
	mdColumns: 4
}, pP = (e, t) => {
	let n = Number(e);
	return Number.isInteger(n) && n >= 1 && n <= 6 ? n : t;
}, mP = ({ columns: e, smColumns: t, mdColumns: n } = {}) => `grid sm-gap grid-cols-${pP(e, fP.columns)} sm-grid-cols-${pP(t, fP.smColumns)} md-grid-cols-${pP(n, fP.mdColumns)} mt-24 sm-mt-gutter`, hP = () => {
	if (typeof window > "u") return;
	let e = requestAnimationFrame(() => {
		window.StampedFn?.loadBadges?.();
	});
	return () => cancelAnimationFrame(e);
}, gP = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", _P = (e) => e == null || e === !1 ? !1 : gP(e) ? Array.from(e).some(_P) : typeof e == "object" ? _P(e.value) : String(e).trim().length > 0, vP = (e, t) => _P(e?.[t]), yP = (e) => {
	let t = String(e?.didYouMean?.string ?? "").trim(), n = String(e?.query?.string ?? "").trim();
	return !t || t.toLowerCase() === n.toLowerCase() ? "" : t;
}, bP = "at22v8", xP = (e) => e?.display?.mappings?.core || e?.mappings?.core || e || {}, SP = (e) => {
	let t = String(xP(e).url || ""), n = t;
	try {
		n = new URL(t, "https://example.invalid").pathname;
	} catch {
		n = t;
	}
	return n.includes("/blogs/") || n.includes("/articles/") ? "blog" : n.includes("/pages/") ? "page" : n.includes("/collections/") ? "collection" : "product";
}, CP = (e, t, n) => {
	let r = xP(e), i = String(r.name || "").trim(), a = String(r.url || "").trim();
	return !i || !a || SP(e) !== n ? null : {
		id: `${n}-${t + 1}`,
		href: a,
		title: i
	};
}, wP = (e = []) => {
	let t = [], n = [], r = /* @__PURE__ */ new Set();
	return e.forEach((e) => {
		let i = SP(e);
		if (i !== "collection" && i !== "page") return;
		let a = CP(e, i === "collection" ? t.length : n.length, i);
		!a || r.has(a.href) || (r.add(a.href), i === "collection" ? t.push(a) : n.push(a));
	}), {
		collections: t,
		pages: n
	};
}, TP = /* @__PURE__ */ new WeakMap(), EP = (e) => {
	if (TP.has(e)) return TP.get(e);
	let t = e(`https://${bP}.a.athoscommerce.net/v1/search?siteId=${bP}&q=*&resultsPerPage=50`).then((e) => e?.ok ? e.json() : { results: [] }).then((e) => Array.isArray(e?.results) ? e.results : []).catch(() => []);
	return TP.set(e, t), t;
}, DP = async (e, t = globalThis.fetch) => {
	let n = String(e ?? "").trim().toLowerCase();
	return !n || typeof t != "function" ? [] : (await EP(t)).filter((e) => String(e?.name || "").toLowerCase().includes(n));
}, OP = "(max-width: 767px)", kP = (e, t = 3) => {
	let n = [], r = 0;
	return e.forEach((e, i) => {
		let a = n.indexOf(e);
		a === -1 && (n.push(e), a = n.length - 1), a < t && (r = i + 1);
	}), {
		rowCount: n.length,
		visibleCount: r,
		needsToggle: n.length > t
	};
}, AP = (e, t = 3) => e ? kP([...e.children].filter((e) => e.tagName === "LI").map((e) => e.offsetTop), t) : {
	rowCount: 0,
	visibleCount: 0,
	needsToggle: !1
};
//#endregion
//#region src/athos/components/AthosRecommendationSkeleton.jsx
Ae();
var jP = () => {
	if (typeof document > "u") return {
		showRating: !1,
		showSwatches: !1
	};
	try {
		let e = JSON.parse(document.getElementById("athos-product-card-config")?.textContent || "{}");
		return {
			showRating: e.labels?.stampedEnabled === !0,
			showSwatches: e.enableSwatches === !0
		};
	} catch {
		return {
			showRating: !1,
			showSwatches: !1
		};
	}
}, MP = () => {
	let { showRating: e, showSwatches: t } = jP();
	return /* @__PURE__ */ F("div", {
		className: "card card--product athos-rec-skeleton",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ F("div", {
			className: "card-media",
			children: /* @__PURE__ */ F("figure", { className: "media contain square pulse" })
		}), /* @__PURE__ */ F("div", {
			className: "card-body",
			children: [
				e ? /* @__PURE__ */ F("span", { className: "athos-rec-skeleton__rating pulse" }) : null,
				/* @__PURE__ */ F("div", {
					className: "card-info-grid",
					children: [
						/* @__PURE__ */ F("span", { className: "card-vendor athos-rec-skeleton__line athos-rec-skeleton__line--vendor pulse" }),
						/* @__PURE__ */ F("span", { className: "card-title athos-rec-skeleton__line athos-rec-skeleton__line--title pulse" }),
						/* @__PURE__ */ F("span", { className: "price card-price-grid athos-rec-skeleton__line athos-rec-skeleton__line--price pulse" })
					]
				}),
				t ? /* @__PURE__ */ F("span", {
					className: "mt-12 athos-rec-skeleton__swatches",
					children: [/* @__PURE__ */ F("span", { className: "pulse" }), /* @__PURE__ */ F("span", { className: "pulse" })]
				}) : null
			]
		})]
	});
};
R(), Ae();
var NP = (e, t) => `profile = ${JSON.stringify(e)}; options = { limit: ${Number(t) || 10}, beacon: true };`, PP = ({ profile: e, limit: t = 10, labels: n = {} }) => {
	let r = Pe(null), i = Pe(null);
	L(() => {
		let n = r.current, a = String(e ?? "").trim();
		if (!n || !a) return;
		let o = document.createElement("script");
		return o.type = "athos/recommend", o.textContent = NP(a, t), n.appendChild(o), i.current = o, typeof window < "u" && typeof window.mountAthosRecommendations == "function" ? window.mountAthosRecommendations(document) : document.dispatchEvent(new CustomEvent("athos:recommendations:mount")), () => {
			o.remove(), i.current = null, n.querySelectorAll("[searchspring-recommend]").forEach((e) => e.remove());
		};
	}, [e, t]);
	let a = mP(n), o = String(e ?? "").trim(), s = Number(t), c = Number.isFinite(s) && s > 0 ? s : 10;
	return /* @__PURE__ */ F("div", {
		id: "athos-search-no-results-recs",
		className: "athos-search-no-results-recs",
		"data-context": "athos_recommendations",
		"aria-busy": o ? "true" : void 0,
		children: [
			o ? /* @__PURE__ */ F("p", {
				className: "visually-hidden athos-rec-skeleton-status",
				role: "status",
				children: n.loading || "Loading..."
			}) : null,
			o ? /* @__PURE__ */ F("div", {
				className: `grid sm-gap athos-rec-skeleton-grid ${a}`,
				style: {
					"--gap": n.gridGap || "var(--gutter)",
					"--sm-gap": n.smGridGap || "var(--gutter)"
				},
				children: Array.from({ length: c }, (e, t) => /* @__PURE__ */ F(MP, {}, t))
			}) : null,
			/* @__PURE__ */ F("div", {
				ref: r,
				className: `grid sm-gap ss__results ${a}`,
				style: {
					"--gap": n.gridGap || "var(--gutter)",
					"--sm-gap": n.smGridGap || "var(--gutter)"
				}
			})
		]
	});
};
Q(), R(), Ae();
var FP = () => /* @__PURE__ */ F("svg", {
	role: "presentation",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	width: "18",
	height: "18",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "2",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	children: [
		/* @__PURE__ */ F("line", {
			x1: "4",
			y1: "6",
			x2: "20",
			y2: "6"
		}),
		/* @__PURE__ */ F("line", {
			x1: "7",
			y1: "12",
			x2: "17",
			y2: "12"
		}),
		/* @__PURE__ */ F("line", {
			x1: "10",
			y1: "18",
			x2: "14",
			y2: "18"
		})
	]
}), IP = () => /* @__PURE__ */ F("svg", {
	role: "presentation",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	width: "24",
	height: "24",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "2",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-chevron-down",
	children: /* @__PURE__ */ F("polyline", { points: "6 9 12 15 18 9" })
}), LP = (e, t) => {
	if (t.pageType !== "search" || !t.documentTitle || t.nativeCount == null) return;
	let n = t.documentTitle.replace(String(t.nativeCount), String(e));
	n !== document.title && (document.title = n);
}, RP = () => {
	let [e, t] = I(!1);
	return L(() => {
		let e = window.matchMedia(OP), n = () => t(e.matches);
		return n(), e.addEventListener("change", n), () => e.removeEventListener("change", n);
	}, []), e;
}, zP = ({ id: e, heading: t, items: n, labels: r }) => {
	let i = Pe(null), a = RP(), [o, s] = I(!1), [c, l] = I({
		visibleCount: n.length,
		needsToggle: !1
	}), u = Le(() => {
		if (!a || o) {
			l({
				visibleCount: n.length,
				needsToggle: !1
			});
			return;
		}
		l(AP(i.current, 3));
	}, [
		o,
		a,
		n.length
	]);
	if (Ne(() => {
		u();
	}, [n, u]), L(() => {
		s(!1);
	}, [n]), L(() => {
		if (!i.current) return;
		let e = new ResizeObserver(() => u());
		return e.observe(i.current), () => e.disconnect();
	}, [u]), !n.length) return null;
	let d = a && !o && c.needsToggle, f = d ? Math.max(n.length - c.visibleCount, 0) : 0, p = `${e}-toggle`;
	return /* @__PURE__ */ F("section", {
		className: "athos-content-links__section",
		"aria-label": t,
		id: e,
		children: [/* @__PURE__ */ F("ul", {
			ref: i,
			className: "athos-content-links__list",
			id: `${e}-list`,
			children: n.map((e, t) => /* @__PURE__ */ F("li", {
				hidden: d && t >= c.visibleCount,
				children: /* @__PURE__ */ F("a", {
					className: "athos-content-link-btn",
					href: e.href,
					children: e.title
				})
			}, e.id))
		}), a && c.needsToggle && /* @__PURE__ */ F("button", {
			type: "button",
			id: p,
			className: "btn btn--link size--small athos-content-links__toggle",
			"aria-expanded": o,
			"aria-controls": `${e}-list`,
			onClick: () => s((e) => !e),
			children: [o ? r.facetShowLess || "Show less" : r.facetShowMore || "Show more", d && f > 0 ? ` (${f})` : ""]
		})]
	});
}, BP = ({ links: e, labels: t }) => {
	let n = e.collections || [], r = e.pages || [];
	return !n.length && !r.length ? null : /* @__PURE__ */ F("div", {
		className: "athos-content-links",
		children: [/* @__PURE__ */ F(zP, {
			id: "athos-search-collections",
			heading: t.collections,
			items: n,
			labels: t
		}), /* @__PURE__ */ F(zP, {
			id: "athos-search-pages",
			heading: t.pages,
			items: r,
			labels: t
		})]
	});
}, VP = Z(({ controller: e, labels: t }) => {
	let { store: n } = e, r = Pe(null), [i, a] = I([]), o = t.pageType === "search" ? String(n.search?.query?.string || "") : "";
	if (L(() => {
		if (!o) {
			a([]);
			return;
		}
		let e = !1;
		return DP(o).then((t) => {
			e || a(t);
		}).catch(() => {
			e || a([]);
		}), () => {
			e = !0;
		};
	}, [o]), L(() => {
		if (!(!n.loaded || !t.stampedEnabled)) return hP();
	}, [
		t.stampedEnabled,
		n.loaded,
		n.results.length
	]), L(() => {
		if (!n.loaded) return;
		let e = n.pagination.page;
		if (t.paginationType === "button") {
			NM(e);
			return;
		}
		if (!MM(e)) {
			NM(e);
			return;
		}
		let i = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches, a = !1, o = requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				a || (IM(r.current || document.getElementById("athos-results"), { reducedMotion: i }), PM(e));
			});
		});
		return () => {
			a = !0, cancelAnimationFrame(o);
		};
	}, [
		t.paginationType,
		n.loaded,
		n.pagination.page,
		n.results.length
	]), L(() => {
		!n.loaded || t.enableFiltering === !1 || aP();
	}, [t.enableFiltering, n.loaded]), L(() => {
		n.loaded && LP(n.pagination.totalResults, t);
	}, [
		t.documentTitle,
		t.nativeCount,
		t.pageType,
		n.loaded,
		n.pagination.totalResults
	]), !n.loaded) return /* @__PURE__ */ F(EM, { loadingLabel: t.loading });
	let s = n.sorting?.options?.length ? n.sorting : {
		options: [],
		current: null
	}, c = t.showCount !== !1, l = t.enableFiltering !== !1, u = t.enableSorting !== !1 && s.options.length > 0, d = [
		c,
		l,
		u
	].filter(Boolean).length, f = SM(n.filters).length, p = f > 0, m = dP({
		filteredCount: n.pagination.totalResults,
		totalCount: p ? t.allProductsCount : n.pagination.totalResults,
		labels: t
	}), h = n.merchandising?.content, g = t.pageType === "search" ? wP([...n.results || [], ...i]) : {
		collections: [],
		pages: []
	}, _ = t.pageType === "search" ? (n.results || []).filter((e) => SP(e) === "product") : n.results, v = t.pageType === "search" ? yP(n.search) : "";
	return /* @__PURE__ */ F(Zx, {
		controller: e,
		children: [
			vP(h, "header") ? /* @__PURE__ */ F(tD, {
				content: h,
				type: "header"
			}) : null,
			v ? /* @__PURE__ */ F("p", {
				className: "athos-did-you-mean size--small",
				children: /* @__PURE__ */ F("a", {
					href: n.search.didYouMean.url?.href,
					children: String(t.didYouMean || "").replaceAll("__QUERY__", v)
				})
			}) : null,
			/* @__PURE__ */ F(BP, {
				links: g,
				labels: t
			}),
			/* @__PURE__ */ F("div", {
				id: DM,
				className: "athos-results",
				tabIndex: -1,
				ref: r,
				children: [d > 0 && /* @__PURE__ */ F("div", {
					className: `product-grid-actions athos-grid-actions items-count-${d}`,
					children: [l && /* @__PURE__ */ F("div", {
						className: "athos-filter-toolbar",
						children: [/* @__PURE__ */ F("a", {
							className: "btn btn--primary size--small athos-filters-toggle filters-button",
							href: "#drawer-filter",
							onClick: lP,
							"aria-label": p ? `${t.filterToggle || t.filterButton || t.filters} (${f})` : void 0,
							children: [
								/* @__PURE__ */ F("span", {
									className: "athos-filters-toggle__icon",
									"aria-hidden": "true",
									children: /* @__PURE__ */ F(FP, {})
								}),
								/* @__PURE__ */ F("span", {
									className: "athos-filters-toggle__label",
									children: t.filterToggle || t.filterButton || t.filters
								}),
								p ? /* @__PURE__ */ F("span", {
									className: "athos-filters-toggle__count",
									"aria-hidden": "true",
									children: f
								}) : null
							]
						}), p ? /* @__PURE__ */ F("a", {
							href: "#",
							className: "athos-clear-filters link size--small",
							onClick: (t) => {
								t.preventDefault(), uP(e);
							},
							children: t.clearAll
						}) : null]
					}), (c || u) && /* @__PURE__ */ F("div", {
						className: "athos-grid-actions__meta",
						children: [
							c && /* @__PURE__ */ F("p", {
								className: "products-count size--tiny",
								id: "products-count-ajax",
								role: "status",
								children: m
							}),
							c && u && /* @__PURE__ */ F("span", {
								className: "athos-grid-actions__divider size--small",
								"aria-hidden": "true",
								children: "|"
							}),
							u && /* @__PURE__ */ F("label", {
								className: "sort-by athos-sort",
								children: [
									/* @__PURE__ */ F("span", {
										className: "athos-sort__label size--small",
										children: t.sortLabel || t.sort
									}),
									/* @__PURE__ */ F("span", {
										className: "athos-sort__value size--small",
										children: s.current?.label
									}),
									/* @__PURE__ */ F("span", {
										className: "athos-sort__caret",
										"aria-hidden": "true",
										children: /* @__PURE__ */ F(IP, {})
									}),
									/* @__PURE__ */ F("select", {
										id: "athos-sort-by",
										name: t.sortByName || "sort_by",
										className: "athos-sort__select",
										"aria-label": t.sort,
										value: s.current?.value,
										onChange: (e) => {
											s.options.find((t) => t.value === e.currentTarget.value)?.url.go();
										},
										children: s.options.map((e) => /* @__PURE__ */ F("option", {
											value: e.value,
											children: e.label
										}, e.value))
									})
								]
							})
						]
					})]
				}), l && /* @__PURE__ */ F(wM, { controller: e })]
			}),
			/* @__PURE__ */ F("div", {
				className: "athos-results-layout",
				children: /* @__PURE__ */ F("div", {
					className: "athos-results-main col-products",
					children: [
						vP(h, "banner") ? /* @__PURE__ */ F(tD, {
							content: h,
							type: "banner"
						}) : null,
						n.pagination.totalResults > 0 ? /* @__PURE__ */ F(XE, {
							controller: e,
							results: _,
							resultComponent: /* @__PURE__ */ F(QN, { labels: t }),
							className: mP(t),
							style: {
								"--gap": t.gridGap || "var(--gutter)",
								"--sm-gap": t.smGridGap || "var(--gutter)"
							},
							disableStyles: !0
						}) : /* @__PURE__ */ F("div", {
							className: "athos-no-results",
							role: "status",
							children: [
								t.pageType === "collection" ? /* @__PURE__ */ F("h2", { children: t.noResultsTitle }) : /* @__PURE__ */ F("p", { children: t.noResultsTitle }),
								/* @__PURE__ */ F("p", { children: t.noResultsBody }),
								t.pageType === "search" && t.continueShoppingUrl && /* @__PURE__ */ F("a", {
									className: "link",
									href: t.continueShoppingUrl,
									children: t.continueShopping
								}),
								t.pageType === "search" && t.searchNoResultsProfile ? /* @__PURE__ */ F(PP, {
									profile: t.searchNoResultsProfile,
									limit: t.searchNoResultsLimit,
									labels: t
								}) : null
							]
						}),
						n.pagination.totalResults > 0 && (t.paginationType === "button" ? /* @__PURE__ */ F(GM, {
							pagination: n.pagination,
							displayedCount: _.length,
							loading: n.loading,
							labels: t
						}) : /* @__PURE__ */ F(VM, {
							pagination: n.pagination,
							labels: t
						})),
						vP(h, "footer") ? /* @__PURE__ */ F(tD, {
							content: h,
							type: "footer"
						}) : null
					]
				})
			})
		]
	});
}), HP = [
	"Muoto",
	"Henkilömäärä",
	"Materiaali",
	"Ominaisuus",
	"Kotimaisuus",
	"Tuotemerkki"
], UP = (e) => String(e.value ?? e.label ?? "").trim(), WP = (e) => {
	if (e?.enableTagFilterGrouping === !1) return [];
	let t = (e?.tagFilterKeys || []).map((e) => String(e).trim()).filter(Boolean);
	return t.length > 0 ? t : HP;
}, GP = (e, t) => Object.assign(Object.create(Object.getPrototypeOf(e)), e, t), KP = (e) => Array.from(e || []).slice().sort((e, t) => String(e.label ?? e.value ?? "").localeCompare(String(t.label ?? t.value ?? ""), "fi", {
	numeric: !0,
	sensitivity: "base"
})), qP = (e) => String(e?.label ?? e?.value ?? "").trim(), JP = (e) => {
	let t = qP(e), n = t.match(/^(\d+)\s*x\s*(\d+)\s*cm/i);
	if (n) return {
		kind: "multi",
		primary: Number(n[1]),
		secondary: Number(n[2]),
		label: t
	};
	let r = t.match(/^(\d+)\s*cm\b/i);
	return r ? {
		kind: "single",
		primary: Number(r[1]),
		secondary: 0,
		label: t
	} : {
		kind: "other",
		primary: Infinity,
		secondary: 0,
		label: t
	};
}, YP = {
	single: 0,
	multi: 1,
	other: 2
}, XP = (e, t) => {
	let n = JP(e), r = JP(t), i = YP[n.kind] - YP[r.kind];
	return i === 0 ? n.primary === r.primary ? n.secondary === r.secondary ? n.label.localeCompare(r.label, "fi", {
		numeric: !0,
		sensitivity: "base"
	}) : n.secondary - r.secondary : n.primary - r.primary : i;
}, ZP = (e) => Array.from(e || []).slice().sort(XP), QP = (e) => {
	let t = Array.from(e?.values || []);
	return e?.field === "koko" ? ZP(t) : KP(t);
}, $P = (e, t) => {
	let n = `${t}:`, r = e.values.filter((e) => {
		let n = UP(e);
		return n.includes(":") ? n.split(":")[0].trim() === t : !1;
	}).map((e) => {
		let t = UP(e), r = t.startsWith(n) ? t.slice(n.length).trim() : e.label;
		return {
			...e,
			label: r
		};
	});
	return r.length === 0 ? null : GP(e, {
		label: t,
		values: r
	});
}, eF = /* @__PURE__ */ new Set([
	"tags",
	"_tags",
	"ss_tags"
]), tF = (e) => e.field === "price" ? GP(e, { formatValue: "%01.0f €" }) : e, nF = (e) => !e || !eF.has(e.field) || e.field === "tags" ? e : GP(e, {
	field: "tags",
	label: e.label || "tags"
}), rF = ({ storeFacets: e = [], tagFacetKeys: t = [], useTagGrouping: n = !1, fallbackPriceFacet: r = null }) => {
	let i = e.map(nF), a = i.find((e) => e.field === "price"), o = a || r, s = i.filter((e) => e?.field && !(e.field === "tags" && n)).map(tF);
	!s.some((e) => e.field === "price") && o && (s = [tF(o), ...s]);
	let c = i.find((e) => e.field === "tags"), l = n && c ? t.map((e) => [e, $P(c, e)]).filter(([, e]) => e) : [];
	return {
		facets: s,
		groupedTagFacets: l,
		priceFacet: a || o
	};
}, iF = (e) => {
	let t = WP(e);
	return {
		tagFacetKeys: t,
		useTagGrouping: t.length > 0
	};
}, aF = (e, t = []) => e?.field === "tags" && e?.label && e.label !== "tags" && t.includes(e.label), oF = (e, t = 10) => {
	e?.overflow?.setLimit?.(t), e?.overflow?.calculate?.();
}, sF = (e) => QP(e), cF = (e, { expanded: t = !1, limit: n = 10 } = {}) => {
	let r = sF(e), i = e?.overflow?.limit > 0 ? e.overflow.limit : n;
	if (r.length <= i) return {
		values: r,
		showToggle: !1,
		isCollapsed: !1,
		remaining: 0
	};
	if (t) return {
		values: r,
		showToggle: !0,
		isCollapsed: !1,
		remaining: 0
	};
	let a = e?.overflow;
	if (!(!a?.enabled || a.limited)) return {
		values: r,
		showToggle: !0,
		isCollapsed: !1,
		remaining: 0
	};
	let o = a?.enabled && a.remaining != null ? a.remaining : r.length - i;
	return {
		values: r.slice(0, i),
		showToggle: !0,
		isCollapsed: !0,
		remaining: o
	};
}, lF = 400, uF = (e) => {
	let t = e.querySelector("summary"), n = e.querySelector(".content");
	if (!t || !n) return () => {};
	let r = null, i = !1, a = (t) => {
		e.open = t, r = null, i = !1, e.style.height = "", e.style.overflow = "";
	}, o = (t, n, o, s) => {
		r?.cancel(), r = e.animate({ height: [t, n] }, {
			duration: lF,
			easing: o
		}), r.onfinish = () => a(s), r.oncancel = () => {
			i = !1;
		};
	}, s = () => {
		o(`${e.offsetHeight}px`, `${t.offsetHeight + n.offsetHeight}px`, "ease-out", !0);
	}, c = () => {
		i = !0, o(`${e.offsetHeight}px`, `${t.offsetHeight}px`, "ease-in-out", !1);
	}, l = (t) => {
		if (t.preventDefault(), e.style.overflow = "hidden", i || !e.open) {
			e.style.height = `${e.offsetHeight}px`, e.open = !0, window.requestAnimationFrame(s);
			return;
		}
		c();
	};
	return t.addEventListener("click", l), () => {
		t.removeEventListener("click", l), r?.cancel();
	};
}, dF = (e, t) => {
	let n = Number(e);
	return Number.isFinite(n) ? n : t;
}, fF = (e) => {
	let t = Math.floor(dF(e?.range?.low, 0)), n = Math.ceil(dF(e?.range?.high, t));
	return {
		min: t,
		max: n,
		from: Math.floor(dF(e?.active?.low, t)),
		to: Math.ceil(dF(e?.active?.high, n))
	};
}, pF = (e, t, n) => {
	let r = e?.services?.urlManager, { min: i, max: a } = fF(e);
	if (!r || !e?.field) return;
	let o = Math.min(Math.max(Math.round(dF(t, i)), i), a), s = Math.min(Math.max(Math.round(dF(n, a)), i), a), c = Math.min(o, s), l = Math.max(o, s);
	if (c === i && l === a) {
		r.remove("page")?.remove(`filter.${e.field}`)?.go();
		return;
	}
	r.remove("page")?.set(`filter.${e.field}`, {
		low: c,
		high: l
	})?.go();
};
Q(), R(), gM(), Ae();
var mF = () => /* @__PURE__ */ F("svg", {
	role: "presentation",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	width: "24",
	height: "24",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "2",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "feather feather-chevron-down",
	children: /* @__PURE__ */ F("polyline", { points: "6 9 12 15 18 9" })
}), hF = (e) => e.field === "price" || e.type === "range" || e.display === "slider", gF = ({ value: e, labels: t }) => {
	let n = e.count === 0 && !e.filtered, r = dP({
		filteredCount: e.count,
		totalCount: e.count,
		labels: t
	});
	return /* @__PURE__ */ F("li", {
		className: `filter-option${n ? " filter-option--disabled" : ""}`,
		children: /* @__PURE__ */ F("label", {
			className: `filter-type-default${n ? " disabled" : ""}`,
			children: [
				/* @__PURE__ */ F("input", {
					type: "checkbox",
					className: "checkbox",
					checked: !!e.filtered,
					disabled: n,
					onChange: (t) => {
						t.preventDefault(), n || e.url?.go();
					}
				}),
				/* @__PURE__ */ F("span", {
					className: "filter-option__label",
					"aria-hidden": "true",
					children: e.label
				}),
				/* @__PURE__ */ F("span", {
					className: "filter-option__count",
					"aria-hidden": "true",
					children: [
						"(",
						e.count,
						")"
					]
				}),
				/* @__PURE__ */ F("span", {
					className: "visually-hidden",
					children: [
						e.label,
						" (",
						r,
						")"
					]
				})
			]
		})
	});
}, _F = ({ facet: e, children: t }) => {
	let n = Pe(null);
	return L(() => {
		let e = n.current;
		if (e) return uF(e);
	}, []), /* @__PURE__ */ F("details", {
		ref: n,
		className: "filter-group",
		open: !0,
		children: [/* @__PURE__ */ F("summary", { children: [/* @__PURE__ */ F("span", { children: e.label }), /* @__PURE__ */ F(mF, {})] }), /* @__PURE__ */ F("div", {
			className: "content pt-12 pb-24",
			children: t
		})]
	});
}, vF = ({ isCollapsed: e, remaining: t, labels: n, onToggle: r }) => /* @__PURE__ */ F("button", {
	type: "button",
	className: "btn btn--link size--small filter-facet-show-more mt-8",
	"aria-expanded": !e,
	onClick: (e) => {
		e.preventDefault(), r();
	},
	children: [e ? n.facetShowMore || "Show more" : n.facetShowLess || "Show less", e && t > 0 ? ` (${t})` : ""]
}), yF = Z(({ facet: e, labels: t, tagFacetKeys: n }) => {
	let r = aF(e, n), [i, a] = I(!1);
	L(() => {
		r || oF(e);
	}, [
		e,
		e?.values?.length,
		r
	]);
	let { values: o, showToggle: s, isCollapsed: c, remaining: l } = cF(e, { expanded: r ? i : e?.overflow?.enabled && !e.overflow.limited });
	return /* @__PURE__ */ F(_F, {
		facet: e,
		children: /* @__PURE__ */ F("fieldset", { children: [
			/* @__PURE__ */ F("legend", {
				className: "visually-hidden",
				children: e.label
			}),
			/* @__PURE__ */ F("ul", {
				className: "filter-options-list default",
				style: { gap: "8px" },
				children: o.map((e) => /* @__PURE__ */ F(gF, {
					value: e,
					labels: t
				}, String(e.value ?? e.label)))
			}),
			s && /* @__PURE__ */ F(vF, {
				isCollapsed: c,
				remaining: l,
				labels: t,
				onToggle: () => {
					if (r) {
						a((e) => !e);
						return;
					}
					e?.overflow?.toggle?.();
				}
			})
		] })
	});
}), bF = Z(({ facet: e, labels: t }) => {
	let n = Ve(), { min: r, max: i, from: a, to: o } = fF(e), [s, c] = I(String(a)), [l, u] = I(String(o));
	if (L(() => {
		c(String(a)), u(String(o));
	}, [a, o]), !e?.range) return null;
	let d = () => {
		pF(e, s, l);
	};
	return /* @__PURE__ */ F("div", {
		className: "price-range-slider",
		children: /* @__PURE__ */ F("div", {
			className: "inputs",
			children: [
				/* @__PURE__ */ F("div", {
					className: "price-range-input-wrapper",
					children: [/* @__PURE__ */ F("label", {
						htmlFor: `${n}-from`,
						className: "currency",
						children: t.currencySymbol || "€"
					}), /* @__PURE__ */ F("input", {
						id: `${n}-from`,
						className: "price-range-input",
						type: "number",
						"data-min": !0,
						min: r,
						max: i,
						value: s,
						onInput: (e) => c(e.currentTarget.value),
						onBlur: d,
						onKeyDown: (e) => {
							e.key === "Enter" && d();
						}
					})]
				}),
				/* @__PURE__ */ F("div", {
					className: "price-range__horizontal-divider",
					"aria-hidden": "true",
					children: "-"
				}),
				/* @__PURE__ */ F("div", {
					className: "price-range-input-wrapper",
					children: [/* @__PURE__ */ F("label", {
						htmlFor: `${n}-to`,
						className: "currency",
						children: t.currencySymbol || "€"
					}), /* @__PURE__ */ F("input", {
						id: `${n}-to`,
						className: "price-range-input",
						type: "number",
						"data-max": !0,
						min: r,
						max: i,
						value: l,
						onInput: (e) => u(e.currentTarget.value),
						onBlur: d,
						onKeyDown: (e) => {
							e.key === "Enter" && d();
						}
					})]
				})
			]
		})
	});
}), xF = ({ facet: e, labels: t }) => /* @__PURE__ */ F(_F, {
	facet: e,
	children: [/* @__PURE__ */ F(oO, {
		facet: e,
		justContent: !0,
		disableCollapse: !0
	}), /* @__PURE__ */ F(bF, {
		facet: e,
		labels: t
	})]
}), SF = Z(({ controller: e, labels: t }) => {
	let n = Pe(null), { tagFacetKeys: r, useTagGrouping: i } = iF(t), { facets: a, groupedTagFacets: o, priceFacet: s } = rF({
		storeFacets: e.store.facets,
		tagFacetKeys: r,
		useTagGrouping: i,
		fallbackPriceFacet: n.current
	});
	return s && (n.current = s), a.length === 0 && o.length === 0 ? null : /* @__PURE__ */ F(_, { children: [a.map((e) => hF(e) ? /* @__PURE__ */ F(xF, {
		facet: e,
		labels: t
	}, e.field) : /* @__PURE__ */ F(yF, {
		facet: e,
		labels: t,
		tagFacetKeys: r
	}, e.field)), o.map(([e, n]) => /* @__PURE__ */ F(yF, {
		facet: n,
		labels: t,
		tagFacetKeys: r
	}, e))] });
}), CF = ({ filteredCount: e, labels: t = {} }) => {
	let n = Number(e) || 0;
	if (t.pageType === "search") {
		let e = n === 1 ? t.searchResultsCountOne : t.searchResultsCountOther;
		return e ? e.replaceAll("__COUNT__", String(n)) : String(n);
	}
	let r = n === 1 ? t.productCountSimpleOne : t.productCountSimpleOther;
	return r ? r.replaceAll("__COUNT__", String(n)) : String(n);
}, wF = (e, t = {}, n = {}) => {
	let r = e?.store;
	if (!r?.loaded) return;
	let i = r.pagination?.totalResults ?? 0, a = document.getElementById(n.applyCountId || "apply-count"), o = document.getElementById(n.zeroMessageId || "facets-no-results-message");
	a && (a.textContent = CF({
		filteredCount: i,
		labels: t
	})), o && o.classList.toggle("hide", i !== 0);
};
Q(), R(), gM(), Ae();
var TF = {
	drawer: {
		applyCountId: "apply-count",
		zeroMessageId: "facets-no-results-message"
	},
	desktop: {
		applyCountId: "apply-count-desktop",
		zeroMessageId: "facets-no-results-message-desktop"
	}
}, EF = Z(({ controller: e, labels: t, variant: n = "drawer" }) => {
	let { store: r } = e, i = n === "desktop" ? "athos-clear-filters-desktop" : "athos-clear-filters", a = TF[n] || TF.drawer;
	if (L(() => {
		let t = document.getElementById(i);
		if (!t) return;
		let n = (t) => {
			t.preventDefault(), uP(e);
		};
		return t.addEventListener("click", n), () => t.removeEventListener("click", n);
	}, [i, e]), L(() => {
		!r.loaded || t.enableFiltering === !1 || wF(e, t, a);
	}, [
		e,
		a,
		t,
		r.loaded,
		r.pagination.totalResults,
		r.filters,
		t.enableFiltering
	]), !r.loaded || t.enableFiltering === !1) return null;
	let o = /* @__PURE__ */ F("form", {
		className: n === "desktop" ? "sidebar-facets filter-form" : "filter-form",
		"aria-label": t.filterButton || t.filters,
		onSubmit: (e) => e.preventDefault(),
		children: /* @__PURE__ */ F(SF, {
			controller: e,
			labels: t
		})
	});
	return /* @__PURE__ */ F(Zx, {
		controller: e,
		children: n === "desktop" ? /* @__PURE__ */ F("div", {
			className: "sidebar-group --facets",
			children: o
		}) : o
	});
}), DF = { beacon: !0 }, OF = (e) => async ({ request: t }, n) => {
	t.pagination = t.pagination || {}, t.pagination.pageSize = e, await n();
}, kF = () => async ({ controller: e }, t) => {
	await t();
	let n = e?.urlManager;
	n?.state?.pageSize != null && n.remove("pageSize").go({ history: "replace" });
}, AF = ({ pageType: e, collectionHandle: t, pageSize: n } = {}) => {
	let r = [];
	e === "collection" && t && t !== "all" && r.push({
		field: "collection_handle",
		value: t,
		type: "value",
		background: !0
	});
	let i = {
		filters: r,
		pagination: { pageSize: n }
	};
	return e === "collection" && t === "all" && (i.search = { query: { string: "*" } }), i;
}, jF = (e) => ({
	merchandising: e === "search",
	singleResult: !1
}), MF = (e = document) => {
	let t = e.getElementById("athos-product-card-config");
	if (!t?.textContent) return {};
	try {
		return JSON.parse(t.textContent);
	} catch {
		return {};
	}
}, NF = (e = document, t = {}) => {
	let n = MF(e);
	return {
		...n.labels || {},
		customBadges: n.customBadges,
		badgeCustomAria: n.badgeCustomAria,
		badgePosition: n.badgePosition,
		fromPriceHtml: n.fromPriceHtml,
		regularPrice: n.regularPrice,
		salePrice: n.salePrice,
		customPriceTag: String(n.customPriceTag || "").trim() || void 0,
		customPriceColor: String(n.customPriceColor || "").trim() || void 0,
		enableSwatches: n.enableSwatches !== !1,
		colorSwatchIdentifiers: n.colorSwatchIdentifiers || "",
		cardType: n.cardType || "default",
		imagePadding: n.imagePadding || "default",
		textAlign: n.textAlign || "text-align-left",
		titleFontClass: n.titleFontClass || "",
		titleSizeClass: n.titleSizeClass || "",
		titleSmSizeClass: n.titleSmSizeClass || "",
		priceClass: n.priceClass || "card-price-grid",
		cardLayoutClass: t.cardLayoutClass || "",
		showSecondaryImage: n.showSecondaryImage !== !1,
		showVendor: n.showVendor === !0,
		imageSizes: t.imageSizes || n.imageSizes || "",
		imageLoading: t.imageLoading || n.imageLoading || "lazy"
	};
}, PF = (e) => String(e || "").trim() === "button" ? "button" : "default", FF = (e = document) => {
	let t = e.getElementById("athos-theme-config");
	if (t?.textContent) try {
		return JSON.parse(t.textContent);
	} catch {
		return {};
	}
	return {};
}, IF = (e) => {
	let t = Number(e);
	return Number.isFinite(t) && t > 0 ? t : 16;
}, LF = (e = {}, t = {}, n = document) => {
	let r = e.pageType || "search", i = e.collectionHandle || "", a = NF(n), o = PF(e.paginationType);
	return {
		pageType: r,
		collectionHandle: i,
		pageSize: IF(e.pageSize),
		paginationType: o,
		labels: {
			...a,
			...e.labels || {},
			customBadges: e.customBadges ?? a.customBadges,
			badgeCustomAria: e.badgeCustomAria ?? a.badgeCustomAria,
			badgePosition: e.badgePosition ?? a.badgePosition,
			fromPriceHtml: e.fromPriceHtml ?? a.fromPriceHtml,
			regularPrice: e.regularPrice ?? a.regularPrice,
			salePrice: e.salePrice ?? a.salePrice,
			customPriceTag: e.customPriceTag ?? a.customPriceTag,
			customPriceColor: e.customPriceColor ?? a.customPriceColor,
			enableTagFilterGrouping: e.enableTagFilterGrouping !== !1,
			tagFilterKeys: (e.tagFilterKeys || []).map((e) => String(e).trim()).filter(Boolean),
			enableSwatches: e.enableSwatches ?? a.enableSwatches,
			colorSwatchIdentifiers: e.colorSwatchIdentifiers ?? a.colorSwatchIdentifiers,
			showCount: e.showCount !== !1,
			enableSorting: e.enableSorting !== !1,
			enableFiltering: e.enableFiltering !== !1,
			showSidebar: e.showSidebar === !0,
			pageType: r,
			documentTitle: t.documentTitle,
			nativeCount: e.nativeCount,
			allProductsCount: e.allProductsCount,
			productCountSimpleOne: e.productCountSimpleOne,
			productCountSimpleOther: e.productCountSimpleOther,
			productCountOne: e.productCountOne,
			productCountOther: e.productCountOther,
			gridGap: e.gridGap,
			smGridGap: e.smGridGap,
			columns: e.columns,
			smColumns: e.smColumns,
			mdColumns: e.mdColumns,
			searchNoResultsProfile: String(e.searchNoResultsProfile ?? "").trim(),
			searchNoResultsLimit: e.searchNoResultsLimit,
			paginationType: o,
			loadMore: e.labels?.loadMore,
			allLoaded: e.labels?.allLoaded,
			loadMoreProgress: e.labels?.loadMoreProgress
		}
	};
};
if (Iu(), document.getElementById("athos-discovery")) {
	let e = tu(["siteId"]), { pageType: t, collectionHandle: n, pageSize: r, labels: i, paginationType: a } = LF(FF(), { documentTitle: document.title }), o = AF({
		pageType: t,
		collectionHandle: n,
		pageSize: r
	}), s = a === "button", c = new vw({
		mode: "production",
		url: { parameters: { core: {
			query: { name: "q" },
			page: { name: "page" }
		} } },
		client: {
			globals: { siteId: e.siteId || "atg0mj" },
			config: { search: { globals: DF } }
		},
		controllers: { search: [{
			config: {
				id: "search",
				globals: o,
				middleware: {
					init: [kF()],
					beforeSearch: [OF(r)]
				},
				settings: {
					redirects: jF(t),
					...s ? { infinite: { enabled: !0 } } : {},
					facets: {
						pinFiltered: !1,
						fields: { price: { trim: !1 } }
					}
				}
			},
			targeters: [
				{
					selector: "#athos-sidebar",
					component: () => EF,
					props: {
						labels: i,
						variant: "drawer"
					},
					hideTarget: !1,
					renderAfterSearch: !0
				},
				{
					selector: "#athos-sidebar-desktop",
					component: () => EF,
					props: {
						labels: i,
						variant: "desktop"
					},
					hideTarget: !1,
					renderAfterSearch: !0
				},
				{
					selector: "#athos-content",
					component: () => VP,
					props: { labels: i },
					hideTarget: !0,
					renderAfterSearch: !0
				}
			]
		}] }
	});
	window.athosSnapDiscovery = c, oP();
}
//#endregion
